/*
 Highcharts JS v7.1.3 (2019-08-14)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(O,M){"object"===typeof module&&module.exports?(M["default"]=M,module.exports=O.document?M(O):M):"function"===typeof define&&define.amd?define("highcharts/highcharts",function(){return M(O)}):(O.Highcharts&&O.Highcharts.error(16,!0),O.Highcharts=M(O))})("undefined"!==typeof window?window:this,function(O){function M(c,p,y,G){c.hasOwnProperty(p)||(c[p]=G.apply(null,y))}var J={};M(J,"parts/Globals.js",[],function(){var c="undefined"===typeof O?"undefined"!==typeof window?window:{}:O,p=c.document,
y=c.navigator&&c.navigator.userAgent||"",G=p&&p.createElementNS&&!!p.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,F=/(edge|msie|trident)/i.test(y)&&!c.opera,z=-1!==y.indexOf("Firefox"),r=-1!==y.indexOf("Chrome"),K=z&&4>parseInt(y.split("Firefox/")[1],10);return{product:"Highcharts",version:"7.1.3",deg2rad:2*Math.PI/360,doc:p,hasBidiBug:K,hasTouch:!!O.TouchEvent,isMS:F,isWebKit:-1!==y.indexOf("AppleWebKit"),isFirefox:z,isChrome:r,isSafari:!r&&-1!==y.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(y),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:c,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});M(J,"parts/Utilities.js",[J["parts/Globals.js"]],function(c){function p(b,d){return parseInt(b,d||10)}function y(b){return"string"===typeof b}function G(b){b=Object.prototype.toString.call(b);return"[object Array]"===b||"[object Array Iterator]"===b}function F(b,d){return!!b&&"object"===typeof b&&(!d||
!G(b))}function z(b){return F(b)&&"number"===typeof b.nodeType}function r(b){var d=b&&b.constructor;return!(!F(b,!0)||z(b)||!d||!d.name||"Object"===d.name)}function K(b){return"number"===typeof b&&!isNaN(b)&&Infinity>b&&-Infinity<b}function v(b){return"undefined"!==typeof b&&null!==b}function D(b,d,a){for(var g in b)Object.prototype.hasOwnProperty.call(b,g)&&d.call(a||b[g],b[g],g,b)}c.timers=[];var w=c.charts,n=c.doc,l=c.win;c.error=function(b,d,a){var g=K(b)?"Highcharts error #"+b+": www.highcharts.com/errors/"+
b:b,h=function(){if(d)throw Error(g);l.console&&console.log(g)};a?c.fireEvent(a,"displayError",{code:b,message:g},h):h()};c.Fx=function(b,d,a){this.options=d;this.elem=b;this.prop=a};c.Fx.prototype={dSetter:function(){var b=this.paths[0],d=this.paths[1],a=[],g=this.now,h=b.length;if(1===g)a=this.toD;else if(h===d.length&&1>g)for(;h--;){var e=parseFloat(b[h]);a[h]=isNaN(e)?d[h]:g*parseFloat(""+(d[h]-e))+e}else a=d;this.elem.attr("d",a,null,!0)},update:function(){var b=this.elem,d=this.prop,a=this.now,
g=this.options.step;if(this[d+"Setter"])this[d+"Setter"]();else b.attr?b.element&&b.attr(d,a,null,!0):b.style[d]=a+this.unit;g&&g.call(b,a,this)},run:function(b,d,a){var g=this,h=g.options,e=function(a){return e.stopped?!1:g.step(a)},m=l.requestAnimationFrame||function(a){setTimeout(a,13)},u=function(){for(var a=0;a<c.timers.length;a++)c.timers[a]()||c.timers.splice(a--,1);c.timers.length&&m(u)};b!==d||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=b,this.end=d,this.unit=
a,this.now=this.start,this.pos=0,e.elem=this.elem,e.prop=this.prop,e()&&1===c.timers.push(e)&&m(u)):(delete h.curAnim[this.prop],h.complete&&0===Object.keys(h.curAnim).length&&h.complete.call(this.elem))},step:function(b){var d=+new Date,a=this.options,g=this.elem,h=a.complete,e=a.duration,c=a.curAnim;if(g.attr&&!g.element)b=!1;else if(b||d>=e+this.startTime){this.now=this.end;this.pos=1;this.update();var u=c[this.prop]=!0;D(c,function(a){!0!==a&&(u=!1)});u&&h&&h.call(g);b=!1}else this.pos=a.easing((d-
this.startTime)/e),this.now=this.start+(this.end-this.start)*this.pos,this.update(),b=!0;return b},initPath:function(b,d,a){function g(a){for(k=a.length;k--;){var b="M"===a[k]||"L"===a[k];var f=/[a-zA-Z]/.test(a[k+3]);b&&f&&a.splice(k+1,0,a[k+1],a[k+2],a[k+1],a[k+2])}}function h(a,b){for(;a.length<f;){a[0]=b[f-a.length];var q=a.slice(0,t);[].splice.apply(a,[0,0].concat(q));A&&(q=a.slice(a.length-t),[].splice.apply(a,[a.length,0].concat(q)),k--)}a[0]="M"}function e(a,b){for(var q=(f-a.length)/t;0<
q&&q--;)x=a.slice().splice(a.length/B-t,t*B),x[0]=b[f-t-q*t],n&&(x[t-6]=x[t-2],x[t-5]=x[t-1]),[].splice.apply(a,[a.length/B,0].concat(x)),A&&q--}d=d||"";var c=b.startX,u=b.endX,n=-1<d.indexOf("C"),t=n?7:3,x,k;d=d.split(" ");a=a.slice();var A=b.isArea,B=A?2:1;n&&(g(d),g(a));if(c&&u){for(k=0;k<c.length;k++)if(c[k]===u[0]){var H=k;break}else if(c[0]===u[u.length-c.length+k]){H=k;var q=!0;break}else if(c[c.length-1]===u[u.length-c.length+k]){H=c.length-k;break}"undefined"===typeof H&&(d=[])}if(d.length&&
K(H)){var f=a.length+H*B*t;q?(h(d,a),e(a,d)):(h(a,d),e(d,a))}return[d,a]},fillSetter:function(){c.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,c.color(this.start).tweenTo(c.color(this.end),this.pos),null,!0)}};c.merge=function(){var b,d=arguments,a={},g=function(a,b){"object"!==typeof a&&(a={});D(b,function(d,e){!F(d,!0)||r(d)||z(d)?a[e]=b[e]:a[e]=g(a[e]||{},d)});return a};!0===d[0]&&(a=d[1],d=Array.prototype.slice.call(d,2));var h=d.length;for(b=
0;b<h;b++)a=g(a,d[b]);return a};c.attr=function(b,d,a){var g;y(d)?v(a)?b.setAttribute(d,a):b&&b.getAttribute&&((g=b.getAttribute(d))||"class"!==d||(g=b.getAttribute(d+"Name"))):v(d)&&F(d)&&D(d,function(a,d){b.setAttribute(d,a)});return g};c.syncTimeout=function(b,d,a){if(d)return setTimeout(b,d,a);b.call(0,a)};c.clearTimeout=function(b){v(b)&&clearTimeout(b)};c.extend=function(b,d){var a;b||(b={});for(a in d)b[a]=d[a];return b};c.pick=function(){var b=arguments,d,a=b.length;for(d=0;d<a;d++){var g=
b[d];if("undefined"!==typeof g&&null!==g)return g}};c.css=function(b,d){c.isMS&&!c.svg&&d&&"undefined"!==typeof d.opacity&&(d.filter="alpha(opacity="+100*d.opacity+")");c.extend(b.style,d)};c.createElement=function(b,d,a,g,h){b=n.createElement(b);var e=c.css;d&&c.extend(b,d);h&&e(b,{padding:"0",border:"none",margin:"0"});a&&e(b,a);g&&g.appendChild(b);return b};c.extendClass=function(b,d){var a=function(){};a.prototype=new b;c.extend(a.prototype,d);return a};c.pad=function(b,d,a){return Array((d||
2)+1-String(b).replace("-","").length).join(a||"0")+b};c.relativeLength=function(b,d,a){return/%$/.test(b)?d*parseFloat(b)/100+(a||0):parseFloat(b)};c.wrap=function(b,d,a){var g=b[d];b[d]=function(){var b=Array.prototype.slice.call(arguments),d=arguments,c=this;c.proceed=function(){g.apply(c,arguments.length?arguments:d)};b.unshift(g);b=a.apply(this,b);c.proceed=null;return b}};c.datePropsToTimestamps=function(b){D(b,function(d,a){F(d)&&"function"===typeof d.getTime?b[a]=d.getTime():(F(d)||G(d))&&
c.datePropsToTimestamps(d)})};c.formatSingle=function(b,d,a){var g=/\.([0-9])/,h=c.defaultOptions.lang;/f$/.test(b)?(a=(a=b.match(g))?a[1]:-1,null!==d&&(d=c.numberFormat(d,a,h.decimalPoint,-1<b.indexOf(",")?h.thousandsSep:""))):d=(a||c.time).dateFormat(b,d);return d};c.format=function(b,d,a){for(var g="{",h=!1,e,m,u,n,t=[],x;b;){g=b.indexOf(g);if(-1===g)break;e=b.slice(0,g);if(h){e=e.split(":");m=e.shift().split(".");n=m.length;x=d;for(u=0;u<n;u++)x&&(x=x[m[u]]);e.length&&(x=c.formatSingle(e.join(":"),
x,a));t.push(x)}else t.push(e);b=b.slice(g+1);g=(h=!h)?"}":"{"}t.push(b);return t.join("")};c.getMagnitude=function(b){return Math.pow(10,Math.floor(Math.log(b)/Math.LN10))};c.normalizeTickInterval=function(b,d,a,g,h){var e=b;a=c.pick(a,1);var m=b/a;d||(d=h?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===g&&(1===a?d=d.filter(function(a){return 0===a%1}):.1>=a&&(d=[1/a])));for(g=0;g<d.length&&!(e=d[g],h&&e*a>=b||!h&&m<=(d[g]+(d[g+1]||d[g]))/2);g++);return e=c.correctFloat(e*a,-Math.round(Math.log(.001)/
Math.LN10))};c.stableSort=function(b,d){var a=b.length,g,h;for(h=0;h<a;h++)b[h].safeI=h;b.sort(function(a,b){g=d(a,b);return 0===g?a.safeI-b.safeI:g});for(h=0;h<a;h++)delete b[h].safeI};c.arrayMin=function(b){for(var d=b.length,a=b[0];d--;)b[d]<a&&(a=b[d]);return a};c.arrayMax=function(b){for(var d=b.length,a=b[0];d--;)b[d]>a&&(a=b[d]);return a};c.destroyObjectProperties=function(b,d){D(b,function(a,g){a&&a!==d&&a.destroy&&a.destroy();delete b[g]})};c.discardElement=function(b){var d=c.garbageBin;
d||(d=c.createElement("div"));b&&d.appendChild(b);d.innerHTML=""};c.correctFloat=function(b,d){return parseFloat(b.toPrecision(d||14))};c.setAnimation=function(b,d){d.renderer.globalAnimation=c.pick(b,d.options.chart.animation,!0)};c.animObject=function(b){return F(b)?c.merge(b):{duration:b?500:0}};c.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};c.numberFormat=function(b,d,a,g){b=+b||0;d=+d;var h=c.defaultOptions.lang,e=(b.toString().split(".")[1]||
"").split("e")[0].length,m=b.toString().split("e");if(-1===d)d=Math.min(e,20);else if(!K(d))d=2;else if(d&&m[1]&&0>m[1]){var u=d+ +m[1];0<=u?(m[0]=(+m[0]).toExponential(u).split("e")[0],d=u):(m[0]=m[0].split(".")[0]||0,b=20>d?(m[0]*Math.pow(10,m[1])).toFixed(d):0,m[1]=0)}var n=(Math.abs(m[1]?m[0]:b)+Math.pow(10,-Math.max(d,e)-1)).toFixed(d);e=String(p(n));u=3<e.length?e.length%3:0;a=c.pick(a,h.decimalPoint);g=c.pick(g,h.thousandsSep);b=(0>b?"-":"")+(u?e.substr(0,u)+g:"");b+=e.substr(u).replace(/(\d{3})(?=\d)/g,
"$1"+g);d&&(b+=a+n.slice(-d));m[1]&&0!==+b&&(b+="e"+m[1]);return b};Math.easeInOutSine=function(b){return-.5*(Math.cos(Math.PI*b)-1)};c.getStyle=function(b,d,a){if("width"===d)return d=Math.min(b.offsetWidth,b.scrollWidth),a=b.getBoundingClientRect&&b.getBoundingClientRect().width,a<d&&a>=d-1&&(d=Math.floor(a)),Math.max(0,d-c.getStyle(b,"padding-left")-c.getStyle(b,"padding-right"));if("height"===d)return Math.max(0,Math.min(b.offsetHeight,b.scrollHeight)-c.getStyle(b,"padding-top")-c.getStyle(b,
"padding-bottom"));l.getComputedStyle||c.error(27,!0);if(b=l.getComputedStyle(b,void 0))b=b.getPropertyValue(d),c.pick(a,"opacity"!==d)&&(b=p(b));return b};c.inArray=function(b,d,a){return d.indexOf(b,a)};c.find=Array.prototype.find?function(b,d){return b.find(d)}:function(b,d){var a,g=b.length;for(a=0;a<g;a++)if(d(b[a],a))return b[a]};c.keys=Object.keys;c.offset=function(b){var d=n.documentElement;b=b.parentElement||b.parentNode?b.getBoundingClientRect():{top:0,left:0};return{top:b.top+(l.pageYOffset||
d.scrollTop)-(d.clientTop||0),left:b.left+(l.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}};c.stop=function(b,d){for(var a=c.timers.length;a--;)c.timers[a].elem!==b||d&&d!==c.timers[a].prop||(c.timers[a].stopped=!0)};D({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(b,d){c[d]=function(a){return Array.prototype[b].apply(a,[].slice.call(arguments,1))}});c.addEvent=function(b,d,a,g){void 0===g&&(g={});var h=b.addEventListener||c.addEventListenerPolyfill;var e="function"===
typeof b&&b.prototype?b.prototype.protoEvents=b.prototype.protoEvents||{}:b.hcEvents=b.hcEvents||{};c.Point&&b instanceof c.Point&&b.series&&b.series.chart&&(b.series.chart.runTrackerClick=!0);h&&h.call(b,d,a,!1);e[d]||(e[d]=[]);e[d].push({fn:a,order:"number"===typeof g.order?g.order:Infinity});e[d].sort(function(a,b){return a.order-b.order});return function(){c.removeEvent(b,d,a)}};c.removeEvent=function(b,d,a){function g(a,d){var e=b.removeEventListener||c.removeEventListenerPolyfill;e&&e.call(b,
a,d,!1)}function h(a){var e;if(b.nodeName){if(d){var h={};h[d]=!0}else h=a;D(h,function(b,d){if(a[d])for(e=a[d].length;e--;)g(d,a[d][e].fn)})}}var e;["protoEvents","hcEvents"].forEach(function(c){var m=b[c];m&&(d?(e=m[d]||[],a?(m[d]=e.filter(function(b){return a!==b.fn}),g(d,a)):(h(m),m[d]=[])):(h(m),b[c]={}))})};c.fireEvent=function(b,d,a,g){var h;a=a||{};if(n.createEvent&&(b.dispatchEvent||b.fireEvent)){var e=n.createEvent("Events");e.initEvent(d,!0,!0);c.extend(e,a);b.dispatchEvent?b.dispatchEvent(e):
b.fireEvent(d,e)}else a.target||c.extend(a,{preventDefault:function(){a.defaultPrevented=!0},target:b,type:d}),function(d,e){void 0===d&&(d=[]);void 0===e&&(e=[]);var g=0,c=0,m=d.length+e.length;for(h=0;h<m;h++)!1===(d[g]?e[c]?d[g].order<=e[c].order?d[g++]:e[c++]:d[g++]:e[c++]).fn.call(b,a)&&a.preventDefault()}(b.protoEvents&&b.protoEvents[d],b.hcEvents&&b.hcEvents[d]);g&&!a.defaultPrevented&&g.call(b,a)};c.animate=function(b,d,a){var g,h="",e,m;if(!F(a)){var u=arguments;a={duration:u[2],easing:u[3],
complete:u[4]}}K(a.duration)||(a.duration=400);a.easing="function"===typeof a.easing?a.easing:Math[a.easing]||Math.easeInOutSine;a.curAnim=c.merge(d);D(d,function(u,t){c.stop(b,t);m=new c.Fx(b,a,t);e=null;"d"===t?(m.paths=m.initPath(b,b.d,d.d),m.toD=d.d,g=0,e=1):b.attr?g=b.attr(t):(g=parseFloat(c.getStyle(b,t))||0,"opacity"!==t&&(h="px"));e||(e=u);e&&e.match&&e.match("px")&&(e=e.replace(/px/g,""));m.run(g,e,h)})};c.seriesType=function(b,d,a,g,h){var e=c.getOptions(),m=c.seriesTypes;e.plotOptions[b]=
c.merge(e.plotOptions[d],a);m[b]=c.extendClass(m[d]||function(){},g);m[b].prototype.type=b;h&&(m[b].prototype.pointClass=c.extendClass(c.Point,h));return m[b]};c.uniqueKey=function(){var b=Math.random().toString(36).substring(2,9),d=0;return function(){return"highcharts-"+b+"-"+d++}}();c.isFunction=function(b){return"function"===typeof b};l.jQuery&&(l.jQuery.fn.highcharts=function(){var b=[].slice.call(arguments);if(this[0])return b[0]?(new (c[y(b[0])?b.shift():"Chart"])(this[0],b[0],b[1]),this):
w[c.attr(this[0],"data-highcharts-chart")]});return{defined:v,erase:function(b,d){for(var a=b.length;a--;)if(b[a]===d){b.splice(a,1);break}},isArray:G,isClass:r,isDOMElement:z,isNumber:K,isObject:F,isString:y,objectEach:D,pInt:p,splat:function(b){return G(b)?b:[b]}}});M(J,"parts/Color.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.isNumber,G=p.pInt,F=c.merge;c.Color=function(z){if(!(this instanceof c.Color))return new c.Color(z);this.init(z)};c.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),parseFloat(c[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(z){var r,p;if((this.input=z=this.names[z&&z.toLowerCase?z.toLowerCase():""]||z)&&z.stops)this.stops=z.stops.map(function(w){return new c.Color(w[1])});else{if(z&&z.charAt&&"#"===z.charAt()){var v=z.length;z=parseInt(z.substr(1),16);7===v?r=[(z&16711680)>>
16,(z&65280)>>8,z&255,1]:4===v&&(r=[(z&3840)>>4|(z&3840)>>8,(z&240)>>4|z&240,(z&15)<<4|z&15,1])}if(!r)for(p=this.parsers.length;p--&&!r;){var y=this.parsers[p];(v=y.regex.exec(z))&&(r=y.parse(v))}}this.rgba=r||[]},get:function(c){var r=this.input,z=this.rgba;if(this.stops){var v=F(r);v.stops=[].concat(v.stops);this.stops.forEach(function(r,w){v.stops[w]=[v.stops[w][0],r.get(c)]})}else v=z&&y(z[0])?"rgb"===c||!c&&1===z[3]?"rgb("+z[0]+","+z[1]+","+z[2]+")":"a"===c?z[3]:"rgba("+z.join(",")+")":r;return v},
brighten:function(c){var r,z=this.rgba;if(this.stops)this.stops.forEach(function(r){r.brighten(c)});else if(y(c)&&0!==c)for(r=0;3>r;r++)z[r]+=G(255*c),0>z[r]&&(z[r]=0),255<z[r]&&(z[r]=255);return this},setOpacity:function(c){this.rgba[3]=c;return this},tweenTo:function(c,r){var z=this.rgba,v=c.rgba;v.length&&z&&z.length?(c=1!==v[3]||1!==z[3],r=(c?"rgba(":"rgb(")+Math.round(v[0]+(z[0]-v[0])*(1-r))+","+Math.round(v[1]+(z[1]-v[1])*(1-r))+","+Math.round(v[2]+(z[2]-v[2])*(1-r))+(c?","+(v[3]+(z[3]-v[3])*
(1-r)):"")+")"):r=c.input||"none";return r}};c.color=function(z){return new c.Color(z)}});M(J,"parts/SvgRenderer.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.erase,F=p.isArray,z=p.isNumber,r=p.isObject,K=p.isString,v=p.objectEach,D=p.pInt,w=p.splat,n=c.addEvent,l=c.animate,b=c.attr,d=c.charts,a=c.color,g=c.css,h=c.createElement,e=c.deg2rad,m=c.destroyObjectProperties,u=c.doc,E=c.extend,t=c.hasTouch,x=c.isFirefox,k=c.isMS,A=c.isWebKit,B=c.merge,H=c.noop,q=c.pick,
f=c.removeEvent,C=c.stop,N=c.svg,T=c.SVG_NS,R=c.symbolSizes,S=c.win;var L=c.SVGElement=function(){return this};E(L.prototype,{opacity:1,SVG_NS:T,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),init:function(a,b){this.element="span"===b?h(b):u.createElementNS(this.SVG_NS,b);this.renderer=a;c.fireEvent(this,"afterInit")},animate:function(a,b,f){var I=c.animObject(q(b,this.renderer.globalAnimation,
!0));q(u.hidden,u.msHidden,u.webkitHidden,!1)&&(I.duration=0);0!==I.duration?(f&&(I.complete=f),l(this,a,I)):(this.attr(a,void 0,f),v(a,function(a,b){I.step&&I.step.call(this,a,{prop:b,pos:1})},this));return this},complexColor:function(a,b,f){var I=this.renderer,q,d,e,k,g,h,P,m,A,C,N,Q=[],L;c.fireEvent(this.renderer,"complexColor",{args:arguments},function(){a.radialGradient?d="radialGradient":a.linearGradient&&(d="linearGradient");d&&(e=a[d],g=I.gradients,P=a.stops,C=f.radialReference,F(e)&&(a[d]=
e={x1:e[0],y1:e[1],x2:e[2],y2:e[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===d&&C&&!y(e.gradientUnits)&&(k=e,e=B(e,I.getRadialAttr(C,k),{gradientUnits:"userSpaceOnUse"})),v(e,function(a,I){"id"!==I&&Q.push(I,a)}),v(P,function(a){Q.push(a)}),Q=Q.join(","),g[Q]?N=g[Q].attr("id"):(e.id=N=c.uniqueKey(),g[Q]=h=I.createElement(d).attr(e).add(I.defs),h.radAttr=k,h.stops=[],P.forEach(function(a){0===a[1].indexOf("rgba")?(q=c.color(a[1]),m=q.get("rgb"),A=q.get("a")):(m=a[1],A=1);a=I.createElement("stop").attr({offset:a[0],
"stop-color":m,"stop-opacity":A}).add(h);h.stops.push(a)})),L="url("+I.url+"#"+N+")",f.setAttribute(b,L),f.gradient=Q,a.toString=function(){return L})})},applyTextOutline:function(a){var I=this.element,f;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(I.style.fill)));a=a.split(" ");var q=a[a.length-1];if((f=a[0])&&"none"!==f&&c.svg){this.fakeTS=!0;a=[].slice.call(I.getElementsByTagName("tspan"));this.ySetter=this.xSetter;f=f.replace(/(^[\d\.]+)(.*?)$/g,function(a,I,
b){return 2*I+b});this.removeTextOutline(a);var d=I.firstChild;a.forEach(function(a,e){0===e&&(a.setAttribute("x",I.getAttribute("x")),e=I.getAttribute("y"),a.setAttribute("y",e||0),null===e&&I.setAttribute("y",0));a=a.cloneNode(1);b(a,{"class":"highcharts-text-outline",fill:q,stroke:q,"stroke-width":f,"stroke-linejoin":"round"});I.insertBefore(a,d)})}},removeTextOutline:function(a){for(var I=a.length,b;I--;)b=a[I],"highcharts-text-outline"===b.getAttribute("class")&&G(a,this.element.removeChild(b))},
symbolCustomAttribs:"x y width height r start end innerR anchorX anchorY rounded".split(" "),attr:function(a,b,f,q){var I=this.element,d,e=this,g,k,h=this.symbolCustomAttribs;if("string"===typeof a&&void 0!==b){var P=a;a={};a[P]=b}"string"===typeof a?e=(this[a+"Getter"]||this._defaultGetter).call(this,a,I):(v(a,function(b,f){g=!1;q||C(this,f);this.symbolName&&-1!==c.inArray(f,h)&&(d||(this.symbolAttr(a),d=!0),g=!0);!this.rotation||"x"!==f&&"y"!==f||(this.doTransform=!0);g||(k=this[f+"Setter"]||this._defaultSetter,
k.call(this,b,f,I),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(f)&&this.updateShadows(f,b,k))},this),this.afterSetters());f&&f.call(this);return e},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,b,f){for(var I=this.shadows,q=I.length;q--;)f.call(I[q],"height"===a?Math.max(b-(I[q].cutHeight||0),0):"d"===a?this.d:b,a,I[q])},addClass:function(a,b){var I=this.attr("class")||"";b||(a=(a||"").split(/ /g).reduce(function(a,
b){-1===I.indexOf(b)&&a.push(b);return a},I?[I]:[]).join(" "));a!==I&&this.attr("class",a);return this},hasClass:function(a){return-1!==(this.attr("class")||"").split(" ").indexOf(a)},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(I){b[I]=q(a[I],b[I])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",
a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,b){b=b||a.strokeWidth||0;var I=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+I;a.y=Math.floor(a.y||this.y||0)+I;a.width=Math.floor((a.width||this.width||0)-2*I);a.height=Math.floor((a.height||this.height||0)-2*I);y(a.strokeWidth)&&(a.strokeWidth=b);return a},css:function(a){var f=this.styles,I={},q=this.element,d="",e=!f,k=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);f&&v(a,function(a,b){a!==f[b]&&(I[b]=a,
e=!0)});if(e){f&&(a=E(f,I));if(a)if(null===a.width||"auto"===a.width)delete this.textWidth;else if("text"===q.nodeName.toLowerCase()&&a.width)var c=this.textWidth=D(a.width);this.styles=a;c&&!N&&this.renderer.forExport&&delete a.width;if(q.namespaceURI===this.SVG_NS){var h=function(a,b){return"-"+b.toLowerCase()};v(a,function(a,b){-1===k.indexOf(b)&&(d+=b.replace(/([A-Z])/g,h)+":"+a+";")});d&&b(q,"style",d)}else g(q,a);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&
a.textOutline&&this.applyTextOutline(a.textOutline))}return this},getStyle:function(a){return S.getComputedStyle(this.element||this,"").getPropertyValue(a)},strokeWidth:function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var a=this.getStyle("stroke-width");if(a.indexOf("px")===a.length-2)a=D(a);else{var f=u.createElementNS(T,"rect");b(f,{width:a,"stroke-width":0});this.element.parentNode.appendChild(f);a=f.getBBox().width;f.parentNode.removeChild(f)}return a},on:function(a,b){var f=
this,q=f.element;t&&"click"===a?(q.ontouchstart=function(a){f.touchEventFired=Date.now();a.preventDefault();b.call(q,a)},q.onclick=function(a){(-1===S.navigator.userAgent.indexOf("Android")||1100<Date.now()-(f.touchEventFired||0))&&b.call(q,a)}):q["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,
translateY:b})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,f=this.scaleX,d=this.scaleY,e=this.inverted,k=this.rotation,g=this.matrix,c=this.element;e&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];y(g)&&a.push("matrix("+g.join(",")+")");e?a.push("rotate(90) scale(-1,1)"):k&&a.push("rotate("+k+" "+q(this.rotationOriginX,c.getAttribute("x"),0)+" "+q(this.rotationOriginY,c.getAttribute("y")||
0)+")");(y(f)||y(d))&&a.push("scale("+q(f,1)+" "+q(d,1)+")");a.length&&c.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,f){var d,I={};var e=this.renderer;var k=e.alignedObjects;var g,c;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!f||K(f))this.alignTo=d=f||"renderer",G(k,this),k.push(this),f=null}else a=this.alignOptions,b=this.alignByTranslate,d=this.alignTo;f=q(f,e[d],e);d=a.align;e=a.verticalAlign;
k=(f.x||0)+(a.x||0);var h=(f.y||0)+(a.y||0);"right"===d?g=1:"center"===d&&(g=2);g&&(k+=(f.width-(a.width||0))/g);I[b?"translateX":"x"]=Math.round(k);"bottom"===e?c=1:"middle"===e&&(c=2);c&&(h+=(f.height-(a.height||0))/c);I[b?"translateY":"y"]=Math.round(h);this[this.placed?"animate":"attr"](I);this.placed=!0;this.alignAttr=I;return this},getBBox:function(a,b){var f,d=this.renderer,I=this.element,k=this.styles,g=this.textStr,c,h=d.cache,B=d.cacheKeys,P=I.namespaceURI===this.SVG_NS;b=q(b,this.rotation);
var m=b*e;var A=d.styledMode?I&&L.prototype.getStyle.call(I,"font-size"):k&&k.fontSize;if(y(g)){var C=g.toString();-1===C.indexOf("<")&&(C=C.replace(/[0-9]/g,"0"));C+=["",b||0,A,this.textWidth,k&&k.textOverflow].join()}C&&!a&&(f=h[C]);if(!f){if(P||d.forExport){try{(c=this.fakeTS&&function(a){[].forEach.call(I.querySelectorAll(".highcharts-text-outline"),function(b){b.style.display=a})})&&c("none"),f=I.getBBox?E({},I.getBBox()):{width:I.offsetWidth,height:I.offsetHeight},c&&c("")}catch(aa){""}if(!f||
0>f.width)f={width:0,height:0}}else f=this.htmlGetBBox();d.isSVG&&(a=f.width,d=f.height,P&&(f.height=d={"11px,17":14,"13px,20":16}[k&&k.fontSize+","+Math.round(d)]||d),b&&(f.width=Math.abs(d*Math.sin(m))+Math.abs(a*Math.cos(m)),f.height=Math.abs(d*Math.cos(m))+Math.abs(a*Math.sin(m))));if(C&&0<f.height){for(;250<B.length;)delete h[B.shift()];h[C]||B.push(C);h[C]=f}}return f},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(a){a?this.attr({y:-9999}):this.attr({visibility:"hidden"});
return this},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,f=this.element;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)var q=this.zIndexSetter();q||(a?a.element:b.box).appendChild(f);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=
this,b=a.element||{},f=a.renderer,q=f.isSVG&&"SPAN"===b.nodeName&&a.parentGroup,d=b.ownerSVGElement,e=a.clipPath;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;C(a);e&&d&&([].forEach.call(d.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){-1<a.getAttribute("clip-path").indexOf(e.element.id)&&a.removeAttribute("clip-path")}),a.clipPath=e.destroy());if(a.stops){for(d=0;d<a.stops.length;d++)a.stops[d]=a.stops[d].destroy();a.stops=null}a.safeRemoveChild(b);for(f.styledMode||a.destroyShadows();q&&
q.div&&0===q.div.childNodes.length;)b=q.parentGroup,a.safeRemoveChild(q.div),delete q.div,q=b;a.alignTo&&G(f.alignedObjects,a);v(a,function(b,f){a[f]&&a[f].parentGroup===a&&a[f].destroy&&a[f].destroy();delete a[f]})},shadow:function(a,f,d){var e=[],k,g=this.element;if(!a)this.destroyShadows();else if(!this.shadows){var I=q(a.width,3);var c=(a.opacity||.15)/I;var h=this.parentInverted?"(-1,-1)":"("+q(a.offsetX,1)+", "+q(a.offsetY,1)+")";for(k=1;k<=I;k++){var B=g.cloneNode(0);var m=2*I+1-2*k;b(B,{stroke:a.color||
"#000000","stroke-opacity":c*k,"stroke-width":m,transform:"translate"+h,fill:"none"});B.setAttribute("class",(B.getAttribute("class")||"")+" highcharts-shadow");d&&(b(B,"height",Math.max(b(B,"height")-m,0)),B.cutHeight=m);f?f.element.appendChild(B):g.parentNode&&g.parentNode.insertBefore(B,g);e.push(B)}this.shadows=e}return this},destroyShadows:function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&
("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=q(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,b,f){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[b]!==a&&(f.setAttribute(b,a),this[b]=a)},dashstyleSetter:function(a){var b,f=this["stroke-width"];"inherit"===f&&(f=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot",
"3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=D(a[b])*f;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){var b={left:"start",center:"middle",right:"end"};b[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",b[a]))},opacitySetter:function(a,b,f){this[b]=a;f.setAttribute(b,a)},titleSetter:function(a){var b=
this.element.getElementsByTagName("title")[0];b||(b=u.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(u.createTextNode(String(q(a,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,delete this.textPxLength,this.textStr=a,this.added&&this.renderer.buildText(this))},setTextPath:function(a,b){var f=this.element,q={textAnchor:"text-anchor"},d=!1,e=
this.textPathWrapper,k=!e;b=B(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var g=b.attributes;if(a&&b&&b.enabled){this.options&&this.options.padding&&(g.dx=-this.options.padding);e||(this.textPathWrapper=e=this.renderer.createElement("textPath"),d=!0);var h=e.element;(b=a.element.getAttribute("id"))||a.element.setAttribute("id",b=c.uniqueKey());if(k)for(a=f.getElementsByTagName("tspan");a.length;)a[0].setAttribute("y",0),h.appendChild(a[0]);d&&e.add({element:this.text?
this.text.element:f});h.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);y(g.dy)&&(h.parentNode.setAttribute("dy",g.dy),delete g.dy);y(g.dx)&&(h.parentNode.setAttribute("dx",g.dx),delete g.dx);v(g,function(a,b){h.setAttribute(q[b]||b,a)});f.removeAttribute("transform");this.removeTextOutline.call(e,[].slice.call(f.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=H}else e&&
(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(f,a));return this},destroyTextPath:function(a,b){var f;b.element.setAttribute("id","");for(f=this.textPathWrapper.element.childNodes;f.length;)a.firstChild.appendChild(f[0]);a.firstChild.removeChild(this.textPathWrapper.element);delete b.textPathWrapper},fillSetter:function(a,b,f){"string"===typeof a?f.setAttribute(b,a):a&&this.complexColor(a,b,f)},visibilitySetter:function(a,b,f){"inherit"===a?f.removeAttribute(b):this[b]!==
a&&f.setAttribute(b,a);this[b]=a},zIndexSetter:function(a,b){var f=this.renderer,q=this.parentGroup,d=(q||f).element||f.box,e=this.element,k=!1;f=d===f.box;var g=this.added;var c;y(a)?(e.setAttribute("data-z-index",a),a=+a,this[b]===a&&(g=!1)):y(this[b])&&e.removeAttribute("data-z-index");this[b]=a;if(g){(a=this.zIndex)&&q&&(q.handleZ=!0);b=d.childNodes;for(c=b.length-1;0<=c&&!k;c--){q=b[c];g=q.getAttribute("data-z-index");var h=!y(g);if(q!==e)if(0>a&&h&&!f&&!c)d.insertBefore(e,b[c]),k=!0;else if(D(g)<=
a||h&&(!y(a)||0<=a))d.insertBefore(e,b[c+1]||null),k=!0}k||(d.insertBefore(e,b[f?3:0]||null),k=!0)}return k},_defaultSetter:function(a,b,f){f.setAttribute(b,a)}});L.prototype.yGetter=L.prototype.xGetter;L.prototype.translateXSetter=L.prototype.translateYSetter=L.prototype.rotationSetter=L.prototype.verticalAlignSetter=L.prototype.rotationOriginXSetter=L.prototype.rotationOriginYSetter=L.prototype.scaleXSetter=L.prototype.scaleYSetter=L.prototype.matrixSetter=function(a,b){this[b]=a;this.doTransform=
!0};L.prototype["stroke-widthSetter"]=L.prototype.strokeSetter=function(a,b,f){this[b]=a;this.stroke&&this["stroke-width"]?(L.prototype.fillSetter.call(this,this.stroke,"stroke",f),f.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===b&&0===a&&this.hasStroke?(f.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(f.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};p=c.SVGRenderer=function(){this.init.apply(this,
arguments)};E(p.prototype,{Element:L,SVG_NS:T,init:function(a,f,q,d,e,k,c){var h=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});c||h.css(this.getStyle(d));d=h.element;a.appendChild(d);b(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&b(d,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=d;this.boxWrapper=h;this.alignedObjects=[];this.url=(x||A)&&u.getElementsByTagName("base").length?S.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,
"%20"):"";this.createElement("desc").add().element.appendChild(u.createTextNode("Created with Highcharts 7.1.3"));this.defs=this.createElement("defs").add();this.allowHTML=k;this.forExport=e;this.styledMode=c;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(f,q,!1);var I;x&&a.getBoundingClientRect&&(f=function(){g(a,{left:0,top:0});I=a.getBoundingClientRect();g(a,{left:Math.ceil(I.left)-I.left+"px",top:Math.ceil(I.top)-I.top+"px"})},f(),this.unSubPixelFix=n(S,"resize",
f))},definition:function(a){function b(a,q){var d;w(a).forEach(function(a){var e=f.createElement(a.tagName),k={};v(a,function(a,b){"tagName"!==b&&"children"!==b&&"textContent"!==b&&(k[b]=a)});e.attr(k);e.add(q||f.defs);a.textContent&&e.element.appendChild(u.createTextNode(a.textContent));b(a.children||[],e);d=e});return d}var f=this;return b(a)},getStyle:function(a){return this.style=E({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},
isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();m(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:H,getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},truncate:function(a,b,f,d,q,
e,k){var g=this,c=a.rotation,h,I=d?1:0,B=(f||d).length,m=B,A=[],C=function(a){b.firstChild&&b.removeChild(b.firstChild);a&&b.appendChild(u.createTextNode(a))},N=function(e,c){c=c||e;if(void 0===A[c])if(b.getSubStringLength)try{A[c]=q+b.getSubStringLength(0,d?c+1:c)}catch(ba){""}else g.getSpanWidth&&(C(k(f||d,e)),A[c]=q+g.getSpanWidth(a,b));return A[c]},L;a.rotation=0;var P=N(b.textContent.length);if(L=q+P>e){for(;I<=B;)m=Math.ceil((I+B)/2),d&&(h=k(d,m)),P=N(m,h&&h.length-1),I===B?I=B+1:P>e?B=m-1:
I=m;0===B?C(""):f&&B===f.length-1||C(h||k(f||d,m))}d&&d.splice(0,m);a.actualWidth=P;a.rotation=c;return L},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(a){var f=a.element,d=this,e=d.forExport,k=q(a.textStr,"").toString(),c=-1!==k.indexOf("<"),h=f.childNodes,B,I=b(f,"x"),m=a.styles,A=a.textWidth,C=m&&m.lineHeight,L=m&&m.textOutline,t=m&&"ellipsis"===m.textOverflow,H=m&&"nowrap"===m.whiteSpace,x=m&&m.fontSize,n,l=h.length;m=A&&!a.added&&this.box;var E=function(a){var b;
d.styledMode||(b=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:x||d.style.fontSize||12);return C?D(C):d.fontMetrics(b,a.getAttribute("style")?a:f).h},w=function(a,b){v(d.escapes,function(f,d){b&&-1!==b.indexOf(f)||(a=a.toString().replace(new RegExp(f,"g"),d))});return a},R=function(a,b){var f=a.indexOf("<");a=a.substring(f,a.indexOf(">")-f);f=a.indexOf(b+"=");if(-1!==f&&(f=f+b.length+1,b=a.charAt(f),'"'===b||"'"===b))return a=a.substring(f+1),a.substring(0,a.indexOf(b))},r=/<br.*?>/g;var S=
[k,t,H,C,L,x,A].join();if(S!==a.textCache){for(a.textCache=S;l--;)f.removeChild(h[l]);c||L||t||A||-1!==k.indexOf(" ")&&(!H||r.test(k))?(m&&m.appendChild(f),c?(k=d.styledMode?k.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):k.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),k=k.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(r)):k=[k],k=
k.filter(function(a){return""!==a}),k.forEach(function(q,k){var c=0,h=0;q=q.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var m=q.split("|||");m.forEach(function(q){if(""!==q||1===m.length){var C={},L=u.createElementNS(d.SVG_NS,"tspan"),P,l;(P=R(q,"class"))&&b(L,"class",P);if(P=R(q,"style"))P=P.replace(/(;| |^)color([ :])/,"$1fill$2"),b(L,"style",P);(l=R(q,"href"))&&!e&&(b(L,"onclick",'location.href="'+l+'"'),b(L,"class","highcharts-anchor"),d.styledMode||
g(L,{cursor:"pointer"}));q=w(q.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==q){L.appendChild(u.createTextNode(q));c?C.dx=0:k&&null!==I&&(C.x=I);b(L,C);f.appendChild(L);!c&&n&&(!N&&e&&g(L,{display:"block"}),b(L,"dy",E(L)));if(A){var Q=q.replace(/([^\^])-/g,"$1- ").split(" ");C=!H&&(1<m.length||k||1<Q.length);l=0;var r=E(L);if(t)B=d.truncate(a,L,q,void 0,0,Math.max(0,A-parseInt(x||12,10)),function(a,b){return a.substring(0,b)+"\u2026"});else if(C)for(;Q.length;)Q.length&&!H&&0<l&&(L=u.createElementNS(T,
"tspan"),b(L,{dy:r,x:I}),P&&b(L,"style",P),L.appendChild(u.createTextNode(Q.join(" ").replace(/- /g,"-"))),f.appendChild(L)),d.truncate(a,L,null,Q,0===l?h:0,A,function(a,b){return Q.slice(0,b).join(" ").replace(/- /g,"-")}),h=a.actualWidth,l++}c++}}});n=n||f.childNodes.length}),t&&B&&a.attr("title",w(a.textStr,["&lt;","&gt;"])),m&&m.removeChild(f),L&&a.applyTextOutline&&a.applyTextOutline(L)):f.appendChild(u.createTextNode(w(k)))}},getContrast:function(b){b=a(b).rgba;b[0]*=1;b[1]*=1.2;b[2]*=.5;return 459<
b[0]+b[1]+b[2]?"#000000":"#FFFFFF"},button:function(a,b,f,d,q,e,g,c,h,m){var I=this.label(a,b,f,h,null,null,m,null,"button"),A=0,C=this.styledMode;I.attr(B({padding:8,r:2},q));if(!C){q=B({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},q);var N=q.style;delete q.style;e=B(q,{fill:"#e6e6e6"},e);var L=e.style;delete e.style;g=B(q,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},g);var t=g.style;delete g.style;c=B(q,{style:{color:"#cccccc"}},
c);var H=c.style;delete c.style}n(I.element,k?"mouseover":"mouseenter",function(){3!==A&&I.setState(1)});n(I.element,k?"mouseout":"mouseleave",function(){3!==A&&I.setState(A)});I.setState=function(a){1!==a&&(I.state=A=a);I.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);C||I.attr([q,e,g,c][a||0]).css([N,L,t,H][a||0])};C||I.attr(q).css(E({cursor:"default"},N));return I.on("click",function(a){3!==A&&d.call(I,
a)})},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+b%2/2);return a},path:function(a){var b=this.styledMode?{}:{fill:"none"};F(a)?b.d=a:r(a)&&E(b,a);return this.createElement("path").attr(b)},circle:function(a,b,f){a=r(a)?a:void 0===a?{}:{x:a,y:b,r:f};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,f){f.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,f,q,d,e){r(a)?(q=a,b=q.y,f=q.r,a=q.x):q={innerR:q,start:d,
end:e};a=this.symbol("arc",a,b,f,f,q);a.r=f;return a},rect:function(a,f,q,d,e,k){e=r(a)?a.r:e;var g=this.createElement("rect");a=r(a)?a:void 0===a?{}:{x:a,y:f,width:Math.max(q,0),height:Math.max(d,0)};this.styledMode||(void 0!==k&&(a.strokeWidth=k,a=g.crisp(a)),a.fill="none");e&&(a.r=e);g.rSetter=function(a,f,q){g.r=a;b(q,{rx:a,ry:a})};g.rGetter=function(){return g.r};return g.attr(a)},setSize:function(a,b,f){var d=this.alignedObjects,e=d.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,
height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:q(f,!0)?void 0:0});e--;)d[e].align()},g:function(a){var b=this.createElement("g");return a?b.attr({"class":"highcharts-"+a}):b},image:function(a,b,f,q,d,e){var k={preserveAspectRatio:"none"},g=function(a,b){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",b):a.setAttribute("hc-svg-href",b)},c=function(b){g(h.element,a);e.call(h,b)};1<arguments.length&&E(k,{x:b,y:f,width:q,
height:d});var h=this.createElement("image").attr(k);e?(g(h.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),k=new S.Image,n(k,"load",c),k.src=a,k.complete&&c({})):g(h.element,a);return h},symbol:function(a,b,f,e,k,c){var m=this,B=/^url\((.*?)\)$/,A=B.test(a),C=!A&&(this.symbols[a]?a:"circle"),I=C&&this.symbols[C],N=y(b)&&I&&I.call(this.symbols,Math.round(b),Math.round(f),e,k,c);if(I){var L=this.path(N);m.styledMode||L.attr("fill","none");E(L,{symbolName:C,x:b,
y:f,width:e,height:k});c&&E(L,c)}else if(A){var t=a.match(B)[1];L=this.image(t);L.imgwidth=q(R[t]&&R[t].width,c&&c.width);L.imgheight=q(R[t]&&R[t].height,c&&c.height);var H=function(){L.attr({width:L.width,height:L.height})};["width","height"].forEach(function(a){L[a+"Setter"]=function(a,b){var f={},q=this["img"+b],d="width"===b?"translateX":"translateY";this[b]=a;y(q)&&(c&&"within"===c.backgroundSize&&this.width&&this.height&&(q=Math.round(q*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),
this.element&&this.element.setAttribute(b,q),this.alignByTranslate||(f[d]=((this[b]||0)-q)/2,this.attr(f)))}});y(b)&&L.attr({x:b,y:f});L.isImg=!0;y(L.imgwidth)&&y(L.imgheight)?H():(L.attr({width:0,height:0}),h("img",{onload:function(){var a=d[m.chartIndex];0===this.width&&(g(this,{position:"absolute",top:"-999em"}),u.body.appendChild(this));R[t]={width:this.width,height:this.height};L.imgwidth=this.width;L.imgheight=this.height;L.element&&H();this.parentNode&&this.parentNode.removeChild(this);m.imgCount--;
if(!m.imgCount&&a&&a.onload)a.onload()},src:t}),this.imgCount++)}return L},symbols:{circle:function(a,b,f,q){return this.arc(a+f/2,b+q/2,f/2,q/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,b,f,q){return["M",a,b,"L",a+f,b,a+f,b+q,a,b+q,"Z"]},triangle:function(a,b,f,q){return["M",a+f/2,b,"L",a+f,b+q,a,b+q,"Z"]},"triangle-down":function(a,b,f,q){return["M",a,b,"L",a+f,b,a+f/2,b+q,"Z"]},diamond:function(a,b,f,q){return["M",a+f/2,b,"L",a+f,b+q/2,a+f/2,b+q,a,b+q/2,"Z"]},arc:function(a,
b,f,d,e){var k=e.start,g=e.r||f,c=e.r||d||f,h=e.end-.001;f=e.innerR;d=q(e.open,.001>Math.abs(e.end-e.start-2*Math.PI));var m=Math.cos(k),B=Math.sin(k),A=Math.cos(h);h=Math.sin(h);k=.001>e.end-k-Math.PI?0:1;e=["M",a+g*m,b+c*B,"A",g,c,0,k,q(e.clockwise,1),a+g*A,b+c*h];y(f)&&e.push(d?"M":"L",a+f*A,b+f*h,"A",f,f,0,k,0,a+f*m,b+f*B);e.push(d?"":"Z");return e},callout:function(a,b,f,q,d){var e=Math.min(d&&d.r||0,f,q),k=e+6,g=d&&d.anchorX;d=d&&d.anchorY;var c=["M",a+e,b,"L",a+f-e,b,"C",a+f,b,a+f,b,a+f,b+
e,"L",a+f,b+q-e,"C",a+f,b+q,a+f,b+q,a+f-e,b+q,"L",a+e,b+q,"C",a,b+q,a,b+q,a,b+q-e,"L",a,b+e,"C",a,b,a,b,a+e,b];g&&g>f?d>b+k&&d<b+q-k?c.splice(13,3,"L",a+f,d-6,a+f+6,d,a+f,d+6,a+f,b+q-e):c.splice(13,3,"L",a+f,q/2,g,d,a+f,q/2,a+f,b+q-e):g&&0>g?d>b+k&&d<b+q-k?c.splice(33,3,"L",a,d+6,a-6,d,a,d-6,a,b+e):c.splice(33,3,"L",a,q/2,g,d,a,q/2,a,b+e):d&&d>q&&g>a+k&&g<a+f-k?c.splice(23,3,"L",g+6,b+q,g,b+q+6,g-6,b+q,a+e,b+q):d&&0>d&&g>a+k&&g<a+f-k&&c.splice(3,3,"L",g-6,b,g,b-6,g+6,b,f-e,b);return c}},clipRect:function(a,
b,f,q){var d=c.uniqueKey()+"-",e=this.createElement("clipPath").attr({id:d}).add(this.defs);a=this.rect(a,b,f,q,0).add(e);a.id=d;a.clipPath=e;a.count=0;return a},text:function(a,b,f,q){var d={};if(q&&(this.allowHTML||!this.forExport))return this.html(a,b,f);d.x=Math.round(b||0);f&&(d.y=Math.round(f));y(a)&&(d.text=a);a=this.createElement("text").attr(d);q||(a.xSetter=function(a,b,f){var q=f.getElementsByTagName("tspan"),d=f.getAttribute(b),e;for(e=0;e<q.length;e++){var k=q[e];k.getAttribute(b)===
d&&k.setAttribute(b,a)}f.setAttribute(b,a)});return a},fontMetrics:function(a,b){a=!this.styledMode&&/px/.test(a)||!S.getComputedStyle?a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize:b&&L.prototype.getStyle.call(b,"font-size");a=/px/.test(a)?D(a):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,b,f){var q=a;b&&f&&(q=Math.max(q*Math.cos(b*e),4));return{x:-a/3*Math.sin(b*e),y:q}},label:function(a,b,q,d,e,k,g,c,h){var m=this,A=m.styledMode,C=m.g("button"!==
h&&"label"),N=C.text=m.text("",0,0,g).attr({zIndex:1}),t,H,u=0,x=3,n=0,I,l,T,P,w,Q={},R,r,S=/^url\((.*?)\)$/.test(d),v=A||S,p=function(){return A?t.strokeWidth()%2/2:(R?parseInt(R,10):0)%2/2};h&&C.addClass("highcharts-"+h);var K=function(){var a=N.element.style,b={};H=(void 0===I||void 0===l||w)&&y(N.textStr)&&N.getBBox();C.width=(I||H.width||0)+2*x+n;C.height=(l||H.height||0)+2*x;r=x+Math.min(m.fontMetrics(a&&a.fontSize,N).b,H?H.height:Infinity);v&&(t||(C.box=t=m.symbols[d]||S?m.symbol(d):m.rect(),
t.addClass(("button"===h?"":"highcharts-label-box")+(h?" highcharts-"+h+"-box":"")),t.add(C),a=p(),b.x=a,b.y=(c?-r:0)+a),b.width=Math.round(C.width),b.height=Math.round(C.height),t.attr(E(b,Q)),Q={})};var D=function(){var a=n+x;var b=c?0:r;y(I)&&H&&("center"===w||"right"===w)&&(a+={center:.5,right:1}[w]*(I-H.width));if(a!==N.x||b!==N.y)N.attr("x",a),N.hasBoxWidthChanged&&(H=N.getBBox(!0),K()),void 0!==b&&N.attr("y",b);N.x=a;N.y=b};var V=function(a,b){t?t.attr(a,b):Q[a]=b};C.onAdd=function(){N.add(C);
C.attr({text:a||0===a?a:"",x:b,y:q});t&&y(e)&&C.attr({anchorX:e,anchorY:k})};C.widthSetter=function(a){I=z(a)?a:null};C.heightSetter=function(a){l=a};C["text-alignSetter"]=function(a){w=a};C.paddingSetter=function(a){y(a)&&a!==x&&(x=C.padding=a,D())};C.paddingLeftSetter=function(a){y(a)&&a!==n&&(n=a,D())};C.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==u&&(u=a,H&&C.attr({x:T}))};C.textSetter=function(a){void 0!==a&&N.attr({text:a});K();D()};C["stroke-widthSetter"]=function(a,b){a&&(v=
!0);R=this["stroke-width"]=a;V(b,a)};A?C.rSetter=function(a,b){V(b,a)}:C.strokeSetter=C.fillSetter=C.rSetter=function(a,b){"r"!==b&&("fill"===b&&a&&(v=!0),C[b]=a);V(b,a)};C.anchorXSetter=function(a,b){e=C.anchorX=a;V(b,Math.round(a)-p()-T)};C.anchorYSetter=function(a,b){k=C.anchorY=a;V(b,a-P)};C.xSetter=function(a){C.x=a;u&&(a-=u*((I||H.width)+2*x),C["forceAnimate:x"]=!0);T=Math.round(a);C.attr("translateX",T)};C.ySetter=function(a){P=C.y=Math.round(a);C.attr("translateY",P)};var U=C.css;g={css:function(a){if(a){var b=
{};a=B(a);C.textProps.forEach(function(f){void 0!==a[f]&&(b[f]=a[f],delete a[f])});N.css(b);"width"in b&&K();"fontSize"in b&&(K(),D())}return U.call(C,a)},getBBox:function(){return{width:H.width+2*x,height:H.height+2*x,x:H.x-x,y:H.y-x}},destroy:function(){f(C.element,"mouseenter");f(C.element,"mouseleave");N&&(N=N.destroy());t&&(t=t.destroy());L.prototype.destroy.call(C);C=m=K=D=V=null}};A||(g.shadow=function(a){a&&(K(),t&&t.shadow(a));return C});return E(C,g)}});c.Renderer=p});M(J,"parts/Html.js",
[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.pInt,F=c.attr,z=c.createElement,r=c.css,K=c.extend,v=c.isFirefox,D=c.isMS,w=c.isWebKit,n=c.pick,l=c.SVGElement;p=c.SVGRenderer;var b=c.win;K(l.prototype,{htmlCss:function(b){var a="SPAN"===this.element.tagName&&b&&"width"in b,d=n(a&&b.width,void 0);if(a){delete b.width;this.textWidth=d;var c=!0}b&&"ellipsis"===b.textOverflow&&(b.whiteSpace="nowrap",b.overflow="hidden");this.styles=K(this.styles,b);r(this.element,b);
c&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var b=this.element;return{x:b.offsetLeft,y:b.offsetTop,width:b.offsetWidth,height:b.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var b=this.renderer,a=this.element,g=this.translateX||0,c=this.translateY||0,e=this.x||0,m=this.y||0,u=this.textAlign||"left",n={left:0,center:.5,right:1}[u],t=this.styles,x=t&&t.whiteSpace;r(a,{marginLeft:g,marginTop:c});!b.styledMode&&this.shadows&&this.shadows.forEach(function(a){r(a,{marginLeft:g+
1,marginTop:c+1})});this.inverted&&[].forEach.call(a.childNodes,function(d){b.invertChild(d,a)});if("SPAN"===a.tagName){t=this.rotation;var k=this.textWidth&&G(this.textWidth),A=[t,u,a.innerHTML,this.textWidth,this.textAlign].join(),B;(B=k!==this.oldTextWidth)&&!(B=k>this.oldTextWidth)&&((B=this.textPxLength)||(r(a,{width:"",whiteSpace:x||"nowrap"}),B=a.offsetWidth),B=B>k);B&&(/[ \-]/.test(a.textContent||a.innerText)||"ellipsis"===a.style.textOverflow)?(r(a,{width:k+"px",display:"block",whiteSpace:x||
"normal"}),this.oldTextWidth=k,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;A!==this.cTT&&(x=b.fontMetrics(a.style.fontSize,a).b,!y(t)||t===(this.oldRotation||0)&&u===this.oldAlign||this.setSpanRotation(t,n,x),this.getSpanCorrection(!y(t)&&this.textPxLength||a.offsetWidth,x,n,t,u));r(a,{left:e+(this.xCorr||0)+"px",top:m+(this.yCorr||0)+"px"});this.cTT=A;this.oldRotation=t;this.oldAlign=u}}else this.alignOnAdd=!0},setSpanRotation:function(b,a,g){var d={},e=this.renderer.getTransformKey();
d[e]=d.transform="rotate("+b+"deg)";d[e+(v?"Origin":"-origin")]=d.transformOrigin=100*a+"% "+g+"px";r(this.element,d)},getSpanCorrection:function(b,a,g){this.xCorr=-b*g;this.yCorr=-a}});K(p.prototype,{getTransformKey:function(){return D&&!/Edge/.test(b.navigator.userAgent)?"-ms-transform":w?"-webkit-transform":v?"MozTransform":b.opera?"-o-transform":""},html:function(b,a,g){var d=this.createElement("span"),e=d.element,m=d.renderer,u=m.isSVG,E=function(a,b){["opacity","visibility"].forEach(function(d){a[d+
"Setter"]=function(e,k,q){var f=a.div?a.div.style:b;l.prototype[d+"Setter"].call(this,e,k,q);f&&(f[k]=e)}});a.addedSetters=!0},t=c.charts[m.chartIndex];t=t&&t.styledMode;d.textSetter=function(a){a!==e.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;e.innerHTML=n(a,"");d.doTransform=!0};u&&E(d,d.element.style);d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){"align"===b&&(b="textAlign");d[b]=a;d.doTransform=!0};d.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),
this.doTransform=!1)};d.attr({text:b,x:Math.round(a),y:Math.round(g)}).css({position:"absolute"});t||d.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});e.style.whiteSpace="nowrap";d.css=d.htmlCss;u&&(d.add=function(a){var b=m.box.parentNode,g=[];if(this.parentGroup=a){var c=a.div;if(!c){for(;a;)g.push(a),a=a.parentGroup;g.reverse().forEach(function(a){function q(b,f){a[f]=b;"translateX"===f?e.left=b+"px":e.top=b+"px";a.doTransform=!0}var f=F(a.element,"class");f&&(f={className:f});
c=a.div=a.div||z("div",f,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},c||b);var e=c.style;K(a,{classSetter:function(a){return function(b){this.element.setAttribute("class",b);a.className=b}}(c),on:function(){g[0].div&&d.on.apply({element:g[0].div},arguments);return a},translateXSetter:q,translateYSetter:q});a.addedSetters||E(a)})}}else c=b;c.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();
return d});return d}})});M(J,"parts/Time.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isObject,F=p.objectEach,z=p.splat,r=c.extend,K=c.merge,v=c.pick,D=c.timeUnits,w=c.win;c.Time=function(c){this.update(c,!1)};c.Time.prototype={defaultOptions:{},update:function(c){var n=v(c&&c.useUTC,!0),b=this;this.options=c=K(!0,this.options||{},c);this.Date=c.Date||w.Date||Date;this.timezoneOffset=(this.useUTC=n)&&c.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();
(this.variableTimezone=!(n&&!c.getTimezoneOffset&&!c.timezone))||this.timezoneOffset?(this.get=function(d,a){var g=a.getTime(),c=g-b.getTimezoneOffset(a);a.setTime(c);d=a["getUTC"+d]();a.setTime(g);return d},this.set=function(d,a,g){if("Milliseconds"===d||"Seconds"===d||"Minutes"===d&&0===a.getTimezoneOffset()%60)a["set"+d](g);else{var c=b.getTimezoneOffset(a);c=a.getTime()-c;a.setTime(c);a["setUTC"+d](g);d=b.getTimezoneOffset(a);c=a.getTime()+d;a.setTime(c)}}):n?(this.get=function(b,a){return a["getUTC"+
b]()},this.set=function(b,a,c){return a["setUTC"+b](c)}):(this.get=function(b,a){return a["get"+b]()},this.set=function(b,a,c){return a["set"+b](c)})},makeTime:function(n,l,b,d,a,g){if(this.useUTC){var h=this.Date.UTC.apply(0,arguments);var e=this.getTimezoneOffset(h);h+=e;var m=this.getTimezoneOffset(h);e!==m?h+=m-e:e-36E5!==this.getTimezoneOffset(h-36E5)||c.isSafari||(h-=36E5)}else h=(new this.Date(n,l,v(b,1),v(d,0),v(a,0),v(g,0))).getTime();return h},timezoneOffsetFunction:function(){var n=this,
l=this.options,b=w.moment;if(!this.useUTC)return function(b){return 6E4*(new Date(b)).getTimezoneOffset()};if(l.timezone){if(b)return function(d){return 6E4*-b.tz(d,l.timezone).utcOffset()};c.error(25)}return this.useUTC&&l.getTimezoneOffset?function(b){return 6E4*l.getTimezoneOffset(b)}:function(){return 6E4*(n.timezoneOffset||0)}},dateFormat:function(n,l,b){if(!y(l)||isNaN(l))return c.defaultOptions.lang.invalidDate||"";n=c.pick(n,"%Y-%m-%d %H:%M:%S");var d=this,a=new this.Date(l),g=this.get("Hours",
a),h=this.get("Day",a),e=this.get("Date",a),m=this.get("Month",a),u=this.get("FullYear",a),E=c.defaultOptions.lang,t=E.weekdays,x=E.shortWeekdays,k=c.pad;a=c.extend({a:x?x[h]:t[h].substr(0,3),A:t[h],d:k(e),e:k(e,2," "),w:h,b:E.shortMonths[m],B:E.months[m],m:k(m+1),o:m+1,y:u.toString().substr(2,2),Y:u,H:k(g),k:g,I:k(g%12||12),l:g%12||12,M:k(d.get("Minutes",a)),p:12>g?"AM":"PM",P:12>g?"am":"pm",S:k(a.getSeconds()),L:k(Math.floor(l%1E3),3)},c.dateFormats);F(a,function(a,b){for(;-1!==n.indexOf("%"+b);)n=
n.replace("%"+b,"function"===typeof a?a.call(d,l):a)});return b?n.substr(0,1).toUpperCase()+n.substr(1):n},resolveDTLFormat:function(c){return G(c,!0)?c:(c=z(c),{main:c[0],from:c[1],to:c[2]})},getTimeTicks:function(c,l,b,d){var a=this,g=[],h={};var e=new a.Date(l);var m=c.unitRange,u=c.count||1,n;d=v(d,1);if(y(l)){a.set("Milliseconds",e,m>=D.second?0:u*Math.floor(a.get("Milliseconds",e)/u));m>=D.second&&a.set("Seconds",e,m>=D.minute?0:u*Math.floor(a.get("Seconds",e)/u));m>=D.minute&&a.set("Minutes",
e,m>=D.hour?0:u*Math.floor(a.get("Minutes",e)/u));m>=D.hour&&a.set("Hours",e,m>=D.day?0:u*Math.floor(a.get("Hours",e)/u));m>=D.day&&a.set("Date",e,m>=D.month?1:Math.max(1,u*Math.floor(a.get("Date",e)/u)));if(m>=D.month){a.set("Month",e,m>=D.year?0:u*Math.floor(a.get("Month",e)/u));var t=a.get("FullYear",e)}m>=D.year&&a.set("FullYear",e,t-t%u);m===D.week&&(t=a.get("Day",e),a.set("Date",e,a.get("Date",e)-t+d+(t<d?-7:0)));t=a.get("FullYear",e);d=a.get("Month",e);var x=a.get("Date",e),k=a.get("Hours",
e);l=e.getTime();a.variableTimezone&&(n=b-l>4*D.month||a.getTimezoneOffset(l)!==a.getTimezoneOffset(b));l=e.getTime();for(e=1;l<b;)g.push(l),l=m===D.year?a.makeTime(t+e*u,0):m===D.month?a.makeTime(t,d+e*u):!n||m!==D.day&&m!==D.week?n&&m===D.hour&&1<u?a.makeTime(t,d,x,k+e*u):l+m*u:a.makeTime(t,d,x+e*u*(m===D.day?1:7)),e++;g.push(l);m<=D.hour&&1E4>g.length&&g.forEach(function(b){0===b%18E5&&"000000000"===a.dateFormat("%H%M%S%L",b)&&(h[b]="day")})}g.info=r(c,{higherRanks:h,totalRange:m*u});return g}}});
M(J,"parts/Options.js",[J["parts/Globals.js"]],function(c){var p=c.color,y=c.merge;c.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:c.Time.prototype.defaultOptions,chart:{styledMode:!1,borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",
margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},
shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:c.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",
day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:c.isTouchDevice?25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:p("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",
position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};c.setOptions=function(p){c.defaultOptions=y(!0,c.defaultOptions,p);c.time.update(y(c.defaultOptions.global,c.defaultOptions.time),!1);return c.defaultOptions};c.getOptions=function(){return c.defaultOptions};c.defaultPlotOptions=c.defaultOptions.plotOptions;c.time=new c.Time(y(c.defaultOptions.global,c.defaultOptions.time));c.dateFormat=function(p,y,z){return c.time.dateFormat(p,
y,z)};""});M(J,"parts/Tick.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=c.correctFloat,z=c.destroyObjectProperties,r=c.fireEvent,K=c.merge,v=c.pick,D=c.deg2rad;c.Tick=function(c,n,l,b,d){this.axis=c;this.pos=n;this.type=l||"";this.isNewLabel=this.isNew=!0;this.parameters=d||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;l||b||this.addLabel()};c.Tick.prototype={addLabel:function(){var w=this,n=w.axis,l=
n.options,b=n.chart,d=n.categories,a=n.names,g=w.pos,h=v(w.options&&w.options.labels,l.labels),e=n.tickPositions,m=g===e[0],u=g===e[e.length-1];d=this.parameters.category||(d?v(d[g],a[g],g):g);var E=w.label;e=e.info;var t,x;if(n.isDatetimeAxis&&e){var k=b.time.resolveDTLFormat(l.dateTimeLabelFormats[!l.grid&&e.higherRanks[g]||e.unitName]);var A=k.main}w.isFirst=m;w.isLast=u;w.formatCtx={axis:n,chart:b,isFirst:m,isLast:u,dateTimeLabelFormat:A,tickPositionInfo:e,value:n.isLog?F(n.lin2log(d)):d,pos:g};
l=n.labelFormatter.call(w.formatCtx,this.formatCtx);if(x=k&&k.list)w.shortenLabel=function(){for(t=0;t<x.length;t++)if(E.attr({text:n.labelFormatter.call(c.extend(w.formatCtx,{dateTimeLabelFormat:x[t]}))}),E.getBBox().width<n.getSlotWidth(w)-2*v(h.padding,5))return;E.attr({text:""})};if(y(E))E&&E.textStr!==l&&(!E.textWidth||h.style&&h.style.width||E.styles.width||E.css({width:null}),E.attr({text:l}),E.textPxLength=E.getBBox().width);else{if(w.label=E=y(l)&&h.enabled?b.renderer.text(l,0,0,h.useHTML).add(n.labelGroup):
null)b.styledMode||E.css(K(h.style)),E.textPxLength=E.getBBox().width;w.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(c){var n=this.axis,l=n.options.labels,b=c.x,d=n.chart.chartWidth,a=n.chart.spacing,g=v(n.labelLeft,Math.min(n.pos,a[3]));a=v(n.labelRight,Math.max(n.isRadial?0:n.pos+n.len,d-a[1]));var h=this.label,e=this.rotation,m={left:0,center:.5,right:1}[n.labelAlign||h.attr("align")],u=h.getBBox().width,
E=n.getSlotWidth(this),t=E,x=1,k,A={};if(e||"justify"!==v(l.overflow,"justify"))0>e&&b-m*u<g?k=Math.round(b/Math.cos(e*D)-g):0<e&&b+m*u>a&&(k=Math.round((d-b)/Math.cos(e*D)));else if(d=b+(1-m)*u,b-m*u<g?t=c.x+t*(1-m)-g:d>a&&(t=a-c.x+t*m,x=-1),t=Math.min(E,t),t<E&&"center"===n.labelAlign&&(c.x+=x*(E-t-m*(E-Math.min(u,t)))),u>t||n.autoRotation&&(h.styles||{}).width)k=t;k&&(this.shortenLabel?this.shortenLabel():(A.width=Math.floor(k),(l.style||{}).textOverflow||(A.textOverflow="ellipsis"),h.css(A)))},
getPosition:function(w,n,l,b){var d=this.axis,a=d.chart,g=b&&a.oldChartHeight||a.chartHeight;w={x:w?c.correctFloat(d.translate(n+l,null,null,b)+d.transB):d.left+d.offset+(d.opposite?(b&&a.oldChartWidth||a.chartWidth)-d.right-d.left:0),y:w?g-d.bottom+d.offset-(d.opposite?d.height:0):c.correctFloat(g-d.translate(n+l,null,null,b)-d.transB)};w.y=Math.max(Math.min(w.y,1E5),-1E5);r(this,"afterGetPosition",{pos:w});return w},getLabelPosition:function(c,n,l,b,d,a,g,h){var e=this.axis,m=e.transA,u=e.reversed,
E=e.staggerLines,t=e.tickRotCorr||{x:0,y:0},x=d.y,k=b||e.reserveSpaceDefault?0:-e.labelOffset*("center"===e.labelAlign?.5:1),A={};y(x)||(x=0===e.side?l.rotation?-8:-l.getBBox().height:2===e.side?t.y+8:Math.cos(l.rotation*D)*(t.y-l.getBBox(!1,0).height/2));c=c+d.x+k+t.x-(a&&b?a*m*(u?-1:1):0);n=n+x-(a&&!b?a*m*(u?1:-1):0);E&&(l=g/(h||1)%E,e.opposite&&(l=E-l-1),n+=e.labelOffset/E*l);A.x=c;A.y=Math.round(n);r(this,"afterGetLabelPosition",{pos:A,tickmarkOffset:a,index:g});return A},getMarkPath:function(c,
n,l,b,d,a){return a.crispLine(["M",c,n,"L",c+(d?0:-l),n+(d?l:0)],b)},renderGridLine:function(c,n,l){var b=this.axis,d=b.options,a=this.gridLine,g={},h=this.pos,e=this.type,m=v(this.tickmarkOffset,b.tickmarkOffset),u=b.chart.renderer,E=e?e+"Grid":"grid",t=d[E+"LineWidth"],x=d[E+"LineColor"];d=d[E+"LineDashStyle"];a||(b.chart.styledMode||(g.stroke=x,g["stroke-width"]=t,d&&(g.dashstyle=d)),e||(g.zIndex=1),c&&(n=0),this.gridLine=a=u.path().attr(g).addClass("highcharts-"+(e?e+"-":"")+"grid-line").add(b.gridGroup));
if(a&&(l=b.getPlotLinePath({value:h+m,lineWidth:a.strokeWidth()*l,force:"pass",old:c})))a[c||this.isNew?"attr":"animate"]({d:l,opacity:n})},renderMark:function(c,n,l){var b=this.axis,d=b.options,a=b.chart.renderer,g=this.type,h=g?g+"Tick":"tick",e=b.tickSize(h),m=this.mark,u=!m,E=c.x;c=c.y;var t=v(d[h+"Width"],!g&&b.isXAxis?1:0);d=d[h+"Color"];e&&(b.opposite&&(e[0]=-e[0]),u&&(this.mark=m=a.path().addClass("highcharts-"+(g?g+"-":"")+"tick").add(b.axisGroup),b.chart.styledMode||m.attr({stroke:d,"stroke-width":t})),
m[u?"attr":"animate"]({d:this.getMarkPath(E,c,e[0],m.strokeWidth()*l,b.horiz,a),opacity:n}))},renderLabel:function(c,n,l,b){var d=this.axis,a=d.horiz,g=d.options,h=this.label,e=g.labels,m=e.step;d=v(this.tickmarkOffset,d.tickmarkOffset);var u=!0,E=c.x;c=c.y;h&&G(E)&&(h.xy=c=this.getLabelPosition(E,c,h,a,e,d,b,m),this.isFirst&&!this.isLast&&!v(g.showFirstLabel,1)||this.isLast&&!this.isFirst&&!v(g.showLastLabel,1)?u=!1:!a||e.step||e.rotation||n||0===l||this.handleOverflow(c),m&&b%m&&(u=!1),u&&G(c.y)?
(c.opacity=l,h[this.isNewLabel?"attr":"animate"](c),this.isNewLabel=!1):(h.attr("y",-9999),this.isNewLabel=!0))},render:function(r,n,l){var b=this.axis,d=b.horiz,a=this.pos,g=v(this.tickmarkOffset,b.tickmarkOffset);a=this.getPosition(d,a,g,n);g=a.x;var h=a.y;b=d&&g===b.pos+b.len||!d&&h===b.pos?-1:1;l=v(l,1);this.isActive=!0;this.renderGridLine(n,l,b);this.renderMark(a,l,b);this.renderLabel(a,n,l,r);this.isNew=!1;c.fireEvent(this,"afterRender")},destroy:function(){z(this,this.axis)}}});M(J,"parts/Axis.js",
[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isArray,F=p.isNumber,z=p.isString,r=p.objectEach,K=p.splat,v=c.addEvent,D=c.animObject,w=c.arrayMax,n=c.arrayMin,l=c.color,b=c.correctFloat,d=c.defaultOptions,a=c.deg2rad,g=c.destroyObjectProperties,h=c.extend,e=c.fireEvent,m=c.format,u=c.getMagnitude,E=c.merge,t=c.normalizeTickInterval,x=c.pick,k=c.removeEvent,A=c.seriesTypes,B=c.syncTimeout,H=c.Tick;p=function(){this.init.apply(this,arguments)};c.extend(p.prototype,
{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,
tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){return c.numberFormat(this.total,
-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},init:function(a,b){var f=b.isX,q=this;q.chart=a;q.horiz=a.inverted&&!q.isZAxis?!f:f;q.isXAxis=
f;q.coll=q.coll||(f?"xAxis":"yAxis");e(this,"init",{userOptions:b});q.opposite=b.opposite;q.side=b.side||(q.horiz?q.opposite?0:2:q.opposite?1:3);q.setOptions(b);var d=this.options,k=d.type;q.labelFormatter=d.labels.formatter||q.defaultLabelFormatter;q.userOptions=b;q.minPixelPadding=0;q.reversed=d.reversed;q.visible=!1!==d.visible;q.zoomEnabled=!1!==d.zoomEnabled;q.hasNames="category"===k||!0===d.categories;q.categories=d.categories||q.hasNames;q.names||(q.names=[],q.names.keys={});q.plotLinesAndBandsGroups=
{};q.isLog="logarithmic"===k;q.isDatetimeAxis="datetime"===k;q.positiveValuesOnly=q.isLog&&!q.allowNegativeLog;q.isLinked=y(d.linkedTo);q.ticks={};q.labelEdge=[];q.minorTicks={};q.plotLinesAndBands=[];q.alternateBands={};q.len=0;q.minRange=q.userMinRange=d.minRange||d.maxZoom;q.range=d.range;q.offset=d.offset||0;q.stacks={};q.oldStacks={};q.stacksTouched=0;q.max=null;q.min=null;q.crosshair=x(d.crosshair,K(a.options.tooltip.crosshairs)[f?0:1],!1);b=q.options.events;-1===a.axes.indexOf(q)&&(f?a.axes.splice(a.xAxis.length,
0,q):a.axes.push(q),a[q.coll].push(q));q.series=q.series||[];a.inverted&&!q.isZAxis&&f&&void 0===q.reversed&&(q.reversed=!0);r(b,function(a,b){c.isFunction(a)&&v(q,b,a)});q.lin2log=d.linearToLogConverter||q.lin2log;q.isLog&&(q.val2lin=q.log2lin,q.lin2val=q.lin2log);e(this,"afterInit")},setOptions:function(a){this.options=E(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],
E(d[this.coll],a));e(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var a=this.axis,b=this.value,e=a.chart.time,k=a.categories,g=this.dateTimeLabelFormat,h=d.lang,B=h.numericSymbols;h=h.numericSymbolMagnitude||1E3;var A=B&&B.length,t=a.options.labels.format;a=a.isLog?Math.abs(b):a.tickInterval;if(t)var u=m(t,this,e);else if(k)u=b;else if(g)u=e.dateFormat(g,b);else if(A&&1E3<=a)for(;A--&&void 0===u;)e=Math.pow(h,A+1),a>=e&&0===10*b%e&&null!==B[A]&&0!==b&&(u=c.numberFormat(b/
e,-1)+B[A]);void 0===u&&(u=1E4<=Math.abs(b)?c.numberFormat(b,-1):c.numberFormat(b,-1,void 0,""));return u},getSeriesExtremes:function(){var a=this,b=a.chart,d;e(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();a.series.forEach(function(f){if(f.visible||!b.options.chart.ignoreHiddenSeries){var q=f.options,e=q.threshold;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=e&&(e=null);if(a.isXAxis){if(q=
f.xData,q.length){d=f.getXExtremes(q);var c=d.min;var k=d.max;F(c)||c instanceof Date||(q=q.filter(F),d=f.getXExtremes(q),c=d.min,k=d.max);q.length&&(a.dataMin=Math.min(x(a.dataMin,c),c),a.dataMax=Math.max(x(a.dataMax,k),k))}}else if(f.getExtremes(),k=f.dataMax,c=f.dataMin,y(c)&&y(k)&&(a.dataMin=Math.min(x(a.dataMin,c),c),a.dataMax=Math.max(x(a.dataMax,k),k)),y(e)&&(a.threshold=e),!q.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});e(this,"afterGetSeriesExtremes")},translate:function(a,
b,d,e,c,k){var f=this.linkedParent||this,q=1,g=0,h=e?f.oldTransA:f.transA;e=e?f.oldMin:f.min;var m=f.minPixelPadding;c=(f.isOrdinal||f.isBroken||f.isLog&&c)&&f.lin2val;h||(h=f.transA);d&&(q*=-1,g=f.len);f.reversed&&(q*=-1,g-=q*(f.sector||f.len));b?(a=(a*q+g-m)/h+e,c&&(a=f.lin2val(a))):(c&&(a=f.val2lin(a)),a=F(e)?q*(a-e)*h+g+q*m+(F(k)?h*k:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),
!0,!this.horiz,null,!0)},getPlotLinePath:function(a){var b=this,q=b.chart,d=b.left,c=b.top,k=a.old,g=a.value,h=a.translatedValue,m=a.lineWidth,B=a.force,A,t,u,H,n=k&&q.oldChartHeight||q.chartHeight,l=k&&q.oldChartWidth||q.chartWidth,E,r=b.transB,w=function(a,b,f){if("pass"!==B&&a<b||a>f)B?a=Math.min(Math.max(b,a),f):E=!0;return a};a={value:g,lineWidth:m,old:k,force:B,acrossPanes:a.acrossPanes,translatedValue:h};e(this,"getPlotLinePath",a,function(a){h=x(h,b.translate(g,null,null,k));h=Math.min(Math.max(-1E5,
h),1E5);A=u=Math.round(h+r);t=H=Math.round(n-h-r);F(h)?b.horiz?(t=c,H=n-b.bottom,A=u=w(A,d,d+b.width)):(A=d,u=l-b.right,t=H=w(t,c,c+b.height)):(E=!0,B=!1);a.path=E&&!B?null:q.renderer.crispLine(["M",A,t,"L",u,H],m||1)});return a.path},getLinearTickPositions:function(a,f,d){var q=b(Math.floor(f/a)*a);d=b(Math.ceil(d/a)*a);var e=[],c;b(q+a)===q&&(c=20);if(this.single)return[f];for(f=q;f<=d;){e.push(f);f=b(f+a,c);if(f===k)break;var k=f}return e},getMinorTickInterval:function(){var a=this.options;return!0===
a.minorTicks?x(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,e=a.minorTickInterval,c=[],k=a.pointRangePadding||0,g=a.min-k;k=a.max+k;var h=k-g;if(h&&h/e<a.len/3)if(a.isLog)this.paddedTicks.forEach(function(b,f,d){f&&c.push.apply(c,a.getLogTickPositions(e,d[f-1],d[f],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())c=c.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),g,k,b.startOfWeek));
else for(b=g+(d[0]-g)%e;b<=k&&b!==c[0];b+=e)c.push(b);0!==c.length&&a.trimTicks(c);return c},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,e,c,k,g,h;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(y(a.min)||y(a.max)?this.minRange=null:(this.series.forEach(function(a){g=a.xData;for(c=h=a.xIncrement?1:g.length-1;0<c;c--)if(k=g[c]-g[c-1],void 0===e||k<e)e=k}),this.minRange=Math.min(5*e,this.dataMax-this.dataMin)));if(d-b<this.minRange){var m=this.dataMax-this.dataMin>=this.minRange;
var B=this.minRange;var A=(B-d+b)/2;A=[b-A,x(a.min,b-A)];m&&(A[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin);b=w(A);d=[b+B,x(a.max,b+B)];m&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax);d=n(d);d-b<B&&(A[0]=d-B,A[1]=x(a.min,d-B),b=w(A))}this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:this.series.forEach(function(b){var f=b.closestPointRange,d=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&y(f)&&d&&(a=y(a)?Math.min(a,f):f)});return a},
nameToX:function(a){var b=G(this.categories),d=b?this.categories:this.names,e=a.options.x;a.series.requireSorting=!1;y(e)||(e=!1===this.options.uniqueNames?a.series.autoIncrement():b?d.indexOf(a.name):x(d.keys[a.name],-1));if(-1===e){if(!b)var q=d.length}else q=e;void 0!==q&&(this.names[q]=a.name,this.names.keys[a.name]=q);return q},updateNames:function(){var a=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,(this.series||
[]).forEach(function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)a.max=Math.max(a.max,b.xData.length-1),b.processData(),b.generatePoints();b.data.forEach(function(f,d){if(f&&f.options&&void 0!==f.name){var e=a.nameToX(f);void 0!==e&&e!==f.x&&(f.x=e,b.xData[d]=e)}})}))},setAxisTranslation:function(a){var b=this,d=b.max-b.min,q=b.axisPointRange||0,c=0,k=0,g=b.linkedParent,h=!!b.categories,m=b.transA,B=b.isXAxis;if(B||h||q){var t=b.getClosest();g?(c=g.minPointOffset,k=g.pointRangePadding):b.series.forEach(function(a){var f=
h?1:B?x(a.options.pointRange,t,0):b.axisPointRange||0,d=a.options.pointPlacement;q=Math.max(q,f);if(!b.single||h)a=A.xrange&&a instanceof A.xrange?!B:B,c=Math.max(c,a&&z(d)?0:f/2),k=Math.max(k,a&&"on"===d?0:f)});g=b.ordinalSlope&&t?b.ordinalSlope/t:1;b.minPointOffset=c*=g;b.pointRangePadding=k*=g;b.pointRange=Math.min(q,d);B&&(b.closestPointRange=t)}a&&(b.oldTransA=m);b.translationSlope=b.transA=m=b.staticScale||b.len/(d+k||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=m*c;e(this,"afterSetAxisTranslation")},
minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var f=this,d=f.chart,q=f.options,k=f.isLog,g=f.isDatetimeAxis,h=f.isXAxis,m=f.isLinked,B=q.maxPadding,A=q.minPadding,H=q.tickInterval,n=q.tickPixelInterval,l=f.categories,E=F(f.threshold)?f.threshold:null,r=f.softThreshold;g||l||m||this.getTickAmount();var w=x(f.userMin,q.min);var v=x(f.userMax,q.max);if(m){f.linkedParent=d[f.coll][q.linkedTo];var z=f.linkedParent.getExtremes();f.min=x(z.min,z.dataMin);f.max=x(z.max,z.dataMax);
q.type!==f.linkedParent.options.type&&c.error(11,1,d)}else{if(!r&&y(E))if(f.dataMin>=E)z=E,A=0;else if(f.dataMax<=E){var p=E;B=0}f.min=x(w,z,f.dataMin);f.max=x(v,p,f.dataMax)}k&&(f.positiveValuesOnly&&!a&&0>=Math.min(f.min,x(f.dataMin,f.min))&&c.error(10,1,d),f.min=b(f.log2lin(f.min),15),f.max=b(f.log2lin(f.max),15));f.range&&y(f.max)&&(f.userMin=f.min=w=Math.max(f.dataMin,f.minFromRange()),f.userMax=v=f.max,f.range=null);e(f,"foundExtremes");f.beforePadding&&f.beforePadding();f.adjustForMinRange();
!(l||f.axisPointRange||f.usePercentage||m)&&y(f.min)&&y(f.max)&&(d=f.max-f.min)&&(!y(w)&&A&&(f.min-=d*A),!y(v)&&B&&(f.max+=d*B));F(q.softMin)&&!F(f.userMin)&&q.softMin<f.min&&(f.min=w=q.softMin);F(q.softMax)&&!F(f.userMax)&&q.softMax>f.max&&(f.max=v=q.softMax);F(q.floor)&&(f.min=Math.min(Math.max(f.min,q.floor),Number.MAX_VALUE));F(q.ceiling)&&(f.max=Math.max(Math.min(f.max,q.ceiling),x(f.userMax,-Number.MAX_VALUE)));r&&y(f.dataMin)&&(E=E||0,!y(w)&&f.min<E&&f.dataMin>=E?f.min=f.options.minRange?Math.min(E,
f.max-f.minRange):E:!y(v)&&f.max>E&&f.dataMax<=E&&(f.max=f.options.minRange?Math.max(E,f.min+f.minRange):E));f.tickInterval=f.min===f.max||void 0===f.min||void 0===f.max?1:m&&!H&&n===f.linkedParent.options.tickPixelInterval?H=f.linkedParent.tickInterval:x(H,this.tickAmount?(f.max-f.min)/Math.max(this.tickAmount-1,1):void 0,l?1:(f.max-f.min)*n/Math.max(f.len,n));h&&!a&&f.series.forEach(function(a){a.processData(f.min!==f.oldMin||f.max!==f.oldMax)});f.setAxisTranslation(!0);f.beforeSetTickPositions&&
f.beforeSetTickPositions();f.postProcessTickInterval&&(f.tickInterval=f.postProcessTickInterval(f.tickInterval));f.pointRange&&!H&&(f.tickInterval=Math.max(f.pointRange,f.tickInterval));a=x(q.minTickInterval,f.isDatetimeAxis&&f.closestPointRange);!H&&f.tickInterval<a&&(f.tickInterval=a);g||k||H||(f.tickInterval=t(f.tickInterval,null,u(f.tickInterval),x(q.allowDecimals,!(.5<f.tickInterval&&5>f.tickInterval&&1E3<f.max&&9999>f.max)),!!this.tickAmount));this.tickAmount||(f.tickInterval=f.unsquish());
this.setTickPositions()},setTickPositions:function(){var a=this.options,b=a.tickPositions;var d=this.getMinorTickInterval();var k=a.tickPositioner,g=a.startOnTick,h=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===d&&this.tickInterval?this.tickInterval/5:d;this.single=this.min===this.max&&y(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=d=b&&b.slice();
!d&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(d=[this.min,this.max],c.error(19,!1,this.chart)):d=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),d.length>this.len&&(d=[d[0],d.pop()],d[0]===
d[1]&&(d.length=1)),this.tickPositions=d,k&&(k=k.apply(this,[this.min,this.max])))&&(this.tickPositions=d=k);this.paddedTicks=d.slice(0);this.trimTicks(d,g,h);this.isLinked||(this.single&&2>d.length&&!this.categories&&(this.min-=.5,this.max+=.5),b||k||this.adjustTickAmount());e(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var f=a[0],q=a[a.length-1],c=this.minPointOffset||0;e(this,"trimTicks");if(!this.isLinked){if(b&&-Infinity!==f)this.min=f;else for(;this.min-c>a[0];)a.shift();if(d)this.max=
q;else for(;this.max+c<a[a.length-1];)a.pop();0===a.length&&y(f)&&!this.options.tickPositions&&a.push((q+f)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||this.chart[this.coll].forEach(function(d){var f=d.options;f=[d.horiz?f.left:f.top,f.width,f.height,f.pane].join();d.series.length&&(a[f]?b=!0:a[f]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;
!y(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.options,d=this.tickInterval,e=this.tickPositions,c=this.tickAmount,k=this.finalTickAmt,g=e&&e.length,h=x(this.threshold,this.softThreshold?0:null),m;if(this.hasData()){if(g<c){for(m=this.min;e.length<c;)e.length%2||m===h?e.push(b(e[e.length-1]+d)):e.unshift(b(e[0]-
d));this.transA*=(g-1)/(c-1);this.min=a.startOnTick?e[0]:Math.min(this.min,e[0]);this.max=a.endOnTick?e[e.length-1]:Math.max(this.max,e[e.length-1])}else g>c&&(this.tickInterval*=2,this.setTickPositions());if(y(k)){for(d=a=e.length;d--;)(3===k&&1===d%2||2>=k&&0<d&&d<a-1)&&e.splice(d,1);this.finalTickAmt=void 0}}},setScale:function(){var a=this.series.some(function(a){return a.isDirtyData||a.isDirty||a.xAxis.isDirty}),b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();
(b=this.len!==this.oldAxisLength)||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();e(this,"afterSetScale")},setExtremes:function(a,b,d,c,k){var f=this,
q=f.chart;d=x(d,!0);f.series.forEach(function(a){delete a.kdTree});k=h(k,{min:a,max:b});e(f,"setExtremes",k,function(){f.userMin=a;f.userMax=b;f.eventArgs=k;d&&q.redraw(c)})},zoom:function(a,b){var d=this.dataMin,f=this.dataMax,c=this.options,q=Math.min(d,x(c.min,d)),k=Math.max(f,x(c.max,f));a={newMin:a,newMax:b};e(this,"zoom",a,function(a){var b=a.newMin,e=a.newMax;if(b!==this.min||e!==this.max)this.allowZoomOutside||(y(d)&&(b<q&&(b=q),b>k&&(b=k)),y(f)&&(e<q&&(e=q),e>k&&(e=k))),this.displayBtn=void 0!==
b||void 0!==e,this.setExtremes(b,e,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return a.zoomed},setAxisSize:function(){var a=this.chart,b=this.options,d=b.offsets||[0,0,0,0],e=this.horiz,k=this.width=Math.round(c.relativeLength(x(b.width,a.plotWidth-d[3]+d[1]),a.plotWidth)),g=this.height=Math.round(c.relativeLength(x(b.height,a.plotHeight-d[0]+d[2]),a.plotHeight)),h=this.top=Math.round(c.relativeLength(x(b.top,a.plotTop+d[0]),a.plotHeight,a.plotTop));b=this.left=Math.round(c.relativeLength(x(b.left,
a.plotLeft+d[3]),a.plotWidth,a.plotLeft));this.bottom=a.chartHeight-g-h;this.right=a.chartWidth-k-b;this.len=Math.max(e?k:g,0);this.pos=e?b:h},getExtremes:function(){var a=this.isLog;return{min:a?b(this.lin2log(this.min)):this.min,max:a?b(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,d=b?this.lin2log(this.min):this.min;b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=d:Infinity===
a?a=b:d>a?a=d:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){var b=(x(a,0)-90*this.side+720)%360;a={align:"center"};e(this,"autoLabelAlign",a,function(a){15<b&&165>b?a.align="right":195<b&&345>b&&(a.align="left")});return a.align},tickSize:function(a){var b=this.options,d=b[a+"Length"],c=x(b[a+"Width"],"tick"===a&&this.isXAxis&&!this.categories?1:0);if(c&&d){"inside"===b[a+"Position"]&&(d=-d);var k=[d,c]}a={tickSize:k};e(this,"afterTickSize",a);return a.tickSize},labelMetrics:function(){var a=
this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var d=this.options.labels,f=this.horiz,e=this.tickInterval,c=e,k=this.len/(((this.categories?1:0)+this.max-this.min)/e),g,h=d.rotation,m=this.labelMetrics(),B,A=Number.MAX_VALUE,t,u=this.max-this.min,H=function(a){var d=a/(k||1);d=1<d?Math.ceil(d):1;d*e>u&&Infinity!==a&&Infinity!==k&&(d=Math.ceil(u/
e));return b(d*e)};f?(t=!d.staggerLines&&!d.step&&(y(h)?[h]:k<x(d.autoRotationLimit,80)&&d.autoRotation))&&t.forEach(function(b){if(b===h||b&&-90<=b&&90>=b){B=H(Math.abs(m.h/Math.sin(a*b)));var d=B+Math.abs(b/360);d<A&&(A=d,g=b,c=B)}}):d.step||(c=H(m.h));this.autoRotation=t;this.labelRotation=x(g,h);return c},getSlotWidth:function(a){var b=this.chart,d=this.horiz,e=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),k=b.margin[3];return a&&a.slotWidth||d&&2>(e.step||
0)&&!e.rotation&&(this.staggerLines||1)*this.len/c||!d&&(e.style&&parseInt(e.style.width,10)||k&&k-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,e=this.ticks,c=this.options.labels,k=c&&c.style||{},g=this.horiz,h=this.getSlotWidth(),m=Math.max(1,Math.round(h-2*(c.padding||5))),B={},A=this.labelMetrics(),t=c.style&&c.style.textOverflow,u=0;z(c.rotation)||(B.rotation=c.rotation||0);d.forEach(function(a){(a=e[a])&&a.label&&a.label.textPxLength>
u&&(u=a.label.textPxLength)});this.maxLabelLength=u;if(this.autoRotation)u>m&&u>A.h?B.rotation=this.labelRotation:this.labelRotation=0;else if(h){var H=m;if(!t){var n="clip";for(m=d.length;!g&&m--;){var x=d[m];if(x=e[x].label)x.styles&&"ellipsis"===x.styles.textOverflow?x.css({textOverflow:"clip"}):x.textPxLength>h&&x.css({width:h+"px"}),x.getBBox().height>this.len/d.length-(A.h-A.f)&&(x.specificTextOverflow="ellipsis")}}}B.rotation&&(H=u>.5*a.chartHeight?.33*a.chartHeight:u,t||(n="ellipsis"));if(this.labelAlign=
c.align||this.autoLabelAlign(this.labelRotation))B.align=this.labelAlign;d.forEach(function(a){var b=(a=e[a])&&a.label,d=k.width,f={};b&&(b.attr(B),a.shortenLabel?a.shortenLabel():H&&!d&&"nowrap"!==k.whiteSpace&&(H<b.textPxLength||"SPAN"===b.element.tagName)?(f.width=H,t||(f.textOverflow=b.specificTextOverflow||n),b.css(f)):b.styles&&b.styles.width&&!f.width&&!d&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=B.rotation)},this);this.tickRotCorr=b.rotCorr(A.b,this.labelRotation||0,0!==
this.side)},hasData:function(){return this.series.some(function(a){return a.hasData()})||this.options.showEmpty&&y(this.min)&&y(this.max)},addTitle:function(a){var b=this.chart.renderer,d=this.horiz,e=this.opposite,c=this.options.title,k,g=this.chart.styledMode;this.axisTitle||((k=c.textAlign)||(k=(d?{low:"left",middle:"center",high:"right"}:{low:e?"right":"left",middle:"center",high:e?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:k}).addClass("highcharts-axis-title"),
g||this.axisTitle.css(E(c.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);g||c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](a)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new H(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,k=a.tickPositions,g=a.ticks,h=a.horiz,m=a.side,B=b.inverted&&!a.isZAxis?[1,0,3,2][m]:m,A,t=0,u=0,H=c.title,n=c.labels,l=0,E=b.axisOffset;b=b.clipOffset;
var w=[-1,1,1,-1][m],z=c.className,v=a.axisParent;var p=a.hasData();a.showAxis=A=p||x(c.showEmpty,!0);a.staggerLines=a.horiz&&n.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(z||"")).add(v),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(z||"")).add(v),a.labelGroup=d.g("axis-labels").attr({zIndex:n.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+
"-labels "+(z||"")).add(v));p||a.isLinked?(k.forEach(function(b,d){a.generateTick(b,d)}),a.renderUnsquish(),a.reserveSpaceDefault=0===m||2===m||{1:"left",3:"right"}[m]===a.labelAlign,x(n.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&k.forEach(function(a){l=Math.max(g[a].getLabelSize(),l)}),a.staggerLines&&(l*=a.staggerLines),a.labelOffset=l*(a.opposite?-1:1)):r(g,function(a,b){a.destroy();delete g[b]});if(H&&H.text&&!1!==H.enabled&&(a.addTitle(A),A&&!1!==H.reserveSpace)){a.titleOffset=
t=a.axisTitle.getBBox()[h?"height":"width"];var K=H.offset;u=y(K)?0:x(H.margin,h?5:10)}a.renderLine();a.offset=w*x(c.offset,E[m]?E[m]+(c.margin||0):0);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===m?-a.labelMetrics().h:2===m?a.tickRotCorr.y:0;u=Math.abs(l)+u;l&&(u=u-d+w*(h?x(n.y,a.tickRotCorr.y+8*w):n.x));a.axisTitleMargin=x(K,u);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(g,k));h=this.tickSize("tick");E[m]=Math.max(E[m],a.axisTitleMargin+t+w*a.offset,u,k&&k.length&&h?h[0]+
w*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[B]=Math.max(b[B],c);e(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,d=this.opposite,e=this.offset,c=this.horiz,k=this.left+(d?this.width:0)+e;e=b.chartHeight-this.bottom-(d?this.height:0)+e;d&&(a*=-1);return b.renderer.crispLine(["M",c?this.left:k,c?e:this.top,"L",c?b.chartWidth-this.right:k,c?e:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,c=this.len,k=this.options.title,g=a?b:d,h=this.opposite,m=this.offset,B=k.x||0,A=k.y||0,t=this.axisTitle,u=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,t);t=Math.max(t.getBBox(null,0).height-u.h-1,0);c={low:g+(a?0:c),middle:g+c/2,high:g+(a?c:0)}[k.align];b=(a?d+this.height:b)+(a?1:-1)*(h?-1:1)*this.axisTitleMargin+
[-t,t,u.f,-t][this.side];a={x:a?c+B:b+(h?this.width:0)+m+B,y:a?b+A-(h?this.height:0)+m:c+A};e(this,"afterGetTitlePosition",{titlePosition:a});return a},renderMinorTick:function(a){var b=this.chart.hasRendered&&F(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new H(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,e=this.ticks,c=this.chart.hasRendered&&F(this.oldMin);if(!d||a>=this.min&&a<=this.max)e[a]||(e[a]=new H(this,a)),c&&e[a].isNew&&
e[a].render(b,!0,-1),e[a].render(b)},render:function(){var a=this,b=a.chart,d=a.options,k=a.isLog,g=a.isLinked,h=a.tickPositions,m=a.axisTitle,A=a.ticks,t=a.minorTicks,u=a.alternateBands,n=d.stackLabels,x=d.alternateGridColor,l=a.tickmarkOffset,E=a.axisLine,w=a.showAxis,z=D(b.renderer.globalAnimation),v,p;a.labelEdge.length=0;a.overlap=!1;[A,t,u].forEach(function(a){r(a,function(a){a.isActive=!1})});if(a.hasData()||g)a.minorTickInterval&&!a.categories&&a.getMinorTickPositions().forEach(function(b){a.renderMinorTick(b)}),
h.length&&(h.forEach(function(b,d){a.renderTick(b,d)}),l&&(0===a.min||a.single)&&(A[-1]||(A[-1]=new H(a,-1,null,!0)),A[-1].render(-1))),x&&h.forEach(function(d,e){p=void 0!==h[e+1]?h[e+1]+l:a.max-l;0===e%2&&d<a.max&&p<=a.max+(b.polar?-l:l)&&(u[d]||(u[d]=new c.PlotLineOrBand(a)),v=d+l,u[d].options={from:k?a.lin2log(v):v,to:k?a.lin2log(p):p,color:x},u[d].render(),u[d].isActive=!0)}),a._addedPlotLB||((d.plotLines||[]).concat(d.plotBands||[]).forEach(function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=
!0);[A,t,u].forEach(function(a){var d,e=[],c=z.duration;r(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,e.push(b))});B(function(){for(d=e.length;d--;)a[e[d]]&&!a[e[d]].isActive&&(a[e[d]].destroy(),delete a[e[d]])},a!==u&&b.hasRendered&&c?c:0)});E&&(E[E.isPlaced?"animate":"attr"]({d:this.getLinePath(E.strokeWidth())}),E.isPlaced=!0,E[w?"show":"hide"](w));m&&w&&(d=a.getTitlePosition(),F(d.y)?(m[m.isNew?"attr":"animate"](d),m.isNew=!1):(m.attr("y",-9999),m.isNew=!0));n&&n.enabled&&a.renderStackTotals();
a.isDirty=!1;e(this,"afterRender")},redraw:function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(a){a.render()}));this.series.forEach(function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,d=b.stacks,c=b.plotLinesAndBands,h;e(this,"destroy",{keepEvents:a});a||k(b);r(d,function(a,b){g(a);d[b]=null});[b.ticks,b.minorTicks,b.alternateBands].forEach(function(a){g(a)});if(c)for(a=c.length;a--;)c[a].destroy();
"stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(a){b[a]&&(b[a]=b[a].destroy())});for(h in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[h]=b.plotLinesAndBandsGroups[h].destroy();r(b,function(a,d){-1===b.keepProps.indexOf(d)&&delete b[d]})},drawCrosshair:function(a,b){var d,c=this.crosshair,k=x(c.snap,!0),f,g=this.cross;e(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(y(b)||!k)){k?y(b)&&
(f=x(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):f=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);y(f)&&(d=this.getPlotLinePath({value:b&&(this.isXAxis?b.x:x(b.stackY,b.y)),translatedValue:f})||null);if(!y(d)){this.hideCrosshair();return}k=this.categories&&!this.isRadial;g||(this.cross=g=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(k?"category ":"thin ")+c.className).attr({zIndex:x(c.zIndex,2)}).add(),this.chart.styledMode||(g.attr({stroke:c.color||
(k?l("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":x(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&g.attr({dashstyle:c.dashStyle})));g.show().attr({d:d});k&&!c.width&&g.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();e(this,"afterDrawCrosshair",{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide();e(this,"afterHideCrosshair")}});return c.Axis=p});M(J,"parts/DateTimeAxis.js",[J["parts/Globals.js"]],function(c){var p=c.Axis,y=c.getMagnitude,
G=c.normalizeTickInterval,F=c.timeUnits;p.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};p.prototype.normalizeTimeTickInterval=function(c,r){var z=r||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];r=z[z.length-1];var v=F[r[0]],p=r[1],w;for(w=0;w<z.length&&!(r=z[w],v=F[r[0]],p=r[1],z[w+1]&&c<=(v*
p[p.length-1]+F[z[w+1][0]])/2);w++);v===F.year&&c<5*v&&(p=[1,2,5]);c=G(c/v,p,"year"===r[0]?Math.max(y(c/v),1):1);return{unitRange:v,count:c,unitName:r[0]}}});M(J,"parts/LogarithmicAxis.js",[J["parts/Globals.js"]],function(c){var p=c.Axis,y=c.getMagnitude,G=c.normalizeTickInterval,F=c.pick;p.prototype.getLogTickPositions=function(c,r,p,v){var z=this.options,w=this.len,n=[];v||(this._minorAutoInterval=null);if(.5<=c)c=Math.round(c),n=this.getLinearTickPositions(c,r,p);else if(.08<=c){w=Math.floor(r);
var l,b;for(z=.3<c?[1,2,4]:.15<c?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];w<p+1&&!b;w++){var d=z.length;for(l=0;l<d&&!b;l++){var a=this.log2lin(this.lin2log(w)*z[l]);a>r&&(!v||g<=p)&&void 0!==g&&n.push(g);g>p&&(b=!0);var g=a}}}else r=this.lin2log(r),p=this.lin2log(p),c=v?this.getMinorTickInterval():z.tickInterval,c=F("auto"===c?null:c,this._minorAutoInterval,z.tickPixelInterval/(v?5:1)*(p-r)/((v?w/this.tickPositions.length:w)||1)),c=G(c,null,y(c)),n=this.getLinearTickPositions(c,r,p).map(this.log2lin),v||
(this._minorAutoInterval=c/5);v||(this.tickInterval=c);return n};p.prototype.log2lin=function(c){return Math.log(c)/Math.LN10};p.prototype.lin2log=function(c){return Math.pow(10,c)}});M(J,"parts/PlotLineOrBand.js",[J["parts/Globals.js"],J["parts/Axis.js"],J["parts/Utilities.js"]],function(c,p,y){var G=y.defined,F=y.erase,z=y.objectEach,r=c.arrayMax,K=c.arrayMin,v=c.destroyObjectProperties,D=c.merge,w=c.pick;c.PlotLineOrBand=function(c,l){this.axis=c;l&&(this.options=l,this.id=l.id)};c.PlotLineOrBand.prototype=
{render:function(){c.fireEvent(this,"render");var n=this,l=n.axis,b=l.horiz,d=n.options,a=d.label,g=n.label,h=d.to,e=d.from,m=d.value,u=G(e)&&G(h),E=G(m),t=n.svgElem,x=!t,k=[],A=d.color,B=w(d.zIndex,0),H=d.events;k={"class":"highcharts-plot-"+(u?"band ":"line ")+(d.className||"")};var q={},f=l.chart.renderer,C=u?"bands":"lines";l.isLog&&(e=l.log2lin(e),h=l.log2lin(h),m=l.log2lin(m));l.chart.styledMode||(E?(k.stroke=A||"#999999",k["stroke-width"]=w(d.width,1),d.dashStyle&&(k.dashstyle=d.dashStyle)):
u&&(k.fill=A||"#e6ebf5",d.borderWidth&&(k.stroke=d.borderColor,k["stroke-width"]=d.borderWidth)));q.zIndex=B;C+="-"+B;(A=l.plotLinesAndBandsGroups[C])||(l.plotLinesAndBandsGroups[C]=A=f.g("plot-"+C).attr(q).add());x&&(n.svgElem=t=f.path().attr(k).add(A));if(E)k=l.getPlotLinePath({value:m,lineWidth:t.strokeWidth(),acrossPanes:d.acrossPanes});else if(u)k=l.getPlotBandPath(e,h,d);else return;(x||!t.d)&&k&&k.length?(t.attr({d:k}),H&&z(H,function(a,b){t.on(b,function(a){H[b].apply(n,[a])})})):t&&(k?(t.show(!0),
t.animate({d:k})):t.d&&(t.hide(),g&&(n.label=g=g.destroy())));a&&(G(a.text)||G(a.formatter))&&k&&k.length&&0<l.width&&0<l.height&&!k.isFlat?(a=D({align:b&&u&&"center",x:b?!u&&4:10,verticalAlign:!b&&u&&"middle",y:b?u?16:10:u?6:-4,rotation:b&&!u&&90},a),this.renderLabel(a,k,u,B)):g&&g.hide();return n},renderLabel:function(c,l,b,d){var a=this.label,g=this.axis.chart.renderer;a||(a={align:c.textAlign||c.align,rotation:c.rotation,"class":"highcharts-plot-"+(b?"band":"line")+"-label "+(c.className||"")},
a.zIndex=d,d=this.getLabelText(c),this.label=a=g.text(d,0,0,c.useHTML).attr(a).add(),this.axis.chart.styledMode||a.css(c.style));g=l.xBounds||[l[1],l[4],b?l[6]:l[1]];l=l.yBounds||[l[2],l[5],b?l[7]:l[2]];b=K(g);d=K(l);a.align(c,!1,{x:b,y:d,width:r(g)-b,height:r(l)-d});a.show(!0)},getLabelText:function(c){return G(c.formatter)?c.formatter.call(this):c.text},destroy:function(){F(this.axis.plotLinesAndBands,this);delete this.axis;v(this)}};c.extend(p.prototype,{getPlotBandPath:function(c,l){var b=this.getPlotLinePath({value:l,
force:!0,acrossPanes:this.options.acrossPanes}),d=this.getPlotLinePath({value:c,force:!0,acrossPanes:this.options.acrossPanes}),a=[],g=this.horiz,h=1;c=c<this.min&&l<this.min||c>this.max&&l>this.max;if(d&&b){if(c){var e=d.toString()===b.toString();h=0}for(c=0;c<d.length;c+=6)g&&b[c+1]===d[c+1]?(b[c+1]+=h,b[c+4]+=h):g||b[c+2]!==d[c+2]||(b[c+2]+=h,b[c+5]+=h),a.push("M",d[c+1],d[c+2],"L",d[c+4],d[c+5],b[c+4],b[c+5],b[c+1],b[c+2],"z"),a.isFlat=e}return a},addPlotBand:function(c){return this.addPlotBandOrLine(c,
"plotBands")},addPlotLine:function(c){return this.addPlotBandOrLine(c,"plotLines")},addPlotBandOrLine:function(n,l){var b=(new c.PlotLineOrBand(this,n)).render(),d=this.userOptions;b&&(l&&(d[l]=d[l]||[],d[l].push(n)),this.plotLinesAndBands.push(b));return b},removePlotBandOrLine:function(c){for(var l=this.plotLinesAndBands,b=this.options,d=this.userOptions,a=l.length;a--;)l[a].id===c&&l[a].destroy();[b.plotLines||[],d.plotLines||[],b.plotBands||[],d.plotBands||[]].forEach(function(b){for(a=b.length;a--;)b[a].id===
c&&F(b,b[a])})},removePlotBand:function(c){this.removePlotBandOrLine(c)},removePlotLine:function(c){this.removePlotBandOrLine(c)}})});M(J,"parts/Tooltip.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=p.isString,z=p.splat;"";var r=c.doc,K=c.extend,v=c.format,D=c.merge,w=c.pick,n=c.syncTimeout,l=c.timeUnits;c.Tooltip=function(){this.init.apply(this,arguments)};c.Tooltip.prototype={init:function(b,d){this.chart=b;this.options=d;this.crosshairs=[];this.now=
{x:0,y:0};this.isHidden=!0;this.split=d.split&&!b.inverted;this.shared=d.shared||this.split;this.outside=w(d.outside,!(!b.scrollablePixelsX&&!b.scrollablePixelsY))&&!this.split},cleanSplit:function(b){this.chart.series.forEach(function(d){var a=d&&d.tt;a&&(!a.isActive||b?d.tt=a.destroy():a.isActive=!1)})},applyFilter:function(){var b=this.chart;b.renderer.definition({tagName:"filter",id:"drop-shadow-"+b.index,opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",
dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});b.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+b.index+"{filter:url(#drop-shadow-"+b.index+")}"})},getLabel:function(){var b=this,d=this.chart.renderer,a=this.chart.styledMode,g=this.options,h="tooltip"+(y(g.className)?" "+g.className:""),e;if(!this.label){this.outside&&(this.container=
e=c.doc.createElement("div"),e.className="highcharts-tooltip-container",c.css(e,{position:"absolute",top:"1px",pointerEvents:g.style&&g.style.pointerEvents,zIndex:3}),c.doc.body.appendChild(e),this.renderer=d=new c.Renderer(e,0,0));this.split?this.label=d.g(h):(this.label=d.label("",0,0,g.shape||"callout",null,null,g.useHTML,null,h).attr({padding:g.padding,r:g.borderRadius}),a||this.label.attr({fill:g.backgroundColor,"stroke-width":g.borderWidth}).css(g.style).shadow(g.shadow));a&&(this.applyFilter(),
this.label.addClass("highcharts-tooltip-"+this.chart.index));if(this.outside){var m={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(a,d){m[d].call(this.label,b.distance);e.style.left=a+"px"};this.label.ySetter=function(a,d){m[d].call(this.label,b.distance);e.style.top=a+"px"}}this.label.attr({zIndex:8}).add()}return this.label},update:function(b){this.destroy();D(!0,this.chart.options.tooltip.userOptions,b);this.init(this.chart,D(!0,this.options,b))},destroy:function(){this.label&&
(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),c.discardElement(this.container));c.clearTimeout(this.hideTimer);c.clearTimeout(this.tooltipTimeout)},move:function(b,d,a,g){var h=this,e=h.now,m=!1!==h.options.animation&&!h.isHidden&&(1<Math.abs(b-e.x)||1<Math.abs(d-e.y)),u=h.followPointer||1<h.len;K(e,{x:m?(2*e.x+b)/3:b,y:m?(e.y+d)/2:d,anchorX:u?void 0:m?(2*e.anchorX+a)/3:a,anchorY:u?
void 0:m?(e.anchorY+g)/2:g});h.getLabel().attr(e);m&&(c.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){h&&h.move(b,d,a,g)},32))},hide:function(b){var d=this;c.clearTimeout(this.hideTimer);b=w(b,this.options.hideDelay,500);this.isHidden||(this.hideTimer=n(function(){d.getLabel()[b?"fadeOut":"hide"]();d.isHidden=!0},b))},getAnchor:function(b,d){var a=this.chart,c=a.pointer,h=a.inverted,e=a.plotTop,m=a.plotLeft,u=0,l=0,t,x;b=z(b);this.followPointer&&d?(void 0===d.chartX&&
(d=c.normalize(d)),b=[d.chartX-a.plotLeft,d.chartY-e]):b[0].tooltipPos?b=b[0].tooltipPos:(b.forEach(function(a){t=a.series.yAxis;x=a.series.xAxis;u+=a.plotX+(!h&&x?x.left-m:0);l+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!h&&t?t.top-e:0)}),u/=b.length,l/=b.length,b=[h?a.plotWidth-l:u,this.shared&&!h&&1<b.length&&d?d.chartY-e:h?a.plotHeight-u:l]);return b.map(Math.round)},getPosition:function(b,d,a){var c=this.chart,h=this.distance,e={},m=c.inverted&&a.h||0,u,l=this.outside,t=l?r.documentElement.clientWidth-
2*h:c.chartWidth,x=l?Math.max(r.body.scrollHeight,r.documentElement.scrollHeight,r.body.offsetHeight,r.documentElement.offsetHeight,r.documentElement.clientHeight):c.chartHeight,k=c.pointer.chartPosition,A=c.containerScaling,B=function(a){return A?a*A.scaleX:a},H=function(a){return A?a*A.scaleY:a},q=function(e){var f="x"===e;return[e,f?t:x,f?b:d].concat(l?[f?B(b):H(d),f?k.left-h+B(a.plotX+c.plotLeft):k.top-h+H(a.plotY+c.plotTop),0,f?t:x]:[f?b:d,f?a.plotX+c.plotLeft:a.plotY+c.plotTop,f?c.plotLeft:
c.plotTop,f?c.plotLeft+c.plotWidth:c.plotTop+c.plotHeight])},f=q("y"),n=q("x"),N=!this.followPointer&&w(a.ttBelow,!c.inverted===!!a.negative),v=function(a,b,d,c,f,k,g){var q="y"===a?H(h):B(h),A=(d-c)/2,t=c<f-h,u=f+h+c<b,x=f-q-d+A;f=f+q-A;if(N&&u)e[a]=f;else if(!N&&t)e[a]=x;else if(t)e[a]=Math.min(g-c,0>x-m?x:x-m);else if(u)e[a]=Math.max(k,f+m+d>b?f:f+m);else return!1},p=function(a,b,d,c,f){var k;f<h||f>b-h?k=!1:e[a]=f<d/2?1:f>b-c/2?b-c-2:f-d/2;return k},z=function(a){var b=f;f=n;n=b;u=a},L=function(){!1!==
v.apply(0,f)?!1!==p.apply(0,n)||u||(z(!0),L()):u?e.x=e.y=0:(z(!0),L())};(c.inverted||1<this.len)&&z();L();return e},defaultFormatter:function(b){var d=this.points||z(this);var a=[b.tooltipFooterHeaderFormatter(d[0])];a=a.concat(b.bodyFormatter(d));a.push(b.tooltipFooterHeaderFormatter(d[0],!0));return a},refresh:function(b,d){var a=this.chart,g=this.options,h=b,e={},m=[];var u=g.formatter||this.defaultFormatter;e=this.shared;var l=a.styledMode;if(g.enabled){c.clearTimeout(this.hideTimer);this.followPointer=
z(h)[0].series.tooltipOptions.followPointer;var t=this.getAnchor(h,d);d=t[0];var x=t[1];!e||h.series&&h.series.noSharedTooltip?e=h.getLabelConfig():(a.pointer.applyInactiveState(h),h.forEach(function(a){a.setState("hover");m.push(a.getLabelConfig())}),e={x:h[0].category,y:h[0].y},e.points=m,h=h[0]);this.len=m.length;u=u.call(e,this);e=h.series;this.distance=w(e.tooltipOptions.distance,16);!1===u?this.hide():(a=this.getLabel(),this.isHidden&&a.attr({opacity:1}).show(),this.split?this.renderSplit(u,
z(b)):(g.style.width&&!l||a.css({width:this.chart.spacingBox.width}),a.attr({text:u&&u.join?u.join(""):u}),a.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+w(h.colorIndex,e.colorIndex)),l||a.attr({stroke:g.borderColor||h.color||e.color||"#666666"}),this.updatePosition({plotX:d,plotY:x,negative:h.negative,ttBelow:h.ttBelow,h:t[2]||0})),this.isHidden=!1);c.fireEvent(this,"refresh")}},renderSplit:function(b,d){var a=this,g=[],h=this.chart,e=h.renderer,m=!0,u=this.options,l=0,t,x=
this.getLabel(),k=h.plotTop;F(b)&&(b=[!1,b]);b.slice(0,d.length+1).forEach(function(b,c){if(!1!==b&&""!==b){c=d[c-1]||{isHeader:!0,plotX:d[0].plotX,plotY:h.plotHeight};var B=c.series||a,q=B.tt,f=c.series||{},A="highcharts-color-"+w(c.colorIndex,f.colorIndex,"none");q||(q={padding:u.padding,r:u.borderRadius},h.styledMode||(q.fill=u.backgroundColor,q["stroke-width"]=u.borderWidth),B.tt=q=e.label(null,null,null,(c.isHeader?u.headerShape:u.shape)||"callout",null,null,u.useHTML).addClass("highcharts-tooltip-box "+
A).attr(q).add(x));q.isActive=!0;q.attr({text:b});h.styledMode||q.css(u.style).shadow(u.shadow).attr({stroke:u.borderColor||c.color||f.color||"#333333"});b=q.getBBox();A=b.width+q.strokeWidth();c.isHeader?(l=b.height,h.xAxis[0].opposite&&(t=!0,k-=l),b=Math.max(0,Math.min(c.plotX+h.plotLeft-A/2,h.chartWidth+(h.scrollablePixelsX?h.scrollablePixelsX-h.marginRight:0)-A))):b=c.plotX+h.plotLeft-w(u.distance,16)-A;0>b&&(m=!1);c.isHeader?f=t?-l:h.plotHeight+l:(f=f.yAxis,f=f.pos-k+Math.max(0,Math.min(c.plotY||
0,f.len)));g.push({target:f,rank:c.isHeader?1:0,size:B.tt.getBBox().height+1,point:c,x:b,tt:q})}});this.cleanSplit();u.positioner&&g.forEach(function(b){var d=u.positioner.call(a,b.tt.getBBox().width,b.size,b.point);b.x=d.x;b.align=0;b.target=d.y;b.rank=w(d.rank,b.rank)});c.distribute(g,h.plotHeight+l);g.forEach(function(b){var d=b.point,c=d.series,e=c&&c.yAxis;b.tt.attr({visibility:void 0===b.pos?"hidden":"inherit",x:m||d.isHeader||u.positioner?b.x:d.plotX+h.plotLeft+a.distance,y:b.pos+k,anchorX:d.isHeader?
d.plotX+h.plotLeft:d.plotX+c.xAxis.pos,anchorY:d.isHeader?h.plotTop+h.plotHeight/2:e.pos+Math.max(0,Math.min(d.plotY,e.len))})})},updatePosition:function(b){var d=this.chart,a=this.getLabel(),g=(this.options.positioner||this.getPosition).call(this,a.width,a.height,b),h=b.plotX+d.plotLeft;b=b.plotY+d.plotTop;if(this.outside){var e=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(a.width+e,a.height+e,!1);if(a=d.containerScaling)c.css(this.container,{transform:"scale("+a.scaleX+", "+
a.scaleY+")"}),h*=a.scaleX,b*=a.scaleY;h+=d.pointer.chartPosition.left-g.x;b+=d.pointer.chartPosition.top-g.y}this.move(Math.round(g.x),Math.round(g.y||0),h,b)},getDateFormat:function(b,d,a,c){var g=this.chart.time,e=g.dateFormat("%m-%d %H:%M:%S.%L",d),m={millisecond:15,second:12,minute:9,hour:6,day:3},u="millisecond";for(n in l){if(b===l.week&&+g.dateFormat("%w",d)===a&&"00:00:00.000"===e.substr(6)){var n="week";break}if(l[n]>b){n=u;break}if(m[n]&&e.substr(m[n])!=="01-01 00:00:00.000".substr(m[n]))break;
"week"!==n&&(u=n)}if(n)var t=g.resolveDTLFormat(c[n]).main;return t},getXDateFormat:function(b,d,a){d=d.dateTimeLabelFormats;var c=a&&a.closestPointRange;return(c?this.getDateFormat(c,b.x,a.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(b,d){var a=d?"footer":"header",g=b.series,h=g.tooltipOptions,e=h.xDateFormat,m=g.xAxis,u=m&&"datetime"===m.options.type&&G(b.key),l=h[a+"Format"];d={isFooter:d,labelConfig:b};c.fireEvent(this,"headerFormatter",d,function(a){u&&!e&&(e=
this.getXDateFormat(b,h,m));u&&e&&(b.point&&b.point.tooltipDateKeys||["key"]).forEach(function(a){l=l.replace("{point."+a+"}","{point."+a+":"+e+"}")});g.chart.styledMode&&(l=this.styledModeFormat(l));a.text=v(l,{point:b,series:g},this.chart.time)});return d.text},bodyFormatter:function(b){return b.map(function(b){var a=b.series.tooltipOptions;return(a[(b.point.formatPrefix||"point")+"Formatter"]||b.point.tooltipFormatter).call(b.point,a[(b.point.formatPrefix||"point")+"Format"]||"")})},styledModeFormat:function(b){return b.replace('style="font-size: 10px"',
'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')}}});M(J,"parts/Pointer.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=p.isObject,z=p.objectEach,r=p.splat,K=c.addEvent,v=c.attr,D=c.charts,w=c.color,n=c.css,l=c.extend,b=c.find,d=c.fireEvent,a=c.offset,g=c.pick,h=c.Tooltip;c.Pointer=function(a,b){this.init(a,b)};c.Pointer.prototype={init:function(a,b){this.options=b;this.chart=
a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};h&&(a.tooltip=new h(a,b.tooltip),this.followTouchMove=g(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,c=d.zoomType||"";b=b.inverted;/touch/.test(a.type)&&(c=g(d.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(b,d){var c=b.touches?b.touches.length?
b.touches.item(0):b.changedTouches[0]:b;d||(this.chartPosition=d=a(this.chart.container));var e=c.pageX-d.left;d=c.pageY-d.top;if(c=this.chart.containerScaling)e/=c.scaleX,d/=c.scaleY;return l(b,{chartX:Math.round(e),chartY:Math.round(d)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,d){var c;a.forEach(function(a){var e=
!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(d,e);if((e=F(a,!0))&&!(e=!F(c,!0))){e=c.distX-a.distX;var k=c.dist-a.dist,g=(a.series.group&&a.series.group.zIndex)-(c.series.group&&c.series.group.zIndex);e=0<(0!==e&&b?e:0!==k?k:0!==g?g:c.series.index>a.series.index?-1:1)}e&&(c=a)});return c},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var d=a.series,c=d.xAxis;d=d.yAxis;
var e=g(a.clientX,a.plotX),h=a.shapeArgs;if(c&&d)return b?{chartX:c.len+c.pos-e,chartY:d.len+d.pos-a.plotY}:{chartX:e+c.pos,chartY:a.plotY+d.pos};if(h&&h.x&&h.y)return{chartX:h.x,chartY:h.y}},getHoverData:function(a,d,c,h,t,x){var e,m=[];h=!(!h||!a);var B=d&&!d.stickyTracking?[d]:c.filter(function(a){return a.visible&&!(!t&&a.directTouch)&&g(a.options.enableMouseTracking,!0)&&a.stickyTracking});d=(e=h?a:this.findNearestKDPoint(B,t,x))&&e.series;e&&(t&&!d.noSharedTooltip?(B=c.filter(function(a){return a.visible&&
!(!t&&a.directTouch)&&g(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),B.forEach(function(a){var d=b(a.points,function(a){return a.x===e.x&&!a.isNull});F(d)&&(a.chart.isBoosting&&(d=a.getPoint(d)),m.push(d))})):m.push(e));return{hoverPoint:e,hoverSeries:d,hoverPoints:m}},runPointActions:function(a,b){var d=this.chart,e=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,h=e?e.shared:!1,m=b||d.hoverPoint,k=m&&m.series||d.hoverSeries;k=this.getHoverData(m,k,d.series,"touchmove"!==a.type&&
(!!b||k&&k.directTouch&&this.isDirectTouch),h,a);m=k.hoverPoint;var A=k.hoverPoints;b=(k=k.hoverSeries)&&k.tooltipOptions.followPointer;h=h&&k&&!k.noSharedTooltip;if(m&&(m!==d.hoverPoint||e&&e.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===A.indexOf(a)&&a.setState()});if(d.hoverSeries!==k)k.onMouseOver();this.applyInactiveState(A);(A||[]).forEach(function(a){a.setState("hover")});d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!m.series)return;m.firePointEvent("mouseOver");d.hoverPoints=
A;d.hoverPoint=m;e&&e.refresh(h?A:m,a)}else b&&e&&!e.isHidden&&(m=e.getAnchor([{}],a),e.updatePosition({plotX:m[0],plotY:m[1]}));this.unDocMouseMove||(this.unDocMouseMove=K(d.container.ownerDocument,"mousemove",function(a){var b=D[c.hoverChartIndex];if(b)b.pointer.onDocumentMouseMove(a)}));d.axes.forEach(function(b){var d=g(b.crosshair.snap,!0),e=d?c.find(A,function(a){return a.series[b.coll]===b}):void 0;e||!d?b.drawCrosshair(a,e):b.hideCrosshair()})},applyInactiveState:function(a){var b=[],d;(a||
[]).forEach(function(a){d=a.series;b.push(d);d.linkedParent&&b.push(d.linkedParent);d.linkedSeries&&(b=b.concat(d.linkedSeries));d.navigatorSeries&&b.push(d.navigatorSeries)});this.chart.series.forEach(function(a){-1===b.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})},reset:function(a,b){var d=this.chart,c=d.hoverSeries,e=d.hoverPoint,g=d.hoverPoints,k=d.tooltip,h=k&&k.shared?g:e;a&&h&&r(h).forEach(function(b){b.series.isCartesian&&void 0===
b.plotX&&(a=!1)});if(a)k&&h&&r(h).length&&(k.refresh(h),k.shared&&g?g.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):e&&(e.setState(e.state,!0),d.axes.forEach(function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();g&&g.forEach(function(a){a.setState()});if(c)c.onMouseOut();k&&k.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());
d.axes.forEach(function(a){a.hideCrosshair()});this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var d=this.chart,c;d.series.forEach(function(e){c=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&e.group&&(e.group.attr(c),e.markerGroup&&(e.markerGroup.attr(c),e.markerGroup.clip(b?d.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(c))});d.clipRect.attr(b||d.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=
a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,d=b.options.chart,c=a.chartX,e=a.chartY,g=this.zoomHor,k=this.zoomVert,h=b.plotLeft,B=b.plotTop,H=b.plotWidth,q=b.plotHeight,f=this.selectionMarker,l=this.mouseDownX,n=this.mouseDownY,r=d.panKey&&a[d.panKey+"Key"];if(!f||!f.touch)if(c<h?c=h:c>h+H&&(c=h+H),e<B?e=B:e>B+q&&(e=B+q),this.hasDragged=Math.sqrt(Math.pow(l-c,2)+Math.pow(n-e,2)),10<this.hasDragged){var v=b.isInsidePlot(l-h,n-B);b.hasCartesianSeries&&(this.zoomX||
this.zoomY)&&v&&!r&&!f&&(this.selectionMarker=f=b.renderer.rect(h,B,g?1:H,k?1:q,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),b.styledMode||f.attr({fill:d.selectionMarkerFill||w("#335cad").setOpacity(.25).get()}));f&&g&&(c-=l,f.attr({width:Math.abs(c),x:(0<c?0:c)+l}));f&&k&&(c=e-n,f.attr({height:Math.abs(c),y:(0<c?0:c)+n}));v&&!f&&d.panning&&b.pan(a,d.panning)}},drop:function(a){var b=this,c=this.chart,e=this.hasPinched;if(this.selectionMarker){var g={originalEvent:a,xAxis:[],yAxis:[]},
h=this.selectionMarker,k=h.attr?h.attr("x"):h.x,A=h.attr?h.attr("y"):h.y,B=h.attr?h.attr("width"):h.width,H=h.attr?h.attr("height"):h.height,q;if(this.hasDragged||e)c.axes.forEach(function(d){if(d.zoomEnabled&&y(d.min)&&(e||b[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])){var c=d.horiz,f="touchend"===a.type?d.minPixelPadding:0,h=d.toValue((c?k:A)+f);c=d.toValue((c?k+B:A+H)-f);g[d.coll].push({axis:d,min:Math.min(h,c),max:Math.max(h,c)});q=!0}}),q&&d(c,"selection",g,function(a){c.zoom(l(a,e?{animation:!1}:
null))});G(c.index)&&(this.selectionMarker=this.selectionMarker.destroy());e&&this.scaleGroups()}c&&G(c.index)&&(n(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(a){D[c.hoverChartIndex]&&D[c.hoverChartIndex].pointer.drop(a)},onDocumentMouseMove:function(a){var b=
this.chart,d=this.chartPosition;a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(a){var b=D[c.hoverChartIndex];b&&(a.relatedTarget||a.toElement)&&(b.pointer.reset(),b.pointer.chartPosition=null)},onContainerMouseMove:function(a){var b=this.chart;y(c.hoverChartIndex)&&D[c.hoverChartIndex]&&D[c.hoverChartIndex].mouseIsDown||(c.hoverChartIndex=b.index);a=this.normalize(a);a.preventDefault||
(a.returnValue=!1);"mousedown"===b.mouseIsDown&&this.drag(a);!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||b.openMenu||this.runPointActions(a)},inClass:function(a,b){for(var d;a;){if(d=v(a,"class")){if(-1!==d.indexOf(b))return!0;if(-1!==d.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,
"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,e=b.plotLeft,g=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(d(c.series,"click",l(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(l(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-e,a.chartY-g)&&d(b,"click",a)))},setDOMEvents:function(){var a=this,b=a.chart.container,
d=b.ownerDocument;b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};this.unbindContainerMouseLeave=K(b,"mouseleave",a.onContainerMouseLeave);c.unbindDocumentMouseUp||(c.unbindDocumentMouseUp=K(d,"mouseup",a.onDocumentMouseUp));c.hasTouch&&(K(b,"touchstart",function(b){a.onContainerTouchStart(b)}),K(b,"touchmove",function(b){a.onContainerTouchMove(b)}),c.unbindDocumentTouchEnd||(c.unbindDocumentTouchEnd=
K(d,"touchend",a.onDocumentTouchEnd)))},destroy:function(){var a=this;a.unDocMouseMove&&a.unDocMouseMove();this.unbindContainerMouseLeave();c.chartCount||(c.unbindDocumentMouseUp&&(c.unbindDocumentMouseUp=c.unbindDocumentMouseUp()),c.unbindDocumentTouchEnd&&(c.unbindDocumentTouchEnd=c.unbindDocumentTouchEnd()));clearInterval(a.tooltipTimeout);z(a,function(b,d){a[d]=null})}}});M(J,"parts/TouchPointer.js",[J["parts/Globals.js"]],function(c){var p=c.charts,y=c.extend,G=c.noop,F=c.pick;y(c.Pointer.prototype,
{pinchTranslate:function(c,r,p,v,y,w){this.zoomHor&&this.pinchTranslateDirection(!0,c,r,p,v,y,w);this.zoomVert&&this.pinchTranslateDirection(!1,c,r,p,v,y,w)},pinchTranslateDirection:function(c,r,p,v,y,w,n,l){var b=this.chart,d=c?"x":"y",a=c?"X":"Y",g="chart"+a,h=c?"width":"height",e=b["plot"+(c?"Left":"Top")],m,u,E=l||1,t=b.inverted,x=b.bounds[c?"h":"v"],k=1===r.length,A=r[0][g],B=p[0][g],H=!k&&r[1][g],q=!k&&p[1][g];p=function(){!k&&20<Math.abs(A-H)&&(E=l||Math.abs(B-q)/Math.abs(A-H));u=(e-B)/E+A;
m=b["plot"+(c?"Width":"Height")]/E};p();r=u;if(r<x.min){r=x.min;var f=!0}else r+m>x.max&&(r=x.max-m,f=!0);f?(B-=.8*(B-n[d][0]),k||(q-=.8*(q-n[d][1])),p()):n[d]=[B,q];t||(w[d]=u-e,w[h]=m);w=t?1/E:E;y[h]=m;y[d]=r;v[t?c?"scaleY":"scaleX":"scale"+a]=E;v["translate"+a]=w*e+(B-w*A)},pinch:function(c){var r=this,p=r.chart,v=r.pinchDown,z=c.touches,w=z.length,n=r.lastValidTouch,l=r.hasZoom,b=r.selectionMarker,d={},a=1===w&&(r.inClass(c.target,"highcharts-tracker")&&p.runTrackerClick||r.runChartClick),g={};
1<w&&(r.initiated=!0);l&&r.initiated&&!a&&c.preventDefault();[].map.call(z,function(a){return r.normalize(a)});"touchstart"===c.type?([].forEach.call(z,function(a,b){v[b]={chartX:a.chartX,chartY:a.chartY}}),n.x=[v[0].chartX,v[1]&&v[1].chartX],n.y=[v[0].chartY,v[1]&&v[1].chartY],p.axes.forEach(function(a){if(a.zoomEnabled){var b=p.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,c=a.toPixels(Math.min(F(a.options.min,a.dataMin),a.dataMin)),g=a.toPixels(Math.max(F(a.options.max,a.dataMax),a.dataMax)),h=Math.max(c,
g);b.min=Math.min(a.pos,Math.min(c,g)-d);b.max=Math.max(a.pos+a.len,h+d)}}),r.res=!0):r.followTouchMove&&1===w?this.runPointActions(r.normalize(c)):v.length&&(b||(r.selectionMarker=b=y({destroy:G,touch:!0},p.plotBox)),r.pinchTranslate(v,z,d,b,g,n),r.hasPinched=l,r.scaleGroups(d,g),r.res&&(r.res=!1,this.reset(!1,0)))},touch:function(p,r){var z=this.chart,v;if(z.index!==c.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});c.hoverChartIndex=z.index;if(1===p.touches.length)if(p=this.normalize(p),
(v=z.isInsidePlot(p.chartX-z.plotLeft,p.chartY-z.plotTop))&&!z.openMenu){r&&this.runPointActions(p);if("touchmove"===p.type){r=this.pinchDown;var y=r[0]?4<=Math.sqrt(Math.pow(r[0].chartX-p.chartX,2)+Math.pow(r[0].chartY-p.chartY,2)):!1}F(y,!0)&&this.pinch(p)}else r&&this.reset();else 2===p.touches.length&&this.pinch(p)},onContainerTouchStart:function(c){this.zoomOption(c);this.touch(c,!0)},onContainerTouchMove:function(c){this.touch(c)},onDocumentTouchEnd:function(z){p[c.hoverChartIndex]&&p[c.hoverChartIndex].pointer.drop(z)}})});
M(J,"parts/MSPointer.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.objectEach,G=c.addEvent,F=c.charts,z=c.css,r=c.doc;p=c.extend;var K=c.noop,v=c.Pointer,D=c.removeEvent,w=c.win,n=c.wrap;if(!c.hasTouch&&(w.PointerEvent||w.MSPointerEvent)){var l={},b=!!w.PointerEvent,d=function(){var a=[];a.item=function(a){return this[a]};y(l,function(b){a.push({pageX:b.pageX,pageY:b.pageY,target:b.target})});return a},a=function(a,b,e,m){"touch"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_TOUCH||
!F[c.hoverChartIndex]||(m(a),m=F[c.hoverChartIndex].pointer,m[b]({type:e,target:a.currentTarget,preventDefault:K,touches:d()}))};p(v.prototype,{onContainerPointerDown:function(b){a(b,"onContainerTouchStart","touchstart",function(a){l[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(b){a(b,"onContainerTouchMove","touchmove",function(a){l[a.pointerId]={pageX:a.pageX,pageY:a.pageY};l[a.pointerId].target||(l[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(b){a(b,
"onDocumentTouchEnd","touchend",function(a){delete l[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,b?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,b?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(r,b?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});n(v.prototype,"init",function(a,b,d){a.call(this,b,d);this.hasZoom&&z(b.container,{"-ms-touch-action":"none","touch-action":"none"})});n(v.prototype,"setDOMEvents",function(a){a.apply(this);
(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(G)});n(v.prototype,"destroy",function(a){this.batchMSEvents(D);a.call(this)})}});M(J,"parts/Legend.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=c.addEvent,z=c.css,r=c.discardElement,K=c.fireEvent;p=c.isFirefox;var v=c.marginNames,D=c.merge,w=c.pick,n=c.setAnimation,l=c.stableSort,b=c.win,d=c.wrap;c.Legend=function(a,b){this.init(a,b)};c.Legend.prototype={init:function(a,b){this.chart=a;this.setOptions(b);
b.enabled&&(this.render(),F(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=F(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var b=w(a.padding,8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=D(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=
b-5;this.symbolWidth=w(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,b){var d=this.chart;this.setOptions(D(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;w(b,!0)&&d.redraw();K(this,"afterUpdate")},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var d=this.options,c=a.legendItem,g=a.legendLine,l=a.legendSymbol,n=this.itemHiddenStyle.color;
d=b?d.itemStyle.color:n;var t=b?a.color||n:n,x=a.options&&a.options.marker,k={fill:t};c&&c.css({fill:d,color:d});g&&g.attr({stroke:t});l&&(x&&l.isMarker&&(k=a.pointAttribs(),b||(k.stroke=k.fill=n)),l.attr(k))}K(this,"afterColorizeItem",{item:a,visible:b})},positionItems:function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var b=this.options,d=b.symbolPadding;b=!b.rtl;var c=a._legendItemPos,m=c[0];c=c[1];var l=a.checkbox;
if((a=a.legendGroup)&&a.element)a[y(a.translateY)?"animate":"attr"]({translateX:b?m:this.legendWidth-m-2*d-4,translateY:c});l&&(l.x=m,l.y=c)},destroyItem:function(a){var b=a.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(b){a[b]&&(a[b]=a[b].destroy())});b&&r(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(b){["legendItem","legendGroup"].forEach(a,b)});"clipRect up down pager nav box title group".split(" ").forEach(a,
this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,b=this.clipHeight||this.legendHeight,d=this.titleHeight;if(a){var c=a.translateY;this.allItems.forEach(function(e){var g=e.checkbox;if(g){var h=c+d+g.y+(this.scrollOffset||0)+3;z(g,{left:a.translateX+e.checkboxOffset+g.x-20+"px",top:h+"px",display:this.proximate||h>c-6&&h<c+b-6?"":"none"})}},this)}},renderTitle:function(){var a=this.options,b=this.padding,d=a.title,c=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,
b-3,b-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),c=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:c}));this.titleHeight=c},setText:function(a){var b=this.options;a.legendItem.attr({text:b.labelFormat?c.format(b.labelFormat,a,this.chart.time):b.labelFormatter.call(a)})},renderItem:function(a){var b=this.chart,
d=b.renderer,c=this.options,m=this.symbolWidth,l=c.symbolPadding,n=this.itemStyle,t=this.itemHiddenStyle,x="horizontal"===c.layout?w(c.itemDistance,20):0,k=!c.rtl,A=a.legendItem,B=!a.series,H=!B&&a.series.drawLegendSymbol?a.series:a,q=H.options;q=this.createCheckboxForItem&&q&&q.showCheckbox;x=m+l+x+(q?20:0);var f=c.useHTML,C=a.options.className;A||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+H.type+"-series highcharts-color-"+a.colorIndex+(C?" "+C:"")+(B?" highcharts-series-"+a.index:
"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=A=d.text("",k?m+l:-l,this.baseline||0,f),b.styledMode||A.css(D(a.visible?n:t)),A.attr({align:k?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(b.styledMode?12:n.fontSize,A),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,A.attr("y",this.baseline)),this.symbolHeight=c.symbolHeight||this.fontMetrics.f,H.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,A,f));q&&!a.checkbox&&this.createCheckboxForItem(a);
this.colorizeItem(a,a.visible);!b.styledMode&&n.width||A.css({width:(c.itemWidth||this.widthOption||b.spacingBox.width)-x});this.setText(a);b=A.getBBox();a.itemWidth=a.checkboxOffset=c.itemWidth||a.legendItemWidth||b.width+x;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||b.height||this.symbolHeight)},layoutItem:function(a){var b=this.options,d=this.padding,c="horizontal"===b.layout,m=a.itemHeight,
l=b.itemMarginBottom||0,n=this.itemMarginTop,t=c?w(b.itemDistance,20):0,x=this.maxLegendWidth;b=b.alignColumns&&this.totalItemWidth>x?this.maxItemWidth:a.itemWidth;c&&this.itemX-d+b>x&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=n+this.lastLineHeight+l),this.lastLineHeight=0);this.lastItemY=n+this.itemY+l;this.lastLineHeight=Math.max(m,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];c?this.itemX+=b:(this.itemY+=n+m+l,this.lastLineHeight=m);this.offsetWidth=this.widthOption||Math.max((c?
this.itemX-d-(a.checkbox?0:t):b)+d,this.offsetWidth)},getAllItems:function(){var a=[];this.chart.series.forEach(function(b){var d=b&&b.options;b&&w(d.showInLegend,y(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===d.legendType?b.data:b)))});K(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,b){var d=
this.chart,c=this.options,g=this.getAlignment(),l=d.options.title.margin,n=void 0!==l?d.titleOffset[0]+l:0,t=void 0!==l?d.titleOffset[2]+l:0;g&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(e,k){e.test(g)&&!y(a[k])&&(d[v[k]]=Math.max(d[v[k]],d.legend[(k+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][k]*c[k%2?"x":"y"]+w(c.margin,12)+b[k]+(0===k&&(0===d.titleOffset[0]?0:n))+(2===k&&(0===d.titleOffset[2]?0:t))))})},proximatePositions:function(){var a=this.chart,b=[],
d="left"===this.options.align;this.allItems.forEach(function(e){var g=d;if(e.yAxis&&e.points){e.xAxis.options.reversed&&(g=!g);var h=c.find(g?e.points:e.points.slice(0).reverse(),function(a){return G(a.plotY)});g=e.legendGroup.getBBox().height;var l=e.yAxis.top-a.plotTop;e.visible?(h=h?h.plotY:e.yAxis.height,h+=l-.3*g):h=l+e.yAxis.height;b.push({target:h,size:g,item:e})}},this);c.distribute(b,a.plotHeight);b.forEach(function(b){b.item._legendItemPos[1]=a.plotTop-a.spacing[0]+b.pos})},render:function(){var a=
this.chart,b=a.renderer,d=this.group,e,m=this.box,n=this.options,w=this.padding;this.itemX=w;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=c.relativeLength(n.width,a.spacingBox.width-w);var t=a.spacingBox.width-2*w-n.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(t/=2);this.maxLegendWidth=this.widthOption||t;d||(this.group=d=b.g("legend").attr({zIndex:7}).add(),this.contentGroup=b.g().attr({zIndex:1}).add(d),this.scrollGroup=b.g().add(this.contentGroup));
this.renderTitle();t=this.getAllItems();l(t,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});n.reversed&&t.reverse();this.allItems=t;this.display=e=!!t.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;t.forEach(this.renderItem,this);t.forEach(this.layoutItem,this);t=(this.widthOption||this.offsetWidth)+w;var x=this.lastItemY+this.lastLineHeight+this.titleHeight;x=this.handleOverflow(x);x+=w;m||(this.box=m=b.rect().addClass("highcharts-legend-box").attr({r:n.borderRadius}).add(d),
m.isNew=!0);a.styledMode||m.attr({stroke:n.borderColor,"stroke-width":n.borderWidth||0,fill:n.backgroundColor||"none"}).shadow(n.shadow);0<t&&0<x&&(m[m.isNew?"attr":"animate"](m.crisp.call({},{x:0,y:0,width:t,height:x},m.strokeWidth())),m.isNew=!1);m[e?"show":"hide"]();a.styledMode&&"none"===d.getStyle("display")&&(t=x=0);this.legendWidth=t;this.legendHeight=x;e&&(b=a.options.title.margin,m=a.spacingBox,w=m.y,/(lth|ct|rth)/.test(this.getAlignment())&&0<a.titleOffset[0]?w+=a.titleOffset[0]+b:/(lbh|cb|rbh)/.test(this.getAlignment())&&
0<a.titleOffset[2]&&(w-=a.titleOffset[2]+b),w!==m.y&&(m=D(m,{y:w})),d.align(D(n,{width:t,height:x,verticalAlign:this.proximate?"top":n.verticalAlign}),!0,m));this.proximate||this.positionItems();K(this,"afterRender")},handleOverflow:function(a){var b=this,d=this.chart,c=d.renderer,m=this.options,l=m.y,n=this.padding;l=d.spacingBox.height+("top"===m.verticalAlign?-l:l)-n;var t=m.maxHeight,x,k=this.clipRect,A=m.navigation,B=w(A.animation,!0),H=A.arrowSize||12,q=this.nav,f=this.pages,C,r=this.allItems,
p=function(a){"number"===typeof a?k.attr({height:a}):k&&(b.clipRect=k.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+n+"px,9999px,"+(n+a)+"px,0)":"auto")},v=function(a){b[a]=c.circle(0,0,1.3*H).translate(H/2,H/2).add(q);d.styledMode||b[a].attr("fill","rgba(0,0,0,0.0001)");return b[a]};"horizontal"!==m.layout||"middle"===m.verticalAlign||m.floating||(l/=2);t&&(l=Math.min(l,t));f.length=0;a>l&&!1!==A.enabled?(this.clipHeight=x=Math.max(l-20-this.titleHeight-
n,0),this.currentPage=w(this.currentPage,1),this.fullHeight=a,r.forEach(function(a,b){var d=a._legendItemPos[1],c=Math.round(a.legendItem.getBBox().height),k=f.length;if(!k||d-f[k-1]>x&&(C||d)!==f[k-1])f.push(C||d),k++;a.pageIx=k-1;C&&(r[b-1].pageIx=k-1);b===r.length-1&&d+c-f[k-1]>x&&d!==C&&(f.push(d),a.pageIx=k);d!==C&&(C=d)}),k||(k=b.clipRect=c.clipRect(0,n,9999,0),b.contentGroup.clip(k)),p(x),q||(this.nav=q=c.g().attr({zIndex:1}).add(this.group),this.up=c.symbol("triangle",0,0,H,H).add(q),v("upTracker").on("click",
function(){b.scroll(-1,B)}),this.pager=c.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(A.style),this.pager.add(q),this.down=c.symbol("triangle-down",0,0,H,H).add(q),v("downTracker").on("click",function(){b.scroll(1,B)})),b.scroll(0),a=l):q&&(p(),this.nav=q.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,b){var d=this.pages,c=d.length,g=this.currentPage+a;a=this.clipHeight;var l=this.options.navigation,w=this.pager,
t=this.padding;g>c&&(g=c);0<g&&(void 0!==b&&n(b,this.chart),this.nav.attr({translateX:t,translateY:a+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===g?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),w.attr({text:g+"/"+c}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":g===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),this.chart.styledMode||
(this.up.attr({fill:1===g?l.inactiveColor:l.activeColor}),this.upTracker.css({cursor:1===g?"default":"pointer"}),this.down.attr({fill:g===c?l.inactiveColor:l.activeColor}),this.downTracker.css({cursor:g===c?"default":"pointer"})),this.scrollOffset=-d[g-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=g,this.positionCheckboxes())}};c.LegendSymbolMixin={drawRectangle:function(a,b){var d=a.symbolHeight,c=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(c?
(a.symbolWidth-d)/2:0,a.baseline-d+1,c?d:a.symbolWidth,d,w(a.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,d=b.marker,c=a.symbolWidth,m=a.symbolHeight,l=m/2,n=this.chart.renderer,t=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var x={};this.chart.styledMode||(x={"stroke-width":b.lineWidth||0},b.dashStyle&&(x.dashstyle=b.dashStyle));this.legendLine=n.path(["M",0,a,"L",c,a]).addClass("highcharts-graph").attr(x).add(t);
d&&!1!==d.enabled&&c&&(b=Math.min(w(d.radius,l),l),0===this.symbol.indexOf("url")&&(d=D(d,{width:m,height:m}),b=0),this.legendSymbol=d=n.symbol(this.symbol,c/2-b,a-b,2*b,2*b,d).addClass("highcharts-point").add(t),d.isMarker=!0)}};(/Trident\/7\.0/.test(b.navigator&&b.navigator.userAgent)||p)&&d(c.Legend.prototype,"positionItem",function(a,b){var d=this,c=function(){b._legendItemPos&&a.call(d,b)};c();d.bubbleLegend||setTimeout(c)})});M(J,"parts/Chart.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],
function(c,p){var y=p.defined,G=p.erase,F=p.isArray,z=p.isNumber,r=p.isObject,K=p.isString,v=p.objectEach,D=p.pInt,w=p.splat,n=c.addEvent,l=c.animate,b=c.animObject,d=c.attr,a=c.doc,g=c.Axis,h=c.createElement,e=c.defaultOptions,m=c.discardElement,u=c.charts,E=c.css,t=c.extend,x=c.find,k=c.fireEvent,A=c.Legend,B=c.marginNames,H=c.merge,q=c.Pointer,f=c.pick,C=c.removeEvent,N=c.seriesTypes,T=c.syncTimeout,R=c.win,S=c.Chart=function(){this.getArgs.apply(this,arguments)};c.chart=function(a,b,d){return new S(a,
b,d)};t(S.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(K(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,b){var d,f=a.series,g=a.plotOptions||{};k(this,"init",{args:arguments},function(){a.series=null;d=H(e,a);v(d.plotOptions,function(a,b){r(a)&&(a.tooltip=g[b]&&H(g[b].tooltip)||void 0)});d.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;d.series=a.series=f;this.userOptions=a;var h=d.chart,q=h.events;
this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=b;this.isResizing=0;this.options=d;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new c.Time(a.time):c.time;this.styledMode=h.styledMode;this.hasCartesianSeries=h.showAxes;var B=this;B.index=u.length;u.push(B);c.chartCount++;q&&v(q,function(a,b){c.isFunction(a)&&n(B,b,a)});B.xAxis=[];B.yAxis=[];B.pointCount=B.colorCounter=B.symbolCounter=0;k(B,"afterInit");B.firstRender()})},initSeries:function(a){var b=
this.options.chart;(b=N[a.type||b.type||b.defaultSeriesType])||c.error(17,!0,this);b=new b;b.init(this,a);return b},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,d){var c=d?b:a;a=d?a:b;return 0<=c&&c<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(a){k(this,"beforeRedraw");var b=this.axes,d=this.series,f=this.pointer,e=this.legend,g=this.userOptions.legend,h=this.isDirtyLegend,q=this.hasCartesianSeries,
B=this.isDirtyBox,A=this.renderer,m=A.isHidden(),l=[];this.setResponsive&&this.setResponsive(!1);c.setAnimation(a,this);m&&this.temporaryDisplay();this.layOutTitles();for(a=d.length;a--;){var n=d[a];if(n.options.stacking){var H=!0;if(n.isDirty){var x=!0;break}}}if(x)for(a=d.length;a--;)n=d[a],n.options.stacking&&(n.isDirty=!0);d.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),h=!0):g&&(g.labelFormatter||g.labelFormat)&&(h=!0));a.isDirtyData&&k(a,"updatedData")});
h&&e&&e.options.enabled&&(e.render(),this.isDirtyLegend=!1);H&&this.getStacks();q&&b.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();q&&(b.forEach(function(a){a.isDirty&&(B=!0)}),b.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,l.push(function(){k(a,"afterSetExtremes",t(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(B||H)&&a.redraw()}));B&&this.drawChartBox();k(this,"predraw");d.forEach(function(a){(B||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=
!1});f&&f.reset(!0);A.draw();k(this,"redraw");k(this,"render");m&&this.temporaryDisplay(!0);l.forEach(function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var d=this.series,c;var f=x(this.axes,b)||x(this.series,b);for(c=0;!f&&c<d.length;c++)f=x(d[c].points||[],b);return f},getAxes:function(){var a=this,b=this.options,d=b.xAxis=w(b.xAxis||{});b=b.yAxis=w(b.yAxis||{});k(this,"getAxes");d.forEach(function(a,b){a.index=b;a.isX=!0});b.forEach(function(a,b){a.index=
b});d.concat(b).forEach(function(b){new g(a,b)});k(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(b){a=a.concat((b[b.hasGroupedData?"points":"data"]||[]).filter(function(a){return f(a.selectedStaging,a.selected)}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,b,d){var c=this,f=c.options,k=c.styledMode;var e=f.title=H(!k&&{style:{color:"#333333",fontSize:f.isStock?"16px":"18px"}},f.title,
a);f=f.subtitle=H(!k&&{style:{color:"#666666"}},f.subtitle,b);[["title",a,e],["subtitle",b,f]].forEach(function(a,b){var d=a[0],f=c[d],e=a[1];a=a[2];f&&e&&(c[d]=f=f.destroy());a&&!f&&(c[d]=c.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+d,zIndex:a.zIndex||4}).add(),c[d].update=function(a){c.setTitle(!b&&a,b&&a)},k||c[d].css(a.style))});c.layOutTitles(d)},layOutTitles:function(a){var b=[0,0,0],d=this.renderer,c=this.spacingBox;["title","subtitle"].forEach(function(a){var f=
this[a],k=this.options[a],e="title"===a?-3:k.verticalAlign?0:b[0]+2;a="subtitle"===a&&"bottom"===k.verticalAlign;if(f){if(!this.styledMode)var g=k.style.fontSize;g=d.fontMetrics(g,f).b;f.css({width:(k.width||c.width+k.widthAdjust)+"px"});var h=f.getBBox(k.useHTML).height;f.align(t({y:a?g:e+g,height:h},k),!1,"spacingBox");k.floating||(k.verticalAlign?a&&(b[2]=h):b[0]=Math.ceil(b[0]+h))}},this);var k=!this.titleOffset||this.titleOffset.join(",")!==b.join(",");this.titleOffset=b;!this.isDirtyBox&&k&&
(this.isDirtyBox=this.isDirtyLegend=k,this.hasRendered&&f(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=this.options.chart,b=a.width;a=a.height;var d=this.renderTo;y(b)||(this.containerWidth=c.getStyle(d,"width"));y(a)||(this.containerHeight=c.getStyle(d,"height"));this.chartWidth=Math.max(0,b||this.containerWidth||600);this.chartHeight=Math.max(0,c.relativeLength(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var d=this.renderTo;
if(b)for(;d&&d.style;)d.hcOrigStyle&&(c.css(d,d.hcOrigStyle),delete d.hcOrigStyle),d.hcOrigDetached&&(a.body.removeChild(d),d.hcOrigDetached=!1),d=d.parentNode;else for(;d&&d.style;){a.body.contains(d)||d.parentNode||(d.hcOrigDetached=!0,a.body.appendChild(d));if("none"===c.getStyle(d,"display",!1)||d.hcOricDetached)d.hcOrigStyle={display:d.style.display,height:d.style.height,overflow:d.style.overflow},b={display:"block",overflow:"hidden"},d!==this.renderTo&&(b.height=0),c.css(d,b),d.offsetWidth||
d.style.setProperty("display","block","important");d=d.parentNode;if(d===a.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b=this.options,f=b.chart;var e=this.renderTo;var g=c.uniqueKey(),q,B;e||(this.renderTo=e=f.renderTo);K(e)&&(this.renderTo=e=a.getElementById(e));e||c.error(13,!0,this);var A=D(d(e,"data-highcharts-chart"));z(A)&&u[A]&&u[A].hasRendered&&u[A].destroy();d(e,"data-highcharts-chart",this.index);e.innerHTML=
"";f.skipClone||e.offsetWidth||this.temporaryDisplay();this.getChartSize();A=this.chartWidth;var m=this.chartHeight;E(e,{overflow:"hidden"});this.styledMode||(q=t({position:"relative",overflow:"hidden",width:A+"px",height:m+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},f.style));this.container=e=h("div",{id:g},q,e);this._cursor=e.style.cursor;this.renderer=new (c[f.renderer]||c.Renderer)(e,A,m,null,f.forExport,b.exporting&&b.exporting.allowHTML,
this.styledMode);this.setClassName(f.className);if(this.styledMode)for(B in b.defs)this.renderer.definition(b.defs[B]);else this.renderer.setStyle(f.style);this.renderer.chartIndex=this.index;k(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,d=this.margin,c=this.titleOffset;this.resetMargins();c[0]&&!y(d[0])&&(this.plotTop=Math.max(this.plotTop,c[0]+this.options.title.margin+b[0]));c[2]&&!y(d[2])&&(this.marginBottom=Math.max(this.marginBottom,c[2]+this.options.title.margin+b[2]));
this.legend&&this.legend.display&&this.legend.adjustMargins(d,b);k(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&a.axes.forEach(function(a){a.visible&&a.getOffset()});B.forEach(function(c,f){y(d[f])||(a[c]+=b[f])});a.setChartSize()},reflow:function(b){var d=this,f=d.options.chart,k=d.renderTo,e=y(f.width)&&y(f.height),g=f.width||c.getStyle(k,"width");f=f.height||c.getStyle(k,"height");k=b?b.target:R;if(!e&&
!d.isPrinting&&g&&f&&(k===R||k===a)){if(g!==d.containerWidth||f!==d.containerHeight)c.clearTimeout(d.reflowTimeout),d.reflowTimeout=T(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=g;d.containerHeight=f}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=n(R,"resize",function(a){b.reflow(a)}),n(this,"destroy",this.unbindReflow))},setSize:function(a,d,f){var e=this,g=e.renderer;
e.isResizing+=1;c.setAnimation(f,e);e.oldChartHeight=e.chartHeight;e.oldChartWidth=e.chartWidth;void 0!==a&&(e.options.chart.width=a);void 0!==d&&(e.options.chart.height=d);e.getChartSize();if(!e.styledMode){var h=g.globalAnimation;(h?l:E)(e.container,{width:e.chartWidth+"px",height:e.chartHeight+"px"},h)}e.setChartSize(!0);g.setSize(e.chartWidth,e.chartHeight,f);e.axes.forEach(function(a){a.isDirty=!0;a.setScale()});e.isDirtyLegend=!0;e.isDirtyBox=!0;e.layOutTitles();e.getMargins();e.redraw(f);e.oldChartHeight=
null;k(e,"resize");T(function(){e&&k(e,"endResize",null,function(){--e.isResizing})},b(h).duration)},setChartSize:function(a){var b=this.inverted,d=this.renderer,c=this.chartWidth,f=this.chartHeight,e=this.options.chart,g=this.spacing,h=this.clipOffset,q,B,A,m;this.plotLeft=q=Math.round(this.plotLeft);this.plotTop=B=Math.round(this.plotTop);this.plotWidth=A=Math.max(0,Math.round(c-q-this.marginRight));this.plotHeight=m=Math.max(0,Math.round(f-B-this.marginBottom));this.plotSizeX=b?m:A;this.plotSizeY=
b?A:m;this.plotBorderWidth=e.plotBorderWidth||0;this.spacingBox=d.spacingBox={x:g[3],y:g[0],width:c-g[3]-g[1],height:f-g[0]-g[2]};this.plotBox=d.plotBox={x:q,y:B,width:A,height:m};c=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(c,h[3])/2);d=Math.ceil(Math.max(c,h[0])/2);this.clipBox={x:b,y:d,width:Math.floor(this.plotSizeX-Math.max(c,h[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(c,h[2])/2-d))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});
k(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){k(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(d){var c=b[d],k=r(c)?c:[c,c,c,c];["Top","Right","Bottom","Left"].forEach(function(c,e){a[d][e]=f(b[d+c],k[e])})});B.forEach(function(b,d){a[b]=f(a.margin[d],a.spacing[d])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,d=this.chartWidth,c=this.chartHeight,f=this.chartBackground,
e=this.plotBackground,g=this.plotBorder,h=this.styledMode,q=this.plotBGImage,B=a.backgroundColor,A=a.plotBackgroundColor,m=a.plotBackgroundImage,l,t=this.plotLeft,n=this.plotTop,H=this.plotWidth,x=this.plotHeight,C=this.plotBox,u=this.clipRect,w=this.clipBox,r="animate";f||(this.chartBackground=f=b.rect().addClass("highcharts-background").add(),r="attr");if(h)var p=l=f.strokeWidth();else{p=a.borderWidth||0;l=p+(a.shadow?8:0);B={fill:B||"none"};if(p||f["stroke-width"])B.stroke=a.borderColor,B["stroke-width"]=
p;f.attr(B).shadow(a.shadow)}f[r]({x:l/2,y:l/2,width:d-l-p%2,height:c-l-p%2,r:a.borderRadius});r="animate";e||(r="attr",this.plotBackground=e=b.rect().addClass("highcharts-plot-background").add());e[r](C);h||(e.attr({fill:A||"none"}).shadow(a.plotShadow),m&&(q?q.animate(C):this.plotBGImage=b.image(m,t,n,H,x).add()));u?u.animate({width:w.width,height:w.height}):this.clipRect=b.clipRect(w);r="animate";g||(r="attr",this.plotBorder=g=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());
h||g.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});g[r](g.crisp({x:t,y:n,width:H,height:x},-g.strokeWidth()));this.isDirtyBox=!1;k(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,d,c=a.options.series,f,k;["inverted","angular","polar"].forEach(function(e){d=N[b.type||b.defaultSeriesType];k=b[e]||d&&d.prototype[e];for(f=c&&c.length;!k&&f--;)(d=N[c[f].type])&&d.prototype[e]&&(k=!0);a[e]=k})},linkSeries:function(){var a=this,b=a.series;
b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var d=b.options.linkedTo;K(d)&&(d=":previous"===d?a.series[b.index-1]:a.get(d))&&d.linkedParent!==b&&(d.linkedSeries.push(b),b.linkedParent=d,b.visible=f(b.options.visible,d.options.visible,b.visible))});k(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(d){var c=t(b.style,d.style),
f=D(c.left)+a.plotLeft,k=D(c.top)+a.plotTop+12;delete c.left;delete c.top;a.renderer.text(d.html,f,k).attr({zIndex:2}).css(c).add()})},render:function(){var a=this.axes,b=this.renderer,d=this.options,c=0;this.setTitle();this.legend=new A(this,d.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();d=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return c=21,!0});var f=this.plotHeight=Math.max(this.plotHeight-c,0);a.forEach(function(a){a.setScale()});
this.getAxisMargins();var k=1.1<d/this.plotWidth;var e=1.05<f/this.plotHeight;if(k||e)a.forEach(function(a){(a.horiz&&k||!a.horiz&&e)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&a.forEach(function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(a){var b=
this;a=H(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(R.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),b.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},updateContainerScaling:function(){var a=this.container;if(a.offsetWidth&&a.offsetHeight&&
a.getBoundingClientRect){var b=a.getBoundingClientRect(),d=b.width/a.offsetWidth;a=b.height/a.offsetHeight;1!==d||1!==a?this.containerScaling={scaleX:d,scaleY:a}:delete this.containerScaling}},destroy:function(){var a=this,b=a.axes,d=a.series,f=a.container,e,g=f&&f.parentNode;k(a,"destroy");a.renderer.forExport?G(u,a):u[a.index]=void 0;c.chartCount--;a.renderTo.removeAttribute("data-highcharts-chart");C(a);for(e=b.length;e--;)b[e]=b[e].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();
for(e=d.length;e--;)d[e]=d[e].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(b){var d=a[b];d&&d.destroy&&(a[b]=d.destroy())});f&&(f.innerHTML="",C(f),g&&m(f));v(a,function(b,d){delete a[d]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();
a.getAxes();(F(b.series)?b.series:[]).forEach(function(b){a.initSeries(b)});a.linkSeries();k(a,"beforeRender");q&&(a.pointer=new q(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);k(this,"load");k(this,"render");y(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})});M(J,"parts/ScrollablePlotArea.js",[J["parts/Globals.js"]],
function(c){var p=c.addEvent,y=c.Chart;"";p(y,"afterSetChartSize",function(p){var y=this.options.chart.scrollablePlotArea,z=y&&y.minWidth;y=y&&y.minHeight;if(!this.renderer.forExport){if(z){if(this.scrollablePixelsX=z=Math.max(0,z-this.chartWidth)){this.plotWidth+=z;this.inverted?(this.clipBox.height+=z,this.plotBox.height+=z):(this.clipBox.width+=z,this.plotBox.width+=z);var r={1:{name:"right",value:z}}}}else y&&(this.scrollablePixelsY=z=Math.max(0,y-this.chartHeight))&&(this.plotHeight+=z,this.inverted?
(this.clipBox.width+=z,this.plotBox.width+=z):(this.clipBox.height+=z,this.plotBox.height+=z),r={2:{name:"bottom",value:z}});r&&!p.skipAxes&&this.axes.forEach(function(p){r[p.side]?p.getPlotLinePath=function(){var v=r[p.side].name,z=this[v];this[v]=z-r[p.side].value;var w=c.Axis.prototype.getPlotLinePath.apply(this,arguments);this[v]=z;return w}:(p.setAxisSize(),p.setAxisTranslation())})}});p(y,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),
this.applyFixed()):this.fixedDiv&&this.applyFixed()});y.prototype.setUpScrolling=function(){var p={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(p.overflowX="auto");this.scrollablePixelsY&&(p.overflowY="auto");this.scrollingContainer=c.createElement("div",{className:"highcharts-scrolling"},p,this.renderTo);this.innerContainer=c.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);
this.setUpScrolling=null};y.prototype.moveFixedElements=function(){var c=this.container,p=this.fixedRenderer,z=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-reset-zoom .highcharts-subtitle .highcharts-title .highcharts-legend-checkbox".split(" "),r;this.scrollablePixelsX&&!this.inverted?r=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?r=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?r=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&
(r=".highcharts-yaxis");z.push(r,r+"-labels");z.forEach(function(r){[].forEach.call(c.querySelectorAll(r),function(c){(c.namespaceURI===p.SVG_NS?p.box:p.box.parentNode).appendChild(c);c.style.pointerEvents="auto"})})};y.prototype.applyFixed=function(){var y,F=!this.fixedDiv,z=this.options.chart.scrollablePlotArea;F?(this.fixedDiv=c.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,
this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=y=new c.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight),this.scrollableMask=y.path().attr({fill:c.color(this.options.chart.backgroundColor||"#fff").setOpacity(c.pick(z.opacity,.85)).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),this.moveFixedElements(),p(this,"afterShowResetZoom",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);y=this.chartWidth+(this.scrollablePixelsX||
0);var r=this.chartHeight+(this.scrollablePixelsY||0);c.stop(this.container);this.container.style.width=y+"px";this.container.style.height=r+"px";this.renderer.boxWrapper.attr({width:y,height:r,viewBox:[0,0,y,r].join(" ")});this.chartBackground.attr({width:y,height:r});this.scrollablePixelsY&&(this.scrollingContainer.style.height=this.chartHeight+"px");F&&(z.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*z.scrollPositionX),z.scrollPositionY&&(this.scrollingContainer.scrollTop=
this.scrollablePixelsY*z.scrollPositionY));r=this.axisOffset;F=this.plotTop-r[0]-1;z=this.plotLeft-r[3]-1;y=this.plotTop+this.plotHeight+r[2]+1;r=this.plotLeft+this.plotWidth+r[1]+1;var K=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),v=this.plotTop+this.plotHeight-(this.scrollablePixelsY||0);F=this.scrollablePixelsX?["M",0,F,"L",this.plotLeft-1,F,"L",this.plotLeft-1,y,"L",0,y,"Z","M",K,F,"L",this.chartWidth,F,"L",this.chartWidth,y,"L",K,y,"Z"]:this.scrollablePixelsY?["M",z,0,"L",z,this.plotTop-
1,"L",r,this.plotTop-1,"L",r,0,"Z","M",z,v,"L",z,this.chartHeight,"L",r,this.chartHeight,"L",r,v,"Z"]:["M",0,0];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:F})}});M(J,"parts/Point.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.erase,F=p.isArray,z=p.isNumber,r=p.isObject,K,v=c.extend,D=c.fireEvent,w=c.format,n=c.pick,l=c.uniqueKey,b=c.removeEvent;c.Point=K=function(){};c.Point.prototype={init:function(b,a,c){this.series=b;this.applyOptions(a,
c);this.id=y(this.id)?this.id:l();this.resolveColor();b.chart.pointCount++;D(this,"afterInit");return this},resolveColor:function(){var b=this.series;var a=b.chart.options.chart.colorCount;var c=b.chart.styledMode;c||this.options.color||(this.color=b.color);b.options.colorByPoint?(c||(a=b.options.colors||b.chart.options.colors,this.color=this.color||a[b.colorCounter],a=a.length),c=b.colorCounter,b.colorCounter++,b.colorCounter===a&&(b.colorCounter=0)):c=b.colorIndex;this.colorIndex=n(this.colorIndex,
c)},applyOptions:function(b,a){var d=this.series,c=d.options.pointValKey||d.pointValKey;b=K.prototype.optionsToObject.call(this,b);v(this,b);this.options=this.options?v(this.options,b):b;b.group&&delete this.group;b.dataLabels&&delete this.dataLabels;c&&(this.y=this[c]);this.formatPrefix=(this.isNull=n(this.isValid&&!this.isValid(),null===this.x||!z(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&void 0===a&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===
this.x&&d&&(this.x=void 0===a?d.autoIncrement(this):a);return this},setNestedProperty:function(b,a,c){c.split(".").reduce(function(b,d,c,g){b[d]=g.length-1===c?a:r(b[d],!0)?b[d]:{};return b[d]},b);return b},optionsToObject:function(b){var a={},d=this.series,h=d.options.keys,e=h||d.pointArrayMap||["y"],m=e.length,l=0,n=0;if(z(b)||null===b)a[e[0]]=b;else if(F(b))for(!h&&b.length>m&&(d=typeof b[0],"string"===d?a.name=b[0]:"number"===d&&(a.x=b[0]),l++);n<m;)h&&void 0===b[l]||(0<e[n].indexOf(".")?c.Point.prototype.setNestedProperty(a,
b[l],e[n]):a[e[n]]=b[l]),l++,n++;else"object"===typeof b&&(a=b,b.dataLabels&&(d._hasPointLabels=!0),b.marker&&(d._hasPointMarkers=!0));return a},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",
""):"")},getZone:function(){var b=this.series,a=b.zones;b=b.zoneAxis||"y";var c=0,h;for(h=a[c];this[b]>=h.value;)h=a[++c];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=h&&h.color&&!this.options.color?h.color:this.nonZonedColor;return h},destroy:function(){var d=this.series.chart,a=d.hoverPoints,c;d.pointCount--;a&&(this.setState(),G(a,this),a.length||(d.hoverPoints=null));if(this===d.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)b(this),this.destroyElements();
this.legendItem&&d.legend.destroyItem(this);for(c in this)this[c]=null},destroyElements:function(b){var a=this,d=[],c;b=b||{graphic:1,dataLabel:1};b.graphic&&d.push("graphic","shadowGroup");b.dataLabel&&d.push("dataLabel","dataLabelUpper","connector");for(c=d.length;c--;){var e=d[c];a[e]&&(a[e]=a[e].destroy())}["dataLabel","connector"].forEach(function(d){var c=d+"s";b[d]&&a[c]&&(a[c].forEach(function(a){a.element&&a.destroy()}),delete a[c])})},getLabelConfig:function(){return{x:this.category,y:this.y,
color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(b){var a=this.series,d=a.tooltipOptions,c=n(d.valueDecimals,""),e=d.valuePrefix||"",m=d.valueSuffix||"";a.chart.styledMode&&(b=a.chart.tooltip.styledModeFormat(b));(a.pointArrayMap||["y"]).forEach(function(a){a="{point."+a;if(e||m)b=b.replace(RegExp(a+"}","g"),e+a+"}"+m);b=b.replace(RegExp(a+"}","g"),a+":,."+
c+"f}")});return w(b,{point:this,series:this.series},a.chart.time)},firePointEvent:function(b,a,c){var d=this,e=this.series.options;(e.point.events[b]||d.options&&d.options.events&&d.options.events[b])&&this.importEvents();"click"===b&&e.allowPointSelect&&(c=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});D(this,b,a,c)},visible:!0}});M(J,"parts/Series.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.erase,F=p.isArray,z=p.isNumber,r=p.isString,
K=p.objectEach,v=p.splat,D=c.addEvent,w=c.animObject,n=c.arrayMax,l=c.arrayMin,b=c.correctFloat,d=c.defaultOptions,a=c.defaultPlotOptions,g=c.extend,h=c.fireEvent,e=c.merge,m=c.pick,u=c.removeEvent,E=c.SVGElement,t=c.syncTimeout,x=c.win;c.Series=c.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,
lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":c.numberFormat(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},
inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,isCartesian:!0,parallelArrays:["x","y"],pointClass:c.Point,requireSorting:!0,sorted:!0,init:function(a,b){h(this,"init",{options:b});var d=this,e=a.series,k;this.eventOptions=this.eventOptions||{};d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();g(d,{name:b.name,state:"",visible:!1!==
b.visible,selected:!0===b.selected});var f=b.events;K(f,function(a,b){c.isFunction(a)&&d.eventOptions[b]!==a&&(c.isFunction(d.eventOptions[b])&&u(d,b,d.eventOptions[b]),d.eventOptions[b]=a,D(d,b,a))});if(f&&f.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(a){d[a+"Data"]||(d[a+"Data"]=[])});d.points||d.data||d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);e.length&&(k=e[e.length-
1]);d._i=m(k&&k._i,-1)+1;a.orderSeries(this.insert(e));h(this,"afterInit")},insert:function(a){var b=this.options.index,d;if(z(b)){for(d=a.length;d--;)if(b>=m(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&a.unshift(this);d+=1}else a.push(this);return m(d,a.length-1)},bindAxes:function(){var a=this,b=a.options,d=a.chart,e;h(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(k){d[k].forEach(function(d){e=d.options;if(b[k]===e.index||void 0!==b[k]&&b[k]===e.id||void 0===
b[k]&&0===e.index)a.insert(d.series),a[k]=d,d.isDirty=!0});a[k]||a.optionalAxis===k||c.error(18,!0,d)})})},updateParallelArrays:function(a,b){var d=a.series,c=arguments,e=z(b)?function(c){var f="y"===c&&d.toYData?d.toYData(a):a[c];d[c+"Data"][b]=f}:function(a){Array.prototype[b].apply(d[a+"Data"],Array.prototype.slice.call(c,2))};d.parallelArrays.forEach(e)},hasData:function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=
this.options,b=this.xIncrement,d,c=a.pointIntervalUnit,e=this.chart.time;b=m(b,a.pointStart,0);this.pointInterval=d=m(this.pointInterval,a.pointInterval,1);c&&(a=new e.Date(b),"day"===c?e.set("Date",a,e.get("Date",a)+d):"month"===c?e.set("Month",a,e.get("Month",a)+d):"year"===c&&e.set("FullYear",a,e.get("FullYear",a)+d),d=a.getTime()-b);this.xIncrement=b+d;return b},setOptions:function(a){var b=this.chart,c=b.options,k=c.plotOptions,g=b.userOptions||{};a=e(a);b=b.styledMode;var f={plotOptions:k,userOptions:a};
h(this,"setOptions",f);var l=f.plotOptions[this.type],n=g.plotOptions||{};this.userOptions=f.userOptions;g=e(l,k.series,g.plotOptions&&g.plotOptions[this.type],a);this.tooltipOptions=e(d.tooltip,d.plotOptions.series&&d.plotOptions.series.tooltip,d.plotOptions[this.type].tooltip,c.tooltip.userOptions,k.series&&k.series.tooltip,k[this.type].tooltip,a.tooltip);this.stickyTracking=m(a.stickyTracking,n[this.type]&&n[this.type].stickyTracking,n.series&&n.series.stickyTracking,this.tooltipOptions.shared&&
!this.noSharedTooltip?!0:g.stickyTracking);null===l.marker&&delete g.marker;this.zoneAxis=g.zoneAxis;c=this.zones=(g.zones||[]).slice();!g.negativeColor&&!g.negativeFillColor||g.zones||(k={value:g[this.zoneAxis+"Threshold"]||g.threshold||0,className:"highcharts-negative"},b||(k.color=g.negativeColor,k.fillColor=g.negativeFillColor),c.push(k));c.length&&y(c[c.length-1].value)&&c.push(b?{}:{color:this.color,fillColor:this.fillColor});h(this,"afterSetOptions",{options:g});return g},getName:function(){return m(this.options.name,
"Series "+(this.index+1))},getCyclic:function(a,b,d){var c=this.chart,e=this.userOptions,f=a+"Index",k=a+"Counter",g=d?d.length:m(c.options.chart[a+"Count"],c[a+"Count"]);if(!b){var h=m(e[f],e["_"+f]);y(h)||(c.series.length||(c[k]=0),e["_"+f]=h=c[k]%g,c[k]+=1);d&&(b=d[h])}void 0!==h&&(this[f]=h);this[a]=b},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||a[this.type].color,this.chart.options.colors)},
getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,b){var d=a.id;a=a.x;var c=this.points,e;if(d){var f=(d=this.chart.get(d))&&d.index;void 0!==f&&(e=!0)}void 0===f&&z(a)&&(f=this.xData.indexOf(a,b));-1!==f&&void 0!==f&&this.cropped&&(f=f>=this.cropStart?f-this.cropStart:f);!e&&c[f]&&c[f].touched&&(f=void 0);return f},drawLegendSymbol:c.LegendSymbolMixin.drawLineMarker,updateData:function(a){var b=this.options,d=this.points,
c=[],e,f,k,g=this.requireSorting,h=a.length===d.length,m=!0;this.xIncrement=null;a.forEach(function(a,f){var q=y(a)&&this.pointClass.prototype.optionsToObject.call({series:this},a)||{};var m=q.x;if(q.id||z(m))if(m=this.findPointIndex(q,k),-1===m||void 0===m?c.push(a):d[m]&&a!==b.data[m]?(d[m].update(a,!1,null,!1),d[m].touched=!0,g&&(k=m+1)):d[m]&&(d[m].touched=!0),!h||f!==m||this.hasDerivedData)e=!0},this);if(e)for(a=d.length;a--;)(f=d[a])&&!f.touched&&f.remove(!1);else h?a.forEach(function(a,b){d[b].update&&
a!==d[b].y&&d[b].update(a,!1,null,!1)}):m=!1;d.forEach(function(a){a&&(a.touched=!1)});if(!m)return!1;c.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);return!0},setData:function(a,b,d,e){var k=this,f=k.points,g=f&&f.length||0,h,A=k.options,l=k.chart,B=null,n=k.xAxis,t=A.turboThreshold,H=this.xData,x=this.yData,u=(h=k.pointArrayMap)&&h.length,w=A.keys,p=0,v=1,E;a=a||[];h=a.length;b=m(b,!0);!1!==e&&h&&g&&!k.cropped&&!k.hasGroupedData&&k.visible&&!k.isSeriesBoosting&&(E=this.updateData(a));
if(!E){k.xIncrement=null;k.colorCounter=0;this.parallelArrays.forEach(function(a){k[a+"Data"].length=0});if(t&&h>t){for(d=0;null===B&&d<h;)B=a[d],d++;if(z(B))for(d=0;d<h;d++)H[d]=this.autoIncrement(),x[d]=a[d];else if(F(B))if(u)for(d=0;d<h;d++)B=a[d],H[d]=B[0],x[d]=B.slice(1,u+1);else for(w&&(p=w.indexOf("x"),v=w.indexOf("y"),p=0<=p?p:0,v=0<=v?v:1),d=0;d<h;d++)B=a[d],H[d]=B[p],x[d]=B[v];else c.error(12,!1,l)}else for(d=0;d<h;d++)void 0!==a[d]&&(B={series:k},k.pointClass.prototype.applyOptions.apply(B,
[a[d]]),k.updateParallelArrays(B,d));x&&r(x[0])&&c.error(14,!0,l);k.data=[];k.options.data=k.userOptions.data=a;for(d=g;d--;)f[d]&&f[d].destroy&&f[d].destroy();n&&(n.minRange=n.userMinRange);k.isDirty=l.isDirtyBox=!0;k.isDirtyData=!!f;d=!1}"point"===A.legendType&&(this.processData(),this.generatePoints());b&&l.redraw(d)},processData:function(a){var b=this.xData,d=this.yData,e=b.length;var k=0;var f=this.xAxis,g=this.options;var h=g.cropThreshold;var m=this.getExtremesFromAll||g.getExtremesFromAll,
l=this.isCartesian;g=f&&f.val2lin;var n=f&&f.isLog,t=this.requireSorting;if(l&&!this.isDirty&&!f.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(f){a=f.getExtremes();var x=a.min;var u=a.max}if(l&&this.sorted&&!m&&(!h||e>h||this.forceCrop))if(b[e-1]<x||b[0]>u)b=[],d=[];else if(this.yData&&(b[0]<x||b[e-1]>u)){k=this.cropData(this.xData,this.yData,x,u);b=k.xData;d=k.yData;k=k.start;var w=!0}for(h=b.length||1;--h;)if(e=n?g(b[h])-g(b[h-1]):b[h]-b[h-1],0<e&&(void 0===p||e<p))var p=e;else 0>e&&t&&(c.error(15,
!1,this.chart),t=!1);this.cropped=w;this.cropStart=k;this.processedXData=b;this.processedYData=d;this.closestPointRange=this.basePointRange=p},cropData:function(a,b,d,c,e){var f=a.length,k=0,g=f,h;e=m(e,this.cropShoulder);for(h=0;h<f;h++)if(a[h]>=d){k=Math.max(0,h-e);break}for(d=h;d<f;d++)if(a[d]>c){g=d+e;break}return{xData:a.slice(k,g),yData:b.slice(k,g),start:k,end:g}},generatePoints:function(){var a=this.options,b=a.data,d=this.data,c,e=this.processedXData,f=this.processedYData,m=this.pointClass,
l=e.length,n=this.cropStart||0,t=this.hasGroupedData;a=a.keys;var x=[],u;d||t||(d=[],d.length=b.length,d=this.data=d);a&&t&&(this.options.keys=!1);for(u=0;u<l;u++){var w=n+u;if(t){var p=(new m).init(this,[e[u]].concat(v(f[u])));p.dataGroup=this.groupMap[u];p.dataGroup.options&&(p.options=p.dataGroup.options,g(p,p.dataGroup.options),delete p.dataLabels)}else(p=d[w])||void 0===b[w]||(d[w]=p=(new m).init(this,b[w],e[u]));p&&(p.index=w,x[u]=p)}this.options.keys=a;if(d&&(l!==(c=d.length)||t))for(u=0;u<
c;u++)u!==n||t||(u+=l),d[u]&&(d[u].destroyElements(),d[u].plotX=void 0);this.data=d;this.points=x;h(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:l(a),max:n(a)}},getExtremes:function(a){var b=this.yAxis,d=this.processedXData,c=[],e=0;var f=this.xAxis.getExtremes();var k=f.min,g=f.max,m=this.requireSorting?this.cropShoulder:0,t;a=a||this.stackedYData||this.processedYData||[];f=a.length;for(t=0;t<f;t++){var x=d[t];var u=a[t];var p=(z(u)||F(u))&&(!b.positiveValuesOnly||u.length||0<
u);x=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(d[t+m]||x)>=k&&(d[t-m]||x)<=g;if(p&&x)if(p=u.length)for(;p--;)z(u[p])&&(c[e++]=u[p]);else c[e++]=u}this.dataMin=l(c);this.dataMax=n(c);h(this,"afterGetExtremes")},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,d=a.stacking,c=this.xAxis,e=c.categories,g=this.yAxis,f=this.points,l=f.length,t=!!this.modifyValue,n,x=this.pointPlacementToXValue(),u=z(x),p=a.threshold,w=a.startFromThreshold?
p:0,r,v=this.zoneAxis||"y",E=Number.MAX_VALUE;for(n=0;n<l;n++){var D=f[n],K=D.x;var G=D.y;var J=D.low,M=d&&g.stacks[(this.negStacks&&G<(w?0:p)?"-":"")+this.stackKey];g.positiveValuesOnly&&null!==G&&0>=G&&(D.isNull=!0);D.plotX=r=b(Math.min(Math.max(-1E5,c.translate(K,0,0,0,1,x,"flags"===this.type)),1E5));if(d&&this.visible&&M&&M[K]){var X=this.getStackIndicator(X,K,this.index);if(!D.isNull){var O=M[K];var Y=O.points[X.key]}}F(Y)&&(J=Y[0],G=Y[1],J===w&&X.key===M[K].base&&(J=m(z(p)&&p,g.min)),g.positiveValuesOnly&&
0>=J&&(J=null),D.total=D.stackTotal=O.total,D.percentage=O.total&&D.y/O.total*100,D.stackY=G,O.setOffset(this.pointXOffset||0,this.barW||0));D.yBottom=y(J)?Math.min(Math.max(-1E5,g.translate(J,0,1,0,1)),1E5):null;t&&(G=this.modifyValue(G,D));D.plotY=G="number"===typeof G&&Infinity!==G?Math.min(Math.max(-1E5,g.translate(G,0,1,0,1)),1E5):void 0;D.isInside=void 0!==G&&0<=G&&G<=g.len&&0<=r&&r<=c.len;D.clientX=u?b(c.translate(K,0,0,0,1,x)):r;D.negative=D[v]<(a[v+"Threshold"]||p||0);D.category=e&&void 0!==
e[D.x]?e[D.x]:D.x;if(!D.isNull){void 0!==Z&&(E=Math.min(E,Math.abs(r-Z)));var Z=r}D.zone=this.zones.length&&D.getZone()}this.closestPointRangePx=E;h(this,"afterTranslate")},getValidPoints:function(a,b,d){var c=this.chart;return(a||this.points||[]).filter(function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:d||!a.isNull})},getClipBox:function(a,b){var d=this.options,c=this.chart,e=c.inverted,f=this.xAxis,k=f&&this.yAxis;a&&!1===d.clip&&k?a=e?{y:-c.chartWidth+k.len+k.pos,height:c.chartWidth,
width:c.chartHeight,x:-c.chartHeight+f.len+f.pos}:{y:-k.pos,height:c.chartHeight,width:c.chartWidth,x:-f.pos}:(a=this.clipBox||c.clipBox,b&&(a.width=c.plotSizeX,a.x=0));return b?{width:a.width,x:a.x}:a},setClip:function(a){var b=this.chart,d=this.options,c=b.renderer,e=b.inverted,f=this.clipBox,k=this.getClipBox(a),g=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,k.height,d.xAxis,d.yAxis].join(),h=b[g],m=b[g+"m"];h||(a&&(k.width=0,e&&(k.x=b.plotSizeX+(!1!==d.clip?0:b.plotTop)),b[g+"m"]=
m=c.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[g]=h=c.clipRect(k),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);if(!1!==d.clip||a)this.group.clip(a||f?h:b.clipRect),this.markerGroup.clip(m),this.sharedClipKey=g;a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&g&&b[g]&&(f||(b[g]=b[g].destroy()),b[g+"m"]&&(b[g+"m"]=b[g+"m"].destroy())))},animate:function(a){var b=this.chart,
d=w(this.options.animation);if(a)this.setClip(d);else{var c=this.sharedClipKey;a=b[c];var e=this.getClipBox(d,!0);a&&a.animate(e,d);b[c+"m"]&&b[c+"m"].animate({width:e.width+99,x:e.x-(b.inverted?0:99)},d);this.animate=null}},afterAnimate:function(){this.setClip();h(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,d,c=this.options.marker,e=this[this.specialGroup]||this.markerGroup;var f=this.xAxis;var g=m(c.enabled,!f||f.isRadial?!0:null,this.closestPointRangePx>=
c.enabledThreshold*c.radius);if(!1!==c.enabled||this._hasPointMarkers)for(f=0;f<a.length;f++){var h=a[f];var l=(d=h.graphic)?"animate":"attr";var t=h.marker||{};var n=!!h.marker;var x=g&&void 0===t.enabled||t.enabled;var u=!1!==h.isInside;if(x&&!h.isNull){x=m(t.symbol,this.symbol);var p=this.markerAttribs(h,h.selected&&"select");d?d[u?"show":"hide"](u).animate(p):u&&(0<p.width||h.hasImage)&&(h.graphic=d=b.renderer.symbol(x,p.x,p.y,p.width,p.height,n?t:c).add(e));if(d&&!b.styledMode)d[l](this.pointAttribs(h,
h.selected&&"select"));d&&d.addClass(h.getClassName(),!0)}else d&&(h.graphic=d.destroy())}},markerAttribs:function(a,b){var d=this.options.marker,c=a.marker||{},e=c.symbol||d.symbol,f=m(c.radius,d.radius);b&&(d=d.states[b],b=c.states&&c.states[b],f=m(b&&b.radius,d&&d.radius,f+(d&&d.radiusPlus||0)));a.hasImage=e&&0===e.indexOf("url");a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},pointAttribs:function(a,b){var d=this.options.marker,c=a&&a.options,e=c&&
c.marker||{},f=this.color,k=c&&c.color,g=a&&a.color;c=m(e.lineWidth,d.lineWidth);var h=a&&a.zone&&a.zone.color;a=1;f=k||h||g||f;k=e.fillColor||d.fillColor||f;f=e.lineColor||d.lineColor||f;b=b||"normal";d=d.states[b];b=e.states&&e.states[b]||{};c=m(b.lineWidth,d.lineWidth,c+m(b.lineWidthPlus,d.lineWidthPlus,0));k=b.fillColor||d.fillColor||k;f=b.lineColor||d.lineColor||f;a=m(b.opacity,d.opacity,a);return{stroke:f,"stroke-width":c,fill:k,opacity:a}},destroy:function(a){var b=this,d=b.chart,e=/AppleWebKit\/533/.test(x.navigator.userAgent),
k,f,g=b.data||[],m,l;h(b,"destroy");a||u(b);(b.axisTypes||[]).forEach(function(a){(l=b[a])&&l.series&&(G(l.series,b),l.isDirty=l.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(f=g.length;f--;)(m=g[f])&&m.destroy&&m.destroy();b.points=null;c.clearTimeout(b.animationTimeout);K(b,function(a,b){a instanceof E&&!a.survive&&(k=e&&"group"===b?"hide":"destroy",a[k]())});d.hoverSeries===b&&(d.hoverSeries=null);G(d.series,b);d.orderSeries();K(b,function(d,c){a&&"hcEvents"===c||delete b[c]})},
getGraphPath:function(a,b,d){var c=this,e=c.options,f=e.step,k,g=[],h=[],m;a=a||c.points;(k=a.reversed)&&a.reverse();(f={right:1,center:2}[f]||f&&3)&&k&&(f=4-f);!e.connectNulls||b||d||(a=this.getValidPoints(a));a.forEach(function(k,q){var l=k.plotX,t=k.plotY,n=a[q-1];(k.leftCliff||n&&n.rightCliff)&&!d&&(m=!0);k.isNull&&!y(b)&&0<q?m=!e.connectNulls:k.isNull&&!b?m=!0:(0===q||m?q=["M",k.plotX,k.plotY]:c.getPointSpline?q=c.getPointSpline(a,k,q):f?(q=1===f?["L",n.plotX,t]:2===f?["L",(n.plotX+l)/2,n.plotY,
"L",(n.plotX+l)/2,t]:["L",l,n.plotY],q.push("L",l,t)):q=["L",l,t],h.push(k.x),f&&(h.push(k.x),2===f&&h.push(k.x)),g.push.apply(g,q),m=!1)});g.xMap=h;return c.graphPath=g},drawGraph:function(){var a=this,b=this.options,d=(this.gappedPath||this.getGraphPath).call(this),c=this.chart.styledMode,e=[["graph","highcharts-graph"]];c||e[0].push(b.lineColor||this.color||"#cccccc",b.dashStyle);e=a.getZonesGraphs(e);e.forEach(function(e,k){var f=e[0],g=a[f],h=g?"animate":"attr";g?(g.endX=a.preventGraphAnimation?
null:d.xMap,g.animate({d:d})):d.length&&(a[f]=g=a.chart.renderer.path(d).addClass(e[1]).attr({zIndex:1}).add(a.group));g&&!c&&(f={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?f.dashstyle=e[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),g[h](f).shadow(2>k&&b.shadow));g&&(g.startX=d.xMap,g.isArea=d.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,d){d=["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(b.className||
"")];this.chart.styledMode||d.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(d)},this);return a},applyZones:function(){var a=this,b=this.chart,d=b.renderer,c=this.zones,e,f,g=this.clips||[],h,l=this.graph,t=this.area,n=Math.max(b.chartWidth,b.chartHeight),x=this[(this.zoneAxis||"y")+"Axis"],u=b.inverted,p,w,r,v=!1;if(c.length&&(l||t)&&x&&void 0!==x.min){var E=x.reversed;var y=x.horiz;l&&!this.showLine&&l.hide();t&&t.hide();var z=x.getExtremes();c.forEach(function(c,k){e=E?y?
b.plotWidth:0:y?0:x.toPixels(z.min)||0;e=Math.min(Math.max(m(f,e),0),n);f=Math.min(Math.max(Math.round(x.toPixels(m(c.value,z.max),!0)||0),0),n);v&&(e=f=x.toPixels(z.max));p=Math.abs(e-f);w=Math.min(e,f);r=Math.max(e,f);x.isXAxis?(h={x:u?r:w,y:0,width:p,height:n},y||(h.x=b.plotHeight-h.x)):(h={x:0,y:u?r:w,width:n,height:p},y&&(h.y=b.plotWidth-h.y));u&&d.isVML&&(h=x.isXAxis?{x:0,y:E?w:r,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});g[k]?
g[k].animate(h):g[k]=d.clipRect(h);l&&a["zone-graph-"+k].clip(g[k]);t&&a["zone-area-"+k].clip(g[k]);v=c.value>z.max;a.resetZones&&0===f&&(f=void 0)});this.clips=g}else a.visible&&(l&&l.show(!0),t&&t.show(!0))},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){d[b]&&(c.renderer.isVML&&d[b].attr({width:d.yAxis.len,height:d.xAxis.len}),d[b].width=d.yAxis.len,d[b].height=d.xAxis.len,d[b].invert(a))})}var d=this,c=d.chart;if(d.xAxis){var e=D(c,"resize",b);D(d,"destroy",
e);b(a);d.invertGroups=b}},plotGroup:function(a,b,d,c,e){var f=this[a],k=!f;k&&(this[a]=f=this.chart.renderer.g().attr({zIndex:c||.1}).add(e));f.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(y(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(f.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);f.attr({visibility:d})[k?"attr":"animate"](this.getPlotBox());return f},getPlotBox:function(){var a=this.chart,
b=this.xAxis,d=this.yAxis;a.inverted&&(b=d,d=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,d=a.options,c=!!a.animate&&b.renderer.isSVG&&w(d.animation).duration,e=a.visible?"inherit":"hidden",f=d.zIndex,g=a.hasRendered,m=b.seriesGroup,l=b.inverted;h(this,"render");var n=a.plotGroup("group","series",e,f,m);a.markerGroup=a.plotGroup("markerGroup","markers",e,f,m);c&&a.animate(!0);n.inverted=a.isCartesian||a.invertable?
l:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(l);!1===d.clip||a.sharedClipKey||g||n.clip(b.clipRect);c&&a.animate();g||(a.animationTimeout=t(function(){a.afterAnimate()},c));a.isDirty=!1;a.hasRendered=!0;h(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,c=this.xAxis,e=
this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:m(c&&c.left,a.plotLeft),translateY:m(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var d=this.xAxis,c=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?d.len-a.chartY+d.pos:a.chartX-d.pos,plotY:e?c.len-a.chartX+c.pos:a.chartY-c.pos},b,a)},buildKDTree:function(a){function b(a,c,e){var f;if(f=a&&a.length){var g=
d.kdAxisArray[c%e];a.sort(function(a,b){return a[g]-b[g]});f=Math.floor(f/2);return{point:a[f],left:b(a.slice(0,f),c+1,e),right:b(a.slice(f+1),c+1,e)}}}this.buildingKdTree=!0;var d=this,c=-1<d.options.findNearestPointBy.indexOf("y")?2:1;delete d.kdTree;t(function(){d.kdTree=b(d.getValidPoints(null,!d.directTouch),c,c);d.buildingKdTree=!1},d.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,b,d){function c(a,b,d,h){var m=b.point,l=e.kdAxisArray[d%h],q=m;var t=y(a[f])&&y(m[f])?Math.pow(a[f]-
m[f],2):null;var n=y(a[g])&&y(m[g])?Math.pow(a[g]-m[g],2):null;n=(t||0)+(n||0);m.dist=y(n)?Math.sqrt(n):Number.MAX_VALUE;m.distX=y(t)?Math.sqrt(t):Number.MAX_VALUE;l=a[l]-m[l];n=0>l?"left":"right";t=0>l?"right":"left";b[n]&&(n=c(a,b[n],d+1,h),q=n[k]<q[k]?n:m);b[t]&&Math.sqrt(l*l)<q[k]&&(a=c(a,b[t],d+1,h),q=a[k]<q[k]?a:q);return q}var e=this,f=this.kdAxisArray[0],g=this.kdAxisArray[1],k=b?"distX":"dist";b=-1<e.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(d);
if(this.kdTree)return c(a,this.kdTree,b,b)},pointPlacementToXValue:function(){var a=this.options.pointPlacement;"between"===a&&(a=.5);z(a)&&(a*=m(this.options.pointRange||this.xAxis.pointRange));return a}});""});M(J,"parts/Stacking.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.objectEach;p=c.Axis;var F=c.Chart,z=c.correctFloat,r=c.destroyObjectProperties,K=c.format,v=c.pick,D=c.Series;c.StackItem=function(c,n,l,b,d){var a=c.chart.inverted;this.axis=c;this.isNegative=
l;this.options=n=n||{};this.x=b;this.total=null;this.points={};this.stack=d;this.rightCliff=this.leftCliff=0;this.alignOptions={align:n.align||(a?l?"left":"right":"center"),verticalAlign:n.verticalAlign||(a?"middle":l?"bottom":"top"),y:n.y,x:n.x};this.textAlign=n.textAlign||(a?l?"right":"left":"center")};c.StackItem.prototype={destroy:function(){r(this,this.axis)},render:function(c){var n=this.axis.chart,l=this.options,b=l.format;b=b?K(b,this,n.time):l.formatter.call(this);this.label?this.label.attr({text:b,
visibility:"hidden"}):(this.label=n.renderer.label(b,null,null,l.shape,null,null,l.useHTML,!1,"stack-labels"),b={text:b,align:this.textAlign,rotation:l.rotation,padding:v(l.padding,0),visibility:"hidden"},this.label.attr(b),n.styledMode||this.label.css(l.style),this.label.added||this.label.add(c));this.label.labelrank=n.plotHeight},setOffset:function(c,n,l,b){var d=this.axis,a=d.chart;b=d.translate(d.usePercentage?100:b?b:this.total,0,0,0,1);l=d.translate(l?l:0);l=y(b)&&Math.abs(b-l);c=a.xAxis[0].translate(this.x)+
c;d=y(b)&&this.getStackBox(a,this,c,b,n,l,d);n=this.label;c=this.isNegative;b="justify"===v(this.options.overflow,"justify");if(n&&d){var g=n.getBBox(),h=a.inverted?c?g.width:0:g.width/2,e=a.inverted?g.height/2:c?-4:g.height+4;n.align(this.alignOptions,null,d);l=n.alignAttr;n.show();l.y-=e;b&&(l.x-=h,D.prototype.justifyDataLabel.call(this.axis,n,this.alignOptions,l,g,d),l.x+=h);n.alignAttr=l;n.attr({x:l.x,y:l.y});v(!b&&this.options.crop,!0)&&((a=a.isInsidePlot(n.alignAttr.x-g.width/2,n.alignAttr.y)&&
a.isInsidePlot(n.alignAttr.x+(a.inverted?c?-g.width:g.width:g.width/2),n.alignAttr.y+g.height))||n.hide())}},getStackBox:function(c,n,l,b,d,a,g){var h=n.axis.reversed,e=c.inverted;c=g.height+g.pos-(e?c.plotLeft:c.plotTop);n=n.isNegative&&!h||!n.isNegative&&h;return{x:e?n?b:b-a:l,y:e?c-l-d:n?c-b-a:c-b,width:e?a:d,height:e?d:a}}};F.prototype.getStacks=function(){var c=this,n=c.inverted;c.yAxis.forEach(function(c){c.stacks&&c.hasVisibleSeries&&(c.oldStacks=c.stacks)});c.series.forEach(function(l){var b=
l.xAxis&&l.xAxis.options||{};!l.options.stacking||!0!==l.visible&&!1!==c.options.chart.ignoreHiddenSeries||(l.stackKey=[l.type,v(l.options.stack,""),n?b.top:b.left,n?b.height:b.width].join())})};p.prototype.buildStacks=function(){var c=this.series,n=v(this.options.reversedStacks,!0),l=c.length,b;if(!this.isXAxis){this.usePercentage=!1;for(b=l;b--;)c[n?b:l-b-1].setStackedPoints();for(b=0;b<l;b++)c[b].modifyStacks()}};p.prototype.renderStackTotals=function(){var c=this.chart,n=c.renderer,l=this.stacks,
b=this.stackTotalGroup;b||(this.stackTotalGroup=b=n.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());b.translate(c.plotLeft,c.plotTop);G(l,function(d){G(d,function(a){a.render(b)})})};p.prototype.resetStacks=function(){var c=this,n=c.stacks;c.isXAxis||G(n,function(l){G(l,function(b,d){b.touched<c.stacksTouched?(b.destroy(),delete l[d]):(b.total=null,b.cumulative=null)})})};p.prototype.cleanStacks=function(){if(!this.isXAxis){if(this.oldStacks)var c=this.stacks=this.oldStacks;G(c,function(c){G(c,
function(c){c.cumulative=c.total})})}};D.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var p=this.processedXData,n=this.processedYData,l=[],b=n.length,d=this.options,a=d.threshold,g=v(d.startFromThreshold&&a,0),h=d.stack;d=d.stacking;var e=this.stackKey,m="-"+e,u=this.negStacks,r=this.yAxis,t=r.stacks,x=r.oldStacks,k,A;r.stacksTouched+=1;for(A=0;A<b;A++){var B=p[A];var H=n[A];var q=this.getStackIndicator(q,B,
this.index);var f=q.key;var C=(k=u&&H<(g?0:a))?m:e;t[C]||(t[C]={});t[C][B]||(x[C]&&x[C][B]?(t[C][B]=x[C][B],t[C][B].total=null):t[C][B]=new c.StackItem(r,r.options.stackLabels,k,B,h));C=t[C][B];null!==H?(C.points[f]=C.points[this.index]=[v(C.cumulative,g)],y(C.cumulative)||(C.base=f),C.touched=r.stacksTouched,0<q.index&&!1===this.singleStacks&&(C.points[f][0]=C.points[this.index+","+B+",0"][0])):C.points[f]=C.points[this.index]=null;"percent"===d?(k=k?e:m,u&&t[k]&&t[k][B]?(k=t[k][B],C.total=k.total=
Math.max(k.total,C.total)+Math.abs(H)||0):C.total=z(C.total+(Math.abs(H)||0))):C.total=z(C.total+(H||0));C.cumulative=v(C.cumulative,g)+(H||0);null!==H&&(C.points[f].push(C.cumulative),l[A]=C.cumulative)}"percent"===d&&(r.usePercentage=!0);this.stackedYData=l;r.oldStacks={}}};D.prototype.modifyStacks=function(){var c=this,n=c.stackKey,l=c.yAxis.stacks,b=c.processedXData,d,a=c.options.stacking;c[a+"Stacker"]&&[n,"-"+n].forEach(function(g){for(var h=b.length,e,m;h--;)if(e=b[h],d=c.getStackIndicator(d,
e,c.index,g),m=(e=l[g]&&l[g][e])&&e.points[d.key])c[a+"Stacker"](m,e,h)})};D.prototype.percentStacker=function(c,n,l){n=n.total?100/n.total:0;c[0]=z(c[0]*n);c[1]=z(c[1]*n);this.stackedYData[l]=c[1]};D.prototype.getStackIndicator=function(c,n,l,b){!y(c)||c.x!==n||b&&c.key!==b?c={x:n,index:0,key:b}:c.index++;c.key=[l,n,c.index].join();return c}});M(J,"parts/Dynamics.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.erase,F=p.isArray,z=p.isNumber,r=p.isObject,K=p.isString,
v=p.objectEach,D=p.splat,w=c.addEvent,n=c.animate,l=c.Axis;p=c.Chart;var b=c.createElement,d=c.css,a=c.extend,g=c.fireEvent,h=c.merge,e=c.pick,m=c.Point,u=c.Series,E=c.seriesTypes,t=c.setAnimation;c.cleanRecursively=function(a,b){var d={};v(a,function(e,g){if(r(a[g],!0)&&!a.nodeType&&b[g])e=c.cleanRecursively(a[g],b[g]),Object.keys(e).length&&(d[g]=e);else if(r(a[g])||a[g]!==b[g])d[g]=a[g]});return d};a(p.prototype,{addSeries:function(a,b,d){var c,k=this;a&&(b=e(b,!0),g(k,"addSeries",{options:a},
function(){c=k.initSeries(a);k.isDirtyLegend=!0;k.linkSeries();g(k,"afterAddSeries",{series:c});b&&k.redraw(d)}));return c},addAxis:function(a,b,d,c){var g=b?"xAxis":"yAxis",k=this.options;a=h(a,{index:this[g].length,isX:b});b=new l(this,a);k[g]=D(k[g]||{});k[g].push(a);e(d,!0)&&this.redraw(c);return b},showLoading:function(c){var g=this,h=g.options,m=g.loadingDiv,l=h.loading,q=function(){m&&d(m,{left:g.plotLeft+"px",top:g.plotTop+"px",width:g.plotWidth+"px",height:g.plotHeight+"px"})};m||(g.loadingDiv=
m=b("div",{className:"highcharts-loading highcharts-loading-hidden"},null,g.container),g.loadingSpan=b("span",{className:"highcharts-loading-inner"},null,m),w(g,"redraw",q));m.className="highcharts-loading";g.loadingSpan.innerHTML=e(c,h.lang.loading,"");g.styledMode||(d(m,a(l.style,{zIndex:10})),d(g.loadingSpan,l.labelStyle),g.loadingShown||(d(m,{opacity:0,display:""}),n(m,{opacity:l.style.opacity||.5},{duration:l.showDuration||0})));g.loadingShown=!0;q()},hideLoading:function(){var a=this.options,
b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",this.styledMode||n(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){d(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),collectionsWithUpdate:"xAxis yAxis zAxis series colorAxis pane".split(" "),update:function(a,b,d,m){var k=this,l={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},f,n,t,x=a.isResponsiveOptions,A=[];g(k,"update",{options:a});x||k.setResponsive(!1,!0);a=c.cleanRecursively(a,k.options);h(!0,k.userOptions,a);if(f=a.chart){h(!0,k.options.chart,f);"className"in
f&&k.setClassName(f.className);"reflow"in f&&k.setReflow(f.reflow);if("inverted"in f||"polar"in f||"type"in f){k.propFromSeries();var u=!0}"alignTicks"in f&&(u=!0);v(f,function(a,b){-1!==k.propsRequireUpdateSeries.indexOf("chart."+b)&&(n=!0);-1!==k.propsRequireDirtyBox.indexOf(b)&&(k.isDirtyBox=!0);x||-1===k.propsRequireReflow.indexOf(b)||(t=!0)});!k.styledMode&&"style"in f&&k.renderer.setStyle(f.style)}!k.styledMode&&a.colors&&(this.options.colors=a.colors);a.plotOptions&&h(!0,this.options.plotOptions,
a.plotOptions);a.time&&this.time===c.time&&(this.time=new c.Time(a.time));v(a,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,!1);else if("function"===typeof k[l[b]])k[l[b]](a);"chart"!==b&&-1!==k.propsRequireUpdateSeries.indexOf(b)&&(n=!0)});this.collectionsWithUpdate.forEach(function(b){if(a[b]){if("series"===b){var c=[];k[b].forEach(function(a,b){a.options.isInternal||c.push(e(a.options.index,b))})}D(a[b]).forEach(function(a,e){(e=y(a.id)&&k.get(a.id)||k[b][c?c[e]:e])&&e.coll===
b&&(e.update(a,!1),d&&(e.touched=!0));!e&&d&&k.collectionsWithInit[b]&&(k.collectionsWithInit[b][0].apply(k,[a].concat(k.collectionsWithInit[b][1]||[]).concat([!1])).touched=!0)});d&&k[b].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:A.push(a)})}});A.forEach(function(a){a.remove&&a.remove(!1)});u&&k.axes.forEach(function(a){a.update({},!1)});n&&k.series.forEach(function(a){a.update({},!1)});a.loading&&h(!0,k.options.loading,a.loading);u=f&&f.width;f=f&&f.height;K(f)&&(f=c.relativeLength(f,
u||k.chartWidth));t||z(u)&&u!==k.chartWidth||z(f)&&f!==k.chartHeight?k.setSize(u,f,m):e(b,!0)&&k.redraw(m);g(k,"afterUpdate",{options:a,redraw:b,animation:m})},setSubtitle:function(a){this.setTitle(void 0,a)}});p.prototype.collectionsWithInit={xAxis:[p.prototype.addAxis,[!0]],yAxis:[p.prototype.addAxis,[!1]],series:[p.prototype.addSeries]};a(m.prototype,{update:function(a,b,d,c){function g(){k.applyOptions(a);null===k.y&&h&&(k.graphic=h.destroy());r(a,!0)&&(h&&h.element&&a&&a.marker&&void 0!==a.marker.symbol&&
(k.graphic=h.destroy()),a&&a.dataLabels&&k.dataLabel&&(k.dataLabel=k.dataLabel.destroy()),k.connector&&(k.connector=k.connector.destroy()));m=k.index;f.updateParallelArrays(k,m);n.data[m]=r(n.data[m],!0)||r(a,!0)?k.options:e(a,n.data[m]);f.isDirty=f.isDirtyData=!0;!f.fixedBox&&f.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===n.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(d)}var k=this,f=k.series,h=k.graphic,m,l=f.chart,n=f.options;b=e(b,!0);!1===c?g():k.firePointEvent("update",{options:a},g)},remove:function(a,
b){this.series.removePoint(this.series.data.indexOf(this),a,b)}});a(u.prototype,{addPoint:function(a,b,d,c,h){var k=this.options,f=this.data,m=this.chart,l=this.xAxis;l=l&&l.hasNames&&l.names;var n=k.data,t=this.xData,x;b=e(b,!0);var u={series:this};this.pointClass.prototype.applyOptions.apply(u,[a]);var A=u.x;var p=t.length;if(this.requireSorting&&A<t[p-1])for(x=!0;p&&t[p-1]>A;)p--;this.updateParallelArrays(u,"splice",p,0,0);this.updateParallelArrays(u,p);l&&u.name&&(l[A]=u.name);n.splice(p,0,a);
x&&(this.data.splice(p,0,null),this.processData());"point"===k.legendType&&this.generatePoints();d&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(u,"shift"),n.shift()));!1!==h&&g(this,"addPoint",{point:u});this.isDirtyData=this.isDirty=!0;b&&m.redraw(c)},removePoint:function(a,b,d){var c=this,g=c.data,k=g[a],f=c.points,h=c.chart,m=function(){f&&f.length===g.length&&f.splice(a,1);g.splice(a,1);c.options.data.splice(a,1);c.updateParallelArrays(k||{series:c},"splice",a,1);k&&
k.destroy();c.isDirty=!0;c.isDirtyData=!0;b&&h.redraw()};t(d,h);b=e(b,!0);k?k.firePointEvent("remove",null,m):m()},remove:function(a,b,d,c){function k(){h.destroy(c);h.remove=null;f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();e(a,!0)&&f.redraw(b)}var h=this,f=h.chart;!1!==d?g(h,"remove",null,k):k()},update:function(b,d){b=c.cleanRecursively(b,this.userOptions);g(this,"update",{options:b});var k=this,m=k.chart,l=k.userOptions,n=k.initialType||k.type,f=b.type||l.type||m.options.chart.type,t=!(this.hasDerivedData||
b.dataGrouping||f&&f!==this.type||void 0!==b.pointStart||b.pointInterval||b.pointIntervalUnit||b.keys),u=E[n].prototype,x,p=["group","markerGroup","dataLabelsGroup","transformGroup"],r=["eventOptions","navigatorSeries","baseSeries"],v=k.finishedAnimating&&{animation:!1},w={};t&&(r.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==b.visible&&r.push("area","graph"),k.parallelArrays.forEach(function(a){r.push(a+
"Data")}),b.data&&this.setData(b.data,!1));b=h(l,v,{index:void 0===l.index?k.index:l.index,pointStart:e(l.pointStart,k.xData[0])},!t&&{data:k.options.data},b);t&&b.data&&(b.data=k.options.data);r=p.concat(r);r.forEach(function(a){r[a]=k[a];delete k[a]});k.remove(!1,null,!1,!0);for(x in u)k[x]=void 0;E[f||n]?a(k,E[f||n].prototype):c.error(17,!0,m);r.forEach(function(a){k[a]=r[a]});k.init(m,b);if(t&&this.points){var y=k.options;!1===y.visible?(w.graphic=1,w.dataLabel=1):k._hasPointLabels||(f=y.marker,
u=y.dataLabels,f&&(!1===f.enabled||"symbol"in f)&&(w.graphic=1),u&&!1===u.enabled&&(w.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(w).length&&a.destroyElements(w),!1===y.showInLegend&&a.legendItem&&m.legend.destroyItem(a))},this)}b.zIndex!==l.zIndex&&p.forEach(function(a){k[a]&&k[a].attr({zIndex:b.zIndex})});k.initialType=n;m.linkSeries();g(this,"afterUpdate");e(d,!0)&&m.redraw(t?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=
a;this.chart.isDirtyLegend=!0}});a(l.prototype,{update:function(b,d){var c=this.chart,g=b&&b.events||{};b=h(this.userOptions,b);c.options[this.coll].indexOf&&(c.options[this.coll][c.options[this.coll].indexOf(this.userOptions)]=b);v(c.options[this.coll].events,function(a,b){"undefined"===typeof g[b]&&(g[b]=void 0)});this.destroy(!0);this.init(c,a(b,{events:g}));c.isDirtyBox=!0;e(d,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,d=this.coll,c=this.series,g=c.length;g--;)c[g]&&c[g].remove(!1);
G(b.axes,this);G(b[d],this);F(b.options[d])?b.options[d].splice(this.options.index,1):delete b.options[d];b[d].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;e(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})});M(J,"parts/AreaSeries.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.objectEach,G=c.color,F=c.pick,z=c.Series;p=c.seriesType;p("area","line",
{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(c){var p=[],r=[],z=this.xAxis,w=this.yAxis,n=w.stacks[this.stackKey],l={},b=this.index,d=w.series,a=d.length,g=F(w.options.reversedStacks,!0)?1:-1,h;c=c||this.points;if(this.options.stacking){for(h=0;h<c.length;h++)c[h].leftNull=c[h].rightNull=null,l[c[h].x]=c[h];y(n,function(a,b){null!==a.total&&r.push(b)});r.sort(function(a,b){return a-b});var e=d.map(function(a){return a.visible});r.forEach(function(d,c){var m=0,t,u;if(l[d]&&
!l[d].isNull)p.push(l[d]),[-1,1].forEach(function(k){var m=1===k?"rightNull":"leftNull",p=0,x=n[r[c+k]];if(x)for(h=b;0<=h&&h<a;)t=x.points[h],t||(h===b?l[d][m]=!0:e[h]&&(u=n[d].points[h])&&(p-=u[1]-u[0])),h+=g;l[d][1===k?"rightCliff":"leftCliff"]=p});else{for(h=b;0<=h&&h<a;){if(t=n[d].points[h]){m=t[1];break}h+=g}m=w.translate(m,0,1,0,1);p.push({isNull:!0,plotX:z.translate(d,0,0,0,1),x:d,plotY:m,yBottom:m})}})}return p},getGraphPath:function(p){var r=z.prototype.getGraphPath,v=this.options,y=v.stacking,
w=this.yAxis,n,l=[],b=[],d=this.index,a=w.stacks[this.stackKey],g=v.threshold,h=Math.round(w.getThreshold(v.threshold));v=c.pick(v.connectNulls,"percent"===y);var e=function(c,e,k){var m=p[c];c=y&&a[m.x].points[d];var n=m[k+"Null"]||0;k=m[k+"Cliff"]||0;m=!0;if(k||n){var t=(n?c[0]:c[1])+k;var q=c[0]+k;m=!!n}else!y&&p[e]&&p[e].isNull&&(t=q=g);void 0!==t&&(b.push({plotX:u,plotY:null===t?h:w.getThreshold(t),isNull:m,isCliff:!0}),l.push({plotX:u,plotY:null===q?h:w.getThreshold(q),doCurve:!1}))};p=p||this.points;
y&&(p=this.getStackPoints(p));for(n=0;n<p.length;n++){var m=p[n].isNull;var u=F(p[n].rectPlotX,p[n].plotX);var E=F(p[n].yBottom,h);if(!m||v)v||e(n,n-1,"left"),m&&!y&&v||(b.push(p[n]),l.push({x:n,plotX:u,plotY:E})),v||e(n,n+1,"right")}n=r.call(this,b,!0,!0);l.reversed=!0;m=r.call(this,l,!0,!0);m.length&&(m[0]="L");m=n.concat(m);r=r.call(this,b,!1,v);m.xMap=n.xMap;this.areaPath=m;return r},drawGraph:function(){this.areaPath=[];z.prototype.drawGraph.apply(this);var c=this,p=this.areaPath,v=this.options,
y=[["area","highcharts-area",this.color,v.fillColor]];this.zones.forEach(function(p,n){y.push(["zone-area-"+n,"highcharts-area highcharts-zone-area-"+n+" "+p.className,p.color||c.color,p.fillColor||v.fillColor])});y.forEach(function(r){var n=r[0],l=c[n],b=l?"animate":"attr",d={};l?(l.endX=c.preventGraphAnimation?null:p.xMap,l.animate({d:p})):(d.zIndex=0,l=c[n]=c.chart.renderer.path(p).addClass(r[1]).add(c.group),l.isArea=!0);c.chart.styledMode||(d.fill=F(r[3],G(r[2]).setOpacity(F(v.fillOpacity,.75)).get()));
l[b](d);l.startX=p.xMap;l.shiftUnit=v.step?2:1})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(J,"parts/SplineSeries.js",[J["parts/Globals.js"]],function(c){var p=c.pick;c=c.seriesType;c("spline","line",{},{getPointSpline:function(c,G,F){var y=G.plotX,r=G.plotY,K=c[F-1];F=c[F+1];if(K&&!K.isNull&&!1!==K.doCurve&&!G.isCliff&&F&&!F.isNull&&!1!==F.doCurve&&!G.isCliff){c=K.plotY;var v=F.plotX;F=F.plotY;var D=0;var w=(1.5*y+K.plotX)/2.5;var n=(1.5*r+c)/2.5;v=(1.5*y+v)/2.5;var l=(1.5*r+F)/
2.5;v!==w&&(D=(l-n)*(v-y)/(v-w)+r-l);n+=D;l+=D;n>c&&n>r?(n=Math.max(c,r),l=2*r-n):n<c&&n<r&&(n=Math.min(c,r),l=2*r-n);l>F&&l>r?(l=Math.max(F,r),n=2*r-l):l<F&&l<r&&(l=Math.min(F,r),n=2*r-l);G.rightContX=v;G.rightContY=l}G=["C",p(K.rightContX,K.plotX),p(K.rightContY,K.plotY),p(w,y),p(n,r),y,r];K.rightContX=K.rightContY=null;return G}});""});M(J,"parts/AreaSplineSeries.js",[J["parts/Globals.js"]],function(c){var p=c.seriesTypes.area.prototype,y=c.seriesType;y("areaspline","spline",c.defaultPlotOptions.area,
{getStackPoints:p.getStackPoints,getGraphPath:p.getGraphPath,drawGraph:p.drawGraph,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(J,"parts/ColumnSeries.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=c.animObject,z=c.color,r=c.extend,K=c.merge,v=c.pick,D=c.Series;p=c.seriesType;var w=c.svg;p("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,
brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){D.prototype.init.apply(this,arguments);var c=this,l=c.chart;l.hasRendered&&l.series.forEach(function(b){b.type===c.type&&(b.isDirty=!0)})},getColumnMetrics:function(){var c=
this,l=c.options,b=c.xAxis,d=c.yAxis,a=b.options.reversedStacks;a=b.reversed&&!a||!b.reversed&&a;var g,h={},e=0;!1===l.grouping?e=1:c.chart.series.forEach(function(a){var b=a.yAxis,k=a.options;if(a.type===c.type&&(a.visible||!c.chart.options.chart.ignoreHiddenSeries)&&d.len===b.len&&d.pos===b.pos){if(k.stacking){g=a.stackKey;void 0===h[g]&&(h[g]=e++);var m=h[g]}else!1!==k.grouping&&(m=e++);a.columnIndex=m}});var m=Math.min(Math.abs(b.transA)*(b.ordinalSlope||l.pointRange||b.closestPointRange||b.tickInterval||
1),b.len),u=m*l.groupPadding,p=(m-2*u)/(e||1);l=Math.min(l.maxPointWidth||b.len,v(l.pointWidth,p*(1-2*l.pointPadding)));c.columnMetrics={width:l,offset:(p-l)/2+(u+((c.columnIndex||0)+(a?1:0))*p-m/2)*(a?-1:1)};return c.columnMetrics},crispCol:function(c,l,b,d){var a=this.chart,g=this.borderWidth,h=-(g%2?.5:0);g=g%2?.5:1;a.inverted&&a.renderer.isVML&&(g+=1);this.options.crisp&&(b=Math.round(c+b)+h,c=Math.round(c)+h,b-=c);d=Math.round(l+d)+g;h=.5>=Math.abs(l)&&.5<d;l=Math.round(l)+g;d-=l;h&&d&&(--l,
d+=1);return{x:c,y:l,width:b,height:d}},translate:function(){var c=this,l=c.chart,b=c.options,d=c.dense=2>c.closestPointRange*c.xAxis.transA;d=c.borderWidth=v(b.borderWidth,d?0:1);var a=c.yAxis,g=b.threshold,h=c.translatedThreshold=a.getThreshold(g),e=v(b.minPointLength,5),m=c.getColumnMetrics(),p=m.width,r=c.barW=Math.max(p,1+2*d),t=c.pointXOffset=m.offset,x=c.dataMin,k=c.dataMax;l.inverted&&(h-=.5);b.pointPadding&&(r=Math.ceil(r));D.prototype.translate.apply(c);c.points.forEach(function(b){var d=
v(b.yBottom,h),m=999+Math.abs(d),n=p;m=Math.min(Math.max(-m,b.plotY),a.len+m);var f=b.plotX+t,u=r,A=Math.min(m,d),w=Math.max(m,d)-A;if(e&&Math.abs(w)<e){w=e;var z=!a.reversed&&!b.negative||a.reversed&&b.negative;b.y===g&&c.dataMax<=g&&a.min<g&&x!==k&&(z=!z);A=Math.abs(A-h)>e?d-e:h-(z?e:0)}y(b.options.pointWidth)&&(n=u=Math.ceil(b.options.pointWidth),f-=Math.round((n-p)/2));b.barX=f;b.pointWidth=n;b.tooltipPos=l.inverted?[a.len+a.pos-l.plotLeft-m,c.xAxis.len-f-u/2,w]:[f+u/2,m+a.pos-l.plotTop,w];b.shapeType=
c.pointClass.prototype.shapeType||"rect";b.shapeArgs=c.crispCol.apply(c,b.isNull?[f,h,u,0]:[f,A,u,w])})},getSymbol:c.noop,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(c,l){var b=this.options,d=this.pointAttrToOptions||{};var a=d.stroke||"borderColor";var g=d["stroke-width"]||"borderWidth",h=c&&c.color||this.color,e=c&&c[a]||b[a]||this.color||h,m=c&&c[g]||b[g]||this[g]||0;d=c&&
c.options.dashStyle||b.dashStyle;var n=v(b.opacity,1);if(c&&this.zones.length){var p=c.getZone();h=c.options.color||p&&(p.color||c.nonZonedColor)||this.color;p&&(e=p.borderColor||e,d=p.dashStyle||d,m=p.borderWidth||m)}l&&(c=K(b.states[l],c.options.states&&c.options.states[l]||{}),l=c.brightness,h=c.color||void 0!==l&&z(h).brighten(c.brightness).get()||h,e=c[a]||e,m=c[g]||m,d=c.dashStyle||d,n=v(c.opacity,n));a={fill:h,stroke:e,"stroke-width":m,opacity:n};d&&(a.dashstyle=d);return a},drawPoints:function(){var c=
this,l=this.chart,b=c.options,d=l.renderer,a=b.animationLimit||250,g;c.points.forEach(function(h){var e=h.graphic,m=e&&l.pointCount<a?"animate":"attr";if(G(h.plotY)&&null!==h.y){g=h.shapeArgs;e&&e.element.nodeName!==h.shapeType&&(e=e.destroy());if(e)e[m](K(g));else h.graphic=e=d[h.shapeType](g).add(h.group||c.group);if(b.borderRadius)e[m]({r:b.borderRadius});l.styledMode||e[m](c.pointAttribs(h,h.selected&&"select")).shadow(!1!==h.allowShadow&&b.shadow,null,b.stacking&&!b.borderRadius);e.addClass(h.getClassName(),
!0)}else e&&(h.graphic=e.destroy())})},animate:function(c){var l=this,b=this.yAxis,d=l.options,a=this.chart.inverted,g={},h=a?"translateX":"translateY";if(w)if(c)g.scaleY=.001,c=Math.min(b.pos+b.len,Math.max(b.pos,b.toPixels(d.threshold))),a?g.translateX=c-b.len:g.translateY=c,l.clipBox&&l.setClip(),l.group.attr(g);else{var e=l.group.attr(h);l.group.animate({scaleY:1},r(F(l.options.animation),{step:function(a,d){g[h]=e+d.pos*(b.pos-e);l.group.attr(g)}}));l.animate=null}},remove:function(){var c=this,
l=c.chart;l.hasRendered&&l.series.forEach(function(b){b.type===c.type&&(b.isDirty=!0)});D.prototype.remove.apply(c,arguments)}});""});M(J,"parts/BarSeries.js",[J["parts/Globals.js"]],function(c){c=c.seriesType;c("bar","column",null,{inverted:!0});""});M(J,"parts/ScatterSeries.js",[J["parts/Globals.js"]],function(c){var p=c.Series,y=c.seriesType;y("scatter","line",{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',
pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&p.prototype.drawGraph.call(this)},applyJitter:function(){var c=this,p=this.options.jitter,y=this.points.length;p&&this.points.forEach(function(r,z){["x","y"].forEach(function(v,D){var w="plot"+v.toUpperCase();if(p[v]&&!r.isNull){var n=c[v+"Axis"];var l=p[v]*n.transA;
if(n&&!n.isLog){var b=Math.max(0,r[w]-l);n=Math.min(n.len,r[w]+l);D=1E4*Math.sin(z+D*y);r[w]=b+(n-b)*(D-Math.floor(D));"x"===v&&(r.clientX=r.plotX)}}})})}});c.addEvent(p,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});M(J,"mixins/centered-series.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.isNumber,G=c.deg2rad,F=c.pick,z=c.relativeLength;c.CenteredSeriesMixin={getCenter:function(){var c=this.options,p=this.chart,v=2*(c.slicedOffset||0),y=p.plotWidth-
2*v;p=p.plotHeight-2*v;var w=c.center;w=[F(w[0],"50%"),F(w[1],"50%"),c.size||"100%",c.innerSize||0];var n=Math.min(y,p),l;for(l=0;4>l;++l){var b=w[l];c=2>l||2===l&&/%$/.test(b);w[l]=z(b,[y,p,n,w[2]][l])+(c?v:0)}w[3]>w[2]&&(w[3]=w[2]);return w},getStartAndEndRadians:function(c,p){c=y(c)?c:0;p=y(p)&&p>c&&360>p-c?p:c+360;return{start:G*(c+-90),end:G*(p+-90)}}}});M(J,"parts/PieSeries.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isNumber,F=c.addEvent;p=c.CenteredSeriesMixin;
var z=p.getStartAndEndRadians,r=c.merge,K=c.noop,v=c.pick,D=c.Point,w=c.Series,n=c.seriesType,l=c.setAnimation;n("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0,connectorShape:"fixedOffset",crookDistance:"70%"},ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,
tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:c.seriesTypes.column.prototype.pointAttribs,animate:function(b){var d=this,a=d.points,c=d.startAngleRad;b||(a.forEach(function(a){var b=a.graphic,g=a.shapeArgs;b&&(b.attr({r:a.startR||d.center[3]/2,start:c,end:c}),b.animate({r:g.r,start:g.start,end:g.end},d.options.animation))}),
d.animate=null)},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var b,d=0,a=this.points,c=a.length,h=this.options.ignoreHiddenPoint;for(b=0;b<c;b++){var e=a[b];d+=h&&!e.visible?0:e.isNull?0:e.y}this.total=d;for(b=0;b<c;b++)e=a[b],e.percentage=0<d&&(e.visible||!h)?e.y/d*100:0,e.total=d},generatePoints:function(){w.prototype.generatePoints.call(this);this.updateTotals()},getX:function(b,d,a){var c=this.center,h=this.radii?this.radii[a.index]:c[2]/2;return c[0]+(d?-1:
1)*Math.cos(Math.asin(Math.max(Math.min((b-c[1])/(h+a.labelDistance),1),-1)))*(h+a.labelDistance)+(0<a.labelDistance?(d?-1:1)*this.options.dataLabels.padding:0)},translate:function(b){this.generatePoints();var d=0,a=this.options,g=a.slicedOffset,h=g+(a.borderWidth||0),e=z(a.startAngle,a.endAngle),m=this.startAngleRad=e.start;e=(this.endAngleRad=e.end)-m;var l=this.points,n=a.dataLabels.distance;a=a.ignoreHiddenPoint;var t,p=l.length;b||(this.center=b=this.getCenter());for(t=0;t<p;t++){var k=l[t];
var A=m+d*e;if(!a||k.visible)d+=k.percentage/100;var r=m+d*e;k.shapeType="arc";k.shapeArgs={x:b[0],y:b[1],r:b[2]/2,innerR:b[3]/2,start:Math.round(1E3*A)/1E3,end:Math.round(1E3*r)/1E3};k.labelDistance=v(k.options.dataLabels&&k.options.dataLabels.distance,n);k.labelDistance=c.relativeLength(k.labelDistance,k.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,k.labelDistance);r=(r+A)/2;r>1.5*Math.PI?r-=2*Math.PI:r<-Math.PI/2&&(r+=2*Math.PI);k.slicedTranslation={translateX:Math.round(Math.cos(r)*
g),translateY:Math.round(Math.sin(r)*g)};var w=Math.cos(r)*b[2]/2;var q=Math.sin(r)*b[2]/2;k.tooltipPos=[b[0]+.7*w,b[1]+.7*q];k.half=r<-Math.PI/2||r>Math.PI/2?1:0;k.angle=r;A=Math.min(h,k.labelDistance/5);k.labelPosition={natural:{x:b[0]+w+Math.cos(r)*k.labelDistance,y:b[1]+q+Math.sin(r)*k.labelDistance},"final":{},alignment:0>k.labelDistance?"center":k.half?"right":"left",connectorPosition:{breakAt:{x:b[0]+w+Math.cos(r)*A,y:b[1]+q+Math.sin(r)*A},touchingSliceAt:{x:b[0]+w,y:b[1]+q}}}}},drawGraph:null,
redrawPoints:function(){var b=this,d=b.chart,a=d.renderer,c,h,e,m,l=b.options.shadow;!l||b.shadowGroup||d.styledMode||(b.shadowGroup=a.g("shadow").attr({zIndex:-1}).add(b.group));b.points.forEach(function(g){var t={};h=g.graphic;if(!g.isNull&&h){m=g.shapeArgs;c=g.getTranslate();if(!d.styledMode){var n=g.shadowGroup;l&&!n&&(n=g.shadowGroup=a.g("shadow").add(b.shadowGroup));n&&n.attr(c);e=b.pointAttribs(g,g.selected&&"select")}g.delayedRendering?(h.setRadialReference(b.center).attr(m).attr(c),d.styledMode||
h.attr(e).attr({"stroke-linejoin":"round"}).shadow(l,n),g.delayedRendering=!1):(h.setRadialReference(b.center),d.styledMode||r(!0,t,e),r(!0,t,m,c),h.animate(t));h.attr({visibility:g.visible?"inherit":"hidden"});h.addClass(g.getClassName())}else h&&(g.graphic=h.destroy())})},drawPoints:function(){var b=this.chart.renderer;this.points.forEach(function(c){c.graphic||(c.graphic=b[c.shapeType](c.shapeArgs).add(c.series.group),c.delayedRendering=!0)})},searchPoint:K,sortByAngle:function(b,c){b.sort(function(a,
b){return void 0!==a.angle&&(b.angle-a.angle)*c})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,getCenter:p.getCenter,getSymbol:K},{init:function(){D.prototype.init.apply(this,arguments);var b=this;b.name=v(b.name,"Slice");var c=function(a){b.slice("select"===a.type)};F(b,"select",c);F(b,"unselect",c);return b},isValid:function(){return G(this.y)&&0<=this.y},setVisible:function(b,c){var a=this,d=a.series,h=d.chart,e=d.options.ignoreHiddenPoint;c=v(c,e);b!==a.visible&&(a.visible=a.options.visible=
b=void 0===b?!a.visible:b,d.options.data[d.data.indexOf(a)]=a.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(c){if(a[c])a[c][b?"show":"hide"](!0)}),a.legendItem&&h.legend.colorizeItem(a,b),b||"hover"!==a.state||a.setState(""),e&&(d.isDirty=!0),c&&h.redraw())},slice:function(b,c,a){var d=this.series;l(a,d.chart);v(c,!0);this.sliced=this.options.sliced=y(b)?b:!this.sliced;d.options.data[d.data.indexOf(this)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&
this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(b){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+b,c.r+b,{innerR:c.r-1,start:c.start,end:c.end})},connectorShapes:{fixedOffset:function(b,c,a){var d=c.breakAt;c=c.touchingSliceAt;return["M",b.x,b.y].concat(a.softConnector?["C",b.x+("left"===b.alignment?-5:5),b.y,2*d.x-c.x,2*d.y-
c.y,d.x,d.y]:["L",d.x,d.y]).concat(["L",c.x,c.y])},straight:function(b,c){c=c.touchingSliceAt;return["M",b.x,b.y,"L",c.x,c.y]},crookedLine:function(b,d,a){d=d.touchingSliceAt;var g=this.series,h=g.center[0],e=g.chart.plotWidth,m=g.chart.plotLeft;g=b.alignment;var l=this.shapeArgs.r;a=c.relativeLength(a.crookDistance,1);a="left"===g?h+l+(e+m-h-l)*(1-a):m+(h-l)*a;h=["L",a,b.y];if("left"===g?a>b.x||a<d.x:a<b.x||a>d.x)h=[];return["M",b.x,b.y].concat(h).concat(["L",d.x,d.y])}},getConnectorPath:function(){var b=
this.labelPosition,c=this.series.options.dataLabels,a=c.connectorShape,g=this.connectorShapes;g[a]&&(a=g[a]);return a.call(this,{x:b.final.x,y:b.final.y,alignment:b.alignment},b.connectorPosition,c)}});""});M(J,"parts/DataLabels.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isArray,F=p.objectEach,z=p.splat,r=c.arrayMax,K=c.extend,v=c.format,D=c.merge;p=c.noop;var w=c.pick,n=c.relativeLength,l=c.Series,b=c.seriesTypes,d=c.stableSort;c.distribute=function(a,b,
h){function e(a,b){return a.target-b.target}var g,l=!0,n=a,t=[];var p=0;var k=n.reducedLen||b;for(g=a.length;g--;)p+=a[g].size;if(p>k){d(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(p=g=0;p<=k;)p+=a[g].size,g++;t=a.splice(g-1,a.length)}d(a,e);for(a=a.map(function(a){return{size:a.size,targets:[a.target],align:w(a.align,.5)}});l;){for(g=a.length;g--;)l=a[g],p=(Math.min.apply(0,l.targets)+Math.max.apply(0,l.targets))/2,l.pos=Math.min(Math.max(0,p-l.size*l.align),b-l.size);g=a.length;for(l=!1;g--;)0<
g&&a[g-1].pos+a[g-1].size>a[g].pos&&(a[g-1].size+=a[g].size,a[g-1].targets=a[g-1].targets.concat(a[g].targets),a[g-1].align=.5,a[g-1].pos+a[g-1].size>b&&(a[g-1].pos=b-a[g-1].size),a.splice(g,1),l=!0)}n.push.apply(n,t);g=0;a.some(function(a){var d=0;if(a.targets.some(function(){n[g].pos=a.pos+d;if(Math.abs(n[g].pos-n[g].target)>h)return n.slice(0,g+1).forEach(function(a){delete a.pos}),n.reducedLen=(n.reducedLen||b)-.1*b,n.reducedLen>.1*b&&c.distribute(n,b,h),!0;d+=n[g].size;g++}))return!0});d(n,e)};
l.prototype.drawDataLabels=function(){function a(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,">"===b&&a>c||"<"===b&&a<c||">="===b&&a>=c||"<="===b&&a<=c||"=="===b&&a==c||"==="===b&&a===c?!0:!1):!0}function b(a,b){var c=[],d;if(G(a)&&!G(b))c=a.map(function(a){return D(a,b)});else if(G(b)&&!G(a))c=b.map(function(b){return D(a,b)});else if(G(a)||G(b))for(d=Math.max(a.length,b.length);d--;)c[d]=D(a[d],b[d]);else c=D(a,b);return c}var d=this,e=d.chart,l=d.options,n=l.dataLabels,
p=d.points,t,r=d.hasRendered||0,k=c.animObject(l.animation).duration,A=Math.min(k,200),B=!e.renderer.forExport&&w(n.defer,0<A),H=e.renderer;n=b(b(e.options.plotOptions&&e.options.plotOptions.series&&e.options.plotOptions.series.dataLabels,e.options.plotOptions&&e.options.plotOptions[d.type]&&e.options.plotOptions[d.type].dataLabels),n);c.fireEvent(this,"drawDataLabels");if(G(n)||n.enabled||d._hasPointLabels){var q=d.plotGroup("dataLabelsGroup","data-labels",B&&!r?"hidden":"inherit",n.zIndex||6);B&&
(q.attr({opacity:+r}),r||setTimeout(function(){var a=d.dataLabelsGroup;a&&(d.visible&&q.show(!0),a[l.animation?"animate":"attr"]({opacity:1},{duration:A}))},k-A));p.forEach(function(c){t=z(b(n,c.dlOptions||c.options&&c.options.dataLabels));t.forEach(function(b,f){var g=b.enabled&&(!c.isNull||c.dataLabelOnNull)&&a(c,b),k=c.dataLabels?c.dataLabels[f]:c.dataLabel,h=c.connectors?c.connectors[f]:c.connector,m=w(b.distance,c.labelDistance),t=!k;if(g){var n=c.getLabelConfig();var p=w(b[c.formatPrefix+"Format"],
b.format);n=y(p)?v(p,n,e.time):(b[c.formatPrefix+"Formatter"]||b.formatter).call(n,b);p=b.style;var u=b.rotation;e.styledMode||(p.color=w(b.color,p.color,d.color,"#000000"),"contrast"===p.color&&(c.contrastColor=H.getContrast(c.color||d.color),p.color=!y(m)&&b.inside||0>m||l.stacking?c.contrastColor:"#000000"),l.cursor&&(p.cursor=l.cursor));var r={r:b.borderRadius||0,rotation:u,padding:b.padding,zIndex:1};e.styledMode||(r.fill=b.backgroundColor,r.stroke=b.borderColor,r["stroke-width"]=b.borderWidth);
F(r,function(a,b){void 0===a&&delete r[b]})}!k||g&&y(n)?g&&y(n)&&(k?r.text=n:(c.dataLabels=c.dataLabels||[],k=c.dataLabels[f]=u?H.text(n,0,-9999).addClass("highcharts-data-label"):H.label(n,0,-9999,b.shape,null,null,b.useHTML,null,"data-label"),f||(c.dataLabel=k),k.addClass(" highcharts-data-label-color-"+c.colorIndex+" "+(b.className||"")+(b.useHTML?" highcharts-tracker":""))),k.options=b,k.attr(r),e.styledMode||k.css(p).shadow(b.shadow),k.added||k.add(q),b.textPath&&!b.useHTML&&k.setTextPath(c.getDataLabelPath&&
c.getDataLabelPath(k)||c.graphic,b.textPath),d.alignDataLabel(c,k,b,null,t)):(c.dataLabel=c.dataLabel&&c.dataLabel.destroy(),c.dataLabels&&(1===c.dataLabels.length?delete c.dataLabels:delete c.dataLabels[f]),f||delete c.dataLabel,h&&(c.connector=c.connector.destroy(),c.connectors&&(1===c.connectors.length?delete c.connectors:delete c.connectors[f])))})})}c.fireEvent(this,"afterDrawDataLabels")};l.prototype.alignDataLabel=function(a,b,c,d,l){var e=this.chart,g=this.isCartesian&&e.inverted,h=w(a.dlBox&&
a.dlBox.centerX,a.plotX,-9999),m=w(a.plotY,-9999),k=b.getBBox(),n=c.rotation,p=c.align,r=this.visible&&(a.series.forceDL||e.isInsidePlot(h,Math.round(m),g)||d&&e.isInsidePlot(h,g?d.x+1:d.y+d.height-1,g)),q="justify"===w(c.overflow,"justify");if(r){var f=e.renderer.fontMetrics(e.styledMode?void 0:c.style.fontSize,b).b;d=K({x:g?this.yAxis.len-m:h,y:Math.round(g?this.xAxis.len-h:m),width:0,height:0},d);K(c,{width:k.width,height:k.height});n?(q=!1,h=e.renderer.rotCorr(f,n),h={x:d.x+c.x+d.width/2+h.x,
y:d.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*d.height},b[l?"attr":"animate"](h).attr({align:p}),m=(n+720)%360,m=180<m&&360>m,"left"===p?h.y-=m?k.height:0:"center"===p?(h.x-=k.width/2,h.y-=k.height/2):"right"===p&&(h.x-=k.width,h.y-=m?0:k.height),b.placed=!0,b.alignAttr=h):(b.align(c,null,d),h=b.alignAttr);q&&0<=d.height?this.justifyDataLabel(b,c,h,k,d,l):w(c.crop,!0)&&(r=e.isInsidePlot(h.x,h.y)&&e.isInsidePlot(h.x+k.width,h.y+k.height));if(c.shape&&!n)b[l?"attr":"animate"]({anchorX:g?e.plotWidth-
a.plotY:a.plotX,anchorY:g?e.plotHeight-a.plotX:a.plotY})}r||(b.hide(!0),b.placed=!1)};l.prototype.justifyDataLabel=function(a,b,c,d,l,n){var e=this.chart,g=b.align,h=b.verticalAlign,k=a.box?0:a.padding||0;var m=c.x+k;if(0>m){"right"===g?(b.align="left",b.inside=!0):b.x=-m;var p=!0}m=c.x+d.width-k;m>e.plotWidth&&("left"===g?(b.align="right",b.inside=!0):b.x=e.plotWidth-m,p=!0);m=c.y+k;0>m&&("bottom"===h?(b.verticalAlign="top",b.inside=!0):b.y=-m,p=!0);m=c.y+d.height-k;m>e.plotHeight&&("top"===h?(b.verticalAlign=
"bottom",b.inside=!0):b.y=e.plotHeight-m,p=!0);p&&(a.placed=!n,a.align(b,null,l));return p};b.pie&&(b.pie.prototype.dataLabelPositioners={radialDistributionY:function(a){return a.top+a.distributeBox.pos},radialDistributionX:function(a,b,c,d){return a.getX(c<b.top+2||c>b.bottom-2?d:c,b.half,b)},justify:function(a,b,c){return c[0]+(a.half?-1:1)*(b+a.labelDistance)},alignToPlotEdges:function(a,b,c,d){a=a.getBBox().width;return b?a+d:c-a-d},alignToConnectors:function(a,b,c,d){var e=0,g;a.forEach(function(a){g=
a.dataLabel.getBBox().width;g>e&&(e=g)});return b?e+d:c-e-d}},b.pie.prototype.drawDataLabels=function(){var a=this,b=a.data,d,e=a.chart,m=a.options.dataLabels,n=m.connectorPadding,p,t=e.plotWidth,x=e.plotHeight,k=e.plotLeft,A=Math.round(e.chartWidth/3),v,z=a.center,q=z[2]/2,f=z[1],C,F,K,G,J=[[],[]],L,I,M,Q,O=[0,0,0,0],U=a.dataLabelPositioners,W;a.visible&&(m.enabled||a._hasPointLabels)&&(b.forEach(function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",
textOverflow:"clip"}),a.dataLabel.shortened=!1)}),l.prototype.drawDataLabels.apply(a),b.forEach(function(a){a.dataLabel&&(a.visible?(J[a.half].push(a),a.dataLabel._pos=null,!y(m.style.width)&&!y(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>A&&(a.dataLabel.css({width:.7*A}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),J.forEach(function(b,g){var h=b.length,
l=[],p;if(h){a.sortByAngle(b,g-.5);if(0<a.maxLabelDistance){var r=Math.max(0,f-q-a.maxLabelDistance);var u=Math.min(f+q+a.maxLabelDistance,e.plotHeight);b.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,f-q-a.labelDistance),a.bottom=Math.min(f+q+a.labelDistance,e.plotHeight),p=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+p/2,size:p,rank:a.y},l.push(a.distributeBox))});r=u+p-r;c.distribute(l,r,r/5)}for(Q=0;Q<h;Q++){d=b[Q];K=d.labelPosition;
C=d.dataLabel;M=!1===d.visible?"hidden":"inherit";I=r=K.natural.y;l&&y(d.distributeBox)&&(void 0===d.distributeBox.pos?M="hidden":(G=d.distributeBox.size,I=U.radialDistributionY(d)));delete d.positionIndex;if(m.justify)L=U.justify(d,q,z);else switch(m.alignTo){case "connectors":L=U.alignToConnectors(b,g,t,k);break;case "plotEdges":L=U.alignToPlotEdges(C,g,t,k);break;default:L=U.radialDistributionX(a,d,I,r)}C._attr={visibility:M,align:K.alignment};C._pos={x:L+m.x+({left:n,right:-n}[K.alignment]||0),
y:I+m.y-10};K.final.x=L;K.final.y=I;w(m.crop,!0)&&(F=C.getBBox().width,r=null,L-F<n&&1===g?(r=Math.round(F-L+n),O[3]=Math.max(r,O[3])):L+F>t-n&&0===g&&(r=Math.round(L+F-t+n),O[1]=Math.max(r,O[1])),0>I-G/2?O[0]=Math.max(Math.round(-I+G/2),O[0]):I+G/2>x&&(O[2]=Math.max(Math.round(I+G/2-x),O[2])),C.sideOverflow=r)}}}),0===r(O)||this.verifyDataLabelOverflow(O))&&(this.placeDataLabels(),this.points.forEach(function(b){W=D(m,b.options.dataLabels);if(p=w(W.connectorWidth,1)){var c;v=b.connector;if((C=b.dataLabel)&&
C._pos&&b.visible&&0<b.labelDistance){M=C._attr.visibility;if(c=!v)b.connector=v=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+b.colorIndex+(b.className?" "+b.className:"")).add(a.dataLabelsGroup),e.styledMode||v.attr({"stroke-width":p,stroke:W.connectorColor||b.color||"#666666"});v[c?"attr":"animate"]({d:b.getConnectorPath()});v.attr("visibility",M)}else v&&(b.connector=v.destroy())}}))},b.pie.prototype.placeDataLabels=function(){this.points.forEach(function(a){var b=
a.dataLabel,c;b&&a.visible&&((c=b._pos)?(b.sideOverflow&&(b._attr.width=Math.max(b.getBBox().width-b.sideOverflow,0),b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](c),b.moved=!0):b&&b.attr({y:-9999}));delete a.distributeBox},this)},b.pie.prototype.alignDataLabel=p,b.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,l=c.minSize||80,p=null!==
c.size;if(!p){if(null!==d[0])var r=Math.max(b[2]-Math.max(a[1],a[3]),l);else r=Math.max(b[2]-a[1]-a[3],l),b[0]+=(a[3]-a[1])/2;null!==d[1]?r=Math.max(Math.min(r,b[2]-Math.max(a[0],a[2])),l):(r=Math.max(Math.min(r,b[2]-a[0]-a[2]),l),b[1]+=(a[0]-a[2])/2);r<b[2]?(b[2]=r,b[3]=Math.min(n(c.innerSize||0,r),r),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):p=!0}return p});b.column&&(b.column.prototype.alignDataLabel=function(a,b,c,d,m){var e=this.chart.inverted,g=a.series,h=a.dlBox||a.shapeArgs,
n=w(a.below,a.plotY>w(this.translatedThreshold,g.yAxis.len)),k=w(c.inside,!!this.options.stacking);h&&(d=D(h),0>d.y&&(d.height+=d.y,d.y=0),h=d.y+d.height-g.yAxis.len,0<h&&(d.height-=h),e&&(d={x:g.yAxis.len-d.y-d.height,y:g.xAxis.len-d.x-d.width,width:d.height,height:d.width}),k||(e?(d.x+=n?0:d.width,d.width=0):(d.y+=n?d.height:0,d.height=0)));c.align=w(c.align,!e||k?"center":n?"right":"left");c.verticalAlign=w(c.verticalAlign,e||k?"middle":n?"top":"bottom");l.prototype.alignDataLabel.call(this,a,
b,c,d,m);c.inside&&a.contrastColor&&b.css({color:a.contrastColor})})});M(J,"modules/overlapping-datalabels.src.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.isArray,G=p.objectEach;p=c.Chart;var F=c.pick,z=c.addEvent,r=c.fireEvent;z(p,"render",function(){var c=[];(this.labelCollectors||[]).forEach(function(p){c=c.concat(p())});(this.yAxis||[]).forEach(function(p){p.options.stackLabels&&!p.options.stackLabels.allowOverlap&&G(p.stacks,function(p){G(p,function(p){c.push(p.label)})})});
(this.series||[]).forEach(function(p){var r=p.options.dataLabels;p.visible&&(!1!==r.enabled||p._hasPointLabels)&&p.points.forEach(function(p){p.visible&&(y(p.dataLabels)?p.dataLabels:p.dataLabel?[p.dataLabel]:[]).forEach(function(n){var l=n.options;n.labelrank=F(l.labelrank,p.labelrank,p.shapeArgs&&p.shapeArgs.height);l.allowOverlap||c.push(n)})})});this.hideOverlappingLabels(c)});p.prototype.hideOverlappingLabels=function(c){var p=this,y=c.length,w=p.renderer,n,l,b;var d=function(a){var b=a.box?
0:a.padding||0;var c=0;if(a&&(!a.alignAttr||a.placed)){var d=a.alignAttr||{x:a.attr("x"),y:a.attr("y")};var g=a.parentGroup;a.width||(c=a.getBBox(),a.width=c.width,a.height=c.height,c=w.fontMetrics(null,a.element).h);return{x:d.x+(g.translateX||0)+b,y:d.y+(g.translateY||0)+b-c,width:a.width-2*b,height:a.height-2*b}}};for(l=0;l<y;l++)if(n=c[l])n.oldOpacity=n.opacity,n.newOpacity=1,n.absoluteBox=d(n);c.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(l=0;l<y;l++){var a=(d=c[l])&&d.absoluteBox;
for(n=l+1;n<y;++n){var g=(b=c[n])&&b.absoluteBox;!a||!g||d===b||0===d.newOpacity||0===b.newOpacity||g.x>a.x+a.width||g.x+g.width<a.x||g.y>a.y+a.height||g.y+g.height<a.y||((d.labelrank<b.labelrank?d:b).newOpacity=0)}}c.forEach(function(a){var b;if(a){var c=a.newOpacity;a.oldOpacity!==c&&(a.alignAttr&&a.placed?(c?a.show(!0):b=function(){a.hide(!0);a.placed=!1},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b),r(p,"afterHideOverlappingLabels")):a.attr({opacity:c}));a.isOld=!0}})}});
M(J,"parts/Interaction.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.defined,G=p.isArray,F=p.isObject,z=p.objectEach,r=c.addEvent;p=c.Chart;var K=c.createElement,v=c.css,D=c.defaultOptions,w=c.defaultPlotOptions,n=c.extend,l=c.fireEvent,b=c.hasTouch,d=c.Legend,a=c.merge,g=c.pick,h=c.Point,e=c.Series,m=c.seriesTypes,u=c.svg;var E=c.TrackerMixin={drawTrackerPoint:function(){var a=this,c=a.chart,d=c.pointer,e=function(a){var b=d.getPointFromEvent(a);void 0!==b&&(d.isDirectTouch=
!0,b.onMouseOver(a))},g;a.points.forEach(function(a){g=G(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);g.forEach(function(b){b.div?b.div.point=a:b.element.point=a})});a._hasTracking||(a.trackerGroups.forEach(function(g){if(a[g]){a[g].addClass("highcharts-tracker").on("mouseover",e).on("mouseout",function(a){d.onTrackerMouseOut(a)});if(b)a[g].on("touchstart",e);!c.styledMode&&a.options.cursor&&a[g].css(v).css({cursor:a.options.cursor})}}),a._hasTracking=
!0);l(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,c=a.options,d=c.trackByArea,e=[].concat(d?a.areaPath:a.graphPath),g=e.length,h=a.chart,m=h.pointer,f=h.renderer,n=h.options.tooltip.snap,p=a.tracker,r,w=function(){if(h.hoverSeries!==a)a.onMouseOver()},v="rgba(192,192,192,"+(u?.0001:.002)+")";if(g&&!d)for(r=g+1;r--;)"M"===e[r]&&e.splice(r+1,0,e[r+1]-n,e[r+2],"L"),(r&&"M"===e[r]||r===g)&&e.splice(r,0,"L",e[r-2]+n,e[r-1]);p?p.attr({d:e}):a.graph&&(a.tracker=f.path(e).attr({visibility:a.visible?
"visible":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),h.styledMode||a.tracker.attr({"stroke-linejoin":"round",stroke:v,fill:d?v:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",w).on("mouseout",function(a){m.onTrackerMouseOut(a)});c.cursor&&!h.styledMode&&a.css({cursor:c.cursor});if(b)a.on("touchstart",w)}));l(this,"afterDrawTracker")}};m.column&&
(m.column.prototype.drawTracker=E.drawTrackerPoint);m.pie&&(m.pie.prototype.drawTracker=E.drawTrackerPoint);m.scatter&&(m.scatter.prototype.drawTracker=E.drawTrackerPoint);n(d.prototype,{setItemEvents:function(b,c,d){var e=this,g=e.chart.renderer.boxWrapper,k=b instanceof h,m="highcharts-legend-"+(k?"point":"series")+"-active",f=e.chart.styledMode;(d?c:b.legendGroup).on("mouseover",function(){b.visible&&e.allItems.forEach(function(a){b!==a&&a.setState("inactive",!k)});b.setState("hover");b.visible&&
g.addClass(m);f||c.css(e.options.itemHoverStyle)}).on("mouseout",function(){e.chart.styledMode||c.css(a(b.visible?e.itemStyle:e.itemHiddenStyle));e.allItems.forEach(function(a){b!==a&&a.setState("",!k)});g.removeClass(m);b.setState()}).on("click",function(a){var c=function(){b.setVisible&&b.setVisible();e.allItems.forEach(function(a){b!==a&&a.setState(b.visible?"inactive":"",!k)})};g.removeClass(m);a={browserEvent:a};b.firePointEvent?b.firePointEvent("legendItemClick",a,c):l(b,"legendItemClick",a,
c)})},createCheckboxForItem:function(a){a.checkbox=K("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);r(a.checkbox,"click",function(b){l(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});n(p.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=D.lang,d=b.options.chart.resetZoomButton,e=d.theme,g=e.states,h="chart"===d.relativeTo||
"spaceBox"===d.relativeTo?null:"plotBox";l(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,g&&g.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,h)});l(this,"afterShowResetZoom")},zoomOut:function(){l(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b=this,c,d=b.pointer,e=!1,h=b.inverted?d.mouseDownX:d.mouseDownY;!a||a.resetSelection?(b.axes.forEach(function(a){c=
a.zoom()}),d.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var f=a.axis,g=b.inverted?f.left:f.top,k=b.inverted?g+f.width:g+f.height,l=f.isXAxis,m=!1;if(!l&&h>=g&&h<=k||l||!y(h))m=!0;d[l?"zoomX":"zoomY"]&&m&&(c=f.zoom(a.min,a.max),f.displayBtn&&(e=!0))});var l=b.resetZoomButton;e&&!l?b.showResetZoom():!e&&F(l)&&(b.resetZoomButton=l.destroy());c&&b.redraw(g(b.options.chart.animation,a&&a.animation,100>b.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;l(this,"pan",{originalEvent:a},
function(){d&&d.forEach(function(a){a.setState()});("xy"===b?[1,0]:[1]).forEach(function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"];d=d?"mouseDownX":"mouseDownY";var g=c[d],k=(b.pointRange||0)/2,h=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),m=b.toValue(g-f,!0)+k*h;h=b.toValue(g+b.len-f,!0)-k*h;var n=h<m;g=n?h:m;m=n?m:h;h=Math.min(l.dataMin,k?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding));k=Math.max(l.dataMax,k?l.max:b.toValue(b.toPixels(l.max)+
b.minPixelPadding));n=h-g;0<n&&(m+=n,g=h);n=m-k;0<n&&(m=k,g-=n);b.series.length&&g!==l.min&&m!==l.max&&(b.setExtremes(g,m,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);v(c.container,{cursor:"move"})})}});n(h.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart;this.selectedStaging=a=g(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[d.data.indexOf(c)]=c.options;c.setState(a&&"select");b||e.getSelectedPoints().forEach(function(a){var b=
a.series;a.selected&&a!==c&&(a.selected=a.options.selected=!1,b.options.data[b.data.indexOf(a)]=a.options,a.setState(e.hoverPoints&&b.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||
(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,d=a(b.series.options.point,b.options).events;b.events=d;z(d,function(a,d){c.isFunction(a)&&r(b,d,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=this.series,d=this.state,e=c.options.states[a||"normal"]||{},h=w[c.type].marker&&c.options.marker,m=h&&!1===h.enabled,f=h&&h.states&&h.states[a||"normal"]||{},p=!1===f.enabled,r=c.stateMarkerGraphic,
t=this.marker||{},u=c.chart,x=c.halo,v,y=h&&c.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===e.enabled||a&&(p||m&&!1===f.enabled)||a&&t.states&&t.states[a]&&!1===t.states[a].enabled)){this.state=a;y&&(v=c.markerAttribs(this,a));if(this.graphic){d&&this.graphic.removeClass("highcharts-point-"+d);a&&this.graphic.addClass("highcharts-point-"+a);if(!u.styledMode){var z=c.pointAttribs(this,a);var D=g(u.options.chart.animation,e.animation);c.options.inactiveOtherPoints&&
((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:z.opacity},D)}),this.connector&&this.connector.animate({opacity:z.opacity},D));this.graphic.animate(z,D)}v&&this.graphic.animate(v,g(u.options.chart.animation,f.animation,h.animation));r&&r.hide()}else{if(a&&f){d=t.symbol||c.symbol;r&&r.currentSymbol!==d&&(r=r.destroy());if(r)r[b?"animate":"attr"]({x:v.x,y:v.y});else d&&(c.stateMarkerGraphic=r=u.renderer.symbol(d,v.x,v.y,v.width,v.height).add(c.markerGroup),r.currentSymbol=d);!u.styledMode&&
r&&r.attr(c.pointAttribs(this,a))}r&&(r[a&&this.isInside?"show":"hide"](),r.element.point=this)}a=e.halo;e=(r=this.graphic||r)&&r.visibility||"inherit";a&&a.size&&"hidden"!==e?(x||(c.halo=x=u.renderer.path().add(r.parentGroup)),x.show()[b?"animate":"attr"]({d:this.haloPath(a.size)}),x.attr({"class":"highcharts-halo highcharts-color-"+g(this.colorIndex,c.colorIndex)+(this.className?" "+this.className:""),visibility:e,zIndex:-1}),x.point=this,u.styledMode||x.attr(n({fill:this.color||c.color,"fill-opacity":a.opacity},
a.attributes))):x&&x.point&&x.point.haloPath&&x.animate({d:x.point.haloPath(0)},null,x.hide);l(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});n(e.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&l(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=
b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&l(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();b.series.forEach(function(a){a.setState("",!0)})},setState:function(a,b){var c=this,d=c.options,e=c.graph,h=d.inactiveOtherPoints,l=d.states,f=d.lineWidth,m=d.opacity,n=g(l[a||"normal"]&&l[a||"normal"].animation,c.chart.options.chart.animation);d=0;a=a||"";if(c.state!==a&&([c.group,c.markerGroup,c.dataLabelsGroup].forEach(function(b){b&&
(c.state&&b.removeClass("highcharts-series-"+c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!c.chart.styledMode)){if(l[a]&&!1===l[a].enabled)return;a&&(f=l[a].lineWidth||f+(l[a].lineWidthPlus||0),m=g(l[a].opacity,m));if(e&&!e.dashstyle)for(l={"stroke-width":f},e.animate(l,n);c["zone-graph-"+d];)c["zone-graph-"+d].attr(l),d+=1;h||[c.group,c.markerGroup,c.dataLabelsGroup,c.labelBySeries].forEach(function(a){a&&a.animate({opacity:m},n)})}b&&h&&c.points&&c.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(b){b.setState&&
b.setState(a)})},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,g=d.options.chart.ignoreHiddenSeries,h=c.visible;var f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!h:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&d.series.forEach(function(a){a.options.stacking&&
a.visible&&(a.isDirty=!0)});c.linkedSeries.forEach(function(b){b.setVisible(a,!1)});g&&(d.isDirtyBox=!0);l(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);l(this,a?"select":"unselect")},drawTracker:E.drawTrackerGraph})});M(J,"parts/Responsive.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=p.isArray,
G=p.isObject,F=p.objectEach,z=p.splat;p=c.Chart;var r=c.pick;p.prototype.setResponsive=function(p,r){var v=this.options.responsive,w=[],n=this.currentResponsive;!r&&v&&v.rules&&v.rules.forEach(function(l){void 0===l._id&&(l._id=c.uniqueKey());this.matchResponsiveRule(l,w)},this);r=c.merge.apply(0,w.map(function(l){return c.find(v.rules,function(b){return b._id===l}).chartOptions}));r.isResponsiveOptions=!0;w=w.toString()||void 0;w!==(n&&n.ruleIds)&&(n&&this.update(n.undoOptions,p,!0),w?(n=this.currentOptions(r),
n.isResponsiveOptions=!0,this.currentResponsive={ruleIds:w,mergedOptions:r,undoOptions:n},this.update(r,p,!0)):this.currentResponsive=void 0)};p.prototype.matchResponsiveRule=function(c,p){var v=c.condition;(v.callback||function(){return this.chartWidth<=r(v.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=r(v.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=r(v.minWidth,0)&&this.chartHeight>=r(v.minHeight,0)}).call(this)&&p.push(c._id)};p.prototype.currentOptions=function(c){function p(c,l,b,d){var a;
F(c,function(c,h){if(!d&&-1<r.collectionsWithUpdate.indexOf(h))for(c=z(c),b[h]=[],a=0;a<c.length;a++)l[h][a]&&(b[h][a]={},p(c[a],l[h][a],b[h][a],d+1));else G(c)?(b[h]=y(c)?[]:{},p(c,l[h]||{},b[h],d+1)):b[h]=void 0===l[h]?null:l[h]})}var r=this,w={};p(c,this.options,w,0);return w}});M(J,"masters/highcharts.src.js",[J["parts/Globals.js"],J["parts/Utilities.js"]],function(c,p){var y=c.extend;y(c,{defined:p.defined,erase:p.erase,isArray:p.isArray,isClass:p.isClass,isDOMElement:p.isDOMElement,isNumber:p.isNumber,
isObject:p.isObject,isString:p.isString,objectEach:p.objectEach,pInt:p.pInt,splat:p.splat});return c});J["masters/highcharts.src.js"]._modules=J;return J["masters/highcharts.src.js"]});
//# sourceMappingURL=highcharts.js.map
/*
 Highcharts JS v7.1.3 (2019-08-14)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(r){"object"===typeof module&&module.exports?(r["default"]=r,module.exports=r):"function"===typeof define&&define.amd?define("highcharts/highcharts-more",["highcharts"],function(z){r(z);r.Highcharts=z;return r}):r("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(r){function z(c,b,m,g){c.hasOwnProperty(b)||(c[b]=g.apply(null,m))}r=r?r._modules:{};z(r,"parts-more/Pane.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){function m(a,d){this.init(a,d)}var g=b.splat,
l=c.CenteredSeriesMixin,a=c.extend,f=c.merge;a(m.prototype,{coll:"pane",init:function(a,d){this.chart=d;this.background=[];d.pane.push(this);this.setOptions(a)},setOptions:function(a){this.options=f(this.defaultOptions,this.chart.angular?{background:{}}:void 0,a)},render:function(){var a=this.options,d=this.options.background,c=this.chart.renderer;this.group||(this.group=c.g("pane-group").attr({zIndex:a.zIndex||0}).add());this.updateCenter();if(d)for(d=g(d),a=Math.max(d.length,this.background.length||
0),c=0;c<a;c++)d[c]&&this.axis?this.renderBackground(f(this.defaultBackgroundOptions,d[c]),c):this.background[c]&&(this.background[c]=this.background[c].destroy(),this.background.splice(c,1))},renderBackground:function(c,d){var f="animate",b={"class":"highcharts-pane "+(c.className||"")};this.chart.styledMode||a(b,{fill:c.backgroundColor,stroke:c.borderColor,"stroke-width":c.borderWidth});this.background[d]||(this.background[d]=this.chart.renderer.path().add(this.group),f="attr");this.background[d][f]({d:this.axis.getPlotBandPath(c.from,
c.to,c)}).attr(b)},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},updateCenter:function(a){this.center=(a||this.axis||{}).center=l.getCenter.call(this)},update:function(a,d){f(!0,this.options,a);f(!0,this.chart.options.pane,a);this.setOptions(this.options);
this.render();this.chart.axes.forEach(function(a){a.pane===this&&(a.pane=null,a.update({},d))},this)}});c.Pane=m});z(r,"parts-more/RadialAxis.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.pInt;b=c.addEvent;var g=c.Axis,l=c.extend,a=c.merge,f=c.noop,u=c.pick,d=c.Tick,v=c.wrap,n=c.correctFloat,w=g.prototype,q=d.prototype;var t={getOffset:f,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},setScale:f,setCategories:f,setTitle:f};var e={defaultRadialGaugeOptions:{labels:{align:"center",
x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null,style:{textOverflow:"none"}},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},
setOptions:function(h){h=this.options=a(this.defaultOptions,this.defaultRadialOptions,h);h.plotBands||(h.plotBands=[]);c.fireEvent(this,"afterSetOptions")},getOffset:function(){w.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(h,e){h=this.center;var k=this.chart,p=u(e,h[2]/2-this.offset);this.isCircular||void 0!==e?(e=this.chart.renderer.symbols.arc(this.left+h[0],this.top+h[1],p,p,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0}),e.xBounds=[this.left+
h[0]],e.yBounds=[this.top+h[1]-p]):(e=this.postTranslate(this.angleRad,p),e=["M",h[0]+k.plotLeft,h[1]+k.plotTop,"L",e.x,e.y]);return e},setAxisTranslation:function(){w.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=this.isCircular&&void 0===u(this.userMax,
this.options.max)&&n(this.endAngleRad-this.startAngleRad)===n(2*Math.PI))this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){w.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*u(this.sector,1)/2)},getPosition:function(h,e){return this.postTranslate(this.isCircular?this.translate(h):this.angleRad,u(this.isCircular?e:this.translate(h),
this.center[2]/2)-this.offset)},postTranslate:function(h,e){var k=this.chart,p=this.center;h=this.startAngleRad+h;return{x:k.plotLeft+p[0]+Math.cos(h)*e,y:k.plotTop+p[1]+Math.sin(h)*e}},getPlotBandPath:function(h,e,k){var p=this.center,a=this.startAngleRad,y=p[2]/2,d=[u(k.outerRadius,"100%"),k.innerRadius,u(k.thickness,10)],c=Math.min(this.offset,0),f=/%$/;var b=this.isCircular;if("polygon"===this.options.gridLineInterpolation)d=this.getPlotLinePath({value:h}).concat(this.getPlotLinePath({value:e,
reverse:!0}));else{h=Math.max(h,this.min);e=Math.min(e,this.max);b||(d[0]=this.translate(h),d[1]=this.translate(e));d=d.map(function(k){f.test(k)&&(k=m(k,10)*y/100);return k});if("circle"!==k.shape&&b)h=a+this.translate(h),e=a+this.translate(e);else{h=-Math.PI/2;e=1.5*Math.PI;var q=!0}d[0]-=c;d[2]-=c;d=this.chart.renderer.symbols.arc(this.left+p[0],this.top+p[1],d[0],d[0],{start:Math.min(h,e),end:Math.max(h,e),innerR:u(d[1],d[0]-d[2]),open:q});b&&(b=(e+h)/2,c=this.left+p[0]+p[2]/2*Math.cos(b),d.xBounds=
b>-Math.PI/2&&b<Math.PI/2?[c,this.chart.plotWidth]:[0,c],d.yBounds=[this.top+p[1]+p[2]/2*Math.sin(b)],d.yBounds[0]+=b>-Math.PI&&0>b||b>Math.PI?-10:10)}return d},getPlotLinePath:function(e){var h=this,k=h.center,p=h.chart,a=e.value;e=e.reverse;var d=h.getPosition(a),c,b;if(h.isCircular)var f=["M",k[0]+p.plotLeft,k[1]+p.plotTop,"L",d.x,d.y];else"circle"===h.options.gridLineInterpolation?(a=h.translate(a),f=h.getLinePath(0,a)):(p.xAxis.forEach(function(k){k.pane===h.pane&&(c=k)}),f=[],a=h.translate(a),
k=c.tickPositions,c.autoConnect&&(k=k.concat([k[0]])),e&&(k=[].concat(k).reverse()),k.forEach(function(k,e){b=c.getPosition(k,a);f.push(e?"L":"M",b.x,b.y)}));return f},getTitlePosition:function(){var e=this.center,a=this.chart,k=this.options.title;return{x:a.plotLeft+e[0]+(k.x||0),y:a.plotTop+e[1]-{high:.5,middle:.25,low:0}[k.align]*e[2]+(k.y||0)}}};b(g,"init",function(h){var d=this,k=this.chart,p=k.angular,x=k.polar,c=this.isXAxis,b=p&&c,f,q=k.options;h=h.userOptions.pane||0;h=this.pane=k.pane&&
k.pane[h];if(p){if(l(this,b?t:e),f=!c)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else x&&(l(this,e),this.defaultRadialOptions=(f=c)?this.defaultRadialXOptions:a(this.defaultYAxisOptions,this.defaultRadialYOptions));p||x?(this.isRadial=!0,k.inverted=!1,q.chart.zoomType=null,k.labelCollectors.push(function(){if(d.isRadial&&d.tickPositions&&!0!==d.options.labels.allowOverlap)return d.tickPositions.map(function(k){return d.ticks[k]&&d.ticks[k].label}).filter(function(k){return!!k})})):this.isRadial=
!1;h&&f&&(h.axis=this);this.isCircular=f});b(g,"afterInit",function(){var e=this.chart,a=this.options,k=this.pane,p=k&&k.options;e.angular&&this.isXAxis||!k||!e.angular&&!e.polar||(this.angleRad=(a.angle||0)*Math.PI/180,this.startAngleRad=(p.startAngle-90)*Math.PI/180,this.endAngleRad=(u(p.endAngle,p.startAngle+360)-90)*Math.PI/180,this.offset=a.offset||0)});b(g,"autoLabelAlign",function(e){this.isRadial&&(e.align=void 0,e.preventDefault())});b(d,"afterGetPosition",function(e){this.axis.getPosition&&
l(e.pos,this.axis.getPosition(this.pos))});b(d,"afterGetLabelPosition",function(e){var h=this.axis,k=this.label,p=k.getBBox(),a=h.options.labels,d=a.y,b=20,f=a.align,q=(h.translate(this.pos)+h.startAngleRad+Math.PI/2)/Math.PI*180%360,g=Math.round(q),t="end",n=0>g?g+360:g,l=n,v=0,w=0,m=null===a.y?.3*-p.height:0;if(h.isRadial){var r=h.getPosition(this.pos,h.center[2]/2+c.relativeLength(u(a.distance,-25),h.center[2]/2,-h.center[2]/2));"auto"===a.rotation?k.attr({rotation:q}):null===d&&(d=h.chart.renderer.fontMetrics(k.styles&&
k.styles.fontSize).b-p.height/2);null===f&&(h.isCircular?(p.width>h.len*h.tickInterval/(h.max-h.min)&&(b=0),f=q>b&&q<180-b?"left":q>180+b&&q<360-b?"right":"center"):f="center",k.attr({align:f}));if("auto"===f&&2===h.tickPositions.length&&h.isCircular){90<n&&180>n?n=180-n:270<n&&360>=n&&(n=540-n);180<l&&360>=l&&(l=360-l);if(h.pane.options.startAngle===g||h.pane.options.startAngle===g+360||h.pane.options.startAngle===g-360)t="start";f=-90<=g&&90>=g||-360<=g&&-270>=g||270<=g&&360>=g?"start"===t?"right":
"left":"start"===t?"left":"right";70<l&&110>l&&(f="center");15>n||180<=n&&195>n?v=.3*p.height:15<=n&&35>=n?v="start"===t?0:.75*p.height:195<=n&&215>=n?v="start"===t?.75*p.height:0:35<n&&90>=n?v="start"===t?.25*-p.height:p.height:215<n&&270>=n&&(v="start"===t?p.height:.25*-p.height);15>l?w="start"===t?.15*-p.height:.15*p.height:165<l&&180>=l&&(w="start"===t?.15*p.height:.15*-p.height);k.attr({align:f});k.translate(w,v+m)}e.pos.x=r.x+a.x;e.pos.y=r.y+d}});v(q,"getMarkPath",function(e,a,k,p,d,c,b){var h=
this.axis;h.isRadial?(e=h.getPosition(this.pos,h.center[2]/2+p),a=["M",a,k,"L",e.x,e.y]):a=e.call(this,a,k,p,d,c,b);return a})});z(r,"parts-more/AreaRangeSeries.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.defined,g=b.isArray,l=b.isNumber,a=c.pick,f=c.extend;b=c.seriesType;var u=c.seriesTypes,d=c.Series.prototype,v=c.Point.prototype;b("arearange","area",{lineWidth:1,threshold:null,tooltip:{pointFormat:'<span style="color:{series.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},
trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},{pointArrayMap:["low","high"],pointValKey:"low",deferTranslatePolar:!0,toYData:function(a){return[a.low,a.high]},highToXY:function(a){var d=this.chart,c=this.xAxis.postTranslate(a.rectPlotX,this.yAxis.len-a.plotHigh);a.plotHighX=c.x-d.plotLeft;a.plotHigh=c.y-d.plotTop;a.plotLowX=a.plotX},translate:function(){var a=this,d=a.yAxis,c=!!a.modifyValue;u.area.prototype.translate.apply(a);a.points.forEach(function(b){var e=
b.high,h=b.plotY;b.isNull?b.plotY=null:(b.plotLow=h,b.plotHigh=d.translate(c?a.modifyValue(e,b):e,0,1,0,1),c&&(b.yBottom=b.plotHigh))});this.chart.polar&&this.points.forEach(function(d){a.highToXY(d);d.tooltipPos=[(d.plotHighX+d.plotLowX)/2,(d.plotHigh+d.plotLow)/2]})},getGraphPath:function(d){var c=[],b=[],f,e=u.area.prototype.getGraphPath;var h=this.options;var y=this.chart.polar&&!1!==h.connectEnds,k=h.connectNulls,p=h.step;d=d||this.points;for(f=d.length;f--;){var x=d[f];x.isNull||y||k||d[f+1]&&
!d[f+1].isNull||b.push({plotX:x.plotX,plotY:x.plotY,doCurve:!1});var D={polarPlotY:x.polarPlotY,rectPlotX:x.rectPlotX,yBottom:x.yBottom,plotX:a(x.plotHighX,x.plotX),plotY:x.plotHigh,isNull:x.isNull};b.push(D);c.push(D);x.isNull||y||k||d[f-1]&&!d[f-1].isNull||b.push({plotX:x.plotX,plotY:x.plotY,doCurve:!1})}d=e.call(this,d);p&&(!0===p&&(p="left"),h.step={left:"right",center:"center",right:"left"}[p]);c=e.call(this,c);b=e.call(this,b);h.step=p;h=[].concat(d,c);this.chart.polar||"M"!==b[0]||(b[0]="L");
this.graphPath=h;this.areaPath=d.concat(b);h.isArea=!0;h.xMap=d.xMap;this.areaPath.xMap=d.xMap;return h},drawDataLabels:function(){var a=this.points,c=a.length,b,l=[],e=this.options.dataLabels,h,y=this.chart.inverted;if(g(e))if(1<e.length){var k=e[0];var p=e[1]}else k=e[0],p={enabled:!1};else k=f({},e),k.x=e.xHigh,k.y=e.yHigh,p=f({},e),p.x=e.xLow,p.y=e.yLow;if(k.enabled||this._hasPointLabels){for(b=c;b--;)if(h=a[b]){var x=k.inside?h.plotHigh<h.plotLow:h.plotHigh>h.plotLow;h.y=h.high;h._plotY=h.plotY;
h.plotY=h.plotHigh;l[b]=h.dataLabel;h.dataLabel=h.dataLabelUpper;h.below=x;y?k.align||(k.align=x?"right":"left"):k.verticalAlign||(k.verticalAlign=x?"top":"bottom")}this.options.dataLabels=k;d.drawDataLabels&&d.drawDataLabels.apply(this,arguments);for(b=c;b--;)if(h=a[b])h.dataLabelUpper=h.dataLabel,h.dataLabel=l[b],delete h.dataLabels,h.y=h.low,h.plotY=h._plotY}if(p.enabled||this._hasPointLabels){for(b=c;b--;)if(h=a[b])x=p.inside?h.plotHigh<h.plotLow:h.plotHigh>h.plotLow,h.below=!x,y?p.align||(p.align=
x?"left":"right"):p.verticalAlign||(p.verticalAlign=x?"bottom":"top");this.options.dataLabels=p;d.drawDataLabels&&d.drawDataLabels.apply(this,arguments)}if(k.enabled)for(b=c;b--;)if(h=a[b])h.dataLabels=[h.dataLabelUpper,h.dataLabel].filter(function(k){return!!k});this.options.dataLabels=e},alignDataLabel:function(){u.column.prototype.alignDataLabel.apply(this,arguments)},drawPoints:function(){var a=this.points.length,b;d.drawPoints.apply(this,arguments);for(b=0;b<a;){var f=this.points[b];f.origProps=
{plotY:f.plotY,plotX:f.plotX,isInside:f.isInside,negative:f.negative,zone:f.zone,y:f.y};f.lowerGraphic=f.graphic;f.graphic=f.upperGraphic;f.plotY=f.plotHigh;m(f.plotHighX)&&(f.plotX=f.plotHighX);f.y=f.high;f.negative=f.high<(this.options.threshold||0);f.zone=this.zones.length&&f.getZone();this.chart.polar||(f.isInside=f.isTopInside=void 0!==f.plotY&&0<=f.plotY&&f.plotY<=this.yAxis.len&&0<=f.plotX&&f.plotX<=this.xAxis.len);b++}d.drawPoints.apply(this,arguments);for(b=0;b<a;)f=this.points[b],f.upperGraphic=
f.graphic,f.graphic=f.lowerGraphic,c.extend(f,f.origProps),delete f.origProps,b++},setStackedPoints:c.noop},{setState:function(){var a=this.state,d=this.series,b=d.chart.polar;m(this.plotHigh)||(this.plotHigh=d.yAxis.toPixels(this.high,!0));m(this.plotLow)||(this.plotLow=this.plotY=d.yAxis.toPixels(this.low,!0));d.stateMarkerGraphic&&(d.lowerStateMarkerGraphic=d.stateMarkerGraphic,d.stateMarkerGraphic=d.upperStateMarkerGraphic);this.graphic=this.upperGraphic;this.plotY=this.plotHigh;b&&(this.plotX=
this.plotHighX);v.setState.apply(this,arguments);this.state=a;this.plotY=this.plotLow;this.graphic=this.lowerGraphic;b&&(this.plotX=this.plotLowX);d.stateMarkerGraphic&&(d.upperStateMarkerGraphic=d.stateMarkerGraphic,d.stateMarkerGraphic=d.lowerStateMarkerGraphic,d.lowerStateMarkerGraphic=void 0);v.setState.apply(this,arguments)},haloPath:function(){var a=this.series.chart.polar,d=[];this.plotY=this.plotLow;a&&(this.plotX=this.plotLowX);this.isInside&&(d=v.haloPath.apply(this,arguments));this.plotY=
this.plotHigh;a&&(this.plotX=this.plotHighX);this.isTopInside&&(d=d.concat(v.haloPath.apply(this,arguments)));return d},destroyElements:function(){["lowerGraphic","upperGraphic"].forEach(function(a){this[a]&&(this[a]=this[a].destroy())},this);this.graphic=null;return v.destroyElements.apply(this,arguments)},isValid:function(){return l(this.low)&&l(this.high)}});""});z(r,"parts-more/AreaSplineRangeSeries.js",[r["parts/Globals.js"]],function(c){var b=c.seriesType;b("areasplinerange","arearange",null,
{getPointSpline:c.seriesTypes.spline.prototype.getPointSpline});""});z(r,"parts-more/ColumnRangeSeries.js",[r["parts/Globals.js"]],function(c){var b=c.defaultPlotOptions,m=c.merge,g=c.noop,l=c.pick,a=c.seriesType,f=c.seriesTypes.column.prototype;a("columnrange","arearange",m(b.column,b.arearange,{pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var a=this,d=a.yAxis,b=a.xAxis,c=b.startAngleRad,g,m=a.chart,t=a.xAxis.isRadial,e=Math.max(m.chartWidth,m.chartHeight)+999,h;f.translate.apply(a);
a.points.forEach(function(f){var k=f.shapeArgs,p=a.options.minPointLength;f.plotHigh=h=Math.min(Math.max(-e,d.translate(f.high,0,1,0,1)),e);f.plotLow=Math.min(Math.max(-e,f.plotY),e);var x=h;var y=l(f.rectPlotY,f.plotY)-h;Math.abs(y)<p?(p-=y,y+=p,x-=p/2):0>y&&(y*=-1,x-=y);t?(g=f.barX+c,f.shapeType="path",f.shapeArgs={d:a.polarArc(x+y,x,g,g+f.pointWidth)}):(k.height=y,k.y=x,f.tooltipPos=m.inverted?[d.len+d.pos-m.plotLeft-x-y/2,b.len+b.pos-m.plotTop-k.x-k.width/2,y]:[b.left-m.plotLeft+k.x+k.width/2,
d.pos-m.plotTop+x+y/2,y])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:g,getSymbol:g,crispCol:function(){return f.crispCol.apply(this,arguments)},drawPoints:function(){return f.drawPoints.apply(this,arguments)},drawTracker:function(){return f.drawTracker.apply(this,arguments)},getColumnMetrics:function(){return f.getColumnMetrics.apply(this,arguments)},pointAttribs:function(){return f.pointAttribs.apply(this,arguments)},animate:function(){return f.animate.apply(this,arguments)},
polarArc:function(){return f.polarArc.apply(this,arguments)},translate3dPoints:function(){return f.translate3dPoints.apply(this,arguments)},translate3dShapes:function(){return f.translate3dShapes.apply(this,arguments)}},{setState:f.pointClass.prototype.setState});""});z(r,"parts-more/ColumnPyramidSeries.js",[r["parts/Globals.js"]],function(c){var b=c.pick,m=c.seriesType,g=c.seriesTypes.column.prototype;m("columnpyramid","column",{},{translate:function(){var c=this,a=c.chart,f=c.options,m=c.dense=
2>c.closestPointRange*c.xAxis.transA;m=c.borderWidth=b(f.borderWidth,m?0:1);var d=c.yAxis,v=f.threshold,n=c.translatedThreshold=d.getThreshold(v),w=b(f.minPointLength,5),q=c.getColumnMetrics(),t=q.width,e=c.barW=Math.max(t,1+2*m),h=c.pointXOffset=q.offset;a.inverted&&(n-=.5);f.pointPadding&&(e=Math.ceil(e));g.translate.apply(c);c.points.forEach(function(y){var k=b(y.yBottom,n),p=999+Math.abs(k),x=Math.min(Math.max(-p,y.plotY),d.len+p);p=y.plotX+h;var g=e/2,l=Math.min(x,k);k=Math.max(x,k)-l;y.barX=
p;y.pointWidth=t;y.tooltipPos=a.inverted?[d.len+d.pos-a.plotLeft-x,c.xAxis.len-p-g,k]:[p+g,x+d.pos-a.plotTop,k];x=v+(y.total||y.y);"percent"===f.stacking&&(x=v+(0>y.y)?-100:100);x=d.toPixels(x,!0);var m=a.plotHeight-x-(a.plotHeight-n);var A=g*(l-x)/m;var u=g*(l+k-x)/m;m=p-A+g;A=p+A+g;var q=p+u+g;u=p-u+g;var B=l-w;var C=l+k;0>y.y&&(B=l,C=l+k+w);a.inverted&&(q=a.plotWidth-l,m=x-(a.plotWidth-n),A=g*(x-q)/m,u=g*(x-(q-k))/m,m=p+g+A,A=m-2*A,q=p-u+g,u=p+u+g,B=l,C=l+k-w,0>y.y&&(C=l+k+w));y.shapeType="path";
y.shapeArgs={x:m,y:B,width:A-m,height:k,d:["M",m,B,"L",A,B,q,C,u,C,"Z"]}})}});""});z(r,"parts-more/GaugeSeries.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.isNumber,g=b.pInt,l=c.merge,a=c.pick,f=c.Series;b=c.seriesType;var u=c.TrackerMixin;b("gauge","line",{dataLabels:{borderColor:"#cccccc",borderRadius:3,borderWidth:1,crop:!1,defer:!1,enabled:!0,verticalAlign:"top",y:15,zIndex:2},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:c.noop,
fixedBox:!0,forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var d=this.yAxis,f=this.options,b=d.center;this.generatePoints();this.points.forEach(function(c){var v=l(f.dial,c.dial),t=g(a(v.radius,80))*b[2]/200,e=g(a(v.baseLength,70))*t/100,h=g(a(v.rearLength,10))*t/100,y=v.baseWidth||3,k=v.topWidth||1,p=f.overshoot,x=d.startAngleRad+d.translate(c.y,null,null,null,!0);m(p)?(p=p/180*Math.PI,x=Math.max(d.startAngleRad-p,Math.min(d.endAngleRad+p,x))):!1===f.wrap&&
(x=Math.max(d.startAngleRad,Math.min(d.endAngleRad,x)));x=180*x/Math.PI;c.shapeType="path";c.shapeArgs={d:v.path||["M",-h,-y/2,"L",e,-y/2,t,-k/2,t,k/2,e,y/2,-h,y/2,"z"],translateX:b[0],translateY:b[1],rotation:x};c.plotX=b[0];c.plotY=b[1]})},drawPoints:function(){var d=this,f=d.chart,b=d.yAxis.center,c=d.pivot,g=d.options,m=g.pivot,e=f.renderer;d.points.forEach(function(a){var h=a.graphic,k=a.shapeArgs,p=k.d,b=l(g.dial,a.dial);h?(h.animate(k),k.d=p):a.graphic=e[a.shapeType](k).attr({rotation:k.rotation,
zIndex:1}).addClass("highcharts-dial").add(d.group);if(!f.styledMode)a.graphic[h?"animate":"attr"]({stroke:b.borderColor||"none","stroke-width":b.borderWidth||0,fill:b.backgroundColor||"#000000"})});c?c.animate({translateX:b[0],translateY:b[1]}):(d.pivot=e.circle(0,0,a(m.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(b[0],b[1]).add(d.group),f.styledMode||d.pivot.attr({"stroke-width":m.borderWidth||0,stroke:m.borderColor||"#cccccc",fill:m.backgroundColor||"#000000"}))},animate:function(a){var d=
this;a||(d.points.forEach(function(a){var b=a.graphic;b&&(b.attr({rotation:180*d.yAxis.startAngleRad/Math.PI}),b.animate({rotation:a.shapeArgs.rotation},d.options.animation))}),d.animate=null)},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);f.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(d,b){f.prototype.setData.call(this,d,!1);this.processData();this.generatePoints();a(b,
!0)&&this.chart.redraw()},hasData:function(){return!!this.points.length},drawTracker:u&&u.drawTrackerPoint},{setState:function(a){this.state=a}});""});z(r,"parts-more/BoxPlotSeries.js",[r["parts/Globals.js"]],function(c){var b=c.noop,m=c.pick,g=c.seriesType,l=c.seriesTypes;g("boxplot","column",{threshold:null,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'},
whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,whiskerWidth:2},{pointArrayMap:["low","q1","median","q3","high"],toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttribs:function(){return{}},drawDataLabels:b,translate:function(){var a=this.yAxis,b=this.pointArrayMap;l.column.prototype.translate.apply(this);this.points.forEach(function(f){b.forEach(function(d){null!==f[d]&&(f[d+"Plot"]=a.translate(f[d],0,1,0,1))})})},drawPoints:function(){var a=
this,b=a.options,c=a.chart,d=c.renderer,g,l,w,q,t,e,h=0,y,k,p,x,D=!1!==a.doQuartiles,F,E=a.options.whiskerLength;a.points.forEach(function(f){var v=f.graphic,u=v?"animate":"attr",n=f.shapeArgs,A={},I={},J={},r={},G=f.color||a.color;void 0!==f.plotY&&(y=n.width,k=Math.floor(n.x),p=k+y,x=Math.round(y/2),g=Math.floor(D?f.q1Plot:f.lowPlot),l=Math.floor(D?f.q3Plot:f.lowPlot),w=Math.floor(f.highPlot),q=Math.floor(f.lowPlot),v||(f.graphic=v=d.g("point").add(a.group),f.stem=d.path().addClass("highcharts-boxplot-stem").add(v),
E&&(f.whiskers=d.path().addClass("highcharts-boxplot-whisker").add(v)),D&&(f.box=d.path(void 0).addClass("highcharts-boxplot-box").add(v)),f.medianShape=d.path(void 0).addClass("highcharts-boxplot-median").add(v)),c.styledMode||(I.stroke=f.stemColor||b.stemColor||G,I["stroke-width"]=m(f.stemWidth,b.stemWidth,b.lineWidth),I.dashstyle=f.stemDashStyle||b.stemDashStyle,f.stem.attr(I),E&&(J.stroke=f.whiskerColor||b.whiskerColor||G,J["stroke-width"]=m(f.whiskerWidth,b.whiskerWidth,b.lineWidth),f.whiskers.attr(J)),
D&&(A.fill=f.fillColor||b.fillColor||G,A.stroke=b.lineColor||G,A["stroke-width"]=b.lineWidth||0,f.box.attr(A)),r.stroke=f.medianColor||b.medianColor||G,r["stroke-width"]=m(f.medianWidth,b.medianWidth,b.lineWidth),f.medianShape.attr(r)),e=f.stem.strokeWidth()%2/2,h=k+x+e,f.stem[u]({d:["M",h,l,"L",h,w,"M",h,g,"L",h,q]}),D&&(e=f.box.strokeWidth()%2/2,g=Math.floor(g)+e,l=Math.floor(l)+e,k+=e,p+=e,f.box[u]({d:["M",k,l,"L",k,g,"L",p,g,"L",p,l,"L",k,l,"z"]})),E&&(e=f.whiskers.strokeWidth()%2/2,w+=e,q+=e,
F=/%$/.test(E)?x*parseFloat(E)/100:E/2,f.whiskers[u]({d:["M",h-F,w,"L",h+F,w,"M",h-F,q,"L",h+F,q]})),t=Math.round(f.medianPlot),e=f.medianShape.strokeWidth()%2/2,t+=e,f.medianShape[u]({d:["M",k,t,"L",p,t]}))})},setStackedPoints:b});""});z(r,"parts-more/ErrorBarSeries.js",[r["parts/Globals.js"]],function(c){var b=c.noop,m=c.seriesType,g=c.seriesTypes;m("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},
whiskerWidth:null},{type:"errorbar",pointArrayMap:["low","high"],toYData:function(b){return[b.low,b.high]},pointValKey:"high",doQuartiles:!1,drawDataLabels:g.arearange?function(){var b=this.pointValKey;g.arearange.prototype.drawDataLabels.call(this);this.data.forEach(function(a){a.y=a[b]})}:b,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||g.column.prototype.getColumnMetrics.call(this)}});""});z(r,"parts-more/WaterfallSeries.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],
function(c,b){var m=b.isNumber,g=b.objectEach,l=c.correctFloat,a=c.pick,f=c.arrayMin,u=c.arrayMax;b=c.addEvent;var d=c.Axis,v=c.Chart,n=c.Point,w=c.Series,q=c.StackItem,t=c.seriesType,e=c.seriesTypes;b(d,"afterInit",function(){this.isXAxis||(this.waterfallStacks={changed:!1})});b(v,"beforeRedraw",function(){for(var e=this.axes,a=this.series,k=a.length;k--;)a[k].options.stacking&&(e.forEach(function(k){k.isXAxis||(k.waterfallStacks.changed=!0)}),k=0)});b(d,"afterRender",function(){var e=this.options.stackLabels;
e&&e.enabled&&this.waterfallStacks&&this.renderWaterfallStackTotals()});d.prototype.renderWaterfallStackTotals=function(){var e=this.waterfallStacks,a=this.stackTotalGroup,k=new q(this,this.options.stackLabels,!1,0,void 0);this.dummyStackItem=k;g(e,function(e){g(e,function(e){k.total=e.stackTotal;e.label&&(k.label=e.label);q.prototype.render.call(k,a);e.label=k.label;delete k.label})});k.total=null};t("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"Dot",borderColor:"#333333",
states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",showLine:!0,generatePoints:function(){var a;e.column.prototype.generatePoints.apply(this);var d=0;for(a=this.points.length;d<a;d++){var k=this.points[d];var p=this.processedYData[d];if(k.isIntermediateSum||k.isSum)k.y=l(p)}},translate:function(){var h=this.options,d=this.yAxis,k,p=a(h.minPointLength,5),b=p/2,f=h.threshold,c=h.stacking,g=d.waterfallStacks[this.stackKey];e.column.prototype.translate.apply(this);var l=k=f;var m=this.points;var v=0;for(h=
m.length;v<h;v++){var t=m[v];var u=this.processedYData[v];var n=t.shapeArgs;var q=[0,u];var w=t.y;if(c){if(g){q=g[v];if("overlap"===c){var r=q.stackState[q.stateIndex--];r=0<=w?r:r-w;Object.prototype.hasOwnProperty.call(q,"absolutePos")&&delete q.absolutePos;Object.prototype.hasOwnProperty.call(q,"absoluteNeg")&&delete q.absoluteNeg}else 0<=w?(r=q.threshold+q.posTotal,q.posTotal-=w):(r=q.threshold+q.negTotal,q.negTotal-=w,r-=w),!q.posTotal&&Object.prototype.hasOwnProperty.call(q,"absolutePos")&&(q.posTotal=
q.absolutePos,delete q.absolutePos),!q.negTotal&&Object.prototype.hasOwnProperty.call(q,"absoluteNeg")&&(q.negTotal=q.absoluteNeg,delete q.absoluteNeg);t.isSum||(q.connectorThreshold=q.threshold+q.stackTotal);d.reversed?(u=0<=w?r-w:r+w,w=r):(u=r,w=r-w);t.below=u<=a(f,0);n.y=d.translate(u,0,1,0,1);n.height=Math.abs(n.y-d.translate(w,0,1,0,1))}if(w=d.dummyStackItem)w.x=v,w.label=g[v].label,w.setOffset(this.pointXOffset||0,this.barW||0,this.stackedYNeg[v],this.stackedYPos[v])}else r=Math.max(l,l+w)+
q[0],n.y=d.translate(r,0,1,0,1),t.isSum?(n.y=d.translate(q[1],0,1,0,1),n.height=Math.min(d.translate(q[0],0,1,0,1),d.len)-n.y):t.isIntermediateSum?(0<=w?(u=q[1]+k,w=k):(u=k,w=q[1]+k),d.reversed&&(u^=w,w^=u,u^=w),n.y=d.translate(u,0,1,0,1),n.height=Math.abs(n.y-Math.min(d.translate(w,0,1,0,1),d.len)),k+=q[1]):(n.height=0<u?d.translate(l,0,1,0,1)-n.y:d.translate(l,0,1,0,1)-d.translate(l-u,0,1,0,1),l+=u,t.below=l<a(f,0)),0>n.height&&(n.y+=n.height,n.height*=-1);t.plotY=n.y=Math.round(n.y)-this.borderWidth%
2/2;n.height=Math.max(Math.round(n.height),.001);t.yBottom=n.y+n.height;n.height<=p&&!t.isNull?(n.height=p,n.y-=b,t.plotY=n.y,t.minPointLengthOffset=0>t.y?-b:b):(t.isNull&&(n.width=0),t.minPointLengthOffset=0);n=t.plotY+(t.negative?n.height:0);this.chart.inverted?t.tooltipPos[0]=d.len-n:t.tooltipPos[1]=n}},processData:function(e){var a=this.options,k=this.yData,d=a.data,h=k.length,b=a.threshold||0,f,c,g,m,t;for(t=c=f=g=m=0;t<h;t++){var v=k[t];var n=d&&d[t]?d[t]:{};"sum"===v||n.isSum?k[t]=l(c):"intermediateSum"===
v||n.isIntermediateSum?(k[t]=l(f),f=0):(c+=v,f+=v);g=Math.min(c,g);m=Math.max(c,m)}w.prototype.processData.call(this,e);a.stacking||(this.dataMin=g+b,this.dataMax=m)},toYData:function(e){return e.isSum?0===e.x?null:"sum":e.isIntermediateSum?0===e.x?null:"intermediateSum":e.y},pointAttribs:function(a,d){var k=this.options.upColor;k&&!a.options.color&&(a.color=0<a.y?k:null);a=e.column.prototype.pointAttribs.call(this,a,d);delete a.dashstyle;return a},getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var e=
this.data,a=this.yAxis,k=e.length,d=Math.round(this.graph.strokeWidth())%2/2,b=Math.round(this.borderWidth)%2/2,f=this.xAxis.reversed,c=this.yAxis.reversed,g=this.options.stacking,l=[],m;for(m=1;m<k;m++){var t=e[m].shapeArgs;var v=e[m-1];var n=e[m-1].shapeArgs;var q=a.waterfallStacks[this.stackKey];var u=0<v.y?-n.height:0;if(q){q=q[m-1];g?(q=q.connectorThreshold,u=Math.round(a.translate(q,0,1,0,1)+(c?u:0))-d):u=n.y+v.minPointLengthOffset+b-d;var w=["M",n.x+(f?0:n.width),u,"L",t.x+(f?t.width:0),u]}if(!g&&
0>v.y&&!c||0<v.y&&c)w[2]+=n.height,w[5]+=n.height;l=l.concat(w)}return l},drawGraph:function(){w.prototype.drawGraph.call(this);this.graph.attr({d:this.getCrispPath()})},setStackedPoints:function(){function e(e,k,a,d){if(H)for(a;a<H;a++)u.stackState[a]+=d;else u.stackState[0]=e,H=u.stackState.length;u.stackState.push(u.stackState[H-1]+k)}var a=this.options,k=this.yAxis.waterfallStacks,d=a.threshold,b=d||0,f=b,c=this.stackKey,g=this.xData,l=g.length,m,t;this.yAxis.usePercentage=!1;var v=m=t=b;if(this.visible||
!this.chart.options.chart.ignoreHiddenSeries){k[c]||(k[c]={});c=k[c];for(var n=0;n<l;n++){var q=g[n];if(!c[q]||k.changed)c[q]={negTotal:0,posTotal:0,stackTotal:0,threshold:0,stateIndex:0,stackState:[],label:k.changed&&c[q]?c[q].label:void 0};var u=c[q];var w=this.yData[n];0<=w?u.posTotal+=w:u.negTotal+=w;var r=a.data[n];q=u.absolutePos=u.posTotal;var z=u.absoluteNeg=u.negTotal;u.stackTotal=q+z;var H=u.stackState.length;r&&r.isIntermediateSum?(e(t,m,0,t),t=m,m=d,b^=f,f^=b,b^=f):r&&r.isSum?(e(d,v,H),
b=d):(e(b,w,0,v),r&&(v+=w,m+=w));u.stateIndex++;u.threshold=b;b+=u.stackTotal}k.changed=!1}},getExtremes:function(){var e=this.options.stacking;if(e){var a=this.yAxis;a=a.waterfallStacks;var k=this.stackedYNeg=[];var d=this.stackedYPos=[];"overlap"===e?g(a[this.stackKey],function(e){k.push(f(e.stackState));d.push(u(e.stackState))}):g(a[this.stackKey],function(e){k.push(e.negTotal+e.threshold);d.push(e.posTotal+e.threshold)});this.dataMin=f(k);this.dataMax=u(d)}}},{getClassName:function(){var e=n.prototype.getClassName.call(this);
this.isSum?e+=" highcharts-sum":this.isIntermediateSum&&(e+=" highcharts-intermediate-sum");return e},isValid:function(){return m(this.y)||this.isSum||this.isIntermediateSum}});""});z(r,"parts-more/PolygonSeries.js",[r["parts/Globals.js"]],function(c){var b=c.Series,m=c.seriesType,g=c.seriesTypes;m("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var c=b.prototype.getGraphPath.call(this),
a=c.length+1;a--;)(a===c.length||"M"===c[a])&&0<a&&c.splice(a,0,"z");return this.areaPath=c},drawGraph:function(){this.options.fillColor=this.color;g.area.prototype.drawGraph.call(this)},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,drawTracker:b.prototype.drawTracker,setStackedPoints:c.noop});""});z(r,"parts-more/BubbleLegend.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.isNumber,g=b.objectEach;b=c.Series;var l=c.Legend,a=c.Chart,f=c.addEvent,u=c.wrap,d=c.color,v=
c.numberFormat,n=c.merge,w=c.noop,q=c.pick,t=c.stableSort,e=c.setOptions,h=c.arrayMin,y=c.arrayMax;e({legend:{bubbleLegend:{borderColor:void 0,borderWidth:2,className:void 0,color:void 0,connectorClassName:void 0,connectorColor:void 0,connectorDistance:60,connectorWidth:1,enabled:!1,labels:{className:void 0,allowOverlap:!1,format:"",formatter:void 0,align:"right",style:{fontSize:10,color:void 0},x:0,y:0},maxSize:60,minSize:10,legendIndex:0,ranges:{value:void 0,borderColor:void 0,color:void 0,connectorColor:void 0},
sizeBy:"area",sizeByAbsoluteValue:!1,zIndex:1,zThreshold:0}}});c.BubbleLegend=function(e,a){this.init(e,a)};c.BubbleLegend.prototype={init:function(e,a){this.options=e;this.visible=!0;this.chart=a.chart;this.legend=a},setState:w,addToLegend:function(e){e.splice(this.options.legendIndex,0,this)},drawLegendSymbol:function(e){var a=this.chart,k=this.options,d=q(e.options.itemDistance,20),b=k.ranges;var f=k.connectorDistance;this.fontMetrics=a.renderer.fontMetrics(k.labels.style.fontSize.toString()+"px");
b&&b.length&&m(b[0].value)?(t(b,function(e,a){return a.value-e.value}),this.ranges=b,this.setOptions(),this.render(),a=this.getMaxLabelSize(),b=this.ranges[0].radius,e=2*b,f=f-b+a.width,f=0<f?f:0,this.maxLabel=a,this.movementX="left"===k.labels.align?f:0,this.legendItemWidth=e+f+d,this.legendItemHeight=e+this.fontMetrics.h/2):e.options.bubbleLegend.autoRanges=!0},setOptions:function(){var e=this.ranges,a=this.options,b=this.chart.series[a.seriesIndex],f=this.legend.baseline,h={"z-index":a.zIndex,
"stroke-width":a.borderWidth},c={"z-index":a.zIndex,"stroke-width":a.connectorWidth},g=this.getLabelStyles(),m=b.options.marker.fillOpacity,l=this.chart.styledMode;e.forEach(function(k,p){l||(h.stroke=q(k.borderColor,a.borderColor,b.color),h.fill=q(k.color,a.color,1!==m?d(b.color).setOpacity(m).get("rgba"):b.color),c.stroke=q(k.connectorColor,a.connectorColor,b.color));e[p].radius=this.getRangeRadius(k.value);e[p]=n(e[p],{center:e[0].radius-e[p].radius+f});l||n(!0,e[p],{bubbleStyle:n(!1,h),connectorStyle:n(!1,
c),labelStyle:g})},this)},getLabelStyles:function(){var e=this.options,a={},d="left"===e.labels.align,b=this.legend.options.rtl;g(e.labels.style,function(e,k){"color"!==k&&"fontSize"!==k&&"z-index"!==k&&(a[k]=e)});return n(!1,a,{"font-size":e.labels.style.fontSize,fill:q(e.labels.style.color,"#000000"),"z-index":e.zIndex,align:b||d?"right":"left"})},getRangeRadius:function(e){var a=this.options;return this.chart.series[this.options.seriesIndex].getRadius.call(this,a.ranges[a.ranges.length-1].value,
a.ranges[0].value,a.minSize,a.maxSize,e)},render:function(){var e=this.chart.renderer,a=this.options.zThreshold;this.symbols||(this.symbols={connectors:[],bubbleItems:[],labels:[]});this.legendSymbol=e.g("bubble-legend");this.legendItem=e.g("bubble-legend-item");this.legendSymbol.translateX=0;this.legendSymbol.translateY=0;this.ranges.forEach(function(e){e.value>=a&&this.renderRange(e)},this);this.legendSymbol.add(this.legendItem);this.legendItem.add(this.legendGroup);this.hideOverlappingLabels()},
renderRange:function(e){var a=this.options,d=a.labels,k=this.chart.renderer,b=this.symbols,f=b.labels,h=e.center,c=Math.abs(e.radius),g=a.connectorDistance,m=d.align,l=d.style.fontSize;g=this.legend.options.rtl||"left"===m?-g:g;d=a.connectorWidth;var t=this.ranges[0].radius,v=h-c-a.borderWidth/2+d/2;l=l/2-(this.fontMetrics.h-l)/2;var y=k.styledMode;"center"===m&&(g=0,a.connectorDistance=0,e.labelStyle.align="center");m=v+a.labels.y;var n=t+g+a.labels.x;b.bubbleItems.push(k.circle(t,h+((v%1?1:.5)-
(d%2?0:.5)),c).attr(y?{}:e.bubbleStyle).addClass((y?"highcharts-color-"+this.options.seriesIndex+" ":"")+"highcharts-bubble-legend-symbol "+(a.className||"")).add(this.legendSymbol));b.connectors.push(k.path(k.crispLine(["M",t,v,"L",t+g,v],a.connectorWidth)).attr(y?{}:e.connectorStyle).addClass((y?"highcharts-color-"+this.options.seriesIndex+" ":"")+"highcharts-bubble-legend-connectors "+(a.connectorClassName||"")).add(this.legendSymbol));e=k.text(this.formatLabel(e),n,m+l).attr(y?{}:e.labelStyle).addClass("highcharts-bubble-legend-labels "+
(a.labels.className||"")).add(this.legendSymbol);f.push(e);e.placed=!0;e.alignAttr={x:n,y:m+l}},getMaxLabelSize:function(){var e,a;this.symbols.labels.forEach(function(d){a=d.getBBox(!0);e=e?a.width>e.width?a:e:a});return e||{}},formatLabel:function(e){var a=this.options,d=a.labels.formatter;return(a=a.labels.format)?c.format(a,e):d?d.call(e):v(e.value,1)},hideOverlappingLabels:function(){var e=this.chart,a=this.symbols;!this.options.labels.allowOverlap&&a&&(e.hideOverlappingLabels(a.labels),a.labels.forEach(function(e,
d){e.newOpacity?e.newOpacity!==e.oldOpacity&&a.connectors[d].show():a.connectors[d].hide()}))},getRanges:function(){var e=this.legend.bubbleLegend,a=e.options.ranges,d,b=Number.MAX_VALUE,f=-Number.MAX_VALUE;e.chart.series.forEach(function(e){e.isBubble&&!e.ignoreSeries&&(d=e.zData.filter(m),d.length&&(b=q(e.options.zMin,Math.min(b,Math.max(h(d),!1===e.options.displayNegative?e.options.zThreshold:-Number.MAX_VALUE))),f=q(e.options.zMax,Math.max(f,y(d)))))});var c=b===f?[{value:f}]:[{value:b},{value:(b+
f)/2},{value:f,autoRanges:!0}];a.length&&a[0].radius&&c.reverse();c.forEach(function(e,d){a&&a[d]&&(c[d]=n(!1,a[d],e))});return c},predictBubbleSizes:function(){var e=this.chart,a=this.fontMetrics,d=e.legend.options,b="horizontal"===d.layout,f=b?e.legend.lastLineHeight:0,h=e.plotSizeX,c=e.plotSizeY,g=e.series[this.options.seriesIndex];e=Math.ceil(g.minPxSize);var m=Math.ceil(g.maxPxSize);g=g.options.maxSize;var l=Math.min(c,h);if(d.floating||!/%$/.test(g))a=m;else if(g=parseFloat(g),a=(l+f-a.h/2)*
g/100/(g/100+1),b&&c-a>=h||!b&&h-a>=c)a=m;return[e,Math.ceil(a)]},updateRanges:function(e,a){var d=this.legend.options.bubbleLegend;d.minSize=e;d.maxSize=a;d.ranges=this.getRanges()},correctSizes:function(){var e=this.legend,a=this.chart.series[this.options.seriesIndex];1<Math.abs(Math.ceil(a.maxPxSize)-this.options.maxSize)&&(this.updateRanges(this.options.minSize,a.maxPxSize),e.render())}};f(c.Legend,"afterGetAllItems",function(e){var a=this.bubbleLegend,d=this.options,b=d.bubbleLegend,k=this.chart.getVisibleBubbleSeriesIndex();
a&&a.ranges&&a.ranges.length&&(b.ranges.length&&(b.autoRanges=!!b.ranges[0].autoRanges),this.destroyItem(a));0<=k&&d.enabled&&b.enabled&&(b.seriesIndex=k,this.bubbleLegend=new c.BubbleLegend(b,this),this.bubbleLegend.addToLegend(e.allItems))});a.prototype.getVisibleBubbleSeriesIndex=function(){for(var e=this.series,a=0;a<e.length;){if(e[a]&&e[a].isBubble&&e[a].visible&&e[a].zData.length)return a;a++}return-1};l.prototype.getLinesHeights=function(){var e=this.allItems,a=[],d=e.length,b,f=0;for(b=0;b<
d;b++)if(e[b].legendItemHeight&&(e[b].itemHeight=e[b].legendItemHeight),e[b]===e[d-1]||e[b+1]&&e[b]._legendItemPos[1]!==e[b+1]._legendItemPos[1]){a.push({height:0});var h=a[a.length-1];for(f;f<=b;f++)e[f].itemHeight>h.height&&(h.height=e[f].itemHeight);h.step=b}return a};l.prototype.retranslateItems=function(e){var a,d,b,f=this.options.rtl,k=0;this.allItems.forEach(function(h,c){a=h.legendGroup.translateX;d=h._legendItemPos[1];if((b=h.movementX)||f&&h.ranges)b=f?a-h.options.maxSize/2:a+b,h.legendGroup.attr({translateX:b});
c>e[k].step&&k++;h.legendGroup.attr({translateY:Math.round(d+e[k].height/2)});h._legendItemPos[1]=d+e[k].height/2})};f(b,"legendItemClick",function(){var e=this.chart,a=this.visible,d=this.chart.legend;d&&d.bubbleLegend&&(this.visible=!a,this.ignoreSeries=a,e=0<=e.getVisibleBubbleSeriesIndex(),d.bubbleLegend.visible!==e&&(d.update({bubbleLegend:{enabled:e}}),d.bubbleLegend.visible=e),this.visible=a)});u(a.prototype,"drawChartBox",function(e,a,d){var b=this.legend,f=0<=this.getVisibleBubbleSeriesIndex();
if(b&&b.options.enabled&&b.bubbleLegend&&b.options.bubbleLegend.autoRanges&&f){var h=b.bubbleLegend.options;f=b.bubbleLegend.predictBubbleSizes();b.bubbleLegend.updateRanges(f[0],f[1]);h.placed||(b.group.placed=!1,b.allItems.forEach(function(e){e.legendGroup.translateY=null}));b.render();this.getMargins();this.axes.forEach(function(e){e.render();h.placed||(e.setScale(),e.updateNames(),g(e.ticks,function(e){e.isNew=!0;e.isNewLabel=!0}))});h.placed=!0;this.getMargins();e.call(this,a,d);b.bubbleLegend.correctSizes();
b.retranslateItems(b.getLinesHeights())}else e.call(this,a,d),b&&b.options.enabled&&b.bubbleLegend&&(b.render(),b.retranslateItems(b.getLinesHeights()))})});z(r,"parts-more/BubbleSeries.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.isNumber,g=b.pInt,l=c.arrayMax,a=c.arrayMin;b=c.Axis;var f=c.color,u=c.noop,d=c.pick,v=c.Point,n=c.Series,w=c.seriesType,q=c.seriesTypes;w("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},
animationLimit:250,marker:{lineColor:null,lineWidth:1,fillOpacity:.5,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,isBubble:!0,pointAttribs:function(a,
e){var d=this.options.marker.fillOpacity;a=n.prototype.pointAttribs.call(this,a,e);1!==d&&(a.fill=f(a.fill).setOpacity(d).get("rgba"));return a},getRadii:function(a,e,d){var b=this.zData,f=this.yData,h=d.minPxSize,c=d.maxPxSize,g=[];var m=0;for(d=b.length;m<d;m++){var l=b[m];g.push(this.getRadius(a,e,h,c,l,f[m]))}this.radii=g},getRadius:function(a,e,d,b,f,c){var h=this.options,k="width"!==h.sizeBy,g=h.zThreshold,p=e-a,l=.5;if(null===c||null===f)return null;if(m(f)){h.sizeByAbsoluteValue&&(f=Math.abs(f-
g),p=Math.max(e-g,Math.abs(a-g)),a=0);if(f<a)return d/2-1;0<p&&(l=(f-a)/p)}k&&0<=l&&(l=Math.sqrt(l));return Math.ceil(d+l*(b-d))/2},animate:function(a){!a&&this.points.length<this.options.animationLimit&&(this.points.forEach(function(e){var a=e.graphic;if(a&&a.width){var d={x:a.x,y:a.y,width:a.width,height:a.height};a.attr({x:e.plotX,y:e.plotY,width:1,height:1});a.animate(d,this.options.animation)}},this),this.animate=null)},hasData:function(){return!!this.processedXData.length},translate:function(){var a,
e=this.data,d=this.radii;q.scatter.prototype.translate.call(this);for(a=e.length;a--;){var b=e[a];var f=d?d[a]:0;m(f)&&f>=this.minPxSize/2?(b.marker=c.extend(b.marker,{radius:f,width:2*f,height:2*f}),b.dlBox={x:b.plotX-f,y:b.plotY-f,width:2*f,height:2*f}):b.shapeArgs=b.plotY=b.dlBox=void 0}},alignDataLabel:q.column.prototype.alignDataLabel,buildKDTree:u,applyZones:u},{haloPath:function(a){return v.prototype.haloPath.call(this,0===a?0:(this.marker?this.marker.radius||0:0)+a)},ttBelow:!1});b.prototype.beforePadding=
function(){var b=this,e=this.len,f=this.chart,c=0,k=e,p=this.isXAxis,v=p?"xData":"yData",n=this.min,u={},q=Math.min(f.plotWidth,f.plotHeight),w=Number.MAX_VALUE,r=-Number.MAX_VALUE,z=this.max-n,B=e/z,C=[];this.series.forEach(function(e){var c=e.options;!e.bubblePadding||!e.visible&&f.options.chart.ignoreHiddenSeries||(b.allowZoomOutside=!0,C.push(e),p&&(["minSize","maxSize"].forEach(function(e){var a=c[e],d=/%$/.test(a);a=g(a);u[e]=d?q*a/100:a}),e.minPxSize=u.minSize,e.maxPxSize=Math.max(u.maxSize,
u.minSize),e=e.zData.filter(m),e.length&&(w=d(c.zMin,Math.min(w,Math.max(a(e),!1===c.displayNegative?c.zThreshold:-Number.MAX_VALUE))),r=d(c.zMax,Math.max(r,l(e))))))});C.forEach(function(e){var a=e[v],d=a.length;p&&e.getRadii(w,r,e);if(0<z)for(;d--;)if(m(a[d])&&b.dataMin<=a[d]&&a[d]<=b.dataMax){var f=e.radii[d];c=Math.min((a[d]-n)*B-f,c);k=Math.max((a[d]-n)*B+f,k)}});C.length&&0<z&&!this.isLog&&(k-=e,B*=(e+Math.max(0,c)-Math.min(k,e))/e,[["min","userMin",c],["max","userMax",k]].forEach(function(e){void 0===
d(b.options[e[0]],b[e[1]])&&(b[e[0]]+=e[2]/B)}))};""});z(r,"modules/networkgraph/integrations.js",[r["parts/Globals.js"]],function(c){c.networkgraphIntegrations={verlet:{attractiveForceFunction:function(b,c){return(c-b)/b},repulsiveForceFunction:function(b,c){return(c-b)/b*(c>b?1:0)},barycenter:function(){var b=this.options.gravitationalConstant,c=this.barycenter.xFactor,g=this.barycenter.yFactor;c=(c-(this.box.left+this.box.width)/2)*b;g=(g-(this.box.top+this.box.height)/2)*b;this.nodes.forEach(function(b){b.fixedPosition||
(b.plotX-=c/b.mass/b.degree,b.plotY-=g/b.mass/b.degree)})},repulsive:function(b,c,g){c=c*this.diffTemperature/b.mass/b.degree;b.fixedPosition||(b.plotX+=g.x*c,b.plotY+=g.y*c)},attractive:function(b,c,g){var l=b.getMass(),a=-g.x*c*this.diffTemperature;c=-g.y*c*this.diffTemperature;b.fromNode.fixedPosition||(b.fromNode.plotX-=a*l.fromNode/b.fromNode.degree,b.fromNode.plotY-=c*l.fromNode/b.fromNode.degree);b.toNode.fixedPosition||(b.toNode.plotX+=a*l.toNode/b.toNode.degree,b.toNode.plotY+=c*l.toNode/
b.toNode.degree)},integrate:function(b,c){var g=-b.options.friction,l=b.options.maxSpeed,a=(c.plotX+c.dispX-c.prevX)*g;g*=c.plotY+c.dispY-c.prevY;var f=Math.abs,m=f(a)/(a||1);f=f(g)/(g||1);a=m*Math.min(l,Math.abs(a));g=f*Math.min(l,Math.abs(g));c.prevX=c.plotX+c.dispX;c.prevY=c.plotY+c.dispY;c.plotX+=a;c.plotY+=g;c.temperature=b.vectorLength({x:a,y:g})},getK:function(b){return Math.pow(b.box.width*b.box.height/b.nodes.length,.5)}},euler:{attractiveForceFunction:function(b,c){return b*b/c},repulsiveForceFunction:function(b,
c){return c*c/b},barycenter:function(){var b=this.options.gravitationalConstant,c=this.barycenter.xFactor,g=this.barycenter.yFactor;this.nodes.forEach(function(l){if(!l.fixedPosition){var a=l.getDegree();a*=1+a/2;l.dispX+=(c-l.plotX)*b*a/l.degree;l.dispY+=(g-l.plotY)*b*a/l.degree}})},repulsive:function(b,c,g,l){b.dispX+=g.x/l*c/b.degree;b.dispY+=g.y/l*c/b.degree},attractive:function(b,c,g,l){var a=b.getMass(),f=g.x/l*c;c*=g.y/l;b.fromNode.fixedPosition||(b.fromNode.dispX-=f*a.fromNode/b.fromNode.degree,
b.fromNode.dispY-=c*a.fromNode/b.fromNode.degree);b.toNode.fixedPosition||(b.toNode.dispX+=f*a.toNode/b.toNode.degree,b.toNode.dispY+=c*a.toNode/b.toNode.degree)},integrate:function(b,c){c.dispX+=c.dispX*b.options.friction;c.dispY+=c.dispY*b.options.friction;var g=c.temperature=b.vectorLength({x:c.dispX,y:c.dispY});0!==g&&(c.plotX+=c.dispX/g*Math.min(Math.abs(c.dispX),b.temperature),c.plotY+=c.dispY/g*Math.min(Math.abs(c.dispY),b.temperature))},getK:function(b){return Math.pow(b.box.width*b.box.height/
b.nodes.length,.3)}}}});z(r,"modules/networkgraph/QuadTree.js",[r["parts/Globals.js"]],function(c){var b=c.QuadTreeNode=function(b){this.box=b;this.boxSize=Math.min(b.width,b.height);this.nodes=[];this.body=this.isInternal=!1;this.isEmpty=!0};c.extend(b.prototype,{insert:function(c,l){this.isInternal?this.nodes[this.getBoxPosition(c)].insert(c,l-1):(this.isEmpty=!1,this.body?l?(this.isInternal=!0,this.divideBox(),!0!==this.body&&(this.nodes[this.getBoxPosition(this.body)].insert(this.body,l-1),this.body=
!0),this.nodes[this.getBoxPosition(c)].insert(c,l-1)):(l=new b({top:c.plotX,left:c.plotY,width:.1,height:.1}),l.body=c,l.isInternal=!1,this.nodes.push(l)):(this.isInternal=!1,this.body=c))},updateMassAndCenter:function(){var b=0,c=0,a=0;this.isInternal?(this.nodes.forEach(function(f){f.isEmpty||(b+=f.mass,c+=f.plotX*f.mass,a+=f.plotY*f.mass)}),c/=b,a/=b):this.body&&(b=this.body.mass,c=this.body.plotX,a=this.body.plotY);this.mass=b;this.plotX=c;this.plotY=a},divideBox:function(){var c=this.box.width/
2,l=this.box.height/2;this.nodes[0]=new b({left:this.box.left,top:this.box.top,width:c,height:l});this.nodes[1]=new b({left:this.box.left+c,top:this.box.top,width:c,height:l});this.nodes[2]=new b({left:this.box.left+c,top:this.box.top+l,width:c,height:l});this.nodes[3]=new b({left:this.box.left,top:this.box.top+l,width:c,height:l})},getBoxPosition:function(b){var c=b.plotY<this.box.top+this.box.height/2;return b.plotX<this.box.left+this.box.width/2?c?0:3:c?1:2}});var m=c.QuadTree=function(c,l,a,f){this.box=
{left:c,top:l,width:a,height:f};this.maxDepth=25;this.root=new b(this.box,"0");this.root.isInternal=!0;this.root.isRoot=!0;this.root.divideBox()};c.extend(m.prototype,{insertNodes:function(b){b.forEach(function(b){this.root.insert(b,this.maxDepth)},this)},visitNodeRecursive:function(b,c,a){var f;b||(b=this.root);b===this.root&&c&&(f=c(b));!1!==f&&(b.nodes.forEach(function(b){if(b.isInternal){c&&(f=c(b));if(!1===f)return;this.visitNodeRecursive(b,c,a)}else b.body&&c&&c(b.body);a&&a(b)},this),b===this.root&&
a&&a(b))},calculateMassAndCenter:function(){this.visitNodeRecursive(null,null,function(b){b.updateMassAndCenter()})}})});z(r,"modules/networkgraph/layouts.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.defined,g=c.pick;b=c.addEvent;var l=c.Chart;c.layouts={"reingold-fruchterman":function(){}};c.extend(c.layouts["reingold-fruchterman"].prototype,{init:function(a){this.options=a;this.nodes=[];this.links=[];this.series=[];this.box={x:0,y:0,width:0,height:0};this.setInitialRendering(!0);
this.integration=c.networkgraphIntegrations[a.integration];this.attractiveForce=g(a.attractiveForce,this.integration.attractiveForceFunction);this.repulsiveForce=g(a.repulsiveForce,this.integration.repulsiveForceFunction);this.approximation=a.approximation},start:function(){var a=this.series,b=this.options;this.currentStep=0;this.forces=a[0]&&a[0].forces||[];this.initialRendering&&(this.initPositions(),a.forEach(function(a){a.render()}));this.setK();this.resetSimulation(b);b.enableSimulation&&this.step()},
step:function(){var a=this,b=this.series,g=this.options;a.currentStep++;"barnes-hut"===a.approximation&&(a.createQuadTree(),a.quadTree.calculateMassAndCenter());a.forces.forEach(function(b){a[b+"Forces"](a.temperature)});a.applyLimits(a.temperature);a.temperature=a.coolDown(a.startTemperature,a.diffTemperature,a.currentStep);a.prevSystemTemperature=a.systemTemperature;a.systemTemperature=a.getSystemTemperature();g.enableSimulation&&(b.forEach(function(a){a.chart&&a.render()}),a.maxIterations--&&isFinite(a.temperature)&&
!a.isStable()?(a.simulation&&c.win.cancelAnimationFrame(a.simulation),a.simulation=c.win.requestAnimationFrame(function(){a.step()})):a.simulation=!1)},stop:function(){this.simulation&&c.win.cancelAnimationFrame(this.simulation)},setArea:function(a,b,c,d){this.box={left:a,top:b,width:c,height:d}},setK:function(){this.k=this.options.linkLength||this.integration.getK(this)},addNodes:function(a){a.forEach(function(a){-1===this.nodes.indexOf(a)&&this.nodes.push(a)},this)},removeNode:function(a){a=this.nodes.indexOf(a);
-1!==a&&this.nodes.splice(a,1)},removeLink:function(a){a=this.links.indexOf(a);-1!==a&&this.links.splice(a,1)},addLinks:function(a){a.forEach(function(a){-1===this.links.indexOf(a)&&this.links.push(a)},this)},addSeries:function(a){-1===this.series.indexOf(a)&&this.series.push(a)},clear:function(){this.nodes.length=0;this.links.length=0;this.series.length=0;this.resetSimulation()},resetSimulation:function(){this.forcedStop=!1;this.systemTemperature=0;this.setMaxIterations();this.setTemperature();this.setDiffTemperature()},
setMaxIterations:function(a){this.maxIterations=g(a,this.options.maxIterations)},setTemperature:function(){this.temperature=this.startTemperature=Math.sqrt(this.nodes.length)},setDiffTemperature:function(){this.diffTemperature=this.startTemperature/(this.options.maxIterations+1)},setInitialRendering:function(a){this.initialRendering=a},createQuadTree:function(){this.quadTree=new c.QuadTree(this.box.left,this.box.top,this.box.width,this.box.height);this.quadTree.insertNodes(this.nodes)},initPositions:function(){var a=
this.options.initialPositions;c.isFunction(a)?(a.call(this),this.nodes.forEach(function(a){m(a.prevX)||(a.prevX=a.plotX);m(a.prevY)||(a.prevY=a.plotY);a.dispX=0;a.dispY=0})):"circle"===a?this.setCircularPositions():this.setRandomPositions()},setCircularPositions:function(){function a(b){b.linksFrom.forEach(function(e){m[e.toNode.id]||(m[e.toNode.id]=!0,l.push(e.toNode),a(e.toNode))})}var b=this.box,c=this.nodes,d=2*Math.PI/(c.length+1),v=c.filter(function(a){return 0===a.linksTo.length}),l=[],m={},
q=this.options.initialPositionRadius;v.forEach(function(b){l.push(b);a(b)});l.length?c.forEach(function(a){-1===l.indexOf(a)&&l.push(a)}):l=c;l.forEach(function(a,e){a.plotX=a.prevX=g(a.plotX,b.width/2+q*Math.cos(e*d));a.plotY=a.prevY=g(a.plotY,b.height/2+q*Math.sin(e*d));a.dispX=0;a.dispY=0})},setRandomPositions:function(){function a(a){a=a*a/Math.PI;return a-=Math.floor(a)}var b=this.box,c=this.nodes,d=c.length+1;c.forEach(function(c,f){c.plotX=c.prevX=g(c.plotX,b.width*a(f));c.plotY=c.prevY=g(c.plotY,
b.height*a(d+f));c.dispX=0;c.dispY=0})},force:function(a){this.integration[a].apply(this,Array.prototype.slice.call(arguments,1))},barycenterForces:function(){this.getBarycenter();this.force("barycenter")},getBarycenter:function(){var a=0,b=0,c=0;this.nodes.forEach(function(d){b+=d.plotX*d.mass;c+=d.plotY*d.mass;a+=d.mass});return this.barycenter={x:b,y:c,xFactor:b/a,yFactor:c/a}},barnesHutApproximation:function(a,b){var c=this.getDistXY(a,b),d=this.vectorLength(c);if(a!==b&&0!==d)if(b.isInternal)if(b.boxSize/
d<this.options.theta&&0!==d){var f=this.repulsiveForce(d,this.k);this.force("repulsive",a,f*b.mass,c,d);var g=!1}else g=!0;else f=this.repulsiveForce(d,this.k),this.force("repulsive",a,f*b.mass,c,d);return g},repulsiveForces:function(){var a=this;"barnes-hut"===a.approximation?a.nodes.forEach(function(b){a.quadTree.visitNodeRecursive(null,function(c){return a.barnesHutApproximation(b,c)})}):a.nodes.forEach(function(b){a.nodes.forEach(function(c){if(b!==c&&!b.fixedPosition){var d=a.getDistXY(b,c);
var f=a.vectorLength(d);if(0!==f){var g=a.repulsiveForce(f,a.k);a.force("repulsive",b,g*c.mass,d,f)}}})})},attractiveForces:function(){var a=this,b,c,d;a.links.forEach(function(f){f.fromNode&&f.toNode&&(b=a.getDistXY(f.fromNode,f.toNode),c=a.vectorLength(b),0!==c&&(d=a.attractiveForce(c,a.k),a.force("attractive",f,d,b,c)))})},applyLimits:function(){var a=this;a.nodes.forEach(function(b){b.fixedPosition||(a.integration.integrate(a,b),a.applyLimitBox(b,a.box),b.dispX=0,b.dispY=0)})},applyLimitBox:function(a,
b){var c=a.radius;a.plotX=Math.max(Math.min(a.plotX,b.width-c),b.left+c);a.plotY=Math.max(Math.min(a.plotY,b.height-c),b.top+c)},coolDown:function(a,b,c){return a-b*c},isStable:function(){return.00001>Math.abs(this.systemTemperature-this.prevSystemTemperature)||0>=this.temperature},getSystemTemperature:function(){return this.nodes.reduce(function(a,b){return a+b.temperature},0)},vectorLength:function(a){return Math.sqrt(a.x*a.x+a.y*a.y)},getDistR:function(a,b){a=this.getDistXY(a,b);return this.vectorLength(a)},
getDistXY:function(a,b){var c=a.plotX-b.plotX;a=a.plotY-b.plotY;return{x:c,y:a,absX:Math.abs(c),absY:Math.abs(a)}}});b(l,"predraw",function(){this.graphLayoutsLookup&&this.graphLayoutsLookup.forEach(function(a){a.stop()})});b(l,"render",function(){function a(a){a.maxIterations--&&isFinite(a.temperature)&&!a.isStable()&&!a.options.enableSimulation&&(a.beforeStep&&a.beforeStep(),a.step(),g=!1,b=!0)}var b=!1;if(this.graphLayoutsLookup){c.setAnimation(!1,this);for(this.graphLayoutsLookup.forEach(function(a){a.start()});!g;){var g=
!0;this.graphLayoutsLookup.forEach(a)}b&&this.series.forEach(function(a){a&&a.layout&&a.render()})}})});z(r,"modules/networkgraph/draggable-nodes.js",[r["parts/Globals.js"]],function(c){var b=c.Chart,m=c.addEvent;c.dragNodesMixin={onMouseDown:function(b,c){c=this.chart.pointer.normalize(c);b.fixedPosition={chartX:c.chartX,chartY:c.chartY,plotX:b.plotX,plotY:b.plotY};b.inDragMode=!0},onMouseMove:function(b,c){if(b.fixedPosition&&b.inDragMode){var a=this.chart,f=a.pointer.normalize(c);c=b.fixedPosition.chartX-
f.chartX;f=b.fixedPosition.chartY-f.chartY;if(5<Math.abs(c)||5<Math.abs(f))c=b.fixedPosition.plotX-c,f=b.fixedPosition.plotY-f,a.isInsidePlot(c,f)&&(b.plotX=c,b.plotY=f,b.hasDragged=!0,this.redrawHalo(b),this.layout.simulation?this.layout.resetSimulation():(this.layout.setInitialRendering(!1),this.layout.enableSimulation?this.layout.start():this.layout.setMaxIterations(1),this.chart.redraw(),this.layout.setInitialRendering(!0)))}},onMouseUp:function(b,c){b.fixedPosition&&b.hasDragged&&(this.layout.enableSimulation?
this.layout.start():this.chart.redraw(),b.inDragMode=b.hasDragged=!1,this.options.fixedDraggable||delete b.fixedPosition)},redrawHalo:function(b){b&&this.halo&&this.halo.attr({d:b.haloPath(this.options.states.hover.halo.size)})}};m(b,"load",function(){var b=this,c,a,f;b.container&&(c=m(b.container,"mousedown",function(c){var d=b.hoverPoint;d&&d.series&&d.series.hasDraggableNodes&&d.series.options.draggable&&(d.series.onMouseDown(d,c),a=m(b.container,"mousemove",function(a){return d&&d.series&&d.series.onMouseMove(d,
a)}),f=m(b.container.ownerDocument,"mouseup",function(b){a();f();return d&&d.series&&d.series.onMouseUp(d,b)}))}));m(b,"destroy",function(){c()})})});z(r,"parts-more/PackedBubbleSeries.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.defined,g=b.isArray,l=b.isNumber;b=c.seriesType;var a=c.Series,f=c.Point,r=c.pick,d=c.addEvent,v=c.Chart,n=c.Color,w=c.layouts["reingold-fruchterman"],q=c.seriesTypes.bubble.prototype.pointClass,t=c.dragNodesMixin;c.networkgraphIntegrations.packedbubble=
{repulsiveForceFunction:function(a,b,c,d){return Math.min(a,(c.marker.radius+d.marker.radius)/2)},barycenter:function(){var a=this,b=a.options.gravitationalConstant,c=a.box,d=a.nodes,f,g;d.forEach(function(e){a.options.splitSeries&&!e.isParentNode?(f=e.series.parentNode.plotX,g=e.series.parentNode.plotY):(f=c.width/2,g=c.height/2);e.fixedPosition||(e.plotX-=(e.plotX-f)*b/(e.mass*Math.sqrt(d.length)),e.plotY-=(e.plotY-g)*b/(e.mass*Math.sqrt(d.length)))})},repulsive:function(a,b,c,d){var e=b*this.diffTemperature/
a.mass/a.degree;b=c.x*e;c=c.y*e;a.fixedPosition||(a.plotX+=b,a.plotY+=c);d.fixedPosition||(d.plotX-=b,d.plotY-=c)},integrate:c.networkgraphIntegrations.verlet.integrate,getK:c.noop};c.layouts.packedbubble=c.extendClass(w,{beforeStep:function(){this.options.marker&&this.series.forEach(function(a){a&&a.calculateParentRadius()})},setCircularPositions:function(){var a=this,b=a.box,c=a.nodes,d=2*Math.PI/(c.length+1),f,g,l=a.options.initialPositionRadius;c.forEach(function(e,c){a.options.splitSeries&&!e.isParentNode?
(f=e.series.parentNode.plotX,g=e.series.parentNode.plotY):(f=b.width/2,g=b.height/2);e.plotX=e.prevX=r(e.plotX,f+l*Math.cos(e.index||c*d));e.plotY=e.prevY=r(e.plotY,g+l*Math.sin(e.index||c*d));e.dispX=0;e.dispY=0})},repulsiveForces:function(){var a=this,b,c,d,f=a.options.bubblePadding;a.nodes.forEach(function(e){e.degree=e.mass;e.neighbours=0;a.nodes.forEach(function(h){b=0;e===h||e.fixedPosition||!a.options.seriesInteraction&&e.series!==h.series||(d=a.getDistXY(e,h),c=a.vectorLength(d)-(e.marker.radius+
h.marker.radius+f),0>c&&(e.degree+=.01,e.neighbours++,b=a.repulsiveForce(-c/Math.sqrt(e.neighbours),a.k,e,h)),a.force("repulsive",e,b*h.mass,d,h,c))})})},applyLimitBox:function(a){if(this.options.splitSeries&&!a.isParentNode&&this.options.parentNodeLimit){var e=this.getDistXY(a,a.series.parentNode);var b=a.series.parentNodeRadius-a.marker.radius-this.vectorLength(e);0>b&&b>-2*a.marker.radius&&(a.plotX-=.01*e.x,a.plotY-=.01*e.y)}w.prototype.applyLimitBox.apply(this,arguments)},isStable:function(){return.00001>
Math.abs(this.systemTemperature-this.prevSystemTemperature)||0>=this.temperature||0<this.systemTemperature&&.02>this.systemTemperature/this.nodes.length&&this.enableSimulation}});b("packedbubble","bubble",{minSize:"10%",maxSize:"50%",sizeBy:"area",zoneAxis:"y",tooltip:{pointFormat:"Value: {point.value}"},draggable:!0,useSimulation:!0,dataLabels:{formatter:function(){return this.point.value},parentNodeFormatter:function(){return this.name},parentNodeTextPath:{enabled:!0},padding:0},layoutAlgorithm:{initialPositions:"circle",
initialPositionRadius:20,bubblePadding:5,parentNodeLimit:!1,seriesInteraction:!0,dragBetweenSeries:!1,parentNodeOptions:{maxIterations:400,gravitationalConstant:.03,maxSpeed:50,initialPositionRadius:100,seriesInteraction:!0,marker:{fillColor:null,fillOpacity:1,lineWidth:1,lineColor:null,symbol:"circle"}},enableSimulation:!0,type:"packedbubble",integration:"packedbubble",maxIterations:1E3,splitSeries:!1,maxSpeed:5,gravitationalConstant:.01,friction:-.981}},{hasDraggableNodes:!0,forces:["barycenter",
"repulsive"],pointArrayMap:["value"],pointValKey:"value",isCartesian:!1,axisTypes:[],noSharedTooltip:!0,accumulateAllPoints:function(a){var b=a.chart,e=[],c,d;for(c=0;c<b.series.length;c++)if(a=b.series[c],a.visible||!b.options.chart.ignoreHiddenSeries)for(d=0;d<a.yData.length;d++)e.push([null,null,a.yData[d],a.index,d,{id:d,marker:{radius:0}}]);return e},init:function(){a.prototype.init.apply(this,arguments);d(this,"updatedData",function(){this.chart.series.forEach(function(a){a.type===this.type&&
(a.isDirty=!0)},this)});return this},render:function(){var b=[];a.prototype.render.apply(this,arguments);this.options.dataLabels.allowOverlap||(this.data.forEach(function(a){g(a.dataLabels)&&a.dataLabels.forEach(function(a){b.push(a)})}),this.chart.hideOverlappingLabels(b))},setVisible:function(){var b=this;a.prototype.setVisible.apply(b,arguments);b.parentNodeLayout&&b.graph?b.visible?(b.graph.show(),b.parentNode.dataLabel&&b.parentNode.dataLabel.show()):(b.graph.hide(),b.parentNodeLayout.removeNode(b.parentNode),
b.parentNode.dataLabel&&b.parentNode.dataLabel.hide()):b.layout&&(b.visible?b.layout.addNodes(b.points):b.points.forEach(function(a){b.layout.removeNode(a)}))},drawDataLabels:function(){var b=this.options.dataLabels.textPath,c=this.points;a.prototype.drawDataLabels.apply(this,arguments);this.parentNode&&(this.parentNode.formatPrefix="parentNode",this.points=[this.parentNode],this.options.dataLabels.textPath=this.options.dataLabels.parentNodeTextPath,a.prototype.drawDataLabels.apply(this,arguments),
this.points=c,this.options.dataLabels.textPath=b)},seriesBox:function(){var a=this.chart,b=Math.max,c=Math.min,d,f=[a.plotLeft,a.plotLeft+a.plotWidth,a.plotTop,a.plotTop+a.plotHeight];this.data.forEach(function(a){m(a.plotX)&&m(a.plotY)&&a.marker.radius&&(d=a.marker.radius,f[0]=c(f[0],a.plotX-d),f[1]=b(f[1],a.plotX+d),f[2]=c(f[2],a.plotY-d),f[3]=b(f[3],a.plotY+d))});return l(f.width/f.height)?f:null},calculateParentRadius:function(){var a=this.seriesBox();this.parentNodeRadius=Math.min(Math.max(Math.sqrt(2*
this.parentNodeMass/Math.PI)+20,20),a?Math.max(Math.sqrt(Math.pow(a.width,2)+Math.pow(a.height,2))/2+20,20):Math.sqrt(2*this.parentNodeMass/Math.PI)+20);this.parentNode&&(this.parentNode.marker.radius=this.parentNode.radius=this.parentNodeRadius)},drawGraph:function(){if(this.layout&&this.layout.options.splitSeries){var a=this.chart,b=this.layout.options.parentNodeOptions.marker;b={fill:b.fillColor||n(this.color).brighten(.4).get(),opacity:b.fillOpacity,stroke:b.lineColor||this.color,"stroke-width":b.lineWidth};
var d=this.visible?"inherit":"hidden";this.parentNodesGroup||(this.parentNodesGroup=this.plotGroup("parentNodesGroup","parentNode",d,.1,a.seriesGroup),this.group.attr({zIndex:2}));this.calculateParentRadius();d=c.merge({x:this.parentNode.plotX-this.parentNodeRadius,y:this.parentNode.plotY-this.parentNodeRadius,width:2*this.parentNodeRadius,height:2*this.parentNodeRadius},b);this.graph?this.graph.attr(d):this.graph=this.parentNode.graphic=a.renderer.symbol(b.symbol).attr(d).add(this.parentNodesGroup)}},
createParentNodes:function(){var a=this,b=a.chart,c=a.parentNodeLayout,d,f=a.parentNode;a.parentNodeMass=0;a.points.forEach(function(b){a.parentNodeMass+=Math.PI*Math.pow(b.marker.radius,2)});a.calculateParentRadius();c.nodes.forEach(function(b){b.seriesIndex===a.index&&(d=!0)});c.setArea(0,0,b.plotWidth,b.plotHeight);d||(f||(f=(new q).init(this,{mass:a.parentNodeRadius/2,marker:{radius:a.parentNodeRadius},dataLabels:{inside:!1},dataLabelOnNull:!0,degree:a.parentNodeRadius,isParentNode:!0,seriesIndex:a.index})),
a.parentNode&&(f.plotX=a.parentNode.plotX,f.plotY=a.parentNode.plotY),a.parentNode=f,c.addSeries(a),c.addNodes([f]))},addSeriesLayout:function(){var a=this.options.layoutAlgorithm,b=this.chart.graphLayoutsStorage,d=this.chart.graphLayoutsLookup,f=c.merge(a,a.parentNodeOptions,{enableSimulation:this.layout.options.enableSimulation});var g=b[a.type+"-series"];g||(b[a.type+"-series"]=g=new c.layouts[a.type],g.init(f),d.splice(g.index,0,g));this.parentNodeLayout=g;this.createParentNodes()},addLayout:function(){var a=
this.options.layoutAlgorithm,b=this.chart.graphLayoutsStorage,d=this.chart.graphLayoutsLookup,f=this.chart.options.chart;b||(this.chart.graphLayoutsStorage=b={},this.chart.graphLayoutsLookup=d=[]);var g=b[a.type];g||(a.enableSimulation=m(f.forExport)?!f.forExport:a.enableSimulation,b[a.type]=g=new c.layouts[a.type],g.init(a),d.splice(g.index,0,g));this.layout=g;this.points.forEach(function(a){a.mass=2;a.degree=1;a.collisionNmb=1});g.setArea(0,0,this.chart.plotWidth,this.chart.plotHeight);g.addSeries(this);
g.addNodes(this.points)},deferLayout:function(){var a=this.options.layoutAlgorithm;this.visible&&(this.addLayout(),a.splitSeries&&this.addSeriesLayout())},translate:function(){var a=this.chart,b=this.data,d=this.index,f,g=this.options.useSimulation;this.processedXData=this.xData;this.generatePoints();m(a.allDataPoints)||(a.allDataPoints=this.accumulateAllPoints(this),this.getPointRadius());if(g)var l=a.allDataPoints;else l=this.placeBubbles(a.allDataPoints),this.options.draggable=!1;for(f=0;f<l.length;f++)if(l[f][3]===
d){var n=b[l[f][4]];var q=l[f][2];g||(n.plotX=l[f][0]-a.plotLeft+a.diffX,n.plotY=l[f][1]-a.plotTop+a.diffY);n.marker=c.extend(n.marker,{radius:q,width:2*q,height:2*q});n.radius=q}g&&this.deferLayout()},checkOverlap:function(a,b){var c=a[0]-b[0],e=a[1]-b[1];return-.001>Math.sqrt(c*c+e*e)-Math.abs(a[2]+b[2])},positionBubble:function(a,b,c){var e=Math.sqrt,d=Math.asin,f=Math.acos,h=Math.pow,g=Math.abs;e=e(h(a[0]-b[0],2)+h(a[1]-b[1],2));f=f((h(e,2)+h(c[2]+b[2],2)-h(c[2]+a[2],2))/(2*(c[2]+b[2])*e));d=
d(g(a[0]-b[0])/e);a=(0>a[1]-b[1]?0:Math.PI)+f+d*(0>(a[0]-b[0])*(a[1]-b[1])?1:-1);return[b[0]+(b[2]+c[2])*Math.sin(a),b[1]-(b[2]+c[2])*Math.cos(a),c[2],c[3],c[4]]},placeBubbles:function(a){var b=this.checkOverlap,c=this.positionBubble,d=[],e=1,f=0,g=0;var l=[];var n;a=a.sort(function(a,b){return b[2]-a[2]});if(a.length){d.push([[0,0,a[0][2],a[0][3],a[0][4]]]);if(1<a.length)for(d.push([[0,0-a[1][2]-a[0][2],a[1][2],a[1][3],a[1][4]]]),n=2;n<a.length;n++)a[n][2]=a[n][2]||1,l=c(d[e][f],d[e-1][g],a[n]),
b(l,d[e][0])?(d.push([]),g=0,d[e+1].push(c(d[e][f],d[e][0],a[n])),e++,f=0):1<e&&d[e-1][g+1]&&b(l,d[e-1][g+1])?(g++,d[e].push(c(d[e][f],d[e-1][g],a[n])),f++):(f++,d[e].push(l));this.chart.stages=d;this.chart.rawPositions=[].concat.apply([],d);this.resizeRadius();l=this.chart.rawPositions}return l},resizeRadius:function(){var a=this.chart,b=a.rawPositions,c=Math.min,d=Math.max,f=a.plotLeft,g=a.plotTop,l=a.plotHeight,n=a.plotWidth,q,v,m;var t=q=Number.POSITIVE_INFINITY;var w=v=Number.NEGATIVE_INFINITY;
for(m=0;m<b.length;m++){var r=b[m][2];t=c(t,b[m][0]-r);w=d(w,b[m][0]+r);q=c(q,b[m][1]-r);v=d(v,b[m][1]+r)}m=[w-t,v-q];c=c.apply([],[(n-f)/m[0],(l-g)/m[1]]);if(1e-10<Math.abs(c-1)){for(m=0;m<b.length;m++)b[m][2]*=c;this.placeBubbles(b)}else a.diffY=l/2+g-q-(v-q)/2,a.diffX=n/2+f-t-(w-t)/2},calculateZExtremes:function(){var a=this.options.zMin,b=this.options.zMax,c=Infinity,d=-Infinity;if(a&&b)return[a,b];this.chart.series.forEach(function(a){a.yData.forEach(function(a){m(a)&&(a>d&&(d=a),a<c&&(c=a))})});
a=r(a,c);b=r(b,d);return[a,b]},getPointRadius:function(){var a=this,b=a.chart,c=a.options,d=c.useSimulation,f=Math.min(b.plotWidth,b.plotHeight),g={},l=[],n=b.allDataPoints,q,m,v,t;["minSize","maxSize"].forEach(function(a){var b=parseInt(c[a],10),d=/%$/.test(c[a]);g[a]=d?f*b/100:b*Math.sqrt(n.length)});b.minRadius=q=g.minSize/Math.sqrt(n.length);b.maxRadius=m=g.maxSize/Math.sqrt(n.length);var w=d?a.calculateZExtremes():[q,m];(n||[]).forEach(function(b,c){v=d?Math.max(Math.min(b[2],w[1]),w[0]):b[2];
t=a.getRadius(w[0],w[1],q,m,v);0===t&&(t=null);n[c][2]=t;l.push(t)});a.radii=l},redrawHalo:t.redrawHalo,onMouseDown:t.onMouseDown,onMouseMove:t.onMouseMove,onMouseUp:function(a){if(a.fixedPosition&&!a.removed){var b,d,e=this.layout,f=this.parentNodeLayout;f&&e.options.dragBetweenSeries&&f.nodes.forEach(function(f){a&&a.marker&&f!==a.series.parentNode&&(b=e.getDistXY(a,f),d=e.vectorLength(b)-f.marker.radius-a.marker.radius,0>d&&(f.series.addPoint(c.merge(a.options,{plotX:a.plotX,plotY:a.plotY}),!1),
e.removeNode(a),a.remove()))});t.onMouseUp.apply(this,arguments)}},destroy:function(){this.parentNode&&(this.parentNodeLayout.removeNode(this.parentNode),this.parentNode.dataLabel&&(this.parentNode.dataLabel=this.parentNode.dataLabel.destroy()));c.Series.prototype.destroy.apply(this,arguments)},alignDataLabel:c.Series.prototype.alignDataLabel},{destroy:function(){this.series.layout&&this.series.layout.removeNode(this);return f.prototype.destroy.apply(this,arguments)}});d(v,"beforeRedraw",function(){this.allDataPoints&&
delete this.allDataPoints});""});z(r,"parts-more/Polar.js",[r["parts/Globals.js"],r["parts/Utilities.js"]],function(c,b){var m=b.splat,g=c.pick,l=c.Series,a=c.seriesTypes;b=c.wrap;var f=l.prototype,r=c.Pointer.prototype;f.searchPointByAngle=function(a){var b=this.chart,c=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(a.chartX-c[0]-b.plotLeft,a.chartY-c[1]-b.plotTop)})};f.getConnectors=function(a,b,c,f){var d=f?1:0;var g=0<=b&&b<=a.length-1?b:0>b?a.length-1+b:
0;b=0>g-1?a.length-(1+d):g-1;d=g+1>a.length-1?d:g+1;var e=a[b];d=a[d];var h=e.plotX;e=e.plotY;var l=d.plotX;var k=d.plotY;d=a[g].plotX;g=a[g].plotY;h=(1.5*d+h)/2.5;e=(1.5*g+e)/2.5;l=(1.5*d+l)/2.5;var n=(1.5*g+k)/2.5;k=Math.sqrt(Math.pow(h-d,2)+Math.pow(e-g,2));var m=Math.sqrt(Math.pow(l-d,2)+Math.pow(n-g,2));h=Math.atan2(e-g,h-d);n=Math.PI/2+(h+Math.atan2(n-g,l-d))/2;Math.abs(h-n)>Math.PI/2&&(n-=Math.PI);h=d+Math.cos(n)*k;e=g+Math.sin(n)*k;l=d+Math.cos(Math.PI+n)*m;n=g+Math.sin(Math.PI+n)*m;d={rightContX:l,
rightContY:n,leftContX:h,leftContY:e,plotX:d,plotY:g};c&&(d.prevPointCont=this.getConnectors(a,b,!1,f));return d};f.toXY=function(a){var b=this.chart,c=a.plotX;var d=a.plotY;a.rectPlotX=c;a.rectPlotY=d;d=this.xAxis.postTranslate(a.plotX,this.yAxis.len-d);a.plotX=a.polarPlotX=d.x-b.plotLeft;a.plotY=a.polarPlotY=d.y-b.plotTop;this.kdByAngle?(b=(c/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>b&&(b+=360),a.clientX=b):a.clientX=a.plotX};a.spline&&(b(a.spline.prototype,"getPointSpline",function(a,
b,c,f){this.chart.polar?f?(a=this.getConnectors(b,f,!0,this.connectEnds),a=["C",a.prevPointCont.rightContX,a.prevPointCont.rightContY,a.leftContX,a.leftContY,a.plotX,a.plotY]):a=["M",c.plotX,c.plotY]:a=a.call(this,b,c,f);return a}),a.areasplinerange&&(a.areasplinerange.prototype.getPointSpline=a.spline.prototype.getPointSpline));c.addEvent(l,"afterTranslate",function(){var a=this.chart,b;if(a.polar){(this.kdByAngle=a.tooltip&&a.tooltip.shared)?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy=
"xy";if(!this.preventPostTranslate){var f=this.points;for(b=f.length;b--;)this.toXY(f[b]),!a.hasParallelCoordinates&&!this.yAxis.reversed&&f[b].y<this.yAxis.min&&(f[b].isNull=!0)}this.hasClipCircleSetter||(this.hasClipCircleSetter=!!c.addEvent(this,"afterRender",function(){if(a.polar){var b=this.yAxis.center;this.group.clip(a.renderer.clipCircle(b[0],b[1],b[2]/2));this.setClip=c.noop}}))}},{order:2});b(f,"getGraphPath",function(a,b){var c=this,d;if(this.chart.polar){b=b||this.points;for(d=0;d<b.length;d++)if(!b[d].isNull){var f=
d;break}if(!1!==this.options.connectEnds&&void 0!==f){this.connectEnds=!0;b.splice(b.length,0,b[f]);var g=!0}b.forEach(function(a){void 0===a.polarPlotY&&c.toXY(a)})}d=a.apply(this,[].slice.call(arguments,1));g&&b.pop();return d});l=function(a,b){var c=this.chart,d=this.options.animation,f=this.group,g=this.markerGroup,e=this.xAxis.center,h=c.plotLeft,l=c.plotTop;c.polar?c.renderer.isSVG&&(!0===d&&(d={}),b?(a={translateX:e[0]+h,translateY:e[1]+l,scaleX:.001,scaleY:.001},f.attr(a),g&&g.attr(a)):(a=
{translateX:h,translateY:l,scaleX:1,scaleY:1},f.animate(a,d),g&&g.animate(a,d),this.animate=null)):a.call(this,b)};b(f,"animate",l);a.column&&(a=a.column.prototype,a.polarArc=function(a,b,c,f){var d=this.xAxis.center,l=this.yAxis.len;return this.chart.renderer.symbols.arc(d[0],d[1],l-b,null,{start:c,end:f,innerR:l-g(a,l)})},b(a,"animate",l),b(a,"translate",function(a){var b=this.xAxis,c=b.startAngleRad,d;this.preventPostTranslate=!0;a.call(this);if(b.isRadial){var f=this.points;for(d=f.length;d--;){var g=
f[d];a=g.barX+c;g.shapeType="path";g.shapeArgs={d:this.polarArc(g.yBottom,g.plotY,a,a+g.pointWidth)};this.toXY(g);g.tooltipPos=[g.plotX,g.plotY];g.ttBelow=g.plotY>b.center[1]}}}),b(a,"alignDataLabel",function(a,b,c,g,l,m){this.chart.polar?(a=b.rectPlotX/Math.PI*180,null===g.align&&(g.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===g.verticalAlign&&(g.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),f.alignDataLabel.call(this,b,c,g,l,m)):a.call(this,b,c,g,l,m)}));b(r,
"getCoordinates",function(a,b){var c=this.chart,d={xAxis:[],yAxis:[]};c.polar?c.axes.forEach(function(a){var f=a.isXAxis,e=a.center,g=b.chartX-e[0]-c.plotLeft;e=b.chartY-e[1]-c.plotTop;d[f?"xAxis":"yAxis"].push({axis:a,value:a.translate(f?Math.PI-Math.atan2(g,e):Math.sqrt(Math.pow(g,2)+Math.pow(e,2)),!0)})}):d=a.call(this,b);return d});c.SVGRenderer.prototype.clipCircle=function(a,b,f){var d=c.uniqueKey(),g=this.createElement("clipPath").attr({id:d}).add(this.defs);a=this.circle(a,b,f).add(g);a.id=
d;a.clipPath=g;return a};c.addEvent(c.Chart,"getAxes",function(){this.pane||(this.pane=[]);m(this.options.pane).forEach(function(a){new c.Pane(a,this)},this)});c.addEvent(c.Chart,"afterDrawChartBox",function(){this.pane.forEach(function(a){a.render()})});b(c.Chart.prototype,"get",function(a,b){return c.find(this.pane,function(a){return a.options.id===b})||a.call(this,b)})});z(r,"masters/highcharts-more.src.js",[],function(){})});
//# sourceMappingURL=highcharts-more.js.map
/*
 Highcharts JS v7.1.3 (2019-08-14)

 3D features for Highcharts JS

 License: www.highcharts.com/license
*/
(function(u){"object"===typeof module&&module.exports?(u["default"]=u,module.exports=u):"function"===typeof define&&define.amd?define("highcharts/highcharts-3d",["highcharts"],function(B){u(B);u.Highcharts=B;return u}):u("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(u){function B(b,t,z,q){b.hasOwnProperty(t)||(b[t]=q.apply(null,z))}u=u?u._modules:{};B(u,"parts-3d/Math.js",[u["parts/Globals.js"]],function(b){var t=b.deg2rad,z=b.pick;b.perspective3D=function(b,g,v){g=0<v&&v<Number.POSITIVE_INFINITY?
v/(b.z+g.z+v):1;return{x:b.x*g,y:b.y*g}};b.perspective=function(q,g,v){var A=g.options.chart.options3d,r=v?g.inverted:!1,w={x:g.plotWidth/2,y:g.plotHeight/2,z:A.depth/2,vd:z(A.depth,1)*z(A.viewDistance,0)},x=g.scale3d||1,y=t*A.beta*(r?-1:1);A=t*A.alpha*(r?-1:1);var l=Math.cos(A),a=Math.cos(-y),f=Math.sin(A),h=Math.sin(-y);v||(w.x+=g.plotLeft,w.y+=g.plotTop);return q.map(function(k){var d=(r?k.y:k.x)-w.x;var c=(r?k.x:k.y)-w.y;k=(k.z||0)-w.z;d={x:a*d-h*k,y:-f*h*d+l*c-a*f*k,z:l*h*d+f*c+l*a*k};c=b.perspective3D(d,
w,w.vd);c.x=c.x*x+w.x;c.y=c.y*x+w.y;c.z=d.z*x+w.z;return{x:r?c.y:c.x,y:r?c.x:c.y,z:c.z}})};b.pointCameraDistance=function(b,g){var v=g.options.chart.options3d,A=g.plotWidth/2;g=g.plotHeight/2;v=z(v.depth,1)*z(v.viewDistance,0)+v.depth;return Math.sqrt(Math.pow(A-b.plotX,2)+Math.pow(g-b.plotY,2)+Math.pow(v-b.plotZ,2))};b.shapeArea=function(b){var g=0,v;for(v=0;v<b.length;v++){var A=(v+1)%b.length;g+=b[v].x*b[A].y-b[A].x*b[v].y}return g/2};b.shapeArea3d=function(t,g,v){return b.shapeArea(b.perspective(t,
g,v))}});B(u,"parts-3d/SVGRenderer.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,t){function z(a,d,e,D,b,f,h,l){var m=[],E=f-b;return f>b&&f-b>Math.PI/2+.0001?(m=m.concat(z(a,d,e,D,b,b+Math.PI/2,h,l)),m=m.concat(z(a,d,e,D,b+Math.PI/2,f,h,l))):f<b&&b-f>Math.PI/2+.0001?(m=m.concat(z(a,d,e,D,b,b-Math.PI/2,h,l)),m=m.concat(z(a,d,e,D,b-Math.PI/2,f,h,l))):["C",a+e*Math.cos(b)-e*c*E*Math.sin(b)+h,d+D*Math.sin(b)+D*c*E*Math.cos(b)+l,a+e*Math.cos(f)+e*c*E*Math.sin(f)+h,d+D*Math.sin(f)-D*c*
E*Math.cos(f)+l,a+e*Math.cos(f)+h,d+D*Math.sin(f)+l]}var q=t.defined,g=t.objectEach,v=Math.cos,A=Math.PI,r=Math.sin,w=b.animObject,x=b.charts,y=b.color,l=b.deg2rad,a=b.extend,f=b.merge,h=b.perspective,k=b.pick,d=b.SVGElement;t=b.SVGRenderer;var c=4*(Math.sqrt(2)-1)/3/(A/2);t.prototype.toLinePath=function(a,c){var e=[];a.forEach(function(a){e.push("L",a.x,a.y)});a.length&&(e[0]="M",c&&e.push("Z"));return e};t.prototype.toLineSegments=function(a){var c=[],e=!0;a.forEach(function(a){c.push(e?"M":"L",
a.x,a.y);e=!e});return c};t.prototype.face3d=function(a){var c=this,e=this.createElement("path");e.vertexes=[];e.insidePlotArea=!1;e.enabled=!0;e.attr=function(a){if("object"===typeof a&&(q(a.enabled)||q(a.vertexes)||q(a.insidePlotArea))){this.enabled=k(a.enabled,this.enabled);this.vertexes=k(a.vertexes,this.vertexes);this.insidePlotArea=k(a.insidePlotArea,this.insidePlotArea);delete a.enabled;delete a.vertexes;delete a.insidePlotArea;var e=h(this.vertexes,x[c.chartIndex],this.insidePlotArea),m=c.toLinePath(e,
!0);e=b.shapeArea(e);e=this.enabled&&0<e?"visible":"hidden";a.d=m;a.visibility=e}return d.prototype.attr.apply(this,arguments)};e.animate=function(a){if("object"===typeof a&&(q(a.enabled)||q(a.vertexes)||q(a.insidePlotArea))){this.enabled=k(a.enabled,this.enabled);this.vertexes=k(a.vertexes,this.vertexes);this.insidePlotArea=k(a.insidePlotArea,this.insidePlotArea);delete a.enabled;delete a.vertexes;delete a.insidePlotArea;var e=h(this.vertexes,x[c.chartIndex],this.insidePlotArea),m=c.toLinePath(e,
!0);e=b.shapeArea(e);e=this.enabled&&0<e?"visible":"hidden";a.d=m;this.attr("visibility",e)}return d.prototype.animate.apply(this,arguments)};return e.attr(a)};t.prototype.polyhedron=function(a){var c=this,e=this.g(),m=e.destroy;this.styledMode||e.attr({"stroke-linejoin":"round"});e.faces=[];e.destroy=function(){for(var a=0;a<e.faces.length;a++)e.faces[a].destroy();return m.call(this)};e.attr=function(a,m,b,f){if("object"===typeof a&&q(a.faces)){for(;e.faces.length>a.faces.length;)e.faces.pop().destroy();
for(;e.faces.length<a.faces.length;)e.faces.push(c.face3d().add(e));for(var h=0;h<a.faces.length;h++)c.styledMode&&delete a.faces[h].fill,e.faces[h].attr(a.faces[h],null,b,f);delete a.faces}return d.prototype.attr.apply(this,arguments)};e.animate=function(a,m,b){if(a&&a.faces){for(;e.faces.length>a.faces.length;)e.faces.pop().destroy();for(;e.faces.length<a.faces.length;)e.faces.push(c.face3d().add(e));for(var f=0;f<a.faces.length;f++)e.faces[f].animate(a.faces[f],m,b);delete a.faces}return d.prototype.animate.apply(this,
arguments)};return e.attr(a)};var p={initArgs:function(a){var c=this,e=c.renderer,d=e[c.pathType+"Path"](a),m=d.zIndexes;c.parts.forEach(function(a){c[a]=e.path(d[a]).attr({"class":"highcharts-3d-"+a,zIndex:m[a]||0}).add(c)});c.attr({"stroke-linejoin":"round",zIndex:m.group});c.originalDestroy=c.destroy;c.destroy=c.destroyParts},singleSetterForParts:function(a,c,e,d,b,f){var m={};d=[null,null,d||"attr",b,f];var h=e&&e.zIndexes;e?(g(e,function(c,d){m[d]={};m[d][a]=c;h&&(m[d].zIndex=e.zIndexes[d]||
0)}),d[1]=m):(m[a]=c,d[0]=m);return this.processParts.apply(this,d)},processParts:function(a,c,e,d,f){var m=this;m.parts.forEach(function(h){c&&(a=b.pick(c[h],!1));if(!1!==a)m[h][e](a,d,f)});return m},destroyParts:function(){this.processParts(null,null,"destroy");return this.originalDestroy()}};var n=b.merge(p,{parts:["front","top","side"],pathType:"cuboid",attr:function(a,c,e,b){if("string"===typeof a&&"undefined"!==typeof c){var m=a;a={};a[m]=c}return a.shapeArgs||q(a.x)?this.singleSetterForParts("d",
null,this.renderer[this.pathType+"Path"](a.shapeArgs||a)):d.prototype.attr.call(this,a,void 0,e,b)},animate:function(a,c,e){q(a.x)&&q(a.y)?(a=this.renderer[this.pathType+"Path"](a),this.singleSetterForParts("d",null,a,"animate",c,e),this.attr({zIndex:a.zIndexes.group})):d.prototype.animate.call(this,a,c,e);return this},fillSetter:function(a){this.singleSetterForParts("fill",null,{front:a,top:y(a).brighten(.1).get(),side:y(a).brighten(-.1).get()});this.color=this.fill=a;return this}});t.prototype.elements3d=
{base:p,cuboid:n};t.prototype.element3d=function(a,c){var e=this.g();b.extend(e,this.elements3d[a]);e.initArgs(c);return e};t.prototype.cuboid=function(a){return this.element3d("cuboid",a)};b.SVGRenderer.prototype.cuboidPath=function(a){function c(a){return g[a]}var e=a.x,d=a.y,m=a.z,f=a.height,l=a.width,k=a.depth,n=x[this.chartIndex],y=n.options.chart.options3d.alpha,p=0,g=[{x:e,y:d,z:m},{x:e+l,y:d,z:m},{x:e+l,y:d+f,z:m},{x:e,y:d+f,z:m},{x:e,y:d+f,z:m+k},{x:e+l,y:d+f,z:m+k},{x:e+l,y:d,z:m+k},{x:e,
y:d,z:m+k}];g=h(g,n,a.insidePlotArea);var v=function(a,e){var d=[[],-1];a=a.map(c);e=e.map(c);0>b.shapeArea(a)?d=[a,0]:0>b.shapeArea(e)&&(d=[e,1]);return d};var r=v([3,2,1,0],[7,6,5,4]);a=r[0];l=r[1];r=v([1,6,7,0],[4,5,2,3]);f=r[0];k=r[1];r=v([1,2,5,6],[0,7,4,3]);v=r[0];r=r[1];1===r?p+=1E4*(1E3-e):r||(p+=1E4*e);p+=10*(!k||0<=y&&180>=y||360>y&&357.5<y?n.plotHeight-d:10+d);1===l?p+=100*m:l||(p+=100*(1E3-m));return{front:this.toLinePath(a,!0),top:this.toLinePath(f,!0),side:this.toLinePath(v,!0),zIndexes:{group:Math.round(p)},
isFront:l,isTop:k}};b.SVGRenderer.prototype.arc3d=function(c){function m(a){var c=!1,e={},d;a=f(a);for(d in a)-1!==n.indexOf(d)&&(e[d]=a[d],delete a[d],c=!0);return c?e:!1}var e=this.g(),h=e.renderer,n="x y r innerR start end".split(" ");c=f(c);c.alpha=(c.alpha||0)*l;c.beta=(c.beta||0)*l;e.top=h.path();e.side1=h.path();e.side2=h.path();e.inn=h.path();e.out=h.path();e.onAdd=function(){var a=e.parentGroup,c=e.attr("class");e.top.add(e);["out","inn","side1","side2"].forEach(function(d){e[d].attr({"class":c+
" highcharts-3d-side"}).add(a)})};["addClass","removeClass"].forEach(function(a){e[a]=function(){var c=arguments;["top","out","inn","side1","side2"].forEach(function(d){e[d][a].apply(e[d],c)})}});e.setPaths=function(a){var c=e.renderer.arc3dPath(a),d=100*c.zTop;e.attribs=a;e.top.attr({d:c.top,zIndex:c.zTop});e.inn.attr({d:c.inn,zIndex:c.zInn});e.out.attr({d:c.out,zIndex:c.zOut});e.side1.attr({d:c.side1,zIndex:c.zSide1});e.side2.attr({d:c.side2,zIndex:c.zSide2});e.zIndex=d;e.attr({zIndex:d});a.center&&
(e.top.setRadialReference(a.center),delete a.center)};e.setPaths(c);e.fillSetter=function(a){var c=y(a).brighten(-.1).get();this.fill=a;this.side1.attr({fill:c});this.side2.attr({fill:c});this.inn.attr({fill:c});this.out.attr({fill:c});this.top.attr({fill:a});return this};["opacity","translateX","translateY","visibility"].forEach(function(a){e[a+"Setter"]=function(a,c){e[c]=a;["out","inn","side1","side2","top"].forEach(function(d){e[d].attr(c,a)})}});e.attr=function(c){var b;"object"===typeof c&&
(b=m(c))&&(a(e.attribs,b),e.setPaths(e.attribs));return d.prototype.attr.apply(e,arguments)};e.animate=function(a,c,h){var l=this.attribs,n="data-"+Math.random().toString(26).substring(2,9);delete a.center;delete a.z;delete a.depth;delete a.alpha;delete a.beta;var y=w(k(c,this.renderer.globalAnimation));if(y.duration){var p=m(a);e[n]=0;a[n]=1;e[n+"Setter"]=b.noop;p&&(y.step=function(a,c){function e(a){return l[a]+(k(p[a],l[a])-l[a])*c.pos}c.prop===n&&c.elem.setPaths(f(l,{x:e("x"),y:e("y"),r:e("r"),
innerR:e("innerR"),start:e("start"),end:e("end")}))});c=y}return d.prototype.animate.call(this,a,c,h)};e.destroy=function(){this.top.destroy();this.out.destroy();this.inn.destroy();this.side1.destroy();this.side2.destroy();return d.prototype.destroy.call(this)};e.hide=function(){this.top.hide();this.out.hide();this.inn.hide();this.side1.hide();this.side2.hide()};e.show=function(a){this.top.show(a);this.out.show(a);this.inn.show(a);this.side1.show(a);this.side2.show(a)};return e};t.prototype.arc3dPath=
function(a){function c(a){a%=2*Math.PI;a>Math.PI&&(a=2*Math.PI-a);return a}var e=a.x,d=a.y,b=a.start,f=a.end-.00001,h=a.r,l=a.innerR||0,m=a.depth||0,n=a.alpha,k=a.beta,y=Math.cos(b),p=Math.sin(b);a=Math.cos(f);var g=Math.sin(f),w=h*Math.cos(k);h*=Math.cos(n);var t=l*Math.cos(k),x=l*Math.cos(n);l=m*Math.sin(k);var q=m*Math.sin(n);m=["M",e+w*y,d+h*p];m=m.concat(z(e,d,w,h,b,f,0,0));m=m.concat(["L",e+t*a,d+x*g]);m=m.concat(z(e,d,t,x,f,b,0,0));m=m.concat(["Z"]);var u=0<k?Math.PI/2:0;k=0<n?0:Math.PI/2;
u=b>-u?b:f>-u?-u:b;var B=f<A-k?f:b<A-k?A-k:f,C=2*A-k;n=["M",e+w*v(u),d+h*r(u)];n=n.concat(z(e,d,w,h,u,B,0,0));f>C&&b<C?(n=n.concat(["L",e+w*v(B)+l,d+h*r(B)+q]),n=n.concat(z(e,d,w,h,B,C,l,q)),n=n.concat(["L",e+w*v(C),d+h*r(C)]),n=n.concat(z(e,d,w,h,C,f,0,0)),n=n.concat(["L",e+w*v(f)+l,d+h*r(f)+q]),n=n.concat(z(e,d,w,h,f,C,l,q)),n=n.concat(["L",e+w*v(C),d+h*r(C)]),n=n.concat(z(e,d,w,h,C,B,0,0))):f>A-k&&b<A-k&&(n=n.concat(["L",e+w*Math.cos(B)+l,d+h*Math.sin(B)+q]),n=n.concat(z(e,d,w,h,B,f,l,q)),n=n.concat(["L",
e+w*Math.cos(f),d+h*Math.sin(f)]),n=n.concat(z(e,d,w,h,f,B,0,0)));n=n.concat(["L",e+w*Math.cos(B)+l,d+h*Math.sin(B)+q]);n=n.concat(z(e,d,w,h,B,u,l,q));n=n.concat(["Z"]);k=["M",e+t*y,d+x*p];k=k.concat(z(e,d,t,x,b,f,0,0));k=k.concat(["L",e+t*Math.cos(f)+l,d+x*Math.sin(f)+q]);k=k.concat(z(e,d,t,x,f,b,l,q));k=k.concat(["Z"]);y=["M",e+w*y,d+h*p,"L",e+w*y+l,d+h*p+q,"L",e+t*y+l,d+x*p+q,"L",e+t*y,d+x*p,"Z"];e=["M",e+w*a,d+h*g,"L",e+w*a+l,d+h*g+q,"L",e+t*a+l,d+x*g+q,"L",e+t*a,d+x*g,"Z"];g=Math.atan2(q,-l);
d=Math.abs(f+g);a=Math.abs(b+g);b=Math.abs((b+f)/2+g);d=c(d);a=c(a);b=c(b);b*=1E5;f=1E5*a;d*=1E5;return{top:m,zTop:1E5*Math.PI+1,out:n,zOut:Math.max(b,f,d),inn:k,zInn:Math.max(b,f,d),side1:y,zSide1:.99*d,side2:e,zSide2:.99*f}}});B(u,"parts-3d/Chart.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,t){function u(b,l){var a=b.plotLeft,f=b.plotWidth+a,h=b.plotTop,k=b.plotHeight+h,d=a+b.plotWidth/2,c=h+b.plotHeight/2,p=Number.MAX_VALUE,n=-Number.MAX_VALUE,m=Number.MAX_VALUE,y=-Number.MAX_VALUE,
e=1;var g=[{x:a,y:h,z:0},{x:a,y:h,z:l}];[0,1].forEach(function(a){g.push({x:f,y:g[a].y,z:g[a].z})});[0,1,2,3].forEach(function(a){g.push({x:g[a].x,y:k,z:g[a].z})});g=A(g,b,!1);g.forEach(function(a){p=Math.min(p,a.x);n=Math.max(n,a.x);m=Math.min(m,a.y);y=Math.max(y,a.y)});a>p&&(e=Math.min(e,1-Math.abs((a+d)/(p+d))%1));f<n&&(e=Math.min(e,(f-d)/(n-d)));h>m&&(e=0>m?Math.min(e,(h+c)/(-m+h+c)):Math.min(e,1-(h+c)/(m+c)%1));k<y&&(e=Math.min(e,Math.abs((k-c)/(y-c))));return e}var q=t.isArray;t=b.addEvent;
var g=b.Chart,v=b.merge,A=b.perspective,r=b.pick,w=b.wrap;g.prototype.is3d=function(){return this.options.chart.options3d&&this.options.chart.options3d.enabled};g.prototype.propsRequireDirtyBox.push("chart.options3d");g.prototype.propsRequireUpdateSeries.push("chart.options3d");t(g,"afterInit",function(){var b=this.options;this.is3d()&&(b.series||[]).forEach(function(l){"scatter"===(l.type||b.chart.type||b.chart.defaultSeriesType)&&(l.type="scatter3d")})});t(g,"addSeries",function(b){this.is3d()&&
"scatter"===b.options.type&&(b.options.type="scatter3d")});b.wrap(b.Chart.prototype,"isInsidePlot",function(b){return this.is3d()||b.apply(this,[].slice.call(arguments,1))});var x=b.getOptions();v(!0,x,{chart:{options3d:{enabled:!1,alpha:0,beta:0,depth:100,fitToPlot:!0,viewDistance:25,axisLabelPosition:null,frame:{visible:"default",size:1,bottom:{},top:{},left:{},right:{},back:{},front:{}}}}});t(g,"afterGetContainer",function(){this.styledMode&&(this.renderer.definition({tagName:"style",textContent:".highcharts-3d-top{filter: url(#highcharts-brighter)}\n.highcharts-3d-side{filter: url(#highcharts-darker)}\n"}),
[{name:"darker",slope:.6},{name:"brighter",slope:1.4}].forEach(function(b){this.renderer.definition({tagName:"filter",id:"highcharts-"+b.name,children:[{tagName:"feComponentTransfer",children:[{tagName:"feFuncR",type:"linear",slope:b.slope},{tagName:"feFuncG",type:"linear",slope:b.slope},{tagName:"feFuncB",type:"linear",slope:b.slope}]}]})},this))});w(g.prototype,"setClassName",function(b){b.apply(this,[].slice.call(arguments,1));this.is3d()&&(this.container.className+=" highcharts-3d-chart")});t(b.Chart,
"afterSetChartSize",function(){var b=this.options.chart.options3d;if(this.is3d()){var l=this.inverted,a=this.clipBox,f=this.margin;a[l?"y":"x"]=-(f[3]||0);a[l?"x":"y"]=-(f[0]||0);a[l?"height":"width"]=this.chartWidth+(f[3]||0)+(f[1]||0);a[l?"width":"height"]=this.chartHeight+(f[0]||0)+(f[2]||0);this.scale3d=1;!0===b.fitToPlot&&(this.scale3d=u(this,b.depth));this.frame3d=this.get3dFrame()}});t(g,"beforeRedraw",function(){this.is3d()&&(this.isDirtyBox=!0)});t(g,"beforeRender",function(){this.is3d()&&
(this.frame3d=this.get3dFrame())});w(g.prototype,"renderSeries",function(b){var l=this.series.length;if(this.is3d())for(;l--;)b=this.series[l],b.translate(),b.render();else b.call(this)});t(g,"afterDrawChartBox",function(){if(this.is3d()){var y=this.renderer,l=this.options.chart.options3d,a=this.get3dFrame(),f=this.plotLeft,h=this.plotLeft+this.plotWidth,k=this.plotTop,d=this.plotTop+this.plotHeight;l=l.depth;var c=f-(a.left.visible?a.left.size:0),p=h+(a.right.visible?a.right.size:0),n=k-(a.top.visible?
a.top.size:0),m=d+(a.bottom.visible?a.bottom.size:0),g=0-(a.front.visible?a.front.size:0),e=l+(a.back.visible?a.back.size:0),r=this.hasRendered?"animate":"attr";this.frame3d=a;this.frameShapes||(this.frameShapes={bottom:y.polyhedron().add(),top:y.polyhedron().add(),left:y.polyhedron().add(),right:y.polyhedron().add(),back:y.polyhedron().add(),front:y.polyhedron().add()});this.frameShapes.bottom[r]({"class":"highcharts-3d-frame highcharts-3d-frame-bottom",zIndex:a.bottom.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.bottom.color).brighten(.1).get(),
vertexes:[{x:c,y:m,z:g},{x:p,y:m,z:g},{x:p,y:m,z:e},{x:c,y:m,z:e}],enabled:a.bottom.visible},{fill:b.color(a.bottom.color).brighten(.1).get(),vertexes:[{x:f,y:d,z:l},{x:h,y:d,z:l},{x:h,y:d,z:0},{x:f,y:d,z:0}],enabled:a.bottom.visible},{fill:b.color(a.bottom.color).brighten(-.1).get(),vertexes:[{x:c,y:m,z:g},{x:c,y:m,z:e},{x:f,y:d,z:l},{x:f,y:d,z:0}],enabled:a.bottom.visible&&!a.left.visible},{fill:b.color(a.bottom.color).brighten(-.1).get(),vertexes:[{x:p,y:m,z:e},{x:p,y:m,z:g},{x:h,y:d,z:0},{x:h,
y:d,z:l}],enabled:a.bottom.visible&&!a.right.visible},{fill:b.color(a.bottom.color).get(),vertexes:[{x:p,y:m,z:g},{x:c,y:m,z:g},{x:f,y:d,z:0},{x:h,y:d,z:0}],enabled:a.bottom.visible&&!a.front.visible},{fill:b.color(a.bottom.color).get(),vertexes:[{x:c,y:m,z:e},{x:p,y:m,z:e},{x:h,y:d,z:l},{x:f,y:d,z:l}],enabled:a.bottom.visible&&!a.back.visible}]});this.frameShapes.top[r]({"class":"highcharts-3d-frame highcharts-3d-frame-top",zIndex:a.top.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.top.color).brighten(.1).get(),
vertexes:[{x:c,y:n,z:e},{x:p,y:n,z:e},{x:p,y:n,z:g},{x:c,y:n,z:g}],enabled:a.top.visible},{fill:b.color(a.top.color).brighten(.1).get(),vertexes:[{x:f,y:k,z:0},{x:h,y:k,z:0},{x:h,y:k,z:l},{x:f,y:k,z:l}],enabled:a.top.visible},{fill:b.color(a.top.color).brighten(-.1).get(),vertexes:[{x:c,y:n,z:e},{x:c,y:n,z:g},{x:f,y:k,z:0},{x:f,y:k,z:l}],enabled:a.top.visible&&!a.left.visible},{fill:b.color(a.top.color).brighten(-.1).get(),vertexes:[{x:p,y:n,z:g},{x:p,y:n,z:e},{x:h,y:k,z:l},{x:h,y:k,z:0}],enabled:a.top.visible&&
!a.right.visible},{fill:b.color(a.top.color).get(),vertexes:[{x:c,y:n,z:g},{x:p,y:n,z:g},{x:h,y:k,z:0},{x:f,y:k,z:0}],enabled:a.top.visible&&!a.front.visible},{fill:b.color(a.top.color).get(),vertexes:[{x:p,y:n,z:e},{x:c,y:n,z:e},{x:f,y:k,z:l},{x:h,y:k,z:l}],enabled:a.top.visible&&!a.back.visible}]});this.frameShapes.left[r]({"class":"highcharts-3d-frame highcharts-3d-frame-left",zIndex:a.left.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.left.color).brighten(.1).get(),vertexes:[{x:c,y:m,z:g},{x:f,
y:d,z:0},{x:f,y:d,z:l},{x:c,y:m,z:e}],enabled:a.left.visible&&!a.bottom.visible},{fill:b.color(a.left.color).brighten(.1).get(),vertexes:[{x:c,y:n,z:e},{x:f,y:k,z:l},{x:f,y:k,z:0},{x:c,y:n,z:g}],enabled:a.left.visible&&!a.top.visible},{fill:b.color(a.left.color).brighten(-.1).get(),vertexes:[{x:c,y:m,z:e},{x:c,y:n,z:e},{x:c,y:n,z:g},{x:c,y:m,z:g}],enabled:a.left.visible},{fill:b.color(a.left.color).brighten(-.1).get(),vertexes:[{x:f,y:k,z:l},{x:f,y:d,z:l},{x:f,y:d,z:0},{x:f,y:k,z:0}],enabled:a.left.visible},
{fill:b.color(a.left.color).get(),vertexes:[{x:c,y:m,z:g},{x:c,y:n,z:g},{x:f,y:k,z:0},{x:f,y:d,z:0}],enabled:a.left.visible&&!a.front.visible},{fill:b.color(a.left.color).get(),vertexes:[{x:c,y:n,z:e},{x:c,y:m,z:e},{x:f,y:d,z:l},{x:f,y:k,z:l}],enabled:a.left.visible&&!a.back.visible}]});this.frameShapes.right[r]({"class":"highcharts-3d-frame highcharts-3d-frame-right",zIndex:a.right.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.right.color).brighten(.1).get(),vertexes:[{x:p,y:m,z:e},{x:h,y:d,z:l},{x:h,
y:d,z:0},{x:p,y:m,z:g}],enabled:a.right.visible&&!a.bottom.visible},{fill:b.color(a.right.color).brighten(.1).get(),vertexes:[{x:p,y:n,z:g},{x:h,y:k,z:0},{x:h,y:k,z:l},{x:p,y:n,z:e}],enabled:a.right.visible&&!a.top.visible},{fill:b.color(a.right.color).brighten(-.1).get(),vertexes:[{x:h,y:k,z:0},{x:h,y:d,z:0},{x:h,y:d,z:l},{x:h,y:k,z:l}],enabled:a.right.visible},{fill:b.color(a.right.color).brighten(-.1).get(),vertexes:[{x:p,y:m,z:g},{x:p,y:n,z:g},{x:p,y:n,z:e},{x:p,y:m,z:e}],enabled:a.right.visible},
{fill:b.color(a.right.color).get(),vertexes:[{x:p,y:n,z:g},{x:p,y:m,z:g},{x:h,y:d,z:0},{x:h,y:k,z:0}],enabled:a.right.visible&&!a.front.visible},{fill:b.color(a.right.color).get(),vertexes:[{x:p,y:m,z:e},{x:p,y:n,z:e},{x:h,y:k,z:l},{x:h,y:d,z:l}],enabled:a.right.visible&&!a.back.visible}]});this.frameShapes.back[r]({"class":"highcharts-3d-frame highcharts-3d-frame-back",zIndex:a.back.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.back.color).brighten(.1).get(),vertexes:[{x:p,y:m,z:e},{x:c,y:m,z:e},{x:f,
y:d,z:l},{x:h,y:d,z:l}],enabled:a.back.visible&&!a.bottom.visible},{fill:b.color(a.back.color).brighten(.1).get(),vertexes:[{x:c,y:n,z:e},{x:p,y:n,z:e},{x:h,y:k,z:l},{x:f,y:k,z:l}],enabled:a.back.visible&&!a.top.visible},{fill:b.color(a.back.color).brighten(-.1).get(),vertexes:[{x:c,y:m,z:e},{x:c,y:n,z:e},{x:f,y:k,z:l},{x:f,y:d,z:l}],enabled:a.back.visible&&!a.left.visible},{fill:b.color(a.back.color).brighten(-.1).get(),vertexes:[{x:p,y:n,z:e},{x:p,y:m,z:e},{x:h,y:d,z:l},{x:h,y:k,z:l}],enabled:a.back.visible&&
!a.right.visible},{fill:b.color(a.back.color).get(),vertexes:[{x:f,y:k,z:l},{x:h,y:k,z:l},{x:h,y:d,z:l},{x:f,y:d,z:l}],enabled:a.back.visible},{fill:b.color(a.back.color).get(),vertexes:[{x:c,y:m,z:e},{x:p,y:m,z:e},{x:p,y:n,z:e},{x:c,y:n,z:e}],enabled:a.back.visible}]});this.frameShapes.front[r]({"class":"highcharts-3d-frame highcharts-3d-frame-front",zIndex:a.front.frontFacing?-1E3:1E3,faces:[{fill:b.color(a.front.color).brighten(.1).get(),vertexes:[{x:c,y:m,z:g},{x:p,y:m,z:g},{x:h,y:d,z:0},{x:f,
y:d,z:0}],enabled:a.front.visible&&!a.bottom.visible},{fill:b.color(a.front.color).brighten(.1).get(),vertexes:[{x:p,y:n,z:g},{x:c,y:n,z:g},{x:f,y:k,z:0},{x:h,y:k,z:0}],enabled:a.front.visible&&!a.top.visible},{fill:b.color(a.front.color).brighten(-.1).get(),vertexes:[{x:c,y:n,z:g},{x:c,y:m,z:g},{x:f,y:d,z:0},{x:f,y:k,z:0}],enabled:a.front.visible&&!a.left.visible},{fill:b.color(a.front.color).brighten(-.1).get(),vertexes:[{x:p,y:m,z:g},{x:p,y:n,z:g},{x:h,y:k,z:0},{x:h,y:d,z:0}],enabled:a.front.visible&&
!a.right.visible},{fill:b.color(a.front.color).get(),vertexes:[{x:h,y:k,z:0},{x:f,y:k,z:0},{x:f,y:d,z:0},{x:h,y:d,z:0}],enabled:a.front.visible},{fill:b.color(a.front.color).get(),vertexes:[{x:p,y:m,z:g},{x:c,y:m,z:g},{x:c,y:n,z:g},{x:p,y:n,z:g}],enabled:a.front.visible}]})}});g.prototype.retrieveStacks=function(b){var l=this.series,a={},f,h=1;this.series.forEach(function(k){f=r(k.options.stack,b?0:l.length-1-k.index);a[f]?a[f].series.push(k):(a[f]={series:[k],position:h},h++)});a.totalStacks=h+1;
return a};g.prototype.get3dFrame=function(){var g=this,l=g.options.chart.options3d,a=l.frame,f=g.plotLeft,h=g.plotLeft+g.plotWidth,k=g.plotTop,d=g.plotTop+g.plotHeight,c=l.depth,p=function(a){a=b.shapeArea3d(a,g);return.5<a?1:-.5>a?-1:0},n=p([{x:f,y:d,z:c},{x:h,y:d,z:c},{x:h,y:d,z:0},{x:f,y:d,z:0}]),m=p([{x:f,y:k,z:0},{x:h,y:k,z:0},{x:h,y:k,z:c},{x:f,y:k,z:c}]),v=p([{x:f,y:k,z:0},{x:f,y:k,z:c},{x:f,y:d,z:c},{x:f,y:d,z:0}]),e=p([{x:h,y:k,z:c},{x:h,y:k,z:0},{x:h,y:d,z:0},{x:h,y:d,z:c}]),w=p([{x:f,y:d,
z:0},{x:h,y:d,z:0},{x:h,y:k,z:0},{x:f,y:k,z:0}]);p=p([{x:f,y:k,z:c},{x:h,y:k,z:c},{x:h,y:d,z:c},{x:f,y:d,z:c}]);var t=!1,q=!1,x=!1,u=!1;[].concat(g.xAxis,g.yAxis,g.zAxis).forEach(function(a){a&&(a.horiz?a.opposite?q=!0:t=!0:a.opposite?u=!0:x=!0)});var z=function(a,c,d){for(var e=["size","color","visible"],b={},f=0;f<e.length;f++)for(var h=e[f],n=0;n<a.length;n++)if("object"===typeof a[n]){var l=a[n][h];if(void 0!==l&&null!==l){b[h]=l;break}}a=d;!0===b.visible||!1===b.visible?a=b.visible:"auto"===
b.visible&&(a=0<c);return{size:r(b.size,1),color:r(b.color,"none"),frontFacing:0<c,visible:a}};a={axes:{},bottom:z([a.bottom,a.top,a],n,t),top:z([a.top,a.bottom,a],m,q),left:z([a.left,a.right,a.side,a],v,x),right:z([a.right,a.left,a.side,a],e,u),back:z([a.back,a.front,a],p,!0),front:z([a.front,a.back,a],w,!1)};"auto"===l.axisLabelPosition?(e=function(a,c){return a.visible!==c.visible||a.visible&&c.visible&&a.frontFacing!==c.frontFacing},l=[],e(a.left,a.front)&&l.push({y:(k+d)/2,x:f,z:0,xDir:{x:1,
y:0,z:0}}),e(a.left,a.back)&&l.push({y:(k+d)/2,x:f,z:c,xDir:{x:0,y:0,z:-1}}),e(a.right,a.front)&&l.push({y:(k+d)/2,x:h,z:0,xDir:{x:0,y:0,z:1}}),e(a.right,a.back)&&l.push({y:(k+d)/2,x:h,z:c,xDir:{x:-1,y:0,z:0}}),n=[],e(a.bottom,a.front)&&n.push({x:(f+h)/2,y:d,z:0,xDir:{x:1,y:0,z:0}}),e(a.bottom,a.back)&&n.push({x:(f+h)/2,y:d,z:c,xDir:{x:-1,y:0,z:0}}),m=[],e(a.top,a.front)&&m.push({x:(f+h)/2,y:k,z:0,xDir:{x:1,y:0,z:0}}),e(a.top,a.back)&&m.push({x:(f+h)/2,y:k,z:c,xDir:{x:-1,y:0,z:0}}),v=[],e(a.bottom,
a.left)&&v.push({z:(0+c)/2,y:d,x:f,xDir:{x:0,y:0,z:-1}}),e(a.bottom,a.right)&&v.push({z:(0+c)/2,y:d,x:h,xDir:{x:0,y:0,z:1}}),d=[],e(a.top,a.left)&&d.push({z:(0+c)/2,y:k,x:f,xDir:{x:0,y:0,z:-1}}),e(a.top,a.right)&&d.push({z:(0+c)/2,y:k,x:h,xDir:{x:0,y:0,z:1}}),f=function(a,c,d){if(0===a.length)return null;if(1===a.length)return a[0];for(var e=0,b=A(a,g,!1),f=1;f<b.length;f++)d*b[f][c]>d*b[e][c]?e=f:d*b[f][c]===d*b[e][c]&&b[f].z<b[e].z&&(e=f);return a[e]},a.axes={y:{left:f(l,"x",-1),right:f(l,"x",1)},
x:{top:f(m,"y",-1),bottom:f(n,"y",1)},z:{top:f(d,"y",-1),bottom:f(v,"y",1)}}):a.axes={y:{left:{x:f,z:0,xDir:{x:1,y:0,z:0}},right:{x:h,z:0,xDir:{x:0,y:0,z:1}}},x:{top:{y:k,z:0,xDir:{x:1,y:0,z:0}},bottom:{y:d,z:0,xDir:{x:1,y:0,z:0}}},z:{top:{x:x?h:f,y:k,xDir:x?{x:0,y:0,z:1}:{x:0,y:0,z:-1}},bottom:{x:x?h:f,y:d,xDir:x?{x:0,y:0,z:1}:{x:0,y:0,z:-1}}}};return a};b.Fx.prototype.matrixSetter=function(){if(1>this.pos&&(q(this.start)||q(this.end))){var b=this.start||[1,0,0,1,0,0],l=this.end||[1,0,0,1,0,0];var a=
[];for(var f=0;6>f;f++)a.push(this.pos*l[f]+(1-this.pos)*b[f])}else a=this.end;this.elem.attr(this.prop,a,null,!0)};""});B(u,"parts-3d/Axis.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,t){function u(d,c,b){if(!d.chart.is3d()||"colorAxis"===d.coll)return c;var f=d.chart,h=A*f.options.chart.options3d.alpha,k=A*f.options.chart.options3d.beta,e=l(b&&d.options.title.position3d,d.options.labels.position3d);b=l(b&&d.options.title.skew3d,d.options.labels.skew3d);var g=f.frame3d,p=f.plotLeft,
r=f.plotWidth+p,y=f.plotTop,v=f.plotHeight+y;f=!1;var w=0,t=0,q={x:0,y:1,z:0};c=d.swapZ({x:c.x,y:c.y,z:0});if(d.isZAxis)if(d.opposite){if(null===g.axes.z.top)return{};t=c.y-y;c.x=g.axes.z.top.x;c.y=g.axes.z.top.y;p=g.axes.z.top.xDir;f=!g.top.frontFacing}else{if(null===g.axes.z.bottom)return{};t=c.y-v;c.x=g.axes.z.bottom.x;c.y=g.axes.z.bottom.y;p=g.axes.z.bottom.xDir;f=!g.bottom.frontFacing}else if(d.horiz)if(d.opposite){if(null===g.axes.x.top)return{};t=c.y-y;c.y=g.axes.x.top.y;c.z=g.axes.x.top.z;
p=g.axes.x.top.xDir;f=!g.top.frontFacing}else{if(null===g.axes.x.bottom)return{};t=c.y-v;c.y=g.axes.x.bottom.y;c.z=g.axes.x.bottom.z;p=g.axes.x.bottom.xDir;f=!g.bottom.frontFacing}else if(d.opposite){if(null===g.axes.y.right)return{};w=c.x-r;c.x=g.axes.y.right.x;c.z=g.axes.y.right.z;p=g.axes.y.right.xDir;p={x:p.z,y:p.y,z:-p.x}}else{if(null===g.axes.y.left)return{};w=c.x-p;c.x=g.axes.y.left.x;c.z=g.axes.y.left.z;p=g.axes.y.left.xDir}"chart"!==e&&("flap"===e?d.horiz?(k=Math.sin(h),h=Math.cos(h),d.opposite&&
(k=-k),f&&(k=-k),q={x:p.z*k,y:h,z:-p.x*k}):p={x:Math.cos(k),y:0,z:Math.sin(k)}:"ortho"===e?d.horiz?(q=Math.cos(h),e=Math.sin(k)*q,h=-Math.sin(h),k=-q*Math.cos(k),q={x:p.y*k-p.z*h,y:p.z*e-p.x*k,z:p.x*h-p.y*e},h=1/Math.sqrt(q.x*q.x+q.y*q.y+q.z*q.z),f&&(h=-h),q={x:h*q.x,y:h*q.y,z:h*q.z}):p={x:Math.cos(k),y:0,z:Math.sin(k)}:d.horiz?q={x:Math.sin(k)*Math.sin(h),y:Math.cos(h),z:-Math.cos(k)*Math.sin(h)}:p={x:Math.cos(k),y:0,z:Math.sin(k)});c.x+=w*p.x+t*q.x;c.y+=w*p.y+t*q.y;c.z+=w*p.z+t*q.z;f=x([c],d.chart)[0];
b&&(0>a(x([c,{x:c.x+p.x,y:c.y+p.y,z:c.z+p.z},{x:c.x+q.x,y:c.y+q.y,z:c.z+q.z}],d.chart))&&(p={x:-p.x,y:-p.y,z:-p.z}),d=x([{x:c.x,y:c.y,z:c.z},{x:c.x+p.x,y:c.y+p.y,z:c.z+p.z},{x:c.x+q.x,y:c.y+q.y,z:c.z+q.z}],d.chart),f.matrix=[d[1].x-d[0].x,d[1].y-d[0].y,d[2].x-d[0].x,d[2].y-d[0].y,f.x,f.y],f.matrix[4]-=f.x*f.matrix[0]+f.y*f.matrix[2],f.matrix[5]-=f.x*f.matrix[1]+f.y*f.matrix[3]);return f}var q=t.splat;t=b.addEvent;var g=b.Axis,v=b.Chart,A=b.deg2rad,r=b.extend,w=b.merge,x=b.perspective,y=b.perspective3D,
l=b.pick,a=b.shapeArea,f=b.Tick,h=b.wrap;w(!0,g.prototype.defaultOptions,{labels:{position3d:"offset",skew3d:!1},title:{position3d:null,skew3d:null}});t(g,"afterSetOptions",function(){if(this.chart.is3d&&this.chart.is3d()&&"colorAxis"!==this.coll){var a=this.options;a.tickWidth=l(a.tickWidth,0);a.gridLineWidth=l(a.gridLineWidth,1)}});h(g.prototype,"getPlotLinePath",function(a){var c=a.apply(this,[].slice.call(arguments,1));if(!this.chart.is3d()||"colorAxis"===this.coll||null===c)return c;var d=this.chart,
b=d.options.chart.options3d;b=this.isZAxis?d.plotWidth:b.depth;d=d.frame3d;c=[this.swapZ({x:c[1],y:c[2],z:0}),this.swapZ({x:c[1],y:c[2],z:b}),this.swapZ({x:c[4],y:c[5],z:0}),this.swapZ({x:c[4],y:c[5],z:b})];b=[];this.horiz?(this.isZAxis?(d.left.visible&&b.push(c[0],c[2]),d.right.visible&&b.push(c[1],c[3])):(d.front.visible&&b.push(c[0],c[2]),d.back.visible&&b.push(c[1],c[3])),d.top.visible&&b.push(c[0],c[1]),d.bottom.visible&&b.push(c[2],c[3])):(d.front.visible&&b.push(c[0],c[2]),d.back.visible&&
b.push(c[1],c[3]),d.left.visible&&b.push(c[0],c[1]),d.right.visible&&b.push(c[2],c[3]));b=x(b,this.chart,!1);return this.chart.renderer.toLineSegments(b)});h(g.prototype,"getLinePath",function(a){return this.chart.is3d()&&"colorAxis"!==this.coll?[]:a.apply(this,[].slice.call(arguments,1))});h(g.prototype,"getPlotBandPath",function(a){if(!this.chart.is3d()||"colorAxis"===this.coll)return a.apply(this,[].slice.call(arguments,1));var c=arguments,d=c[2],b=[];c=this.getPlotLinePath({value:c[1]});d=this.getPlotLinePath({value:d});
if(c&&d)for(var f=0;f<c.length;f+=6)b.push("M",c[f+1],c[f+2],"L",c[f+4],c[f+5],"L",d[f+4],d[f+5],"L",d[f+1],d[f+2],"Z");return b});h(f.prototype,"getMarkPath",function(a){var c=a.apply(this,[].slice.call(arguments,1));c=[u(this.axis,{x:c[1],y:c[2],z:0}),u(this.axis,{x:c[4],y:c[5],z:0})];return this.axis.chart.renderer.toLineSegments(c)});t(f,"afterGetLabelPosition",function(a){r(a.pos,u(this.axis,a.pos))});h(g.prototype,"getTitlePosition",function(a){var c=a.apply(this,[].slice.call(arguments,1));
return u(this,c,!0)});t(g,"drawCrosshair",function(a){this.chart.is3d()&&"colorAxis"!==this.coll&&a.point&&(a.point.crosshairPos=this.isXAxis?a.point.axisXpos:this.len-a.point.axisYpos)});t(g,"destroy",function(){["backFrame","bottomFrame","sideFrame"].forEach(function(a){this[a]&&(this[a]=this[a].destroy())},this)});g.prototype.swapZ=function(a,c){return this.isZAxis?(c=c?0:this.chart.plotLeft,{x:c+a.z,y:a.y,z:a.x-c}):a};var k=b.ZAxis=function(){this.init.apply(this,arguments)};r(k.prototype,g.prototype);
r(k.prototype,{isZAxis:!0,setOptions:function(a){a=w({offset:0,lineWidth:0},a);g.prototype.setOptions.call(this,a);this.coll="zAxis"},setAxisSize:function(){g.prototype.setAxisSize.call(this);this.width=this.len=this.chart.options.chart.options3d.depth;this.right=this.chart.chartWidth-this.width-this.left},getSeriesExtremes:function(){var a=this,c=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.ignoreMinPadding=a.ignoreMaxPadding=null;a.buildStacks&&a.buildStacks();a.series.forEach(function(b){if(b.visible||
!c.options.chart.ignoreHiddenSeries)a.hasVisibleSeries=!0,b=b.zData,b.length&&(a.dataMin=Math.min(l(a.dataMin,b[0]),Math.min.apply(null,b)),a.dataMax=Math.max(l(a.dataMax,b[0]),Math.max.apply(null,b)))})}});t(v,"afterGetAxes",function(){var a=this,c=this.options;c=c.zAxis=q(c.zAxis||{});a.is3d()&&(this.zAxis=[],c.forEach(function(c,b){c.index=b;c.isX=!0;(new k(a,c)).setScale()}))});h(g.prototype,"getSlotWidth",function(a,c){if(this.chart.is3d()&&c&&c.label&&this.categories&&this.chart.frameShapes){var b=
this.chart,d=this.ticks,f=this.gridGroup.element.childNodes[0].getBBox(),h=b.frameShapes.left.getBBox(),e=b.options.chart.options3d;b={x:b.plotWidth/2,y:b.plotHeight/2,z:e.depth/2,vd:l(e.depth,1)*l(e.viewDistance,0)};var g,k;e=c.pos;var r=d[e-1];d=d[e+1];0!==e&&r&&r.label.xy&&(g=y({x:r.label.xy.x,y:r.label.xy.y,z:null},b,b.vd));d&&d.label.xy&&(k=y({x:d.label.xy.x,y:d.label.xy.y,z:null},b,b.vd));d={x:c.label.xy.x,y:c.label.xy.y,z:null};d=y(d,b,b.vd);return Math.abs(g?d.x-g.x:k?k.x-d.x:f.x-h.x)}return a.apply(this,
[].slice.call(arguments,1))})});B(u,"parts-3d/Series.js",[u["parts/Globals.js"]],function(b){var t=b.addEvent,u=b.perspective,q=b.pick;t(b.Series,"afterTranslate",function(){this.chart.is3d()&&this.translate3dPoints()});b.Series.prototype.translate3dPoints=function(){var b=this.chart,v=q(this.zAxis,b.options.zAxis[0]),t=[],r;for(r=0;r<this.data.length;r++){var w=this.data[r];if(v&&v.translate){var x=v.isLog&&v.val2lin?v.val2lin(w.z):w.z;w.plotZ=v.translate(x);w.isInside=w.isInside?x>=v.min&&x<=v.max:
!1}else w.plotZ=0;w.axisXpos=w.plotX;w.axisYpos=w.plotY;w.axisZpos=w.plotZ;t.push({x:w.plotX,y:w.plotY,z:w.plotZ})}b=u(t,b,!0);for(r=0;r<this.data.length;r++)w=this.data[r],v=b[r],w.plotX=v.x,w.plotY=v.y,w.plotZ=v.z}});B(u,"parts-3d/Column.js",[u["parts/Globals.js"]],function(b){function t(b){var g=b.apply(this,[].slice.call(arguments,1));this.chart.is3d&&this.chart.is3d()&&(g.stroke=this.options.edgeColor||g.fill,g["stroke-width"]=v(this.options.edgeWidth,1));return g}function u(b,g,a){var f=this.chart.is3d&&
this.chart.is3d();f&&(this.options.inactiveOtherPoints=!0);b.call(this,g,a);f&&(this.options.inactiveOtherPoints=!1)}var q=b.addEvent,g=b.perspective,v=b.pick,A=b.Series,r=b.seriesTypes,w=b.svg,x=b.wrap;x(r.column.prototype,"translate",function(b){b.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&this.translate3dShapes()});x(b.Series.prototype,"alignDataLabel",function(b){arguments[3].outside3dPlot=arguments[1].outside3dPlot;b.apply(this,[].slice.call(arguments,1))});x(b.Series.prototype,
"justifyDataLabel",function(b){return arguments[2].outside3dPlot?!1:b.apply(this,[].slice.call(arguments,1))});r.column.prototype.translate3dPoints=function(){};r.column.prototype.translate3dShapes=function(){var b=this,l=b.chart,a=b.options,f=a.depth||25,h=(a.stacking?a.stack||0:b.index)*(f+(a.groupZPadding||1)),k=b.borderWidth%2?.5:0;l.inverted&&!b.yAxis.reversed&&(k*=-1);!1!==a.grouping&&(h=0);h+=a.groupZPadding||1;b.data.forEach(function(a){a.outside3dPlot=null;if(null!==a.y){var c=a.shapeArgs,
d=a.tooltipPos,n;[["x","width"],["y","height"]].forEach(function(d){n=c[d[0]]-k;0>n&&(c[d[1]]+=c[d[0]]+k,c[d[0]]=-k,n=0);n+c[d[1]]>b[d[0]+"Axis"].len&&0!==c[d[1]]&&(c[d[1]]=b[d[0]+"Axis"].len-c[d[0]]);if(0!==c[d[1]]&&(c[d[0]]>=b[d[0]+"Axis"].len||c[d[0]]+c[d[1]]<=k)){for(var f in c)c[f]=0;a.outside3dPlot=!0}});"rect"===a.shapeType&&(a.shapeType="cuboid");c.z=h;c.depth=f;c.insidePlotArea=!0;d=g([{x:d[0],y:d[1],z:h}],l,!0)[0];a.tooltipPos=[d.x,d.y]}});b.z=h};x(r.column.prototype,"animate",function(b){if(this.chart.is3d()){var g=
arguments[1],a=this.yAxis,f=this,h=this.yAxis.reversed;w&&(g?f.data.forEach(function(b){null!==b.y&&(b.height=b.shapeArgs.height,b.shapey=b.shapeArgs.y,b.shapeArgs.height=1,h||(b.shapeArgs.y=b.stackY?b.plotY+a.translate(b.stackY):b.plotY+(b.negative?-b.height:b.height)))}):(f.data.forEach(function(a){null!==a.y&&(a.shapeArgs.height=a.height,a.shapeArgs.y=a.shapey,a.graphic&&a.graphic.animate(a.shapeArgs,f.options.animation))}),this.drawDataLabels(),f.animate=null))}else b.apply(this,[].slice.call(arguments,
1))});x(r.column.prototype,"plotGroup",function(b,g,a,f,h,k){this.chart.is3d()&&(this[g]&&delete this[g],k&&(this.chart.columnGroup||(this.chart.columnGroup=this.chart.renderer.g("columnGroup").add(k)),this[g]=this.chart.columnGroup,this.chart.columnGroup.attr(this.getPlotBox()),this[g].survive=!0,"group"===g||"markerGroup"===g))&&(arguments[3]="visible");return b.apply(this,Array.prototype.slice.call(arguments,1))});x(r.column.prototype,"setVisible",function(b,g){var a=this,f;a.chart.is3d()&&a.data.forEach(function(b){f=
(b.visible=b.options.visible=g=void 0===g?!v(a.visible,b.visible):g)?"visible":"hidden";a.options.data[a.data.indexOf(b)]=b.options;b.graphic&&b.graphic.attr({visibility:f})});b.apply(this,Array.prototype.slice.call(arguments,1))});r.column.prototype.handle3dGrouping=!0;q(A,"afterInit",function(){if(this.chart.is3d()&&this.handle3dGrouping){var b=this.options,g=b.grouping,a=b.stacking,f=v(this.yAxis.options.reversedStacks,!0),h=0;if(void 0===g||g){g=this.chart.retrieveStacks(a);h=b.stack||0;for(a=
0;a<g[h].series.length&&g[h].series[a]!==this;a++);h=10*(g.totalStacks-g[h].position)+(f?a:-a);this.xAxis.reversed||(h=10*g.totalStacks-h)}b.zIndex=h}});x(r.column.prototype,"pointAttribs",t);x(r.column.prototype,"setState",u);r.columnrange&&(x(r.columnrange.prototype,"pointAttribs",t),x(r.columnrange.prototype,"setState",u),r.columnrange.prototype.plotGroup=r.column.prototype.plotGroup,r.columnrange.prototype.setVisible=r.column.prototype.setVisible);x(A.prototype,"alignDataLabel",function(b){if(this.chart.is3d()&&
this instanceof r.column){var l=arguments,a=l[4];l=l[1];var f={x:a.x,y:a.y,z:this.z};f=g([f],this.chart,!0)[0];a.x=f.x;a.y=l.outside3dPlot?-9E9:f.y}b.apply(this,[].slice.call(arguments,1))});x(b.StackItem.prototype,"getStackBox",function(g,l){var a=g.apply(this,[].slice.call(arguments,1));if(l.is3d()){var f={x:a.x,y:a.y,z:0};f=b.perspective([f],l,!0)[0];a.x=f.x;a.y=f.y}return a})});B(u,"parts-3d/Pie.js",[u["parts/Globals.js"]],function(b){var t=b.deg2rad,u=b.pick,q=b.seriesTypes,g=b.svg;b=b.wrap;
b(q.pie.prototype,"translate",function(b){b.apply(this,[].slice.call(arguments,1));if(this.chart.is3d()){var g=this,r=g.options,q=r.depth||0,v=g.chart.options.chart.options3d,u=v.alpha,l=v.beta,a=r.stacking?(r.stack||0)*q:g._i*q;a+=q/2;!1!==r.grouping&&(a=0);g.data.forEach(function(b){var f=b.shapeArgs;b.shapeType="arc3d";f.z=a;f.depth=.75*q;f.alpha=u;f.beta=l;f.center=g.center;f=(f.end+f.start)/2;b.slicedTranslation={translateX:Math.round(Math.cos(f)*r.slicedOffset*Math.cos(u*t)),translateY:Math.round(Math.sin(f)*
r.slicedOffset*Math.cos(u*t))}})}});b(q.pie.prototype.pointClass.prototype,"haloPath",function(b){var g=arguments;return this.series.chart.is3d()?[]:b.call(this,g[1])});b(q.pie.prototype,"pointAttribs",function(b,g,r){b=b.call(this,g,r);r=this.options;this.chart.is3d()&&!this.chart.styledMode&&(b.stroke=r.edgeColor||g.color||this.color,b["stroke-width"]=u(r.edgeWidth,1));return b});b(q.pie.prototype,"drawDataLabels",function(b){if(this.chart.is3d()){var g=this.chart.options.chart.options3d;this.data.forEach(function(b){var q=
b.shapeArgs,r=q.r,v=(q.start+q.end)/2;b=b.labelPosition;var l=b.connectorPosition,a=-r*(1-Math.cos((q.alpha||g.alpha)*t))*Math.sin(v),f=r*(Math.cos((q.beta||g.beta)*t)-1)*Math.cos(v);[b.natural,l.breakAt,l.touchingSliceAt].forEach(function(b){b.x+=f;b.y+=a})})}b.apply(this,[].slice.call(arguments,1))});b(q.pie.prototype,"addPoint",function(b){b.apply(this,[].slice.call(arguments,1));this.chart.is3d()&&this.update(this.userOptions,!0)});b(q.pie.prototype,"animate",function(b){if(this.chart.is3d()){var q=
arguments[1],r=this.options.animation,v=this.center,t=this.group,u=this.markerGroup;g&&(!0===r&&(r={}),q?(t.oldtranslateX=t.translateX,t.oldtranslateY=t.translateY,q={translateX:v[0],translateY:v[1],scaleX:.001,scaleY:.001},t.attr(q),u&&(u.attrSetters=t.attrSetters,u.attr(q))):(q={translateX:t.oldtranslateX,translateY:t.oldtranslateY,scaleX:1,scaleY:1},t.animate(q,r),u&&u.animate(q,r),this.animate=null))}else b.apply(this,[].slice.call(arguments,1))})});B(u,"parts-3d/Scatter.js",[u["parts/Globals.js"]],
function(b){var t=b.Point,u=b.seriesType,q=b.seriesTypes;u("scatter3d","scatter",{tooltip:{pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>z: <b>{point.z}</b><br/>"}},{pointAttribs:function(g){var t=q.scatter.prototype.pointAttribs.apply(this,arguments);this.chart.is3d()&&g&&(t.zIndex=b.pointCameraDistance(g,this.chart));return t},axisTypes:["xAxis","yAxis","zAxis"],pointArrayMap:["x","y","z"],parallelArrays:["x","y","z"],directTouch:!0},{applyOptions:function(){t.prototype.applyOptions.apply(this,
arguments);void 0===this.z&&(this.z=0);return this}});""});B(u,"parts-3d/VMLRenderer.js",[u["parts/Globals.js"]],function(b){var t=b.addEvent,u=b.Axis,q=b.SVGRenderer,g=b.VMLRenderer;g&&(b.setOptions({animate:!1}),g.prototype.face3d=q.prototype.face3d,g.prototype.polyhedron=q.prototype.polyhedron,g.prototype.elements3d=q.prototype.elements3d,g.prototype.element3d=q.prototype.element3d,g.prototype.cuboid=q.prototype.cuboid,g.prototype.cuboidPath=q.prototype.cuboidPath,g.prototype.toLinePath=q.prototype.toLinePath,
g.prototype.toLineSegments=q.prototype.toLineSegments,g.prototype.arc3d=function(b){b=q.prototype.arc3d.call(this,b);b.css({zIndex:b.zIndex});return b},b.VMLRenderer.prototype.arc3dPath=b.SVGRenderer.prototype.arc3dPath,t(u,"render",function(){this.sideFrame&&(this.sideFrame.css({zIndex:0}),this.sideFrame.front.attr({fill:this.sideFrame.color}));this.bottomFrame&&(this.bottomFrame.css({zIndex:1}),this.bottomFrame.front.attr({fill:this.bottomFrame.color}));this.backFrame&&(this.backFrame.css({zIndex:0}),
this.backFrame.front.attr({fill:this.backFrame.color}))}))});B(u,"masters/highcharts-3d.src.js",[],function(){})});
//# sourceMappingURL=highcharts-3d.js.map
/*
 Highcharts JS v7.1.3 (2019-08-14)

 Exporting module

 (c) 2010-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(c){"object"===typeof module&&module.exports?(c["default"]=c,module.exports=c):"function"===typeof define&&define.amd?define("highcharts/modules/exporting",["highcharts"],function(k){c(k);c.Highcharts=k;return c}):c("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(c){function k(e,t,c,k){e.hasOwnProperty(t)||(e[t]=k.apply(null,c))}c=c?c._modules:{};k(c,"modules/full-screen.src.js",[c["parts/Globals.js"]],function(e){(e.FullScreen=function(e){this.init(e.parentNode)}).prototype=
{init:function(e){var c;e.requestFullscreen?c=e.requestFullscreen():e.mozRequestFullScreen?c=e.mozRequestFullScreen():e.webkitRequestFullscreen?c=e.webkitRequestFullscreen():e.msRequestFullscreen&&(c=e.msRequestFullscreen());if(c)c["catch"](function(){alert("Full screen is not supported inside a frame")})}}});k(c,"mixins/navigation.js",[],function(){return{initUpdate:function(e){e.navigation||(e.navigation={updates:[],update:function(e,c){this.updates.forEach(function(t){t.update.call(t.context,e,
c)})}})},addUpdate:function(e,c){c.navigation||this.initUpdate(c);c.navigation.updates.push({update:e,context:c})}}});k(c,"modules/exporting.src.js",[c["parts/Globals.js"],c["parts/Utilities.js"],c["mixins/navigation.js"]],function(e,c,k){var t=c.isObject,E=c.objectEach;c=e.defaultOptions;var z=e.doc,C=e.Chart,y=e.addEvent,J=e.removeEvent,D=e.fireEvent,w=e.createElement,F=e.discardElement,u=e.css,p=e.merge,q=e.pick,x=e.extend,K=e.isTouchDevice,A=e.win,H=A.navigator.userAgent,G=e.SVGRenderer,I=e.Renderer.prototype.symbols,
L=/Edge\/|Trident\/|MSIE /.test(H),M=/firefox/i.test(H);x(c.lang,{viewFullscreen:"View in full screen",printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});c.navigation||(c.navigation={});p(!0,c.navigation,{buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}});
p(!0,c.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",color:"#333333",background:"none",fontSize:K?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}}});c.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",
menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:"viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen=new e.FullScreen(this.container)}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",
onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};e.post=function(a,b,f){var d=w("form",p({method:"post",action:a,enctype:"multipart/form-data"},f),{display:"none"},z.body);E(b,function(b,a){w("input",{type:"hidden",name:a,value:b},null,d)});d.submit();F(d)};x(C.prototype,{sanitizeSVG:function(a,
b){var f=a.indexOf("</svg>")+6,d=a.substr(f);a=a.substr(0,f);b&&b.exporting&&b.exporting.allowHTML&&d&&(d='<foreignObject x="0" y="0" width="'+b.chart.width+'" height="'+b.chart.height+'"><body xmlns="http://www.w3.org/1999/xhtml">'+d+"</body></foreignObject>",a=a.replace("</svg>",d+"</svg>"));a=a.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(.*?)("|&quot;);?\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,
'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+:)href=/g," xlink:href=").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){this.styledMode&&this.inlineStyles();return this.container.innerHTML},getSVG:function(a){var b,f=p(this.options,a);f.plotOptions=p(this.userOptions.plotOptions,
a&&a.plotOptions);var d=w("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},z.body);var c=this.renderTo.style.width;var r=this.renderTo.style.height;c=f.exporting.sourceWidth||f.chart.width||/px$/.test(c)&&parseInt(c,10)||(f.isGantt?800:600);r=f.exporting.sourceHeight||f.chart.height||/px$/.test(r)&&parseInt(r,10)||400;x(f.chart,{animation:!1,renderTo:d,forExport:!0,renderer:"SVGRenderer",width:c,height:r});f.exporting.enabled=!1;delete f.data;
f.series=[];this.series.forEach(function(a){b=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});b.isInternal||f.series.push(b)});this.axes.forEach(function(b){b.userOptions.internalKey||(b.userOptions.internalKey=e.uniqueKey())});var l=new e.Chart(f,this.callback);a&&["xAxis","yAxis","series"].forEach(function(b){var d={};a[b]&&(d[b]=a[b],l.update(d))});this.axes.forEach(function(b){var a=e.find(l.axes,function(a){return a.options.internalKey===b.userOptions.internalKey}),
d=b.getExtremes(),f=d.userMin;d=d.userMax;a&&(void 0!==f&&f!==a.min||void 0!==d&&d!==a.max)&&a.setExtremes(f,d,!0,!1)});c=l.getChartHTML();D(this,"getSVG",{chartCopy:l});c=this.sanitizeSVG(c,f);f=null;l.destroy();F(d);return c},getSVGForExport:function(a,b){var f=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},f.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||f.sourceWidth,sourceHeight:a&&a.sourceHeight||f.sourceHeight}}))},getFilename:function(){var a=this.userOptions.title&&
this.userOptions.title.text,b=this.options.exporting.filename;if(b)return b;"string"===typeof a&&(b=a.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,24).replace(/[\-]+$/g,""));if(!b||5>b.length)b="chart";return b},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=p(this.options.exporting,a);e.post(a.url,{filename:a.filename||this.getFilename(),type:a.type,width:a.width||0,scale:a.scale,svg:b},
a.formAttributes)},print:function(){function a(a){(b.fixedDiv?[b.fixedDiv,b.scrollingContainer]:[b.container]).forEach(function(b){a.appendChild(b)})}var b=this,f=[],d=z.body,c=d.childNodes,e=b.options.exporting.printMaxWidth,l;if(!b.isPrinting){b.isPrinting=!0;b.pointer.reset(null,0);D(b,"beforePrint");if(l=e&&b.chartWidth>e){var g=[b.options.chart.width,void 0,!1];b.setSize(e,void 0,!1)}[].forEach.call(c,function(b,a){1===b.nodeType&&(f[a]=b.style.display,b.style.display="none")});a(d);setTimeout(function(){A.focus();
A.print();setTimeout(function(){a(b.renderTo);[].forEach.call(c,function(b,a){1===b.nodeType&&(b.style.display=f[a])});b.isPrinting=!1;l&&b.setSize.apply(b,g);D(b,"afterPrint")},1E3)},1)}},contextMenu:function(a,b,f,d,c,r,l){var g=this,m=g.options.navigation,p=g.chartWidth,B=g.chartHeight,n="cache-"+a,h=g[n],v=Math.max(c,r);if(!h){g.exportContextMenu=g[n]=h=w("div",{className:a},{position:"absolute",zIndex:1E3,padding:v+"px",pointerEvents:"auto"},g.fixedDiv||g.container);var k=w("div",{className:"highcharts-menu"},
null,h);g.styledMode||u(k,x({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},m.menuStyle));h.hideMenu=function(){u(h,{display:"none"});l&&l.setState(0);g.openMenu=!1;u(g.renderTo,{overflow:"hidden"});e.clearTimeout(h.hideTimer);D(g,"exportMenuHidden")};g.exportEvents.push(y(h,"mouseleave",function(){h.hideTimer=setTimeout(h.hideMenu,500)}),y(h,"mouseenter",function(){e.clearTimeout(h.hideTimer)}),y(z,"mouseup",function(b){g.pointer.inClass(b.target,
a)||h.hideMenu()}),y(h,"click",function(){g.openMenu&&h.hideMenu()}));b.forEach(function(b){"string"===typeof b&&(b=g.options.exporting.menuItemDefinitions[b]);if(t(b,!0)){if(b.separator)var a=w("hr",null,null,k);else a=w("div",{className:"highcharts-menu-item",onclick:function(a){a&&a.stopPropagation();h.hideMenu();b.onclick&&b.onclick.apply(g,arguments)},innerHTML:b.text||g.options.lang[b.textKey]},null,k),g.styledMode||(a.onmouseover=function(){u(this,m.menuItemHoverStyle)},a.onmouseout=function(){u(this,
m.menuItemStyle)},u(a,x({cursor:"pointer"},m.menuItemStyle)));g.exportDivElements.push(a)}});g.exportDivElements.push(k,h);g.exportMenuWidth=h.offsetWidth;g.exportMenuHeight=h.offsetHeight}b={display:"block"};f+g.exportMenuWidth>p?b.right=p-f-c-v+"px":b.left=f-v+"px";d+r+g.exportMenuHeight>B&&"top"!==l.alignOptions.verticalAlign?b.bottom=B-d-v+"px":b.top=d+r-v+"px";u(h,b);u(g.renderTo,{overflow:""});g.openMenu=!0},addButton:function(a){var b=this,f=b.renderer,d=p(b.options.navigation.buttonOptions,
a),c=d.onclick,e=d.menuItems,l=d.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==d.enabled){var g=d.theme,m=g.states,k=m&&m.hover;m=m&&m.select;var B;b.styledMode||(g.fill=q(g.fill,"#ffffff"),g.stroke=q(g.stroke,"none"));delete g.states;c?B=function(a){a&&a.stopPropagation();c.call(b,a)}:e&&(B=function(a){a&&a.stopPropagation();b.contextMenu(n.menuClassName,e,n.translateX,n.translateY,n.width,n.height,n);n.setState(2)});d.text&&
d.symbol?g.paddingLeft=q(g.paddingLeft,25):d.text||x(g,{width:d.width,height:d.height,padding:0});b.styledMode||(g["stroke-linecap"]="round",g.fill=q(g.fill,"#ffffff"),g.stroke=q(g.stroke,"none"));var n=f.button(d.text,0,0,B,g,k,m).addClass(a.className).attr({title:q(b.options.lang[d._titleKey||d.titleKey],"")});n.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;if(d.symbol){var h=f.symbol(d.symbol,d.symbolX-l/2,d.symbolY-l/2,l,l,{width:l,height:l}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(n);
b.styledMode||h.attr({stroke:d.symbolStroke,fill:d.symbolFill,"stroke-width":d.symbolStrokeWidth||1})}n.add(b.exportingGroup).align(x(d,{width:n.width,x:q(d.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(n.width+d.buttonSpacing)*("right"===d.align?-1:1);b.exportSVGElements.push(n,h)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var f=b.exportDivElements,d=b.exportEvents,c;a&&(a.forEach(function(a,d){a&&(a.onclick=a.ontouchstart=null,c="cache-"+a.menuClassName,b[c]&&
delete b[c],b.exportSVGElements[d]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);f&&(f.forEach(function(a,d){e.clearTimeout(a.hideTimer);J(a,"mouseleave");b.exportDivElements[d]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;F(a)}),f.length=0);d&&(d.forEach(function(a){a()}),d.length=0)}});G.prototype.inlineToAttributes="fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");G.prototype.inlineBlacklist=[/-/,/^(clipPath|cssText|d|height|width)$/,
/^font$/,/[lL]ogical(Width|Height)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/];G.prototype.unstyledElements=["clipPath","defs","desc"];C.prototype.inlineStyles=function(){function a(a){return a.replace(/([A-Z])/g,function(a,b){return"-"+b.toLowerCase()})}function b(c){function f(b,f){v=u=!1;if(k){for(r=k.length;r--&&!u;)u=k[r].test(f);v=!u}"transform"===f&&"none"===b&&(v=!0);for(r=e.length;r--&&!v;)v=e[r].test(f)||"function"===typeof b;v||y[f]===b&&"svg"!==c.nodeName||g[c.nodeName][f]===
b||(-1!==d.indexOf(f)?c.setAttribute(a(f),b):h+=a(f)+":"+b+";")}var h="",v,u,r;if(1===c.nodeType&&-1===l.indexOf(c.nodeName)){var t=A.getComputedStyle(c,null);var y="svg"===c.nodeName?{}:A.getComputedStyle(c.parentNode,null);if(!g[c.nodeName]){m=q.getElementsByTagName("svg")[0];var w=q.createElementNS(c.namespaceURI,c.nodeName);m.appendChild(w);g[c.nodeName]=p(A.getComputedStyle(w,null));"text"===c.nodeName&&delete g.text.fill;m.removeChild(w)}if(M||L)for(var x in t)f(t[x],x);else E(t,f);h&&(t=c.getAttribute("style"),
c.setAttribute("style",(t?t+";":"")+h));"svg"===c.nodeName&&c.setAttribute("stroke-width","1px");"text"!==c.nodeName&&[].forEach.call(c.children||c.childNodes,b)}}var c=this.renderer,d=c.inlineToAttributes,e=c.inlineBlacklist,k=c.inlineWhitelist,l=c.unstyledElements,g={},m;c=z.createElement("iframe");u(c,{width:"1px",height:"1px",visibility:"hidden"});z.body.appendChild(c);var q=c.contentWindow.document;q.open();q.write('<svg xmlns="http://www.w3.org/2000/svg"></svg>');q.close();b(this.container.querySelector("svg"));
m.parentNode.removeChild(m)};I.menu=function(a,b,c,d){return["M",a,b+2.5,"L",a+c,b+2.5,"M",a,b+d/2+.5,"L",a+c,b+d/2+.5,"M",a,b+d-1.5,"L",a+c,b+d-1.5]};I.menuball=function(a,b,c,d){a=[];d=d/3-2;return a=a.concat(this.circle(c-d,b,d,d),this.circle(c-d,b+d+4,d,d),this.circle(c-d,b+2*(d+4),d,d))};C.prototype.renderExporting=function(){var a=this,b=a.options.exporting,c=b.buttons,d=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();d&&!1!==b.enabled&&(a.exportEvents=
[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),E(c,function(b){a.addButton(b)}),a.isDirtyExporting=!1);y(a,"destroy",a.destroyExport)};y(C,"init",function(){var a=this;a.exporting={update:function(b,c){a.isDirtyExporting=!0;p(!0,a.options.exporting,b);q(c,!0)&&a.redraw()}};k.addUpdate(function(b,c){a.isDirtyExporting=!0;p(!0,a.options.navigation,b);q(c,!0)&&a.redraw()},a)});C.prototype.callbacks.push(function(a){a.renderExporting();y(a,"redraw",a.renderExporting)})});
k(c,"masters/modules/exporting.src.js",[],function(){})});
//# sourceMappingURL=exporting.js.map
/*
 Highcharts JS v7.1.3 (2019-08-14)

 Exporting module

 (c) 2010-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(b){"object"===typeof module&&module.exports?(b["default"]=b,module.exports=b):"function"===typeof define&&define.amd?define("highcharts/modules/export-data",["highcharts","highcharts/modules/exporting"],function(m){b(m);b.Highcharts=m;return b}):b("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(b){function m(a,c,b,E){a.hasOwnProperty(c)||(a[c]=E.apply(null,b))}b=b?b._modules:{};m(b,"mixins/ajax.js",[b["parts/Globals.js"],b["parts/Utilities.js"]],function(a,c){var b=c.objectEach;
a.ajax=function(c){var h=a.merge(!0,{url:!1,type:"get",dataType:"json",success:!1,error:!1,data:!1,headers:{}},c);c={json:"application/json",xml:"application/xml",text:"text/plain",octet:"application/octet-stream"};var f=new XMLHttpRequest;if(!h.url)return!1;f.open(h.type.toUpperCase(),h.url,!0);h.headers["Content-Type"]||f.setRequestHeader("Content-Type",c[h.dataType]||c.text);b(h.headers,function(e,a){f.setRequestHeader(a,e)});f.onreadystatechange=function(){if(4===f.readyState){if(200===f.status){var a=
f.responseText;if("json"===h.dataType)try{a=JSON.parse(a)}catch(n){h.error&&h.error(f,n);return}return h.success&&h.success(a)}h.error&&h.error(f,f.responseText)}};try{h.data=JSON.stringify(h.data)}catch(e){}f.send(h.data||!0)};a.getJSON=function(c,b){a.ajax({url:c,success:b,dataType:"json",headers:{"Content-Type":"text/plain"}})}});m(b,"mixins/download-url.js",[b["parts/Globals.js"]],function(a){var c=a.win,b=c.navigator,m=c.document,h=c.URL||c.webkitURL||c,f=/Edge\/\d+/.test(b.userAgent);a.dataURLtoBlob=
function(a){if((a=a.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/))&&3<a.length&&c.atob&&c.ArrayBuffer&&c.Uint8Array&&c.Blob&&h.createObjectURL){var b=c.atob(a[3]),e=new c.ArrayBuffer(b.length);e=new c.Uint8Array(e);for(var f=0;f<e.length;++f)e[f]=b.charCodeAt(f);a=new c.Blob([e],{type:a[1]});return h.createObjectURL(a)}};a.downloadURL=function(e,h){var d=m.createElement("a");if("string"===typeof e||e instanceof String||!b.msSaveOrOpenBlob){if(f||2E6<e.length)if(e=a.dataURLtoBlob(e),!e)throw Error("Failed to convert to blob");
if(void 0!==d.download)d.href=e,d.download=h,m.body.appendChild(d),d.click(),m.body.removeChild(d);else try{var n=c.open(e,"chart");if(void 0===n||null===n)throw Error("Failed to open window");}catch(y){c.location.href=e}}else b.msSaveOrOpenBlob(e,h)}});m(b,"modules/export-data.src.js",[b["parts/Globals.js"],b["parts/Utilities.js"]],function(a,c){function b(a,b){var c=e.navigator,q=-1<c.userAgent.indexOf("WebKit")&&0>c.userAgent.indexOf("Chrome"),l=e.URL||e.webkitURL||e;try{if(c.msSaveOrOpenBlob&&
e.MSBlobBuilder){var f=new e.MSBlobBuilder;f.append(a);return f.getBlob("image/svg+xml")}if(!q)return l.createObjectURL(new e.Blob(["\ufeff"+a],{type:b}))}catch(F){}}var m=c.defined,h=c.isObject,f=a.pick,e=a.win,n=e.document,d=a.seriesTypes,C=a.downloadURL,y=a.fireEvent;a.setOptions({exporting:{csv:{columnHeaderFormatter:null,dateFormat:"%Y-%m-%d %H:%M:%S",decimalPoint:null,itemDelimiter:null,lineDelimiter:"\n"},showTable:!1,useMultiLevelHeaders:!0,useRowspanHeaders:!0},lang:{downloadCSV:"Download CSV",
downloadXLS:"Download XLS",openInCloud:"Open in Highcharts Cloud",viewData:"View data table"}});a.addEvent(a.Chart,"render",function(){this.options&&this.options.exporting&&this.options.exporting.showTable&&!this.options.chart.forExport&&this.viewData()});a.Chart.prototype.setUpKeyToAxis=function(){d.arearange&&(d.arearange.prototype.keyToAxis={low:"y",high:"y"});d.gantt&&(d.gantt.prototype.keyToAxis={start:"x",end:"x"})};a.Chart.prototype.getDataRows=function(b){var c=this.time,e=this.options.exporting&&
this.options.exporting.csv||{},h=this.xAxis,l={},q=[],d=[],A=[],w,t=function(k,c,g){if(e.columnHeaderFormatter){var l=e.columnHeaderFormatter(k,c,g);if(!1!==l)return l}return k?k instanceof a.Axis?k.options.title&&k.options.title.text||(k.isDatetimeAxis?"DateTime":"Category"):b?{columnTitle:1<g?c:k.name,topLevelColumnTitle:k.name}:k.name+(1<g?" ("+c+")":""):"Category"},u=[];var v=0;this.setUpKeyToAxis();this.series.forEach(function(k){var g=k.options.keys||k.pointArrayMap||["y"],q=g.length,r=!k.requireSorting&&
{},D={},x={},z=h.indexOf(k.xAxis),p;g.forEach(function(a){var g=(k.keyToAxis&&k.keyToAxis[a]||a)+"Axis";D[a]=k[g]&&k[g].categories||[];x[a]=k[g]&&k[g].isDatetimeAxis});if(!1!==k.options.includeInDataExport&&!k.options.isInternal&&!1!==k.visible){a.find(u,function(a){return a[0]===z})||u.push([z,v]);for(p=0;p<q;)w=t(k,g[p],g.length),A.push(w.columnTitle||w),b&&d.push(w.topLevelColumnTitle||w),p++;var m={chart:k.chart,autoIncrement:k.autoIncrement,options:k.options,pointArrayMap:k.pointArrayMap};k.options.data.forEach(function(a,
b){var h={series:m};k.pointClass.prototype.applyOptions.apply(h,[a]);a=h.x;var d=k.data[b]&&k.data[b].name;p=0;k.xAxis&&"name"!==k.exportKey||(a=d);r&&(r[a]&&(a+="|"+b),r[a]=!0);l[a]||(l[a]=[],l[a].xValues=[]);l[a].x=h.x;l[a].name=d;for(l[a].xValues[z]=h.x;p<q;)b=g[p],d=h[b],l[a][v+p]=f(D[b][d],x[b]?c.dateFormat(e.dateFormat,d):null,d),p++});v+=p}});for(g in l)l.hasOwnProperty(g)&&q.push(l[g]);var g=b?[d,A]:[A];for(v=u.length;v--;){var B=u[v][0];var p=u[v][1];var r=h[B];q.sort(function(a,b){return a.xValues[B]-
b.xValues[B]});var x=t(r);g[0].splice(p,0,x);b&&g[1]&&g[1].splice(p,0,x);q.forEach(function(a){var b=a.name;r&&!m(b)&&(r.isDatetimeAxis?(a.x instanceof Date&&(a.x=a.x.getTime()),b=c.dateFormat(e.dateFormat,a.x)):b=r.categories?f(r.names[a.x],r.categories[a.x],a.x):a.x);a.splice(p,0,b)})}g=g.concat(q);y(this,"exportData",{dataRows:g});return g};a.Chart.prototype.getCSV=function(a){var b="",c=this.getDataRows(),e=this.options.exporting.csv,h=f(e.decimalPoint,","!==e.itemDelimiter&&a?(1.1).toLocaleString()[1]:
"."),q=f(e.itemDelimiter,","===h?";":","),d=e.lineDelimiter;c.forEach(function(a,e){for(var f,l=a.length;l--;)f=a[l],"string"===typeof f&&(f='"'+f+'"'),"number"===typeof f&&"."!==h&&(f=f.toString().replace(".",h)),a[l]=f;b+=a.join(q);e<c.length-1&&(b+=d)});return b};a.Chart.prototype.getTable=function(a){var b='<table id="highcharts-data-table-'+this.index+'">',c=this.options,e=a?(1.1).toLocaleString()[1]:".",h=f(c.exporting.useMultiLevelHeaders,!0);a=this.getDataRows(h);var d=0,q=h?a.shift():null,
m=a.shift(),n=function(a,b,c,h){var g=f(h,"");b="text"+(b?" "+b:"");"number"===typeof g?(g=g.toString(),","===e&&(g=g.replace(".",e)),b="number"):h||(b="empty");return"<"+a+(c?" "+c:"")+' class="'+b+'">'+g+"</"+a+">"};!1!==c.exporting.tableCaption&&(b+='<caption class="highcharts-table-caption">'+f(c.exporting.tableCaption,c.title.text?c.title.text.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"):"Chart")+"</caption>");
for(var t=0,u=a.length;t<u;++t)a[t].length>d&&(d=a[t].length);b+=function(a,b,e){var f="<thead>",g=0;e=e||b&&b.length;var d,k=0;if(d=h&&a&&b){a:if(d=a.length,b.length===d){for(;d--;)if(a[d]!==b[d]){d=!1;break a}d=!0}else d=!1;d=!d}if(d){for(f+="<tr>";g<e;++g){d=a[g];var l=a[g+1];d===l?++k:k?(f+=n("th","highcharts-table-topheading",'scope="col" colspan="'+(k+1)+'"',d),k=0):(d===b[g]?c.exporting.useRowspanHeaders?(l=2,delete b[g]):(l=1,b[g]=""):l=1,f+=n("th","highcharts-table-topheading",'scope="col"'+
(1<l?' valign="top" rowspan="'+l+'"':""),d))}f+="</tr>"}if(b){f+="<tr>";g=0;for(e=b.length;g<e;++g)void 0!==b[g]&&(f+=n("th",null,'scope="col"',b[g]));f+="</tr>"}return f+"</thead>"}(q,m,Math.max(d,m.length));b+="<tbody>";a.forEach(function(a){b+="<tr>";for(var c=0;c<d;c++)b+=n(c?"td":"th",null,c?"":'scope="row"',a[c]);b+="</tr>"});b+="</tbody></table>";a={html:b};y(this,"afterGetTable",a);return a.html};a.Chart.prototype.downloadCSV=function(){var a=this.getCSV(!0);C(b(a,"text/csv")||"data:text/csv,\ufeff"+
encodeURIComponent(a),this.getFilename()+".csv")};a.Chart.prototype.downloadXLS=function(){var a='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>'+
this.getTable(!0)+"</body></html>";C(b(a,"application/vnd.ms-excel")||"data:application/vnd.ms-excel;base64,"+e.btoa(unescape(encodeURIComponent(a))),this.getFilename()+".xls")};a.Chart.prototype.viewData=function(){this.dataTableDiv||(this.dataTableDiv=n.createElement("div"),this.dataTableDiv.className="highcharts-data-table",this.renderTo.parentNode.insertBefore(this.dataTableDiv,this.renderTo.nextSibling));this.dataTableDiv.innerHTML=this.getTable();y(this,"afterViewData",this.dataTableDiv)};a.Chart.prototype.openInCloud=
function(){function b(a){Object.keys(a).forEach(function(c){"function"===typeof a[c]&&delete a[c];h(a[c])&&b(a[c])})}var c=a.merge(this.userOptions);b(c);c={name:c.title&&c.title.text||"Chart title",options:c,settings:{constructor:"Chart",dataProvider:{csv:this.getCSV()}}};var d=JSON.stringify(c);(function(){var a=n.createElement("form");n.body.appendChild(a);a.method="post";a.action="https://cloud-api.highcharts.com/openincloud";a.target="_blank";var b=n.createElement("input");b.type="hidden";b.name=
"chart";b.value=d;a.appendChild(b);a.submit();n.body.removeChild(a)})()};if(c=a.getOptions().exporting)a.extend(c.menuItemDefinitions,{downloadCSV:{textKey:"downloadCSV",onclick:function(){this.downloadCSV()}},downloadXLS:{textKey:"downloadXLS",onclick:function(){this.downloadXLS()}},viewData:{textKey:"viewData",onclick:function(){this.viewData()}},openInCloud:{textKey:"openInCloud",onclick:function(){this.openInCloud()}}}),c.buttons&&c.buttons.contextButton.menuItems.push("separator","downloadCSV",
"downloadXLS","viewData","openInCloud");d.map&&(d.map.prototype.exportKey="name");d.mapbubble&&(d.mapbubble.prototype.exportKey="name");d.treemap&&(d.treemap.prototype.exportKey="name")});m(b,"masters/modules/export-data.src.js",[],function(){})});
//# sourceMappingURL=export-data.js.map
/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

//////////////////////////////////////////////////////////////////////////////

/** The main highcharts editor namespace
 * @ignore
 */
var highed = {
  schemas: {},
  meta: {
    chartTemplates: {},
    fonts: []
  },
  plugins: {},

  resources: {
    logo:
      '<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"     width="425.197px" height="141.732px" viewBox="0 0 425.197 141.732" enable-background="new 0 0 425.197 141.732"     xml:space="preserve"><g>    <path fill="#eeeaea" d="M138.475,69.712h-17.02v9.77c0,1.037-0.813,1.851-1.849,1.851c-1.037,0-1.85-0.813-1.85-1.851V57.725        c0-1.037,0.813-1.852,1.85-1.852c1.036,0,1.849,0.813,1.849,1.852v8.436h17.02v-8.436c0-1.037,0.814-1.852,1.85-1.852        c1.036,0,1.85,0.813,1.85,1.852v21.754c0,1.037-0.814,1.851-1.85,1.851c-1.036,0-1.85-0.813-1.85-1.851V69.712z"/>    <path fill="#eeeaea" d="M156.973,79.479c0,1.037-0.814,1.851-1.852,1.851s-1.852-0.813-1.852-1.851V57.725        c0-1.037,0.814-1.852,1.852-1.852s1.852,0.813,1.852,1.852V79.479z"/>    <path fill="#eeeaea" d="M184.125,70.378c0-1.036,0.814-1.774,1.852-1.774c1.034,0,1.852,0.813,1.852,1.849v5.847        c0,0.444-0.226,1.109-0.595,1.479c-2.367,2.369-5.549,3.773-9.176,3.773c-7.178,0-12.949-5.771-12.949-12.948        c0-7.181,5.771-12.949,12.949-12.949c3.627,0,6.809,1.405,9.176,3.771c0.738,0.74,0.738,1.852,0,2.592        c-0.741,0.738-1.922,0.813-2.663,0.072c-1.702-1.699-3.923-2.736-6.513-2.736c-5.104,0-9.249,4.144-9.249,9.25        c0,5.104,4.146,9.25,9.249,9.25c2.367,0,4.441-0.813,6.067-2.222V70.378z"/>    <path fill="#eeeaea" d="M218.162,69.712h-17.019v9.77c0,1.037-0.817,1.851-1.852,1.851c-1.037,0-1.849-0.813-1.849-1.851V57.725        c0-1.037,0.812-1.852,1.849-1.852c1.034,0,1.852,0.813,1.852,1.852v8.436h17.019v-8.436c0-1.037,0.813-1.852,1.849-1.852        c1.037,0,1.852,0.813,1.852,1.852v21.754c0,1.037-0.813,1.851-1.852,1.851c-1.033,0-1.849-0.813-1.849-1.851V69.712z"/>    <path fill="#eeeaea" d="M242.948,81.552c-7.182,0-12.949-5.771-12.949-12.948c0-7.181,5.77-12.949,12.949-12.949        c3.627,0,6.809,1.405,9.176,3.771c0.738,0.74,0.738,1.852,0,2.592c-0.741,0.738-1.925,0.813-2.666,0.072        c-1.699-1.699-3.92-2.736-6.51-2.736c-5.106,0-9.249,4.144-9.249,9.25c0,5.104,4.143,9.25,9.249,9.25        c2.59,0,4.884-0.962,6.586-2.664c0.74-0.741,1.849-0.741,2.59,0c0.738,0.738,0.738,1.85,0,2.589        C249.756,80.146,246.574,81.552,242.948,81.552z"/>    <path fill="#eeeaea" d="M281.569,69.712h-17.02v9.77c0,1.037-0.813,1.851-1.852,1.851c-1.034,0-1.85-0.813-1.85-1.851V57.725        c0-1.037,0.813-1.852,1.85-1.852c1.035,0,1.852,0.813,1.852,1.852v8.436h17.02v-8.436c0-1.037,0.813-1.852,1.853-1.852        c1.034,0,1.849,0.813,1.849,1.852v21.754c0,1.037-0.813,1.851-1.849,1.851c-1.037,0-1.853-0.813-1.853-1.851V69.712z"/>    <path fill="#eeeaea" d="M308.758,57.503l10.507,20.646c0.223,0.443,0.445,1.036,0.445,1.554c0,1.036-0.668,1.628-1.702,1.628        c-0.741,0-1.481-0.222-2.001-1.258l-3.253-6.438h-13.547l-3.183,6.438c-0.517,1.036-1.256,1.258-1.994,1.258        c-1.037,0-1.702-0.593-1.702-1.628c0-0.519,0.22-1.109,0.442-1.554l10.506-20.646c0.668-1.405,2.002-1.628,2.74-1.628        C306.76,55.875,308.09,56.096,308.758,57.503z M300.985,70.083h9.988l-4.957-9.99L300.985,70.083z"/>    <path fill="#eeeaea" d="M340.159,56.023c4.441,0,8.064,3.255,8.064,7.694c0,3.923-2.813,6.884-6.511,7.549l6.731,7.104        c0.664,0.666,0.889,1.85,0.146,2.516c-0.736,0.741-2.145,0.521-2.886-0.296l-8.729-9.176h-6.511v8.142        c0,1.034-0.815,1.774-1.854,1.774c-1.033,0-1.85-0.813-1.85-1.851V57.873c0-1.035,0.814-1.85,1.85-1.85H340.159z M330.468,59.575        v8.288h9.691c2.59,0,4.367-1.776,4.367-4.146c0-2.365-1.777-4.144-4.367-4.144L330.468,59.575L330.468,59.575z"/>    <path fill="#eeeaea" d="M365.047,59.575h-9.249c-1.033,0-1.849-0.74-1.849-1.776c0-1.034,0.813-1.773,1.849-1.773h22.201        c1.037,0,1.852,0.74,1.852,1.773c0,1.037-0.813,1.776-1.852,1.776h-9.249V79.48c0,1.037-0.813,1.851-1.849,1.851        c-1.037,0-1.854-0.813-1.854-1.851V59.575z"/>    <path fill="#eeeaea" d="M388.724,66.013c0-9.25,5.698-10.359,9.99-10.359c1.035,0,1.85,0.813,1.85,1.85        c0,1.036-0.813,1.851-1.85,1.851c-3.479,0-6.29,0.738-6.29,6.66v5.18c0,9.25-5.698,10.358-9.989,10.358        c-1.035,0-1.85-0.813-1.85-1.85s0.814-1.85,1.85-1.85c3.479,0,6.289-0.74,6.289-6.66V66.013z"/></g><polygon fill="#8087E8" points="67.981,30.52 56.757,56.73 42.009,91.171 76.301,76.685 94.465,69.013 "/><polygon fill="#30426B" points="73.7,62.25 76.302,76.685 94.466,69.013 "/><polygon fill="#6699A1" points="67.981,30.52 73.7,62.251 94.465,69.013 "/><polygon fill="#78758C" points="73.7,62.25 94.466,69.013 56.758,56.729 42.009,91.171 76.302,76.685 "/><polygon fill="#A3EDBA" points="42.009,91.171 56.757,56.73 26.442,46.855 "/><polygon fill="#6699A1" points="76.302,76.685 79.628,95.13 94.466,69.013 "/><polygon fill="#8087E8" points="67.981,30.52 56.757,56.73 73.7,62.251 "/></svg>'
  },

  /** Trigger file download
   *  @namespace highed
   *  @param filename {string} - the filename
   *  @param data {string} - the contained data
   */
  download: function(filename, data, mime) {
    var l = highed.dom.cr('a');
    mime = mime || 'application/octet-stream';
    l.download = filename || 'unkown';
    l.href = 'data:' + mime + ',' + encodeURIComponent(data);
    highed.dom.ap(document.body, l);
    l.click();
    document.body.removeChild(l);
  },

  /** Clear an object
   * Deletes all the object attributes.
   * Useful when needing to clear an object without invalidating references to it
   * @namespace highed
   * @param obj {object} - the object to clear
   */
  clearObj: function(obj) {
    Object.keys(obj).forEach(function(key) {
      delete obj[key];
    });
  },

  /** Preform an AJAX request. Same syntax as jQuery.
   *  @namespace highed
   *  @param p {object} - options
   *    > url {string} - the URL to call
   *    > type {enum} - the type of request
   *    > dataType {enum} - the type of data expected
   *    > success {function} - function to call on success
   *    > error {function} - function to call on request fail
   *    > data {object} - the payload
   *    > autoFire {boolean} - whether or not to fire the request right away
   *
   *   @emits Error {string} - when there's an error
   *   @emits OK {string} - when the request succeeded
   *   @returns {object} - interface to the request
   */
  ajax: function(p) {
    var props = highed.merge(
        {
          url: false,
          type: 'GET',
          dataType: 'json',
          success: false,
          error: false,
          data: {},
          autoFire: true,
          headers: {}
        },
        p
      ),
      headers = {
        json: 'application/json',
        xml: 'application/xml',
        text: 'text/plain',
        octet: 'application/octet-stream'
      },
      r = new XMLHttpRequest(),
      events = highed.events();

    if (!props.url) return false;

    r.open(props.type, props.url, true);
    r.setRequestHeader('Content-Type', headers[props.dataType] || headers.text);

    Object.keys(props.headers).forEach(function(key) {
      r.setRequestHeader(key, props.headers[key]);
    });

    r.onreadystatechange = function() {
      events.emit('ReadyStateChange', r.readyState, r.status);

      if (r.readyState === 4 && r.status === 200) {
        if (props.dataType === 'json') {
          try {
            var json = JSON.parse(r.responseText);
            if (highed.isFn(props.success)) {
              props.success(json);
            }
            events.emit('OK', json);
          } catch (e) {
            console.log('parse error', e);
            if (highed.isFn(props.error)) {
              props.error(e.toString(), r.responseText);
            }
            events.emit('Error', e.toString(), r.status);
          }
        } else {
          if (highed.isFn(props.success)) {
            props.success(r.responseText);
          }
          events.emit('OK', r.responseText);
        }
      } else if (r.readyState === 4) {
        events.emit('Error', r.status, r.statusText);
        if (highed.isFn(props.error)) {
          props.error(r.status, r.statusText);
        }
      }
    };

    function fire() {
      try {
        r.send(JSON.stringify(props.data));
      } catch (e) {
        r.send(props.data || true);
      }
    }

    if (props.autoFire) {
      fire();
    }

    return {
      on: events.on,
      fire: fire,
      request: r
    };
  },

  /** Generate a uuid
   *  Borrowed from http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
   *  @namespace highed
   *  @returns {string} - a UUID string
   */
  uuid: function() {
    var d = new Date().getTime(),
      uuid;

    if (window.performance && typeof window.performance.now === 'function') {
      d += window.performance.now(); //use high-precision timer if available
    }

    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = ((d + Math.random() * 16) % 16) | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  },

  /** Map an array to an object
   *  @namespace highed
   *  @param {array} arr - the array to map
   *  @return {object} - an object with the array contents as keys, and their value set to true
   */
  arrToObj: function(arr) {
    var obj = {};

    if ((!highed.isArr(arr) && !highed.isBasic(arr)) || arr === false) {
      return arr;
    }

    if (highed.isStr(arr)) {
      arr = arr.split(' ');
    }

    arr.forEach(function(thing) {
      obj[thing] = true;
    });

    return obj;
  },

  /** Make a camel back string pretty
   *  Transforms e.g. `imACamelBackString` to `Im a camelback string`.
   *  @namespace highed
   *  @param str {string} - the input string
   *  @return {string} - the transformed string
   */
  uncamelize: function(str) {
    var s = '';

    if (!str) {
      return str;
    }

    if (str.length < 0 || !str) {
      return str;
    }

    for (var i = 0; i < str.length; i++) {
      if (str[i] === str[i].toUpperCase()) {
        if (
          (str[i + 1] && str[i + 1] === str[i + 1].toUpperCase()) ||
          (str[i - 1] && str[i - 1] === str[i - 1].toUpperCase())
        ) {
        } else {
          s += ' ';
        }
      }
      s += str[i];
    }

    return s[0].toUpperCase() + s.substr(1);
  },

  /** Clamp a number between min/max
   *  @namespace highed
   *  @param min {number} - minimum value
   *  @param max {number} - maximum value
   *  @param value {number} - the value to clamp
   *  @returns {number} - the clamped value
   */
  clamp: function(min, max, value) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  },

  /** Convert a hex value to RGB
   *
   *  @namespace highed
   *  @param {string} hex - the hex string
   *  @return {object} - an object with rgb components
   *    > r {number} - red
   *    > g {number} - green
   *    > b {number} - blue
   */
  hexToRgb: function(hex) {
    if (!hex) {
      return {
        r: 0,
        g: 0,
        b: 0
      };
    }

    if (hex.indexOf('rgba') === 0) {
      hex = hex
        .substr(5)
        .replace(')', '')
        .split(',');
      return {
        r: parseInt(hex[0], 10),
        g: parseInt(hex[1], 10),
        b: parseInt(hex[2], 10),
        a: parseInt(hex[3], 10)
      };
    }

    if (hex.length === 4) {
      hex += hex[hex.length - 1];
      hex += hex[hex.length - 1];
      hex += hex[hex.length - 1];
    }

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : {
          r: 0,
          g: 0,
          b: 0
        };
  },

  /** Invert a color
   *  @namespace highed
   *  @param {string} hex - the color to invert
   *  @return {string} - new hex color
   */
  invertHexColor: function(hex) {
    var rgb = highed.hexToRgb(hex),
      res = 0;

    rgb.r = 255 - rgb.r;
    rgb.g = 255 - rgb.g;
    rgb.b = 255 - rgb.b;

    res = rgb.r << 16;
    res |= rgb.g << 8;
    res |= rgb.b;

    return '#' + res;
  },

  /** Return #FFF or #000 based on the intensity of a color
   *  @namespace highed
   *  @param {string} hex - input color
   *  @return {string} - the new hex color
   */
  getContrastedColor: function(hex) {
    var rgb = highed.hexToRgb(hex),
      avarage = (rgb.r + rgb.g + rgb.b) / 3;

    if (avarage > 150) {
      return '#000';
    }
    return '#FFF';
  },

  /** Convert a string to a bool
   *  @namespace highed
   *  @param {string} what - the string to convert
   *  @return {bool} - the resulting bool
   */
  toBool: function(what) {
    return what === 'true' || what === true || what === 'on';
  },

  /** Set a property based on -- delimited path
   *  @namespace highed
   *  @param {object} obj - the object to modify
   *  @param {string} path - the path to the attribute to change
   *  @param {anything} value - the value to set
   *  @param {number} index - if we're accessing an array, this is the index
   */
  setAttr: function(obj, path, value, index) {
    var current = obj;

    if (!current) return;

    if (highed.isArr(obj)) {
      obj.forEach(function(thing) {
        highed.setAttr(thing, path, value, index);
      });
      return;
    }

    path = path
      .replace(/\-\-/g, '.')
      .replace(/\-/g, '.')
      .split('.');

    path.forEach(function(p, i) {
      if (i === path.length - 1) {
        current[p] = value;
      } else {
        if (typeof current[p] === 'undefined') {
          current = current[p] = {};
        } else {
          current = current[p];

          if (highed.isArr(current)) {
            if (index > current.length - 1) {
              for (var j = current.length; j <= index; j++) {
                current.push({});
              }
            }
            if (index >= 0) {
              current = current[index];
            }
          }
        }
      }
    });
  },

  /** Get a property based on -- delimited path
   *  @namespace highed
   *  @param {object} obj - the object to traverse
   *  @param {string} path - the path to the attribute to get
   *  @param {number} index - if we're accessing an array, this is the index
   *  @returns {anything} - the value or false
   */
  getAttr: function(obj, path, index) {
    var current = obj,
      result = undefined;

    if (!current) return result;

    if (highed.isArr(obj)) {
      obj.forEach(function(thing) {
        result = highed.getAttr(thing, path);
      });
      return result;
    }

    path = path
      .replace(/\-\-/g, '.')
      .replace(/\-/g, '.')
      .split('.');

    path.forEach(function(p, i) {
      if (i === path.length - 1) {
        if (typeof current !== 'undefined') {
          result = current[p];
        }
      } else {
        if (typeof current[p] === 'undefined') {
          current = current[p] = {};
        } else {
          current = current[p];

          if (highed.isArr(current) && index >= 0 && index < current.length) {
            current = current[index];
          }
        }
      }
    });

    return result;
  },

  /** Deep merge two objects.
   * Note: this modifies object `a`!
   * @namespace highed
   * @param {object} a - the destination object
   * @param {object} b - the source object
   * @param {bool} ignoreEmpty - Ignore empty things
   * @param {object} excludeMap - Map of properties to exclude from the merge
   * @return {object} - argument a
   */
  merge: function(a, b, ignoreEmpty, excludeMap) {
    if (!a || !b) return a || b;

    if (ignoreEmpty && Object.keys(b).length === 0) {
      return;
    }

    Object.keys(b).forEach(function(bk) {
      if (excludeMap && excludeMap[bk]) {
      } else if (highed.isNull(b[bk]) || highed.isBasic(b[bk])) {
        a[bk] = b[bk];
      } else if (highed.isArr(b[bk])) {
        a[bk] = [];

        b[bk].forEach(function(i) {
          if (highed.isNull(i) || highed.isBasic(i)) {
            a[bk].push(i);
          } else {
            a[bk].push(highed.merge(highed.isArr(i) ? [] : {}, i));
          }
        });
      } else if (
        b[bk].tagName &&
        b[bk].appendChild &&
        b[bk].removeChild &&
        b[bk].style
      ) {
        a[bk] = b[bk];
      } else {
        if (ignoreEmpty && Object.keys(b[bk]).length === 0) {
          return;
        }

        a[bk] = a[bk] || {};
        highed.merge(a[bk], b[bk]);
      }
    });
    return a;
  },

  /** Check if something is null or undefined
   *  @namespace highed
   *  @param {anything} what - the value to check
   *  @return {bool} - true if null
   */
  isNull: function(what) {
    return typeof what === 'undefined' || what === null;
  },

  /** Check if something is a string
   *  @namespace highed
   *  @param {anything} what - the value to check
   *  @return {bool} - true if string
   */
  isStr: function(what) {
    return typeof what === 'string' || what instanceof String;
  },

  /** Check if something is a number
   * @namespace highed
   *  @param {anything} what - the value to check
   *  @return {bool} - true if number
   */
  isNum: function(what) {
    return !isNaN(parseFloat(what)) && isFinite(what);
  },

  /** Check if a value is a function
   * @namespace highed
   * @param {anything} what - the value to check
   * @return {bool} - true if function
   */
  isFn: function(what) {
    return (what && typeof what === 'function') || what instanceof Function;
  },

  /** Check if a value is an array
   * @namespace highed
   * @param {anything} what - the value to check
   * @return {bool} - true if array
   */
  isArr: function(what) {
    return (
      !highed.isNull(what) && what.constructor.toString().indexOf('Array') > -1
    );
  },

  /** Check if a value is a boolean
   * @namespace highed
   * @param {anything} what - the value to check
   * @return {bool} - true if bool
   */
  isBool: function(what) {
    return what === true || what === false;
  },

  /** Check if a value is a basic type
   * A basic type is either a bool, string, or a number
   * @namespace highed
   * @param {anything} what - the value to check
   * @return {bool} - true if basic
   */
  isBasic: function(what) {
    return (
      !highed.isArr(what) &&
      (highed.isStr(what) ||
        highed.isNum(what) ||
        highed.isBool(what) ||
        highed.isFn(what))
    );
  },

  /** Parse CSV Data
     * @namespace highed
     * @param {string} - inData
     * @return {string} - delimiter
     */

  parseCSV: function(inData, delimiter) {
    var isStr = highed.isStr,
      isArr = highed.isArray,
      isNum = highed.isNum,
      csv = inData || '',
      result = [],
      options = {
        delimiter: delimiter
      },
      potentialDelimiters = {
        ',': true,
        ';': true,
        '\t': true
      },
      delimiterCounts = {
        ',': 0,
        ';': 0,
        '\t': 0
      },
      rows;
    //The only thing CSV formats have in common..
    rows = (csv || '').replace(/\r\n/g, '\n').split('\n');

    // If there's no delimiter, look at the first few rows to guess it.

    if (!options.delimiter) {
      rows.some(function(row, i) {
        if (i > 10) return true;

        var inStr = false,
          c,
          cn,
          cl,
          token = '';

        for (var j = 0; j < row.length; j++) {
          c = row[j];
          cn = row[j + 1];
          cl = row[j - 1];

          if (c === '"') {
            if (inStr) {
              if (cl !== '"' && cn !== '"') {
                // The next non-blank character is likely the delimiter.

                while (cn === ' ') {
                  cn = row[++j];
                }

                if (potentialDelimiters[cn]) {
                  delimiterCounts[cn]++;
                  return true;
                }

                inStr = false;
              }
            } else {
              inStr = true;
            }
          } else if (potentialDelimiters[c]) {
            if (!isNaN(Date.parse(token))) {
              // Yup, likely the right delimiter
              token = '';
              delimiterCounts[c]++;
            } else if (!isNum(token) && token.length) {
              token = '';
              delimiterCounts[c]++;
            }
          } else {
            token += c;
          }
        }
      });

      options.delimiter = ';';

      if (
        delimiterCounts[','] > delimiterCounts[';'] &&
        delimiterCounts[','] > delimiterCounts['\t']
      ) {
        options.delimiter = ',';
      }

      if (
        delimiterCounts['\t'] >= delimiterCounts[';'] &&
        delimiterCounts['\t'] >= delimiterCounts[',']
      ) {
        options.delimiter = '\t';
      }
    }

    rows.forEach(function(row, rowNumber) {
      var cols = [],
        inStr = false,
        i = 0,
        j,
        token = '',
        guessedDel,
        c,
        cp,
        cn;

      function pushToken() {
        if (!token.length) {
          token = null;
          // return;
        }

        if (isNum(token)) {
          token = parseFloat(token);
        }

        cols.push(token);
        token = '';
      }

      for (i = 0; i < row.length; i++) {
        c = row[i];
        cn = row[i + 1];
        cp = row[i - 1];

        if (c === '"') {
          if (inStr) {
            pushToken();
          } else {
            inStr = false;
          }

          //Everything is allowed inside quotes
        } else if (inStr) {
          token += c;
          //Check if we're done reading a token
        } else if (c === options.delimiter) {
          pushToken();

          //Append to token
        } else {
          token += c;
        }

        // Push if this was the last character
        if (i === row.length - 1) {
          pushToken();
        }
      }

      result.push(cols);
    });

    return result;
  },

  removeNulls: function(dataSet){

    const newDataArr = [];
    dataSet.forEach(function(e){

      var rarr = [],
        hasData = false;

      e.forEach(function(v) {
        if (v) {
          hasData = true;
        }

        if (!highed.isNum(v) && highed.isStr(v)) {
          v = v.replace(/\"/g, '"');
        }

        if (highed.isNum(v)) {
          v = parseFloat(v);
        }

        if (highed.isStr(v) && Date.parse(v) !== NaN) {
          //v = (new Date(v)).getTime();
        }

        rarr.push(v);
      });

      if (hasData) {
        newDataArr.push(rarr);
      }
    });

    return newDataArr;
  }

};

// Stateful functions
(function() {
  var logLevels = ['error', 'warn', 'notice', 'verbose'],
    currentLogLevel = 0,
    initQueue = [],
    isReady = false,
    includedScripts = {},
    isOnPhone = false,
    options = {
      codeMirrorTheme: 'neo',
      helpURL: 'https://www.highcharts.com/products/highcharts-editor',
      defaultLanguage: 'en',
      includeCDNInExport: true,
      stickyChartProperties: {},
      includeHighcharts: true,
      cloudAPIURL: 'https://cloud-api.highcharts.com/',
      helpImgPath: 'help/',
      thumbnailURL: 'https://cloud.highcharts.com/static/thumbnails/',
      autoIncludeDependencies: true
    },
    cdnScripts = [
      'https://code.highcharts.com/stock/highstock.js',
      'https://code.highcharts.com/highcharts-more.js',
      'https://code.highcharts.com/highcharts-3d.js',
      'https://code.highcharts.com/modules/data.js',
      'https://code.highcharts.com/modules/exporting.js'
    ];

  ///////////////////////////////////////////////////////////////////////////

  function pollForReady() {
    if (!isReady) {
      if (document.body) {
        isReady = true;
        initQueue.forEach(function(fn) {
          fn();
        });
      } else {
        window.setTimeout(pollForReady, 100);
      }
    }
  }

  pollForReady();

  ///////////////////////////////////////////////////////////////////////////

  /**
   * Whitelist an option in simple view
   */
  highed.exposeOption = function(option) {};

  /** Set/get an option
   *  Skip `value` to get the value
   *  @param option {string} - the option to set
   *  @param value {anything} - the value to set
   *  @returns {anything} - the option value
   */
  highed.option = function(option, value) {
    if (!highed.isBasic(option)) {
      highed.merge(options, option);
    } else if (options[option]) {
      if (typeof value !== 'undefined') {
        options[option] = value;
      }
      return options[option];
    }
    return false;
  };

  /** Set a set of options
   *  @param options {object} - an object of options to set
   */
  highed.options = function(options) {
    Object.keys(options || {}).forEach(function(key) {
      highed.option(key, options[key]);
    });
  };

  /** Serialize the global options
   *  @returns {object} - a copy of the global options
   */
  highed.serializeEditorOptions = function() {
    return highed.merge({}, options);
  };

  /** Add a function to call when the document is ready
   * @param {function} fn - the function to call
   */
  highed.ready = function(fn) {
    if (highed.isFn(fn)) {
      if (isReady) {
        fn();
      } else {
        initQueue.push(fn);
      }
    }
  };

  /** Log something
   * Accepts a variable amount of arguments after `level` which will be
   * the log message (similar to `console.log`).
   * @param {number} level - the log level 1..4
   */
  highed.log = function(level) {
    var things = Array.prototype.slice.call(arguments);
    things.splice(0, 1);

    if (level <= currentLogLevel) {
      console.log.apply(undefined, [logLevels[level - 1] + ':'].concat(things)); //eslint-disable-line no-console
    }
  };

  /** Set the current log level
   *  @param level {number} - the current log level
   */
  highed.setLogLevel = function(level) {
    if (level <= logLevels.length) {
      currentLogLevel = level;
    }
  };

  /** Include something
   *  @namespace highed
   *  @param what {string} - URL to a css or javascript file
   *  @param fn {function} - function to call when done including the script
   *  @param asCSS {boolean} - force including as css
   */
  highed.include = function(what, fn, asCSS) {
    var n;

    if (!highed.isStr(what)) {
      return highed.isFn(fn) && fn();
    }

    function next() {
      if (n < what.length - 1) {
        highed.include(what[++n], next);
      }

      return highed.isFn(fn) && fn();
    }

    if (highed.isArr(what)) {
      n = -1;
      return next();
    }

    if (includedScripts[what]) {
      highed.log(3, 'script already included, skipping:', what);
      if (fn)
        return fn();

      return;
    }

    highed.log(3, 'including script', what);
    includedScripts[what] = true;

    if (asCSS || what.lastIndexOf('.css') === what.length - 4) {
      n = document.createElement('link');
      n.rel = 'stylesheet';
      n.type = 'text/css';
      n.href = what;
      n.onload = fn;
    } else {
      n = document.createElement('script');
      n.src = what;
      n.onload = fn;
    }

    document.head.appendChild(n);
  };

  /** Returns true if running on a phone
   *  @namespace highed
   *  @returns {boolean} - true if running on a phone
   */
  highed.onPhone = function() {
    return isOnPhone;
  };

  function checkIfPhone() {
    var check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  isOnPhone = checkIfPhone();

  ///////////////////////////////////////////////////////////////////////////

  //Inject dependencies
  highed.ready(function() {
    if (!options.autoIncludeDependencies) {
      return false;
    }

    highed.include(
      'https://maxcdn.bootstrapcdn.com/font-awesome/4.6.0/css/font-awesome.min.css'
    );
    highed.include(
      'https://fonts.googleapis.com/css?family=Roboto:400,300,100,700|Source Sans:400,300,100',
      false,
      true
    );
  });

  //   highed.ready(function () {
  //Include the highcharts scripts
  // function tryAddScripts() {
  //     if (document.head) {
  //         cdnScripts.forEach(function (script) {
  //             var s = document.createElement('script');
  //             s.src = script;
  //             document.head.appendChild(s);
  //         });
  //     } else {
  //         window.setTimeout(tryAddScripts, 10);
  //     }
  // }

  // tryAddScripts();

  // function include(script, next) {
  //     var sc=document.createElement("script");
  //     sc.src = script;
  //     sc.type="text/javascript";
  //     sc.onload=function() {
  //         if (++next < incl.length) {
  //             include(incl[next], next);
  //         } else {
  //             loadedScripts = true;
  //         }
  //     };
  //     document.head.appendChild(sc);
  // }

  // var inc = {},
  //     incl = []
  // ;

  // document.querySelectorAll("script").forEach(function(t) {inc[t.src.substr(0, t.src.indexOf("?"))] = 1;});

  // Object.keys(cdnScripts).forEach(function (k){
  //     if (!inc[k] && k && k.length > 0) {
  //         incl.push(k)
  //     }
  // });

  // if (incl.length > 0) { include(incl[0], 0); } else {loadedScripts = true;}
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/*
    Note that the localization system uses attribute names
    rather than a default string. This is to make it easier to
    modify translations.

*/

(function() {
  var currentLang = highed.option('defaultLanguage'),
    langTree = {};

  /** Get a localized string based on the current global language
     *  @param id {string} - the ID of the string to get
     */
  highed.getLocalizedStr = function(id) {
    if (langTree[currentLang]) {
      if (langTree[currentLang][id]) {
        return langTree[currentLang][id];
      }
    } else {
      //The current language is invalid, fall back to 'en'
      if (langTree.en[id]) {
        return langTree.en[id];
      }
    }

    //404
    return 'bad localized string: ' + id;
  };

  /** This is an alias for highed.getLocalizedStr
     *  @type {function}
     *  @param id {string} - the string to get
     */
  highed.L = highed.getLocalizedStr;

  /** Install a language pack from a json object
     *  @param translations {object} - translation object
     */
  highed.installLanguage = function(translations) {
    if (translations && translations.language && translations.entries) {
      langTree[translations.language] = translations.entries;
    }
  };

  /** Install a language pack from a url
     *  @param url {string} - the location of the pack
     */
  highed.installLanguageFromURL = function(url, fn) {
    highed.ajax({
      url: url,
      success: function(res) {
        if (res) {
          if (highed.installLanguage(res)) {
            return fn && fn(false);
          }
          return fn && fn(true);
        }
      },
      error: function(err) {
        return fn && fn(err);
      }
    });
  };

  /** Set the active language
     *  @param lang {string} - the language to activate
     *  @return {boolean} - true if the language exists, and was applied
     */
  highed.setLang = function(lang) {
    if (langTree[lang]) {
      currentLang = lang;
      return true;
    }
    return false;
  };
})();

/*
    
    en Language Pack for the Highcharts Editor

    This file was generated by tools/gen.localization.js from
    en.json, Wed Oct 09 2019 11:08:54 GMT-0400 (Eastern Daylight Time)

*/

//Install "en" translations
highed.installLanguage({
    language: "en",
    entries: {
        confirmNewChart:
            "Are you sure you want to abandon the current chart and start over?",
        previewChart: "Preview Chart",
        newChart: "New Chart",
        saveProject: "Save Project",
        loadProject: "Load Project",
        exportPNG: "Export as PNG",
        exportJPEG: "Export as JPEG",
        exportSVG: "Export as SVG",
        exportPDF: "Export as PDF",
        loadCloud: "Load From Cloud",
        saveCloud: "Save To Cloud",
        help: "Help",
        licenseInfo: "License Information",
        stepDone: "Done",
        stepStart: "Start",
        stepImport: "Import",
        stepTemplates: "Templates",
        stepCustomize: "Customize",
        stepExport: "Export",
        stepData: "Data",
        doneCaption: "Close & Generate Chart",
        dgDeleteRow: "Really delete the selected rows?",
        dgWithSelected: "With Selection:",
        dgImportBtn: "IMPORT",
        dgExportBtn: "EXPORT DATA",
        dgNewBtn: "CLEAR DATA",
        dgAddRow: "ADD ROW",
        dgDataImported: "Data imported",
        dgDataImporting: "Importing data",
        dgNewCol: "New Column",
        dgSortAsc: "Sort Ascending",
        dgSortDec: "Sort Descending",
        dgSortAscMonth: "Sort as Month Names Ascending",
        dgSortDecMonth: "Sort as Month Names Decending",
        dgDelCol: "Delete Column",
        dgDelColConfirm: "Really delete the column?",
        dgInsColBefore: "Insert Column Before",
        dgInsColAfter: "Insert Column After",
        customizeSimple: "SIMPLE",
        customizeAdvanced: "ADVANCED",
        customizeCustomCode: "CUSTOM CODE",
        customizePreview: "PREVIEW OPTIONS",
        "option.cat.title": "Titles",
        "option.subcat.titles": "Main titles",
        "option.cat.general": "General",
        "option.subcat.size": "Chart size",
        "option.subcat.interaction": "Chart Interaction",
        "option.cat.appearance": "Appearance",
        "option.subcat.fonts": "Fonts",
        "option.subcat.titlestyle": "Title Style",
        "option.subcat.seriescolors": "Series Colors",
        "option.subcat.chartarea": "Chart Area",
        "option.subcat.plotarea": "Plot Area",
        "option.cat.axes": "Axes",
        "option.subcat.axessetup": "Axes Setup",
        "option.subcat.xaxis": "X-Axis",
        "option.subcat.yaxis": "Y-Axis",
        "option.cat.series": "Data Series",
        "option.cat.labels": "Value Labels",
        "option.subcat.labels": "Value Labels",
        "option.cat.legend": "Legend",
        "option.subcat.general": "General",
        "option.subcat.placement": "Placement",
        "option.subcat.legendappearance": "Appearance",
        "option.cat.tooltip": "Tooltip",
        "option.subcat.colorborder": "Color and Border",
        "option.cat.exporting": "Exporting",
        "option.cat.localization": "Localization",
        "option.subcat.numberformat": "Number formatting",
        "option.subcat.exportbutton": "Exporting button and menu",
        "option.subcat.zoombutton": "Zoom button",
        "option.cat.credits": "Credits",
        "option.series.label": "Series Labels",
        "option.text.series.label.enabled": "Series label",
        "option.tooltip.series.label.enabled":
            "Enable or disable the series label. Series labels are placed as close to the series as possible in a natural way, seeking to avoid other series. The goal of this feature is to make the chart more easily readable, like if a human designer placed the labels in the optimal position.",
        "option.text.series.label.style": "Series label style",
        "options.tooltip.series.label.style": "",
        "option.text.title.text": "Chart title",
        "option.tooltip.title.text": "The main chart title.",
        "option.text.subtitle.text": "Chart subtitle",
        "option.tooltip.subtitle.text":
            "The chart's subtitle, normally displayed with smaller fonts below the main title.",
        "option.text.yAxis.title.text": "Y axis title",
        "option.tooltip.yAxis.title.text":
            "The Y axis title, normally displayed vertically along the Y axis.",
        "option.text.chart.width": "Chart width",
        "option.tooltip.chart.width":
            "An explicit width for the chart. By default (when <code>null</code>) the width is calculated from the offset width of the containing element.",
        "option.text.chart.height": "Chart height",
        "option.tooltip.chart.height":
            "An explicit height for the chart. By default (when <code>null</code>) the height is calculated from the offset height of the containing element, or 400 pixels if the containing element's height is 0.",
        "option.text.chart.zoomType": "Allow zooming",
        "option.tooltip.chart.zoomType":
            "Decides in what dimensions the user can zoom by dragging the mouse. Can be one of <code>x</code>, <code>y</code> or <code>xy</code>.",
        "option.text.chart.polar": "Polar (radar) projection",
        "option.tooltip.chart.polar":
            "When true, cartesian charts like line, spline, area and column are transformed into the polar coordinate system. Requires <code>highcharts-more.js</code>.",
        "option.text.chart.style": "Font family",
        "option.tooltip.chart.style": "The font to use throughout the chart",
        "option.text.title.style": "Main title style",
        "option.tooltip.title.style": "Styling for the main chart title",
        "option.text.subtitle.style": "Subtitle style",
        "option.tooltip.subtitle.style":
            "Styling for the chart's subtitle, normally displayed with smaller fonts below the main title",
        "option.text.colors": "Colors",
        "option.tooltip.colors":
            "Default colors for the data series, or for individual points in a pie series or a column series with individual colors. Colors will be picked in succession. If a color is explicitly set for each series in the <em>Data series</em> view, that color will take precedence.",
        "option.text.chart.backgroundColor": "Background color",
        "option.tooltip.chart.backgroundColor":
            "Background color for the full chart area",
        "option.text.chart.borderWidth": "Border width",
        "option.tooltip.chart.borderWidth":
            "The pixel width of the outer chart border.",
        "option.text.chart.borderRadius": "Border corner radius",
        "option.tooltip.chart.borderRadius":
            "The corner radius of the outer chart border.",
        "option.text.chart.borderColor": "Border color",
        "option.tooltip.chart.borderColor": "The color of the outer chart border.",
        "option.text.chart.plotBackgroundColor": "Background color",
        "option.tooltip.chart.plotBackgroundColor":
            "Background color for the plot area, the area inside the axes",
        "option.text.chart.plotBackgroundImage": "Background image URL",
        "option.tooltip.chart.plotBackgroundImage":
            "The online URL for an image to use as the plot area background",
        "option.text.chart.plotBorderWidth": "Border width",
        "option.tooltip.chart.plotBorderWidth":
            "The pixel width of the plot area border.",
        "option.text.chart.plotBorderColor": "Border color",
        "option.tooltip.chart.plotBorderColor":
            "The color of the inner chart or plot area border.",
        "option.text.chart.inverted": "Inverted axes",
        "option.tooltip.chart.inverted":
            '<p>Whether to invert the axes so that the x axis is vertical and y axis is horizontal. When true, the x axis is <a href="#xAxis.reversed">reversed</a> by default. If a bar series is present in the chart, it will be inverted automatically.</p>\r\n\r\n<p>Inverting the chart doesn\'t have an effect if there are no cartesian series in the chart, or if the chart is <a href="#chart.polar">polar</a>.</p>',
        "option.text.xAxis.title.style": "X axis title",
        "option.tooltip.xAxis.title.style": "Styling and text for the X axis title",
        "option.text.xAxis.title.text": "Text",
        "option.tooltip.xAxis.title.text":
            "The actual text of the axis title. It can contain basic HTML text markup like &lt;b&gt;, &lt;i&gt; and spans with style.",
        "option.text.xAxis.type": "Type",
        "option.tooltip.xAxis.type": "The type of axis",
        "option.text.xAxis.opposite": "Opposite side of chart",
        "option.tooltip.xAxis.opposite":
            "Whether to display the axis on the opposite side of the normal. The normal is on the left side for vertical axes and bottom for horizontal, so the opposite sides will be right and top respectively. This is typically used with dual or multiple axes.",
        "option.text.xAxis.reversed": "Reversed direction",
        "option.tooltip.xAxis.reversed":
            "Whether to reverse the axis so that the highest number is closest to the origin. If the chart is inverted, the x axis is reversed by default.",
        "option.text.xAxis.labels.format": "Axis labels format",
        "option.tooltip.xAxis.labels.format":
            "<p>A format string for the axis labels. The value is available through a variable <code>{value}</code>.</p><p><b>Units</b> can be added for example like <code>{value} USD</code>.</p><p><b>Formatting</b> can be added after a colon inside the variable, for example <code>USD {value:.2f}</code> to display two decimals, or <code>{value:%Y-%m-%d}</code> for a certain time format.",
        "option.text.yAxis.title.style": "Y axis title style",
        "option.tooltip.yAxis.title.style": "Styling and text for the X axis title",
        "option.text.yAxis.type": "Type",
        "option.tooltip.yAxis.type": "The type of axis",
        "option.text.yAxis.opposite": "Opposite side of chart",
        "option.tooltip.yAxis.opposite":
            "Whether to display the axis on the opposite side of the normal. The normal is on the left side for vertical axes and bottom for horizontal, so the opposite sides will be right and top respectively. This is typically used with dual or multiple axes.",
        "option.text.yAxis.reversed": "Reversed direction",
        "option.tooltip.yAxis.reversed":
            "Whether to reverse the axis so that the highest number is closest to the origin. If the chart is inverted, the x axis is reversed by default.",
        "option.text.yAxis.labels.format": "Axis labels format",
        "option.tooltip.yAxis.labels.format":
            "<p>A format string for the axis labels. The value is available through a variable <code>{value}</code>.</p><p><b>Units</b> can be added for example like <code>{value} USD</code>.</p><p><b>Formatting</b> can be added after a colon inside the variable, for example <code>USD {value:.2f}</code> to display two decimals, or <code>{value:%Y-%m-%d}</code> for a certain time format.",
        "option.text.series.type": "Series type",
        "option.tooltip.series.type": "The type of series",
        "option.text.series.color": "Color",
        "option.tooltip.series.color":
            'The main color of the series. If no color is given here, the color is pulled from the array of default colors as given in the "Appearance" section.',
        "option.text.series.negativeColor": "Negative color",
        "option.tooltip.series.negativeColor":
            "The negative color of the series below the threshold. Threshold is default zero, this can be changed in the advanced settings.",
        "option.text.series.colorByPoint": "Color by point",
        "option.tooltip.series.colorByPoint":
            'Use one color per point. Colors can be changed in the "Appearance" section.',
        "option.text.series.dashStyle": "Dash style",
        "option.tooltip.series.dashStyle":
            "A name for the dash style to use for the graph. Applies only to series type having a graph, like <code>line</code>, <code>spline</code>, <code>area</code> and <code>scatter</code> in  case it has a <code>lineWidth</code>. The value for the <code>dashStyle</code> include:\r\n\t\t    <ul>\r\n\t\t    \t<li>Solid</li>\r\n\t\t    \t<li>ShortDash</li>\r\n\t\t    \t<li>ShortDot</li>\r\n\t\t    \t<li>ShortDashDot</li>\r\n\t\t    \t<li>ShortDashDotDot</li>\r\n\t\t    \t<li>Dot</li>\r\n\t\t    \t<li>Dash</li>\r\n\t\t    \t<li>LongDash</li>\r\n\t\t    \t<li>DashDot</li>\r\n\t\t    \t<li>LongDashDot</li>\r\n\t\t    \t<li>LongDashDotDot</li>\r\n\t\t    </ul>",
        "option.text.series.marker.enabled": "Enable point markers",
        "option.tooltip.series.marker.enabled":
            "Enable or disable the point marker. If <code>null</code>, the markers are hidden when the data is dense, and shown for more widespread data points.",
        "option.text.series.marker.symbol": "Marker symbol",
        "option.tooltip.series.marker.symbol":
            '<p>A predefined shape or symbol for the marker. When null, the symbol is pulled from options.symbols. Other possible values are "circle", "square", "diamond", "triangle" and "triangle-down".</p>\r\n\r\n<p>Additionally, the URL to a graphic can be given on this form:  "url(graphic.png)". Note that for the image to be applied to exported charts, its URL needs to be accessible by the export server.</p>\r\n\r\n<p>Custom callbacks for symbol path generation can also be added to <code>Highcharts.SVGRenderer.prototype.symbols</code>. The callback is then used by its method name, as shown in the demo.</p>',
        "option.text.series.pattern": "Pattern",
        "option.tooltip.series.pattern": "Pattern fill for area",
        "option.text.series.fill": "Fill color",
        "option.tooltip.series.fill": "The color for the pattern chosen",
        "option.text.series.datasorting": "Sort data",
        "option.tooltip.series.datasorting":
            "Enable the sorting of data when available",
        "option.text.plotOptions.dataLabels.alignment": "Align legends",
        "option.tooltip.plotOptions.dataLabels.alignment":
            "Align the legends to connectors or plot edges",
        "option.text.plotOptions.dataLabels.connectorShape": "Connector shape",
        "option.tooltip.plotOptions.dataLabels.connectorShape":
            "Specifies the method that is used to generate the connector path.",
        "option.text.plotOptions.dataLabels.crookDistance": "Crook distance",
        "option.tooltip.plotOptions.dataLabels.crookDistance":
            "It defines how far from the vertical plot edge the coonnector path should be crooked.",
        "option.text.plotOptions.series.dataLabels.enabled":
            "Enable data labels for all series",
        "option.tooltip.plotOptions.series.dataLabels.enabled":
            "Show small labels next to each data value (point, column, pie slice etc)",
        "option.text.plotOptions.series.dataLabels.style": "Text style",
        "option.tooltip.plotOptions.series.dataLabels.style": "Styles for the label.",
        "option.text.legend.enabled": "Enable legend",
        "option.tooltip.legend.enabled": "Enable or disable the legend.",
        "option.text.legend.layout": "Item layout",
        "option.tooltip.legend.layout":
            'The layout of the legend items. Can be one of "horizontal" or "vertical".',
        "option.text.legend.align": "Horizontal alignment",
        "option.tooltip.legend.align":
            "<p>The horizontal alignment of the legend box within the chart area. Valid values are <code>left</code>, <code>center</code> and <code>right</code>.</p>\r\n\r\n<p>In the case that the legend is aligned in a corner position, the <code>layout</code> option will determine whether to place it above/below or on the side of the plot area.</p>",
        "option.text.legend.x": "Horizontal offset",
        "option.tooltip.legend.x":
            "The pixel offset of the legend relative to its alignment",
        "option.text.legend.verticalAlign": "Vertical alignment",
        "option.tooltip.legend.verticalAlign":
            "<p>The vertical alignment of the legend box. Can be one of <code>top</code>, <code>middle</code> or  <code>bottom</code>. Vertical position can be further determined by the <code>y</code> option.</p>\r\n\r\n<p>In the case that the legend is aligned in a corner position, the <code>layout</code> option will determine whether to place it above/below or on the side of the plot area.</p>",
        "option.text.legend.y": "Vertical offset",
        "option.tooltip.legend.y":
            "The pixel offset of the legend relative to its alignment",
        "option.text.legend.floating": "Float on top of plot area",
        "option.tooltip.legend.floating":
            "When the legend is floating, the plot area ignores it and is allowed to be placed below it.",
        "option.text.legend.itemStyle": "Text style",
        "option.tooltip.legend.itemStyle":
            "CSS styles for each legend item. Only a subset of CSS is supported, notably those options related to text.",
        "option.text.legend.itemHiddenStyle": "Text style hidden",
        "option.tooltip.legend.itemHiddenStyle":
            "CSS styles for each legend item when the corresponding series or point is hidden. Only a subset of CSS is supported, notably those options related to text. Properties are inherited from <code>style</code> unless overridden here.",
        "option.text.legend.backgroundColor": "Background color",
        "option.tooltip.legend.backgroundColor": "The background color of the legend.",
        "option.text.legend.borderWidth": "Border width",
        "option.tooltip.legend.borderWidth":
            "The width of the drawn border around the legend.",
        "option.text.legend.borderRadius": "Border corner radius",
        "option.tooltip.legend.borderRadius": "The border corner radius of the legend.",
        "option.text.legend.borderColor": "Border color",
        "option.tooltip.legend.borderColor":
            "The color of the drawn border around the legend.",
        "option.text.tooltip.enabled": "Enable tooltip",
        "option.tooltip.tooltip.enabled":
            "Enable or disable the tooltip. The tooltip is the information box that appears on mouse-over or touch on a point.",
        "option.text.tooltip.shared": "Shared between series",
        "option.tooltip.tooltip.shared":
            "When the tooltip is shared, the entire plot area will capture mouse movement or touch events. Tooltip texts for series types with ordered data (not pie, scatter, flags etc) will be shown in a single bubble. This is recommended for single series charts and for tablet/mobile optimized charts.",
        "option.text.tooltip.backgroundColor": "Background color",
        "option.tooltip.tooltip.backgroundColor": "The background color of the tooltip",
        "option.text.tooltip.borderWidth": "Border width",
        "option.tooltip.tooltip.borderWidth":
            '<p>The pixel width of the tooltip border.</p>\r\n\r\n<p>In <a href="http://www.highcharts.com/docs/chart-design-and-style/style-by-css">styled mode</a>, the stroke width is set in the <code>.highcharts-tooltip-box</code> class.</p>',
        "option.text.tooltip.borderRadius": "Border corner radius",
        "option.tooltip.tooltip.borderRadius":
            "The radius of the rounded border corners.",
        "option.text.tooltip.borderColor": "Border color",
        "option.tooltip.tooltip.borderColor":
            "The border color of the tooltip. If no color is given, the corresponding series color is used.",
        "option.text.exporting.enabled": "Enable exporting",
        "option.tooltip.exporting.enabled":
            "Enable the context button on the top right of the chart, allowing end users to download image exports.",
        "option.text.exporting.sourceWidth": "Exported width",
        "option.tooltip.exporting.sourceWidth":
            "The width of the original chart when exported. The pixel width of the exported image is then multiplied by the <em>Scaling factor</em>.",
        "option.text.exporting.scale": "Scaling factor",
        "option.tooltip.exporting.scale":
            "The export scale. Note that this is overridden if width is set.",
        "option.text.lang.decimalPoint": "Decimal point",
        "option.tooltip.lang.decimalPoint": "The decimal point used for all numbers",
        "option.text.lang.thousandsSep": "Thousands separator",
        "option.tooltip.lang.thousandsSep":
            "The thousands separator used for all numbers",
        "option.text.lang.contextButtonTitle": "Context button title",
        "option.tooltip.lang.contextButtonTitle":
            "Exporting module menu. The tooltip title for the context menu holding print and export menu items.",
        "option.text.lang.printChart": "Print chart",
        "option.tooltip.lang.printChart":
            "Exporting module only. The text for the menu item to print the chart.",
        "option.text.lang.downloadPNG": "Download PNG",
        "option.tooltip.lang.downloadPNG":
            "Exporting module only. The text for the PNG download menu item.",
        "option.text.lang.downloadJPEG": "Download JPEG",
        "option.tooltip.lang.downloadJPEG":
            "Exporting module only. The text for the JPEG download menu item.",
        "option.text.lang.downloadPDF": "Download PDF",
        "option.tooltip.lang.downloadPDF":
            "Exporting module only. The text for the PDF download menu item.",
        "option.text.lang.downloadSVG": "Download SVG",
        "option.tooltip.lang.downloadSVG":
            "Exporting module only. The text for the SVG download menu item.",
        "option.text.lang.resetZoom": "Reset zoom button",
        "option.tooltip.lang.resetZoom":
            "The text for the label appearing when a chart is zoomed.",
        "option.text.credits.enabled": "Enable credits",
        "option.tooltip.credits.enabled": "Whether to show the credits text",
        "option.text.credits.text": "Credits text",
        "option.tooltip.credits.text": "The text for the credits label",
        "option.text.credits.href": "Link",
        "option.tooltip.credits.href": "The URL for the credits label",
    },
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Namespace for DOM helper functions
 * @ignore
 */
highed.dom = {
  /** Check if a node is visible
     *  @namespace highed.dom
     *  @param node {domnode} - the node to check
     */
  isVisible: function(node) {
    var style = window.getComputedStyle(node);
    return style.display !== 'none';
  },

  /** Append a set of nodes to another node.
     * Arguments supplied after the @param {} target represents the children to append.
     * @namespace highed.dom
     * @param target {object} - the node to append to
     * @return {domnode} - the target
     */
  ap: function(target) {
    var children = Array.prototype.slice.call(arguments);
    children.splice(0, 1);

    target = highed.dom.get(target);

    if (!highed.isNull(target) && typeof target.appendChild !== 'undefined') {
      children.forEach(function(child) {
        if (highed.isArr(child)) {
          child.forEach(function(sc) {
            highed.dom.ap(target, sc);
          });
        } else if (
          typeof child !== 'undefined' &&
          typeof child.appendChild !== 'undefined'
        ) {
          target.appendChild(child);
        } else if (child !== false) {
          highed.log(1, 'child is not valid (highed.dom.ap)');
        }
      });
    } else {
      highed.log(1, 'target is not a valid DOM node (highed.dom.ap)');
    }

    return target;
  },

  /** Create a set of options for a select
     * @namespace highed.dom
     * @param select {HTMLSelect} - the dropdown to add options to
     * @param options {(array|object)} - the options as an array or as an object keyed on ID
     * @param selected {number} - the index of the selected option
     */
  options: function(select, options, selected) {
    if (highed.isNull(options)) {
    } else if (highed.isArr(options)) {
      options.forEach(function(option) {
        highed.dom.ap(select, highed.dom.cr('option', '', option, option));
      });

      if (selected) {
        select.selectedIndex = selected;
      }
    } else if (highed.isStr(options)) {
      try {
        highed.dom.options(select, JSON.parse(options));
      } catch (e) {
        highed.log(e + ' in highed.options (json parser)');
      }
    } else {
      Object.keys(options).forEach(function(key) {
        highed.dom.ap(select, highed.dom.cr('option', '', options[key], key));
      });
    }
  },

  /** Show a node when another is hovered
     * @namespace highed.dom
     * @param parent {object} - the node to listen for the hover on
     * @param child {object} - the node to show when the parent is hovered
     */
  showOnHover: function(parent, child) {
    if (highed.isArr(child)) {
      child.forEach(function(c) {
        highed.dom.showOnHover(parent, c);
      });
      return;
    }

    highed.dom.on(parent, 'mouseover', function() {
      highed.dom.style(child, {
        //display: 'block',
        opacity: 1,
        //  background: 'rgba(46, 46, 46, 0.85)',
        'pointer-events': 'auto'
      });
    });

    highed.dom.on(parent, 'mouseout', function() {
      highed.dom.style(child, {
        //display: 'none',
        opacity: 0,
        //background: 'rgba(0, 0, 0, 0)',
        'pointer-events': 'none'
      });
    });
  },

  /** Create a new HTML node
     * @namespace highed.dom
     * @param type {string} - the type of node to create
     * @param cssClass {string} (optional) - the css class to use for the node
     * @param innerHTML {string} (optional) - the inner html of the new node
     * @param id {string} (optional) - the id of the new node
     *
     * @return {domnode} - the new dom node
     */
  cr: function(type, cssClass, innerHTML, id) {
    var res = false;

    if (typeof type !== 'undefined') {
      res = document.createElement(type);

      if (typeof cssClass !== 'undefined') {
        res.className = cssClass;
      }

      if (typeof innerHTML !== 'undefined') {
        res.innerHTML = innerHTML;
      }

      if (typeof id !== 'undefined') {
        res.id = id;
      }
    } else {
      highed.log(1, 'no node type supplied (highed.dom.cr');
    }

    return res;
  },

  /** Style a node
     * @namespace highed.dom
     * @param nodes {(object|array)}  - the node to style. Can also be an array
     * @param style {object} - object containing style properties
     *
     * @return {anything} - whatever was supplied to @param {} nodes
     */
  style: function(nodes, style) {
    if (highed.isArr(nodes)) {
      nodes.forEach(function(node) {
        highed.dom.style(node, style);
      });
      return nodes;
    }

    if (nodes && nodes.style) {
      Object.keys(style).forEach(function(p) {
        nodes.style[p] = style[p];
      });
      return nodes;
    }
    return false;
  },

  /** Attach an event listener to a dom node
     * @namespace highed.dom
     * @param target {object} - the dom node to attach to
     * @param event {string} - the event to listen for
     * @param callback {function} - the function to call when the event is emitted
     * @param context {object} (optional) - the context of the callback function
     *
     * @return {function} - a function that can be called to unbind the handler
     */
  on: function(target, event, callback, context) {
    var s = [];

    if (!target) {
      return function() {};
    }

    if (highed.isArr(event)) {
      event.forEach(function(event) {
        s.push(highed.dom.on(target, event, callback, context));
      });

      return function() {
        s.forEach(function(f) {
          f();
        });
      };
    }

    if (target === document.body && event === 'resize') {
      //Need some special magic here eventually.
    }

    if (target && target.forEach) {
      target.forEach(function(t) {
        s.push(highed.dom.on(t, event, callback));
      });
    }

    if (s.length > 0) {
      return function() {
        s.forEach(function(f) {
          f();
        });
      };
    }

    function actualCallback() {
      if (highed.isFn(callback)) {
        return callback.apply(context, arguments);
      }
      return;
    }

    if (target.addEventListener) {
      target.addEventListener(event, actualCallback, false);
    } else {
      target.attachEvent('on' + event, actualCallback, false);
    }

    return function() {
      if (window.removeEventListener) {
        target.removeEventListener(event, actualCallback, false);
      } else {
        target.detachEvent('on' + event, actualCallback);
      }
    };
  },

  nodefault: function(e) {
    e.cancelBubble = true;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  },

  /** Get or set the value of a node
     * @namespace highed.dom
     * @param node {object} - the node to get the value of
     * @param value {(string|bool|number)} (optional) - the value to set
     * @return {anything} - the value
     */
  val: function(node, value) {
    if (node.tagName === 'SELECT') {
      if (node.selectedIndex >= 0) {
        if (!highed.isNull(value)) {
          for (var i = 0; i < node.options.length; i++) {
            if (node.options[i].id === value) {
              node.selectedIndex = i;
              break;
            }
          }
        }
        return node.options[node.selectedIndex].id;
      }
    } else if (node.tagName === 'INPUT') {
      if (node.type === 'checkbox') {
        if (!highed.isNull(value)) {
          node.checked = highed.toBool(value);
        }
        return node.checked;
      }
      if (!highed.isNull(value)) {
        node.value = value;
      }
      return node.value;
    } else {
      if (!highed.isNull(value)) {
        node.innerHTML = value;
      }
      return node.innerText;
    }

    return false;
  },

  /** Get the size of a node
     * @namespace highed.dom
     * @param node {object} - the node to get the size of
     * @return {object} - the size as an object `{w, h}`
     */
  size: function(node) {
    return {
      w: node.clientWidth,
      h: node.clientHeight
    };
  },

  /** Get the position of a node
     * @namespace highed.dom
     * @param node {object} - the node to get the position of
     * @param abs {boolean} - absolute calculation rather than parent relative
     * @return {object} - the position as an object `{x, y}`
     */
  pos: function(node, abs) {
    var x = 0,
      y = 0;

    if (abs) {
      var b = node.getBoundingClientRect();

      return {
        x: b.left + window.scrollX,
        y: b.top + window.scrollY
      };
    }

    return {
      x: node.offsetLeft,
      y: node.offsetTop
    };
  },

  /** Find a node
     * @namespace highed.dom
     * @param node {object} - the node to find. Either a string or an actual node instance
     * @return {object} - the node or false if the node was not found
     */
  get: function(node) {
    if (node && node.appendChild) {
      return node;
    }
    return document.getElementById(node) || false;
  }
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Event dispatcher object
 *  Constructs an instance of an event dispatcher when called.
 *  @constructor
 *  @example
 *  var events = highed.events();
 *  events.on('foobar', function () {console.log('Hello world!')});
 *  events.emit('foobar');
 */
highed.events = function() {
  var callbacks = {},
    listenerCounter = 0;

  /** Listen to an event
      * @memberof highed.events
      * @param event {string} - the event to listen for
      * @param callback {function} - the function to call when the event is emitted
      * @param context {anything} - the calling context (`this` reference) for the callback
      * @returns {function} - function that can be called to unbind the listener
      */
  function on(event, callback, context) {
    var id = ++listenerCounter;

    if (highed.isArr(callback)) {
      return callback.forEach(function(cb) {
        on(event, cb, context);
      });
    }

    callbacks[event] = callbacks[event] || [];

    callbacks[event].push({
      id: id,
      fn: callback,
      context: context
    });

    return function() {
      callbacks[event] = callbacks[event].filter(function(e) {
        return e.id !== id;
      });
    };
  }

  return {
    on: on,

    /** Emit an event
         * Note that the function accepts a variable amount of arguments. Any arguments after the event name will be passed on to any event listeners attached to the event being emitted.
         * @memberof highed.events
         * @param event {string} - the event to emit
         * @return {number} - The number of events dispatched
         */
    emit: function(event) {
      var args = Array.prototype.slice.call(arguments);
      args.splice(0, 1);

      if (typeof callbacks[event] !== 'undefined') {
        callbacks[event].forEach(function(event) {
          if (highed.isFn(event.fn)) {
            event.fn.apply(event.context, args);
          }
        });

        return callbacks[event].length;
      }
      return 0;
    }
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/**
 * @ignore
 */
highed.ready(function() {
  var uploader = highed.dom.cr('input'),
    cb = false;

  uploader.type = 'file';
  uploader.accept = '.csv';

  highed.dom.ap(document.body, uploader);

  highed.dom.style(uploader, {
    display: 'none'
  });

  /** Upload and parse a local file
  *  Borrowed from almostvanilla which is licensed under MIT.
  *  @param props {object} - the upload settings
  *     > type {string} - the type of data to load
  *     > accept {string} - the accepted file extensions
  *     > multiple {boolean} - allow multiple files
  *     > progress {function} - progress callback
  *       > {number} - the progress in percent
  *     > success {function} - function called when the file is uploaded
  *       > {object} - the file information
  *         > filename {string} - the name of the file
  *         > size {number} - the size of the file in bytes
  *         > data {string} - the file data
  */
  highed.readLocalFile = function(props) {
    var p = highed.merge(
      {
        type: 'text',
        multiple: false,
        accept: '.csv'
      },
      props
    );

    uploader.accept = p.accept;

    if (highed.isFn(cb)) {
      cb();
    }

    cb = highed.dom.on(uploader, 'change', function() {
      function crReader(file) {
        var reader = new FileReader();

        reader.onloadstart = function(evt) {
          if (highed.isFn(p.progress)) {
            p.progress(Math.round(evt.loaded / evt.total * 100));
          }
        };

        reader.onload = function(event) {
          var data = reader.result;

          if (p.type === 'json') {
            try {
              data = JSON.parse(data);
            } catch (e) {
              if (highed.isFn(p.error)) {
                p.error(e);
              }
            }
          }

          if (highed.isFn(p.success)) {
            p.success({
              filename: file.name,
              size: file.size,
              data: data
            });
          }
        };

        return reader;
      }

      for (var i = 0; i < uploader.files.length; i++) {
        if (!p.type || p.type === 'text' || p.type === 'json') {
          crReader(uploader.files[i]).readAsText(uploader.files[i]);
        } else if (p.type === 'binary') {
          crReader(uploader.files[i]).readAsBinaryString(uploader.files[i]);
        } else if (p.type === 'b64') {
          crReader(uploader.files[i]).readAsDataURL(uploader.files[i]);
        }
      }
      cb();
      uploader.value = '';
    });

    uploader.multiple = p.multiple;

    uploader.click();
  };
});

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.templates = {};

(function() {
  /* Templates */
  var templates = {};

  /** Install a new template
     *
     *  @example
     *  highed.installTemplate('custom', {
     *      title: 'My company template',
     *      tooltipText: 'Company template: requires no particular data',
     *      config: {
     *           'chart--title': 'Company Chart'
     *      }
     *  });
     *
     *  @param type {string} - template type: `line area column bar scatter pie polar stock`
     *  @param def {object} - the template definition
     *    > title {string} - the template title
     *    > config {object} - the highcharts attributes
     *    > tooltipText {string} - the tooltip text
     */
  highed.templates.add = function(type, def) {
    var properties = highed.merge(
      {
        title: '',
        description: '',
        constructor: '',
        thumbnail: '',
        sampleSets: [],
        validator: false,
        config: {}
      },
      def
    );

    if (!highed.isBasic(type)) {
      return false;
    }

    templates[type] = templates[type] || {
      description: '',
      sampleData: [],
      templates: {}
    };

    if (properties.title.length) {
      templates[type].templates[properties.title] = properties;
      highed.log(4, '[templateman] - added template', properties.title);
      return true;
    }

    return false;
  };

  /**
     * Do something for each template
     * @param fn {function} - the callback
     */
  highed.templates.each = function(fn) {
    if (highed.isFn(fn)) {
      Object.keys(templates).forEach(function(cat) {
        Object.keys(templates[cat].templates).forEach(function(id) {
          fn(cat, templates[cat].templates[id]);
        });
      });
    }
  };

  /**
     * Do something for each template within a given category
     * @param cat {string} - the category to filter by
     * @param fn {function} - the callback
     */
  highed.templates.eachInCategory = function(cat, fn) {
    if (highed.isFn(fn) && templates[cat]) {
      Object.keys(templates[cat].templates).forEach(function(id) {
        fn(templates[cat].templates[id]);
      });
    }
  };

  /**
     * Get a reference to the templates within a given category
     */
  highed.templates.getAllInCat = function(cat) {
    return templates[cat] ? templates[cat].templates : false;
  };

  /**
     * Get category meta
     */
  highed.templates.getCatInfo = function(cat) {
    return highed.merge(
      {
        id: cat
      },
      templates[cat] || {}
    );
  };

  /**
     * Get a list of id/title pairs for templates
     */
  highed.templates.getCatArray = function() {
    return Object.keys(templates).map(function(cat) {
      return {
        id: cat,
        title: cat
      };
    });
  };

  /**
     * Add meta information to a category
     */
  highed.templates.addCategory = function(id, meta) {
    templates[id] = templates[id] || {
      templates: {}
    };

    highed.merge(templates[id], meta, false, { templates: 1 });
  };

  /**
     * Do something with each category
     * @param fn {function} - the callback
     */
  highed.templates.eachCategory = function(fn) {
    if (highed.isFn(fn)) {
      Object.keys(templates).forEach(function(id) {
        fn(id, templates[id]);
      });
    }
  };

  /** Flush templates */
  highed.templates.flush = function() {
    templates = {};
  };

  /** Add a new template type
     *  If the type already exists, nothing will happen
     *
     *  @example
     *  highed.addTemplateType('custom', 'My company templates');
     *
     *  @param type {string} - the type id
     *  @param title {string} - the title as it appears in the category list
     */
  highed.templates.addType = function(type, title) {
    if (typeof templates === 'undefined') {
      templates = {};
    }

    if (typeof templates[type] === 'undefined') {
      templates[type] = {
        title: title,
        templates: {}
      };
    }
  };

  /** Add a set of templates
      * @example
      * highed.installMultipleTemplates([
      *   {type: 'line', template: {title: 'My Line Template', config: {}}}
      * ]);
      *
      * @param templates {array} - an array of templates
      *
      */
  highed.templates.addMultiple = function(templates) {
    if (typeof templates === 'undefined') {
      templates = {};
    }

    if (highed.isArr(templates)) {
      templates.forEach(function(template) {
        if (template.type && template.template) {
          highed.installTemplate(template.type, template.template);
        }
      });
    }
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

// There be dragons here...
(function() {
  var hasTransformedAdvanced = false;

  /**
     * Merges/extends advanced meta
     *  1. Find the source
     *  2. If source is also extending:
     *      2a. Recursively merge source
     *  3. Remove the extends attribute from target
     *  4. Merge source children
     */
  function mergeAdv(superset, dest, src, trigger) {
    var path = src.split('.'),
      current = superset,
      seriesNames = {
        pie: true,
        line: true
      };

    // console.log(
    //     'extending',
    //     (dest.meta.ns ? dest.meta.ns + '.' : '') + dest.meta.name,
    //     'with',
    //     src
    // );

    path.some(function(p) {
      if (current.subtree[p]) {
        current = current.subtree[p];
      } else {
        // console.log(
        //     'unable to resolve path for merge:',
        //     src,
        //     'from',
        //     dest.meta.name
        // );

        current = false;
        return true;
      }
    });

    // Stop from trying to extend this multiple times
    dest.meta.extends = dest.meta.extends.replace(src, '');

    if (current) {
      // Extend the source if needed
      extend(superset, current);

      // Unfortunatly we need to take series into special consideration
      // until we have a more robust way of handling its meta
      if (trigger && trigger.indexOf('series') === 0) {
        Object.keys(current.subtree || {}).forEach(function(key) {
          dest.subtree[key] =
            dest.subtree[key] || highed.merge({}, current.subtree[key]);
          dest.subtree[key].meta.validFor =
            dest.subtree[key].meta.validFor || {};

          if (
            dest.meta.excludes &&
            Object.keys(dest.meta.excludes).length > 0
          ) {
            dest.subtree[key].meta.validFor[current.meta.name] = !dest.meta
              .excludes[key];
          } else {
            dest.subtree[key].meta.validFor[current.meta.name] = 1;
          }
        });

        // console.log(dest);
      } else {
        // Do actual extending
        highed.merge(dest.subtree, current.subtree, false, dest.meta.excludes);
      }
    }
  }

  /**
      * Extend a node
      */
  function extend(superset, node, trigger) {
    if (node.meta.extends && node.meta.extends.length > 0) {
      node.meta.extends = node.meta.extends.replace('{', '').replace('}', '');

      if (trigger === 'series') {
        node.meta.extends += ',plotOptions.line';
      }

      node.meta.extends.split(',').forEach(function(part) {
        if (part && part.length > 0) {
          mergeAdv(superset, node, part.trim(), trigger);
        }
      });
    }
  }

  /**
     * Transform the tree
     * - merges
     * - arrifies
     * - sorts
     *
     * Duplicating children is faster than arrifying and replacing
     *
     */
  function transformAdv(input, onlyOnce) {
    var res;

    if (onlyOnce && hasTransformedAdvanced) {
      return input;
    }

    function visit(node, pname) {
      var children = (node.subtree = node.subtree || {});

      node.meta = node.meta || {};
      node.meta.ns = pname;
      node.children = [];

      // Take care of merging
      extend(input, node, (pname ? pname + '.' : '') + node.meta.name);

      node.meta.hasSubTree = false;

      node.children = [];

      Object.keys(children).forEach(function(child) {
        if (Object.keys(children[child].subtree).length > 0) {
          node.meta.hasSubTree = true;
        }

        node.children.push(
          visit(
            children[child],
            (pname ? pname + '.' : '') + (node.meta.name || '')
          )
        );
      });

      node.children.sort(function(a, b) {
        return a.meta.name.localeCompare(b.meta.name);
      });

      if (node.children.length === 0) {
        node.meta.leafNode = true;
      }

      return node;
    }

    // console.time('tree transform');
    res = visit(input);
    // console.timeEnd('tree transform');

    return res;
  }

  // Removes all empty objects and arrays from the input object
  function removeBlanks(input) {
    function rewind(stack) {
      if (!stack || stack.length === 0) return;

      var t = stack.pop();

      if (Object.keys(t).length === 0) {
        rewind(stack);
      } else {
        Object.keys(t || {}).forEach(function(key) {
          var child = t[key];

          if (key[0] === '_') {
            delete t[key];
          } else if (
            child &&
            !highed.isBasic(child) &&
            !highed.isArr(child) &&
            Object.keys(child).length === 0
          ) {
            delete t[key];
          } else if (highed.isArr(child) && child.length === 0) {
            delete t[key];
          } else if (highed.isArr(child)) {
            child = child.map(function(sub) {
              return removeBlanks(sub);
            });
          }
        });
      }

      rewind(stack);
    }

    function visit(node, parentStack) {
      parentStack = parentStack || [];

      if (node) {
        if (parentStack && Object.keys(node).length === 0) {
          rewind(parentStack.concat([node]));
        } else {
          Object.keys(node).forEach(function(key) {
            var child = node[key];
            if (key[0] === '_') {
              rewind(parentStack.concat([node]));
            } else if (!highed.isBasic(child) && !highed.isArr(child)) {
              visit(child, parentStack.concat([node]));
            }
          });
        }
      }
    }

    visit(input);
    return input;
  }

  highed.transform = {
    advanced: transformAdv,
    remBlanks: removeBlanks
  };
})();

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  // Samples, keyed on ID
  var samples = {};

  highed.samples = {
    /**
         * Add a sample to the sample collection
         *
         * This should be linked to templates too,
         * both in the sense that templates should have a list of
         * ID's for suitable sample data, and in the sense that
         * when displaying sample data it should display what kind of
         * chart types the data is valid for.
         *
         * The latter can be done automatically by cross-checking templates.
         *
         * @param {object} sample - the sample definition
         *    > id {anything} - the ID of the sample
         *    > title {anything} - the sample title
         *    > description {string} - the sample description
         *    > dataset {array<array<object>>} - the sample data
         *    > suitableSeries {object} - the kind of series this is suitable for
         */
    add: function(sample) {
      var options = highed.merge(
        {
          title: 'Untitled Sample',
          description: 'Untitled Sample',
          dataset: [],
          suitableSeries: false,
          products: false
        },
        sample
      );

      if (options.id && !samples[options.id]) {
        samples[options.id] = options;
        return true;
      }

      return false;
    },

    /**
         * Do something for each sample
         * @param fn {function} - the callback
         * @param productFilter {string} - the product(s) to include (optional)
         * @param typeFilter {string} - the series type(s) to include (optional)
         */
    each: function(fn, productFilter, typeFilter) {
      if (highed.isFn(fn)) {
        Object.keys(samples).forEach(function(id) {
          fn(samples[id]);
        });
      }
    },

    /**
         * Get a single sample set
         * @param id {string} - the id of the sample set to get
         * @returns {sample|false} - false if 404, sample if found
         */
    get: function(id) {
      return samples[id] || false;
    }
  };
})();

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/* Keeps track of validations */

(function() {
  // Keyed on ID
  var validators = {};

  highed.validators = {
    /**
         * Add a validator
         * @param id {string} - the id
         * @param fn {function} - the validator function
         */
    add: function(id, fn) {
      if (id && !validators[id] && highed.isFn(fn)) {
        validators[id] = fn;
        return true;
      }

      return false;
    },

    /**
         * Execute a validator
         * @param id {string} - the id of the validator
         * @param chart {Chart} - the charts whose data to validate
         * @return {boolean} - true if valid
         */
    validate: function(id, chart) {
      return validators[id] ? validators[id](chart) : true;
    }
  };
})();

/*******************************************************************************

Copyright (c) 2017-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*******************************************************************************/

// @format

(function() {
  var token = false,
    url = highed.option('cloudAPIURL');

  // Set up namespace for the cloud API
  highed.cloud = {};

  highed.cloud.isLoggedIn = function() {
    return token !== false;
  };

  highed.cloud.login = function(username, password, fn) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'login',
      type: 'post',
      data: {
        username: username,
        password: password
      },
      success: function(data) {
        if (data && data.token) {
          token = data.token;
        }
        return highed.isFn(fn) && fn(typeof data.token === 'undefined', data);
      },
      error: function(err) {
        return highed.isFn(fn) && fn(err);
      }
    });
  };

  highed.cloud.getTeams = function(fn) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'teams',
      type: 'get',
      headers: {
        'X-Auth-Token': token
      },
      success: function(data) {
        if (data.error) {
          return highed.snackBar(data.message);
        }
        return highed.isFn(fn) && fn(data);
      }
    });
  };

  highed.cloud.getCharts = function(teamID, fn, page) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'team/' + teamID + '/charts/' + '?page=' + page,
      type: 'get',
      headers: {
        'X-Auth-Token': token
      },
      success: function(data) {
        if (data.error) {
          return highed.snackBar(data.message);
        }
        return highed.isFn(fn) && fn(data.data, data);
      }
    });
  };

  highed.cloud.getChart = function(teamID, chartID, fn) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'team/' + teamID + '/chart/' + chartID,
      type: 'get',
      headers: {
        'X-Auth-Token': token
      },
      success: function(data) {
        if (data.error) {
          return highed.snackBar(data.message);
        }
        return highed.isFn(fn) && fn(data);
      }
    });
  };

  highed.cloud.saveExistingChart = function(teamID, chartID, chart, fn) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'team/' + teamID + '/chart/' + chartID,
      type: 'post',
      headers: {
        'X-Auth-Token': token
      },
      data: {
        data: chart
      },
      success: function(data) {
        if (data.error) {
          return highed.snackbar(data.message);
        }
        return highed.isFn(fn) && fn(data);
      }
    });
  };

  highed.cloud.saveNewChart = function(teamID, name, chart, fn) {
    url = highed.option('cloudAPIURL');

    highed.ajax({
      url: url + 'team/' + teamID + '/chart',
      type: 'post',
      headers: {
        'X-Auth-Token': token
      },
      data: {
        name: name,
        data: chart
      },
      success: function(data) {
        if (data.error) {
          return highed.snackbar(data.message);
        }
        return highed.isFn(fn) && fn(data);
      }
    });
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var events = highed.events();
  highed.on = events.on;
  highed.emit = events.emit;
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  /** Show a dimmer backdrop
     *
     *  Used to catch input when showing modals, context menus etc.
     *
     *  @example
     *  highed.showDimmer(function () {
     *       alert('You clicked the dimmer!');
     *  });
     *
     *  @param {function} fn - the function to call when the dimmer is clicked
     *  @param {bool} autohide - set to true to hide the dimmer when it's clicked
     *  @param {bool} transparent - set to true for the dimmer to be transparent
     *  @param {number} zIndex - the z index *offset*
     *  @return {function} - A function that can be called to hide the dimmer
     */
  highed.showDimmer = function(fn, autohide, transparent, zIndex) {
    var dimmer = highed.dom.cr('div', 'highed-dimmer'),
      unbinder = false;

    highed.dom.ap(document.body, dimmer);

    highed.dom.style(dimmer, {
      opacity: 0.7,
      'pointer-events': 'auto',
      'z-index': 9999 + (zIndex || 0)
    });

    if (transparent) {
      highed.dom.style(dimmer, {
        opacity: 0
      });
    }

    function hide() {
      highed.dom.style(dimmer, {
        opacity: 0,
        'pointer-events': 'none'
      });

      if (highed.isFn(unbinder)) {
        unbinder();
        unbinder = false;
      }

      window.setTimeout(function() {
        if (dimmer.parentNode) {
          dimmer.parentNode.removeChild(dimmer);
        }
      }, 300);
    }

    unbinder = highed.dom.on(dimmer, 'click', function(e) {
      if (highed.isFn(fn)) {
        fn();
      }

      if (autohide) {
        hide();
      }
    });

    return hide;
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Turn a DOM node into an overlay "popup"
 *
 *  @example
 *  //Create an overlay with hello world in it
 *  highed.OverlayModal(highed.dom.cr('h1', '', 'Hello World!'));
 *
 *  @constructor
 *
 *  @emits Show - when the overlay is shown
 *  @emits Hide - when the overlay is hidden
 *
 *  @param {domnode} contents - the DOM node to wrap.
 *  @param {object} attributes - properties for the modal
 *    > width {number} - the width of the modal
 *    > height {number} - the height of the modal
 *    > minWidth {number} - the minimum width of the modal
 *    > minHeight {number} - the minimum height of the modal
 *    > showOnInit {boolean} - if true, the modal will be shown after creation
 *    > zIndex {number} - the Z-Index to use for the modal
 *  @return {object} - A new instance of OverlayModal
 */
highed.OverlayModal = function(contents, attributes) {
  var container = highed.dom.cr('div', 'highed-overlay-modal'),
    events = highed.events(),
    properties = highed.merge(
      {
        width: 200,
        height: 200,
        minWidth: 10,
        minHeight: 10,
        showOnInit: true,
        zIndex: 10000
      },
      attributes
    ),
    hideDimmer = false,
    visible = false;

  ///////////////////////////////////////////////////////////////////////////

  /** Show the modal
     *  @memberof highed.OverlayModal
     */
  function show() {
    if (visible) return;

    highed.dom.style(container, {
      width:
        properties.width +
        (properties.width.toString().indexOf('%') > 0 ? '' : 'px'),
      height:
        properties.height +
        (properties.height.toString().indexOf('%') > 0 ? '' : 'px'),
      opacity: 1,
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      'pointer-events': 'auto',
      'min-width': properties.minWidth + 'px',
      'min-height': properties.minHeight + 'px',
      'z-index': properties.zIndex
    });

    highed.dom.style(document.body, {
      'overflow-x': 'hidden',
      'overflow-y': 'hidden'
    });

    hideDimmer = highed.showDimmer(
      hide,
      true,
      false,
      properties.zIndex - 10000
    );

    window.setTimeout(function() {
      events.emit('Show');
    }, 300);

    visible = true;
  }

  /** Hide the modal
     *  @memberof highed.OverlayModal
     *  @param suppress {boolean} - suppress the hide event emitting
     */
  function hide(suppress) {
    if (!visible) return;

    highed.dom.style(container, {
      width: '0px',
      height: '0px',
      opacity: 0,
      left: '-20000px',
      'pointer-events': 'none'
    });

    highed.dom.style(document.body, {
      'overflow-x': '',
      'overflow-y': ''
    });

    if (highed.isFn(hideDimmer)) {
      hideDimmer();
    }

    visible = false;

    if (!suppress) {
      events.emit('Hide');
    }
  }

  ///////////////////////////////////////////////////////////////////////////

  highed.ready(function() {
    highed.dom.style(container, {
      display: "none"
    });
    highed.dom.ap(document.body, container);
  });

  if (contents) {
    // if (highed.isStr(contents)) {
    //    contents = highed.dom.cr('div', '', contents);
    // }
    // highed.dom.ap(container,
    //    contents
    // );
  }

  hide(true);

  ///////////////////////////////////////////////////////////////////////////

  //Public interface
  return {
    on: events.on,
    show: show,
    hide: hide,
    /** The container DOM node
         *  @memberof highed.OverlayModal
         */
    body: container
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Horizontal splitter
 *
 *  Splits a view into two horizontal cells
 *
 *  @example
 *  var splitter = highed.HSplitter(document.body);
 *  highed.dom.ap(splitter.left, highed.dom.cr('div', '', 'Left!'));
 *  highed.dom.ap(splitter.right, highed.dom.cr('div', '', 'Right!'));
 *
 *  @constructor
 *  @param parent {domnode} - the parent to attach to
 *  @param attributes {object} - the settings for the splitter
 *    > leftWidth {number} - the width in percent of the left cell
 *    > noOverflow {bool} - whether or not overflowing is allowed
 *    > leftClasses {string} - additional css classes to use for the left body
 *    > rightClasses {string} - additional css classes to use for the right body
 *    > allowResize {boolean} - set to true to enable user-resizing
 *    > leftMax {number} - the max width of the left panel
 *    > rightMax {number} - the max width of the right panel
 */
highed.HSplitter = function(parent, attributes) {
  var properties = highed.merge(
      {
        leftWidth: 40,
        noOverflow: false,
        leftClasses: '',
        rightClasses: '',
        allowResize: false,
        responsive: false,
        leftMax: false,
        rightMax: false
      },
      attributes
    ),
    container = highed.dom.cr('div', 'highed-hsplitter'),
    left = highed.dom.cr(
      'div',
      'highed-scrollbar panel left ' + properties.leftClasses
    ),
    right = highed.dom.cr(
      'div',
      'highed-scrollbar panel right ' + properties.rightClasses
    ),
    leftBody = highed.dom.cr(
      'div',
      'highed-scrollbar highed-hsplitter-body ' + properties.leftClasses
    ),
    rightBody = highed.dom.cr(
      'div',
      'highed-scrollbar highed-hsplitter-body ' + properties.rightClasses
    ),
    resizeBar = highed.dom.cr('div', 'highed-hsplitter-resize-bar'),
    mover;

  if (properties.responsive) {
    left.className += ' highed-hsplitter-body-responsive';
  }

  ///////////////////////////////////////////////////////////////////////////

  function updateSizeFromMover(x) {
    var psize;

    if (properties.allowResize && highed.dom.isVisible(right)) {
      psize = highed.dom.size(container);
      x = x || highed.dom.pos(resizeBar).x;

      highed.dom.style(left, {
        width: x + 'px'
      });

      highed.dom.style(right, {
        width: psize.w - x + 'px'
      });

      highed.dom.style(resizeBar, {
        display: ''
      });
    }
  }

  /** Force a resize of the splitter
     *  @memberof highed.HSplitter
     *  @param w {number} - the width of the splitter (will use parent if null)
     *  @param h {number} - the height of the splitter (will use parent if null)
     */
  function resize(w, h) {
    var s = highed.dom.size(parent),
      st,
      ps;

    //Check if the right side is visible
    if (!highed.dom.isVisible(right)) {
      highed.dom.style(left, {
        width: '100%'
      });

      highed.dom.style(resizeBar, {
        display: 'none'
      });
    } else {
      resetSize();
    }

    if (properties.responsive) {
      st = window.getComputedStyle(left);
      if (st.float === 'none') {
        highed.dom.style(right, {
          width: '100%'
        });

        highed.dom.style(resizeBar, {
          display: 'none'
        });
      } else {
        resetSize();
      }
    }

    highed.dom.style([left, right, container, resizeBar], {
      height: (h || s.h) + 'px'
    });

    if (properties.rightMax) {
      highed.dom.style(right, {
        'max-width': properties.rightMax + 'px'
      });
    }

    if (properties.leftMax) {
      highed.dom.style(left, {
        'max-width': properties.leftMax + 'px'
      });
    }

    //If we're at right max, we need to resize the left panel
    ps = highed.dom.size(left);
    if (ps.w === properties.leftMax) {
      highed.dom.style(right, {
        width: s.w - properties.leftMax - 1 + 'px'
      });
    }

    updateSizeFromMover();
  }

  function resetSize() {
    highed.dom.style(left, {
      width: properties.leftWidth + '%'
    });

    highed.dom.style(right, {
      width: 100 - properties.leftWidth + '%'
    });
  }

  ///////////////////////////////////////////////////////////////////////////

  parent = highed.dom.get(parent);

  highed.dom.ap(
    highed.dom.get(parent),
    highed.dom.ap(
      container,
      highed.dom.ap(left, leftBody),
      highed.dom.ap(right, rightBody)
    )
  );

  resetSize();

  if (properties.noOverflow) {
    highed.dom.style([container, left, right], {
      'overflow-y': 'hidden'
    });
  }

  if (properties.allowResize) {
    highed.dom.ap(container, resizeBar);

    highed.dom.style(resizeBar, {
      left: properties.leftWidth + '%'
    });

    mover = highed.Movable(resizeBar, 'x').on('Moving', function(x) {
      updateSizeFromMover(x);
    });
  }

  //resize();

  ///////////////////////////////////////////////////////////////////////////

  // Public interface
  return {
    resize: resize,
    /** The dom node for the left cell
         *  @memberof highed.HSplitter
         *  @type {domnode}
         */
    left: leftBody,
    /** The dom node for the right cell
         *  @memberof highed.HSplitter
         *  @type {domnode}
         */
    right: rightBody
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Vertical splitter
 *  Splits a view into two vertical cells
 *
 *  @example
 *  var splitter = highed.VSplitter(document.body);
 *  highed.dom.ap(splitter.top, highed.dom.cr('div', '', 'Top!'));
 *  highed.dom.ap(splitter.bottom, highed.dom.cr('div', '', 'Bottom!'));
 *
 *  @constructor
 *  @param parent {domnode} - the parent to attach to
 *  @param attributes {object} - the settings for the splitter
 *    > topHeight {number} - the height in percent of the left cell. Alternatively, use '123px' to set a capped size.
 *    > noOverflow {bool} - whether or not overflowing is allowed
 */
highed.VSplitter = function(parent, attributes) {
  var properties = highed.merge(
      {
        topHeight: 40,
        noOverflow: false
      },
      attributes
    ),
    container = highed.dom.cr('div', 'highed-vsplitter'),
    top = highed.dom.cr('div', 'panel top highed-scrollbar'),
    bottom = highed.dom.cr('div', 'panel bottom highed-scrollbar'),
    topBody = highed.dom.cr('div', 'highed-vsplitter-body highed-scrollbar'),
    bottomBody = highed.dom.cr('div', 'highed-vsplitter-body highed-scrollbar');

  ///////////////////////////////////////////////////////////////////////////

  /** Force a resize of the splitter
     *  @memberof highed.VSplitter
     *  @param w {number} - the width of the splitter (will use parent if null)
     *  @param h {number} - the height of the splitter (will use parent if null)
     */
  function resize(w, h) {
    var s = highed.dom.size(parent);

    highed.dom.style(container, {
      width: (w || s.w) + 'px',
      height: (h || s.h) + 'px'
    });

    if (properties.topHeight.toString().indexOf('px') > 0) {
      highed.dom.style(top, {
        height: properties.topHeight
      });

      highed.dom.style(bottom, {
        height: (h || s.h) - parseInt(properties.topHeight, 10) + 'px'
      });
    } else {
      highed.dom.style(top, {
        height: properties.topHeight + '%'
      });

      highed.dom.style(bottom, {
        height: 100 - properties.topHeight + '%'
      });
    }
    //highed.dom.style([top, bottom, container], {
    //    width: (w || s.w) + 'px'
    //});
  }

  ///////////////////////////////////////////////////////////////////////////

  highed.dom.ap(
    highed.dom.get(parent),
    highed.dom.ap(
      container,
      highed.dom.ap(top, topBody),
      highed.dom.ap(bottom, bottomBody)
    )
  );

  if (properties.noOverflow) {
    highed.dom.style([container, top, bottom], {
      'overflow-y': 'hidden'
    });
  }

  parent = highed.dom.get(parent);

  ///////////////////////////////////////////////////////////////////////////

  // Public interface
  return {
    resize: resize,
    /** The dom node for the top cell
         *  @memberof highed.VSplitter
         *  @type {domnode}
         */
    top: topBody,
    /** The dom node for the bottom cell
         *  @memberof highed.VSplitter
         *  @type {domnode}
         */
    bottom: bottomBody
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Standard tabcontrol component
 *  @example
 *  var tabs = highed.TabControl(document.body),
 *      tab1 = tabs.createTab({title: 'Tab 1'}),
 *      tab2 = tabs.createTab({title: 'Tab 2'})
 *  ;
 *  //Append things to tab1|tab2.body
 *
 *  @constructor
 *
 *  @emits Focus {object} - when a new tab gets focus.
 *
 *  @param parent {domnode} - the node to attach to
 *  @param noOverflow {boolean} - set to true to disable scrollbars
 *  @param extraPadding {boolean} - set to true to have extra padding in bodies
 */
highed.TabControl = function(parent, noOverflow, extraPadding) {
  var container = highed.dom.cr('div', 'highed-tab-control'),
    paneBar = highed.dom.cr('div', 'tabs'),
    body = highed.dom.cr('div', 'body'),
    indicator = highed.dom.cr('div', 'indicator'),
    more = highed.dom.cr('div', 'highed-tab-control-more fa fa-chevron-right'),
    events = highed.events(),
    selectedTab = false,
    tabs = [],
    ctx = highed.ContextMenu();

  ///////////////////////////////////////////////////////////////////////////

  //Build ctx menu
  function buildCTX() {
    ctx.build(
      tabs.map(function(tab) {
        return {
          title: tab.title,
          click: tab.focus,
          selected: tab.selected
        };
      })
    );
  }

  highed.dom.on(more, 'click', function(e) {
    buildCTX();
    ctx.show(e.clientX, e.clientY);
  });

  /** Force a resize of the tab control
   *  @memberof highed.TabControl
   *  @param w {number} - the width, uses parent width if null
   *  @param h {number} - the height, uses parent width if null
   */
  function resize(w, h) {
    var cs = highed.dom.size(parent),
      ps = highed.dom.size(paneBar),
      width = 0;

    highed.dom.style(container, {
      height: (h || cs.h) + 'px'
    });

    highed.dom.style(body, {
      height: (h || cs.h) - ps.h + 'px'
    });

    //Also re-focus the active tab
    if (selectedTab) {
      selectedTab.focus();
    }

    //clientWidth/scrollWidth doesn't produce what we need,
    //so let's check the accumulated width of the tabs.

    tabs.forEach(function(tab) {
      width += highed.dom.size(tab.node).w || 0;
    });

    if (width > paneBar.scrollWidth) {
      highed.dom.style(more, {
        display: 'block'
      });
    } else {
      highed.dom.style(more, {
        display: 'none'
      });
    }
  }

  /** Select the first tab
   *  @memberof highed.TabControl
   */
  function selectFirst() {
    tabs.some(function(tab) {
      if (tab.visible()) {
        tab.focus();
        return true;
      }
    });
  }

  /** Hide the tab control
   *  @memberof highed.TabControl
   */
  function hide() {
    highed.dom.style(container, {
      display: 'none'
    });
  }

  /** Show the tab control
   *  @memberof highed.TabControl
   */
  function show() {
    highed.dom.style(container, {
      display: 'block'
    });
  }

  function updateVisibility() {
    var c = tabs.filter(function(a) {
      return a.visible();
    }).length;

    if (c < 2) {
      highed.dom.style(paneBar, {
        display: 'none'
      });
    } else {
      highed.dom.style(paneBar, {
        display: ''
      });
    }
  }

  /* Create and return a new tab
     * @memberof highed.TabControl
     * @name createTab
     * @properties - the properties for the tab:
     *   > title {string} - the title of the tab
     * @returns {object} - an interface to the tab
     *    > hide {function} - hide the tab
     *    > show {function} - show the tab
     *    > focus {function} - make the tab active
     *    > visible {function} - returns true if the tab is visible
     *    > body {domnode} - the tab body
     */
  function Tab(properties) {
    var tevents = highed.events(),
      tab = highed.dom.cr('div', 'tab', properties.title),
      tbody = highed.dom.cr('div', 'tab-body'),
      visible = true,
      texports = {
        selected: false
      };

    if (extraPadding) {
      tbody.className += ' tab-body-padded';
    }

    highed.dom.ap(paneBar, tab);
    highed.dom.ap(body, tbody);

    function hide() {
      visible = false;
      highed.dom.style(tab, { display: 'none' });
      updateVisibility();
    }

    function show() {
      visible = true;
      highed.dom.style(tab, { display: '' });
      updateVisibility();
    }

    function resize(w, h) {
      highed.dom.style(container, { width: w + 'px', height: h + 'px' });
    }

    function focus() {
      var tsize = highed.dom.size(tab),
        tpos = highed.dom.pos(tab);
      if (!visible) {
        return;
      }

      if (selectedTab) {
        selectedTab.node.className = 'tab';
        selectedTab.selected = false;

        highed.dom.style(selectedTab.body, {
          opacity: 0,
          //                  'pointer-events': 'none',
          display: 'none'
        });
      }

      if (!tsize || !tpos || !tsize.w) {
        //We're not ready yet..
      }

      highed.dom.style(indicator, {
        width: tsize.w + 'px',
        left: tpos.x + 'px'
      });

      tab.className = 'tab tab-selected';

      highed.dom.style(tbody, {
        opacity: 1,
        //                'pointer-events': 'auto',
        display: 'block'
      });

      selectedTab = texports;
      selectedTab.selected = true;
      tevents.emit('Focus');

      events.emit('Focus', texports);
    }

    highed.dom.on(tab, 'click', function() {
      focus();
      highed.emit('UIAction', 'TabControlNavigation', properties.title);
    });

    texports = {
      on: tevents.on,
      focus: focus,
      node: tab,
      body: tbody,
      hide: hide,
      show: show,
      resize: resize,
      title: properties.title,
      visible: function() {
        return visible;
      }
    };

    if (!selectedTab) {
      focus();
    }

    if (noOverflow) {
      highed.dom.style(tbody, {
        overflow: 'hidden'
      });
    }

    tabs.push(texports);

    resize();
    updateVisibility();

    return texports;
  }

  ///////////////////////////////////////////////////////////////////////////

  if (!highed.isNull(parent)) {
    highed.ready(function() {
      highed.dom.ap(
        parent,
        highed.dom.ap(container, highed.dom.ap(paneBar, more, indicator), body)
      );

      resize();
      updateVisibility();
    });
  }

  ///////////////////////////////////////////////////////////////////////////

  return {
    container: container,
    on: events.on,
    createTab: Tab,
    resize: resize,
    selectFirst: selectFirst,
    show: show,
    hide: hide,
    /** Get the size of the title bar
     *  @memberof highed.TabControl
     *  @returns {object}
     *    > w {number} - the width of the control
     *    > h {number} - the height of the control
     */
    barSize: function() {
      return highed.dom.size(paneBar);
    }
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** An editable field
 *
 *  Creates a table row with three columns:
 *    - label
 *    - widget
 *    - help icon
 *  @todo This needs a proper cleaning now that the requirements are set.
 *  @example
 *  //Create a table, append to body, add a color picker to it.
 *  highed.dom.ap(document.body,
 *      highed.dom.ap(highed.dom.cr('table'),
 *          highed.InspectorField('color', '#FFF', {
 *              title: 'Set the color!'
 *          }, function (newValue) {
 *              highed.dom.style(document.body, {
 *                  backgroundColor: newValue
 *              });
 *          })
 *      )
 *  );
 *
 *  @param type {enum} - the type of widget to use
 *    > string
 *    > number
 *    > range
 *    > boolean
 *    > color
 *    > font
 *    > options
 *    > object
 *  @param value {anything} - the current value of the field
 *  @param properties {object} - the properties for the widget
 *  @param fn {function} - the function to call when the field is changed
 *     > {anything} - the changed value
 *  @param nohint {boolean} - if true, the help icon will be skipped
 *  @param fieldID {anything} - the id of the field
 *  @returns {domnode} - a DOM node containing the field + label wrapped in a tr
 */
highed.InspectorField = function(type, value, properties, fn, nohint, fieldID) {
  var createReset = function(resetTo, callback) {
      var node = highed.dom.cr('div', 'highed-field-reset fa fa-undo');

      if (resetTo === 'null') {
        resetTo = null;
      }

      highed.dom.on(node, 'click', function() {
        if (highed.isFn(callback)) {
          callback(properties.defaults || resetTo);
        }
      });

      return node;
    },
    fields = {
      string: function(val, callback) {
        var input = highed.dom.cr('input', 'highed-field-input', '', fieldID),
          reset = createReset(properties.defaults || val || value, function(v) {
            input.value = val = v;
            tryCallback(callback, v);
          });

        highed.dom.on(input, 'change', function(e) {
          tryCallback(callback, input.value);
          e.cancelBubble = true;
        });

        input.value = val || value;

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          reset,
          input
        );
      },
      number: function(val, callback) {
        var input = highed.dom.cr('input', 'highed-field-input', '', fieldID),
          reset = createReset(properties.defaults || val || value, function(v) {
            input.value = val = v;
            tryCallback(callback, parseFloat(v));
          });

        input.type = 'number';

        if (!highed.isNull(properties.custom)) {
          input.step = properties.custom.step;
          input.min = properties.custom.minValue;
          input.max = properties.custom.maxValue;
        }

        highed.dom.on(input, 'change', function() {
          tryCallback(callback, parseFloat(input.value));
        });

        input.value = val || value;

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          reset,
          input
        );
      },
      range: function(val, callback) {
        var slider = highed.Slider(false, {
          min: properties.custom.minValue,
          max: properties.custom.maxValue,
          step: properties.custom.step,
          value: val || value,
          resetTo: properties.defaults
        });

        slider.on('Change', function(v) {
          tryCallback(callback, v);
        });

        return slider.container;
      },
      boolean: function(val, callback) {
        var input = highed.dom.cr('input', '', '', fieldID),
          reset = createReset(properties.defaults || val || value, function(v) {
            input.checked = val = highed.toBool(v);
            tryCallback(callback, val);
          });

        input.type = 'checkbox';

        input.checked = highed.toBool(val || value);

        highed.dom.on(input, 'change', function() {
          tryCallback(callback, input.checked);
        });

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          reset,
          input
        );
      },
      color: function(val, callback) {
        var box = highed.dom.cr('div', 'highed-field-colorpicker', '', fieldID),
          reset = highed.dom.cr('div', 'highed-field-reset fa fa-undo'),
          resetTo = val || value || properties.defaults;

        if (resetTo === 'null') {
          resetTo = null;
        }

        function update(col, callback) {
          if (
            col &&
            col !== 'null' &&
            col !== 'undefined' &&
            typeof col !== 'undefined'
          ) {
            box.innerHTML = col;
          } else {
            box.innerHTML = 'auto';
            col = '#FFFFFF';
          }

          highed.dom.style(box, {
            background: col,
            color: highed.getContrastedColor(col)
          });
        }

        function fixVal() {
          //This is very ugly
          try {
            val = JSON.parse(val);
          } catch (e) {}

          if (highed.isArr(val)) {
            val = '#FFF';
          }
        }

        fixVal();

        highed.dom.on(box, 'click', function(e) {
          highed.pickColor(e.clientX, e.clientY, val || value, function(col) {
            if (highed.isArr(val)) {
              val = '#FFFFFF';
            }

            val = col;
            update(col);
            tryCallback(callback, col);
          });
        });

        highed.dom.on(reset, 'click', function() {
          val = resetTo;
          fixVal();
          update(val);
          tryCallback(callback, val);
        });

        update(val || value);

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          box,
          reset
        );
      },
      font: function(val, callback) {
        return fields.cssobject(val, callback);
      },
      configset: function(val, callback) {
        return fields.string(val, callback);
      },
      json: function(val, callback) {
        var textArea = highed.dom.cr(
            'textarea',
            'highed-field-input',
            '',
            fieldID
          ),
          errorBar = highed.dom.cr('div', 'highed-field-error'),
          editor = false,
          updateIt = function(v) {
            if (editor) {
              editor.setValue(JSON.stringify(v, undefined, '\t'));
            } else {
              textArea.value = JSON.stringify(v, undefined, '\t');
            }
          },
          reset = createReset(properties.defaults || val || value, function(v) {
            val = v;
            updateIt(v);
            tryCallback(callback, v);
          }),
          parent = highed.dom.ap(
            highed.dom.cr('div', 'highed-field-container'),
            textArea,
            reset,
            errorBar
          );

        function resizePoll() {
          if (document.body && editor) {
            if (document.getElementById(fieldID)) {
              editor.refresh();
            } else {
              setTimeout(resizePoll, 10);
            }
          }
        }

        function callHome(v) {
          try {
            v = JSON.parse(v);
            tryCallback(callback, v);
            errorBar.innerHTML = '';
            highed.dom.style(errorBar, { display: 'none', opacity: 0 });
          } catch (e) {
            //highed.snackBar('There\'s an error in your JSON: ' + e);
            errorBar.innerHTML = 'Syntax error: ' + e;
            highed.dom.style(errorBar, { display: 'block', opacity: 1 });
          }
        }

        if (typeof window['CodeMirror'] !== 'undefined') {
          editor = CodeMirror.fromTextArea(textArea, {
            lineNumbers: true,
            mode: 'application/json',
            theme: highed.option('codeMirrorTheme')
          });

          updateIt(val || value || properties.defaults);

          editor.on('change', function() {
            callHome(editor.getValue());
          });

          resizePoll();
        } else {
          updateIt(val || value || properties.defaults);

          highed.dom.on(textArea, 'change', function() {
            callHome(textArea.value);
          });
        }

        return parent;
      },
      cssobject: function(val, callback) {
        var picker = highed.FontPicker(callback || fn, val || value),
          reset = createReset(properties.defaults || val || value, function(v) {
            val = v;
            picker.set(val);
            tryCallback(callback, v);
          });

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          reset,
          picker.container
        );
      },
      options: function(val, callback) {
        var ddown = highed.DropDown(),
          reset = createReset(properties.defaults, function(v) {
            val = v;
            ddown.selectById(val);
            tryCallback(callback, v);
          });

        if (highed.isStr(properties.values)) {
          try {
            properties.values = JSON.parse(properties.values);
          } catch (e) {
            properties.values = properties.values.split(' ');
          }
        }

        ddown.addItems(properties.values);
        ddown.addItem({ title: 'auto', id: properties.defaults });

        ddown.selectById(val || value || properties.defaults);

        ddown.on('Change', function(selected) {
          tryCallback(callback, selected.id());
        });

        return highed.dom.ap(
          highed.dom.cr('div', 'highed-field-container'),
          ddown.container,
          reset
        );
      },
      object: function(val, callback) {
        //Create a sub-table of options
        var stable = highed.dom.cr(
            'table',
            'highed-customizer-table',
            '',
            fieldID
          ),
          wasUndefined = highed.isNull(val || value);

        val = val || value || {};

        if (highed.isStr(val)) {
          try {
            val = JSON.parse(val);
          } catch (e) {}
        }

        if (properties && highed.isArr(properties.attributes)) {
          properties.attributes.forEach(function(attr) {
            val[attr.name || attr.id] =
              val[attr.name || attr.id] ||
              attr.defaults ||
              (attr.dataType.indexOf('object') >= 0 ? {} : '');

            attr.title = highed.uncamelize(attr.title);

            highed.dom.ap(
              stable,
              highed.InspectorField(
                attr.dataType,
                val[attr.name || attr.id] || attr.defaults,
                attr,
                function(nval) {
                  val[attr.name || attr.id] = nval;
                  tryCallback(callback, val);
                }
              )
            );
          });
        }

        if (wasUndefined) {
          // tryCallback(callback, val);
        }

        return stable;
      },

      function: function(val, callback) {
        var container = highed.dom.cr(
            'div',
            'highed-field-container highed-field-code-container'
          ),
          field = highed.dom.cr('textarea', 'highed-field-code', '', fieldID),
          editor = false,
          reset = createReset(properties.defaults || val || value, function(v) {
            val = v;
            updateIt(v);
            callHome(v);
          });

        function updateIt(v) {
          if (highed.isFn(v)) {
            v = v.toString();
          }

          if (editor) {
            editor.setValue(v);
            editor.refresh();
          } else {
            field.value = v;
          }
        }

        function callHome(v) {
          var args = [];
          var argStart = v.indexOf('(');
          var argEnd = v.substr(argStart + 1).indexOf(')');
          var body = '';
          var balance = 0;
          var parsing = false;

          try {
            args = v
              .substr(argStart + 1, argEnd - 1)
              .trim()
              .split(',');

            args = args.filter(function(b) {
              return b && b.length > 0 && b.indexOf('/*') === -1;
            });

            for (var i = 0; i < v.length; i++) {
              if (v[i] === '{') {
                balance++;
                parsing = true;
              } else if (v[i] === '}') {
                balance--;
                if (balance === 0) {
                  parsing = false;
                }
              } else if (parsing) {
                body += v[i];
              }
            }

            v = new Function(args, body);
          } catch (e) {
            console.log(e);
            return;
          }
          tryCallback(callback, v);
        }

        function resizePoll() {
          if (editor && document.body) {
            if (container.parentNode) {
              editor.refresh();
            } else {
              setTimeout(resizePoll, 50);
            }
          }
        }

        highed.dom.ap(container, field);

        if (typeof window['CodeMirror'] !== 'undefined') {
          editor = CodeMirror.fromTextArea(field, {
            lineNumbers: true,
            mode: 'javascript',
            theme: highed.option('codeMirrorTheme')
          });

          editor.on('change', function() {
            callHome(editor.getValue());
          });

          resizePoll();
        } else {
          highed.dom.on(field, 'change', function() {
            callHome(field.value);
          });
        }

        updateIt(val || value || properties.defaults || function() {});

        return container;
      },

      array: function() {
        var container = highed.dom.cr('div', '', '', fieldID),
          add = highed.dom.cr('span', 'highed-field-array-add fa fa-plus', ''),
          itemsNode = highed.dom.cr('div', 'highed-inline-blocks'),
          items = {},
          itemCounter = 0,
          itemTable = highed.dom.cr('table', 'highed-field-table');

        if (highed.isStr(value)) {
          try {
            value = JSON.parse(value);
          } catch (e) {
            return container;
          }
        }

        if (value && !highed.isArr(value) && !highed.isBasic(value)) {
          // This is an object.
          value = Object.keys(value).map(function(e) {
            return value[e];
          });
        }

        function addCompositeItem(val, suppressCallback) {
          var item,
            rem = highed.dom.cr('span', 'highed-icon fa fa-trash'),
            row = highed.dom.cr('tr'),
            id = ++itemCounter;

          function processChange(newVal) {
            if (newVal) {
              items[id].value = newVal;
              doEmitCallback();
            }
          }

          function doEmitCallback() {
            if (highed.isFn(fn)) {
              fn(
                Object.keys(items).map(function(key) {
                  return items[key].value;
                })
              );
            }
          }

          if (highed.isArr(val)) {
            val = val[id];
          }

          items[id] = {
            id: id,
            row: row,
            value: val
          };

          item = fields[properties.subType]
            ? fields[properties.subType](
                val || value[id] || properties.defaults,
                processChange
              )
            : fields.string(val, processChange);

          highed.dom.ap(
            itemTable,
            highed.dom.ap(
              row,
              highed.dom.ap(highed.dom.cr('td'), item),
              highed.dom.ap(highed.dom.cr('td'), rem)
            )
          );

          highed.dom.on(rem, 'click', function(e) {
            delete items[id];
            itemTable.removeChild(row);

            doEmitCallback();

            e.cancelBubble = true;
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          });

          if (!suppressCallback) {
            processChange();
          }
        }

        highed.dom.ap(container, itemTable);

        highed.dom.on(add, 'click', function() {
          addCompositeItem();
        });

        if (highed.isArr(value)) {
          value.forEach(function(item) {
            addCompositeItem(item, true);
          });
        }

        highed.dom.ap(container, itemsNode, add);

        return container;
      }
    },
    help = highed.dom.cr(
      'span',
      'highed-icon highed-field-help fa fa-question-circle'
    ),
    helpTD = highed.dom.cr('td', 'highed-customizer-table-help'),
    widgetTD = highed.dom.cr('td', 'highed-field-table-widget-column'),
    titleCol = highed.dom.cr('td'),
    typeIndicator = highed.dom.cr('span', 'highed-customize-type');

  function tryCallback(cb, val) {
    cb = cb || fn;
    if (highed.isFn(cb)) {
      cb(val);
    }
  }

  function deduceObject() {
    if (
      (!properties.attributes || !properties.attributes.length) &&
      properties.defaults
    ) {
      properties.attributes = [];

      //There's no attributes but it's an object.
      //Check if there are default values we can use
      //to figure out the structure.
      if (properties.defaults) {
        try {
          properties.defaults = JSON.parse(properties.defaults);
          Object.keys(properties.defaults).forEach(function(k) {
            var tp = 'string',
              def = properties.defaults[k],
              up = k.toUpperCase(),
              vals;

            //This is hackish.
            if (highed.isNum(def)) {
              tp = 'number';
            }

            if (
              def.length &&
              def[0] === '#' &&
              (up.indexOf('BACKGROUND') >= 0 || up.indexOf('COLOR') >= 0)
            ) {
              tp = 'color';
            }

            properties.attributes.push({
              id: k,
              title: k,
              dataType: tp,
              defaults: properties.defaults[k],
              tooltip: '',
              values: vals
            });
          });
        } catch (e) {
          highed.log(
            3,
            'property',
            properties.id,
            'skipped, no way to deduce the object members'
          );
          return;
        }
      }
    } else {
      type = 'json';
      properties.defaults = properties.defaults || {};
    }
  }

  if (highed.isNull(value)) {
    value = '';
  }

  if (type === 'cssobject') {
    //So there are more than one version of this thing - one of them
    //requires a font picker, the other is dynamic.
    //Figure out which one we're dealing with here.

    // properties = properties || {};
    // properties.attributes = [
    //     {name: 'x', title: 'x', title: 'X', values: '0', dataType: 'number'}

    // ];
    type = 'object';
  }

  //Choose a type
  if (type && type.indexOf('|') >= 0) {
    type = type.indexOf('object') >= 0 ? 'object' : type.split('|')[0];
  }

  if (
    !highed.isNull(properties.custom) &&
    !highed.isNull(properties.custom.minValue) &&
    !highed.isNull(properties.custom.maxValue) &&
    !highed.isNull(properties.custom.step)
  ) {
    type = 'range';
  }

  if (type && type.indexOf('array') === 0) {
    properties.subType = type.substr(6, type.length - 7);
    type = 'array';

    if (properties.subType === 'object') {
      deduceObject();
    }
  }

  if (type === 'object') {
    deduceObject();
  }

  if (!properties.tooltip && !properties.tooltipText) {
    nohint = true;
  } else {
    // properties.tooltip = properties.tooltip.replace(/\n/g, '<br/><br/>');
  }

  if (highed.onPhone()) {
    highed.dom.on(help, 'click', function() {
      highed.Tooltip(0, 0, properties.tooltip || properties.tooltipText, true);
    });
  } else {
    highed.dom.on([help], 'mouseover', function(e) {
      highed.Tooltip(
        e.clientX + 20,
        e.clientY,
        properties.tooltip || properties.tooltipText
      );

      // highed.showDimmer(highed.hideAllTooltips, true, true);
    });
  }

  if (nohint) {
    highed.dom.style(help, { display: 'none' });
    widgetTD.colSpan = 2;
  }

  typeIndicator.className += ' highed-customize-type-' + type;

  return highed.dom.ap(
    highed.dom.ap(
      highed.dom.cr('tr'),
      highed.dom.ap(
        titleCol,
        highed.dom.cr('span', 'highed-customize-field-label', properties.title),
        typeIndicator
      ),
      highed.dom.ap(widgetTD, fields[type] ? fields[type]() : fields.string()),
      !nohint
        ? highed.dom.ap(
            helpTD,
            //highed.dom.cr('span', 'highed-field-tooltip', properties.tooltip)
            help
          )
        : false
    )
  );
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A list component
 *
 *  Creates a list with selectable items
 *
 *  @example
 *  var list = highed.List(document.body).addItem({
 *      title: 'My Item',
 *      click: function() {
 *          alert('You clicked the item!');
 *      }
 *  });
 *
 *  @constructor
 *  @param parent {domnode} - the node to attach the list to
 *  @param responsive {boolean} - set to true to get JS-based responsive functionality
 */
highed.List = function(parent, responsive) {
  var container = highed.dom.cr('div', 'highed-list'),
    compactIndicator = highed.dom.cr('div', 'highed-list-compact', 'compact'),
    ctx = highed.ContextMenu(),
    selectedItem = false,
    events = highed.events(),
    items = [];

  ///////////////////////////////////////////////////////////////////////////

  /** Add an item to the list
     * @memberof highed.List
     * @param item {object} - the item meta for the item to add
     *   > title {string} - the title as displayed in the list
     *   > id {anything} - the id of the item: used for `highed.List.on('Select')`
     *   > click {function} - function to call when clicking the item
     * @returns {object} - an interface to interact with the item
     *   > id {anything} - the item id
     *   > title {string} - the title of the item
     *   > node {domnode} - the dom node for the item
     *   > select {function} - selects the item if called
     */
  function addItem(item) {
    var node = highed.dom.cr('a', 'item', item.title),
      iexports = {};

    function select(e) {
      if (selectedItem) {
        selectedItem.selected = false;
        selectedItem.node.className = 'item';
      }

      selectedItem = iexports;
      selectedItem.selected = true;
      node.className = 'item item-selected';
      events.emit('Select', item.id);
      compactIndicator.innerHTML =
        '<span class="icon fa fa-th-list"></span>' + item.title;

      if (highed.isFn(item.click)) {
        return item.click(e);
      }
    }

    highed.dom.on(node, 'click', select);
    highed.dom.ap(container, node);

    iexports = {
      id: item.id,
      title: item.title,
      node: node,
      select: select,
      selected: false
    };

    items.push(iexports);

    if (!selectedItem) {
      select();
    }

    return iexports;
  }

  /** Add a set of items to the list
     *  @memberof highed.List
     *  @param items {array<object>} - an array of items to add
     */
  function addItems(items) {
    if (highed.isArr(items)) {
      items.forEach(addItem);
    }
  }

  /** Clear all the items in the list
     *  @memberof highed.List
     */
  function clear() {
    container.innerHTML = '';
  }

  /** Force resize of the list
     *  @memberof highed.List
     */
  function resize() {
    var ps = highed.dom.size(parent),
      cs = highed.dom.size(container);

    if (responsive && ps.h < 50 && ps.h !== 0 && ps.h) {
      highed.dom.style(compactIndicator, {
        display: 'block'
      });
      highed.dom.style(container, {
        display: 'none'
      });
    } else if (responsive) {
      highed.dom.style(compactIndicator, {
        display: 'none'
      });
      highed.dom.style(container, {
        display: ''
      });
    }

    // highed.dom.style(container, {
    //     //height: ps.height + 'px'
    //     height: '100%'
    // });
  }

  /** Show the list
    *  @memberof highed.List
    */
  function show() {
    highed.dom.style(container, {});
  }

  /** Hide the list
     *  @memberof highed.List
     */
  function hide() {}

  /** Select the first item
     *  @memberof highed.List
     */
  function selectFirst() {
    if (items.length > 0) {
      items[0].select();
    }
  }

  /** Select an item
     *  @memberof highed.List
     *  @param which {string} - the id of the item to select
     */
  function select(which) {
    items.some(function(item) {
      if (which === item.title) {
        item.select();
        return true;
      }
    });
  }

  /** Reselect the current item
     *  @memberof highed.List
     */
  function reselect() {
    if (selectedItem) {
      selectedItem.select();
    }
  }

  /** Count the number of items currently in the list
     *  @memberof highed.List
     */
  function countItems() {
    return items.length;
  }

  /** Get the selected item
     *  @memberof highed.List
     *  @returns {object} - the selected item
     */
  function selected() {
    return selectedItem;
  }
  ///////////////////////////////////////////////////////////////////////////

  highed.dom.on(compactIndicator, 'click', function(e) {
    ctx.build(
      items.map(function(item) {
        return {
          title: item.title,
          click: item.select,
          selected: item.selected
        };
      })
    );
    ctx.show(e.clientX, e.clientY);
  });

  highed.dom.ap(parent, container, compactIndicator);

  ///////////////////////////////////////////////////////////////////////////

  //Public interface
  return {
    on: events.on,
    addItem: addItem,
    addItems: addItems,
    clear: clear,
    resize: resize,
    show: show,
    hide: hide,
    selectFirst: selectFirst,
    select: select,
    reselect: reselect,
    selected: selected,
    count: countItems,
    container: container
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var container = highed.dom.cr(
      'div',
      'highed-colorpicker highed-colorpicker-responsive'
    ),
    canvas = highed.dom.cr('canvas', 'picker'),
    closeBtn = highed.dom.cr('div', 'highed-ok-button', 'Close'),
    ctx = canvas.getContext('2d'),
    manualInput = highed.dom.cr('input', 'manual');
    manualInput.setAttribute("aria-hidden", "true");

  //Attach the container to the document when the document is ready
  highed.ready(function() {
    highed.dom.style(container, {
      display: "none"
    });
    highed.dom.ap(document.body, container);
  });

  function updatePickerBackground(current) {
    highed.dom.style(manualInput, {
      background: current,
      color: highed.getContrastedColor(current)
    });
  }

  /** Color picker
     *  Component to pick colors from the google material design color palette.
     *  User input is also possible.
     *
     *  The color palette is defined in meta/highed.meta.colors.js,
     *  and is divided into groups of 14 hues per. color.
     *
     *  @example
     *  //Show a color picker at [10,10]
     *  highed.pickColor(10, 10, '#fff', function (color) {
     *      alert('You selected ' + color + ', great choice!');
     *  });
     *
     *  @param x {number} - the x position to display the picker at
     *  @param y {number} - the y position to display the picker at
     *  @param current {string} - the current color
     *  @param fn {function} - the function to call when the color changes
     *    > newColor {string} - the color selected by the user
     */
  highed.pickColor = function(x, y, current, fn) {
    highed.dom.style(container, {display: "block"});
    var windowSize = highed.dom.size(document.body),
      containerSize = highed.dom.size(container),
      pickerSize = highed.dom.size(canvas),
      binder = false,
      pbinder = false,
      cbinder = false,
      dbinder = false;

    ///////////////////////////////////////////////////////////////////////

    /* Draws the color picker itself */
    function drawPicker() {
      //There's 14 hues per. color, 19 colors in total.
      var x,
        y,
        tx = Math.floor(pickerSize.w / 14),
        ty = Math.floor(pickerSize.h / 19),
        col = -1;

      canvas.width = pickerSize.w;
      canvas.height = pickerSize.h;

      //To avoid picking null
      ctx.fillStyle = '#FFF';
      ctx.fillRect(0, 0, pickerSize.w, pickerSize.h);

      for (y = 0; y < 19; y++) {
        for (x = 0; x < 15; x++) {
          ctx.fillStyle = highed.meta.colors[++col]; //highed.meta.colors[x + y * tx];
          ctx.fillRect(x * tx, y * ty, tx, ty);
        }
      }
    }

    /* Hide the picker */
    function hide() {
      highed.dom.style(container, {
        opacity: 0,
        left: '-20000px',
        'pointer-events': 'none'
      });
      binder();
      pbinder();
      cbinder();
      dbinder();
    }

    function rgbToHex(r, g, b) {
      var res = '#' + ((r << 16) | (g << 8) | b).toString(16);
      if (res.length === 5) {
        return res.replace('#', '#00');
      } else if (res.length === 6) {
        return res.replace('#', '#0');
      }
      return res;
    }

    function pickColor(e) {
      var px = e.clientX || e.touches[0].clientX || 0,
        py = e.clientY || e.touches[0].clientY || 0,
        cp = highed.dom.pos(canvas),
        id = ctx.getImageData(px - cp.x - x, py - cp.y - y, 1, 1).data,
        col = rgbToHex(id[0] || 0, id[1], id[2]);

      manualInput.value = col;

      updatePickerBackground(col);

      if (highed.isFn(fn)) {
        fn(col);
      }

      e.cancelBubble = true;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }

    ///////////////////////////////////////////////////////////////////////

    //Make sure we're not off screen
    if (x > windowSize.w - containerSize.w) {
      x = windowSize.w - containerSize.w - 10;
    }

    if (y > windowSize.h - containerSize.h) {
      y = windowSize.h - containerSize.h - 10;
    }

    highed.dom.style(container, {
      left: x + 'px',
      top: y + 'px',
      opacity: 1,
      'pointer-events': 'auto'
    });

    dbinder = highed.showDimmer(hide, true, true, 5);

    cbinder = highed.dom.on(closeBtn, 'click', hide);

    binder = highed.dom.on(manualInput, 'keyup', function() {
      if (highed.isFn(fn)) {
        fn(manualInput.value);
      }
    });

    pbinder = highed.dom.on(canvas, ['mousedown', 'touchstart'], function(e) {
      var mover = highed.dom.on(canvas, ['mousemove', 'touchmove'], pickColor),
        cancel = highed.dom.on(
          document.body,
          ['mouseup', 'touchend'],
          function() {
            mover();
            cancel();
          }
        );

      pickColor(e);
    });

    manualInput.value = current;
    updatePickerBackground(current);

    drawPicker();

    ///////////////////////////////////////////////////////////////////////

    return {};
  };

  highed.dom.ap(container, canvas, manualInput, closeBtn);
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A standard toolbar.
 *
 *  @example
 *  var toolbar = highed.Toolbar('my-node', {
 *    additionalCSS: ['cool-toolbar']
 *  });
 *
 *  @constructor
 *  @param parent {domnode} - the node to attach the toolbar to
 *  @param attributes {object} - toolbar settings
 *    > additionalCSS {array} - array of additional css classes to add to the toolbar
 */
highed.Toolbar = function(parent, attributes) {
  var properties = highed.merge(
      {
        additionalCSS: []
      },
      attributes
    ),
    container = highed.dom.cr(
      'div',
      'highed-toolbar ' + properties.additionalCSS.join(' ')
    ),
    left = highed.dom.cr('div', 'highed-toolbar-left'),
    right = highed.dom.cr('div', 'highed-toolbar-right'),
    center = highed.dom.cr('div', 'highed-toolbar-center'),
    iconsRight = highed.dom.cr('div', 'icons');

  ///////////////////////////////////////////////////////////////////////////

  /** Add an icon to the toolbar
     *  @memberof highed.Toolbar
     *  @param icon {object} - an object containing the icon settings.
     *    > css {array} - the additional css class(s) to use
     *    > click {function} - the function to call when the icon is clicked
     */
  function addIcon(icon, where) {
    var i = highed.dom.cr('div', 'icon highed-icon fa ' + (icon.css || ''));

    highed.dom.on(i, 'click', function(e) {
      if (highed.isFn(icon.click)) {
        icon.click(e);
      }
    });

    i.title = icon.tooltip || icon.title;

    highed.dom.ap(where === 'left' ? left : right, i);
  }

  /** Add a button to the toolbar
     *  @memberof highed.Toolbar
     *  @param icon {object} - an object containing the icon settings.
     *    > css {array} - the additional css class(s) to use
     *    > click {function} - the function to call when the icon is clicked
     */
  function addButton(icon, where) {
    var i = highed.dom.cr(
      'div',
      'highed-ok-button highed-toolbar-button',
      icon.title || ''
    );

    highed.dom.on(i, 'click', function(e) {
      if (highed.isFn(icon.click)) {
        icon.click(e);
      }
    });

    i.title = icon.tooltip;

    highed.dom.ap(where === 'left' ? left : right, i);
  }

  function addSeparator(where) {
    highed.dom.ap(
      where === 'left' ? left : right,
      highed.dom.cr('span', 'separator')
    );
  }

  ///////////////////////////////////////////////////////////////////////////

  highed.dom.ap(parent, highed.dom.ap(container, left, center, right));

  ///////////////////////////////////////////////////////////////////////////

  return {
    /** The toolbar container
         *  @type {domnode}
         *  @memberof highed.Toolbar
         */
    container: container,
    addIcon: addIcon,
    addButton: addButton,
    addSeparator: addSeparator,
    /** The left part of the toolbar
         *  @type {domnode}
         *  @memberof highed.Toolbar
         */
    left: left,
    /** The center part of the toolbar
         *  @type {domnode}
         *  @memberof highed.Toolbar
         */
    center: center,
    /** The right part of the toolbar
         *  @type {domnode}
         *  @memberof highed.Toolbar
         */
    right: right
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  /** Font picker
     *
     *  Creates a small font picking widget editing of:
     *      - bold
     *      - font family
     *      - font size
     *      - color
     *
     *  Note that this must be attached to the document manually by appending
     *  the returned container to something.
     *
     *  @example
     *  var picker = highed.FontPicker(function (newStyle) {
     *      highed.dom.style(document.body, newStyle);
     *  });
     *
     *  highed.dom.ap(document.body, picker.container);
     *
     *  @param fn {function} - the function to call when things change
     *  @param style {object} - the current style object
     *    > fontFamily {string} - the font family
     *    > color {string} - the font color
     *    > fontWeight {string} - the current font weight
     *    > fontStyle {string} - the current font style
     *  @returns {object} - an interface to the picker
     *    > container {domnode} - the body of the picker
     */
  highed.FontPicker = function(fn, style) {
    var container = highed.dom.cr('div', 'highed-font-picker'),
      fontFamily = highed.DropDown(), //highed.dom.cr('select', 'font-family'),
      fontSize = highed.DropDown(), //highed.dom.cr('select', 'font-size'),
      boldBtn = highed.PushButton(false, 'bold'),
      italicBtn = highed.PushButton(false, 'italic'),
      color = highed.dom.cr('span', 'font-color', '&nbsp;');

    if (highed.isStr(style)) {
      try {
        style = JSON.parse(style);
      } catch (e) {}
    }

    ///////////////////////////////////////////////////////////////////////

    function callback() {
      if (highed.isFn(fn)) {
        fn(style);
      }
    }

    function updateColor(ncol, suppressCallback) {
      highed.dom.style(color, {
        background: ncol
      });

      style.color = ncol;
      if (!suppressCallback) {
        callback();
      }
    }

    ///////////////////////////////////////////////////////////////////////

    /** Set the current options
         *  @memberof highed.FontPicker
         *  @param options {object} - the options to set
         */
    function set(options) {
      if (highed.isStr(options)) {
        try {
          options = JSON.parse(options);
        } catch (e) {
          highed.log(0, 'Error in FontPicker::set');
          return;
        }
      }

      style = highed.merge(
        {
          fontFamily:
            '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
          color: '#333',
          fontSize: '18px',
          fontWeight: 'normal',
          fontStyle: 'normal'
        },
        options
      );

      //Set the current values
      boldBtn.set(style.fontWeight === 'bold');
      italicBtn.set(style.fontStyle === 'italic');
      updateColor(style.color, true);
      fontFamily.selectById(style.fontFamily);
      fontSize.selectById(style.fontSize.replace('px', ''));
    }

    //Add fonts to font selector
    fontFamily.addItems(highed.meta.fonts);
    //Add font sizes
    fontSize.addItems([8, 10, 12, 14, 16, 18, 20, 22, 25, 26, 28, 30, 32, 34]);

    set(style);

    //Listen to font changes
    fontFamily.on('Change', function(selected) {
      style.fontFamily = selected.id();
      return callback();
    });

    //Listen to font size changes
    fontSize.on('Change', function(selected) {
      style.fontSize = selected.id() + 'px';
      return callback();
    });

    //Listen to bold changes
    boldBtn.on('Toggle', function(state) {
      style.fontWeight = state ? 'bold' : 'normal';
      callback();
    });

    //Listen to italic changes
    italicBtn.on('Toggle', function(state) {
      style.fontStyle = state ? 'italic' : 'normal';
      callback();
    });

    //Handle color picker
    highed.dom.on(color, 'click', function(e) {
      highed.pickColor(e.clientX, e.clientY, style.color, updateColor);
    });

    //Create DOM
    highed.dom.ap(
      container,
      fontFamily.container,
      highed.dom.ap(
        highed.dom.cr('div', 'highed-font-picker-button-container'),
        fontSize.container,
        highed.dom.ap(
          highed.dom.cr('div', 'highed-font-picker-buttons'),
          boldBtn.button,
          italicBtn.button,
          color
        )
      )
    );

    ///////////////////////////////////////////////////////////////////////

    return {
      set: set,
      container: container
    };
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A wizard-type stepper
 *  This is sort of like a tab control, but with a logical
 *  x -> y flow.
 *
 *  @emits Step - when going back/forth
 *  @emits AddStep - when a new step is added
 *
 *  @constructor
 *  @param bodyParent {domnode} - the node to attach the body to
 *  @param indicatorParent {domnode} - the node to attach the indicators to
 *  @param attributes {object} - the settings for the stepper
 *    > indicatorPos {enum} - the indicator alignment
 *       > top
 *       > bottom
 */
highed.WizardStepper = function(bodyParent, indicatorParent, attributes) {
  var properties = highed.merge(
      {
        indicatorPos: 'top'
      },
      attributes
    ),
    events = highed.events(),
    body = highed.dom.cr('div', 'highed-wizstepper-body'),
    indicators = highed.dom.cr('div', 'highed-wizstepper-indicators'),
    currentIndicator = highed.dom.cr('div', 'highed-wizstepper-current'),
    currentBubble = highed.dom.cr('div', 'highed-wizstpper-current-bubble'),
    activeStep = false,
    stepCount = 0,
    steps = [],
    ctx = highed.ContextMenu();

  ///////////////////////////////////////////////////////////////////////////

  /* Update the bar CSS - this is more stable than doing it in pure CS */
  function updateBarCSS() {
    var fsteps = steps.filter(function(t) {
      return t.visible;
    });

    stepCount = 0;

    fsteps.forEach(function(step, i) {
      if (i === 0) {
        step.bar.className = 'bar bar-first';
      } else if (i === fsteps.length - 1) {
        step.bar.className = 'bar bar-last';
      } else {
        step.bar.className = 'bar';
      }

      step.number = ++stepCount;

      step.bar.className +=
        ' ' + (properties.indicatorPos === 'bottom' ? 'bar-bottom' : 'bar-top');
    });
  }

  /** Add a new step
     *  @memberof highed.WizardStepper
     *  @param step {object} - an object describing the step
     *    > title {string} - the step title
     *  @returns {object} - interface to manipulate the step
     *    > activate {function} - function to activate the step
     *    > bubble {domnode} - the node for the bubble
     *    > body {domnode} - the node for the step body
     */
  function addStep(step) {
    var stepexports = {
      number: ++stepCount,
      node: highed.dom.cr('div', 'highed-wizstepper-item'),
      label: highed.dom.cr('div', '', step.title, 'label'),
      bubble: highed.dom.cr(
        'div',
        'bubble ' +
          (properties.indicatorPos === 'bottom'
            ? 'bubble-bottom'
            : 'bubble-top')
      ),
      bar: highed.dom.cr(
        'div',
        'bar ' +
          (properties.indicatorPos === 'bottom' ? 'bar-bottom' : 'bar-top')
      ),
      body: highed.dom.cr('div', 'highed-step-body'),
      visible: true
    };

    stepexports.title = step.title;

    function activate() {
      if (activeStep) {
        activeStep.bubble.innerHTML = '';

        highed.dom.style(activeStep.bubble, {
          height: '',
          width: '',
          bottom: '-4px',
          'font-size': '0px'
        });

        highed.dom.style(activeStep.body, {
          opacity: 0,
          display: 'none',
          'pointer-events': 'none'
        });

        if (properties.indicatorPos === 'top') {
          highed.dom.style(activeStep.bubble, {
            top: '-6px',
            bottom: ''
          });
        }

        activeStep.label.className = 'label-inactive';

        currentIndicator.innerHTML =
          step.title + ' - ' + stepexports.number + '/' + stepCount;

        //highed.dom.ap(currentIndicator, currentBubble);
        currentBubble.innerHTML = stepexports.number + '/' + stepCount;

        if (step.onshow) {
          step.onshow();
        }
      }

      stepexports.bubble.innerHTML = stepexports.number;

      highed.dom.style(stepexports.bubble, {
        height: '25px',
        width: '25px',
        bottom: '-8px',
        'font-size': '16px'
      });

      highed.dom.style(stepexports.body, {
        opacity: 1,
        display: 'block',
        'pointer-events': 'auto'
      });

      if (properties.indicatorPos === 'top') {
        highed.dom.style(stepexports.bubble, {
          top: '-10px'
        });
      }

      activeStep = stepexports;
      activeStep.label.className = 'label-active';

      events.emit('Step', stepexports, stepCount, step);
    }

    stepexports.hide = function() {
      highed.dom.style(stepexports.node, {
        display: 'none'
      });
      if (stepexports.visible) {
        //This needs fixing
        stepCount--;
        stepexports.visible = false;
        updateBarCSS();
      }
    };

    stepexports.show = function() {
      highed.dom.style(stepexports.node, {
        display: ''
      });

      if (!stepexports.visible) {
        stepCount++;
        stepexports.visible = true;
        updateBarCSS();

        if (step.onshow) {
          step.onshow();
        }
      }
    };

    stepexports.visible = function() {
      return visible;
    };

    highed.dom.on(stepexports.node, 'click', activate);

    if (!activeStep) {
      activate();
    }

    stepexports.activate = activate;

    steps.push(stepexports);

    updateBarCSS();

    highed.dom.ap(
      indicators,
      highed.dom.ap(
        stepexports.node,
        stepexports.label,
        stepexports.bar,
        stepexports.bubble
      )
    );

    highed.dom.ap(body, stepexports.body);

    events.emit('AddStep', activeStep, stepCount);

    return stepexports;
  }

  /** Go to the next step
     *  @memberof highed.WizardStepper
     */
  function next() {
    var fsteps = steps.filter(function(t) {
      return t.visible;
    });
    if (activeStep && activeStep.number < stepCount) {
      fsteps[activeStep.number].activate();
    }
  }

  /** Go to the previous step
     *  @memberof highed.WizardStepper
     */
  function previous() {
    var fsteps = steps.filter(function(t) {
      return t.visible;
    });
    if (activeStep && activeStep.number > 1) {
      fsteps[activeStep.number - 2].activate();
    }
  }

  /** Force a resize of the splitter
     *  @memberof highed.WizardStepper
     *  @param w {number} - the width of the stepper (will use parent if null)
     *  @param h {number} - the height of the stepper (will use parent if null)
     */
  function resize(w, h) {
    var ps = highed.dom.size(bodyParent);

    highed.dom.style(body, {
      height: (h || ps.h) + 'px'
    });
  }

  /** Select the first step
      * @memberof highed.WizardStepper
      */
  function selectFirst() {
    steps.some(function(step, i) {
      if (step.visible) {
        step.activate();
        return true;
      }
    });
  }

  highed.dom.on(currentIndicator, 'click', function(e) {
    var fsteps = steps.filter(function(t) {
      return t.visible;
    });

    ctx.build(
      fsteps.map(function(step) {
        return {
          title: step.title,
          click: step.activate,
          selected: activeStep.title === step.title
        };
      })
    );

    ctx.show(e.clientX, e.clientY);
  });

  ///////////////////////////////////////////////////////////////////////////

  highed.dom.ap(
    indicatorParent,
    indicators,
    highed.dom.ap(currentIndicator, currentBubble)
  );

  highed.dom.ap(bodyParent, body);

  ///////////////////////////////////////////////////////////////////////////

  return {
    on: events.on,
    addStep: addStep,
    next: next,
    resize: resize,
    previous: previous,
    selectFirst: selectFirst,
    /** The main body
         *  @memberof highed.WizardStepper
         *  @type {domnode}
         */
    body: body
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var container = highed.dom.cr(
    'div',
    'highed-scrollbar highed-tooltip highed-tooltip-fixed'
  );

  highed.ready(function() {
    highed.dom.style(container, {
      display: "none"
    });
    highed.dom.ap(document.body, container);
  });

  function hide() {
    highed.dom.style(container, {
      opacity: 0,
      'pointer-events': 'none'
    });
  }

  highed.dom.on(container, 'mouseout', hide);
  highed.dom.on(container, 'click', hide);

  /** Show a tooltip
     *  @param x {number} - the x position of the tooltip
     *  @param y {number} - the y position of the tooltip
     *  @param tip {string} - the title
     *  @param blowup {boolean}  - blow the tooltip up
     */
  highed.Tooltip = function(x, y, tip, blowup) {
    var ds = highed.dom.size(document.body);

    if (x < 0) x = 0;
    if (y < 0) y = 0;
    if (x > ds.w - 200) x = ds.w - 200;

    highed.dom.style(container, {
      opacity: 1,
      display: 'inline',
      'pointer-events': 'auto',
      left: x + 'px',
      top: y + 'px',
      'max-width': '300px'
    });

    if (blowup) {
      highed.dom.style(container, {
        opacity: 1,
        'pointer-events': 'auto',
        width: '90%',
        height: '90%',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      });
    }

    container.innerHTML = tip;

    return hide;
  };

  highed.hideAllTooltips = hide;
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A simple toggle button component
 *
 *  @example
 *  //Create a push button with the gear icon attached
 *  highed.PushButton(document.body, 'gear', false).on('Toggle', function (state) {
 *      alert('Push button is now ' + state);
 *  });
 *
 *  @constructor
 *
 *  @emits Toggle {boolean} - when the state changes
 *
 *  @param parent {domnode} (optional) - the parent to attach the button to
 *  @param icon {string} - the button icon
 *  @param state {boolean} - the initial state of the button
 */
highed.PushButton = function(parent, icon, state) {
  var button = highed.dom.cr('span', 'highed-pushbutton fa fa-' + icon),
    events = highed.events();

  function updateCSS() {
    if (state) {
      button.className += ' highed-pushbutton-active';
    } else {
      button.className = button.className.replace(
        ' highed-pushbutton-active',
        ''
      );
    }
  }

  /** Set the current state
    *  @memberof highed.PushButton
    *  @param flag {boolean} - the new state
    */
  function set(flag) {
    state = flag;
    updateCSS();
  }

  highed.dom.on(button, 'click', function() {
    state = !state;
    updateCSS();
    events.emit('Toggle', state);
  });

  if (!highed.isNull(parent) && parent !== false) {
    highed.dom.ap(parent, button);
  }

  updateCSS();

  return {
    set: set,
    /** The button
         * @memberof highed.PushButton
         * @type {domnode}
         */
    button: button,
    on: events.on
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Tree component
 *  For an example of formatting, build the editor with `gulp with-advanced`,
 *  and look in `src/meta/highed.options.advanced.js`.
 *
 *  @emits Select {object} - when a node is selected
 *
 *  @constructor
 *  @param parent {domnode} - the node to attach the tree to
 */
highed.Tree = function(parent) {
  var container = highed.dom.cr('div', 'highed-tree'),
    selectedNode = false,
    events = highed.events(),
    expands = {},
    expandState = {},
    selectedID = false,
    selectedPath = false,
    attachedData = {},
    filters = {
      //Filter the series properties based on the series.type property
      series: {
        controller: 'type',
        state: false
      }
    };

  ////////////////////////////////////////////////////////////////////////////

  function createNode(child, pnode, instancedData, productFilter, myIndex) {
    var node = highed.dom.cr(
        'div',
        'node',
        '',
        (child.meta.ns ? child.meta.ns : '') + child.meta.name
      ),
      title = highed.dom.cr(
        'div',
        'parent-title',
        highed.uncamelize(child.meta.title || child.meta.name)
      ),
      body = highed.dom.cr('div', 'parent-body'),
      icon = highed.dom.cr('div', 'exp-col-icon fa fa-folder-o'),
      rightIcons = highed.dom.cr('div', 'right-icons'),
      remIcon = highed.dom.cr('div', 'highed-icon fa fa-minus-square-o'),
      addIcon = highed.dom.cr('div', 'highed-icon fa fa-plus-square-o'),
      index =
        (child.meta.ns ? child.meta.ns + '.' : '') +
        (myIndex ? '[' + myIndex + '].' : '') +
        child.meta.name,
      expanded = true;

    child.meta.fullname = index;

    function pushExpandState() {
      if (
        (!child.meta.types.array &&
          typeof expandState[index] !== 'undefined') ||
        expanded
      ) {
        expandState[index] = expanded;
      }
    }

    function select() {
      if (selectedNode) {
        selectedNode.className = 'parent-title';
      }

      selectedNode = title;
      selectedPath = index;

      title.className = 'parent-title parent-title-selected';

      events.emit(
        'Select',
        child,
        title.innerHTML,
        child.data,
        productFilter,
        filters[index] ? child.data[filters[index].controller] : false
      );
    }

    function expand(noSelect, force) {
      if (
        (force || !expanded) &&
        child.children.length &&
        child.meta.hasSubTree
      ) {
        icon.className = 'exp-col-icon fa fa-folder-open-o';
        highed.dom.style(body, { display: 'block' });
        expanded = true;
        pushExpandState();
      }

      if (!noSelect) {
        select();
      }

      highed.emit(
        'UIAction',
        'AdvancedTreeNavigation',
        (child.meta.ns ? child.meta.ns + '.' : '') + child.meta.name
      );
    }

    function collapse(noSelect, noPush) {
      if (expanded && child.children.length && child.meta.hasSubTree) {
        icon.className = 'exp-col-icon fa fa-folder-o';
        highed.dom.style(body, { display: 'none' });
        expanded = false;
        if (!noPush) {
          pushExpandState();
        }
      }

      if (!noSelect) {
        select();
      }
    }

    function toggle(e) {
      if (expanded) {
        collapse();
      } else {
        expand();
      }

      if (e) {
        return highed.dom.nodefault(e);
      }
    }

    function buildSubtree(activeFilter) {
      body.innerHTML = '';

      // Skip this element if it's not part of the current product
      if (
        productFilter &&
        Object.keys(child.meta.products || {}).length > 0 &&
        !child.meta.products[productFilter]
      ) {
        //return false;
      }

      if (child.meta.isArrayElement) {
        highed.dom.ap(node, highed.dom.ap(rightIcons, remIcon));

        highed.dom.on(remIcon, 'click', function(e) {
          if (confirm('Really delete the element? This cannot be undone!')) {
            var delIndex = false;

            if (selectedNode === node) {
              selectedNode.className = 'parent-title';
              selectedNode = false;
              selectedPath = false;
              events.emit('ClearSelection');
            }

            body.parentNode.removeChild(body);
            node.parentNode.removeChild(node);

            // This is a bit convuluted, but we can't do a filter
            child.meta.arrayData.some(function(a, i) {
              if (a === child.data) {
                delIndex = i;
                return true;
              }
            });

            child.meta.arrayData.splice(delIndex, 1);

            events.emit('ForceSave', attachedData);

            highed.snackBar(
              'Removed element ' +
                delIndex +
                ' from ' +
                (child.meta.ns ? child.meta.ns + '.' : '') +
                child.meta.name
            );
          }

          return highed.dom.nodefault(e);
        });
      }

      // This node contains an array of stuff
      if (child.meta.types.array) {
        highed.dom.ap(node, highed.dom.ap(rightIcons, addIcon));

        icon.className = 'exp-col-icon fa fa-th-list';

        // We need to create one child per. existing entry
        child.data = instancedData[child.meta.name] =
          instancedData[child.meta.name] || [];

        // Force it to be an array
        if (!highed.isArr(child.data)) {
          child.data = instancedData[child.meta.name] = [
            instancedData[child.meta.name]
          ];
        }

        function addArrayElementToList(data, i) {
          var cat = {
              meta: {
                name: child.meta.name,
                title: child.meta.name + '[' + i + ']',
                hasSubTree: true,
                arrayData: instancedData[child.meta.name],
                isArrayElement: true,
                types: {
                  object: 1
                }
              },
              data: data,
              // We need to clone the children since the builders
              // add data attributes to them.
              // If we don't clone, all the sub-stuff will link to
              // the last child data accross all instances.
              children: highed.merge([], child.children)
            },
            node = createNode(cat, body, data, productFilter, i);

          if (node) {
            build(cat, node.body, data, productFilter);
          }
        }

        highed.dom.on(addIcon, 'click', function() {
          var newElement = {};

          highed.snackBar('Added new element to ' + child.meta.name);
          child.data.push(newElement);
          addArrayElementToList(newElement, child.data.length - 1);

          events.emit('ForceSave', attachedData);
        });

        child.data.forEach(addArrayElementToList);
      } else {
        // Only allow expanding on non-array parents
        highed.dom.on(node, 'click', function() {
          expand();
        });

        highed.dom.on(icon, 'click', toggle);

        if (!child.meta.hasSubTree) {
          icon.className = 'exp-col-icon fa fa-sliders';
        }

        // Add data instance
        if (!child.meta.isArrayElement) {
          child.data = instancedData[child.meta.name] =
            instancedData[child.meta.name] || {};
        }

        // Collapsed by default
        if (!expandState[index]) {
          collapse(true, true);
        } else {
          expand(true, true);
        }

        if (index === selectedPath) {
          select();
        }
      }
    }

    ////////////////////////////////////////////////////////////////////////

    highed.dom.ap(pnode, highed.dom.ap(node, icon, title), body);

    expands[index] = expand;

    buildSubtree();

    return {
      data: child.data,
      body: body,
      rebuild: buildSubtree
    };
  }

  /** Expand to show a given ID
   *  @memberof highed.Tree
   *  @param id {string} - the ID of the element to expand
   */
  function expandTo(id) {
    var prev = '';

    if (!id) return;

    id = id
      .replace(/\-\-/g, '.')
      .replace(/\-/g, '.')
      .split('.');

    id.forEach(function(seg) {
      seg = prev + seg;
      if (expands[seg]) expands[seg]();
      prev += seg + '.';
    });
  }

  /** Build the tree
   *
   *  This function takes in a transformed, compact, meta definitions
   *  for all entries in the API. The definitions are structured as an actual
   *  tree, where each node has an array of children, and a meta object with
   *  meta information such as data type, default, and GH links.
   *
   *  @memberof highed.Tree
   *  @param tree {object} - the tree to display
   *    > children {object} - the children of the node
   *    > entries {array} - array of orphan children
   *  @param pnode {domnode} - the parent node
   *  @param instancedData {object} - the actual tree data
   *  @param dataIndex {number} - the path to data in arrays
   */
  function build(tree, pnode, instancedData, productFilter) {
    if (!tree) {
      return;
    }

    // Handled in createNode, just skip.
    if (tree.meta.types['array']) {
      return;
    }

    if (
      productFilter &&
      Object.keys(tree.meta.products || {}).length > 0 &&
      !tree.meta.products[productFilter]
    ) {
      return;
    }

    if (highed.isArr(tree.children)) {
      tree.children.forEach(function(child) {
        var node, fstate;

        if (tree.meta.fullname && filters[tree.meta.fullname]) {
          if (child.meta && child.meta.validFor) {
            fstate = tree.data[filters[tree.meta.fullname].controller];
            if (fstate && fstate.length > 0 && !child.meta.validFor[fstate]) {
              return;
            }
          }
        }

        if (!child.meta.leafNode) {
          node = createNode(child, pnode, instancedData, productFilter);
          if (node) {
            build(child, node.body, node.data, productFilter);
          }
        }
      });
    }
  }

  function getMasterData() {
    return attachedData;
  }

  function isFilterController(ns, name) {
    if (typeof filters[ns] !== 'undefined') {
      return filters[ns].controller === name;
    }
    return false;
  }

  ////////////////////////////////////////////////////////////////////////////

  highed.dom.ap(parent, container);

  ////////////////////////////////////////////////////////////////////////////

  return {
    on: events.on,
    expandTo: expandTo,
    getMasterData: getMasterData,
    isFilterController: isFilterController,
    build: function(tree, data) {
      attachedData = data;
      container.innerHTML = '';
      build(tree, container, data, false);
    }
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var container = highed.dom.cr('div', 'highed-snackbar no-print'),
    title = highed.dom.cr('span', 'snackbar-title', ''),
    action = highed.dom.cr('span', 'snackbar-action', ''),
    closeNode = highed.dom.cr(
      'span',
      'highed-snackbar-close fa fa-times-circle',
      ''
    ),
    timeout = false,
    callback = false;

  highed.ready(function() {
    highed.dom.style(container, {
      display: "none"
    });
    highed.dom.ap(
      document.body,
      highed.dom.ap(container, title, action, closeNode)
    );
  });

  highed.dom.on(container, 'mouseover', function() {
    window.clearTimeout(timeout);
  });

  highed.dom.on(container, 'mouseout', function() {
    hide();
  });

  highed.dom.on(closeNode, 'click', function() {
    highed.dom.style(container, {
      bottom: '-68px'
    });
  });

  ///////////////////////////////////////////////////////////////////////////

  function hide() {
    timeout = window.setTimeout(function() {
      highed.dom.style(container, {
        bottom: '-68px'
      });
    }, 5000);
  }

  ///////////////////////////////////////////////////////////////////////////

  /**  Show a snackbar
     *   A snack bar is those info rectangles showing up on the bottom left.
     *
     *   @example
     *   highed.snackBar('Hello world!');
     *
     *   @param stitle {string} (optional) - the snackbar title
     *   @param saction {string} (optional) - the snackbar action text
     *   @param fn {function} (optional) - the function to call when clicking the action
     */
  highed.snackBar = function(stitle, saction, fn) {
    title.innerHTML = stitle; // .toUpperCase();

    window.clearTimeout(timeout);

    if (saction) {
      action.innerHTML = saction.toUpperCase();
    }

    if (callback) {
      callback();
    }

    highed.dom.style(container, {
      bottom: '10px'
    });

    highed.dom.style(action, {
      display: saction ? '' : 'none'
    });

    callback = highed.dom.on(action, 'click', fn);

    hide();
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A context menu component
 *  Does a typicall right-click menu.
 *  Note that each instance get their own DOM node in the document body.
 *
 *  @example
 *  var ctx = highed.ContextMenu([
 *     {
 *         title: "Hello World",
 *         click: function (e) {
 *             alert('hello world!');
 *         }
 *     }
 *  ]);
 *
 *  @constructor
 *  @param stuff {object} - things to add (optional)
 *      > title {string} - the title of the entry
 *      > click {function} - function to call when selecting the item
 */
highed.ContextMenu = function(stuff) {
  var container = highed.dom.cr(
      'div',
      'highed-ctx-container-common highed-ctx-container'
    ),
    closeBtn = highed.dom.cr('div', 'highed-ctx-close-button', 'Close'),
    visible = false,
    dimHide = false;

  ///////////////////////////////////////////////////////////////////////////

  /** Add an entry to the menu
     *  @memberof highed.ContextMenu
     *  @param entry {object} - the definition of the entry to add
     *    > title {string} - the title of the entry
     *    > click {function} - the function to call when clicking the item
     */
  function addEntry(entry) {
    var item = highed.dom.cr(
        'div',
        'highed-ctx-item highed-ctx-item-responsive',
        entry.title
      ),
      right = highed.dom.cr('div', 'highed-ctx-child-icon fa fa-angle-right'),
      childCtx;

    if (entry === '-') {
      return highed.dom.ap(container, highed.dom.cr('div', 'highed-ctx-sep'));
    }

    highed.dom.on(item, 'click', function() {
      if (highed.isFn(entry.click)) {
        entry.click();
      }

      hide();
    });

    if (entry.selected) {
      item.className += ' highed-ctx-item-selected';
    }

    if (!highed.isNull(entry.children)) {
      childCtx = highed.ContextMenu(entry.children);

      highed.dom.on(item, 'mouseenter', function(e) {
        childCtx.show(e.clientX, e.clientY);
      });
    }

    highed.dom.ap(
      container,
      highed.dom.ap(
        item,
        entry.icon
          ? highed.dom.cr(
              'div',
              'ctx-child-licon highed-ctx-child-licon-responsive fa fa-' +
                entry.icon
            )
          : false,
        entry.children ? right : false
      )
    );
  }

  /** Show the menu
     *  @memberof highed.ContextMenu
     *  @param x {number} - the x position
     *  @param y {number} - the y position
     */
  function show(x, y) {
    var psize = highed.dom.size(document.body),
      size = highed.dom.size(container);

    if (visible) return;

    if (x > psize.w - size.w - 20) {
      x = psize.w - size.w - 20;
    }

    if (y > psize.h - size.h - 20) {
      y = psize.h - size.h - 20;
    }

    highed.dom.style(container, {
      'pointer-events': 'auto',
      opacity: 1,
      left: x + 'px',
      top: y + 'px'
    });

    visible = true;
    dimHide = highed.showDimmer(hide, true, true, 10);
  }

  /** Hide the menu
     *  @memberof highed.ContextMenu
     */
  function hide() {
    if (!visible) return;

    highed.dom.style(container, {
      left: '-2000px',
      'pointer-events': 'none',
      opacity: 0
    });

    if (highed.isFn(dimHide)) {
      dimHide();
    }

    visible = false;
  }

  /** Build a menu
     *  @memberof highed.ContextMenu
     *  @param def {array<object>} - an array of entries
     */
  function build(def) {
    container.innerHTML = '';
    highed.dom.ap(container, closeBtn);

    if (highed.isArr(def)) {
      return def.forEach(addEntry);
    }

    Object.keys(def).forEach(function(key) {
      var entry = def[key];
      addEntry(highed.merge({ title: key }, entry));
    });
  }

  ///////////////////////////////////////////////////////////////////////////

  if (stuff) {
    build(stuff);
  }

  highed.dom.on(closeBtn, 'click', hide);

  highed.ready(function() {
    highed.dom.ap(document.body, container);
  });

  ///////////////////////////////////////////////////////////////////////////

  return {
    addEntry: addEntry,
    show: show,
    hide: hide,
    build: build
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var dropdownItems = highed.dom.cr(
    'div',
    'highed-dropdown-items highed-dropdown-items-responsive'
  );

  highed.ready(function() {
    highed.dom.ap(document.body, dropdownItems);
  });

  /** A stylable dropdown
     *  @constructor
     *
     *  @emits Change - when the selection changes
     *  @emits Open - when the dropdown is opened
     *  @emits Close - when the dropdown is closed
     *
     *  @param parent {domnode} - the node to attach the dropdown to
     */
  highed.DropDown = function(parent) {
    var events = highed.events(),
      container = highed.dom.cr('div', 'highed-dropdown'),
      body = highed.dom.cr('div', 'highed-dropdown-body'),
      arrow = highed.dom.cr('div', 'highed-dropdown-arrow fa fa-arrow-down'),
      items = [],
      selectedItem = false,
      expanded = false,
      catcher = false;

    ////////////////////////////////////////////////////////////////////////

    //Build the DOM
    function buildDOM() {
      dropdownItems.innerHTML = '';

      items.forEach(function(item) {
        highed.dom.ap(dropdownItems, item.node);
        //IE fix
        item.node.innerHTML = item.title();
      });
    }

    //Collapse the dropdown
    function collapse() {
      if (highed.isFn(catcher)) {
        catcher();
        catcher = false;
      }

      //Should update the container
      if (selectedItem) {
        body.innerHTML = selectedItem.title();
      }

      highed.dom.style(dropdownItems, {
        opacity: 0,
        left: '-20000px',
        'pointer-events': 'none'
      });

      expanded = false;
    }

    //Expand the dropdown
    function expand(e) {
      buildDOM();

      var pos = highed.dom.pos(container, true),
        s = highed.dom.size(container);

      //Quick hack for IE...
      if (!pos || !pos.x) {
        pos = {
          x: 10,
          y: 10
        };
      }

      if (!s || !s.w) {
        s = {
          w: 200,
          h: 200
        };
      }

      //Need to check the height + y to see if we need to move it

      highed.dom.style(dropdownItems, {
        opacity: 1,
        'pointer-events': 'auto',
        left: pos.x + 'px',
        top: pos.y + s.h + 'px',
        width: s.w - 1 + 'px',
        'min-height': s.h + 'px'
      });

      catcher = highed.showDimmer(collapse, true, true, 500);

      expanded = true;
    }

    //Toggle expansion
    function toggle(e) {
      expanded = !expanded;
      if (expanded) {
        return expand(e);
      }
      collapse();

      return expanded;
    }

    /** Add an item to the dropdown
         *  @memberof highed.DropDown
         *  @param item {object} - the item to add
         *    > title {string} - the title of the item
         *    > id {anyting} - the id of the item
         *    > select {function} - function to call when the item is selected
         */
    function addItem(item) {
      if (item && item.id) {
        if (!highed.isBasic(item.id)) {
          item.id = '1234';
        }
      }

      if (highed.isBasic(item)) {
        item = {
          id: item,
          title: item
        };
      }

      if (
        items.filter(function(b) {
          return b.id() === item.id;
        }).length > 0
      ) {
        return false;
      }

      var node = highed.dom.cr('div', 'highed-dropdown-item'),
        id = highed.uuid(),
        index = items.length,
        itemInstance = {
          //The node
          node: node,

          //Get the index
          index: function() {
            return index;
          },

          //Get the ID
          id: function() {
            return id;
          },

          //Get the title
          title: function() {
            return highed.isStr(item) ? item : item.title || '';
          },

          //Unselect the item
          unselect: function() {
            node.className = 'highed-dropdown-item';
          },

          //Select the item
          select: function() {
            if (selectedItem) {
              selectedItem.unselect();
            }

            node.className =
              'highed-dropdown-item highed-dropdown-item-selected';
            selectedItem = itemInstance;

            body.innerHTML = selectedItem.title();

            events.emit('Change', itemInstance);

            if (item && highed.isFn(item.select)) {
              item.select(itemInstance);
            }

            collapse();
          }
        };

      if (!item) {
        return false;
      }

      if (highed.isStr(item) || highed.isNum(item)) {
        node.innerHTML = item;
        id = item;
      } else {
        node.innerHTML = item.title || '';
        id = item.id; // || id;

        if (item.selected) {
          itemInstance.select();
        }
      }

      highed.dom.on(node, 'click', function(e) {
        itemInstance.select();
        e.cancelBubble = true;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      });

      items.push(itemInstance);

      return itemInstance;
    }

    /** Clear the dropdown
         *  @memberof highed.DropDown
         */
    function clear() {
      items = [];
    }

    /** Add several items to the dropdown
         *  @memberof highed.DropDown
         *  @param itemsToAdd {array} - array of items to add
         */
    function addItems(itemsToAdd) {
      if (highed.isArr(itemsToAdd)) {
        itemsToAdd.forEach(addItem);
      }
    }

    /** Set the current selection by id
         *  @memberof highed.DropDown
         *  @param id {anything} - the id to select
         */
    function selectById(id) {
      items.some(function(item) {
        //This is not a typo..
        if (item.id() == id) {
          item.select();
          return true;
        }
      });
    }

    /** Set the current selection by index
         *  @memberof highed.DropDown
         *  @param index {number} - the index to select in range [0..item.length]
         */
    function selectByIndex(index) {
      if (index >= 0 && index < items.length) {
        items[index].select();
      }
    }

    ///////////////////////////////////////////////////////////////////////////

    if (parent) {
      parent = highed.dom.get(parent);
      highed.dom.ap(parent, container);
    }

    highed.dom.ap(container, body, arrow);

    highed.dom.on(container, 'click', toggle);

    return {
      container: container,
      selectById: selectById,
      selectByIndex: selectByIndex,
      addItems: addItems,
      addItem: addItem,
      clear: clear,
      on: events.on
    };
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Make a node movable
 *  @constructor
 *
 *  @emits StartMove - when starting to move
 *  @emits Moving - when moving
 *  @emits EndMove - when stopping to move
 *
 *  @param target {domnode} - the node to make movable
 *  @param constrain {string} - constrain moving: `XY`, `Y`, or `X`
 */
highed.Movable = function(
  target,
  constrain,
  constrainParent,
  parentNode,
  min,
  doOffset
) {
  var events = highed.events(),
    moving = false;

  constrain = (constrain || 'XY').toUpperCase();
  target = highed.dom.get(target);

  if (target) {
    highed.dom.on(target, ['mousedown', 'touchstart'], function(e) {
      //   if (moving) return;
      moving = true;
      var cp = highed.dom.pos(target),
        ps = highed.dom.size(parentNode || target.parentNode),
        ns = highed.dom.size(target),
        x = cp.x,
        y = cp.y,
        offsetX = 0,
        offsetY = 0,
        mover = highed.dom.on(
          document.body,
          ['mousemove', 'touchmove'],
          function(moveE) {
            if (constrain === 'X' || constrain === 'XY') {
              x =
                cp.x + ((moveE.clientX || moveE.touches[0].clientX) - offsetX);

              if (constrainParent) {
                if (x < 0) x = 0;
                if (x > ps.w - ns.w) x = ps.w - ns.w;
              }
            }
            if (constrain === 'Y' || constrain === 'XY') {
              y =
                cp.y + ((moveE.clientY || moveE.touches[0].clientY) - offsetY);

              if (constrainParent) {
                if (y < 0) y = 0;
                if (y > ps.h - ns.h) y = ps.h - ns.h;
              }
            }

            if (min && x < min.x) {
              x = min.x;
            }
            if (min && y < min.y) {
              y = min.y;
            }

            highed.dom.style(target, {
              left: x - (doOffset ? ns.w : 0) + 'px',
              top: y + 'px'
            });

            events.emit('Moving', x, y);

            moveE.cancelBubble = true;
            moveE.preventDefault();
            moveE.stopPropagation();
            moveE.stopImmediatePropagation();
            return false;
          }
        ),
        upper = highed.dom.on(document.body, ['mouseup', 'touchend'], function(
          upE
        ) {
          //Detach the document listeners
          upper();
          mover();
          moving = false;
          document.body.className = document.body.className.replace(
            ' highed-nosel',
            ''
          );
          events.emit('EndMove', x, y);

          upE.cancelBubble = true;
          upE.preventDefault();
          upE.stopPropagation();
          upE.stopImmediatePropagation();
          return false;
        });

      document.body.className += ' highed-nosel';
      offsetX = e.clientX || e.touches[0].clientX;
      offsetY = e.clientY || e.touches[0].clientY;
      events.emit('StartMove', cp.x, cp.y);

      e.cancelBubble = true;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    });
  }

  ////////////////////////////////////////////////////////////////////////////

  return {
    on: events.on
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Slider widget
 *  @constructor
 *
 *  @emits Change - when the value changes
 *
 *  @param parent {domnode} - the parent of the slider
 *  @param attributes {object} - the slider properties
 *    > max {number} - the max value
 *    > min {number} - the min value
 *    > step {number} - the step size
 *    > resetTo {anything} - value to reset to
 */
highed.Slider = function(parent, attributes) {
  var properties = highed.merge(
      {
        max: 100,
        min: 1,
        step: 1,
        resetTo: 0,
        value: 0
      },
      attributes
    ),
    events = highed.events(),
    value = properties.value || properties.resetTo,
    container = highed.dom.cr('div', 'highed-slider'),
    indicator = highed.dom.cr('div', 'highed-slider-indicator'),
    textIndicator = highed.dom.cr('div', 'highed-slider-text-indicator'),
    sliderBackground = highed.dom.cr('div', 'highed-slider-background'),
    resetIcon = highed.dom.cr('div', 'highed-slider-reset fa fa-undo'),
    mover = highed.Movable(indicator, 'x', true, sliderBackground);

  ////////////////////////////////////////////////////////////////////////////

  function updateText() {
    textIndicator.innerHTML = value;

    if (value === 'null' || value === null) {
      textIndicator.innerHTML = 'auto';
    }
    if (value === 'undefined' || typeof value === 'undefined') {
      textIndicator.innerHTML = 'auto';
    }
  }

  // Calculate the indicator X
  function calcIndicator() {
    var x = 0,
      s = highed.dom.size(sliderBackground),
      ms = highed.dom.size(indicator);

    if (!highed.isNum(value) || !value) {
      x = 0;
    } else {
      x =
        (value - properties.min) /
        (properties.max - properties.min) *
        (s.w - ms.w);
    }

    highed.dom.style(indicator, {
      left: x + 'px'
    });
  }

  //Waits until the slider is in the dom
  function tryUpdateIndicators() {
    updateText();
    if (container.parentNode) {
      calcIndicator();
    } else {
      window.setTimeout(tryUpdateIndicators, 10);
    }
  }

  /** Set the value
     *  @memberof highed.Slider
     *  @param newValue {number} - the new value
     */
  function set(newValue) {
    value = highed.clamp(properties.min, properties.max, newValue);
    textIndicator.innerHTML = value;
    calcIndicator();
  }

  mover.on('Moving', function(x) {
    var s = highed.dom.size(sliderBackground),
      ms = highed.dom.size(indicator);

    //Set the value based on the new X
    value =
      properties.min +
      Math.round(x / (s.w - ms.w) * (properties.max - properties.min));

    textIndicator.innerHTML = value;
    if (!highed.onPhone()) {
      events.emit('Change', value);
    }
  });

  mover.on('StartMove', function() {
    if (highed.onPhone()) {
      textIndicator.className =
        'highed-slider-text-indicator highed-slider-text-indicator-popup';
    }
  });

  mover.on('EndMove', function() {
    if (highed.onPhone()) {
      textIndicator.className = 'highed-slider-text-indicator';
      //We're not emitting changes until done on mobile
      events.emit('Change', value);
    }
  });

  ////////////////////////////////////////////////////////////////////////////

  highed.dom.on(resetIcon, 'mouseover', function(e) {
    //  highed.Tooltip(e.clientX, e.clientY, 'Reset to initial value');
  });

  highed.dom.on(resetIcon, 'click', function() {
    value = properties.resetTo;
    calcIndicator();

    if (value === 'null') {
      value = null;
    }
    if (value === 'undefined') {
      value = undefined;
    }

    updateText();
    events.emit('Change', value);
  });

  if (parent) {
    parent = highed.dom.get(parent);
    highed.dom.ap(parent, container);
  }

  highed.dom.ap(
    container,
    sliderBackground,
    resetIcon,
    highed.dom.ap(indicator, textIndicator)
  );

  tryUpdateIndicators();

  // Public interface
  return {
    on: events.on,
    set: set,
    container: container
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/** Data table
 *  @constructor
 *  @param {domnode} parent - the node to attach to
 *  @param {object} attributes - the properties
 */
highed.DataTable = function(parent, attributes) {
  var properties = highed.merge(
      {
        checkable: true,
        importer: {}
      },
      attributes
    ),
    events = highed.events(),
    container = highed.dom.cr('div', 'highed-dtable-container'),
    frame = highed.dom.cr('div', 'highed-dtable-table-frame highed-scrollbar'),
    table = highed.dom.cr('table', 'highed-dtable-table'),
    thead = highed.dom.cr('thead', 'highed-dtable-head'),
    tbody = highed.dom.cr('tbody', 'highed-dtable-body'),
    tableTail = highed.dom.cr(
      'div',
      'highed-dtable-table-tail',
      'Only the first 500 rows are shown.'
    ),
    colgroup = highed.dom.cr('colgroup'),
    leftBar = highed.dom.cr('div', 'highed-dtable-left-bar'),
    topBar = highed.dom.cr('div', 'highed-dtable-top-bar'),
    topLeftPanel = highed.dom.cr('div', 'highed-dtable-top-left-panel'),
    checkAll = highed.dom.cr('input'),
    mainInput = highed.dom.cr('textarea', 'highed-dtable-input'),
    weirdDataModal = highed.OverlayModal(false, {
      // zIndex: 20000,
      showOnInit: false,
      width: 300,
      height: 350
    }),
    weirdDataContainer = highed.dom.cr(
      'div',
      'highed-dtable-weird-data highed-box-size highed-errobar-body'
    ),
    weirdDataIgnore = highed.dom.cr(
      'button',
      'highed-ok-button',
      'No, this looks right'
    ),
    weirdDataFix = highed.dom.cr(
      'button',
      'highed-ok-button',
      'Yeah, this looks wrong'
    ),
    loadIndicator = highed.dom.cr(
      'div',
      'highed-dtable-load-indicator',
      'Loading Data...'
    ),
    dropZone = highed.dom.cr(
      'div',
      'highed-dtable-drop-zone highed-transition'
    ),
    liveDataFrame = highed.dom.cr(
      'div',
      'highed-box-size highed-dtable-gsheet-frame'
    ),
    gsheetFrame = highed.dom.cr(
      'div',
      'highed-box-size highed-dtable-gsheet-frame'
    ),
    gsheetContainer = highed.dom.cr(
      'div',
      'highed-box-size highed-prettyscroll highed-dtable-gsheet'
    ),
    liveDataContainer = highed.dom.cr(
      'div',
      'highed-box-size highed-prettyscroll highed-dtable-gsheet'
    ),
    liveDataInput = highed.dom.cr('input', 'highed-imp-input-stretch'),
    liveDataIntervalInput = highed.dom.cr('input', 'highed-imp-input-stretch'),
    liveDataTypeSelect = highed.DropDown(),

    liveDataTypeContainer = highed.dom.cr('div', 'highed-customize-group'),
    liveDataTypeMasterNode = highed.dom.cr('div', 'highed-customize-master-dropdown'),

    gsheetID = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetWorksheetID = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetRefreshTime = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetStartRow = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetEndRow = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetStartCol = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetEndCol = highed.dom.cr(
      'input',
      'highed-box-size highed-dtable-gsheet-id'
    ),
    gsheetCancelButton = highed.dom.cr(
      'button',
      'highed-ok-button highed-dtable-gsheet-button',
      'Detach Sheet From Chart'
    ),
    gsheetLoadButton = highed.dom.cr(
      'button',
      'highed-ok-button highed-dtable-gsheet-button',
      'Load Spreadsheet'
    ),
    liveDataLoadButton = highed.dom.cr(
      'button',
      'highed-ok-button highed-dtable-gsheet-button',
      'Load Live Data'
    ),
    liveDataCancelButton = highed.dom.cr(
      'button',
      'highed-ok-button highed-dtable-gsheet-button',
      'Cancel'
    ),
    detailValue = 0,
    isInGSheetMode = false,
    isInLiveDataMode = false,
    mainInputCb = [],
    rawCSV = false,
    mainInputCloseCb = false,
    toolbar,
    importModal = highed.OverlayModal(false, {
      minWidth: 600,
      minHeight: 600
    }),
    importer = highed.DataImporter(importModal.body, properties.importer),
    rows = [],
    gcolumns = [],
    changeTimeout = false,
    surpressChangeEvents = false,
    monthNumbers = {
      JAN: 1,
      FEB: 2,
      MAR: 3,
      APR: 4,
      MAY: 5,
      JUN: 6,
      JUL: 7,
      AUG: 8,
      SEP: 9,
      OCT: 10,
      NOV: 11,
      DEC: 12
    },
    saveCtx = highed.ContextMenu([
      {
        title: 'Use <code>,</code> as delimiter',
        click: function() {
          highed.download('data.csv', toCSV(','), 'application/csv');
        }
      },
      {
        title: 'Use <code>;</code> as delimiter',
        click: function() {
          highed.download('data.csv', toCSV(';'), 'application/csv');
        }
      }
    ]),
    selectedRowIndex = 0,
    addRowCtx = highed.ContextMenu([
      {
        title: 'At the end',
        icon: '',
        click: function() {
          addRow();
          highed.emit('UIAction', 'AddRowAtEnd');
        }
      },
      {
        title: 'After highlighted',
        click: function() {
          addRowAfter(selectedRowIndex);
          highed.emit('UIAction', 'AddRowAfterHighlight');
        }
      },
      {
        title: 'Before highlighted',
        click: function() {
          addRowBefore(selectedRowIndex);
          highed.emit('UIAction', 'AddRowBeforeHighlight');
        }
      }
    ]);
  checkAll.type = 'checkbox';

  highed.dom.on(mainInput, 'click', function(e) {
    return highed.dom.nodefault(e);
  });

  highed.dom.style(liveDataIntervalInput, {
    padding: '8px'
  });
  ////////////////////////////////////////////////////////////////////////////

  // Handle drag 'n drop of files

  function handleFileUpload(f) {
    if (f.type !== 'text/csv') {
      return highed.snackBar('The file is not a valid CSV file');
    }

    var reader = new FileReader();

    reader.onload = function(e) {
      loadCSV({ csv: e.target.result });
    };

    reader.readAsText(f);
  }

  frame.ondrop = function(e) {
    e.preventDefault();

    var d = e.dataTransfer;
    var f;
    var i;

    if (d.items) {
      for (i = 0; i < d.items.length; i++) {
        f = d.items[i];
        if (f.kind === 'file') {
          handleFileUpload(f.getAsFile());
        }
      }
    } else {
      for (i = 0; i < d.files.length; i++) {
        f = d.files[i];
        handleFileUpload(f);
      }
    }
  };

  frame.ondragover = function(e) {
    e.preventDefault();
  };

  ////////////////////////////////////////////////////////////////////////////

  function showDataImportError() {
    highed.dom.style(weirdDataContainer, {
      display: 'block'
    });
  }

  function hideDataImportError() {
    highed.dom.style(weirdDataContainer, {
      display: 'none'
    });
  }

  function emitChanged(noDelay) {
    window.clearTimeout(changeTimeout);

    if (isInGSheetMode) {
      return;
    }
    if (isInLiveDataMode) {
      return;
    }

    if (surpressChangeEvents) {
      return;
    }

    if (noDelay) {
      return events.emit('Change', getHeaderTextArr(), toData());
    }

    //We use an interval to stop a crazy amount of changes to be
    //emitted in succession when e.g. loading sets.
    changeTimeout = window.setTimeout(function() {
      if (!isInGSheetMode && !isInLiveDataMode) {
        events.emit('Change', getHeaderTextArr(), toData());
      }
    }, 1000);
  }

  function makeEditable(target, value, fn, keyup, close) {
    if (mainInputCb.length) {
      mainInputCb = mainInputCb.filter(function(fn) {
        fn();
        return false;
      });
    }

    if (mainInputCloseCb) {
      mainInputCloseCb();
    }

    mainInputCloseCb = close;

    mainInput.value = value;
    mainInput.setSelectionRange(0, mainInput.value.length);

    mainInputCb.push(
      highed.dom.on(mainInput, 'keydown', function(e) {
        //(highed.isFn(fn) && fn(mainInput.value));
        if (highed.isFn(keyup)) {
          return keyup(e);
        }
      })
    );

    mainInputCb.push(
      highed.dom.on(mainInput, 'keyup', function(e) {
        // Super hack to allow pasting CSV into cells
        var ps = highed.parseCSV(mainInput.value);
        if (ps.length > 1) {
          if (
            confirm(
              'You are about to load CSV data. This will overwrite your current data. Continue?'
            )
          ) {
            rawCSV = mainInput.value;
            highed.emit('UIAction', 'PasteCSVAttempt');
            return loadRows(ps);
          }
          return;
        }

        return highed.isFn(fn) && fn(mainInput.value);
      })
    );

    highed.dom.ap(target, mainInput);
    mainInput.focus();
  }

  ////////////////////////////////////////////////////////////////////////////

  function Column(row, colNumber, val) {
    var value = typeof val === 'undefined' ? null : val,
      col = highed.dom.cr('td'),
      colVal = highed.dom.cr('div', 'highed-dtable-col-val', value),
      input = highed.dom.cr('input'),
      exports = {};

    function goLeft() {
      if (colNumber >= 1) {
        row.columns[colNumber - 1].focus();
      } else {
        //Go up to the last column
        if (row.number - 1 >= 0) {
          rows[row.number - 1].columns[
            rows[row.number - 1].columns.length - 1
          ].focus();
        }
      }
    }

    function goRight() {
      if (colNumber < row.columns.length - 1) {
        row.columns[colNumber + 1].focus();
      } else {
        //Go down on the first column
        if (row.number < rows.length - 1) {
          rows[row.number + 1].columns[0].focus();
        }
      }
    }

    function goUp() {
      if (row.number > 0 && rows[row.number - 1].columns.length > colNumber) {
        rows[row.number - 1].columns[colNumber].focus();
      }
    }

    function goBelow() {
      if (
        row.number < rows.length - 1 &&
        rows[row.number + 1].columns.length > colNumber
      ) {
        rows[row.number + 1].columns[colNumber].focus();
      }
    }

    function handleKeyup(e) {
      //Go the the column to the left
      if (e.keyCode === 37) {
        goLeft();
        return highed.dom.nodefault(e);

        //Go to the column above
      } else if (e.keyCode === 38) {
        goUp();
        return highed.dom.nodefault(e);

        //Go to the column to the right
      } else if (e.keyCode === 39 || e.keyCode === 9) {
        goRight();
        return highed.dom.nodefault(e);

        //Go to the column below
      } else if (e.keyCode === 40) {
        goBelow();
        return highed.dom.nodefault(e);

        //Go to next row
      } else if (e.keyCode === 13) {
        //If we're standing in the last column of the last row,
        //insert a new row.
        if (row.number === rows.length - 1) {
          // && colNumber === rows.columns.length - 1) {
          addRow();
          rows[row.number + 1].columns[0].focus();
        } else {
          goBelow();
        }
        return highed.dom.nodefault(e);
      }
    }

    function selContents() {
      input.setSelectionRange(0, input.value.length);
    }

    function focus() {
      function checkNull(value) {
        return value === null || value === '';
      }
      mainInput.className = 'highed-dtable-input';
      makeEditable(
        col,
        value,
        function(val) {
          var changed = value !== val;
          value = checkNull(val) ? null : val;
          colVal.innerHTML = value;
          if (changed) {
            emitChanged();
          }
        },
        handleKeyup
      );

      row.select();
    }

    function destroy() {
      row.node.removeChild(col);
      col.innerHTML = '';
      colVal.innerHTML = '';
    }

    function getVal() {
      return value;
    }

    function addToDOM(me) {
      colNumber = me || colNumber;
      highed.dom.ap(row.node, highed.dom.ap(col, colVal));
    }

    highed.dom.on(col, 'click', focus);

    if (rows.length <= 500) {
      addToDOM();
    }

    exports = {
      focus: focus,
      value: getVal,
      destroy: destroy,
      addToDOM: addToDOM
    };

    return exports;
  }

  ////////////////////////////////////////////////////////////////////////////

  function Row(skipAdd) {
    var columns = [],
      row = highed.dom.cr('tr'),
      leftItem = highed.dom.cr('div', 'highed-dtable-left-bar-row', ''),
      checker = highed.dom.cr('input', 'highed-dtable-row-select-box'),
      checked = false,
      didAddHTML = false,
      exports = {};

    checker.type = 'checkbox';

    function addCol(val) {
      columns.push(Column(exports, columns.length, val));
    }

    function insertCol(where) {
      var col = Column(exports, columns.length);
      columns.splice(where, 0, col);
    }

    function select() {
      var o = tbody.querySelector('.highed-dtable-body-selected-row');
      if (o) {
        o.className = '';
      }
      row.className = 'highed-dtable-body-selected-row';
      selectedRowIndex = exports.rowIndex;
    }

    function isChecked() {
      return checked;
    }

    function check(state) {
      checker.checked = checked = state;
    }

    function destroy() {
      if (didAddHTML) {
        leftBar.removeChild(leftItem);
        tbody.removeChild(row);
        row.innerHTML = '';
      }

      rows = rows.filter(function(b) {
        return b !== exports;
      });

      if (rows.length < 2) {
        showDropzone();
      }
    }

    function addToDOM(number) {
      didAddHTML = true;
      exports.number = number;

      highed.dom.ap(tbody, row);

      highed.dom.ap(leftBar, highed.dom.ap(leftItem, checker));
    }

    function rebuildColumns() {
      row.innerHTML = '';
      columns.forEach(function(col, i) {
        col.addToDOM(i);
      });
    }

    function delCol(which) {
      if (which >= 0 && which < columns.length) {
        columns[which].destroy();
        columns.splice(which, 1);
      }
    }

    highed.dom.on(checker, 'change', function() {
      checked = checker.checked;
    });

    if (rows.length < 500) {
      addToDOM(rows.length);
    } else if (rows.length === 500) {
      highed.dom.style(tableTail, {
        display: 'block'
      });
    }

    exports = {
      destroy: destroy,
      select: select,
      columns: columns,
      number: rows.length,
      addCol: addCol,
      isChecked: isChecked,
      check: check,
      node: row,
      addToDOM: addToDOM,
      insertCol: insertCol,
      rebuildColumns: rebuildColumns,
      delCol: delCol,
      rowIndex: rows.length
    };

    if (!skipAdd) {
      rows.push(exports);
    }

    resize();

    return exports;
  }

  ////////////////////////////////////////////////////////////////////////////

  function rebuildRows() {
    rows.forEach(function(row, i) {
      if (rows.length < 500) {
        row.addToDOM(i);
      }
      row.rowIndex = i;
    });

    emitChanged();
  }

  function rebuildColumns() {
    rows.forEach(function(row) {
      row.rebuildColumns();
    });
  }

  function addRowBefore(index) {
    if (index > 0 && index < rows.length) {
      rows.splice(index - 0, 0, addRow(true, true));
      rebuildRows();
    }
  }

  function addRowAfter(index) {
    if (index >= 0 && index < rows.length) {
      rows.splice(index + 1, 0, addRow(true, true));
      rebuildRows();
    }
  }

  function init() {
    clear();

    surpressChangeEvents = true;

    for (var i = 0; i < 1; i++) {
      var r = Row();
    }

    for (var j = 0; j < 2; j++) {
      addCol('Column ' + (j + 1));
    }

    highed.dom.ap(colgroup, highed.dom.cr('col'));
    resize();

    surpressChangeEvents = false;
  }

  function updateColumns() {
    colgroup.innerHTML = '';
    topBar.innerHTML = '';

    gcolumns.forEach(function(col, i) {
      col.colNumber = i;
      col.addToDOM();
    });

    rebuildColumns();

    highed.dom.ap(colgroup, highed.dom.cr('col'));
    resize();
  }

  function addCol(value, where) {
    //The header columns control the colgroup
    var col = highed.dom.cr('col'),
      colNumber = gcolumns.length,
      header = highed.dom.cr('span', 'highed-dtable-top-bar-col'),
      headerTitle = highed.dom.cr('div', '', value),
      moveHandle = highed.dom.cr('div', 'highed-dtable-resize-handle'),
      options = highed.dom.cr(
        'div',
        'highed-dtable-top-bar-col-options fa fa-chevron-down'
      ),
      exports = {
        col: col,
        header: header,
        headerTitle: headerTitle,
        colNumber: gcolumns.length
      },
      mover = highed.Movable(
        moveHandle,
        'X',
        false,
        false,
        {
          x: 20,
          y: 0
        },
        true
      ),
      ctx = highed.ContextMenu([
        {
          title: highed.L('dgSortAsc'),
          icon: 'sort-amount-asc',
          click: function() {
            sortRows(exports.colNumber, 'asc');
          }
        },
        {
          title: highed.L('dgSortDec'),
          icon: 'sort-amount-desc',
          click: function() {
            sortRows(exports.colNumber, 'desc');
          }
        },
        '-',
        {
          title: highed.L('dgSortAscMonth'),
          icon: 'sort-amount-asc',
          click: function() {
            sortRows(exports.colNumber, 'asc', true);
          }
        },
        {
          title: highed.L('dgSortDecMonth'),
          icon: 'sort-amount-desc',
          click: function() {
            sortRows(exports.colNumber, 'desc', true);
          }
        },
        '-',
        {
          title: highed.L('dgDelCol'),
          icon: 'trash',
          click: function() {
            if (confirm(highed.L('dgDelColConfirm'))) {
              delCol(exports.colNumber);
            }
          }
        },
        // {
        //     title: 'Clone Column',
        //     icon: 'clone'
        // },
        '-',
        {
          title: highed.L('dgInsColBefore'),
          icon: 'plus',
          click: function() {
            insertCol(exports.colNumber);
          }
        },
        {
          title: highed.L('dgInsColAfter'),
          icon: 'plus',
          click: function() {
            insertCol(exports.colNumber + 1);
          }
        }
      ]),
      ox;

    ////////////////////////////////////////////////////////////////////////

    exports.addToDOM = function() {
      highed.dom.ap(colgroup, col);
      highed.dom.ap(
        topBar,
        highed.dom.ap(header, headerTitle, options, moveHandle)
      );
    };

    exports.destroy = function() {
      colgroup.removeChild(col);
      topBar.removeChild(header);

      gcolumns = gcolumns.filter(function(b) {
        return b !== exports;
      });
    };

    ////////////////////////////////////////////////////////////////////////

    exports.addToDOM();

    // highed.dom.showOnHover(header, options);

    col.width = 140;
    highed.dom.style([col, header], {
      width: col.width + 'px'
    });

    mover.on('StartMove', function(x) {
      ox = x;

      highed.dom.style(document.body, {
        cursor: 'ew-resize'
      });
    });

    mover.on('Moving', function(x) {
      col.width = x;

      highed.dom.style([col, header], {
        width: x + 'px'
      });

      moveHandle.className =
        'highed-dtable-resize-handle highed-dtable-resize-handle-moving';
    });

    mover.on('EndMove', function(x) {
      highed.dom.style(document.body, {
        cursor: ''
      });

      moveHandle.className = 'highed-dtable-resize-handle';
    });

    highed.dom.on(options, 'click', function(e) {
      ctx.show(e.clientX, e.clientY);
      return highed.dom.nodefault(e);
    });

    highed.dom.on(header, 'click', function(e) {
      //Ugly.
      mainInput.className = 'highed-dtable-input highed-dtable-input-header';

      //Spawn an edit box in the node
      makeEditable(
        header,
        value,
        function(val) {
          headerTitle.innerHTML = value = val;
          emitChanged();
        },
        function(e) {
          if (e.keyCode === 13) {
            mainInput.className = 'highed-dtable-input';
            header.removeChild(mainInput);
          }
        }
      );
    });

    rows.forEach(function(row) {
      if (where) {
        row.insertCol(where);
      } else {
        row.addCol();
      }
    });

    if (where) {
      gcolumns.splice(where, 0, exports);
    } else {
      gcolumns.push(exports);
    }

    emitChanged();
  }

  function showDropzone() {
    highed.dom.style(dropZone, {
      opacity: 1
    });
  }

  function hideDropzone() {
    highed.dom.style(dropZone, {
      opacity: 0
    });
  }

  ////////////////////////////////////////////////////////////////////////////
  // PUBLIC FUNCTIONS FOLLOW

  /** Sort rows
   * @memberof highed.DataTable
   * @param column {number} - the column to sort on
   * @param direction {string} - the direction: `asc` or `desc`
   * @param asMonths {boolean} - if true, sort by month
   */
  function sortRows(column, direction, asMonths) {
    tbody.innerHTML = '';

    direction = (direction || '').toUpperCase();

    rows.sort(function(a, b) {
      var ad = a.columns[column].value(),
        bd = b.columns[column].value();

      if ((highed.isNum(ad) && highed.isNum(bd)) || asMonths) {
        if (asMonths) {
          ad = monthNumbers[ad.toUpperCase().substr(0, 3)] || 13;
          bd = monthNumbers[bd.toUpperCase().substr(0, 3)] || 13;
        } else {
          ad = parseFloat(ad);
          bd = parseFloat(bd);
        }

        if (direction === 'ASC') {
          return ad - bd;
        }
        return bd < ad ? -1 : bd > ad ? 1 : 0;
      }

      if (direction === 'ASC') {
        return ad.localeCompare(bd);
      }
      return bd.localeCompare(ad);
    });

    rebuildRows();
    emitChanged();
  }

  /** Clear the table
   * @memberof highed.DataTable
   */
  function clear(noWait) {
    rows = rows.filter(function(row) {
      row.destroy();
      return false;
    });

    gcolumns = gcolumns.filter(function(row) {
      //Destroy col here
      return false;
    });

    tbody.innerHTML = '';
    leftBar.innerHTML = '';
    topBar.innerHTML = '';
    colgroup.innerHTML = '';

    highed.dom.style(tableTail, {
      display: ''
    });

    events.emit('ClearData');

    emitChanged(noWait);
    showDropzone();
  }

  /** Add a new row
   * @memberof highed.DataTable
   */
  function addRow(supressChange, skipAdd) {
    var r = Row(skipAdd);

    gcolumns.forEach(function() {
      r.addCol();
    });

    if (!supressChange) {
      emitChanged();
    }

    if (rows.length > 1) {
      hideDropzone();
    }

    return r;
  }

  /** Insert a new column
   * @memberof highed.DataTable
   * @param {number} where - is the position where to add it
   */
  function insertCol(where) {
    if (!where) gcolumns.length;
    if (where < 0) where = 0;
    if (where >= gcolumns.length) where = gcolumns.length;

    //Insert into gcolumns and on each row, then call updateColumns()
    addCol(highed.L('dgNewCol'), where);

    updateColumns();
  }

  /** Delete a column
   * @memberof highed.DataTable
   * @param {number} which - the index of the column to delete
   */
  function delCol(which) {
    if (which >= 0 && which < gcolumns.length) {
      rows.forEach(function(row) {
        row.delCol(which);
      });

      gcolumns[which].destroy();

      updateColumns();
      emitChanged();
    }
  }

  /** Resize the table based on the container size
   *  @memberof highed.DataTable
   */
  function resize() {
    var ps = highed.dom.size(parent),
      hs = highed.dom.size(topBar),
      tb = highed.dom.size(toolbar.container);

    highed.dom.style(frame, {
      height: ps.h - hs.h - tb.h + 'px',
      width: ps.w - hs.h + 'px'
    });

    highed.dom.style(table, {
      width: ps.w - hs.h + 'px'
    });
  }

  /** Returns the header titles as an array
   *  @memberof highed.DataTable
   *  @returns {array<string>} - the headers
   */
  function getHeaderTextArr(quoteStrings) {
    return gcolumns.map(function(item) {
      var title = item.headerTitle.innerHTML.length
        ? item.headerTitle.innerHTML
        : null;

      if (quoteStrings) {
        title = '"' + title + '"';
      }

      return title;
    });
  }

  /** Get the table contents as an array of arrays
   *  @memberof highed.DataTable
   *  @param {boolean} quoteStrings - if true, strings are wrapped in double quotes
   *  @param {boolean} includeHeaders - if true, the header texts will be included as the first row
   *  @returns {array<array<string>>}
   */
  function toData(quoteStrings, includeHeaders) {
    var data = [];

    if (includeHeaders) {
      data.push(getHeaderTextArr(quoteStrings));
    }

    rows.forEach(function(row) {
      var rarr = [],
        hasData = false;

      row.columns.forEach(function(col) {
        var v = col.value(),
          d;

        if (v) {
          hasData = true;
        }

        if (quoteStrings && !highed.isNum(v) && highed.isStr(v)) {
          v = '"' + v.replace(/\"/g, '"') + '"';
        }

        if (highed.isNum(v)) {
          v = parseFloat(v);
        }

        if (highed.isStr(v) && Date.parse(v) !== NaN) {
          //v = (new Date(v)).getTime();
        }

        rarr.push(v);
      });

      if (hasData) {
        data.push(rarr);
      }
    });

    return data;
  }

  /** Get the table contents as series
   *  @memberof highed.DataTable
   */
  function toDataSeries(ignoreFirst) {
    var res = {
      categories: [],
      series: []
    };

    gcolumns.forEach(function(item, i) {
      if (i > 0) {
        res.series.push({
          name: item.headerTitle.innerHTML.length
            ? item.headerTitle.innerHTML
            : null,
          data: []
        });
      }
    });

    rows.forEach(function(row, i) {
      row.columns.forEach(function(col, ci) {
        var v = col.value();

        if (!ci) {
          if (v && highed.isStr(v) && Date.parse(v) !== NaN) {
            // v = new Date(v);
          }

          res.categories.push(v);
          return;
        }

        ci--;

        if (v && highed.isNum(v)) {
          v = parseFloat(v);
        }

        if (v && highed.isStr(v) && Date.parse(v) !== NaN) {
          // v = (new Date(v)).getTime();
        }

        res.series[ci].data.push(v);
      });
    });

    return res;
  }

  /** Get the table contents as standard CSV
   *  @memberof highed.DataTable
   *  @param delimiter {string} - the delimiter to use. Defaults to `,`.
   */
  function toCSV(delimiter, quoteStrings) {
    delimiter = delimiter || ',';
    return toData(quoteStrings, true)
      .map(function(cols) {
        return cols.join(delimiter);
      })
      .join('\n');
  }

  function loadRows(rows, done) {
    var sanityCounts = {};

    clear();

    if (rows.length > 1) {
      hideDropzone();
    }

    // Do a sanity check on rows.
    // If the column count varries between rows, there may be something wrong.
    // In those cases we should pop up a dialog allow to specify what the
    // delimiter should be manually.

    rows.some(function(row, i) {
      var count = row.length;
      sanityCounts[count] =
        typeof sanityCounts[count] === 'undefined' ? 0 : sanityCounts[count];
      ++sanityCounts[count];
      return i > 20;
    });

    if (Object.keys(sanityCounts).length > 4) {
      // Four or more rows have varrying amounts of columns.
      // Something is wrong.
      showDataImportError();
    }

    highed.dom.style(loadIndicator, {
      opacity: 1
    });

    setTimeout(function() {
      rows.forEach(function(cols, i) {
        var row;

        if (i) {
          row = Row();
        }

        cols.forEach(function(c) {
          if (i === 0) {
            addCol(c);
          } else {
            row.addCol(c);
          }
        });
      });

      highed.dom.ap(colgroup, highed.dom.cr('col'));

      // highed.snackBar(highed.L('dgDataImported'));
      resize();

      highed.dom.style(loadIndicator, {
        opacity: 0
      });

      if (highed.isFn(done)) {
        done();
      }
    }, 10);
  }

  function loadLiveDataPanel(params){
      //loadRows(params.csv);

      isInLiveDataMode = true;
      highed.dom.style(gsheetFrame, {
        display: 'none'
      });
      highed.dom.style(container, {
        display: 'none'
      });
      highed.dom.style(liveDataFrame, {
        display: 'block'
      });

      liveDataInput.value = params.columnsURL || params.rowsURL || params.csvURL;
      liveDataIntervalInput.value = params.dataRefreshRate || '';
      liveDataTypeSelect.selectById((params.columnsURL ? 'columnsURL' : (params.rowsURL ? 'rowsURL': 'csvURL')));
  }

  function loadLiveDataFromURL(url, interval, type) {
    isInLiveDataMode = true;
    events.emit('LoadLiveData', { url: url,
                                  interval: interval,
                                  type: type });
  }

  function loadCSV(data, surpressEvents) {
    var rows;

    if (isInGSheetMode) {
      isInGSheetMode = false;
      isInLiveDataMode = false;

      highed.dom.style(gsheetFrame, {
        display: 'none'
      });

      highed.dom.style(liveDataFrame, {
        display: 'none'
      });

      highed.dom.style(container, {
        display: 'block'
      });
    }

    // highed.snackBar(highed.L('dgDataImporting'));
    importModal.hide();

    surpressChangeEvents = true;

    rawCSV = data.csv;

    if (data && data.csv) {
      rows = parseCSV(data.csv, data.delimiter);
      loadRows(rows, function() {});
    } else {
      // surpressChangeEvents = false;
      // if (!surpressEvents) {
      //   emitChanged(true);
      // }
    }
    surpressChangeEvents = false;
    if (!surpressEvents) {
      emitChanged(true);
    }
  }

  function initGSheet(
    id,
    worksheet,
    startRow,
    endRow,
    startColumn,
    endColumn,
    skipLoad,
    dataRefreshRate
  ) {
    gsheetID.value = id;
    gsheetWorksheetID.value = worksheet || '';
    gsheetRefreshTime.value = dataRefreshRate || '';
    gsheetStartRow.value = startRow || 0;
    gsheetEndRow.value = endRow || '';
    gsheetStartCol.value = startColumn || 0;
    gsheetEndCol.value = endColumn || 0;

    isInGSheetMode = true;
    isInLiveDataMode = false;

    highed.dom.style(gsheetFrame, {
      display: 'block'
    });

    highed.dom.style(container, {
      display: 'none'
    });

    highed.dom.style(liveDataFrame, {
      display: 'none'
    });


    if (!skipLoad) {
      events.emit('LoadGSheet', {
        googleSpreadsheetKey: gsheetID.value,
        googleSpreadsheetWorksheet: gsheetWorksheetID.value || false,
        dataRefreshRate: gsheetRefreshTime.value || false,
        enablePolling: (parseInt(gsheetRefreshTime.value) !== 0),
        startRow: gsheetStartRow.value || 0,
        endRow: gsheetEndRow.value || undefined,
        startColumn: gsheetStartCol.value || 0,
        endColumn: gsheetEndCol.value || undefined
      });
    }
  }

  function addImportTab(tabOptions){
    importer.addImportTab(tabOptions);
  }

  function hideImportModal(){
    importModal.hide();
  }

  function showLiveData() {
    if (
      rows.length <= 1 ||
      confirm('This will clear your existing data. Continue?')
    ) {
      clear(true);

      liveDataInput.value = '';
      liveDataIntervalInput.value = '';
      liveDataTypeSelect.selectByIndex(0);

      highed.dom.style(gsheetFrame, {
        display: 'none'
      });

      highed.dom.style(container, {
        display: 'none'
      });

      highed.dom.style(liveDataFrame, {
        display: 'block'
      });
      importModal.hide();

      isInGSheetMode = false;
      isInLiveDataMode = true;
    }

  }

  function showGSheet() {
    if (
      rows.length <= 1 ||
      confirm('This will clear your existing data. Continue?')
    ) {
      clear(true);

      gsheetID.value = '';
      gsheetWorksheetID.value = '';
      gsheetRefreshTime.value = '';

      highed.dom.style(gsheetFrame, {
        display: 'block'
      });

      highed.dom.style(container, {
        display: 'none'
      });

      highed.dom.style(liveDataFrame, {
        display: 'none'
      });

      isInGSheetMode = true;
      isInLiveDataMode = false;
    }
  }

  function hideLiveData() {
    if (
      !liveDataInput.value ||
      confirm('Are you sure you want to remove your live data?')
    ) {
      // Should emit a gsheet clear

      events.emit('LoadLiveData', {
          url: ''
      });

      highed.dom.style(gsheetFrame, {
        display: 'none'
      });

      highed.dom.style(container, {
        display: 'block'
      });


      highed.dom.style(liveDataFrame, {
        display: 'none'
      });

      isInLiveDataMode = false;

      init();
    }
  }

  function hideGSheet() {
    if (
      !gsheetID.value ||
      confirm('Are you sure you want to detach the current spreadsheet?')
    ) {
      // Should emit a gsheet clear
      events.emit('LoadGSheet', {
        googleSpreadsheetKey: '',
        googleSpreadsheetWorksheet: false
      });

      highed.dom.style(gsheetFrame, {
        display: 'none'
      });

      highed.dom.style(container, {
        display: 'block'
      });

      highed.dom.style(liveDataFrame, {
        display: 'none'
      });
      isInGSheetMode = false;

      init();

      highed.emit('UIAction', 'DetachGoogleSheet');
    }
  }

  ////////////////////////////////////////////////////////////////////////////

  importer.on('ImportCSV', function(data) {
    highed.emit('UIAction', 'ImportCSV');
    loadCSV(data);
  });

  importer.on('ImportLiveData', function(data) {
    isInLiveDataMode = true;
    showLiveData();
    //loadLiveDataFromURL(data.url);
  });

  importer.on('ImportChartSettings', function(settings, format) {
    // Do something with the data here
    events.emit('ImportChartSettings', settings, format);
    importModal.hide();
  });

  highed.dom.on(gsheetCancelButton, 'click', function() {
    hideGSheet();
    events.emit('CancelDataInput');
  });

  highed.dom.on(liveDataCancelButton, 'click', function() {
    hideLiveData();
    events.emit('CancelDataInput');
  });

  highed.dom.on(liveDataLoadButton, 'click', function() {
    loadLiveDataFromURL(liveDataInput.value, liveDataIntervalInput.value, detailValue || 'columnsURL');
  });

  highed.dom.on(gsheetLoadButton, 'click', function() {
    events.emit('LoadGSheet', {
      googleSpreadsheetKey: gsheetID.value,
      googleSpreadsheetWorksheet: gsheetWorksheetID.value || false,
      dataRefreshRate: gsheetRefreshTime.value || false,
      enablePolling: (parseInt(gsheetRefreshTime.value) !== 0),
      startRow: gsheetStartRow.value || 0,
      endRow: gsheetEndRow.value || Number.MAX_VALUE,
      startColumn: gsheetStartCol.value || 0,
      endColumn: gsheetEndCol.value || Number.MAX_VALUE
    });
  });

  highed.dom.on(weirdDataIgnore, 'click', hideDataImportError);

  highed.dom.on(weirdDataFix, 'click', function() {
    // Pop open a modal with the option of supplying a delimiter manually.
    var dropdownParent = highed.dom.cr('div'),
      dropdown = highed.DropDown(dropdownParent),
      okBtn = highed.dom.cr('button', 'highed-ok-button', 'Rerun Import'),
      nevermindBtn = highed.dom.cr('button', 'highed-ok-button', 'Nevermind'),
      selectedDelimiter = undefined;

    weirdDataModal.body.innerHTML = '';
    weirdDataModal.show();

    dropdown.addItems([
      {
        title: 'Tab',
        id: 'tab',
        select: function() {
          selectedDelimiter = '\t';
        }
      },
      {
        title: 'Comma',
        id: 'comma',
        select: function() {
          selectedDelimiter = ',';
        }
      },
      {
        title: 'Semicolon',
        id: 'semicolon',
        select: function() {
          selectedDelimiter = ';';
        }
      }
    ]);

    dropdown.selectByIndex(0);

    highed.dom.ap(
      weirdDataModal.body,
      highed.dom.cr('h3', '', 'Data Import Fixer'),
      highed.dom.cr(
        'div',
        'highed-dtable-weird-data-body',
        [
          'We could not properly determine how your columns are separated.',
          '<br/><br/>',
          'Usually this is caused by commas as thousand separators,',
          'or something similar. Please choose which delimiter you want to use,',
          'and click the Rerun button.<br/><br/>'
        ].join(' ')
      ),
      dropdownParent,
      highed.dom.style(okBtn, {
        marginRight: '5px'
      }),
      nevermindBtn
    );

    highed.dom.on(nevermindBtn, 'click', weirdDataModal.hide);

    highed.dom.on(okBtn, 'click', function() {
      weirdDataModal.hide();
      hideDataImportError();

      loadCSV({
        csv: rawCSV,
        delimiter: selectedDelimiter
      });
    });
  });

  ////////////////////////////////////////////////////////////////////////////

  dropZone.innerHTML =
    'DROP CSV FILES HERE OR ON THE TABLE!<br/>' +
    '<span class="highed-dtable-drop-zone-small">...you can also paste CSV or Excel data into any cell</span>';

  table.cellPadding = 0;
  table.cellSpacing = 0;

  highed.dom.on(frame, 'scroll', function(e) {
    leftBar.style.top = -frame.scrollTop + 'px';
    topBar.style.left = -frame.scrollLeft + 'px';
  });

  parent = highed.dom.get(parent);
  highed.dom.ap(
    parent,
    gsheetFrame,
    liveDataFrame,
    highed.dom.ap(
      container,
      highed.dom.ap(
        frame,
        highed.dom.ap(table, colgroup, thead, tbody),
        tableTail,
        dropZone
      ),
      leftBar,
      topBar,
      highed.dom.ap(topLeftPanel, checkAll)
    ),
    highed.dom.ap(
      weirdDataContainer,
      highed.dom.cr(
        'div',
        'highed-dtable-weird-data-body',
        [
          'Uh-oh! It looks like our data importer may have had some issues',
          'processing your data.',
          'Usually this means that we were unable to deduce how the columns',
          'are separated.'
        ].join(' ')
      ),
      weirdDataIgnore,
      weirdDataFix
    ),

    loadIndicator
  );

  gsheetID.placeholder = 'Spreadsheet ID';
  gsheetWorksheetID.placeholder = 'Worksheet (leave blank for first)';
  gsheetRefreshTime.placeholder = 'Refresh Time (leave blank for no refresh)';

  highed.dom.ap(
    gsheetFrame,
    highed.dom.ap(
      gsheetContainer,
      highed.dom.cr(
        'div',
        'highed-dtable-gsheet-heading',
        'Google Spreadsheet'
      ),
      highed.dom.ap(
        highed.dom.cr('div', 'highed-dtable-gsheet-inner'),
        // highed.dom.cr('div', 'highed-dtable-gsheet-centered', 'You have loaded a Google Spreadsheet.'),
        // highed.dom.cr(
        //   'div',
        //   'highed-dtable-gsheet-desc',
        //   [
        //     'Google Spreadsheets are referenced, meaning that the data is imported',
        //     'on the fly. When viewing the chart, the latest version of your sheet',
        //     'will always be used!<br/><br/>'
        //   ].join(' ')
        // ),
        highed.dom.cr(
          'div',
          'highed-dtable-gsheet-label',
          'Google Spreadsheet ID'
        ),
        highed.dom.ap(highed.dom.cr('div'), gsheetID),
        highed.dom.ap(
          highed.dom.cr('table', 'highed-stretch'),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Worksheet'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Refresh Time (Seconds)')
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetWorksheetID),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetRefreshTime)
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Start Row'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'End Row')
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetStartRow),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetEndRow)
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Start Column'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'End Column')
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetStartCol),
            highed.dom.ap(highed.dom.cr('td', '', ''), gsheetEndCol)
          )
        ),
        highed.dom.ap(
          highed.dom.cr('div'),
          gsheetLoadButton,
          gsheetCancelButton
        ),
        highed.dom.cr(
          'div',
          '',
          [
            'When using Google Spreadsheet, Highcharts references the sheet directly.<br/><br/>',
            'This means that the published chart always loads the latest version of the sheet.<br/><br/>',

            'For more information on how to set up your spreadsheet, visit',
            '<a target="_blank" href="https://www.highcharts.com/cloud/import-data/how-to-set-up-a-google-spreadsheet-file">the documentation</a>.'
          ].join(' ')
        )
      )
    )
  );

  liveDataTypeSelect.addItems([
    {id: 'columnsURL', title: "JSON (Column Ordered)"},
    {id: 'rowsURL', title: "JSON (Row Ordered)"},
    {id: 'csvURL', title: "CSV"}
  ]
  );

  liveDataTypeSelect.on('Change', function(selected) {
    //detailIndex = selected.index();
    detailValue = selected.id();
    //liveDataTypeSelect.selectById(detailValue || 'json');
  });

  highed.dom.ap(liveDataTypeMasterNode, liveDataTypeSelect.container);
  highed.dom.style(liveDataTypeMasterNode, {
    display: 'block'
  });

  highed.dom.ap(
    liveDataFrame,
    highed.dom.ap(
      liveDataContainer,
      highed.dom.cr(
        'div',
        'highed-dtable-gsheet-heading',
        'Live Data'
      ),
      highed.dom.ap(
        highed.dom.cr('div', 'highed-dtable-gsheet-inner'),
        // highed.dom.cr('div', 'highed-dtable-gsheet-centered', 'You have loaded a Google Spreadsheet.'),
        // highed.dom.cr(
        //   'div',
        //   'highed-dtable-gsheet-desc',
        //   [
        //     'Google Spreadsheets are referenced, meaning that the data is imported',
        //     'on the fly. When viewing the chart, the latest version of your sheet',
        //     'will always be used!<br/><br/>'
        //   ].join(' ')
        // ),
        highed.dom.cr(
          'div',
          'highed-dtable-gsheet-label',
          'URL'
        ),
        highed.dom.ap(highed.dom.cr('div'), liveDataInput),

        highed.dom.ap(
          highed.dom.cr('table', 'highed-stretch'),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Chart Refresh Time (Seconds)'),
            highed.dom.cr('td', 'highed-dtable-gsheet-label', 'Data Type')
          ),
          highed.dom.ap(
            highed.dom.cr('tr'),
            highed.dom.ap(highed.dom.cr('td', '', ''), liveDataIntervalInput),
            highed.dom.ap(highed.dom.cr('td', '', ''), liveDataTypeMasterNode)
          )
        ),

        highed.dom.ap(
          highed.dom.cr('div'),
          liveDataLoadButton,
          liveDataCancelButton
        ),
        highed.dom.cr('div', '', [
          'Live data needs a url to your JSON data to reference.<br/><br/>',
          'This means that the published chart always loads the latest version of your data.<br/><br/>'
        ].join(' '))
      )
    )
  );

  function getRawCSV() {
    return rawCSV;
  }

  ////////////////////////////////////////////////////////////////////////////

  toolbar = highed.Toolbar(container, {
    additionalCSS: ['highed-dtable-toolbar']
  });

  toolbar.addButton({
    css: 'fa-plus-circle',
    tooltip: 'Add row',
    title: highed.L('dgAddRow'),
    click: function(e) {
      highed.emit('UIAction', 'BtnAddRow');
      addRowCtx.show(e.clientX, e.clientY);
    }
  });

  toolbar.addButton({
    css: 'fa-file-o',
    tooltip: 'Reset',
    title: highed.L('dgNewBtn'),
    click: function() {
      highed.emit('UIAction', 'BtnFlushData');
      if (confirm('Start from scratch?')) {
        highed.emit('UIAction', 'FlushDataConfirm');
        init();
        emitChanged();
      }
    }
  });

  toolbar.addButton({
    tooltip: 'Import Google Spreadsheet',
    title: 'Google Sheet',
    click: function() {
      highed.emit('UIAction', 'BtnGoogleSheet');
      showGSheet();
    }
  });

  toolbar.addButton({
    css: 'fa-floppy-o',
    title: highed.L('dgExportBtn'),
    tooltip: 'Download data',
    click: function(e) {
      highed.emit('UIAction', 'BtnExportData');
      saveCtx.show(e.clientX, e.clientY);
    }
  });

  toolbar.addButton({
    title: highed.L('dgImportBtn'),
    click: function() {
      highed.emit('UIAction', 'BtnImport');
      importModal.show();
      importer.resize();
    }
  });

  highed.dom.on(checkAll, 'change', function() {
    rows.forEach(function(row) {
      row.check(checkAll.checked);
    });
  });

  highed.dom.ap(
    toolbar.left,
    highed.dom.cr(
      'div',
      'highed-dtable-toolbar-label',
      highed.L('dgWithSelected') + ' '
    )
  );

  toolbar.addIcon(
    {
      css: 'fa-trash',
      title: 'Delete row(s)',
      click: function() {
        highed.emit('UIAction', 'BtnDeleteRow');

        if (!confirm(highed.L('dgDeleteRow'))) {
          return;
        }

        highed.emit('UIAction', 'DeleteRowConfirm');

        rows.forEach(function(row) {
          if (row.isChecked()) {
            row.destroy();
            emitChanged();
          }
        });
      }
    },
    'left'
  );

  // toolbar.addIcon(
  //   {
  //     css: 'fa-clone',
  //     title: 'Clone Rows',
  //     click: function() {
  //       importModal.show();
  //       importer.resize();
  //     }
  //   },
  //   'left'
  // );

  ////////////////////////////////////////////////////////////////////////////

  highed.ready(function() {
    init();
  });

  ////////////////////////////////////////////////////////////////////////////

  return {
    toolbar: toolbar,
    sortRows: sortRows,
    clear: clear,
    addRow: addRow,
    insCol: insertCol,
    delCol: delCol,
    loadCSV: loadCSV,
    getRawCSV: getRawCSV,
    toData: toData,
    toCSV: toCSV,
    toDataSeries: toDataSeries,
    getHeaderTextArr: getHeaderTextArr,
    addImportTab: addImportTab,
    hideImportModal: hideImportModal,
    initGSheet: initGSheet,
    on: events.on,
    resize: resize,
    loadLiveDataFromURL: loadLiveDataFromURL,
    loadLiveDataPanel: loadLiveDataPanel
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.Toolbox = function(parent, attr) {
  var events = highed.events(),
    container = highed.dom.cr(
      'div',
      'highed-transition highed-toolbox highed-box-size'
    ),
    bar = highed.dom.cr('div', 'highed-toolbox-bar highed-box-size'),
    body = highed.dom.cr(
      'div',
      'highed-toolbox-body highed-box-size highed-transition'
    ),
    activeTimeout,
    expanded = false,
    activeItem = false,
    properties = highed.merge(
      {
        animate: true
      },
      attr
    ),
    liveDiv = highed.dom.cr(
      'div',
      'highed-toolbox-live',
      'LIVE'
    );

  function addEntry(def) {
    var props = highed.merge(
        {
          title: 'Tooltip Missing',
          icon: 'fa-trash',
          width: 200
        },
        def
      ),
      entryEvents = highed.events(),
      title = highed.dom.cr('div', 'highed-toolbox-body-title', props.title),
      contents = highed.dom.cr(
        'div',
        'highed-box-size highed-toolbox-inner-body'
      ),
      userContents = highed.dom.cr(
        'div',
        'highed-box-size highed-toolbox-user-contents'
      ),
      helpIcon = highed.dom.cr(
        'div',
        'highed-toolbox-help highed-icon fa fa-question-circle'
      ),
      iconClass = 'highed-box-size highed-toolbox-bar-icon fa ' + props.icon,
      icon = highed.dom.cr('div', iconClass),
      helpModal = highed.HelpModal(props.help || []),
      resizeTimeout,
      exports = {};

    if (def.iconOnly) {
      props.width = 0;
    }

    highed.dom.on(icon, 'click', function() {
      entryEvents.emit('Click');
    });

    highed.dom.on(icon, 'mouseover', function(e) {
      var pos = highed.dom.pos(icon),
        size = highed.dom.size(icon),
        ppos = highed.dom.pos(parent);

      pos.y += ppos.y;

      clearTimeout(activeTimeout);

      activeTimeout = setTimeout(function() {
        highed.Tooltip(pos.x + 10 + size.w, pos.y + size.h, def.title);
      }, 800);
    });

    highed.dom.on(icon, 'mouseout', function() {
      clearTimeout(activeTimeout);
      highed.hideAllTooltips();
    });

    function resizeBody() {
      var bsize = highed.dom.size(body),
        tsize = highed.dom.size(title),
        size = {
          w: bsize.w,
          h: bsize.h - tsize.h
        };

      highed.dom.style(contents, {
        width: size.w + 'px',
        height: size.h + 'px'
      });

      return size;
    }

    function expand() {
      var bsize = highed.dom.size(bar);
      var newWidth = bsize.w + props.width;

      if (expanded && activeItem === exports) {
        return;
      }

      if (props.iconOnly) {
        return;
      }

      if (activeItem) {
        activeItem.disselect();
      }

      entryEvents.emit('BeforeExpand');

      body.innerHTML = '';
      highed.dom.ap(body, contents);

      highed.dom.style(body, {
        width: props.width + 'px',
        height: bsize.h + 'px',
        opacity: 1
      });

      highed.dom.style(container, {
        width: newWidth + 'px'
      });

      events.emit('BeforeResize', newWidth);

      expanded = true;

      setTimeout(function() {
        var height = resizeBody().h;

        events.emit('Expanded', exports, newWidth);
        entryEvents.emit('Expanded', newWidth, height - 20);
      }, 300);

      if (props.iconOnly) {
        activeItem = false;
      } else {
        icon.className = iconClass + ' highed-toolbox-bar-icon-sel';
        activeItem = exports;
      }

      highed.dom.style(helpIcon, {
        display: props.iconOnly ? 'none' : 'block'
      });

      highed.emit('UIAction', 'ToolboxNavigation', props.title);
    }

    function collapse() {
      var newWidth = highed.dom.size(bar).w;

      if (expanded) {
        highed.dom.style(body, {
          width: '0px',
          opacity: 0.1
        });

        highed.dom.style(container, {
          width: newWidth + 'px'
        });

        events.emit('BeforeResize', newWidth);

        disselect();
        expanded = false;
        activeItem = false;

        highed.dom.style(helpIcon, {
          display: 'none'
        });
      }
    }

    function toggle() {
      if (activeItem === exports) {
        collapse();
      } else {
        expand();
      }
    }

    function disselect() {
      icon.className = iconClass;
    }

    function showHelp() {
      highed.emit('UIAction', 'IconHelp', props.title);
      helpModal.show();
    }

    highed.dom.on(helpIcon, 'click', showHelp);
    highed.dom.on(icon, 'click', toggle);
    highed.dom.ap(bar, icon);
    highed.dom.ap(contents, (props.showLiveStatus ? highed.dom.ap(title, liveDiv, helpIcon) :  highed.dom.ap(title, helpIcon)), userContents);

    function reflowEverything() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        highed.dom.style(body, { height: '' });
        if (expanded) {
          var height = resizeBody().h;
          entryEvents.emit('Expanded', highed.dom.size(bar), height - 20);
        }
      }, 100);
    }

    highed.dom.on(window, 'resize', reflowEverything);

    exports = {
      on: entryEvents.on,
      expand: expand,
      collapse: collapse,
      body: userContents,
      disselect: disselect
    };

    return exports;
  }

  function width() {
    var bodySize = highed.dom.size(body),
      barSize = highed.dom.size(bar);

    return bodySize.w + barSize.w;
  }

  function clear() {
    bar.innerHTML = '';
    body.innerHTML = '';
  }

  function showLiveStatus() {
    highed.dom.style(liveDiv, {
      display: 'inline'
    });
  }

  function hideLiveStatus() {
    highed.dom.style(liveDiv, {
      display: 'none'
    });
  }

  highed.dom.ap(parent, highed.dom.ap(container, bar, body));

  return {
    clear: clear,
    on: events.on,
    addEntry: addEntry,
    width: width,
    showLiveStatus: showLiveStatus,
    hideLiveStatus: hideLiveStatus
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.HelpModal = function(items) {
  var active = false,
    nav = highed.dom.cr('div', 'highed-help-nav'),
    body = highed.dom.cr('div'),
    counter = highed.dom.cr('div', 'highed-help-counter'),
    modal = highed.OverlayModal(false, {
      width: 600,
      height: 600
    });

  items.forEach(function(item, i) {
    var container = highed.dom.cr('div'),
      heading = highed.dom.cr('div', 'highed-toolbox-body-title', item.title),
      gif = highed.dom.cr('div', 'highed-help-gif'),
      desc = highed.dom.cr('div', 'highed-scrollbar highed-help-desc'),
      activate = highed.dom.cr('span', 'highed-icon fa fa-circle-o');

    if (highed.isArr(item.description)) {
      item.description = item.description.join(' ');
    }

    desc.innerHTML = item.description;
    if (item.gif) {
      item.gif = highed.option('helpImgPath') + item.gif;

      highed.dom.style(gif, {
        'background-image': 'url("' + item.gif + '")'
      });
    } else {
      highed.dom.style(gif, { display: 'none' });
    }

    function makeActive() {
      if (active) {
        active.className = 'highed-icon fa fa-circle-o';
      }

      body.innerHTML = '';
      activate.className = 'highed-icon fa fa-circle';
      highed.dom.ap(body, container);
      active = activate;

      counter.innerHTML = i + 1 + '/' + items.length;
    }

    highed.dom.on(activate, 'click', makeActive);

    highed.dom.ap(container, heading, gif, desc);

    highed.dom.ap(nav, activate);

    if (i === 0) {
      makeActive();
    }
  });

  if (items.length < 2) {
    highed.dom.style([nav, counter], {
      display: 'none'
    });
  }

  highed.dom.ap(modal.body, body, nav, counter);

  return {
    show: modal.show
  };
};

/*

Highcharts Editor v<%= version %>

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

// @format

highed.meta.optionsExtended = {
    options: {
        "option.cat.title": [
            {
                text: "option.subcat.titles",
                options: [
                    {
                        id: "title--text",
                        pid: "title.text",
                        dataType: "string",
                        context: "General",
                        defaults: "Chart title",
                        parent: "title",
                    },
                    {
                        id: "subtitle--text",
                        pid: "subtitle.text",
                        dataType: "string",
                        context: "General",
                        parent: "subtitle",
                    },
                    {
                        id: "yAxis-title--text",
                        dataIndex: 0,
                        pid: "yAxis.title.text",
                        dataType: "string",
                        context: "General",
                        defaults: "Values",
                        parent: "yAxis-title",
                    },
                ],
            },
        ],
        "option.cat.general": [
            {
                text: "option.subcat.size",
                options: [
                    {
                        id: "chart--width",
                        custom: {
                            minValue: 50,
                            maxValue: 5000,
                            step: 10,
                        },
                        pid: "chart.width",
                        dataType: "number",
                        context: "General",
                        defaults: "null",
                        parent: "chart",
                    },
                    {
                        id: "chart--height",
                        custom: {
                            minValue: 50,
                            maxValue: 5000,
                            step: 10,
                        },
                        pid: "chart.height",
                        dataType: "number",
                        context: "General",
                        defaults: "null",
                        parent: "chart",
                    },
                ],
            },
            {
                text: "option.subcat.interaction",
                options: [
                    {
                        id: "chart--zoomType",
                        pid: "chart.zoomType",
                        dataType: "string",
                        context: "General",
                        parent: "chart",
                        values: '[null, "x", "y", "xy"]',
                    },
                    {
                        id: "chart--polar",
                        pid: "chart.polar",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "chart",
                    },
                ],
            },
        ],
        "option.cat.appearance": [
            {
                text: "option.subcat.fonts",
                options: [
                    {
                        id: "chart--style",
                        dataType: "font",
                        pid: "chart.style",
                        context: "General",
                        defaults:
                            '{"fontFamily":"\\"Lucida Grande\\", \\"Lucida Sans Unicode\\", Verdana, Arial, Helvetica, sans-serif","fontSize":"12px"}',
                        parent: "chart",
                    },
                ],
            },
            {
                text: "option.subcat.titlestyle",
                options: [
                    {
                        id: "title--style",
                        dataType: "font",
                        pid: "title.style",
                        context: "General",
                        defaults: '{ "color": "#333333", "fontSize": "18px" }',
                        parent: "title",
                    },
                    {
                        id: "subtitle--style",
                        dataType: "font",
                        pid: "subtitle.style",
                        context: "General",
                        defaults: '{ "color": "#666666" }',
                        parent: "subtitle",
                    },
                ],
            },
            {
                text: "option.subcat.seriescolors",
                options: [
                    {
                        id: "colors",
                        pid: "colors",
                        dataType: "array<color>",
                        context: "General",
                        defaults:
                            '[ "#7cb5ec" , "#434348" , "#90ed7d" , "#f7a35c" , "#8085e9" , "#f15c80" , "#e4d354" , "#2b908f" , "#f45b5b" , "#91e8e1"]',
                    },
                ],
            },
            {
                text: "option.subcat.chartarea",
                options: [
                    {
                        id: "chart--backgroundColor",
                        pid: "chart.backgroundColor",
                        dataType: "color",
                        context: "General",
                        defaults: "#FFFFFF",
                        parent: "chart",
                    },
                    {
                        id: "chart--borderWidth",
                        custom: {
                            minValue: 0,
                        },
                        pid: "chart.borderWidth",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "chart",
                    },
                    {
                        id: "chart--borderRadius",
                        custom: {
                            minValue: 0,
                        },
                        pid: "chart.borderRadius",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "chart",
                    },
                    {
                        id: "chart--borderColor",
                        pid: "chart.borderColor",
                        dataType: "color",
                        context: "General",
                        defaults: "#335cad",
                        parent: "chart",
                    },
                ],
            },
            {
                text: "option.subcat.plotarea",
                options: [
                    {
                        id: "chart--plotBackgroundColor",
                        pid: "chart.plotBackgroundColor",
                        dataType: "color",
                        context: "General",
                        parent: "chart",
                    },
                    {
                        id: "chart--plotBackgroundImage",
                        pid: "chart.plotBackgroundImage",
                        dataType: "string",
                        context: "General",
                        parent: "chart",
                    },
                    {
                        id: "chart--plotBorderWidth",
                        pid: "chart.plotBorderWidth",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "chart",
                    },
                    {
                        id: "chart--plotBorderColor",
                        pid: "chart.plotBorderColor",
                        dataType: "color",
                        context: "General",
                        defaults: "#cccccc",
                        parent: "chart",
                    },
                ],
            },
        ],
        "option.cat.axes": [
            {
                text: "option.subcat.axessetup",
                options: [
                    {
                        id: "chart--inverted",
                        pid: "chart.inverted",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "chart",
                    },
                ],
            },
            {
                id: "xAxis",
                text: "option.subcat.xaxis",
                options: [
                    {
                        id: "xAxis-title--style",
                        dataType: "font",
                        dataIndex: 0,
                        pid: "xAxis.title.style",
                        context: "General",
                        defaults: '{ "color": "#666666" }',
                        parent: "xAxis-title",
                    },
                    {
                        id: "xAxis-title--text",
                        dataIndex: 0,
                        pid: "xAxis.title.text",
                        dataType: "string",
                        context: "General",
                        parent: "xAxis-title",
                    },
                    {
                        id: "xAxis--type",
                        dataIndex: 0,
                        pid: "xAxis.type",
                        dataType: "string",
                        context: "General",
                        defaults: "linear",
                        parent: "xAxis",
                        values: '["linear", "logarithmic", "datetime", "category"]',
                    },
                    {
                        id: "xAxis--opposite",
                        dataIndex: 0,
                        pid: "xAxis.opposite",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "xAxis",
                    },
                    {
                        id: "xAxis--reversed",
                        dataIndex: 0,
                        pid: "xAxis.reversed",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "xAxis",
                    },
                    {
                        id: "xAxis-labels--format",
                        dataIndex: 0,
                        pid: "xAxis.labels.format",
                        dataType: "string",
                        context: "General",
                        defaults: "{value}",
                        parent: "xAxis-labels",
                    },
                ],
            },
            {
                id: "yAxis",
                text: "option.subcat.yaxis",
                options: [
                    {
                        id: "yAxis-title--style",
                        dataType: "font",
                        dataIndex: 0,
                        pid: "yAxis.title.style",
                        context: "General",
                        defaults: '{ "color": "#666666" }',
                        parent: "yAxis-title",
                    },
                    {
                        id: "yAxis--type",
                        dataIndex: 0,
                        pid: "yAxis.type",
                        dataType: "string",
                        context: "General",
                        defaults: "linear",
                        parent: "yAxis",
                        values: '["linear", "logarithmic", "datetime", "category"]',
                    },
                    {
                        id: "yAxis--opposite",
                        dataIndex: 0,
                        pid: "yAxis.opposite",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "yAxis",
                    },
                    {
                        id: "yAxis--reversed",
                        dataIndex: 0,
                        pid: "yAxis.reversed",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "yAxis",
                    },
                    {
                        id: "yAxis-labels--format",
                        dataIndex: 0,
                        pid: "yAxis.labels.format",
                        dataType: "string",
                        context: "General",
                        defaults: "{value}",
                        parent: "yAxis-labels",
                    },
                ],
            },
        ],
        "option.cat.series": [
            {
                id: "series",
                array: true,
                text: "option.cat.series",
                controlledBy: {
                    title: "Select Series",
                    options: "series",
                    optionsTitle: "name",
                },
                filteredBy: "series--type",
                options: [
                    {
                        id: "series--type",
                        pid: "series.type",
                        dataType: "string",
                        context: "General",
                        parent: "series<treemap>",
                        values:
                            '[null, "line", "spline", "column", "area", "areaspline", "pie", "arearange", "areasplinerange", "bubble", "columnrange", "errorbar", "gauge", "scatter", "waterfall"]',
                        subType: [
                            "treemap",
                            "scatter",
                            "line",
                            "gauge",
                            "heatmap",
                            "spline",
                            "areaspline",
                            "area",
                            "bar",
                            "bubble",
                            "areasplinerange",
                            "pie",
                            "arearange",
                            "column",
                            "waterfall",
                            "columnrange",
                            "pyramid",
                            "polygon",
                            "solidgauge",
                            "errorbar",
                        ],
                        subTypeDefaults: {},
                    },
                    {
                        id: "series--color",
                        pid: "series.color",
                        dataType: "color",
                        context: "General",
                        defaults: "null",
                        parent: "series<boxplot>",
                        subType: [
                            "boxplot",
                            "column",
                            "waterfall",
                            "columnrange",
                            "heatmap",
                            "area",
                            "scatter",
                            "bar",
                            "treemap",
                            "arearange",
                            "bubble",
                            "errorbar",
                            "spline",
                            "polygon",
                            "line",
                            "gauge",
                            "areaspline",
                            "areasplinerange",
                        ],
                        subTypeDefaults: {
                            heatmap: "null",
                            treemap: "null",
                            errorbar: "#000000",
                        },
                    },
                    {
                        id: "series--negativeColor",
                        pid: "series.negativeColor",
                        dataType: "color",
                        context: "General",
                        defaults: "null",
                        parent: "series<gauge>",
                        subType: [
                            "gauge",
                            "arearange",
                            "areasplinerange",
                            "line",
                            "errorbar",
                            "boxplot",
                            "areaspline",
                            "spline",
                            "bar",
                            "scatter",
                            "polygon",
                            "bubble",
                            "area",
                            "column",
                        ],
                        subTypeDefaults: {
                            arearange: "null",
                            areasplinerange: "null",
                            line: "null",
                            errorbar: "null",
                            boxplot: "null",
                            areaspline: "null",
                            spline: "null",
                            bar: "null",
                            scatter: "null",
                            polygon: "null",
                            bubble: "null",
                            area: "null",
                            column: "null",
                        },
                    },
                    {
                        id: "series--colorByPoint",
                        pid: "series.colorByPoint",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "series<treemap>",
                        subType: [
                            "treemap",
                            "heatmap",
                            "column",
                            "errorbar",
                            "columnrange",
                            "boxplot",
                            "bar",
                            "waterfall",
                        ],
                        subTypeDefaults: {
                            heatmap: "false",
                            column: "false",
                            errorbar: "false",
                            columnrange: "false",
                            boxplot: "false",
                            bar: "false",
                            waterfall: "false",
                        },
                    },
                    {
                        id: "series--dashStyle",
                        pid: "series.dashStyle",
                        dataType: "string",
                        context: "General",
                        defaults: "Solid",
                        parent: "series<areasplinerange>",
                        values:
                            '["Solid", "ShortDash", "ShortDot", "ShortDashDot", "ShortDashDotDot", "Dot", "Dash" ,"LongDash", "DashDot", "LongDashDot", "LongDashDotDot"]',
                        subType: [
                            "areasplinerange",
                            "polygon",
                            "areaspline",
                            "spline",
                            "scatter",
                            "area",
                            "bubble",
                            "arearange",
                            "waterfall",
                            "line",
                        ],
                        subTypeDefaults: {
                            polygon: "Solid",
                            areaspline: "Solid",
                            spline: "Solid",
                            scatter: "Solid",
                            area: "Solid",
                            bubble: "Solid",
                            arearange: "Solid",
                            waterfall: "Dot",
                            line: "Solid",
                        },
                    },
                    {
                        id: "series-marker--enabled",
                        pid: "series.marker.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "null",
                        parent: "series<bubble>-marker",
                        subType: [
                            "bubble",
                            "area",
                            "scatter",
                            "areaspline",
                            "spline",
                            "polygon",
                            "line",
                        ],
                        subTypeDefaults: {
                            area: "null",
                            scatter: "null",
                            areaspline: "null",
                            spline: "null",
                            polygon: "null",
                            line: "null",
                        },
                    },
                    {
                        id: "series-marker--symbol",
                        pid: "series.marker.symbol",
                        dataType: "string",
                        context: "General",
                        parent: "series<bubble>-marker",
                        values:
                            '[null, "circle", "square", "diamond", "triangle", "triangle-down"]',
                        subType: [
                            "bubble",
                            "polygon",
                            "line",
                            "scatter",
                            "spline",
                            "area",
                            "areaspline",
                        ],
                        subTypeDefaults: {},
                    },

                    {
                        id: "series--fillColor-pattern-path-d",
                        pid: "series.pattern",
                        dataType: "string",
                        context: "General",
                        defaults: "null",
                        parent: "series<area>",
                        subType: ["area"],
                        subTypeDefaults: {},
                        values: [
                            {
                                id:
                                    "M30 0 L30 29 L1 29 L1 0 Z M29 0 L29 1 L1 1 L1 0 Z M28 0 L28 2 L0 2 L0 0 Z M27 0 L27 3 L0 3 L0 0 Z M26 0 L26 4 L0 4 L0 0 Z M25 0 L25 5 L0 5 L0 0 Z M24 0 L24 6 L0 6 L0 0 Z M23 0 L23 7 L0 7 L0 0 Z M22 0 L22 8 L0 8 L0 0 Z M21 0 L21 9 L0 9 L0 0 Z M20 0 L20 10 L0 10 L0 0 Z M19 0 L19 11 L0 11 L0 0 Z M18 0 L18 12 L0 12 L0 0 Z M17 0 L17 13 L0 13 L0 0 Z M16 0 L16 14 L0 14 L0 0 Z M15 0 L15 15 L0 15 L0 0 Z M14 0 L14 16 L0 16 L0 0 Z M13 0 L13 17 L0 17 L0 0 Z M12 0 L12 18 L0 18 L0 0 Z M11 0 L11 19 L0 19 L0 0 Z M10 0 L10 20 L0 20 L0 0 Z M9 0 L9 21 L0 21 L0 0 Z M8 0 L8 22 L0 22 L0 0 Z M7 0 L7 23 L0 23 L0 0 Z M6 0 L6 24 L0 24 L0 0 Z M5 0 L5 25 L0 25 L0 0 Z M4 0 L4 26 L0 26 L0 0 Z M3 0 L3 27 L0 27 L0 0 Z M2 0 L2 28 L0 28 L0 0 Z M1 0 L1 29 L0 29 L0 0 Z",
                                title: "none",
                            },
                            {
                                id: "M 0 0 L 10 0 M 0 1 L 10 1 M 0 2 L 10 2",
                                title: "Horizontal",
                            },
                            {
                                id: "M 0 0 L 0 10 M 1 0 L 1 10 M 2 0 L 2 10",
                                title: "Vertical",
                            },
                            {
                                id: "M 0 0 L 10 10 M -1 9 L 1 11 M 9 -1 L 11 1",
                                title: "Diagonal (Top-Left to Bottom-Right)",
                            },
                            {
                                id: "M 10 0 L 0 10 M 0 0 L 1 1 M 9 9 L 11 11",
                                title: "Diagonal (Top-Right to Bottom-Left)",
                            },
                            { id: "M 0 5 L 10 5 M 5 0 L 5 10", title: "Grid" },
                            {
                                id: "M 0 0 L 10 10 M 10 0 L 0 10",
                                title: "Diagonal Grid",
                            },
                        ],
                        width: 50,
                    },
                    {
                        id: "series--fillColor-pattern-color",
                        pid: "series.fill",
                        dataType: "color",
                        context: "General",
                        defaults: "null",
                        parent: "series<area>",
                        subType: ["area"],
                        subTypeDefaults: {},
                        width: 25,
                    },
                    {
                        id: "series--dataSorting-enabled",
                        pid: "series.datasorting",
                        dataType: "boolean",
                        context: "General",
                        defaults: false,
                        subType: [
                            "gauge",
                            "arearange",
                            "areasplinerange",
                            "line",
                            "errorbar",
                            "boxplot",
                            "areaspline",
                            "spline",
                            "bar",
                            "scatter",
                            "polygon",
                            "bubble",
                            "area",
                            "column",
                        ],
                        subTypeDefaults: {
                            arearange: "null",
                            areasplinerange: "null",
                            line: "null",
                            errorbar: "null",
                            boxplot: "null",
                            areaspline: "null",
                            spline: "null",
                            bar: "null",
                            scatter: "null",
                            polygon: "null",
                            bubble: "null",
                            area: "null",
                            column: "null",
                        },
                    },
                    // {
                    //   id: 'series-label--enabled',
                    //   pid: 'series.label.enabled',
                    //   defaults: 'true',
                    //   dataType: 'boolean',
                    //   subType: [
                    //     'line',
                    //     'spline',
                    //     'area',
                    //     'arearange',
                    //     'areaspline',
                    //     'waterfall',
                    //     'areasplinerange'
                    //   ],
                    //   subTypeDefaults: {}
                    // }

                    // {
                    // id: 'series-label--style',
                    // pid: 'series.label.style',
                    // dataType: 'font'
                    // }
                ],
            },
        ],
        "option.cat.labels": [
            {
                id: "data-labels",
                text: "option.subcat.labels",
                options: [
                    {
                        id: "plotOptions-series-dataLabels--enabled",
                        pid: "plotOptions.series.dataLabels.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "plotOptions-series-dataLabels",
                    },
                    {
                        id: "plotOptions-series-dataLabels--style",
                        pid: "plotOptions.series.dataLabels.style",
                        dataType: "cssobject",
                        context: "General",
                        defaults:
                            '{"color": "contrast", "fontSize": "11px", "fontWeight": "bold", "textOutline": "1px 1px contrast" }',
                        parent: "plotOptions-series-dataLabels",
                    },
                    {
                        id: "plotOptions-pie--dataLabels-alignTo",
                        pid: "plotOptions.dataLabels.alignment",
                        dataType: "string",
                        context: "General",
                        values: ["connectors", "plotEdges"],
                        defaults: false,
                    },
                    {
                        id: "plotOptions-pie--dataLabels-connectorShape",
                        pid: "plotOptions.dataLabels.connectorShape",
                        dataType: "string",
                        context: "General",
                        values: ["straight", "fixedOffset", "crookedLine"],
                        defaults: false,
                    },
                    {
                        id: "plotOptions-pie--dataLabels-crookDistance",
                        pid: "plotOptions.dataLabels.crookDistance",
                        dataType: "string",
                        context: "General",
                        values: ["20%", "40%", "60%", "80%", "100%"],
                        defaults: false,
                    },
                ],
            },
        ],
        "option.cat.legend": [
            {
                text: "option.subcat.general",
                options: [
                    {
                        id: "legend--enabled",
                        pid: "legend.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "true",
                        parent: "legend",
                    },
                    {
                        id: "legend--layout",
                        pid: "legend.layout",
                        dataType: "string",
                        context: "General",
                        defaults: "horizontal",
                        parent: "legend",
                        values: '["horizontal", "vertical"]',
                    },
                ],
            },
            {
                text: "option.subcat.placement",
                options: [
                    {
                        id: "legend--align",
                        pid: "legend.align",
                        dataType: "string",
                        context: "General",
                        defaults: "center",
                        parent: "legend",
                        values: '["left", "center", "right"]',
                    },
                    {
                        id: "legend--x",
                        pid: "legend.x",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "legend",
                    },
                    {
                        id: "legend--verticalAlign",
                        pid: "legend.verticalAlign",
                        dataType: "string",
                        context: "General",
                        defaults: "bottom",
                        parent: "legend",
                        values: '["top", "middle", "bottom"]',
                    },
                    {
                        id: "legend--y",
                        pid: "legend.y",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "legend",
                    },
                    {
                        id: "legend--floating",
                        pid: "legend.floating",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "legend",
                    },
                ],
            },
            {
                text: "option.subcat.legendappearance",
                options: [
                    {
                        id: "legend--itemStyle",
                        dataType: "font",
                        pid: "legend.itemStyle",
                        context: "General",
                        defaults:
                            '{ "color": "#333333", "cursor": "pointer", "fontSize": "12px", "fontWeight": "bold" }',
                        parent: "legend",
                    },
                    {
                        id: "legend--itemHiddenStyle",
                        dataType: "font",
                        pid: "legend.itemHiddenStyle",
                        context: "General",
                        defaults: '{ "color": "#cccccc" }',
                        parent: "legend",
                    },
                    {
                        id: "legend--backgroundColor",
                        pid: "legend.backgroundColor",
                        dataType: "color",
                        context: "General",
                        parent: "legend",
                    },
                    {
                        id: "legend--borderWidth",
                        pid: "legend.borderWidth",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "legend",
                    },
                    {
                        id: "legend--borderRadius",
                        pid: "legend.borderRadius",
                        dataType: "number",
                        context: "General",
                        defaults: "0",
                        parent: "legend",
                    },
                    {
                        id: "legend--borderColor",
                        pid: "legend.borderColor",
                        dataType: "color",
                        context: "General",
                        defaults: "#999999",
                        parent: "legend",
                    },
                ],
            },
        ],
        "option.cat.tooltip": [
            {
                text: "option.subcat.general",
                options: [
                    {
                        id: "tooltip--enabled",
                        pid: "tooltip.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "true",
                        parent: "tooltip",
                    },
                    {
                        id: "tooltip--shared",
                        pid: "tooltip.shared",
                        dataType: "boolean",
                        context: "General",
                        defaults: "false",
                        parent: "tooltip",
                    },
                ],
            },
            {
                text: "option.subcat.colorborder",
                options: [
                    {
                        id: "tooltip--backgroundColor",
                        pid: "tooltip.backgroundColor",
                        dataType: "color",
                        context: "General",
                        defaults: "rgba(247,247,247,0.85)",
                        parent: "tooltip",
                    },
                    {
                        id: "tooltip--borderWidth",
                        custom: {
                            minValue: 0,
                        },
                        pid: "tooltip.borderWidth",
                        dataType: "number",
                        context: "General",
                        defaults: "1",
                        parent: "tooltip",
                    },
                    {
                        id: "tooltip--borderRadius",
                        custom: {
                            minValue: 0,
                        },
                        pid: "tooltip.borderRadius",
                        dataType: "number",
                        context: "General",
                        defaults: "3",
                        parent: "tooltip",
                    },
                    {
                        id: "tooltip--borderColor",
                        pid: "tooltip.borderColor",
                        dataType: "color",
                        context: "General",
                        defaults: "null",
                        parent: "tooltip",
                    },
                ],
            },
        ],
        "option.cat.exporting": [
            {
                text: "option.cat.exporting",
                options: [
                    {
                        id: "exporting--enabled",
                        pid: "exporting.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "true",
                        parent: "exporting",
                    },
                    {
                        id: "exporting--sourceWidth",
                        custom: {
                            minValue: 10,
                            maxValue: 2000,
                            step: 10,
                        },
                        pid: "exporting.sourceWidth",
                        dataType: "number",
                        context: "General",
                        parent: "exporting",
                        values: "",
                    },
                    {
                        id: "exporting--scale",
                        custom: {
                            minValue: 1,
                            maxValue: 4,
                        },
                        pid: "exporting.scale",
                        dataType: "number",
                        context: "General",
                        defaults: "2",
                        parent: "exporting",
                        values: "",
                    },
                ],
            },
        ],
        "option.cat.localization": [
            {
                text: "option.subcat.numberformat",
                options: [
                    {
                        id: "lang--decimalPoint",
                        pid: "lang.decimalPoint",
                        dataType: "string",
                        context: "General",
                        defaults: ".",
                        parent: "lang",
                    },
                    {
                        id: "lang--thousandsSep",
                        pid: "lang.thousandsSep",
                        dataType: "string",
                        context: "General",
                        defaults: " ",
                        parent: "lang",
                    },
                ],
            },
            {
                text: "option.subcat.exportbutton",
                options: [
                    {
                        id: "lang--contextButtonTitle",
                        pid: "lang.contextButtonTitle",
                        dataType: "string",
                        context: "General",
                        defaults: "Chart context menu",
                        parent: "lang",
                        values: "",
                    },
                    {
                        id: "lang--printChart",
                        pid: "lang.printChart",
                        dataType: "string",
                        context: "General",
                        defaults: "Print chart",
                        parent: "lang",
                        values: "",
                    },
                    {
                        id: "lang--downloadPNG",
                        pid: "lang.downloadPNG",
                        dataType: "string",
                        context: "General",
                        defaults: "Download PNG image",
                        parent: "lang",
                    },
                    {
                        id: "lang--downloadJPEG",
                        pid: "lang.downloadJPEG",
                        dataType: "string",
                        context: "General",
                        defaults: "Download JPEG image",
                        parent: "lang",
                    },
                    {
                        id: "lang--downloadPDF",
                        pid: "lang.downloadPDF",
                        dataType: "string",
                        context: "General",
                        defaults: "Download PDF document",
                        parent: "lang",
                    },
                    {
                        id: "lang--downloadSVG",
                        pid: "lang.downloadSVG",
                        dataType: "string",
                        context: "General",
                        defaults: "Download SVG vector image",
                        parent: "lang",
                    },
                ],
            },
            {
                text: "option.subcat.zoombutton",
                options: [
                    {
                        id: "lang--resetZoom",
                        pid: "lang.resetZoom",
                        dataType: "string",
                        context: "General",
                        defaults: "Reset zoom",
                        parent: "lang",
                    },
                ],
            },
        ],
        "option.cat.credits": [
            {
                text: "option.cat.credits",
                options: [
                    {
                        id: "credits--enabled",
                        pid: "credits.enabled",
                        dataType: "boolean",
                        context: "General",
                        defaults: "true",
                        parent: "credits",
                    },
                    {
                        id: "credits--text",
                        pid: "credits.text",
                        dataType: "string",
                        context: "General",
                        defaults: "Highcharts.com",
                        parent: "credits",
                    },
                    {
                        id: "credits--href",
                        pid: "credits.href",
                        dataType: "string",
                        context: "General",
                        defaults: "http://www.highcharts.com",
                        parent: "credits",
                    },
                ],
            },
        ],
    },
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.meta.colors = [
  //Red
  '#F44336',
  '#FFEBEE',
  '#FFCDD2',
  '#EF9A9A',
  '#E57373',
  '#EF5350',
  '#F44336',
  '#E53935',
  '#D32F2F',
  '#C62828',
  '#B71C1C',
  '#FF8A80',
  '#FF5252',
  '#FF1744',
  '#D50000',
  //Pink
  '#E91E63',
  '#FCE4EC',
  '#F8BBD0',
  '#F48FB1',
  '#F06292',
  '#EC407A',
  '#E91E63',
  '#D81B60',
  '#C2185B',
  '#AD1457',
  '#880E4F',
  '#FF80AB',
  '#FF4081',
  '#F50057',
  '#C51162',
  //Purple
  '#9C27B0',
  '#F3E5F5',
  '#E1BEE7',
  '#CE93D8',
  '#BA68C8',
  '#AB47BC',
  '#9C27B0',
  '#8E24AA',
  '#7B1FA2',
  '#6A1B9A',
  '#4A148C',
  '#EA80FC',
  '#E040FB',
  '#D500F9',
  '#AA00FF',
  //Deep Purple
  '#673AB7',
  '#EDE7F6',
  '#D1C4E9',
  '#B39DDB',
  '#9575CD',
  '#7E57C2',
  '#673AB7',
  '#5E35B1',
  '#512DA8',
  '#4527A0',
  '#311B92',
  '#B388FF',
  '#7C4DFF',
  '#651FFF',
  '#6200EA',
  //Indigo
  '#3F51B5',
  '#E8EAF6',
  '#C5CAE9',
  '#9FA8DA',
  '#7986CB',
  '#5C6BC0',
  '#3F51B5',
  '#3949AB',
  '#303F9F',
  '#283593',
  '#1A237E',
  '#8C9EFF',
  '#536DFE',
  '#3D5AFE',
  '#304FFE',
  //Blue
  '#2196F3',
  '#E3F2FD',
  '#BBDEFB',
  '#90CAF9',
  '#64B5F6',
  '#42A5F5',
  '#2196F3',
  '#1E88E5',
  '#1976D2',
  '#1565C0',
  '#0D47A1',
  '#82B1FF',
  '#448AFF',
  '#2979FF',
  '#2962FF',
  //Light Blue
  '#03A9F4',
  '#E1F5FE',
  '#B3E5FC',
  '#81D4FA',
  '#4FC3F7',
  '#29B6F6',
  '#03A9F4',
  '#039BE5',
  '#0288D1',
  '#0277BD',
  '#01579B',
  '#80D8FF',
  '#40C4FF',
  '#00B0FF',
  '#0091EA',
  //Cyan
  '#00BCD4',
  '#E0F7FA',
  '#B2EBF2',
  '#80DEEA',
  '#4DD0E1',
  '#26C6DA',
  '#00BCD4',
  '#00ACC1',
  '#0097A7',
  '#00838F',
  '#006064',
  '#84FFFF',
  '#18FFFF',
  '#00E5FF',
  '#00B8D4',
  //Teal
  '#009688',
  '#E0F2F1',
  '#B2DFDB',
  '#80CBC4',
  '#4DB6AC',
  '#26A69A',
  '#009688',
  '#00897B',
  '#00796B',
  '#00695C',
  '#004D40',
  '#A7FFEB',
  '#64FFDA',
  '#1DE9B6',
  '#00BFA5',
  //Green
  '#4CAF50',
  '#E8F5E9',
  '#C8E6C9',
  '#A5D6A7',
  '#81C784',
  '#66BB6A',
  '#4CAF50',
  '#43A047',
  '#388E3C',
  '#2E7D32',
  '#1B5E20',
  '#B9F6CA',
  '#69F0AE',
  '#00E676',
  '#00C853',
  //Light Green
  '#8BC34A',
  '#F1F8E9',
  '#DCEDC8',
  '#C5E1A5',
  '#AED581',
  '#9CCC65',
  '#8BC34A',
  '#7CB342',
  '#689F38',
  '#558B2F',
  '#33691E',
  '#CCFF90',
  '#B2FF59',
  '#76FF03',
  '#64DD17',
  //Lime
  '#CDDC39',
  '#F9FBE7',
  '#F0F4C3',
  '#E6EE9C',
  '#DCE775',
  '#D4E157',
  '#CDDC39',
  '#C0CA33',
  '#AFB42B',
  '#9E9D24',
  '#827717',
  '#F4FF81',
  '#EEFF41',
  '#C6FF00',
  '#AEEA00',
  //Yellow
  '#FFEB3B',
  '#FFFDE7',
  '#FFF9C4',
  '#FFF59D',
  '#FFF176',
  '#FFEE58',
  '#FFEB3B',
  '#FDD835',
  '#FBC02D',
  '#F9A825',
  '#F57F17',
  '#FFFF8D',
  '#FFFF00',
  '#FFEA00',
  '#FFD600',
  //Amber
  '#FFC107',
  '#FFF8E1',
  '#FFECB3',
  '#FFE082',
  '#FFD54F',
  '#FFCA28',
  '#FFC107',
  '#FFB300',
  '#FFA000',
  '#FF8F00',
  '#FF6F00',
  '#FFE57F',
  '#FFD740',
  '#FFC400',
  '#FFAB00',
  //Orange
  '#FF9800',
  '#FFF3E0',
  '#FFE0B2',
  '#FFCC80',
  '#FFB74D',
  '#FFA726',
  '#FF9800',
  '#FB8C00',
  '#F57C00',
  '#EF6C00',
  '#E65100',
  '#FFD180',
  '#FFAB40',
  '#FF9100',
  '#FF6D00',
  //Deep Orange
  '#FF5722',
  '#FBE9E7',
  '#FFCCBC',
  '#FFAB91',
  '#FF8A65',
  '#FF7043',
  '#FF5722',
  '#F4511E',
  '#E64A19',
  '#D84315',
  '#BF360C',
  '#FF9E80',
  '#FF6E40',
  '#FF3D00',
  '#DD2C00',
  //Brown
  '#795548',
  '#EFEBE9',
  '#D7CCC8',
  '#BCAAA4',
  '#A1887F',
  '#8D6E63',
  '#795548',
  '#6D4C41',
  '#5D4037',
  '#4E342E',
  '#3E2723',
  '#3E2723',
  '#3E2723',
  '#3E2723',
  '#3E2723',
  //Grey
  '#9E9E9E',
  '#FAFAFA',
  '#F5F5F5',
  '#EEEEEE',
  '#E0E0E0',
  '#BDBDBD',
  '#9E9E9E',
  '#757575',
  '#616161',
  '#424242',
  '#212121',
  '#212121',
  '#212121',
  '#212121',
  //Blue Grey
  '#607D8B',
  '#ECEFF1',
  '#CFD8DC',
  '#B0BEC5',
  '#90A4AE',
  '#78909C',
  '#607D8B',
  '#546E7A',
  '#455A64',
  '#37474F',
  '#37474F',
  '#37474F',
  '#37474F',
  '#263238'
];

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.meta.fonts = [
  '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
  'Courier',
  'Arial',
  'Verdana',
  'Georgia',
  'Palatino Linotype',
  'Times New Roman',
  'Comic Sans MS',
  'Impact',
  'Lucida Sans Unicode',
  'Tahoma',
  'Lucida Console',
  'Courier New',
  'Monaco',
  'Monospace'
];

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

highed.highchartsErrors = {
  // Plotting zero or subzero value on a log axis
  10: {
    title: "Can't plot zero or subzero values on a logarithmic axis",
    text:
      'This error occurs in the following situations:<ul><li>If a zero or subzero data value is added to a logarithmic axis</li><li>If the minimum of a logarithimic axis is set to 0 or less</li><li>If the threshold is set to 0 or less</li></ul>As of Highcharts 5.0.8 it is possible to bypass this error message by setting <code>Axis.prototype.allowNegativeLog</code> to<code>true</code> and add custom conversion functions. <ahref="http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/samples/highcharts/yaxis/type-log-negative/">View live demo</a>.'
  },
  // Can't link axes of different types
  11: { title: "Can't link axes of different type", text: '' },
  // series.data needs to be arrays or numbers when in turbo mode
  12: {
    title:
      'Highcharts expects point configuration to be numbers or arrays in turbo mode',
    text: ''
  },
  // Rendering div not found
  13: { title: 'Rendering div not found', text: '' },
  // Expected number, got string
  14: { title: 'String value sent to series.data, expected Number', text: '' },
  // Expected sorted data, got non-sorted
  15: {
    title: 'Highcharts expects data to be sorted',
    text:
      'The data passed to your chart needs to be sorted. If you\'re using the datagrid, you can sort your data by clicking the arrow in the x-axis column header, and selecting "Sort Ascending"'
  },
  // Highcharts already defined
  16: { title: 'Highcharts already defined in the page', text: '' },
  // Requested type doesn't exist
  17: { title: 'The requested series type does not exist', text: '' },
  // Requested axis doesn't exist
  18: {
    title: 'The requested axis does not exist',
    text:
      'Make sure that your only references existing axis in the series properties.'
  },
  // Too many ticks (use bug spray)
  19: { title: 'Too many ticks', text: '' },
  // Can't add point config to a long data series
  20: {
    title: "Can't add object point configuration to a long data series",
    text: ''
  },
  // Can't find Proj4js library
  21: { title: "Can't find Proj4js library", text: '' },
  // Map does not support lat/long
  22: { title: 'Map does not support latitude/longitude', text: '' },
  // Unsupported color format used for color
  23: {
    title: 'Unsupported color format used for color interpolation',
    text: ''
  },
  // Cannot run Point.update on a grouped point
  24: { title: 'Cannot run Point.update on a grouped point', text: '' },
  // Can't find moment.js
  25: { title: "Can't find Moment.js library", text: '' },
  // WebGL not supported
  26: {
    title: 'WebGL not supported, and no fallback module included',
    text: ''
  },
  // Browser does not support SVG
  27: { title: 'This browser does not support SVG.', text: '' }
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** UI for selecting a chart template from the ones defined in meta/highed.meta.charts.js
 *
 *  @example
 *  var picker = highed.ChartTemplateSelector(document.body);
 *  picker.on('Select', function (template) {
 *      console.log('Selected new template:', template);
 *  });
 *
 *  @constructor
 *
 *  @param parent {domnode} - the parent to attach the selector to
 *
 *  @emits Select - when selecting a template
 *    > {object} - the template definition
 *  @emits Hover - when hovering a template
 *    > {object} - the template definition
 */
highed.ChartTemplateSelector = function(parent, chartPreview) {
  var events = highed.events(),
    container = highed.dom.cr('div', 'highed-chart-templates'),
    splitter = highed.HSplitter(container, { leftWidth: 30 }),
    list = highed.List(splitter.left),
    templates = splitter.right,
    catNode = highed.dom.cr('div', 'highed-chart-template-cat-desc'),
    selected = false;

  highed.dom.ap(parent, container);
  splitter.right.className += ' highed-chart-template-frame';

  ///////////////////////////////////////////////////////////////////////////

  function createSampleBtn(target, sample) {
    var btn,
      dset = highed.samples.get(sample);

    if (!dset) {
      return;
    }

    btn = highed.dom.cr('div', 'highed-ok-button', dset.title);

    highed.dom.on(btn, 'click', function() {
      if (
        confirm(
          'You are about to load the ' +
            dset.title +
            ' sample set. This will purge any existing data in the chart. Continue?'
        )
      ) {
        events.emit('LoadDataSet', dset);
      }
    });

    highed.dom.ap(target, btn);
  }

  function buildCatMeta(catmeta) {
    var title = highed.dom.cr('h3', '', catmeta.id),
      desc = highed.dom.cr('div'),
      samples = highed.dom.cr('div');

    desc.innerHTML = highed.isArr(catmeta.description)
      ? catmeta.description.join('<br/><br/>')
      : catmeta.description || '';

    if (catmeta.samples && catmeta.samples.length > 0) {
      highed.dom.ap(samples, highed.dom.cr('h4', '', 'Sample Data Sets'));

      catmeta.samples.forEach(function(sample) {
        createSampleBtn(samples, sample);
      });
    }

    highed.dom.ap(catNode, title, desc, samples);
  }

  function showTemplates(templateList, masterID, catmeta) {
    var compatible = 0;

    templates.innerHTML = '';
    catNode.innerHTML = '';

    if (catmeta) {
      buildCatMeta(catmeta);
    }

    highed.dom.ap(templates, catNode);

    Object.keys(templateList).forEach(function(key) {
      var t = templateList[key],
        node = highed.dom.cr('div', 'highed-chart-template-container'),
        body = highed.dom.cr('div', 'highed-chart-template-body'),
        preview = highed.dom.cr('div', 'highed-chart-template-thumbnail'),
        titleBar = highed.dom.cr('div', 'highed-chart-template-title', t.title),
        description = highed.dom.cr('div', 'highed-chart-template-description'),
        samples = highed.dom.cr('div', 'highed-chart-template-samples');

      if (t.validator) {
        if (!highed.validators.validate(t.validator, chartPreview || false)) {
          return;
        }
      }

      compatible++;

      (highed.isArr(t.sampleSets)
        ? t.sampleSets
        : (t.sampleSets || '').split('.')
      ).forEach(function(sample, i) {
        if (i === 0) {
          highed.dom.ap(samples, highed.dom.cr('h4', '', 'Sample Data Sets'));
        }

        createSampleBtn(samples, sample);
      });

      description.innerHTML = highed.isArr(t.description)
        ? t.description.join('<br/><br/>')
        : t.description;

      if (selected && selected.id === masterID + key + t.title) {
        node.className =
          'highed-chart-template-container highed-chart-template-preview-selected';
        selected.node = node;
      }

      if (highed.meta.images && highed.meta.images[t.thumbnail]) {
        highed.dom.style(preview, {
          'background-image':
            'url("data:image/svg+xml;utf8,' +
            highed.meta.images[t.thumbnail] +
            '")'
        });
      } else {
        highed.dom.style(preview, {
          'background-image':
            'url(' + highed.option('thumbnailURL') + t.thumbnail + ')'
        });
      }

      highed.dom.on(node, 'click', function() {
        if (selected) {
          selected.node.className = 'highed-chart-template-container';
        }

        node.className =
          'highed-chart-template-container highed-chart-template-preview-selected';

        selected = {
          id: masterID + key + t.title,
          node: node
        };

        // If this is a map, we need to include the map collection
        if (t.constructor === 'Map') {
          var loadedSeries = 0;

          (t.config.series || []).forEach(function(series) {
            function incAndCheck() {
              loadedSeries++;
              if (loadedSeries === t.config.series.length) {
                events.emit('Select', t);
              }
            }

            if (series.mapData) {
              if (highed.isStr(series.mapData)) {
                highed.include(
                  'https://code.highcharts.com/mapdata/' +
                    series.mapData +
                    '.js',
                  function() {
                    series.mapData = Highcharts.maps[series.mapData];
                    incAndCheck();
                  }
                );
              } else {
                incAndCheck();
              }
            } else {
              incAndCheck();
            }
          });
        } else {
          events.emit('Select', t);
        }

        highed.emit('UIAction', 'TemplateChoose', t.title);
      });

      highed.dom.ap(
        templates,
        highed.dom.ap(
          node,
          preview,
          highed.dom.ap(
            body,
            titleBar,
            description,
            // highed.dom.cr('h4', '', 'Sample Data Sets'),
            samples
          )
        )
      );
    });

    if (compatible === 0) {
      highed.dom.ap(
        templates,
        highed.dom.ap(
          highed.dom.cr('div', 'highed-chart-template-404'),
          highed.dom.cr(
            'h4',
            '',
            'None of the templates in this category fits your dataset.'
          ),
          highed.dom.cr('div', '', catmeta ? catmeta.nofits || '' : '')
        )
      );
    } else {
      highed.dom.ap(
        catNode,
        highed.dom.cr(
          'h3',
          'highed-template-choose-text',
          'Choose a template below by clicking it'
        )
      );
    }
  }

  /* Force a resize */
  function resize(w, h) {
    var lsize;

    splitter.resize(w, h);
    list.resize();

    lsize = highed.dom.size(list.container);
    highed.dom.style(templates, {
      minHeight: lsize.h + 'px'
    });
  }

  /* Build the UI */
  function build() {
    list.addItems(highed.templates.getCatArray());
    list.selectFirst();
  }

  ///////////////////////////////////////////////////////////////////////////

  list.on('Select', function(id) {
    var templates = highed.templates.getAllInCat(id);

    highed.emit('UIAction', 'TemplateCatChoose', id);

    if (templates) {
      showTemplates(templates, id, highed.templates.getCatInfo(id));
    }
  });

  build();

  ///////////////////////////////////////////////////////////////////////////

  return {
    on: events.on,
    resize: resize,
    rebuild: build
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Create an instance of the default context menu
 *  This is shared accross the simple and full editor.
 *  @constructor
 *  @param chartPreview {highed.ChartPreview} - the chart preview for the menu
 */
highed.DefaultContextMenu = function(chartPreview) {
  var events = highed.events(),
    cmenu = highed.ContextMenu([
      {
        title: highed.getLocalizedStr('previewChart'),
        icon: 'bar-chart',
        click: function() {
          chartPreview.expand();
        }
      },
      '-',
      {
        title: highed.getLocalizedStr('newChart'),
        icon: 'file-o',
        click: function() {
          if (window.confirm(highed.getLocalizedStr('confirmNewChart'))) {
            chartPreview.new();
            events.emit('NewChart');
          }
        }
      },
      '-',
      {
        title: highed.getLocalizedStr('saveProject'),
        icon: 'floppy-o',
        click: function() {
          highed.download('chart.json', chartPreview.toProjectStr());
        }
      },
      {
        title: highed.getLocalizedStr('loadProject'),
        icon: 'folder-open-o',
        click: function() {
          highed.readLocalFile({
            type: 'text',
            accept: '.json',
            success: function(file) {
              try {
                file = JSON.parse(file.data);
              } catch (e) {
                return highed.snackBar('Error loading JSON: ' + e);
              }

              chartPreview.loadProject(file);
            }
          });
        }
      },
      '-',
      {
        title: 'Save to Cloud',
        icon: 'upload',
        click: function() {
          highed.cloud.save(chartPreview);
        }
      },
      {
        title: highed.getLocalizedStr('loadCloud'),
        icon: 'cloud',
        click: function() {
          highed.cloud.showUI(chartPreview);
        }
      },
      '-',
      {
        title: highed.getLocalizedStr('exportPNG'),
        icon: 'file-image-o',
        click: function() {
          chartPreview.data.export({});
        }
      },
      {
        title: highed.getLocalizedStr('exportJPEG'),
        icon: 'file-image-o',
        click: function() {
          chartPreview.data.export({ type: 'image/jpeg' });
        }
      },
      {
        title: highed.getLocalizedStr('exportSVG'),
        icon: 'file-image-o',
        click: function() {
          chartPreview.data.export({ type: 'image/svg+xml' });
        }
      },
      {
        title: highed.getLocalizedStr('exportPDF'),
        icon: 'file-pdf-o',
        click: function() {
          chartPreview.data.export({ type: 'application/pdf' });
        }
      },
      '-',
      {
        title: highed.getLocalizedStr('help'),
        icon: 'question-circle',
        click: function() {
          window.open(highed.option('helpURL'));
        }
      } //,
      // {
      //     title: highed.getLocalizedStr('licenseInfo'),
      //     icon: 'key',
      //     click: function () {
      //         highed.licenseInfo.show();
      //     }
      // }
    ]);

  return {
    on: events.on,
    show: cmenu.show
  };
};

/******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** UI For customizing a chart
 *  @todo there be dragons here.
 *  @example
 *  var chart = highed.ChartCustomizer(document.body, {}, chartPreview);
 *
 *  @constructor
 *
 *  @emits PropertyChange - when a property changes
 *    > {string} - the path of the change
 *    > {anything} - the new value
 *    > {number} - the change array index
 *
 *  @param parent {domnode} - the node to attach the editor to
 *  @param attributes {object} - the attributes
 *    > noAdvanced {bool} - set to true to force disable the advance view
 *    > noCustomCode {bool} - set to true to disable custom code view
 *    > noPreview {bool} - set to true to disable option preview view
 *    > availableSettings {string|array} - whitelist of exposed settings
 *  @param chartPreview {ChartPreview} - the chart preview instance
 */
highed.ChartCustomizer = function(parent, attributes, chartPreview) {
  var properties = highed.merge(
      {
        noAdvanced: false,
        noCustomCode: false,
        noPreview: false,
        availableSettings: []
      },
      attributes
    ),
    events = highed.events(),
    advancedLoader = highed.dom.cr(
      'div',
      'highed-customizer-adv-loader',
      'Loading...'
    ),
    tabs = highed.TabControl(parent, true),
    simpleTab = tabs.createTab({
      title: highed.getLocalizedStr('customizeSimple')
    }),
    advancedTab = tabs.createTab({
      title: highed.getLocalizedStr('customizeAdvanced')
    }),
    customCodeTab = tabs.createTab({
      title: highed.getLocalizedStr('customizeCustomCode')
    }),
    outputPreviewTab = tabs.createTab({
      title: highed.getLocalizedStr('customizePreview')
    }),
    previewEditor = highed.dom.cr(
      'textarea',
      'highed-custom-code highed-box-size highed-stretch'
    ),
    previewCodeMirror = false,
    splitter = highed.HSplitter(simpleTab.body, {
      leftWidth: 20,
      responsive: true
    }),
    list = highed.List(splitter.left, true),
    body = splitter.right,
    advSplitter = highed.HSplitter(advancedTab.body, {
      leftWidth: 30
    }),
    advBody = advSplitter.right,
    advTree = highed.Tree(advSplitter.left),
    flatOptions = {},
    chartOptions = {},
    customCodeSplitter = highed.VSplitter(customCodeTab.body, {
      topHeight: 90,
      noOverflow: true
    }),
    customCodeDebug = highed.dom.cr('pre', 'highed-custom-debug'),
    codeMirrorBox = false,
    customCodeBox = highed.dom.cr(
      'textarea',
      'highed-custom-code highed-box-size highed-stretch'
    ),
    highlighted = false;

  //If we're on mobile, completely disable the advanced view
  if (highed.onPhone()) {
    properties.noAdvanced = true;
    properties.noCustomCode = true;
    properties.noPreview = true;
  }

  body.className += ' highed-customizer-body';

  properties.availableSettings = highed.arrToObj(properties.availableSettings);

  highed.dom.ap(parent, advancedLoader);
  highed.dom.ap(outputPreviewTab.body, previewEditor);

  ///////////////////////////////////////////////////////////////////////////

  advancedTab.on('Focus', function() {
    buildTree();
  });

  outputPreviewTab.on('Focus', function() {
    var prev = chartPreview.options.getPreview();

    if (!previewCodeMirror && typeof window.CodeMirror !== 'undefined') {
      previewCodeMirror = CodeMirror.fromTextArea(previewEditor, {
        lineNumbers: true,
        mode: 'application/javascript',
        theme: highed.option('codeMirrorTheme'),
        readOnly: true
      });

      previewCodeMirror.setSize('100%', '100%');
    }

    if (previewCodeMirror) {
      previewCodeMirror.setValue(prev);
    } else {
      previewEditor.readonly = true;
      previewEditor.value = prev;
    }
  });

  function loadCustomCode() {
    var code;

    if (chartPreview) {
      code = chartPreview.getCustomCode() || '';
      if (codeMirrorBox) {
        codeMirrorBox.setValue(code);
      } else {
        customCodeBox.value = code;
      }
    }
  }

  /**
   * Init the custom code stuff
   */
  function initCustomCode() {
    // Build the custom code tab
    highed.dom.ap(customCodeSplitter.top, customCodeBox);

    highed.dom.ap(customCodeSplitter.bottom, customCodeDebug);

    function setCustomCode() {
      highed.emit('UIAction', 'CustomCodeUpdate');
      customCodeDebug.innerHTML = '';
      if (chartPreview) {
        chartPreview.setCustomCode(
          codeMirrorBox ? codeMirrorBox.getValue() : customCodeBox.value,
          function(err) {
            customCodeDebug.innerHTML = err;
          }
        );
      }
    }

    if (typeof window['CodeMirror'] !== 'undefined') {
      codeMirrorBox = CodeMirror.fromTextArea(customCodeBox, {
        lineNumbers: true,
        mode: 'application/javascript',
        theme: highed.option('codeMirrorTheme')
      });
      codeMirrorBox.setSize('100%', '100%');
      codeMirrorBox.on('change', setCustomCode);
    } else {
      highed.dom.on(customCodeBox, 'change', function() {
        setCustomCode();
      });
    }
  }

  /** Force a resize of the editor
   *  @memberof highed.ChartCustomizer
   *  @param w {number} - the new width
   *  @param h {number} - the new height
   */
  function resize(w, h) {
    var bsize, lsize;

    tabs.resize(w, h);
    bsize = tabs.barSize();

    list.resize(w, h - bsize.h);
    splitter.resize(w, h - bsize.h - 10);

    //The customize body needs to have a min-height of the list height
    lsize = highed.dom.size(list.container);

    highed.dom.style(body, {
      minHeight: lsize.h + 'px'
    });

    customCodeSplitter.resize(w, h);

    if (codeMirrorBox) {
      codeMirrorBox.refresh();
    }
  }

  /** Init the customizer
   *  @memberof highed.ChartCustomizer
   *  @param foptions {object} - the customized options
   *  @param coptions {object} - the full chart options
   */
  function init(foptions, coptions, chartp) {
    flatOptions = coptions || {};
    chartOptions = highed.merge({}, foptions || {});
    list.reselect();
    // buildTree();
    chartPreview = chartp || chartPreview;

    customCodeSplitter.resize();
    loadCustomCode();
  }

  function buildBody(entry) {}

  function applyFilter(detailIndex, filteredBy, filter) {
    var selected = list.selected(),
      id = selected.id,
      entry = highed.meta.optionsExtended.options[id];

    if (!selected) return false;

    body.innerHTML = '';

    entry.forEach(function(thing) {
      selectGroup(thing, false, false, detailIndex, filteredBy, filter);
    });

    highlighted = false;
  }

  function shouldInclude(group) {
    var doInclude = false;

    if (Object.keys(properties.availableSettings || {}).length > 0) {
      if (highed.isArr(group)) {
        group.forEach(function(sub) {
          if (shouldInclude(sub)) {
            doInclude = true;
          }
        });
      } else if (highed.isArr(group.options)) {
        group.options.forEach(function(sub) {
          if (shouldInclude(sub)) {
            doInclude = true;
          }
        });
      } else if (
        properties.availableSettings[group.id] ||
        properties.availableSettings[group.pid]
      ) {
        doInclude = true;
      }

      return doInclude;
    }

    return true;
  }

  //This function has mutated into a proper mess. Needs refactoring.
  function selectGroup(group, table, options, detailIndex, filteredBy, filter) {
    var master,
      vals,
      doInclude = true,
      container,
      masterNode,
      def;

    options = chartPreview.options.getCustomized();

    if (highed.isArr(group.options)) {
      table = highed.dom.cr('table', 'highed-customizer-table');

      doInclude = shouldInclude(group);

      if (!doInclude) {
        return;
      }

      container = highed.dom.cr('div', 'highed-customize-group');
      masterNode = highed.dom.cr('div', 'highed-customize-master-dropdown');

      highed.dom.ap(
        body,
        highed.dom.ap(
          container,
          highed.dom.cr(
            'div',
            'highed-customizer-table-heading',
            highed.L(group.text)
          ),
          masterNode,
          table
        )
      );

      if (group.filteredBy) {
        filter = highed.getAttr(options, group.filteredBy, detailIndex);
      }

      if (group.controlledBy) {
        master = highed.DropDown();
        highed.dom.style(masterNode, {
          display: 'block'
        });

        if (highed.isStr(group.controlledBy.options)) {
          vals = highed.getAttr(
            options,
            group.controlledBy.options,
            detailIndex
          );

          if (highed.isArr(vals)) {
            if (vals.length === 0) {
              highed.dom.ap(
                body,
                highed.dom.cr('i', '', 'No data to display..')
              );
              return;
            }

            master.addItems(
              vals.map(function(t, i) {
                return (
                  (group.controlledBy.optionsTitle
                    ? t[group.controlledBy.optionsTitle]
                    : '#' + (i + 1)) || '#' + (i + 1)
                );
              })
            );

            master.selectByIndex(detailIndex || 0);

            master.on('Change', function(selected) {
              detailIndex = selected.index();

              table.innerHTML = '';

              group.options.forEach(function(sub) {
                if (group.filteredBy) {
                  filter = highed.getAttr(
                    options,
                    group.filteredBy,
                    detailIndex
                  );
                }
                selectGroup(
                  sub,
                  table,
                  options,
                  detailIndex,
                  group.filteredBy,
                  filter
                );
              });
            });

            highed.dom.ap(masterNode, master.container);
            detailIndex = detailIndex || 0;
          } else {
            return;
          }
        }
      }

      //highed.dom.ap(body, table);

      group.options.forEach(function(sub) {
        selectGroup(sub, table, options, detailIndex, group.filteredBy, filter);
      });
    } else if (typeof group.id !== 'undefined') {
      //Check if we should filter out this column
      if (filter && group.subType && group.subType.length) {
        if (!highed.arrToObj(group.subType)[filter]) {
          return;
        }
      }

      if (Object.keys(properties.availableSettings || {}).length > 0) {
        if (
          !properties.availableSettings[group.id] &&
          !properties.availableSettings[group.pid]
        ) {
          return;
        }
      }

      if (typeof group.dataIndex !== 'undefined') {
        detailIndex = group.dataIndex;
      }

      def = highed.getAttr(options, group.id, detailIndex);

      //highed.dom.ap(sub, highed.dom.cr('span', '', referenced[0].returnType));
      highed.dom.ap(
        table,
        highed.InspectorField(
          group.values ? 'options' : group.dataType,
          typeof def !== 'undefined'
            ? def
            : filter && group.subTypeDefaults[filter]
              ? group.subTypeDefaults[filter]
              : group.defaults,
          {
            title: highed.L('option.text.' + group.pid),
            tooltip: highed.L('option.tooltip.' + group.pid),
            values: group.values,
            custom: group.custom,
            defaults: group.defaults,
            attributes: group.attributes || []
          },
          function(newValue) {
            events.emit('PropertyChange', group.id, newValue, detailIndex);
            highed.emit(
              'UIAction',
              'SimplePropSet',
              highed.L('option.text.' + group.pid),
              newValue
            );

            if (group.id === filteredBy) {
              //This is a master for the rest of the childs,
              //which means that we need to rebuild everything
              //here somehow and check their subType
              applyFilter(detailIndex, filteredBy, newValue);
            }
          },
          false,
          group.id
        )
      );
    }
  }

  function buildTree() {
    if (properties.noAdvanced) {
      return;
    }

    highed.dom.style(advancedLoader, {
      opacity: 1
    });

    if (properties.noAdvanced || highed.isNull(highed.meta.optionsAdvanced)) {
      advancedTab.hide();
    } else {
      setTimeout(function() {
        highed.meta.optionsAdvanced = highed.transform.advanced(
          highed.meta.optionsAdvanced,
          true
        );

        advTree.build(
          highed.meta.optionsAdvanced,
          highed.merge({}, chartPreview.options.getCustomized())
        );

        highed.dom.style(advancedLoader, {
          opacity: 0
        });
      }, 10);
    }
  }

  function build() {
    Object.keys(highed.meta.optionsExtended.options).forEach(function(key) {
      if (!shouldInclude(highed.meta.optionsExtended.options[key])) {
        return;
      }

      list.addItem({
        id: key,
        title: highed.L(key)
      });
    });

    // buildTree();
  }

  //Highlight a node
  function highlightNode(n, x, y) {
    if (!n) return;

    var p = highed.dom.pos(n);

    if (!simpleTab.selected) {
      simpleTab.focus();
    }

    n.focus();
    n.scrollIntoView({
      inline: 'nearest'
    });

    // Draw a dot where the item was clicked
    var attention = highed.dom.cr('div', 'highed-attention');
    highed.dom.style(attention, {
      width: '10px',
      height: '10px',
      left: x - 5 + 'px',
      top: y - 5 + 'px',
      borderRadius: '50%'
    });
    highed.dom.ap(document.body, attention);

    // Animate it to the corresponding element
    var pos = Highcharts.offset(n);

    var bgColor = n.style.backgroundColor;
    highed.dom.style(attention, {
      width: n.clientWidth + 'px',
      height: n.clientHeight + 'px',
      borderRadius: 0,
      left: pos.left + 'px',
      top: pos.top + 'px'
    });
    window.setTimeout(function() {
      highed.dom.style(n, {
        backgroundColor: window.getComputedStyle(attention).backgroundColor,
        transition: '1s ease background-color'
      });

      attention.parentNode.removeChild(attention);
      attention = null;

      window.setTimeout(function() {
        highed.dom.style(n, {
          backgroundColor: bgColor
        });
      }, 250);
    }, 350);
  }

  //////////////////////////////////////////////////////////////////////////////
  // P U B L I C  F U N S

  /** Highlight a field in the customizer
   *  @memberof highed.ChartCustomizer
   *  @param id {string} - is the id of the field to highlight
   *  @param x {number} - the x coordinate where the focus was triggered
   *  @param y {number} - the y coordinate where the focus was triggered
   */
  function highlightField(id, x, y) {
    if (id.indexOf('-') >= 0) {
      var n = advSplitter.left.querySelector(
        '#' + id.substr(0, id.indexOf('-'))
      );

      highlightNode(body.querySelector('#' + id), x, y);
      highlightNode(advSplitter.right.querySelector('#' + id));

      if (n) {
        n.scrollIntoView({
          block: 'end'
        });
      }
    }
  }

  /** Focus a category
   *  @memberof highed.ChartCustomizer
   *  @param thing {anything} - the category to focus
   *  @param x {number} - the x coordinate where the focus was triggered
   *  @param y {number} - the y coordinate where the focus was triggered
   */
  function focus(thing, x, y) {
    var n;

    list.select(thing.tab);
    advTree.expandTo(thing.id);
    highlightField(thing.id, x, y);
  }

  ///////////////////////////////////////////////////////////////////////////

  list.on('Select', function(id) {
    var entry = highed.meta.optionsExtended.options[id];
    body.innerHTML = '';
    entry.forEach(function(thing) {
      selectGroup(thing);
    });
    highlighted = false;
    highed.emit('UIAction', 'SimplePropCatChoose', id);
  });

  function buildAdvTree(item, selected, instancedData, filter, propFilter) {
    var table = highed.dom.cr('table', 'highed-customizer-table'),
      componentCount = 0;

    advBody.innerHTML = '';

    if (properties.noAdvanced) {
      return;
    }

    item.children.forEach(function(entry) {
      if (!entry.meta.leafNode) {
        return;
      }

      // Skip functions for now
      if (Object.keys(entry.meta.types)[0] === 'function') {
        return;
      }

      if (propFilter && entry.meta.validFor) {
        if (!entry.meta.validFor[propFilter]) {
          // console.log('filtered', entry.meta.name, 'based on', propFilter);
          return false;
        }
      }

      if (
        filter &&
        entry.meta.products &&
        Object.keys(entry.meta.products) > 0 &&
        !entry.meta.products[filter]
      ) {
        return;
      }

      componentCount++;

      entry.values = entry.meta.enumValues;

      highed.dom.ap(
        table,
        highed.InspectorField(
          entry.values
            ? 'options'
            : Object.keys(entry.meta.types)[0] || 'string',
          typeof instancedData[entry.meta.name] !== 'undefined'
            ? instancedData[entry.meta.name]
            : entry.meta.default, //(highed.getAttr(chartOptions, entry.id)  || entry.defaults),
          {
            title: highed.uncamelize(entry.meta.name),
            tooltip: entry.meta.description,
            values: entry.meta.enumValues,
            defaults: entry.meta.default,
            custom: {},
            attributes: entry.attributes || []
          },
          function(newValue) {
            highed.emit(
              'UIAction',
              'AdvancedPropSet',
              (entry.meta.ns ? entry.meta.ns + '.' : '') + highed.uncamelize(entry.meta.name),
              newValue
            );
            instancedData[entry.meta.name] = newValue;
            events.emit('PropertySetChange', advTree.getMasterData());
            if (advTree.isFilterController(entry.meta.ns, entry.meta.name)) {
              buildTree();
            }
          },
          false,
          entry.id
        )
      );
    });

    highed.dom.ap(
      advBody,
      highed.dom.ap(
        highed.dom.cr('div', 'highed-customize-group'),
        highed.dom.cr('div', 'highed-customizer-table-heading', selected),
        table
      )
    );
  }

  advTree.on('ForceSave', function(data) {
    events.emit('PropertySetChange', data);
  });

  advTree.on('ClearSelection', function() {
    advBody.innerHTML = '';
  });

  advTree.on('Select', buildAdvTree);

  advTree.on('DataUpdate', function(path, data) {
    events.emit('PropertyChange', path, data);
  });

  advTree.on('Dirty', function() {
    init(flatOptions, chartOptions);
  });

  tabs.on('Focus', function() {
    init(flatOptions, chartOptions);
  });

  build();
  initCustomCode();

  if (properties.noCustomCode) {
    customCodeTab.hide();
  }

  if (properties.noAdvanced) {
    advancedTab.hide();
  }

  if (properties.noPreview) {
    outputPreviewTab.hide();
  }

  return {
    /* Listen to an event */
    on: events.on,
    resize: resize,
    init: init,
    focus: focus,
    reselect: list.reselect,
    highlightField: highlightField
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** This is a component that implements a toolbar with wizard steps
 * Proxies the interface of the WizardStepper object.
 * @constructor
 * @emits Step - when stepping back or forth
 * @emits AddStep - when adding a step to the stepper
 * @param parent {domnode} - the dom node to attach the UI to
 * @param bodyParent {domnode} - the dom node to attach the stepper body to
 * @param attributes {object} - options for the object
 */
highed.WizardBar = function(parent, bodyParent, attributes) {
  var toolbar = highed.Toolbar(parent, {
      additionalCSS: ['highed-wizstepper-bar']
    }),
    stepper = highed.WizardStepper(bodyParent, toolbar.center),
    next = highed.dom.cr(
      'span',
      'highed-wizstepper-next-prev fa fa-arrow-right'
    ),
    previous = highed.dom.cr(
      'span',
      'highed-wizstepper-next-prev fa fa-arrow-left'
    );

  ///////////////////////////////////////////////////////////////////////////

  function handleStepEvent(step, count) {
    if (step.number > 1) {
      highed.dom.style(previous, {
        opacity: 1,
        'pointer-events': 'auto',
        visibility: 'visible'
      });
    } else {
      highed.dom.style(previous, {
        opacity: 0,
        'pointer-events': 'none',
        visibility: 'hidden'
      });
    }

    if (step.number < count) {
      highed.dom.style(next, {
        opacity: 1,
        'pointer-events': 'auto',
        visibility: 'visible'
      });
    } else {
      highed.dom.style(next, {
        opacity: 0,
        'pointer-events': 'none',
        visibility: 'hidden'
      });
    }
  }

  stepper.on('Step', handleStepEvent);
  stepper.on('AddStep', handleStepEvent);

  highed.dom.on(next, 'click', stepper.next);
  highed.dom.on(previous, 'click', stepper.previous);

  ///////////////////////////////////////////////////////////////////////////

  highed.dom.ap(toolbar.right, next);
  highed.dom.ap(toolbar.left, previous);

  highed.dom.style(previous, {
    opacity: 0,
    'pointer-events': 'none'
  });

  return {
    /** The container which the bar is attached to
     *  @type {domnode}
     *  @memberof highed.WizardBar
     */
    container: toolbar.container,
    on: stepper.on,
    next: stepper.next,
    previous: stepper.previous,
    addStep: stepper.addStep,
    selectFirst: stepper.selectFirst
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var webImports = {};

  highed.plugins.import = {
    /** Install a data import plugin
     * @namespace highed.plugins.import
     * @param name {string} - the name of the plugin
     * @param defintion {object} - the plugin definition
     *   > description {string} - the plugin description
     *   > treatAs {string} - what to treat the import as: `json|csv`
     *   > fetchAs {string} - what the expect request return is
     *   > defaultURL {string} - the default URL
     *   > depdendencies {array<string>} - set of additional javascript/css to include
     *   > options {object} - additional user-supplied options
     *      > label {string} - the title of the option
     *      > type {string} - the type of the option
     *      > default {string} - the default value
     *   > filter {function} - function to call when executing the plugin
     *      >  url {anything} - request url
     *      >  options {object} - contains user-defined options
     *      >  callback {function} - function to call when the import is done
     */
    install: function(name, defintion) {
      if (highed.isNull(webImports[name])) {
        webImports[name] = highed.merge(
          {
            title: false,
            description: '',
            treatAs: 'csv',
            fetchAs: 'json',
            defaultURL: '',
            dependencies: [],
            options: {},
            filter: function() {}
          },
          defintion
        );

        if (webImports[name].dependencies) {
          webImports[name].dependencies.forEach(function(d) {
            highed.include(d);
          });
        }
      } else {
        highed.log(
          1,
          'tried to register an import plugin which already exists:',
          name
        );
      }
    }
  };

  /** Data importer widget
   *
   *  @example
   *  var dimp = highed.DataImporter(document.body);
   *  dimp.on('ImportCSV', function (data) {
   *      console.log('Importing csv:', data.csv);
   *  });
   *
   *  @constructor
   *
   *  @emits ImportChartSettings - when importing chart settings
   *  @emits ImportCSV - when importing CSV
   *  @emits ImportJSON - when importing JSON
   *  @param parent {domnode} - the node to attach the widget to
   *  @param attributes {object} - the settings
   *     > options {string} - the options to include: `csv json plugins samples`
   *     > plugins {string} - the plugins to activate (must have been installed first)
   */
  highed.DataImporter = function(parent, attributes) {
    var events = highed.events(),
      properties = highed.merge(
        {
          options: ['csv', 'plugins', 'samples'],
          plugins: ['CSV', 'JSON', 'Difi', 'Socrata', 'Google Spreadsheets']
        },
        attributes
      ),
      tabs = highed.TabControl(parent, false, true),
      csvTab = tabs.createTab({ title: 'CSV' }),
      jsonTab = tabs.createTab({ title: 'JSON' }),
      webTab = tabs.createTab({ title: 'Plugins' }),
      samplesTab = tabs.createTab({ title: 'Sample Data' }),
      csvPasteArea = highed.dom.cr('textarea', 'highed-imp-pastearea'),
      csvImportBtn = highed.dom.cr(
        'button',
        'highed-imp-button',
        'Import Pasted Data'
      ),
      liveDataImportBtn = highed.dom.cr('button', 'highed-imp-button', 'Import Live Data'),
      csvImportFileBtn = highed.dom.cr(
        'button',
        'highed-imp-button',
        'Upload & Import File'
      ),
      delimiter = highed.dom.cr('input', 'highed-imp-input'),
      dateFormat = highed.dom.cr('input', 'highed-imp-input'),
      decimalPoint = highed.dom.cr('input', 'highed-imp-input'),
      firstAsNames = highed.dom.cr('input', 'highed-imp-input'),
      jsonPasteArea = highed.dom.cr('textarea', 'highed-imp-pastearea'),
      jsonImportBtn = highed.dom.cr('button', 'highed-imp-button', 'Import'),
      jsonImportFileBtn = highed.dom.cr(
        'button',
        'highed-imp-button',
        'Upload & Import File'
      ),
      webSplitter = highed.HSplitter(webTab.body, { leftWidth: 30 }),
      webList = highed.List(webSplitter.left);

    jsonPasteArea.value = JSON.stringify({}, undefined, 2);

    setDefaultTabSize(600, 600, [csvTab, jsonTab, webTab, samplesTab]);
    ///////////////////////////////////////////////////////////////////////////

    highed.dom.style(samplesTab.body, { overflow: 'hidden' });

    properties.options = highed.arrToObj(properties.options);
    properties.plugins = highed.arrToObj(properties.plugins);

    //Remove referenced un-installed plugins.
    Object.keys(properties.plugins).forEach(function(plugin) {
      if (highed.isNull(webImports[plugin])) {
        delete properties.plugins[plugin];
      }
    });

    function setDefaultTabSize(w, h, tabs) {
      tabs.forEach(function (tab) {
        tab.on('Focus',function() {
          highed.dom.style(parent, { width: 600 + 'px', height: 600 + 'px' });
          tab.resize(600 - 10, 600 - 10);
        });
      });
    }

    function updateOptions() {
      if (!properties.options.csv) {
        csvTab.hide();
      }

      //Always disable json options..
      if (1 === 1 || !properties.options.json) {
        jsonTab.hide();
      }

      if (
        Object.keys(properties.plugins).length === 0 ||
        !properties.options.plugins
      ) {
        webTab.hide();
      }

      if (!properties.options.samples) {
        samplesTab.hide();
      }

      tabs.selectFirst();
    }

    function buildWebTab() {
      Object.keys(webImports).forEach(function(name) {
        if (!properties.plugins[name]) {
          return;
        }

        function buildBody() {
          var options = webImports[name],
            url = highed.dom.cr('input', 'highed-imp-input-stretch'),
            urlTitle = highed.dom.cr('div', '', 'URL'),
            importBtn = highed.dom.cr(
              'button',
              'highed-imp-button',
              'Import ' + name + ' from URL'
            ),
            dynamicOptionsContainer = highed.dom.cr(
              'table',
              'highed-customizer-table'
            ),
            dynamicOptions = {};

          url.value = options.defaultURL || '';

          Object.keys(options.options || {}).forEach(function(name) {
            dynamicOptions[name] = options.options[name].default;

            highed.dom.ap(
              dynamicOptionsContainer,
              highed.InspectorField(
                options.options[name].type,
                options.options[name].default,
                {
                  title: options.options[name].label
                },
                function(nval) {
                  dynamicOptions[name] = nval;
                },
                true
              )
            );
          });

          if (options.surpressURL) {
            highed.dom.style([url, urlTitle], {
              display: 'none'
            });
          }

          url.placeholder = 'Enter URL';

          highed.dom.on(importBtn, 'click', function() {
            highed.snackBar('Importing ' + name + ' data');

            if (highed.isFn(options.request)) {
              return options.request(url.value, dynamicOptions, function(
                err,
                chartProperties
              ) {
                if (err) return highed.snackBar('import error: ' + err);
                events.emit(
                  'ImportChartSettings',
                  chartProperties,
                  options.newFormat
                );
              });
            }

            highed.ajax({
              url: url.value,
              type: 'get',
              dataType: options.fetchAs || 'text',
              success: function(val) {
                options.filter(val, highed.merge({}, dynamicOptions), function(
                  error,
                  val
                ) {
                  if (error) return highed.snackBar('import error: ' + error);
                  if (options.treatAs === 'csv') {
                    csvTab.focus();
                    csvPasteArea.value = val;
                    emitCSVImport(val);
                  } else {
                    processJSONImport(val);
                  }
                });
              },
              error: function(err) {
                highed.snackBar('import error: ' + err);
              }
            });
          });

          webSplitter.right.innerHTML = '';

          highed.dom.ap(
            webSplitter.right,
            highed.dom.ap(
              highed.dom.cr('div', 'highed-plugin-details'),
              highed.dom.cr(
                'div',
                'highed-customizer-table-heading',
                options.title || name
              ),
              highed.dom.cr('div', 'highed-imp-help', options.description),
              urlTitle,
              url,
              Object.keys(options.options || {}).length
                ? dynamicOptionsContainer
                : false,
              highed.dom.cr('br'),
              importBtn
            )
          );
        }

        webList.addItem({
          id: name,
          title: webImports[name].title || name,
          click: buildBody
        });
      });

      webList.selectFirst();
    }

    function buildSampleTab() {
      samplesTab.innerHTML = '';

      highed.samples.each(function(sample) {
        var data = sample.dataset.join('\n'),
          loadBtn = highed.dom.cr(
            'button',
            'highed-box-size highed-imp-button',
            sample.title
          );

        highed.dom.style(loadBtn, { width: '99%' });

        highed.dom.on(loadBtn, 'click', function() {
          emitCSVImport(data);
          csvPasteArea.value = data;
          csvTab.focus();
        });

        highed.dom.ap(
          samplesTab.body,
          //highed.dom.cr('div', '', name),
          //highed.dom.cr('br'),
          loadBtn,
          highed.dom.cr('br')
        );
      });
    }

    function emitCSVImport(csv) {
      events.emit('ImportCSV', {
        itemDelimiter: delimiter.value,
        firstRowAsNames: firstAsNames.checked,
        dateFormat: dateFormat.value,
        csv: csv || csvPasteArea.value,
        decimalPoint: decimalPoint.value
      });
    }

    function loadCSVExternal(csv) {
      csvPasteArea.value = csv;
      emitCSVImport();
    }

    function processJSONImport(jsonString) {
      var json = jsonString;
      if (highed.isStr(json)) {
        try {
          json = JSON.parse(jsonString);
        } catch (e) {
          highed.snackBar('Error parsing json: ' + e);
          return false;
        }
      }
      events.emit('ImportJSON', json);
      highed.snackBar('imported json');
    }

    /** Force a resize of the widget
     *  @memberof highed.DataImporter
     *  @param w {number} - the new width
     *  @param h {number} - the new height
     */
    function resize(w, h) {
      var bsize,
        ps = highed.dom.size(parent);

      tabs.resize(w || ps.w, h || ps.h);
      bsize = tabs.barSize();

      webSplitter.resize(w || ps.w, (h || ps.h) - bsize.h - 20);
      webList.resize(w || ps.w, (h || ps.h) - bsize.h);
    }

    /** Show the importer
     *  @memberof highed.DataImporter
     */
    function show() {
      tabs.show();
    }

    /** Hide the importer
     *  @memberof highed.DataImporter
     */
    function hide() {
      tabs.hide();
    }

    function addImportTab(tabOptions){
      var newTab = tabs.createTab({ title: tabOptions.name || 'Features' });

      if (highed.isFn(tabOptions.create)) {
        tabOptions.create(newTab.body);
      }
      if (tabOptions.resize) {
        newTab.on('Focus',function() {
          highed.dom.style(parent, { width: tabOptions.resize.width + 'px', height: tabOptions.resize.height + 'px' });
          newTab.resize(tabOptions.resize.width - 10, tabOptions.resize.height - 10);
        });
      }
    }

    ///////////////////////////////////////////////////////////////////////////

    highed.dom.ap(
      csvTab.body,
      highed.dom.cr(
        'div',
        'highed-imp-help',
        'Paste CSV into the below box, or upload a file. Click Import to import your data.'
      ),
      csvPasteArea,

      // highed.dom.cr('span', 'highed-imp-label', 'Delimiter'),
      // delimiter,
      // highed.dom.cr('br'),

      // highed.dom.cr('span', 'highed-imp-label', 'Date Format'),
      // dateFormat,
      // highed.dom.cr('br'),

      // highed.dom.cr('span', 'highed-imp-label', 'Decimal Point Notation'),
      // decimalPoint,
      // highed.dom.cr('br'),

      // highed.dom.cr('span', 'highed-imp-label', 'First Row Is Series Names'),
      // firstAsNames,
      // highed.dom.cr('br'),

      csvImportBtn,
      csvImportFileBtn,
      liveDataImportBtn
    );

    highed.dom.ap(
      jsonTab.body,
      highed.dom.cr(
        'div',
        'highed-imp-help',
        'Paste JSON into the below box, or upload a file. Click Import to import your data. <br/><b>The JSON is the data passed to the chart constructor, and may contain any of the valid <a href="http://api.highcharts.com/highcharts/" target="_blank">options</a>.</b>'
      ),
      jsonPasteArea,
      jsonImportFileBtn,
      jsonImportBtn
    );

    highed.dom.on(csvImportBtn, 'click', function() {
      emitCSVImport();
    });

    highed.dom.on(liveDataImportBtn, 'click', function () {
      //console.log(liveDataInput);
      //console.log(liveDataInput.value);
      events.emit('ImportLiveData', {
      //  url: liveDataInput.value
      });
    });

    highed.dom.on(csvPasteArea, 'keyup', function(e) {
      if (e.keyCode === 13 || ((e.metaKey || e.ctrlKey) && e.key === 'z')) {
        emitCSVImport(csvPasteArea.value);
      }
    });

    highed.dom.on(csvImportFileBtn, 'click', function() {
      highed.readLocalFile({
        type: 'text',
        accept: '.csv',
        success: function(info) {
          csvPasteArea.value = info.data;
          highed.snackBar('File uploaded');
          emitCSVImport();
        }
      });
    });

    highed.dom.on(jsonImportBtn, 'click', function() {
      processJSONImport(jsonPasteArea.value);
    });

    highed.dom.on(jsonImportFileBtn, 'click', function() {
      highed.readLocalFile({
        type: 'text',
        accept: '.json',
        success: function(info) {
          jsonPasteArea.value = info.data;
          processJSONImport(info.data);
        }
      });
    });

    buildSampleTab();
    buildWebTab();
    updateOptions();

    delimiter.value = ',';
    //dateFormat.value = 'YYYY-mm-dd';
    firstAsNames.type = 'checkbox';
    decimalPoint.value = '.';
    firstAsNames.checked = true;

    //Should hide the web tab if running where cross-origin is an issue

    resize();

    ///////////////////////////////////////////////////////////////////////////

    return {
      on: events.on,
      loadCSV: loadCSVExternal,
      resize: resize,
      show: show,
      hide: hide,
      addImportTab: addImportTab
    };
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var exportPlugins = {};

  highed.plugins.export = {
    /** Install an export plugin
     *  @namespace highed.plugins.export
     *  @param name {string} - the name of the plugin
     *  @param definition {object} - the plugin definition
     */
    install: function(name, definition) {
      if (highed.isNull(exportPlugins[name])) {
        exportPlugins[name] = highed.merge(
          {
            description: '',
            options: {},
            title: false,
            downloadOutput: false
          },
          definition
        );

        if (exportPlugins[name].dependencies) {
          highed.include(exportPlugins[name].dependencies);
        }
      } else {
        highed.log(
          1,
          'tried to register an export plugin which already exists:',
          name
        );
      }
    }
  };

  /** Export widget
   *
   *  @example
   *  var exporter = highed.Exporter(document.body),
   *      preview = highed.ChartPreview(document.body)
   *  ;
   *
   *  exporter.init(preview.export.json(), preview.export.html(), preview.export.svg(), preview);
   *
   *  @constructor
   *
   *  @param parent {domnode} - the node to attach the widget to
   *  @param attributes {object} - the options
   *    > options {string} - things to include: `csv html json plugins`
   *    > plugins {string|array} - plugins to activate
   */
  highed.Exporter = function(parent, attributes) {
    var //splitter = highed.HSplitter(parent, {leftWidth: 50, noOverflow: true}),
      properties = highed.merge(
        {
          options: 'svg html json plugins',
          plugins: 'beautify-js beautify-json'
        },
        attributes
      ),
      tctrl = highed.TabControl(parent, false, true),
      htmlTab = tctrl.createTab({ title: 'HTML' }),
      jsonTab = tctrl.createTab({ title: 'JSON' }),
      svgTab = tctrl.createTab({ title: 'SVG' }),
      pluginTab = tctrl.createTab({ title: 'Plugins' }),
      pluginSplitter = highed.HSplitter(pluginTab.body, { leftWidth: 30 }),
      pluginList = highed.List(pluginSplitter.left),
      exportJSON = highed.dom.cr('a', '', 'Download'),
      exportHTML = highed.dom.cr('a', '', 'Download'),
      exportSVG = highed.dom.cr('a', '', 'Download'),
      jsonValue = highed.dom.cr(
        'textarea',
        'highed-imp-pastearea highed-scrollbar'
      ),
      htmlValue = highed.dom.cr(
        'textarea',
        'highed-imp-pastearea highed-scrollbar'
      ),
      svgValue = highed.dom.cr(
        'textarea',
        'highed-imp-pastearea highed-scrollbar'
      ),
      currentChartPreview = false,
      hasBuiltPlugins = false,
      hasBeenVisible = false,
      pluginData = {},
      activePlugins = {},
      activePlugin = false;

    properties.options = highed.arrToObj(properties.options);
    properties.plugins = highed.arrToObj(properties.plugins);

    ///////////////////////////////////////////////////////////////////////////

    //Hides unwanted stuff
    function updateOptions() {
      if (!properties.options.html) {
        htmlTab.hide();
      }
      if (!properties.options.json) {
        jsonTab.hide();
      }
      if (!properties.options.svg) {
        svgTab.hide();
      }
      if (!properties.options.plugins) {
        pluginTab.hide();
      }
      if (Object.keys(properties.plugins) === 0) {
        pluginTab.hide();
      }

      tctrl.selectFirst();
    }

    //Build plugin panel
    function buildPlugins() {
      if (hasBuiltPlugins) return;
      hasBuiltPlugins = true;

      Object.keys(exportPlugins).forEach(function(name) {
        var options = exportPlugins[name];

        pluginData[name] = { options: {} };

        if (!properties.plugins[name]) {
          return false;
        }

        function buildBody() {
          var container = highed.dom.cr('div', 'highed-plugin-details'),
            executeBtn = highed.dom.cr(
              'button',
              'highed-imp-button',
              options.exportTitle || 'Export'
            ),
            dynamicOptionsContainer = highed.dom.cr(
              'table',
              'highed-customizer-table'
            ),
            additionalUI = highed.dom.cr('div'),
            dynamicOptions = pluginData[name].options;

          // pluginSplitter.right.innerHTML = '';

          Object.keys(options.options || {}).forEach(function(pname) {
            dynamicOptions[pname] = options.options[pname].default;

            highed.dom.ap(
              dynamicOptionsContainer,
              highed.InspectorField(
                options.options[pname].type,
                options.options[pname].default,
                {
                  title: options.options[pname].label
                },
                function(nval) {
                  dynamicOptions[pname] = nval;

                  if (highed.isFn(options.show)) {
                    options.show.apply(pluginData[name], [currentChartPreview]);
                  }
                },
                true
              )
            );
          });

          function doExport() {
            if (highed.isFn(options.export) && currentChartPreview) {
              options.export.apply(pluginData[name], [
                dynamicOptions,
                currentChartPreview,
                function(err, data, filename) {
                  if (err) return highed.snackBar('Export error: ' + err);

                  if (options.downloadOutput) {
                    highed.download(filename, data);
                  }

                  highed.snackBar((options.title || name) + ' export complete');
                },
                additionalUI
              ]);
            }
          }

          highed.dom.on(executeBtn, 'click', doExport);

          highed.dom.ap(pluginSplitter.right, container);

          highed.dom.style(container, { display: 'none' });

          highed.dom.ap(
            container,
            highed.dom.cr(
              'div',
              'highed-customizer-table-heading',
              options.title || name
            ),
            highed.dom.cr('div', 'highed-imp-help', options.description),
            Object.keys(options.options || {}).length
              ? dynamicOptionsContainer
              : false,
            additionalUI,
            options.export ? executeBtn : false
          );

          if (highed.isFn(options.create)) {
            options.create.apply(pluginData[name], [
              currentChartPreview,
              additionalUI
            ]);
          }

          activePlugins[name] = {
            export: doExport,
            show: function() {
              if (activePlugin) {
                activePlugin.hide();
              }
              highed.dom.style(container, { display: '' });
              options.show.apply(pluginData[name], [currentChartPreview]);
              activePlugin = activePlugins[name];
            },
            hide: function() {
              highed.dom.style(container, { display: 'none' });
            }
          };
        }

        buildBody();

        pluginList.addItem({
          id: name,
          title: options.title || name,
          click: activePlugins[name].show
        });
      });
    }

    /** Set the export boxes based on chart JSON data (chart.options)
     *  @memberof highed.Exporter
     *  @param chartData {object} - the chart JSON
     *  @param chartHTML {string} - chart HTML
     *  @param chartSVG {string} - chart svg
     *  @param chartPreview {object} - instance of highed.ChartPreview
     */
    function init(chartData, chartHTML, chartSVG, chartPreview) {
      var title = '_export';

      if (chartData.title && chartData.title.text) {
        title = chartData.title.text.replace(/\s/g, '_') + title;
      } else {
        title = 'untitled' + title;
      }

      jsonValue.value = JSON.stringify(chartData);
      exportJSON.href = 'data:application/octet-stream,' + jsonValue.value;

      htmlValue.value = chartHTML;
      exportHTML.href =
        'data:application/octet-stream,' + encodeURIComponent(chartHTML);

      svgValue.value = chartSVG;
      exportSVG.href =
        'data:application/octet-stream,' + encodeURIComponent(chartSVG);

      exportJSON.download = title + '.json';
      exportHTML.download = title + '.html';
      exportSVG.download = title + '.svg';

      highed.dom.on(exportJSON, 'click', function() {
        highed.events('UIAction', 'BtnDownloadJSON');
      });

      highed.dom.on(exportHTML, 'click', function() {
        highed.events('UIAction', 'BtnDownloadHTML');
      });

      highed.dom.on(exportSVG, 'click', function() {
        highed.events('UIAction', 'BtnDownloadSVG');
      });

      currentChartPreview = chartPreview;

      buildPlugins();

      // Object.keys(activePlugins).forEach(function (name) {
      //     activePlugins[name].show();
      // });

      if (activePlugin) {
        activePlugin.show();
      }

      hasBeenVisible = true;
    }

    /** Force a resize of the UI
     *  @memberof highed.Exporter
     *  @param w {number} - the new width
     *  @param h {number} - the new height
     */
    function resize(w, h) {
      var bsize;

      //splitter.resize(w, h);
      tctrl.resize(w, h);
      bsize = tctrl.barSize();

      pluginSplitter.resize(w, h - bsize.h - 20);
      pluginList.resize(w, h - bsize.h);
    }

    function doSelectOnClick(thing, id) {
      highed.dom.on(thing, 'click', function() {
        thing.focus();
        thing.select();
        highed.emit('UIAction', 'Copy' + id);
      });
    }

    ///////////////////////////////////////////////////////////////////////////

    highed.dom.ap(
      htmlTab.body,
      // highed.dom.cr('div', 'highed-imp-headline', 'Export HTML'),
      highed.dom.ap(highed.dom.cr('div', 'highed-imp-spacer'), htmlValue),
      highed.dom.ap(highed.dom.cr('button', 'highed-imp-button'), exportHTML)
    );

    highed.dom.ap(
      jsonTab.body,
      // highed.dom.cr('div', 'highed-imp-headline', 'Export JSON'),
      highed.dom.ap(highed.dom.cr('div', 'highed-imp-spacer'), jsonValue),
      highed.dom.ap(highed.dom.cr('button', 'highed-imp-button'), exportJSON)
    );

    highed.dom.ap(
      svgTab.body,
      // highed.dom.cr('div', 'highed-imp-headline', 'Export JSON'),
      highed.dom.ap(highed.dom.cr('div', 'highed-imp-spacer'), svgValue),
      highed.dom.ap(highed.dom.cr('button', 'highed-imp-button'), exportSVG)
    );

    resize();
    updateOptions();

    doSelectOnClick(jsonValue, 'JSON');
    doSelectOnClick(htmlValue, 'HTML');
    doSelectOnClick(svgValue, 'SVG');

    ///////////////////////////////////////////////////////////////////////////

    return {
      init: init,
      resize: resize,
      buildPluginUI: buildPlugins
    };
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Basic chart preview
 *  This is just a facade to Highcharts.Chart mostly.
 *  It implements a sliding drawer type widget,
 *  where the initial state can be as part of the main DOM,
 *  and where the expanded state covers most of the screen (90%)
 *
 *  @todo this is a proper mess right now - need a good refactoring
 *
 *  @constructor
 *
 *  @param parent {domnode} - the node to attach the preview to
 *  @param attributes {object} - the settings
 *    > defaultChartOptions {object} - the default chart options
 */
highed.ChartPreview = function(parent, attributes) {
  var properties = highed.merge(
      {
        defaultChartOptions: {
          title: {
            text: 'My Chart'
          },
          subtitle: {
            text: 'My Untitled Chart'
          },
          exporting: {
            //   url: 'http://127.0.0.1:7801'
          }
        },
        expandTo: parent
      },
      attributes
    ),
    events = highed.events(),
    customizedOptions = {},
    aggregatedOptions = {},
    flatOptions = {},
    templateOptions = {},
    chartOptions = {},
    themeOptions = {},
    themeMeta = {},
    exports = {},
    customCodeDefault = [
      '/*',
      '// Sample of extending options:',
      'Highcharts.merge(true, options, {',
      '    chart: {',
      '        backgroundColor: "#bada55"',
      '    },',
      '    plotOptions: {',
      '        series: {',
      '            cursor: "pointer",',
      '            events: {',
      '                click: function(event) {',
      '                    alert(this.name + " clicked\\n" +',
      '                          "Alt: " + event.altKey + "\\n" +',
      '                          "Control: " + event.ctrlKey + "\\n" +',
      '                          "Shift: " + event.shiftKey + "\\n");',
      '                }',
      '            }',
      '        }',
      '    }',
      '});',
      '*/'
    ].join('\n'),
    customCode = '',
    customCodeStr = '',
    lastLoadedCSV = false,
    lastLoadedSheet = false,
    lastLoadedLiveData = false,
    throttleTimeout = false,
    chart = false,
    preExpandSize = false,
    toggleButton = highed.dom.cr(
      'div',
      'highed-icon highed-chart-preview-expand fa fa-external-link-square'
    ),
    expanded = false,
    constr = 'Chart',
    wysiwyg = {
      'g.highcharts-legend': { tab: 'Legend', id: 'legend--enabled' },
      'text.highcharts-title': { tab: 'Titles', id: 'title--text' },
      'text.highcharts-subtitle': { tab: 'Titles', id: 'subtitle--text' },
      '.highcharts-yaxis-labels': { tab: 'Axes', id: 'yAxis-labels--format' },
      '.highcharts-xaxis-labels': { tab: 'Axes', id: 'xAxis-labels--format' },
      '.highcharts-xaxis .highcharts-axis-title': {
        tab: 'Axes',
        id: 'xAxis-title--text'
      },
      '.highcharts-yaxis .highcharts-axis-title': {
        tab: 'Titles',
        id: 'yAxis-title--text'
      },
      'rect.highcharts-background': {
        tab: 'Appearance',
        id: 'chart--backgroundColor'
      },
      '.highcharts-series': { tab: 'Data series', id: 'series' },
      'g.highcharts-tooltip': { tab: 'Tooltip', id: 'tooltip--enabled' }
    };

  ///////////////////////////////////////////////////////////////////////////

  function attachWYSIWYG() {
    Object.keys(wysiwyg).forEach(function(key) {
      highed.dom.on(parent.querySelector(key), 'click', function(e) {
        events.emit('RequestEdit', wysiwyg[key], e.clientX, e.clientY);
        e.cancelBubble = true;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      });
    });
  }

  function stringifyFn(obj, tabs) {
    return JSON.stringify(
      obj,
      function(key, value) {
        if (highed.isFn(value)) {
          return value.toString();
        }

        return value;
      },
      tabs
    );
  }

  /* Get the chart if it's initied */
  function gc(fn) {
    if (highed.isFn(fn)) {
      if (chart !== false) {
        return fn(chart);
      }
      return fn(init());
    }
    return false;
  }

  /* Emit change events */
  function emitChange() {
    events.emit('ChartChange', aggregatedOptions);

    //Throttled event - we use this when doing server stuff in the handler
    //since e.g. using the color picker can result in quite a lot of updates
    //within a short amount of time
    window.clearTimeout(throttleTimeout);
    throttleTimeout = window.setTimeout(function() {
      events.emit('ChartChangeLately', aggregatedOptions);
    }, 200);
  }

  /* Init the chart */
  function init(options, pnode, noAnimation) {
    var i;

    //We want to work on a copy..
    options = options || aggregatedOptions;
    constr = constr || 'Chart';
    // options = highed.merge({}, options || aggregatedOptions);

    // if (aggregatedOptions && aggregatedOptions.series) {
    //     options = aggregatedOptions.series;
    // }

    if (noAnimation) {
      highed.setAttr(options, 'plotOptions--series--animation', false);
    }

    // if (typeof window.Highcharts === 'undefined') {
    //   highed.snackBar('Highcharts.JS must be included to use the editor');
    //   return;
    // }

    // (pnode || parent).innerHTML = 'Chart not loaded yet';

    // options.chart = options.chart || {};
    // options.chart.width = '100%';
    // options.chart.height = '100%';

    // if (options && options.chart) {
    //   delete options.chart.width;
    //   delete options.chart.height;
    // }

    try {
      chart = new Highcharts[constr](pnode || parent, options);
      //This is super ugly.
      // customizedOptions.series = customizedOptions.series || [];
      //  customizedOptions.series = chart.options.series || [];
      // highed.merge(customizedOptions.series, chart.options.series);
      //updateAggregated();

      if (chart && chart.options) {
        highed.clearObj(chartOptions);
        highed.merge(chartOptions, chart.options);
      }

      attachWYSIWYG();

      if (chart && chart.reflow) {
        //chart.reflow();
      }

      // highed.dom.ap(pnode || parent, toggleButton);

      Highcharts.addEvent(chart, 'afterPrint', function() {
        events.emit('RequestResize');
        // highed.dom.ap(pnode || parent, toggleButton);
      });

      events.emit('ChartRecreated');
    } catch (ex) {
      var e = ex.toString();

      //So we know that the return here is likely to be an
      //url with the error code. so extract it.
      highed.log(1, 'error initializing chart:', e);

      i = e.indexOf('www.');

      events.emit('Error', e);

      highed.emit('UIAction', 'UnsuccessfulChartGeneration');

      if (i > 0) {
        // highed.snackBar(
        //   'There is a problem with your chart!',
        //   e.substr(i),
        //   function() {
        //     window.open('http://' + e.substr(i));
        //   }
        // );
      } else {
        //Our assumption was wrong. The world is ending.
        // highed.snackBar(e);

        // console.error(e);
        console.error('exception trace:', ex.stack);
      }

      (pnode || parent).innerHTML = '';

      chart = false;
    }

    return chart;
  }

  /** Resize the preview
   *  Resizes based on the parent size.
   *  @memberof highed.ChartPreview
   */
  function resize(width, height) {
    gc(function(chart) {
      if (width && height) {
        // chart.setSize(width, height);
      }

      if (chart && chart.reflow) {
        // && chart.options) {
        try {
          chart.reflow();
        } catch (e) {
          // No idea why this keeps failing
        }
      }
    });
  }

  /**
   * Clear all themes from the chart.
   * Used by cloud to reset theme
   */
  function clearTheme(theme, skipEmit) {
    themeOptions = false;

    if (!skipEmit) {
      updateAggregated();
      init(aggregatedOptions);
      emitChange();
      events.emit('SetResizeData');
    }

    return true;
  }

  /**
   * Assign a theme to the chart
   * theme can either be a straight-up option set, or a theme object with
   * ID and so on.
   */
  function assignTheme(theme, skipEmit) {
    if (highed.isStr(theme)) {
      return assignTheme(JSON.parse(theme));
    }

    themeMeta = {};

    if (highed.isBasic(theme) || highed.isArr(theme)) {
      return false;
    }

    if (Object.keys(theme).length === 0) {
      return false;
    }

    if (theme && theme.options && theme.id) {
      // Assume that this uses the new format
      themeMeta = {
        id: theme.id,
        name: theme.name || theme.id
      };

      themeOptions = highed.merge({}, theme.options);
    } else {
      themeMeta = {
        id: highed.uuid(),
        name: 'Untitled Theme'
      };

      themeOptions = highed.merge({}, theme);
    }

    if (!skipEmit) {
      updateAggregated();
      init(aggregatedOptions);
      emitChange();
      events.emit('SetResizeData');
    }

    return true;
  }

  function updateAggregated(noCustomCode) {
    // customizedOptions.plotOptions = customizedOptions.plotOptions || {};
    // customizedOptions.plotOptions.series = customizedOptions.plotOptions.series || [];
    //  customizedOptions.series = customizedOptions.series || [];

    if (
      customizedOptions &&
      !highed.isArr(customizedOptions.yAxis) &&
      customizedOptions.yAxis
    ) {
      customizedOptions.yAxis = [customizedOptions.yAxis || {}];
    }

    if (
      customizedOptions &&
      !highed.isArr(customizedOptions.xAxis) &&
      customizedOptions.xAxis
    ) {
      customizedOptions.xAxis = [customizedOptions.xAxis || {}];
    }

    templateOptions = templateOptions || {};

    if (templateOptions.yAxis && !highed.isArr(templateOptions.yAxis)) {
      templateOptions.yAxis = [templateOptions.yAxis];
    }

    if (templateOptions.xAxis && !highed.isArr(templateOptions.xAxis)) {
      templateOptions.xAxis = [templateOptions.xAxis];
    }

    // if (templateOptions.series) {
    //     templateOptions.series = templateOptions.series.map(function (s) {
    //         delete s['data'];
    //         return s;
    //     });
    // }

    //Merge fest

    highed.clearObj(aggregatedOptions);

    highed.merge(aggregatedOptions, properties.defaultChartOptions);

    // Apply theme first
    if (themeOptions && Object.keys(themeOptions).length) {
      highed.merge(
        aggregatedOptions,
        highed.merge(highed.merge({}, themeOptions))
      );
    }

    highed.merge(
      aggregatedOptions,
      highed.merge(highed.merge({}, templateOptions), customizedOptions)
    );

    //This needs to be cleaned up
    if (aggregatedOptions.yAxis && templateOptions.yAxis) {
      aggregatedOptions.yAxis.forEach(function(obj, i) {
        if (i < templateOptions.yAxis.length) {
          highed.merge(obj, templateOptions.yAxis[i]);
        }
      });
    }

    if (aggregatedOptions.xAxis && templateOptions.xAxis) {
      aggregatedOptions.xAxis.forEach(function(obj, i) {
        if (i < templateOptions.xAxis.length) {
          highed.merge(obj, templateOptions.xAxis[i]);
        }
      });
    }

    if (themeOptions && themeOptions.xAxis) {
      themeOptions.xAxis = highed.isArr(themeOptions.xAxis)
        ? themeOptions.xAxis
        : [themeOptions.xAxis];

      aggregatedOptions.xAxis.forEach(function(obj, i) {
        if (i < themeOptions.xAxis.length) {
          highed.merge(obj, themeOptions.xAxis[i]);
        }
      });
    }

    if (themeOptions && themeOptions.yAxis) {
      themeOptions.yAxis = highed.isArr(themeOptions.yAxis)
        ? themeOptions.yAxis
        : [themeOptions.yAxis];

      aggregatedOptions.yAxis.forEach(function(obj, i) {
        if (i < themeOptions.yAxis.length) {
          highed.merge(obj, themeOptions.yAxis[i]);
        }
      });
    }

    //Temporary hack
    //aggregatedOptions.series = customizedOptions.series;\
    aggregatedOptions.series = [];
    if (highed.isArr(customizedOptions.series)) {
      customizedOptions.series.forEach(function(obj, i) {
        var mergeTarget = {};

        if (themeOptions && highed.isArr(themeOptions.series)) {
          if (i < themeOptions.series.length) {
            mergeTarget = highed.merge({}, themeOptions.series[i]);
          }
        }

        aggregatedOptions.series.push(highed.merge(mergeTarget, obj));
      });
    }

    if (templateOptions.series) {
      aggregatedOptions.series = aggregatedOptions.series || [];

      templateOptions.series.forEach(function(obj, i) {
        if (i < aggregatedOptions.series.length) {
          highed.merge(aggregatedOptions.series[i], obj);
        } else {
          aggregatedOptions.series.push(highed.merge({}, obj));
        }
      });
    }

    if (aggregatedOptions.yAxis && !highed.isArr(aggregatedOptions.yAxis)) {
      aggregatedOptions.yAxis = [aggregatedOptions.yAxis];
    }

    if (aggregatedOptions.xAxis && !highed.isArr(aggregatedOptions.xAxis)) {
      aggregatedOptions.xAxis = [aggregatedOptions.xAxis];
    }

    highed.merge(aggregatedOptions, highed.option('stickyChartProperties'));

    // Finally, do custom code
    if (!noCustomCode && highed.isFn(customCode)) {
      customCode(aggregatedOptions);
    }
  }

  /** Load a template from the meta
   *  @memberof highed.ChartPreview
   *  @param template - the template object
   */
  function loadTemplate(template) {
    if (!template || !template.config) {
      return highed.log(
        1,
        'chart preview: templates must be an object {config: {...}}'
      );
    }

    constr = template.constructor || 'Chart';

    highed.clearObj(templateOptions);

    if (customizedOptions.xAxis) {
      delete customizedOptions.xAxis;
    }

    if (customizedOptions.yAxis) {
      delete customizedOptions.yAxis;
    }

    // highed.setAttr(customizedOptions, 'series', []);

    gc(function(chart) {
      templateOptions = highed.merge({}, template.config || {});

      updateAggregated();
      init(aggregatedOptions);
      emitChange();
    });
  }

  function loadSeries() {
    if (
      !gc(function(chart) {
        if (chart.options && chart.options.series) {
          customizedOptions.series = chart.options.series;
        }
        return true;
      })
    ) {
      customizedOptions.series = [];
    }
    updateAggregated();
  }

  /** Load CSV data
   *  @memberof highed.ChartPreview
   *  @name data.csv
   *  @param data {object} - the data to load
   */
  function loadCSVData(data, emitLoadSignal) {
    var mergedExisting = false,
      seriesClones = [];
    if (!data || !data.csv) {
      if (highed.isStr(data)) {
        data = {
          csv: data,
          // itemDelimiter: ';',
          firstRowAsNames: true
        };
      } else {
        return highed.log(1, 'chart load csv: data.csv is required');
      }
    }

    lastLoadedCSV = data.csv;
    lastLoadedSheet = false;
    lastLoadedLiveData = false;

    gc(function(chart) {
      var axis;

      // highed.setAttr(customizedOptions, 'series', []);
      // highed.setAttr(aggregatedOptions, 'series', []);

      // highed.setAttr(customizedOptions, 'plotOptions--series--animation', true);
      // highed.setAttr(customizedOptions, 'data--csv', data.csv);
      // highed.setAttr(customizedOptions, 'data--googleSpreadsheetKey', undefined);
      // highed.setAttr(customizedOptions, 'data--itemDelimiter', data.itemDelimiter);
      // highed.setAttr(customizedOptions, 'data--firstRowAsNames', data.firstRowAsNames);
      // highed.setAttr(customizedOptions, 'data--dateFormat', data.dateFormat);
      // highed.setAttr(customizedOptions, 'data--decimalPoint', data.decimalPoint);

      if (customizedOptions && customizedOptions.series) {
        (highed.isArr(customizedOptions.series)
          ? customizedOptions.series
          : [customizedOptions.series]
        ).forEach(function(series) {
          seriesClones.push(
            highed.merge({}, series, false, {
              data: 1,
              name: 1
            })
          );
        });
      }

      customizedOptions.series = [];

      highed.merge(customizedOptions, {
        plotOptions: {
          series: {
            animation: false
          }
        },
        data: {
          csv: data.csv,
          itemDelimiter: data.itemDelimiter,
          firstRowAsNames: data.firstRowAsNames,
          dateFormat: data.dateFormat,
          decimalPoint: data.decimalPoint,
          googleSpreadsheetKey: undefined,
          url: data.url
        }
      });

      updateAggregated();

      init(aggregatedOptions);
      loadSeries();
      emitChange();

      (customizedOptions.series || []).forEach(function(series, i) {
        if (i < seriesClones.length) {
          mergedExisting = true;
          highed.merge(series, seriesClones[i]);
        }
      });

      if (mergedExisting) {
        updateAggregated();
        init(aggregatedOptions);
        loadSeries();
        emitChange();
      }

      if (emitLoadSignal) {
        events.emit('LoadProjectData', data.csv);
      }
    });

    // setTimeout(function () {
    // gc(function (chart) {
    //   if (chart && highed.isArr(chart.xAxis) && chart.xAxis.length > 0) {
    //     customizedOptions.xAxis = customizedOptions.xAxis || [];
    //     chart.xAxis.forEach(function (a, i) {
    //       customizedOptions.xAxis[i] = customizedOptions.xAxis[i] || {};
    //       if (a.isDatetimeAxis) {
    //         customizedOptions.xAxis[i].type = 'datetime';
    //       } else if (a.categories) {
    //         customizedOptions.xAxis[i].type = 'categories';
    //       } else {
    //         // customizedOptions.xAxis[i].type = 'linear';
    //       }
    //     });
    //   }
    //   console.log(chart);
    // });
    // }, 1000);
  }

  /** Load project
   *  @memberof highed.ChartPreview
   *  @param projectData - the data to load
   */
  function loadProject(projectData) {
    var hasData = false,
      htmlEntities = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>'
      };

    highed.emit('UIAction', 'LoadProject');

    lastLoadedCSV = false;
    lastLoadedSheet = false;
    lastLoadedLiveData = false;

    if (highed.isStr(projectData)) {
      try {
        return loadProject(JSON.parse(projectData));
      } catch (e) {
        highed.snackBar('Invalid project');
      }
    }

    if (projectData) {
      templateOptions = {};
      if (projectData.template) {
        templateOptions = projectData.template;
      }

      customizedOptions = {};
      if (projectData.options) {
        customizedOptions = projectData.options;
      }

      // highed.merge(customizedOptions, {
      //   data: {
      //     csv: undefined
      //   }
      // });

      // if (customizedOptions && customizedOptions.data) {
      //   customizedOptions.data.csv = undefined;
      // }

      if (customizedOptions.lang) {
        Highcharts.setOptions({
          lang: customizedOptions.lang
        });
      }

      if (typeof projectData.theme !== 'undefined') {
        assignTheme(projectData.theme, true);
      }

      if (customizedOptions && customizedOptions.series) {
        customizedOptions.series = highed.isArr(customizedOptions.series)
          ? customizedOptions.series
          : [customizedOptions.series];

        customizedOptions.series.forEach(function(series) {
          if (typeof series._colorIndex !== 'undefined') {
            delete series._colorIndex;
          }
        });
      }

      setCustomCode(
        projectData.customCode,
        function(err) {
          highed.snackBar('Error in custom code: ' + err);
        },
        true
      );

      constr = 'Chart';

      // Support legacy format
      if (projectData.settings && projectData.settings.templateView) {
        if (projectData.settings.templateView.activeSection === 'stock') {
          constr = 'StockChart';
        }
      }

      if (
        projectData.settings &&
        highed.isStr(projectData.settings.constructor)
      ) {
        constr = projectData.settings.constructor;
      }

      if (projectData.settings && projectData.settings.dataProvider) {
        if (projectData.settings.dataProvider.seriesMapping) {
          highed.merge(customizedOptions, {
            data: {
              seriesMapping: projectData.settings.dataProvider.seriesMapping
            }
          });
        }

        if (projectData.settings.dataProvider.googleSpreadsheet) {
          var provider = projectData.settings.dataProvider;
          var sheet = provider.googleSpreadsheet;

          if (customizedOptions.data) {
            sheet.startRow =
              provider.startRow || customizedOptions.data.startRow;
            sheet.endRow = provider.endRow || customizedOptions.data.endRow;
            sheet.startColumn =
              provider.startColumn || customizedOptions.data.startColumn;
            sheet.endColumn =
              provider.endColumn || customizedOptions.data.endColumn;
            if (provider.dataRefreshRate && provider.dataRefreshRate > 0) {
              sheet.dataRefreshRate =
                provider.dataRefreshRate ||
                customizedOptions.data.dataRefreshRate;
              sheet.enablePolling = true;
            }
          }

          events.emit(
            'ProviderGSheet',
            projectData.settings.dataProvider.googleSpreadsheet
          );

          loadGSpreadsheet(sheet);

          hasData = true;
        } else if (projectData.settings.dataProvider.liveData) {
          var provider = projectData.settings.dataProvider;
          var live = provider.liveData;

          loadLiveData(provider.liveData);
        } else if (projectData.settings.dataProvider.csv) {
          // We need to fix potential html-entities as they will mess up separators
          Object.keys(htmlEntities).forEach(function(ent) {
            projectData.settings.dataProvider.csv = projectData.settings.dataProvider.csv.replace(
              new RegExp(ent, 'g'),
              htmlEntities[ent]
            );
          });

          loadCSVData(
            {
              csv: projectData.settings.dataProvider.csv
            },
            true
          );

          // events.emit('LoadProjectData', projectData.settings.dataProvider.csv);

          hasData = true;
        }
      }

      // Not sure if this should be part of the project files yet
      // if (projectData.editorOptions) {
      //     Object.keys(projectData.editorOptions, function (key) {
      //         highed.option(key, projectData.editorOptions[key]);
      //     });
      // }

      if (!hasData) {
        updateAggregated();
        init(aggregatedOptions);
        emitChange();
      }
      events.emit('LoadProject', projectData);
    }
  }

  function loadLiveData(settings) {
    lastLoadedLiveData = settings;

    lastLoadedCSV = false;
    lastLoadedSheet = false;

    highed.merge(customizedOptions, {
      data: lastLoadedLiveData
    });

    events.emit('ProviderLiveData', settings);
    updateAggregated();
    init(aggregatedOptions);

    loadSeries();
    emitChange();
  }

  function loadGSpreadsheet(options) {
    var key;

    lastLoadedCSV = false;
    lastLoadedSheet = options;

    lastLoadedSheet.googleSpreadsheetKey =
      lastLoadedSheet.googleSpreadsheetKey || lastLoadedSheet.id;
    lastLoadedSheet.googleSpreadsheetWorksheet =
      lastLoadedSheet.googleSpreadsheetWorksheet || lastLoadedSheet.worksheet;

    if (options && (options.googleSpreadsheetKey || '').indexOf('http') === 0) {
      // Parse out the spreadsheet ID
      // Located between /d/ and the next slash after that
      key = options.googleSpreadsheetKey;
      key = key.substr(key.indexOf('/d/') + 3);
      key = key.substr(0, key.indexOf('/'));

      options.googleSpreadsheetKey = key;
    }

    highed.merge(customizedOptions, {
      data: lastLoadedSheet
    });

    updateAggregated();
    init(aggregatedOptions);
    loadSeries();
    emitChange();

    // The sheet will be loaded async, so we should listen to the load event.
    gc(function(chart) {
      var found = Highcharts.addEvent(chart, 'load', function() {
        loadSeries();
        found();
      });
    });
  }

  function getCleanOptions(source) {
    return source;

    // return highed.merge(highed.merge({}, source), {
    //   data: {
    //     csv: false
    //   }
    // });

    // var clone = highed.merge({}, source || customizedOptions);

    // if (!highed.isArr(clone.yAxis)) {
    //   clone.yAxis = [clone.yAxis];
    // }

    // (clone.yAxis || []).forEach(function (axis) {
    //   if (axis.series) {
    //     delete axis.series.data;
    //   }
    // });

    // return clone;
  }

  /** Export project as JSON
   *  @memberof highed.ChartPreview
   */
  function toProject() {
    var loadedCSVRaw = false,
      gsheet = lastLoadedSheet,
      livedata = lastLoadedLiveData,
      themeData = false;

    if (
      chart &&
      chart.options &&
      chart.options.data &&
      chart.options.data.csv
    ) {
      loadedCSVRaw = chart.options.data.csv;
    }

    if (
      chart &&
      chart.options &&
      chart.options.data &&
      chart.options.data.googleSpreadsheetKey
    ) {
      gsheet = {
        googleSpreadsheetKey: chart.options.data.googleSpreadsheetKey,
        googleSpreadsheetWorksheet:
          chart.options.data.googleSpreadsheetWorksheet
      };
    }

    if (
      chart &&
      chart.options &&
      chart.options.data &&
      chart.options.data.url
    ) {
      livedata = {
        url: chart.options.data.url,
        interval: chart.options.data.interval,
        type: chart.options.data.type
      };
    }

    if (themeMeta && themeMeta.id && themeOptions) {
      themeData = {
        id: themeMeta.id,
        name: themeMeta.name,
        options: themeOptions || {}
      };
    }

    return {
      template: templateOptions,
      options: getCleanOptions(customizedOptions),
      customCode: highed.isFn(customCode) ? customCodeStr : '',
      theme: themeData,
      settings: {
        constructor: constr,
        dataProvider: {
          csv: !gsheet && !livedata ? loadedCSVRaw || lastLoadedCSV : false,
          googleSpreadsheet: gsheet,
          liveData: livedata
        }
      }
      //editorOptions: highed.serializeEditorOptions()
    };
  }

  function clearData(skipReinit) {
    lastLoadedCSV = false;
    lastLoadedSheet = false;
    lastLoadedLiveData = false;

    if (customizedOptions && customizedOptions.data) {
      customizedOptions.data = {};
    }

    if (customizedOptions.series) {
      customizedOptions.series = highed.isArr(customizedOptions.series)
        ? customizedOptions.series
        : [customizedOptions.series];

      customizedOptions.series.forEach(function(series) {
        if (series.data) {
          delete series.data;
        }
      });
    }

    if (!skipReinit) {
      updateAggregated();
      init(aggregatedOptions);
      emitChange();
    }
  }

  /**
   * Export project as a JSON string
   */
  function toProjectStr(tabs) {
    return stringifyFn(toProject(), tabs);
  }

  /** Load JSON data
   * Functionally, this only instances a new
   * chart with the supplied data as its options.
   * It accepts both a string and and object
   *
   * @memberof highed.ChartPreview
   * @name data.json
   * @param data {object} - the data to load
   */
  function loadJSONData(data) {
    lastLoadedCSV = false;

    gc(function(chart) {
      if (highed.isStr(data)) {
        try {
          loadJSONData(JSON.parse(data));
        } catch (e) {
          highed.snackBar('invalid json: ' + e);
        }
      } else if (highed.isBasic(data)) {
        highed.snackBar('the data is not valid json');
      } else {
        templateOptions = {};
        highed.clearObj(customizedOptions);
        highed.merge(customizedOptions, highed.merge({}, data));

        if (!highed.isNull(data.series)) {
          customizedOptions.series = data.series;
        }

        updateAggregated();
        init(customizedOptions);
        loadSeries();
        emitChange();
      }
    });
  }

  /**
   * Load raw dataset (array of arrays)
   */
  //function

  /** Set chart options from an object
   *
   */
  function setChartOptions(options) {
    function emitWidthChange() {
      events.emit('AttrChange', {
        id: 'chart.width'
      });
    }

    function emitHeightChange() {
      events.emit('AttrChange', {
        id: 'chart.height'
      });
    }

    var doEmitHeightChange = false,
      doEmitWidthChange = false;

    // Temp. hack to deal with actual sizing
    if (options && options.chart) {
      if (typeof options.chart.width !== 'undefined') {
        if (
          !customizedOptions.chart ||
          typeof customizedOptions.chart === 'undefined'
        ) {
          doEmitWidthChange = true;
        } else if (customizedOptions.chart.width !== options.chart.width) {
          doEmitWidthChange = true;
        }
      }

      if (typeof options.chart.height !== 'undefined') {
        if (
          !customizedOptions.chart ||
          typeof customizedOptions.chart === 'undefined'
        ) {
          doEmitHeightChange = true;
        } else if (customizedOptions.chart.height !== options.chart.height) {
          doEmitHeightChange = true;
        }
      }
    }

    // console.time('remblanks');
    customizedOptions = highed.transform.remBlanks(
      highed.merge({}, options, false)
    );
    // console.timeEnd('remblanks');

    if (customizedOptions && customizedOptions.lang) {
      Highcharts.setOptions({
        lang: customizedOptions.lang
      });
    }

    if (options && options.global) {
    }

    // This is nasty
    if (options && options.data && options.data.googleSpreadsheetKey) {
      events.emit('LoadedGoogleSpreadsheet');
    }

    updateAggregated();
    init(aggregatedOptions, false, true);
    emitChange();

    if (doEmitHeightChange) {
      emitHeightChange();
    }

    if (doEmitWidthChange) {
      emitWidthChange();
    }
  }

  /** Load chart settings
   * Note that merges the incoming settings with the existing ones.
   * @memberof highed.ChartPreview
   * @name data.settings
   * @param settings {object} - the settings to load
   */
  function loadChartSettings(settings) {
    gc(function(chart) {
      Object.keys(settings || {}).forEach(function(key) {
        highed.setAttr(customizedOptions, key, settings[key]);
      });

      updateAggregated();
      init(aggregatedOptions);
      emitChange();
    });
  }

  function loadSeriesData(seriesArr) {
    if (!highed.isArr(seriesArr)) return;
    customizedOptions.series = customizedOptions.series || [];

    if (seriesArr.length < customizedOptions.series.length) {
      //Need to delete some series
      customizedOptions.series.splice(
        seriesArr.length,
        customizedOptions.series.length - seriesArr.length
      );
    }

    seriesArr.forEach(function(s, i) {
      if (s.name) {
        set('series-name', s.name, i);
      }
      if (s.data) {
        set('series-data', s.data, i);
      }
    });
  }

  /** Set an attribute
   *  @memberof highed.ChartPreview
   *  @name options.set
   *  @param id {string} - the path of the attribute
   *  @param value {anything} - the value to set
   *  @param index {number} - used if the option is an array
   */
  function set(id, value, index) {
    gc(function(chart) {
      //highed.setAttr(chart.options, id, value, index);
      highed.setAttr(
        chart.options,
        'plotOptions--series--animation',
        false,
        index
      );
    });

    //We want to be able to set the customized options even if the chart
    //doesn't exist
    highed.setAttr(customizedOptions, id, value, index);

    flatOptions[id] = value;

    if (id.indexOf('lang--') === 0 && customizedOptions.lang) {
      Highcharts.setOptions({
        lang: customizedOptions.lang
      });
    }

    updateAggregated();
    init(aggregatedOptions, false, true);
    emitChange();

    events.emit('AttrChange', {
      id: id.replace(/\-\-/g, '.').replace(/\-/g, '.'),
      value: value
    });
  }

  /** Get embeddable JSON
   *  This returns the merged chart, with both customized options
   *  and options set indirectly through templates.
   *  @memberof highed.ChartPreview
   *  @name export.json
   *  @returns {object} - the chart object
   */
  function getEmbeddableJSON(noCustomCode) {
    var r;

    updateAggregated(noCustomCode);
    r = getCleanOptions(highed.merge({}, aggregatedOptions));

    //This should be part of the series
    if (!highed.isNull(r.data)) {
      // Don't delete spreadsheet stuff
      if (!r.data.googleSpreadsheetKey) {
        r.data = undefined;
      }
      //delete r['data'];
    }

    if (r && highed.isArr(r.series)) {
      r.series = r.series.map(function(s) {
        var cloned = highed.merge({}, s);
        delete s.data;
        return s;
      });
    }

    if (lastLoadedSheet) {
      highed.merge(r, {
        data: lastLoadedSheet
      });
    } else if (lastLoadedLiveData) {
      highed.merge(r, {
        data: lastLoadedLiveData,
        googleSpreadsheetKey: false,
        googleSpreadsheetWorksheet: false
      });
    } else if (lastLoadedCSV) {
      highed.merge(r, {
        data: {
          csv: lastLoadedCSV,
          googleSpreadsheetKey: false,
          googleSpreadsheetWorksheet: false
        }
      });
    }

    return r;
  }

  /**
   * Convert the chart to a string
   */
  function toString(tabs) {
    return stringifyFn(getEmbeddableJSON(), tabs);
  }

  /** Get embeddable SVG
   *  @memberof highed.ChartPreview
   *  @name export.svg
   *  @returns {string} - the result from `Highcharts.Chart.getSVG()`
   */
  function getEmbeddableSVG() {
    return gc(function(chart) {
      return highed.isFn(chart.getSVG) ? chart.getSVG() : '';
    });
  }

  /** Get embeddable JavaScript
   *  @memberof highed.ChartPreview
   *  @name export.js
   *  @param id {string} - the ID of the node to attach the chart to
   *  @returns {string} - a string containing JavaScript to reproduce the chart
   */
  function getEmbeddableJavaScript(id) {
    return gc(function(chart) {
      var cdnIncludes = [
          'https://code.highcharts.com/stock/highstock.js',
          'https://code.highcharts.com/highcharts-more.js',
          'https://code.highcharts.com/highcharts-3d.js',
          'https://code.highcharts.com/modules/data.js',
          'https://code.highcharts.com/modules/exporting.js',
          'https://code.highcharts.com/modules/funnel.js',
          'https://code.highcharts.com/modules/annotations.js',
          // 'https://code.highcharts.com/modules/series-label.js'
          'https://code.highcharts.com/modules/solid-gauge.js'
        ],
        cdnIncludesArr = [],
        title =
          chart.options && chart.options.title
            ? chart.options.title.text || 'untitled chart'
            : 'untitled chart';

      id = id || '';

      /*
                This magic code will generate an injection script that will
                check if highcharts is included, and include it if not.
                Afterwards, it will create the chart, and insert it into the page.

                It's quite messy, could to client-side templating or something,
                but it works.
            */

      if (highed.option('includeCDNInExport')) {
        cdnIncludesArr = [
          'var files = ',
          JSON.stringify(cdnIncludes),
          ',',
          'loaded = 0; ',
          'if (typeof window["HighchartsEditor"] === "undefined") {',
          'window.HighchartsEditor = {',
          'ondone: [cl],',
          'hasWrapped: false,',
          'hasLoaded: false',
          '};',
          'include(files[0]);',
          '} else {',
          'if (window.HighchartsEditor.hasLoaded) {',
          'cl();',
          '} else {',
          'window.HighchartsEditor.ondone.push(cl);',
          '}',
          '}',
          'function isScriptAlreadyIncluded(src){',
          'var scripts = document.getElementsByTagName("script");',
          'for (var i = 0; i < scripts.length; i++) {',
          'if (scripts[i].hasAttribute("src")) {',
          'if ((scripts[i].getAttribute("src") || "").indexOf(src) >= 0 || (scripts[i].getAttribute("src") === "http://code.highcharts.com/highcharts.js" && src === "https://code.highcharts.com/stock/highstock.js")) {',
          'return true;',
          '}',
          '}',
          '}',
          'return false;',
          '}',
          'function check() {',
          'if (loaded === files.length) {',
          'for (var i = 0; i < window.HighchartsEditor.ondone.length; i++) {',
          'try {',
          'window.HighchartsEditor.ondone[i]();',
          '} catch(e) {',
          'console.error(e);',
          '}',
          '}',
          'window.HighchartsEditor.hasLoaded = true;',
          '}',
          '}',

          'function include(script) {',
          'function next() {',
          '++loaded;',
          'if (loaded < files.length) {',
          'include(files[loaded]);',
          '}',
          'check();',
          '}',
          'if (isScriptAlreadyIncluded(script)) {',
          'return next();',
          '}',
          'var sc=document.createElement("script");',
          'sc.src = script;',
          'sc.type="text/javascript";',
          'sc.onload=function() { next(); };',
          'document.head.appendChild(sc);',
          '}',

          'function each(a, fn){',
          'if (typeof a.forEach !== "undefined"){a.forEach(fn);}',
          'else{',
          'for (var i = 0; i < a.length; i++){',
          'if (fn) {fn(a[i]);}',
          '}',
          '}',
          '}',

          'var inc = {},incl=[]; each(document.querySelectorAll("script"), function(t) {inc[t.src.substr(0, t.src.indexOf("?"))] = 1; ',
          '});'
        ];
      }

      return (
        '\n' +
        [
          '(function(){ ',

          cdnIncludesArr.join(''),

          ' function cl() {',
          'if(typeof window["Highcharts"] !== "undefined"){', //' && Highcharts.Data ? ',

          !customizedOptions.lang
            ? ''
            : 'Highcharts.setOptions({lang:' +
              JSON.stringify(customizedOptions.lang) +
              '});',
          'var options=',
          stringifyFn(getEmbeddableJSON(true)),
          ';',
          highed.isFn(customCode) ? customCodeStr : '',
          'new Highcharts.' + constr + '("',
          id,
          '", options);',
          '}',
          '}',
          '})();'
        ].join('') +
        '\n'
      );
    });
  }

  function getCodePreview() {
    var options = getEmbeddableJSON(true);

    if (highed.isFn(customCode) && customCodeStr) {
      customCode(options);
    }

    return stringifyFn(options, '  ');
  }

  /** Get embeddable HTML
   *  @memberof highed.ChartPreview
   *  @name export.html
   *  @param placehold {bool} - if true, SVG will also be embedded
   *  @returns {string} - a string of embeddable HTML
   */
  function getEmbeddableHTML(placehold) {
    return gc(function(chart) {
      var id = 'highcharts-' + highed.uuid();
      return (
        '\n' +
        [
          '<div id="',
          id,
          '">',
          placehold ? getEmbeddableSVG() : '',
          '</div>'
        ].join('') +
        '<script>' +
        getEmbeddableJavaScript(id) +
        '</script>'
      );
    });
  }

  /**
   * Expand the chart from its drawer
   * @memberof highed.ChartPreview
   */
  function expand() {
    gc(function(chart) {
      if (!expanded) {
        highed.dom.style(properties.expandTo, {
          width: '100%',
          display: 'block'
        });

        preExpandSize = highed.dom.size(parent);
        init(chart.options, properties.expandTo);
        expanded = true;

        toggleButton.className =
          'highed-icon highed-chart-preview-expand fa fa-times-circle';
      }
    });
  }

  /** Collapse the chart into its drawer
   *  @memberof highed.ChartPreview
   */
  function collapse() {
    gc(function(chart) {
      if (preExpandSize && expanded) {
        highed.dom.style(properties.expandTo, {
          width: '0px',
          display: 'none'
        });

        toggleButton.className =
          'highed-icon highed-chart-preview-expand fa fa-external-link-square';

        init(chart.options, parent);
        expanded = false;
      }
    });
  }

  /** Flush all options and start over
   *  @memberof highed.ChartPreview
   *  @name new
   */
  function newChart() {
    highed.cloud.flush();

    highed.clearObj(templateOptions);
    highed.clearObj(customizedOptions);
    highed.clearObj(flatOptions);

    customCode = false;

    // highed.merge(customizedOptions, properties.defaultChartOptions);

    updateAggregated();

    init(aggregatedOptions);

    emitChange();
    events.emit('New');
  }

  /** Export the chart - calls `Highcharts.Chart.exportChart(..)`
   *  @memberof highed.ChartPreview
   *  @name data.export
   *  @param optons {object} - the export options
   */
  function exportChart(options) {
    gc(function(chart) {
      chart.exportChart(options, aggregatedOptions);
    });
  }

  /** Attach to a new DOM parent
   *  @memberof highed.ChartPreview
   *  @param newParent {DOMNode} - the node to attach to
   */
  function changeParent(newParent) {
    parent = newParent;
    init();
  }

  /** Returns the constructor currently in use
   *  @memberof highed.ChartPreview
   *  @returns {string}
   */
  function getConstructor() {
    return constr;
  }

  function getTheme() {
    return {
      id: themeMeta.id,
      name: themeMeta.name,
      options: themeOptions
    };
  }

  function getCustomCode() {
    return customCodeStr && customCodeStr.length
      ? customCodeStr
      : customCodeDefault;

    // return highed.isFn(customCode) ?
    // customCodeStr || customCodeDefault :
    // customCode || customCodeDefault;
  }

  function setCustomCode(newCode, errFn, skipEmit) {
    var fn;

    if (!newCode) {
      customCode = false;
      customCodeStr = '';
    }

    try {
      // eval('(var options = {};' + newCode + ')');
      customCode = new Function(
        'options',
        [
          'if (options.yAxis && options.yAxis.length === 1) options.yAxis = options.yAxis[0];',
          'if (options.xAxis && options.xAxis.length === 1) options.xAxis = options.xAxis[0];',
          'if (options.zAxis && options.zAxis.length === 1) options.zAxis = options.zAxis[0];',
          'if (!options.series || options.series.length === 0) return;',
          'var encodedUrl = "";'
        ].join('') + newCode
      );
      customCodeStr = newCode;
    } catch (e) {
      customCode = false;
      customCodeStr = newCode;
      return highed.isFn(errFn) && errFn(e);
    }

    if (!skipEmit) {
      updateAggregated();
      init(aggregatedOptions);
      emitChange();
    }
  }

  ///////////////////////////////////////////////////////////////////////////

  //Init the initial chart
  updateAggregated();
  init();

  highed.dom.on(toggleButton, 'click', function() {
    return expanded ? collapse() : expand();
  });

  ///////////////////////////////////////////////////////////////////////////

  exports = {
    assignTheme: assignTheme,
    clearTheme: clearTheme,
    getTheme: getTheme,
    getConstructor: getConstructor,
    on: events.on,
    expand: expand,
    collapse: collapse,
    new: newChart,
    changeParent: changeParent,

    getHighchartsInstance: gc,

    loadTemplate: loadTemplate,
    loadSeries: loadSeriesData,
    resize: resize,

    setCustomCode: setCustomCode,
    getCustomCode: getCustomCode,

    toProject: toProject,
    toProjectStr: toProjectStr,
    loadProject: loadProject,

    toString: toString,

    options: {
      set: set,
      setAll: setChartOptions,
      customized: customizedOptions,
      getCustomized: function() {
        return customizedOptions;
      },
      full: aggregatedOptions,
      flat: flatOptions,
      chart: chartOptions,
      getPreview: getCodePreview
    },

    data: {
      csv: loadCSVData,
      json: loadJSONData,
      settings: loadChartSettings,
      export: exportChart,
      gsheet: loadGSpreadsheet,
      clear: clearData,
      live: loadLiveData
    },

    export: {
      html: getEmbeddableHTML,
      json: getEmbeddableJSON,
      svg: getEmbeddableSVG,
      js: getEmbeddableJavaScript
    }
  };

  return exports;
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var modal = highed.OverlayModal(false, {
    showOnInit: false,
    zIndex: 11000,
    width: 300,
    height: 400
  });

  highed.dom.ap(
    modal.body,
    highed.dom.cr('span', '', 'License info goes here')
  );

  highed.licenseInfo = {
    /** Show license information modal
     *  @namespace highed.licenseInfo
     *  @type function
     */
    show: modal.show
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

(function() {
  var flatOptions = {};

  function dive(tree) {
    if (tree) {
      if (highed.isArr(tree)) {
        tree.forEach(dive);
      } else if (tree.options) {
        if (highed.isArr(tree.options)) {
          tree.options.forEach(dive);
        } else {
          Object.keys(tree.options).forEach(function(key) {
            dive(tree.options[key]);
          });
        }
      } else if (tree.id) {
        flatOptions[tree.id] = tree;
      }
    }
  }

  dive(highed.meta.optionsExtended);

  /** Simple version of the customizer. Whitelisted options
   *  @constructor
   *  @emits PropertyChange - when a property is modified
   *  @param parent {domnode} - the node to append to
   *  @param attributes {object} - settings
   *    > availableSettings {array} - whitelist of options to include
   */
  highed.SimpleCustomizer = function(parent, attributes) {
    var events = highed.events(),
      container = highed.dom.cr('div', 'highed-simple-customizer'),
      table = highed.dom.cr('table', 'highed-customizer-table'),
      properties = highed.merge(
        {
          availableSettings: [
            'title--text',
            'subtitle--text',
            'colors',
            'chart--backgroundColor',
            'yAxis-title--style',
            'yAxis--type',
            'yAxis--opposite',
            'yAxis--reversed',
            'yAxis-labels--format'
          ]
        },
        attributes
      );

    ////////////////////////////////////////////////////////////////////////

    /** Build the property setter
     *  @memberof highed.SimpleCustomizer
     *  @param options {object} - the current chart options
     */
    function build(options) {
      table.innerHTML = '';

      properties.availableSettings.forEach(function(name) {
        var group = highed.merge(
          {
            text: name.replace(/\-/g, ' '),
            id: name,
            tooltipText: false,
            dataType: 'string',
            defaults: false,
            custom: {},
            values: false
          },
          flatOptions[name]
        );

        highed.dom.ap(
          table,
          highed.InspectorField(
            group.values ? 'options' : group.dataType,
            highed.getAttr(options, group.id, 0) || group.defaults,
            {
              title: group.text,
              tooltip: group.tooltipText,
              values: group.values,
              custom: group.custom,
              defaults: group.defaults,
              attributes: group.attributes || []
            },
            function(newValue) {
              events.emit('PropertyChange', group.id, newValue, 0);
            },
            false,
            group.id
          )
        );
      });
    }

    function highlightNode(n) {
      if (!n) return;

      highed.dom.style(n, {
        border: '2px solid #33aa33'
      });

      n.focus();
      n.scrollIntoView(true);

      window.setTimeout(function() {
        highed.dom.style(n, {
          border: ''
        });
      }, 2000);
    }

    /** Focus a field in the inspector
     *  @memberof highed.SimpleCustomizer
     *  @param thing {object} - the thing to focus
     *    > id {anything} - the id of the field
     *  @param x {number} - the x position the request came from
     *  @param y {number} - the y position the request came from
     */
    function focus(thing, x, y) {
      var id = thing.id;
      if (id.indexOf('-') >= 0) {
        highlightNode(table.querySelector('#' + id));
      }
    }

    ////////////////////////////////////////////////////////////////////////

    highed.ready(function() {
      highed.dom.ap(
        parent,
        highed.dom.ap(
          container,
          highed.dom.cr('div', 'highed-customizer-table-heading', 'Edit Chart'),
          table
        )
      );
    });

    return {
      focus: focus,
      on: events.on,
      build: build
    };
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

 ******************************************************************************/

// @format

(function() {
  function createTeamDropDown(target) {
    var dropdown = highed.DropDown(target);

    function refresh() {
      dropdown.clear();

      highed.cloud.getTeams(function(teamCollection) {
        teamCollection.forEach(function(team) {
          dropdown.addItem({
            id: team.id,
            title: team.name
          });
        });

        dropdown.selectByIndex(0);
      });
    }

    return {
      refresh: refresh,
      dropdown: dropdown
    };
  }

  var chartPreview = false,
    modal = highed.OverlayModal(document.body, {
      //eslint-disable-line no-undef
      showOnInit: false,
      width: '90%',
      height: '90%',
      zIndex: 10001
    }),
    mainContainer = highed.dom.cr('div'),
    charts = highed.dom.cr('div', 'highed-cloud-chart-container'),
    teams = createTeamDropDown(mainContainer),
    pageNavigation = highed.dom.cr('div', 'highed-cloud-paging'),
    activeTeam,
    activeChart,
    saveNewModal = highed.OverlayModal(document.body, {
      //eslint-disable-line no-undef
      showOnInt: false,
      width: 400,
      height: 300,
      zIndex: 10001
    }),
    saveNewTeamsContainer = highed.dom.cr('div'),
    saveNewTeams = createTeamDropDown(saveNewTeamsContainer),
    saveNewName = highed.dom.cr('input', 'highed-field-input'),
    saveNewBtn = highed.dom.cr('button', 'highed-ok-button', 'Save to cloud'),
    loginForm = false;

  highed.dom.ap(
    saveNewModal.body,
    highed.dom.cr('span', 'highed-titlebar', 'Save to Cloud'),
    highed.dom.cr('div', '', 'Team'),
    saveNewTeamsContainer,
    highed.dom.cr('br'),
    highed.dom.cr('div', '', 'Chart Name'),
    saveNewName,
    saveNewBtn
  );

  highed.dom.on(saveNewBtn, 'click', function() {
    saveNewBtn.disabled = true;
    saveNewBtn.innerHTML = 'SAVING TO CLOUD...';

    highed.cloud.saveNewChart(
      activeTeam,
      saveNewName.value,
      JSON.stringify(chartPreview.toProject()),
      function(data) {
        saveNewBtn.disabled = false;
        if (!data.error && data) {
          activeChart = data;
          saveNewModal.hide();
          saveNewBtn.innerHTML = 'SAVE TO CLOUD';
          highed.snackBar('SAVED TO CLOUD');
        } else {
          highed.snackBar('Error saving to cloud');
        }
      }
    );
  });

  saveNewTeams.dropdown.on('Change', function(item) {
    activeTeam = item.id();
  });

  function addChart(chart) {
    var container = highed.dom.cr('div', 'highed-cloud-chart'),
      thumbnail = highed.dom.cr('div', 'highed-cloud-thumbnail');

    highed.dom.ap(
      charts,
      highed.dom.ap(
        container,
        thumbnail,
        highed.dom.cr('div', 'highed-cloud-chart-title', chart.name)
      )
    );

    highed.dom.style(thumbnail, {
      'background-image':
        'url(' + chart.thumbnail_url + '?t=' + new Date().getTime() + ')'
    });

    highed.dom.on(thumbnail, 'click', function() {
      if (chartPreview) {
        highed.cloud.getChart(chart.team_owner, chart.id, function(data) {
          try {
            chartPreview.loadProject(JSON.parse(data.data));
            activeChart = chart.id;
            activeTeam = chart.team_owner;
            modal.hide();
          } catch (e) {
            highed.snackbar(e);
          }
        });
      }
    });
  }

  highed.dom.style(mainContainer, { display: 'none' });

  highed.dom.ap(
    modal.body,
    highed.dom.cr(
      'span',
      'highed-titlebar',
      'Load project from Highcharts Cloud'
    ),
    highed.dom.ap(mainContainer, charts, pageNavigation)
  );

  function getCharts(page, teamID) {
    // Load charts here
    charts.innerHTML = 'Loading Charts';
    highed.cloud.getCharts(
      teamID,
      function(chartCollection, full) {
        charts.innerHTML = '';
        pageNavigation.innerHTML = '';

        if (full.pageCount > 1) {
          for (var i = 1; i <= full.pageCount; i++) {
            (function(pageIndex) {
              var item = highed.dom.cr('span', 'highed-cloud-paging-item', i);

              if (pageIndex === page) {
                item.className += ' selected';
              }

              highed.dom.on(item, 'click', function() {
                getCharts(pageIndex, teamID);
              });

              highed.dom.ap(pageNavigation, item);
            })(i);
          }
        }

        chartCollection.forEach(addChart);
      },
      page
    );
  }

  teams.dropdown.on('Change', function(item) {
    getCharts(false, item.id());
  });

  highed.cloud.flush = function() {
    activeChart = false;
    activeTeam = false;
  };

  highed.cloud.save = function(chartp) {
    highed.cloud.loginForm(function() {
      saveNewName.value = '';
      saveNewName.focus();
      chartPreview = chartp || chartPreview;
      if (activeChart && activeTeam) {
        // Save project
        highed.cloud.saveExistingChart(
          activeTeam,
          activeChart,
          JSON.stringify(chartPreview.toProject()),
          function() {
            highed.snackbar('CHART SAVED TO CLOUD');
          }
        );
      } else {
        // Show save as new UI
        saveNewModal.show();
        saveNewTeams.refresh();
      }
    });
  };

  highed.cloud.showUI = function(preview) {
    highed.cloud.loginForm(function() {
      chartPreview = preview;
      modal.show();
      teams.refresh();
    });
  };

  function createLoginForm() {
    var body = highed.dom.cr('div', 'highed-cloud-login-container'),
      username = highed.dom.cr('input', 'highed-cloud-input'),
      password = highed.dom.cr('input', 'highed-cloud-input'),
      btn = highed.dom.cr('button', 'highed-ok-button', 'LOGIN'),
      notice = highed.dom.cr('div', 'highed-cloud-login-error'),
      loginCallback = false,
      modal = highed.OverlayModal(false, {
        height: 300,
        width: 250,
        zIndex: 10001
      });

    username.name = 'cloud-username';
    password.name = 'cloud-password';

    username.placeholder = 'E-Mail';
    password.placeholder = 'Your password';
    password.type = 'password';

    highed.dom.ap(
      modal.body,
      highed.dom.ap(
        body,
        highed.dom.cr('h3', '', 'Login to Highcharts Cloud'),
        notice,
        username,
        password,
        btn,
        highed.dom.cr(
          'div',
          'highed-cloud-login-notice',
          'Requires a Highcharts Cloud account'
        )
      )
    );

    highed.dom.on(btn, 'click', function() {
      btn.disabled = true;
      highed.dom.style(notice, { display: 'none' });

      highed.cloud.login(username.value, password.value, function(err, res) {
        btn.disabled = false;

        if (err || !res || typeof res.token === 'undefined') {
          notice.innerHTML =
            'Error: Check username/password (' + (err || res.message) + ')';
          highed.dom.style(notice, { display: 'block' });
        } else {
          modal.hide();
          if (highed.isFn(loginCallback)) {
            loginCallback();
          }
        }
      });
    });

    return function(fn) {
      loginCallback = fn || function() {};
      if (highed.cloud.isLoggedIn()) {
        loginCallback();
      } else {
        modal.show();
      }
    };
  }

  highed.cloud.loginForm = function(fn) {
    if (!loginForm) {
      loginForm = createLoginForm();
    }
    loginForm(fn);
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/* global window */

highed.DrawerEditor = function(parent, options) {
  var events = highed.events(),
    // Main properties
    properties = highed.merge(
      {
        defaultChartOptions: {},
        useHeader: true,
        features: [
          'data',
          'templates',
          'customize',
          'customcode',
          'advanced',
          'export'
        ],
        importer: {},
        dataGrid: {},
        customizer: {},
        toolbarIcons: []
      },
      options
    ),
    errorBar = highed.dom.cr(
      'div',
      'highed-errorbar highed-box-size highed-transition'
    ),
    errorBarHeadline = highed.dom.cr(
      'div',
      'highed-errorbar-headline',
      'This is an error!'
    ),
    errorBarBody = highed.dom.cr(
      'div',
      'highed-errorbar-body highed-scrollbar',
      'Oh noes! something is very wrong!'
    ),
    lastSetWidth = false,
    fixedSize = false,
    splitter = highed.VSplitter(parent, {
      topHeight: properties.useHeader ? '60px' : '0px',
      noOverflow: true
    }),
    toolbar = highed.Toolbar(splitter.top),
    toolbox = highed.Toolbox(splitter.bottom),
    // Data table
    dataTableContainer = highed.dom.cr('div', 'highed-box-size highed-fill'),
    dataTable = highed.DataTable(
      dataTableContainer,
      highed.merge(
        {
          importer: properties.importer
        },
        properties.dataGrid
      )
    ),
    // Chart preview
    chartFrame = highed.dom.cr(
      'div',
      'highed-transition highed-box-size highed-chart-frame highed-scrollbar'
    ),
    chartContainer = highed.dom.cr(
      'div',
      'highed-box-size highed-chart-frame-body'
    ),
    chartPreview = highed.ChartPreview(chartContainer, {
      defaultChartOptions: properties.defaultChartOptions
    }),
    // Res preview bar
    resPreviewBar = highed.dom.cr('div', 'highed-res-preview'),
    resQuickSelContainer = highed.dom.cr('div', 'highed-res-quicksel'),
    resQuickSel = highed.DropDown(resQuickSelContainer),
    resWidth = highed.dom.cr('input', 'highed-res-number'),
    resHeight = highed.dom.cr('input', 'highed-res-number'),
    // Exporter
    exporterContainer = highed.dom.cr('div', 'highed-box-size highed-fill'),
    exporter = highed.Exporter(exporterContainer),
    // Templates
    templatesContainer = highed.dom.cr('div', 'highed-box-size highed-fill'),
    templates = highed.ChartTemplateSelector(templatesContainer, chartPreview),
    // Customizer
    customizerContainer = highed.dom.cr('div', 'highed-box-size highed-fill'),
    customizer = highed.ChartCustomizer(
      customizerContainer,
      properties.customizer,
      chartPreview
    ),
    // Toolbar buttons
    toolbarButtons = [
      {
        title: highed.L('newChart'),
        css: 'fa-file',
        click: function() {
          if (window.confirm(highed.getLocalizedStr('confirmNewChart'))) {
            chartPreview.new();
          }
        }
      },
      {
        title: highed.L('saveProject'),
        css: 'fa-floppy-o',
        click: function() {
          var name;

          if (chartPreview.options.full.title) {
            name = chartPreview.options.full.title.text;
          }

          name = (name || 'chart').replace(/\s/g, '_');

          highed.download(name + '.json', chartPreview.toProjectStr());
        }
      },
      {
        title: highed.L('openProject'),
        css: 'fa-folder-open',
        click: function() {
          highed.readLocalFile({
            type: 'text',
            accept: '.json',
            success: function(file) {
              try {
                file = JSON.parse(file.data);
              } catch (e) {
                return highed.snackBar('Error loading JSON: ' + e);
              }

              chartPreview.loadProject(file);
            }
          });
        }
      },
      '-',
      {
        title: highed.L('saveCloud'),
        css: 'fa-cloud-upload',
        click: function() {
          highed.cloud.save(chartPreview);
        }
      },
      {
        title: highed.L('loadCloud'),
        css: 'fa-cloud-download',
        click: function() {
          highed.cloud.showUI(chartPreview);
        }
      },
      '-',
      {
        title: 'Help',
        css: 'fa-question-circle',
        click: function() {
          window.open(highed.option('helpURL'));
        }
      }
    ].concat(properties.toolbarIcons),
    // Custom toolbox options
    customOptions = {},
    // The toolbox options
    builtInOptions = {
      data: {
        icon: 'fa-table',
        title: 'Chart Data',
        width: 800,
        help: [
          {
            title: 'Manually Add/Edit Data',
            gif: 'dataImport.gif',
            description: [
              'Click a cell to edit its contents.<br/><br/>',
              'The cells can be navigated using the arrow keys.<br/><br/>',
              'Pressing Enter creates a new row, or navigates to the row directly below the current row.'
            ]
          },
          {
            title: 'Setting headings',
            gif: 'dataImport.gif',
            description: [
              'The headings are used as the series titles.<br/><br/>',
              'They can be edited by left clicking them.<br/><br/>',
              'Click the arrow symbol in the header to access column properties.'
            ]
          },
          {
            title: 'Importing Data',
            gif: 'import.gif',
            description: [
              'To import data, simply drag and drop CSV files onto the table, or paste CSV/Excel data into any cell.<br/><br/>',
              'For more advanced data import, click the IMPORT DATA button.'
            ]
          }
        ],
        create: function(body) {
          highed.dom.ap(body, dataTableContainer);
          dataTable.resize();
        },
        events: {
          Expanded: function(width, height) {
            dataTable.resize(width, height);
          }
        },
        showLiveStatus: true
      },
      templates: {
        icon: 'fa-bar-chart',
        width: 700,
        title: 'Templates',
        help: [
          {
            title: 'Templates',
            description: [
              'Templates are pre-defined bundles of configuration.<br/><br/>',
              'Start by choosing the template category in the list to the left,',
              'then pick a suitable template for your data and use case in the',
              'template list.'
            ]
          }
        ],
        create: function(body) {
          highed.dom.ap(body, templatesContainer);
        },
        events: {
          Expanded: function(width, height) {
            templates.resize(width, height);
          }
        }
      },
      export: {
        icon: 'fa-download',
        title: 'Export',
        width: 600,
        help: [
          {
            title: 'Export Chart',
            description: [
              'The export pane lets you export your chart to HTML, SVG, JSON, or JavaScript.<br/><br/>'
            ]
          }
        ],
        create: function(body) {
          highed.dom.ap(body, exporterContainer);
          exporter.resize();
        },
        events: {
          Expanded: function(width, height) {
            exporter.resize(width, height);
            exporter.init(
              chartPreview.export.json(),
              chartPreview.export.html(),
              chartPreview.export.svg(),
              chartPreview
            );
          }
        }
      },
      customize: {
        icon: 'fa-sliders',
        title: 'Customize Chart',
        width: 800,
        help: [
          {
            title: 'Customize',
            description: [
              'The customize pane lets you customize your chart.<br/><br/>',
              'The customizer has three different sections:<br/>',
              '<li>Simple: A simple customizer with the most used options</li>',
              '<li>Advanced: All options available in Highcharts/Highstock can be set here</li>',
              '<li>Custom code: Here, properties can be overridden programatically</li>'
            ]
          }
        ],
        create: function(body) {
          highed.dom.ap(body, customizerContainer);
          customizer.resize();
        },
        events: {
          Expanded: function(width, height) {
            customizer.resize(width, height);
          }
        }
      }
    },
    toolboxEntries,
    resolutions = {
      'Stretch to fit': [false, false],
      'iPhone X': [375, 812],
      'iPhone 8 Plus': [414, 736],
      'iPhone 8': [375, 667],
      'iPhone 7 Plus': [414, 736],
      'iPhone 7': [375, 667],
      'iPhone 6 Plus': [414, 736],
      'iPhone 6/6S': [375, 667],
      'iPhone 5': [320, 568],
      'iPad Pro': [1024, 1366],
      iPad: [768, 1024],
      'Nexus 6P': [411, 731],
      'Nexus 5X': [411, 731],
      'Google Pixel': [411, 731],
      'Google Pixel XL': [411, 731],
      'Google Pixel 2': [411, 731],
      'Google Pixel 2 XL': [411, 731],
      'Samsung Galaxy Note 5': [480, 853],
      'LG G5': [480, 853],
      'One Plus 3': [480, 853],
      'Samsung Galaxy S8': [360, 740],
      'Samsung Galaxy S8+': [360, 740],
      'Samsung Galaxy S7': [360, 640],
      'Samsung Galaxy S7 Edge': [360, 640]
    };

  if (!properties.useHeader) {
    highed.dom.style(splitter.top.parentNode, {
      display: 'none'
    });
  }

  // Alias import to data
  builtInOptions.import = builtInOptions.data;

  /**
   * Creates the features defined in property.features
   * Call this after changing properties.features to update the options.
   */
  function createFeatures() {
    var addedOptions = {};

    properties.features = highed.isArr(properties.features)
      ? properties.features
      : properties.features.split(' ');

    function addOption(option, id) {
      if (!option || !option.icon) {
        return;
      }

      var o = toolbox.addEntry({
        title: option.title,
        width: option.width,
        iconOnly: option.iconOnly,
        icon: option.icon,
        help: option.help,
        showLiveStatus: option.showLiveStatus
      });

      if (highed.isFn(option.create)) {
        option.create(o.body);
      }

      Object.keys(option.events || {}).forEach(function(e) {
        o.on(e, option.events[e]);
      });

      addedOptions[id] = o;
    }

    toolbox.clear();
    resize();

    properties.features.forEach(function(feature) {
      addOption(
        builtInOptions[feature] || customOptions[feature] || false,
        feature
      );
    });

    if (addedOptions.data) {
      setTimeout(addedOptions.data.expand, 200);
    }

    toolboxEntries = addedOptions;
    // resizeChart(toolbox.width());
  }

  /**
   * Create toolbar
   */
  function createToolbar() {
    toolbarButtons.forEach(function(b) {
      if (b === '-') {
        toolbar.addSeparator();
      } else {
        toolbar.addIcon(b);
      }
    });
  }

  /**
   * Resize the chart preview based on a given width
   */
  function resizeChart(newWidth) {
    var psize = highed.dom.size(splitter.bottom);

    lastSetWidth = newWidth;

    highed.dom.style(chartFrame, {
      left: newWidth + 'px',
      width: psize.w - newWidth + 'px',
      height: psize.h + 'px'
    });

    if (fixedSize) {
      // Update size after the animation is done
      setTimeout(function() {
        sizeChart(fixedSize.w, fixedSize.h);
      }, 400);
      return;
    }

    highed.dom.style(chartContainer, {
      width: psize.w - newWidth - 100 + 'px',
      height: psize.h - 100 + 'px'
    });

    chartPreview.resize();
  }

  function sizeChart(w, h) {
    if ((!w || w.length === 0) && (!h || h.length === 0)) {
      fixedSize = false;
      resHeight.value = '';
      resWidth.value = '';
      resizeChart(lastSetWidth);
    } else {
      var s = highed.dom.size(chartFrame);

      // highed.dom.style(chartFrame, {
      //   paddingLeft: (s.w / 2) - (w / 2) + 'px',
      //   paddingTop: (s.h / 2) - (h / 2) + 'px'
      // });

      fixedSize = {
        w: w,
        h: h
      };

      w = w || s.w - 100;
      h = h || s.h - 100;

      highed.dom.style(chartContainer, {
        width: w + 'px',
        height: h + 'px'
      });

      chartPreview.resize();
    }
  }

  /**
   * Resize everything
   */
  function resize() {
    splitter.resize();
    resizeChart(toolbox.width());
  }

  /**
   * Change the enabled features
   */
  function setEnabledFeatures(feats) {
    properties.features = feats;
    createFeatures();
  }

  /**
   * Add a new feature
   */
  function addFeature(name, feat) {
    customOptions[name] = feat;
    createFeatures();
  }

  function destroy() {}

  function addImportTab(tabOptions) {
    dataTable.addImportTab(tabOptions);
  }

  function hideImportModal() {
    dataTable.hideImportModal();
  }
  function showError(title, message) {
    highed.dom.style(errorBar, {
      opacity: 1,
      'pointer-events': 'auto'
    });

    errorBarHeadline.innerHTML = title;
    errorBarBody.innerHTML = message;
  }

  function hideError() {
    highed.dom.style(errorBar, {
      opacity: 0,
      'pointer-events': 'none'
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Event attachments

  toolbox.on('BeforeResize', resizeChart);

  customizer.on('PropertyChange', chartPreview.options.set);
  customizer.on('PropertySetChange', chartPreview.options.setAll);

  chartPreview.on('LoadProjectData', function(csv) {
    dataTable.loadCSV(
      {
        csv: csv
      },
      true
    );
  });

  chartPreview.on('ChartChange', function(newData) {
    events.emit('ChartChangedLately', newData);
  });

  templates.on('Select', function(template) {
    chartPreview.loadTemplate(template);
  });

  templates.on('LoadDataSet', function(sample) {
    if (sample.type === 'csv') {
      if (highed.isArr(sample.dataset)) {
        chartPreview.data.csv(sample.dataset.join('\n'));
      } else {
        chartPreview.data.csv(sample.dataset);
      }

      chartPreview.options.set('subtitle-text', '');
      chartPreview.options.set('title-text', sample.title);
    }
  });

  dataTable.on('LoadLiveData', function(settings){
    //chartPreview.data.live(settings);

    const liveDataSetting = {};

    liveDataSetting[settings.type] = settings.url;
    if (settings.interval && settings.interval > 0){
      liveDataSetting.enablePolling = true;
      liveDataSetting.dataRefreshRate = settings.interval
    }
    chartPreview.data.live(liveDataSetting);
  });
/*
  dataTable.on('UpdateLiveData', function(p){
    chartPreview.data.liveURL(p);
  });
*/
  chartPreview.on('LoadProject', function () {
    setTimeout(function () {
    resQuickSel.selectByIndex(0);
    setToActualSize();
    }, 2000);
  });

  dataTable.on('LoadGSheet', function(settings) {
    chartPreview.data.gsheet(settings);
  });

  chartPreview.on('RequestEdit', function(event, x, y) {
    // Expanded
    if (toolboxEntries.customize.body.offsetWidth) {
      customizer.focus(event, x, y);

      // Collapsed
    } else {
      var unbind = toolboxEntries.customize.on('Expanded', function() {
        customizer.focus(event, x, y);
        unbind();
      });
      toolboxEntries.customize.expand();
    }
  });

  dataTable.on('Change', function(headers, data) {
    return chartPreview.data.csv({
      csv: dataTable.toCSV(';', true)
    });
  });

  dataTable.on('ClearData', function() {
    chartPreview.data.clear();
  });

  chartPreview.on('ProviderGSheet', function(p) {
    dataTable.initGSheet(
      p.id || p.googleSpreadsheetKey,
      p.worksheet || p.googleSpreadsheetWorksheet,
      p.startRow,
      p.endRow,
      p.startColumn,
      p.endColumn,
      true,
      p.dataRefreshRate
    );
  });

  chartPreview.on('ProviderLiveData', function(p) {
    dataTable.loadLiveDataPanel(p);
  });

  chartPreview.on('Error', function(e) {
    if (e.indexOf('Highcharts error') >= 0) {
      var i1 = e.indexOf('#'),
        i = e.substr(i1).indexOf(':'),
        id = parseInt(e.substr(i1 + 1, i), 10),
        item = highed.highchartsErrors[id],
        urlStart = e.indexOf('www.'),
        url = '';

      if (urlStart >= 0) {
        url =
          '<div class="highed-errorbar-more"><a href="https://' +
          e.substr(urlStart) +
          '" target="_blank">Click here for more information</a></div>';
      }

      return showError(
        (item.title || "There's a problem with your chart") + '!',
        (item.text || e) + url
      );
    }

    showError("There's a problem with your chart!", e);
  });

  chartPreview.on('ChartRecreated', hideError);

  if (!highed.onPhone()) {
    highed.dom.on(window, 'resize', resize);
  }

  //////////////////////////////////////////////////////////////////////////////

  highed.dom.ap(
    toolbar.left,
    highed.dom.style(highed.dom.cr('span'), {
      'margin-left': '2px',
      width: '200px',
      height: '60px',
      float: 'left',
      display: 'inline-block',
      'background-position': 'left middle',
      'background-size': 'auto 100%',
      'background-repeat': 'no-repeat',
      'background-image':
        'url("data:image/svg+xml;utf8,' +
        encodeURIComponent(highed.resources.logo) +
        '")'
    })
  );

  highed.dom.ap(
    splitter.bottom,
    highed.dom.ap(
      chartFrame,

      highed.dom.ap(
        resPreviewBar,
        highed.dom.cr('div', 'highed-res-headline', 'Size Preview:'),
        resQuickSelContainer,
        highed.dom.ap(
          highed.dom.cr('div', 'highed-res-quicksel'),
          resWidth,
          highed.dom.cr('span', '', 'x'),
          resHeight
        )
      ),

      chartContainer,
      highed.dom.ap(errorBar, errorBarHeadline, errorBarBody)
    )
  );

  highed.dom.on([resWidth, resHeight], 'change', function() {
    sizeChart(parseInt(resWidth.value, 10), parseInt(resHeight.value, 10));
  });

  // Create the features
  createFeatures();
  createToolbar();

  resize();

  function setToActualSize() {
    resWidth.disabled = resHeight.disabled = 'disabled';
    chartPreview.getHighchartsInstance(function(chart) {
      var w, h;

      if (!chart || !chart.options || !chart.options.chart) {
        h = 400;
      } else {
        w = chart.options.chart.width;
        h = chart.options.chart.height || 400;
      }

      resWidth.value = w;
      resHeight.value = h;

      sizeChart(w, h);
    });

    highed.dom.style(chartFrame, {
      'overflow-x': 'auto'
    });
  }

  resQuickSel.addItem({
    id: 'actual',
    title: 'Actual Size',
    select: function() {
      setToActualSize();
    }
  });

  chartPreview.on('AttrChange', function(option) {
    if (option.id === 'chart.height' || option.id === 'chart.width') {
      resQuickSel.selectByIndex(0);
      // setToActualSize();
    }
  });
  
  chartPreview.on('SetResizeData', function () {
    setToActualSize();
  });

  Object.keys(resolutions).forEach(function(devName) {
    resQuickSel.addItem({
      id: devName,
      title: devName,
      select: function() {
        resWidth.disabled = resHeight.disabled = undefined;

        resWidth.value = resolutions[devName][0];
        resHeight.value = resolutions[devName][1];

        sizeChart(resolutions[devName][0], resolutions[devName][1]);

        highed.dom.style(chartFrame, {
          'overflow-x': ''
        });
      }
    });
  });

  resQuickSel.selectByIndex(0);

  return {
    on: events.on,
    resize: resize,
    destroy: destroy,
    /* Get embeddable javascript */
    getEmbeddableHTML: chartPreview.export.html,
    /* Get embeddable json */
    getEmbeddableJSON: chartPreview.export.json,
    /* Get embeddable SVG */
    getEmbeddableSVG: chartPreview.export.svg,
    addImportTab: addImportTab,
    hideImportModal: hideImportModal,
    setEnabledFeatures: setEnabledFeatures,
    addFeature: addFeature,
    chart: chartPreview,
    toolbar: toolbar,
    data: {
      on: dataTable.on,
      showLiveStatus: toolbox.showLiveStatus,
      hideLiveStatus: toolbox.hideLiveStatus
    },
    dataTable: dataTable,
    toolbar: toolbar
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

// Alias to drawer editor
highed.Editor = highed.DrawerEditor;

(function() {
  var instanceCount = 0,
    installedPlugins = {},
    activePlugins = {},
    pluginEvents = highed.events(),
    stepPlugins = {};

  ///////////////////////////////////////////////////////////////////////////

  /** Install an editor plugin
      *
      *  Note that plugins must be enabled when creating the editor
      *  for it to be active.
      *
      *  @namespace highed.plugins.editor
      *
      *  @param name       {string} - the name of the plugin
      *  @param definition {object} - the plugin definition
      *     > meta {object}
      *         > version {string}
      *         > author {string}
      *         > homepage {string}
      *     > dependencies {array<string>} - URLs of script dependencies
      *     > options {object}
      *         > option_name {object}
      *             > type {string} - the type of the option
      *             > label {string} - the label
      *             > default {anything} - the default value
      */
  function install(name, definition) {
    var properties = highed.merge(
      {
        meta: {
          version: 'unknown',
          author: 'unknown',
          homepage: 'unknown'
        },
        dependencies: [],
        options: {}
      },
      definition
    );

    console.error('Warning: editor plugins are no longer supported.');

    properties.dependencies.forEach(highed.include);

    if (!highed.isNull(installedPlugins[name])) {
      return highed.log(1, 'plugin -', name, 'is already installed');
    }

    installedPlugins[name] = properties;
  }

  function use(name, options) {
    var plugin = installedPlugins[name],
      filteredOptions = {};

    console.error('Warning: editor plugins are no longer supported.');

    if (!highed.isNull(plugin)) {
      if (activePlugins[name]) {
        return highed.log(2, 'plugin -', name, 'is already active');
      }

      //Verify options
      Object.keys(plugin.options).forEach(function(key) {
        var option = plugin.options[key];
        if (highed.isBasic(option) || highed.isArr(option)) {
          highed.log(
            2,
            'plugin -',
            name,
            'unexpected type definition for option',
            key,
            'expected object'
          );
        } else {
          filteredOptions[key] =
            options[key] || plugin.options[key].default || '';

          if (option.required && highed.isNull(options[key])) {
            highed.log(1, 'plugin -', name, 'option', key, 'is required');
          }
        }
      });

      activePlugins[name] = {
        definition: plugin,
        options: filteredOptions
      };
      filteredOptions;

      if (highed.isFn(plugin.activate)) {
        activePlugins[name].definition.activate(filteredOptions);
      }

      pluginEvents.emit('Use', activePlugins[name]);
    } else {
      highed.log(2, 'plugin -', name, 'is not installed');
    }
  }

  //Public interface
  highed.plugins.editor = {
    install: install,
    use: use
  };

  //UI plugin interface
  highed.plugins.step = {
    install: function(def) {
      stepPlugins[def.title] = def;
    }
  };
})();

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** Simple one-pane editor
 *  An essentials-only editor.
 *
 *  @example
 *  var simpleEditor = highed.SimpleEditor(document.body, {
 *      availableSettings: [
 *          'title--text',
 *          'subtitle--text'
 *      ]
 *  });
 *
 *  simpleEditor.on('Change', function (chart) {
 *       console.log(chart.export.html());
 *  });
 *
 *  @constructor
 *  @emits change - when the chart changes
 *    > {highed.ChartPreview} - an instance of the chart preview
 *
 *  @param parent {domnode} - the node to attach to
 *  @param attributes {object} - the options for the editor
 *    > availableSettings {array<string>} - the settings to include
 *    > defaultChartOptions {object} - default chart settings
 *    > importer {object} - options passed to the importer widget
 *      > options {string|array<string>} - the options to include
 *      > plugins {string|array<sting>} - the plugins to enable
 */
highed.SimpleEditor = function(parent, attributes) {
  var properties = highed.merge(
      {
        importer: {
          options: 'csv'
        },
        features: 'import preview customize',
        availableSettings: [
          'title--text',
          'subtitle--text',
          'colors',
          'chart--backgroundColor',
          'yAxis-title--style',
          'yAxis--type',
          'yAxis--opposite',
          'yAxis--reversed',
          'yAxis-labels--format'
        ],
        defaultChartOptions: {}
      },
      attributes
    ),
    events = highed.events(),
    container = highed.dom.cr('div', 'highed-container'),
    expandContainer = highed.dom.cr('div', 'highed-expand-container'),
    mainVSplitter = highed.VSplitter(container, {
      topHeight: '60px',
      noOverflow: true
    }),
    mainToolbar = highed.Toolbar(mainVSplitter.top, {
      additionalCSS: ['highed-header']
    }),
    hsplitter = highed.HSplitter(mainVSplitter.bottom, {
      leftWidth: 40,
      noOverflow: false
    }),
    vsplitterRight = highed.VSplitter(hsplitter.right, {
      noOverflow: true
    }),
    preview = highed.ChartPreview(vsplitterRight.top, {
      defaultChartOptions: properties.defaultChartOptions,
      expandTo: expandContainer
    }),
    //importer = highed.DataImporter(vsplitterRight.bottom, properties.importer),
    importer = highed.DataTable(vsplitterRight.bottom),
    customizer = highed.SimpleCustomizer(hsplitter.left, {
      availableSettings: properties.availableSettings
    }),
    cmenu = highed.DefaultContextMenu(preview);

  ///////////////////////////////////////////////////////////////////////////

  properties.features = highed.arrToObj(properties.features.split(' '));

  ///////////////////////////////////////////////////////////////////////////

  function applyFeatures() {
    if (!properties.features.import) {
      importer.hide();
    }

    if (!properties.features.preview) {
    }

    if (!properties.features.customize) {
    }
  }

  /** Force a resize of the editor
     *  @memberof highed.SimpleEditor
     */
  function resize() {
    var ps = highed.dom.size(container);

    mainVSplitter.resize(ps.w, ps.h);

    vsplitterRight.resize(false, ps.h - 60);

    hsplitter.resize(ps.w, ps.h - 60);

    preview.resize();
    importer.resize();
  }

  function attachToCustomizer() {
    customizer.build(preview.options.customized);
  }

  ///////////////////////////////////////////////////////////////////////////

  customizer.on('PropertyChange', function(id, value, index) {
    preview.options.set(id, value, index);
    events.emit('Change', preview);
  });
  // importer.on('ImportCSV', [preview.data.csv, attachToCustomizer]);
  // importer.on('ImportJSON', [preview.data.json, attachToCustomizer]);
  // importer.on('ImportChartSettings', [preview.data.settings, attachToCustomizer]);

  importer.on('Change', function(headers, data) {
    if (data.length) {
      var d = importer.toDataSeries();

      preview.options.set('xAxis-categories', d.categories, 0);

      preview.loadSeries(d.series);
    }
  });

  preview.on('RequestEdit', function(event, x, y) {
    customizer.focus(event, x, y);
  });

  preview.on('New', attachToCustomizer);

  ///////////////////////////////////////////////////////////////////////////

  highed.dom.ap(highed.dom.get(parent), container, expandContainer);

  highed.dom.on(window, 'resize', resize);

  highed.dom.ap(
    mainToolbar.left,
    highed.dom.style(highed.dom.cr('div', 'highed-logo'), {
      'background-image':
        'url("data:image/svg+xml;utf8,' +
        encodeURIComponent(
          '<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 16.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"     width="425.197px" height="141.732px" viewBox="0 0 425.197 141.732" enable-background="new 0 0 425.197 141.732"     xml:space="preserve"><g>    <path fill="#eeeaea" d="M138.475,69.712h-17.02v9.77c0,1.037-0.813,1.851-1.849,1.851c-1.037,0-1.85-0.813-1.85-1.851V57.725        c0-1.037,0.813-1.852,1.85-1.852c1.036,0,1.849,0.813,1.849,1.852v8.436h17.02v-8.436c0-1.037,0.814-1.852,1.85-1.852        c1.036,0,1.85,0.813,1.85,1.852v21.754c0,1.037-0.814,1.851-1.85,1.851c-1.036,0-1.85-0.813-1.85-1.851V69.712z"/>    <path fill="#eeeaea" d="M156.973,79.479c0,1.037-0.814,1.851-1.852,1.851s-1.852-0.813-1.852-1.851V57.725        c0-1.037,0.814-1.852,1.852-1.852s1.852,0.813,1.852,1.852V79.479z"/>    <path fill="#eeeaea" d="M184.125,70.378c0-1.036,0.814-1.774,1.852-1.774c1.034,0,1.852,0.813,1.852,1.849v5.847        c0,0.444-0.226,1.109-0.595,1.479c-2.367,2.369-5.549,3.773-9.176,3.773c-7.178,0-12.949-5.771-12.949-12.948        c0-7.181,5.771-12.949,12.949-12.949c3.627,0,6.809,1.405,9.176,3.771c0.738,0.74,0.738,1.852,0,2.592        c-0.741,0.738-1.922,0.813-2.663,0.072c-1.702-1.699-3.923-2.736-6.513-2.736c-5.104,0-9.249,4.144-9.249,9.25        c0,5.104,4.146,9.25,9.249,9.25c2.367,0,4.441-0.813,6.067-2.222V70.378z"/>    <path fill="#eeeaea" d="M218.162,69.712h-17.019v9.77c0,1.037-0.817,1.851-1.852,1.851c-1.037,0-1.849-0.813-1.849-1.851V57.725        c0-1.037,0.812-1.852,1.849-1.852c1.034,0,1.852,0.813,1.852,1.852v8.436h17.019v-8.436c0-1.037,0.813-1.852,1.849-1.852        c1.037,0,1.852,0.813,1.852,1.852v21.754c0,1.037-0.813,1.851-1.852,1.851c-1.033,0-1.849-0.813-1.849-1.851V69.712z"/>    <path fill="#eeeaea" d="M242.948,81.552c-7.182,0-12.949-5.771-12.949-12.948c0-7.181,5.77-12.949,12.949-12.949        c3.627,0,6.809,1.405,9.176,3.771c0.738,0.74,0.738,1.852,0,2.592c-0.741,0.738-1.925,0.813-2.666,0.072        c-1.699-1.699-3.92-2.736-6.51-2.736c-5.106,0-9.249,4.144-9.249,9.25c0,5.104,4.143,9.25,9.249,9.25        c2.59,0,4.884-0.962,6.586-2.664c0.74-0.741,1.849-0.741,2.59,0c0.738,0.738,0.738,1.85,0,2.589        C249.756,80.146,246.574,81.552,242.948,81.552z"/>    <path fill="#eeeaea" d="M281.569,69.712h-17.02v9.77c0,1.037-0.813,1.851-1.852,1.851c-1.034,0-1.85-0.813-1.85-1.851V57.725        c0-1.037,0.813-1.852,1.85-1.852c1.035,0,1.852,0.813,1.852,1.852v8.436h17.02v-8.436c0-1.037,0.813-1.852,1.853-1.852        c1.034,0,1.849,0.813,1.849,1.852v21.754c0,1.037-0.813,1.851-1.849,1.851c-1.037,0-1.853-0.813-1.853-1.851V69.712z"/>    <path fill="#eeeaea" d="M308.758,57.503l10.507,20.646c0.223,0.443,0.445,1.036,0.445,1.554c0,1.036-0.668,1.628-1.702,1.628        c-0.741,0-1.481-0.222-2.001-1.258l-3.253-6.438h-13.547l-3.183,6.438c-0.517,1.036-1.256,1.258-1.994,1.258        c-1.037,0-1.702-0.593-1.702-1.628c0-0.519,0.22-1.109,0.442-1.554l10.506-20.646c0.668-1.405,2.002-1.628,2.74-1.628        C306.76,55.875,308.09,56.096,308.758,57.503z M300.985,70.083h9.988l-4.957-9.99L300.985,70.083z"/>    <path fill="#eeeaea" d="M340.159,56.023c4.441,0,8.064,3.255,8.064,7.694c0,3.923-2.813,6.884-6.511,7.549l6.731,7.104        c0.664,0.666,0.889,1.85,0.146,2.516c-0.736,0.741-2.145,0.521-2.886-0.296l-8.729-9.176h-6.511v8.142        c0,1.034-0.815,1.774-1.854,1.774c-1.033,0-1.85-0.813-1.85-1.851V57.873c0-1.035,0.814-1.85,1.85-1.85H340.159z M330.468,59.575        v8.288h9.691c2.59,0,4.367-1.776,4.367-4.146c0-2.365-1.777-4.144-4.367-4.144L330.468,59.575L330.468,59.575z"/>    <path fill="#eeeaea" d="M365.047,59.575h-9.249c-1.033,0-1.849-0.74-1.849-1.776c0-1.034,0.813-1.773,1.849-1.773h22.201        c1.037,0,1.852,0.74,1.852,1.773c0,1.037-0.813,1.776-1.852,1.776h-9.249V79.48c0,1.037-0.813,1.851-1.849,1.851        c-1.037,0-1.854-0.813-1.854-1.851V59.575z"/>    <path fill="#eeeaea" d="M388.724,66.013c0-9.25,5.698-10.359,9.99-10.359c1.035,0,1.85,0.813,1.85,1.85        c0,1.036-0.813,1.851-1.85,1.851c-3.479,0-6.29,0.738-6.29,6.66v5.18c0,9.25-5.698,10.358-9.989,10.358        c-1.035,0-1.85-0.813-1.85-1.85s0.814-1.85,1.85-1.85c3.479,0,6.289-0.74,6.289-6.66V66.013z"/></g><polygon fill="#8087E8" points="67.981,30.52 56.757,56.73 42.009,91.171 76.301,76.685 94.465,69.013 "/><polygon fill="#30426B" points="73.7,62.25 76.302,76.685 94.466,69.013 "/><polygon fill="#6699A1" points="67.981,30.52 73.7,62.251 94.465,69.013 "/><polygon fill="#78758C" points="73.7,62.25 94.466,69.013 56.758,56.729 42.009,91.171 76.302,76.685 "/><polygon fill="#A3EDBA" points="42.009,91.171 56.757,56.73 26.442,46.855 "/><polygon fill="#6699A1" points="76.302,76.685 79.628,95.13 94.466,69.013 "/><polygon fill="#8087E8" points="67.981,30.52 56.757,56.73 73.7,62.251 "/></svg>'
        ) +
        '")'
    })
  );

  mainToolbar.addIcon({
    css: 'fa-gear',
    click: function(e) {
      cmenu.show(e.clientX, e.clientY);
    }
  });

  applyFeatures();
  resize();
  attachToCustomizer();

  //Public interface
  return {
    resize: resize,
    on: events.on,
    /** Main toolbar
         *  @type {domnode}
         *  @memberof highed.SimpleEditor
         */
    toolbar: mainToolbar,
    /** The chart preview
         *  @type {highed.ChartPreview}
         *  @memberof highed.SimpleEditor
         */
    chart: preview
  };
};

/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

/** A modal editor
 * The modal editor connects to a "summoner", which is the DOM node that should
 * spawn the editor. This arg is however optional, and if not present,
 * `show()` should be called instead when wanting to display it.
 *
 * The contained editor can either be a full editor, or a simple editor.
 *
 * @example
 * highed.ModalEditor('icon', {allowDone: true}, function (html) {
 *    doSomethingWithTheExportedHTML(html);
 * });
 *
 * @constructor
 *
 * @param summoner {domnode} - the node which spawns the editor
 * @param attributes {object} - properties. Note that this object is also passed to the editor constructor.
 *   > type {string} - either `full` or `simple`.
 *   > allowDone {bool} - if set to true (default is false) a "Close and use" button will appear on the top bar
 * @param fn {function} - function to call when done editing, argument is an instance of highed.ChartPreview
 *
 */
highed.ModalEditor = function(summoner, attributes, fn) {
  var properties = highed.merge(
      {
        type: 'full',
        allowDone: false
      },
      attributes
    ),
    modal = highed.OverlayModal(false, {
      width: '95%',
      height: '95%',
      showOnInit: false
    }),
    editor =
      properties.type === 'full'
        ? highed.Editor(modal.body, attributes)
        : highed.SimpleEditor(modal.body, attributes),
    //We don't always know the summoner at create time..
    sumFn = false,
    doneEditing = highed.dom.cr(
      'button',
      'highed-done-button',
      'Close &amp; Use'
    );

  ///////////////////////////////////////////////////////////////////////////

  /** Attach to a new summoner
     *  @memberof highed.ModalEditor
     *  @param nn {domnode} - the new node to attach to
     */
  function attachToSummoner(nn) {
    nn = nn || summoner;

    if (!nn) {
      return;
    }

    if (highed.isFn(sumFn)) {
      sumFn();
    }

    //Show the modal when clicking the summoner
    sumFn = highed.dom.on(highed.dom.get(nn), 'click', modal.show);
  }

  function doDone() {
    if (highed.isFn(fn)) {
      fn(editor.chart);
    }
    modal.hide();
  }

  //Resize the editor when showing the modal
  modal.on('Show', editor.resize);

  highed.dom.on(doneEditing, 'click', doDone);

  attachToSummoner(summoner);

  if (properties.allowDone) {
    highed.dom.ap(editor.toolbar.center, doneEditing);
  }

  editor.on('Done', doDone);
  editor.resize();

  ///////////////////////////////////////////////////////////////////////////

  return {
    editor: editor,
    show: modal.show,
    hide: modal.hide,
    on: editor.on,
    attachToSummoner: attachToSummoner
  };
};

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Validates that the data is suitable to a line series */
highed.validators.add('line', function(chart) {
  return true;
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Validates that the data is suitable to a line series */
highed.validators.add('line', function(chart) {
  return true;
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Validates that the data is suitable to a line series */
highed.validators.add('line', function(chart) {
  return true;
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'line-series-dates',
  title: 'Dates on X',
  description: '',
  type: 'csv',
  dataset: ['row,val', '2013-01-01,24', '2014-01-01,76', '2015-01-01,23']
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'line-series-four-series',
  title: 'Categorized, four series',
  description: '',
  type: 'csv',
  dataset: [
    'Categories,Tokyo,New York,Berlin,London',
    'Jan,7,-0.2,-0.9,3.9',
    'Feb,6.9,0.8,0.6,4.2',
    'Mar,9.5,5.7,3.5,5.7',
    'Apr,14.5,11.3,8.4,8.5',
    'May,18.2,17,13.5,11.9',
    'Jun,21.5,22,17,15.2',
    'Jul,25.2,24.8,18.6,17',
    'Aug,26.5,24.1,17.9,16.6',
    'Sep,23.3,20.1,14.3,14.2',
    'Oct,18.3,14.1,9,10.3',
    'Nov,13.9,8.6,3.9,6.6',
    'Dec,9.6,2.5,1,4.8'
  ]
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'line-series-simple',
  title: 'Basic Line Series',
  description: '',
  type: 'csv',
  dataset: ['row,val', '0,24', '1,76', '2,23']
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
Software), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED AS IS, WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'os-stats',
  title: 'OS Usage Stats',
  description: '',
  type: 'csv',
  dataset: [
    'Date,Windows,Android,iOS,OS X,Unknown,Linux,Nokia Unknown,Series 40,BlackBerry OS,Chrome OS,Samsung,SymbianOS,Playstation,Tizen,Xbox,LG,Sony Ericsson,MeeGo,bada,Other',
    '2016-02-01,48.15,27.51,11.04,5.2,3.61,1,0.97,0.98,0.39,0.3,0.29,0.29,0.09,0.03,0.03,0.03,0.03,0.02,0.02,0.02',
    '2016-03-01,47.32,29.34,11.02,5.08,2.95,0.95,0.94,0.93,0.38,0.29,0.29,0.28,0.08,0.03,0.02,0.03,0.03,0.02,0.02,0.02',
    '2016-04-01,46.44,29.9,11.12,5.09,3.12,0.99,0.96,0.89,0.4,0.3,0.28,0.26,0.08,0.03,0.03,0.03,0.02,0.02,0.01,0.02',
    '2016-05-01,44.29,31.6,11.38,5.05,3.35,0.91,0.99,0.89,0.41,0.3,0.3,0.26,0.1,0.04,0.03,0.03,0.03,0.02,0.01,0.02',
    '2016-06-01,45.55,30.15,11.83,5.29,3.39,0.96,0.79,0.72,0.35,0.22,0.29,0.2,0.1,0.04,0.03,0.03,0.03,0.02,0.01,0.02',
    '2016-07-01,42.56,32.48,12.25,4.81,4,0.96,0.87,0.77,0.34,0.18,0.3,0.22,0.09,0.04,0.03,0.03,0.03,0.02,0.01,0.02',
    '2016-08-01,42.49,32.07,12.16,4.96,4.53,0.98,0.85,0.71,0.29,0.21,0.28,0.21,0.09,0.04,0.03,0.03,0.03,0.02,0.01,0.02',
    '2016-09-01,41.61,32.84,11.87,5.07,4.84,0.94,0.84,0.65,0.27,0.33,0.28,0.19,0.1,0.05,0.03,0.02,0.03,0.02,0.01,0.02',
    '2016-10-01,40.06,34.46,12.04,5.3,4.57,0.85,0.87,0.55,0.27,0.34,0.26,0.17,0.08,0.07,0.03,0.02,0.03,0.01,0.01,0.02',
    '2016-11-01,39.65,36.28,12.28,5.22,3.15,0.86,0.79,0.49,0.26,0.35,0.24,0.15,0.08,0.08,0.03,0.02,0.03,0.01,0.01,0.02',
    '2016-12-01,38.35,37.8,12.71,4.92,2.85,0.86,0.77,0.49,0.22,0.33,0.25,0.15,0.09,0.1,0.03,0.02,0.02,0.01,0.01,0.02',
    '2017-01-01,38.75,37.15,13.16,5.06,2.63,0.78,0.75,0.46,0.21,0.35,0.24,0.14,0.09,0.11,0.03,0.02,0.02,0.01,0.01,0.02',
    '2017-02-01,38.59,37.42,12.99,5.24,2.56,0.77,0.74,0.42,0.23,0.38,0.22,0.13,0.1,0.12,0.03,0.02,0.01,0.01,0.01,0.01'
  ]
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'pie-pacman',
  title: 'Pacman Pie',
  description: '',
  type: 'csv',
  dataset: ['slice,val', 'Not Pacman,24', 'Pacman,76']
});

/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

highed.samples.add({
  id: 'pie-series-simple',
  title: 'Basic Pie Series',
  description: '',
  type: 'csv',
  dataset: ['slice,val', 'Cats,20', 'Dogs,75', 'Birds,5']
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Arearange',
  description: '',
  thumbnail: 'udepat.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'arearange',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Basic',
  description: '',
  thumbnail: 'ecexev.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Area with labels',
  description: '',
  thumbnail: 'atikon.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Inverted',
  description: '',
  thumbnail: 'yqenid.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      inverted: true,
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Inverted with labels',
  description: '',
  thumbnail: 'acemyq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Negative color',
  description: '',
  thumbnail: 'ydypal.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    'series[0]': {
      negativeColor: '#0088FF',
      color: '#FF0000'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Stacked percentage',
  description: '',
  thumbnail: 'iporos.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'percent'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Stacked',
  description: '',
  thumbnail: 'inebav.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Stacked with labels',
  description: '',
  thumbnail: 'iluryh.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Area', {
  title: 'Step line',
  description: '',
  thumbnail: 'abutix.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    plotOptions: {
      area: {
        step: 'left'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Horizontal columnrange',
  description: '',
  thumbnail: 'iqagel.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'columnrange',
      inverted: true,
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Columnrange with labels',
  description: '',
  thumbnail: 'eracar.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'columnrange',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Stacked bar',
  description: '',
  thumbnail: 'epodat.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Stacked with labels',
  description: '',
  thumbnail: 'otupaz.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Stacked percent bar',
  description: '',
  thumbnail: 'yhekaq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'percent'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Stacked percentage with labels',
  description: '',
  thumbnail: 'izoqyx.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'percent',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Basic bar',
  description: '',
  thumbnail: 'ovuvul.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Basic with labels',
  description: '',
  thumbnail: 'ovuvul.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Error bar',
  description: '',
  thumbnail: 'omikax.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    'series[1]': {
      type: 'errorbar'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Logarithmic',
  description: '',
  thumbnail: 'imykus.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    yAxis: {
      type: 'logarithmic',
      minorTickInterval: 'auto'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Multi color',
  description: '',
  thumbnail: 'ogixak.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        colorByPoint: true
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Negative color',
  description: '',
  thumbnail: 'efygam.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    'series[0]': {
      negativeColor: '#0088FF',
      color: '#FF0000'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Bar', {
  title: 'Packed columns',
  description: '',
  thumbnail: 'orixis.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      inverted: true,
      polar: false
    },
    plotOptions: {
      series: {
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0,
        shadow: false
      }
    }
  }
});

/******************************************************************************

Copyright (c) 2016, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

highed.templates.addCategory('Line', {
  description: [
    'A line chart is a type of chart which diplays information as a series of data points called "markers" connected by straight line segments'
  ],

  samples: ['os-stats', 'line-series-simple', 'line-series-four-series']
});

highed.templates.addCategory('Pie', {
  description: [
    'A pie chart is a circular statistical graphic which is divided into slices to illustrate numerical proportions.',
    'In a pie chart, the arc length of each slice is proportional to the quantity it represents.'
  ],

  samples: ['pie-series-simple']
});

highed.templates.addCategory('Bar', {
  description: [
    'A bar chart is a chart that presents grouped data with rectangular bars with lengths proportional to the values that they represent.'
  ],

  nofits: 'The dataset must contain at least one column.',

  samples: []
});

highed.templates.addCategory('Column', {
  description: [],

  samples: []
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Column 3D',
  description: '',
  thumbnail: 'ahyqyx.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      margin: 75,
      options3d: {
        enabled: true,
        alpha: 15,
        beta: 15,
        depth: 50,
        viewDistance: 15
      },
      polar: false
    },
    plotOptions: {
      column: {
        depth: 25
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Stacked 3D',
  description: '',
  thumbnail: 'ahyqyx.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      margin: 75,
      options3d: {
        enabled: true,
        alpha: 15,
        beta: 15,
        depth: 50,
        viewDistance: 15
      },
      polar: false
    },
    plotOptions: {
      column: {
        depth: 25
      },
      series: {
        stacking: 'normal'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Stacked percent',
  description: '',
  thumbnail: 'ojixow.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column'
    },
    plotOptions: {
      series: {
        stacking: 'percent'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Stacked percent with labels',
  description: '',
  thumbnail: 'iwanyg.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'percent',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Columnrange',
  description: '',
  thumbnail: 'ihilaq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'columnrange',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Columnrange with labels',
  description: '',
  thumbnail: 'ojykiw.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'columnrange',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Stacked',
  description: '',
  thumbnail: 'ycehiz.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Stacked with labels',
  description: '',
  thumbnail: 'acijil.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Error bar',
  description: '',
  thumbnail: 'icytes.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    'series[1]': {
      type: 'errorbar'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Basic',
  description: '',
  thumbnail: 'ovobiq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'With label',
  description: '',
  thumbnail: 'ivetir.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Logarithmic',
  description: '',
  thumbnail: 'igipeg.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    yAxis: {
      type: 'logarithmic',
      minorTickInterval: 'auto'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Multi color',
  description: '',
  thumbnail: 'alyqyz.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        colorByPoint: true
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Negative color',
  description: '',
  thumbnail: 'yxajih.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    'series[0]': {
      negativeColor: '#0088FF',
      color: '#FF0000'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Column', {
  title: 'Packed columns',
  description: '',
  thumbnail: 'exypor.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    plotOptions: {
      series: {
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0,
        shadow: false
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Combinations', {
  title: 'Area and line',
  description: '',
  thumbnail: 'ahimym.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line'
    },
    'series[0]': {
      type: 'area'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Combinations', {
  title: 'Arearange and line',
  description: '',
  thumbnail: 'ypepug.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line'
    },
    'series[0]': {
      type: 'arearange'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Combinations', {
  title: 'Column and line',
  description: '',
  thumbnail: 'ufafag.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'column'
    },
    'series[0]': {
      type: 'line'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Combinations', {
  title: 'Line and column',
  description: '',
  thumbnail: 'ynikoc.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line'
    },
    'series[0]': {
      type: 'column'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Combinations', {
  title: 'Scatter and line',
  description: '',
  thumbnail: 'etakof.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line'
    },
    'series[0]': {
      type: 'scatter'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Line chart',
  description: '',
  thumbnail: 'abywon.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Combination chart',
  description: '',
  thumbnail: 'ynikoc.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    'series[0]': {
      type: 'column'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Error bar',
  description: '',
  thumbnail: 'ypewak.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    'series[0]': {
      type: 'line'
    },
    'series[1]': {
      type: 'errorbar'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Inverted',
  description: '',
  thumbnail: 'ozojul.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      inverted: true,
      polar: false
    }
  }
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Standard Line Series */

highed.templates.add('Line', {
  title: 'Line',
  description: [
    'Basic line series. Good starting point for custom line series.',
    "Requires one column for X values or categories, subsequently one column for each series' Y values."
  ],
  constructor: 'Chart',
  thumbnail: 'abywon.svg',
  sampleSets: [],
  validator: 'line',
  config: {
    chart: {
      type: 'line'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Logarithmic',
  description: '',
  thumbnail: 'abywon.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    yAxis: {
      type: 'logarithmic',
      minorTickInterval: 'auto'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Negative color',
  description: '',
  thumbnail: 'uxyfys.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    'series[0]': {
      negativeColor: '#0088FF',
      color: '#FF0000'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Spline',
  description: '',
  thumbnail: 'upafes.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'spline',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Spline with labels',
  description: '',
  thumbnail: 'odopic.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'spline',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Step line',
  description: '',
  thumbnail: 'akeduw.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    plotOptions: {
      line: {
        step: 'left'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'Step line with labels',
  description: '',
  thumbnail: 'oxenux.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      },
      line: {
        step: 'left'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Line', {
  title: 'With data labels',
  description: '',
  thumbnail: 'agonam.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('More', {
  title: 'Boxplot',
  description: '',
  thumbnail: 'idagib.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'boxplot'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('More', {
  title: 'Funnel',
  description: '',
  thumbnail: 'exumeq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'funnel'
    },
    plotOptions: {
      series: {
        datalabels: {
          color: '#000000'
        },
        dataLabels: {
          softConnector: true
        },
        neckWidth: '20%',
        neckHeight: '35%'
      }
    },
    'series[0]': {
      width: '64%'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('More', {
  title: 'Pyramid',
  description: '',
  thumbnail: 'obulek.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pyramid'
    },
    plotOptions: {
      series: {
        datalabels: {
          color: '#000000'
        },
        dataLabels: {
          softConnector: true
        }
      }
    },
    'series[0]': {
      width: '64%'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('More', {
  title: 'Solid gauge',
  description: '',
  thumbnail: 'apocob.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'solidgauge'
    },
    pane: {
      center: ['50%', '85%'],
      size: '140%',
      startAngle: '-90',
      endAngle: '90',
      background: {
        backgroundColor: '#EEE',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc'
      }
    },
    tooltip: {
      enabled: false
    },
    yAxis: {
      stops: [[0.1, '#55BF3B'], [0.5, '#DDDF0D'], [0.9, '#DF5353']],
      min: 0,
      max: 100,
      lineWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 400,
      tickWidth: 0,
      title: {
        y: -70
      },
      labels: {
        y: 16
      }
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: 10,
          borderWidth: 0,
          useHTML: true
        }
      }
    },
    'series[0]': {
      dataLabels: {
        format:
          '<div style="text-align:center"><span style="font-size:25px;color:#000000">{y}</span></div>'
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: 'Donut',
  description: '',
  thumbnail: 'upaxab.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: true,
        innerSize: '60%',
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: '3D Donut chart',
  description: '',
  thumbnail: 'ehuvoh.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      },
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        depth: 35,
        cursor: 'pointer',
        innerSize: '60%'
      },
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: '3D Donut chart with legend',
  description: '',
  thumbnail: 'oriwyb.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      },
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        depth: 35,
        cursor: 'pointer',
        showInLegend: true,
        innerSize: '60%'
      },
      series: {
        dataLabels: {
          enabled: false
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: 'Donut with legend',
  description: '',
  thumbnail: 'arutag.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: true,
        showInLegend: true,
        innerSize: '60%',
        dataLabels: {
          enabled: false
        }
      }
    }
  }
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Standard Line Series */

highed.templates.add('Pie', {
  title: 'Pie',
  description: ['Good starting point for custom pie series.'],
  constructor: 'Chart',
  thumbnail: 'yqoxob.svg',
  sampleSets: [
    // 'pie-series-simple'
  ],
  validator: 'pie',
  config: {
    chart: {
      type: 'pie'
    }
  }
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

/* Standard Line Series */

highed.templates.add('Pie', {
  title: 'Pacman Pie',
  description: ['Pacman Pie.'],
  constructor: 'Chart',
  thumbnail: 'yqoxob.svg',
  sampleSets: ['pie-pacman'],
  validator: 'pie',
  config: {
    chart: {
      type: 'pie'
    },
    series: [
      {
        startAngle: 45,
        colors: ['#fafafa', '#ffff8d'],
        borderColor: '#000000'
      }
    ]
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: 'Pie chart',
  description: '',
  thumbnail: 'yqoxob.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: true
      },
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: '3D Pie chart',
  description: '',
  thumbnail: 'erifer.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      },
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        depth: 35,
        cursor: 'pointer'
      },
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: '3D Pie with legend',
  description: '',
  thumbnail: 'ubopaq.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      },
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        depth: 35,
        cursor: 'pointer',
        showInLegend: true,
        dataLabels: {
          enabled: false
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: 'Pie with legend',
  description: '',
  thumbnail: 'anofof.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: true,
        showInLegend: true,
        dataLabels: {
          enabled: false
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Pie', {
  title: 'Semi circle donut',
  description: '',
  thumbnail: 'iwyfes.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'pie',
      polar: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        dataLabels: {
          distance: -30,
          style: {
            fontWeight: 'bold',
            color: 'white',
            textShadow: '0px 1px 2px black'
          }
        },
        innerSize: '50%',
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%']
      },
      series: {
        dataLabels: {
          enabled: true
        }
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Polar', {
  title: 'Polar area',
  description: '',
  thumbnail: 'oqajux.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: true
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Polar', {
  title: 'Polar line',
  description: '',
  thumbnail: 'ajogud.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: true
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Polar', {
  title: 'Spider area',
  description: '',
  thumbnail: 'exajib.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'area',
      polar: true
    },
    xAxis: {
      tickmarkPlacement: 'on',
      lineWidth: 0
    },
    yAxis: {
      lineWidth: 0,
      gridLineInterpolation: 'polygon'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Polar', {
  title: 'Spider line',
  description: '',
  thumbnail: 'uqonaj.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'line',
      polar: true
    },
    xAxis: {
      tickmarkPlacement: 'on',
      lineWidth: 0
    },
    yAxis: {
      lineWidth: 0,
      gridLineInterpolation: 'polygon'
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Scatterandbubble', {
  title: 'Bubble chart',
  description: '',
  thumbnail: 'usyfyw.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'bubble',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Scatterandbubble', {
  title: 'Scatter chart',
  description: '',
  thumbnail: 'ezatat.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'scatter',
      polar: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Scatterandbubble', {
  title: 'Scatter with line',
  description: '',
  thumbnail: 'ydaqok.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'scatter',
      polar: false
    },
    plotOptions: {
      series: {
        lineWidth: 1
      }
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Scatterandbubble', {
  title: 'Scatter with line, no marker',
  description: '',
  thumbnail: 'uvepiw.svg',
  dataValidator: false,
  sampleSets: [],
  config: {
    chart: {
      type: 'scatter',
      polar: false
    },
    plotOptions: {
      series: {
        lineWidth: 1,
        marker: {
          enabled: false
        }
      }
    }
  }
});

/*******************************************************************************

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/
/*
highed.samples.add({
    id: 'candlestick',
    title: 'Stock Data',
    description: '',
    type: 'csv',
    dataset: [

    ]
});
*/

/******************************************************************************

Copyright (c) 2016, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

highed.templates.addCategory('Stock', {
  description: ['Stock charts are used to display financial data.'],

  samples: []
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Stock', {
  title: 'Area',
  description: '',
  constructor: 'StockChart',
  thumbnail: 'ukaqor.svg',
  dataValidator: false,
  sampleSets: ['line-series-dates'],
  config: {
    chart: {
      type: 'area',
      polar: false
    },
    rangeSelector: {
      enabled: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Stock', {
  title: 'Basic',
  description: '',
  constructor: 'StockChart',
  thumbnail: 'awuhad.svg',
  dataValidator: false,
  sampleSets: ['line-series-dates'],
  config: {
    chart: {
      type: 'line',
      polar: false
    },
    rangeSelector: {
      enabled: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Stock', {
  title: 'Candlestick',
  description: '',
  constructor: 'StockChart',
  thumbnail: 'etybef.svg',
  dataValidator: false,
  sampleSets: ['candlestick'],
  config: {
    chart: {
      type: 'candlestick',
      polar: false
    },
    rangeSelector: {
      enabled: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Stock', {
  title: 'Column',
  description: '',
  constructor: 'StockChart',
  thumbnail: 'ogywen.svg',
  dataValidator: false,
  sampleSets: ['line-series-dates'],
  config: {
    chart: {
      type: 'column',
      polar: false
    },
    rangeSelector: {
      enabled: false
    }
  }
});

/*

Highcharts Editor

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.templates.add('Stock', {
  title: 'OHLC',
  description: '',
  constructor: 'StockChart',
  thumbnail: 'opilip.svg',
  dataValidator: false,
  sampleSets: ['candlestick'],
  config: {
    chart: {
      type: 'ohlc',
      polar: false
    },
    rangeSelector: {
      enabled: false
    }
  }
});

/*

Highcharts Editor v0.2.2

Copyright (c) 2016-2017, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/

highed.meta.optionsAdvanced = {
  "meta": {
    "types": {},
    "excludes": {}
  },
  "subtree": {
    "series": {
      "meta": {
        "types": {
          "array": "series",
          "object": 1
        },
        "name": "series",
        "excludes": {},
        "extends": ",plotOptions.series,plotOptions.ad,plotOptions.atr,plotOptions.bb,plotOptions.cci,plotOptions.cmf,plotOptions.ema,plotOptions.ikh,plotOptions.sma,plotOptions.macd,plotOptions.mfi,plotOptions.momentum,plotOptions.pivotpoints,plotOptions.priceenvelopes,plotOptions.psar,plotOptions.roc,plotOptions.rsi,plotOptions.stochastic,plotOptions.vbp,plotOptions.vwap,plotOptions.wma,plotOptions.zigzag,plotOptions.bellcurve,plotOptions.bullet,plotOptions.line,plotOptions.pyramid,plotOptions.funnel,plotOptions.histogram,plotOptions.pareto,plotOptions.sankey,plotOptions.solidgauge,plotOptions.streamgraph,plotOptions.sunburst,plotOptions.treemap,plotOptions.tilemap,plotOptions.variablepie,plotOptions.variwide,plotOptions.vector,plotOptions.windbarb,plotOptions.wordcloud,plotOptions.xrange,plotOptions.area,plotOptions.areaspline,plotOptions.bar,plotOptions.candlestick,plotOptions.column,plotOptions.flags,plotOptions.ohlc,plotOptions.pie,plotOptions.scatter,plotOptions.spline,plotOptions.scatter3d,plotOptions.arearange,plotOptions.areasplinerange,plotOptions.boxplot,plotOptions.bubble,plotOptions.columnrange,plotOptions.errorbar,plotOptions.gauge,plotOptions.polygon,plotOptions.waterfall,plotOptions.heatmap,plotOptions.mapbubble,plotOptions.mapline,plotOptions.mappoint,plotOptions.map"
      },
      "subtree": {
        "id": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "id",
            "excludes": {},
            "description": "An id for the series. This can be used after render time to get a\npointer to the series object through `chart.get()`."
          },
          "subtree": {}
        },
        "index": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "index",
            "excludes": {},
            "default": "undefined",
            "description": "The index of the series in the chart, affecting the internal index\nin the `chart.series` array, the visible Z index as well as the order\nin the legend."
          },
          "subtree": {}
        },
        "legendIndex": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "legendIndex",
            "excludes": {},
            "description": "The sequential index of the series in the legend."
          },
          "subtree": {}
        },
        "name": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "name",
            "excludes": {},
            "description": "The name of the series as shown in the legend, tooltip etc."
          },
          "subtree": {}
        },
        "stack": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "stack",
            "excludes": {},
            "default": "null",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "This option allows grouping series in a stacked chart. The stack\noption can be a string or a number or anything else, as long as the\ngrouped series' stack options match each other."
          },
          "subtree": {}
        },
        "type": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "type",
            "excludes": {},
            "description": "The type of series, for example `line` or `column`. By default, the\nseries type is inherited from [chart.type](#chart.type), so unless the\nchart is a combination of series types, there is no need to set it on the\nseries level."
          },
          "subtree": {}
        },
        "xAxis": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "xAxis",
            "excludes": {},
            "default": "0",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "When using dual or multiple x axes, this number defines which xAxis\nthe particular series is connected to. It refers to either the [axis\nid](#xAxis.id) or the index of the axis in the xAxis array, with\n0 being the first."
          },
          "subtree": {}
        },
        "yAxis": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "yAxis",
            "excludes": {},
            "default": "0",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "When using dual or multiple y axes, this number defines which yAxis\nthe particular series is connected to. It refers to either the [axis\nid](#yAxis.id) or the index of the axis in the yAxis array, with\n0 being the first."
          },
          "subtree": {}
        },
        "zIndex": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "zIndex",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Define the visual z index of the series."
          },
          "subtree": {}
        },
        "mapData": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "mapData",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "An array of objects containing a `path` definition and optionally\na code or property to join in the data as per the `joinBy` option."
          },
          "subtree": {}
        },
        "baseSeries": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "baseSeries",
            "excludes": {},
            "default": "undefined",
            "validFor": {
              "bellcurve": true,
              "histogram": true,
              "pareto": true
            },
            "description": "An integer identifying the index to use for the base series, or a string\nrepresenting the id of the series."
          },
          "subtree": {}
        },
        "states": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "states",
            "excludes": {},
            "validFor": {
              "bullet": true,
              "bar": true,
              "column": true,
              "columnrange": true
            }
          },
          "subtree": {
            "hover": {
              "meta": {
                "types": {},
                "name": "hover",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                }
              },
              "subtree": {}
            },
            "select": {
              "meta": {
                "types": {},
                "name": "select",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                }
              },
              "subtree": {}
            }
          }
        },
        "nodes": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "nodes",
            "excludes": {},
            "validFor": {
              "sankey": true
            },
            "products": {
              "highcharts": 1
            },
            "description": "A collection of options for the individual nodes. The nodes in a sankey \ndiagram are auto-generated instances of `Highcharts.Point`, but options can\nbe applied here and linked by the `id`."
          },
          "subtree": {
            "id": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "id",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The id of the auto-generated node, refering to the `from` or `to` setting of\nthe link."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the auto generated node."
              },
              "subtree": {}
            },
            "colorIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "colorIndex",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The color index of the auto generated node, especially for use in styled\nmode."
              },
              "subtree": {}
            },
            "column": {
              "meta": {
                "types": {
                  "undefined": 1,
                  "number": 1
                },
                "name": "column",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highcharts": 1
                },
                "description": "An optional column index of where to place the node. The default behaviour is\nto place it next to the preceding node."
              },
              "subtree": {}
            },
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The name to display for the node in data labels and tooltips. Use this when\nthe name is different from the `id`. Where the id must be unique for each\nnode, this is not necessary for the name."
              },
              "subtree": {}
            },
            "offset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "offset",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "The vertical offset of a node in terms of weight. Positive values shift the\nnode downwards, negative shift it upwards."
              },
              "subtree": {}
            }
          }
        },
        "marker": {
          "meta": {
            "types": {},
            "name": "marker",
            "excludes": {},
            "validFor": {
              "bubble": true,
              "mapbubble": true
            }
          },
          "subtree": {}
        }
      }
    },
    "plotOptions": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "plotOptions",
        "excludes": {},
        "description": "The plotOptions is a wrapper object for config objects for each series\ntype. The config objects for each series can also be overridden for\neach series item as given in the series array.\n\nConfiguration options for the series are given in three levels. Options\nfor all series in a chart are given in the [plotOptions.series](#plotOptions.\nseries) object. Then options for all series of a specific type are\ngiven in the plotOptions of that type, for example plotOptions.line.\nNext, options for one single series are given in [the series array](#series)."
      },
      "subtree": {
        "ad": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "ad",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Accumulation Distribution (AD). This series requires `linkedTo` option to\nbe set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "volumeSeriesID": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "volumeSeriesID",
                    "excludes": {},
                    "default": "volume",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The id of volume series which is mandatory.\nFor example using OHLC data, volumeSeriesID='volume' means\nthe indicator will be calculated using OHLC and volume values."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "atr": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "atr",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Average true range indicator (ATR). This series requires `linkedTo`\noption to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "bb": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "bb",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Bollinger bands (BB). This series requires the `linkedTo` option to be\nset and should be loaded after the `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "default": "BB (20, 2)"
              },
              "subtree": {}
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 20
                  },
                  "subtree": {}
                },
                "standardDeviation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "standardDeviation",
                    "excludes": {},
                    "default": 2,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Standard deviation for top and bottom bands."
                  },
                  "subtree": {}
                },
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 3
                  },
                  "subtree": {}
                }
              }
            },
            "bottomLine": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "bottomLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Bottom line options."
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "Styles for a bottom line."
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line. If not set, it's inherited from\n[plotOptions.bb.color](#plotOptions.bb.color)."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "topLine": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "topLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Top line options.",
                "extends": "{plotOptions.bb.bottomLine}"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {},
                        "name": "lineColor",
                        "excludes": {}
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span><b> {series.name}</b><br/>Top: {point.top}<br/>Middle: {point.middle}<br/>Bottom: {point.bottom}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "averages"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "cci": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "cci",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Commodity Channel Index (CCI). This series requires `linkedTo` option to\nbe set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "cmf": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "cmf",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Chaikin Money Flow indicator (cmf).",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                },
                "volumeSeriesID": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "volumeSeriesID",
                    "excludes": {},
                    "default": "volume",
                    "description": "The id of another series to use its data as volume data for the\nindiator calculation."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "ema": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "ema",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Exponential moving average indicator (EMA). This series requires the\n`linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                },
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "ikh": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "ikh",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Ichimoku Kinko Hyo (IKH). This series requires `linkedTo` option to be\nset.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 26
                  },
                  "subtree": {}
                },
                "periodTenkan": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "periodTenkan",
                    "excludes": {},
                    "default": 9,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The base period for Tenkan calculations."
                  },
                  "subtree": {}
                },
                "periodSenkouSpanB": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "periodSenkouSpanB",
                    "excludes": {},
                    "default": 52,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The base period for Senkou Span B calculations"
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "tenkanLine": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "tenkanLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for Tenkan line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "kijunLine": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "kijunLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for Kijun line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "chikouLine": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "chikouLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for Chikou line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "senkouSpanA": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "senkouSpanA",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for Senkou Span A line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "senkouSpanB": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "senkouSpanB",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for Senkou Span B line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "senkouSpan": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "senkouSpan",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for fill between Senkou Span A and B"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "fill": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "fill",
                        "excludes": {},
                        "default": "rgba(255, 0, 0, 0.5)",
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the area between Senkou Span A and B."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "ichimoku-averages"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "sma": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "sma",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Simple moving average indicator (SMA). This series requires `linkedTo`\noption to be set.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The name of the series as shown in the legend, tooltip etc. If not\nset, it will be based on a technical indicator type and default \nparams."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "valueDecimals": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "valueDecimals",
                    "excludes": {},
                    "default": 4,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Number of decimals in indicator series."
                  },
                  "subtree": {}
                }
              }
            },
            "linkedTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linkedTo",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The main series ID that indicator will be based on. Required for this\nindicator."
              },
              "subtree": {}
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 0,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The point index which indicator calculations will base. For\nexample using OHLC data, index=2 means the indicator will be\ncalculated using Low values."
                  },
                  "subtree": {}
                },
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The base period for indicator calculations."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "macd": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "macd",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Moving Average Convergence Divergence (MACD). This series requires\n`linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "shortPeriod": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "shortPeriod",
                    "excludes": {},
                    "default": 12,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The short period for indicator calculations."
                  },
                  "subtree": {}
                },
                "longPeriod": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "longPeriod",
                    "excludes": {},
                    "default": 26,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The long period for indicator calculations."
                  },
                  "subtree": {}
                },
                "signalPeriod": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "signalPeriod",
                    "excludes": {},
                    "default": 9,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The base period for signal calculations."
                  },
                  "subtree": {}
                },
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 26
                  },
                  "subtree": {}
                }
              }
            },
            "signalLine": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "signalLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for signal line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "macdLine": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "macdLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for macd line"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "groupPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "groupPadding",
                "excludes": {},
                "default": 0.1
              },
              "subtree": {}
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 0.1
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "halo": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "halo",
                        "excludes": {}
                      },
                      "subtree": {
                        "size": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "size",
                            "excludes": {},
                            "default": 0
                          },
                          "subtree": {}
                        }
                      }
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "averages"
                  },
                  "subtree": {}
                }
              }
            },
            "minPointLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "minPointLength",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            }
          }
        },
        "mfi": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "mfi",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Money Flow Index. This series requires `linkedTo` option to be set and\nshould be loaded after the `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                },
                "volumeSeriesID": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "volumeSeriesID",
                    "excludes": {},
                    "default": "volume",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The id of volume series which is mandatory.\nFor example using OHLC data, volumeSeriesID='volume' means \nthe indicator will be calculated using OHLC and volume values."
                  },
                  "subtree": {}
                },
                "decimals": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "decimals",
                    "excludes": {},
                    "default": 4,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Number of maximum decimals that are used in MFI calculations."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "momentum": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "momentum",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Momentum. This series requires `linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "pivotpoints": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "pivotpoints",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Pivot points indicator. This series requires the `linkedTo` option to be\rset and should be loaded after `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 28
                  },
                  "subtree": {}
                },
                "algorithm": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "algorithm",
                    "excludes": {},
                    "default": "standard",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Algorithm used to calculate ressistance and support lines based\ron pivot points. Implemented algorithms: `'standard'`,\r`'fibonacci'` and `'camarilla'`"
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "enableMouseTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enableMouseTracking",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "format": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "format",
                    "excludes": {},
                    "default": "{point.pivotLine}"
                  },
                  "subtree": {}
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "averages"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "priceenvelopes": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "priceenvelopes",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Price envelopes indicator based on [SMA](#plotOptions.sma) calculations.\rThis series requires the `linkedTo` option to be set and should be loaded\rafter the `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span><b> {series.name}</b><br/>Top: {point.top}<br/>Middle: {point.middle}<br/>Bottom: {point.bottom}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 20
                  },
                  "subtree": {}
                },
                "topBand": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "topBand",
                    "excludes": {},
                    "default": 0.1,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Percentage above the moving average that should be displayed.\r0.1 means 110%. Relative to the calculated value."
                  },
                  "subtree": {}
                },
                "bottomBand": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "bottomBand",
                    "excludes": {},
                    "default": 0.1,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Percentage below the moving average that should be displayed.\r0.1 means 90%. Relative to the calculated value."
                  },
                  "subtree": {}
                }
              }
            },
            "bottomLine": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "bottomLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Bottom line options."
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line. If not set, it's inherited from\r[plotOptions.priceenvelopes.color](#plotOptions.\rpriceenvelopes.color)."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "topLine": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "topLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Top line options.",
                "extends": "{plotOptions.priceenvelopes.bottomLine}"
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "averages"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "psar": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "psar",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Parabolic SAR. This series requires `linkedTo`\roption to be set and should be loaded\rafter `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidthPlus": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidthPlus",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "initialAccelerationFactor": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "initialAccelerationFactor",
                    "excludes": {},
                    "default": 0.02,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The initial value for acceleration factor.\rAcceleration factor is starting with this value\rand increases by specified increment each time\rthe extreme point makes a new high.\rAF can reach a maximum of maxAccelerationFactor,\rno matter how long the uptrend extends."
                  },
                  "subtree": {}
                },
                "maxAccelerationFactor": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "maxAccelerationFactor",
                    "excludes": {},
                    "default": 0.2,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The Maximum value for acceleration factor.\rAF can reach a maximum of maxAccelerationFactor,\rno matter how long the uptrend extends."
                  },
                  "subtree": {}
                },
                "increment": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "increment",
                    "excludes": {},
                    "default": 0.02,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Acceleration factor increases by increment each time\rthe extreme point makes a new high."
                  },
                  "subtree": {}
                },
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 2,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Index from which PSAR is starting calculation"
                  },
                  "subtree": {}
                },
                "decimals": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "decimals",
                    "excludes": {},
                    "default": 4,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Number of maximum decimals that are used in PSAR calculations."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "roc": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "roc",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Rate of change indicator (ROC). The indicator value for each point\nis defined as:\n\n`(C - Cn) / Cn * 100`\n\nwhere: `C` is the close value of the point of the same x in the\nlinked series and `Cn` is the close value of the point `n` periods\nago. `n` is set through [period](#plotOptions.roc.params.period).\n\nThis series requires `linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "default": "Rate of Change (9)"
              },
              "subtree": {}
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 3
                  },
                  "subtree": {}
                },
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 9
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "rsi": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "rsi",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Relative strength index (RSI) technical indicator. This series\nrequires the `linkedTo` option to be set and should be loaded after\nthe `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 14
                  },
                  "subtree": {}
                },
                "decimals": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "decimals",
                    "excludes": {},
                    "default": 4,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Number of maximum decimals that are used in RSI calculations."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "stochastic": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "stochastic",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Stochastic oscillator. This series requires the `linkedTo` option to be\nset and should be loaded after the `stock/indicators/indicators.js` file.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "default": "Stochastic (14, 3)"
              },
              "subtree": {}
            },
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "periods": {
                  "meta": {
                    "types": {
                      "array": "object"
                    },
                    "name": "periods",
                    "excludes": {},
                    "default": "[14, 3]",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Periods for Stochastic oscillator: [%K, %D]."
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span><b> {series.name}</b><br/>%K: {point.y}<br/>%D: {point.smoothed}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "smoothedLine": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "smoothedLine",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Smoothed line options."
              },
              "subtree": {
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "Styles for a smoothed line."
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of the line."
                      },
                      "subtree": {}
                    },
                    "lineColor": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of the line. If not set, it's inherited from\n[plotOptions.stochastic.color](#plotOptions.stochastic.\ncolor)."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "averages"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "vbp": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "vbp",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Volume By Price indicator.\n\nThis series requires `linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "ranges": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "ranges",
                    "excludes": {},
                    "default": 12,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The number of price zones."
                  },
                  "subtree": {}
                },
                "volumeSeriesID": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "volumeSeriesID",
                    "excludes": {},
                    "default": "volume",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The id of volume series which is mandatory. For example using\nOHLC data, volumeSeriesID='volume' means the indicator will be\ncalculated using OHLC and volume values."
                  },
                  "subtree": {}
                }
              }
            },
            "zoneLines": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "zoneLines",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for lines which determine price zones."
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": "true",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Enable/disable zone lines."
                  },
                  "subtree": {}
                },
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#0A9AC9",
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of zone lines."
                      },
                      "subtree": {}
                    },
                    "dashStyle": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "dashStyle",
                        "excludes": {},
                        "default": "LongDash",
                        "products": {
                          "highstock": 1
                        },
                        "description": "The dash style of zone lines."
                      },
                      "subtree": {}
                    },
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": 1,
                        "products": {
                          "highstock": 1
                        },
                        "description": "Pixel width of zone lines."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "volumeDivision": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "volumeDivision",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The styles for bars when volume is divided into positive/negative."
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true,
                    "products": {
                      "highstock": 1
                    },
                    "description": "Option to control if volume is divided."
                  },
                  "subtree": {}
                },
                "styles": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "styles",
                    "excludes": {}
                  },
                  "subtree": {
                    "positiveColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "positiveColor",
                        "excludes": {},
                        "default": "rgba(144, 237, 125, 0.8)",
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of positive volume bars."
                      },
                      "subtree": {}
                    },
                    "negativeColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "negativeColor",
                        "excludes": {},
                        "default": "rgba(244, 91, 91, 0.8)",
                        "products": {
                          "highstock": 1
                        },
                        "description": "Color of negative volume bars."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "animationLimit": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "animationLimit",
                "excludes": {},
                "default": 1000
              },
              "subtree": {}
            },
            "enableMouseTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enableMouseTracking",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": -1
              },
              "subtree": {}
            },
            "crisp": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "crisp",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "allowOverlap": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "allowOverlap",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "top"
                  },
                  "subtree": {}
                },
                "format": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "format",
                    "excludes": {},
                    "default": "P: {point.volumePos:.2f} | N: {point.volumeNeg:.2f}"
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {}
                  },
                  "subtree": {
                    "fontSize": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "fontSize",
                        "excludes": {},
                        "default": "7px"
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            }
          }
        },
        "vwap": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "vwap",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Volume Weighted Average Price indicator.\n\nThis series requires `linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 30
                  },
                  "subtree": {}
                },
                "volumeSeriesID": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "volumeSeriesID",
                    "excludes": {},
                    "default": "volume",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The id of volume series which is mandatory. For example using\nOHLC data, volumeSeriesID='volume' means the indicator will be\ncalculated using OHLC and volume values."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "wma": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "wma",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Weighted moving average indicator (WMA). This series requires `linkedTo`\noption to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "index": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "index",
                    "excludes": {},
                    "default": 3
                  },
                  "subtree": {}
                },
                "period": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "period",
                    "excludes": {},
                    "default": 9
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "zigzag": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "zigzag",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Zig Zag indicator.\n\nThis series requires `linkedTo` option to be set.",
            "extends": "{plotOptions.sma}"
          },
          "subtree": {
            "params": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "params",
                "excludes": {}
              },
              "subtree": {
                "lowIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "lowIndex",
                    "excludes": {},
                    "default": 2,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The point index which indicator calculations will base - low\nvalue.\n\nFor example using OHLC data, index=2 means the indicator will be\ncalculated using Low values."
                  },
                  "subtree": {}
                },
                "highIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "highIndex",
                    "excludes": {},
                    "default": 1,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The point index which indicator calculations will base - high\nvalue.\n\nFor example using OHLC data, index=1 means the indicator will be\ncalculated using High values."
                  },
                  "subtree": {}
                },
                "deviation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "deviation",
                    "excludes": {},
                    "default": 1,
                    "products": {
                      "highstock": 1
                    },
                    "description": "The threshold for the value change.\n\nFor example deviation=1 means the indicator will ignore all price\nmovements less than 1%."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "bellcurve": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "bellcurve",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A bell curve is an areaspline series which represents the probability density\nfunction of the normal distribution. It calculates mean and standard\ndeviation of the base series data and plots the curve according to the\ncalculated parameters.",
            "extends": "plotOptions.areaspline"
          },
          "subtree": {
            "intervals": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "intervals",
                "excludes": {},
                "default": 3,
                "description": "This option allows to define the length of the bell curve. A unit of the\nlength of the bell curve is standard deviation."
              },
              "subtree": {}
            },
            "pointsInInterval": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointsInInterval",
                "excludes": {},
                "default": 3,
                "description": "Defines how many points should be plotted within 1 interval. See \n`plotOptions.bellcurve.intervals`."
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "series": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "series",
            "excludes": {},
            "description": "General options for all series types."
          },
          "subtree": {
            "boostThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "boostThreshold",
                "excludes": {},
                "default": "5000",
                "description": "Set the point threshold for when a series should enter boost mode.\n\nSetting it to e.g. 2000 will cause the series to enter boost mode when there\nare 2000 or more points in the series.\n\nTo disable boosting on the series, set the `boostThreshold` to 0. Setting it\nto 1 will force boosting.\n\nRequires `modules/boost.js`."
              },
              "subtree": {}
            },
            "gapSize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "gapSize",
                "excludes": {},
                "default": "0",
                "products": {
                  "highstock": 1
                },
                "description": "Defines when to display a gap in the graph, together with the\n[gapUnit](plotOptions.series.gapUnit) option.\n\nIn case when `dataGrouping` is enabled, points can be grouped into a \nlarger time span. This can make the grouped points to have a greater \ndistance than the absolute value of `gapSize` property, which will result\nin disappearing graph completely. To prevent this situation the mentioned\ndistance between grouped points is used instead of previously defined \n`gapSize`.\n\nIn practice, this option is most often used to visualize gaps in\ntime series. In a stock chart, intraday data is available for daytime\nhours, while gaps will appear in nights and weekends."
              },
              "subtree": {}
            },
            "gapUnit": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "gapUnit",
                "excludes": {},
                "default": "relative",
                "products": {
                  "highstock": 1
                },
                "description": "Together with [gapSize](plotOptions.series.gapSize), this option defines\nwhere to draw gaps in the graph.\n\nWhen the `gapUnit` is `relative` (default), a gap size of 5 means\nthat if the distance between two points is greater than five times\nthat of the two closest points, the graph will be broken.\n\nWhen the `gapUnit` is `value`, the gap is based on absolute axis values,\nwhich on a datetime axis is milliseconds. This also applies to the\nnavigator series that inherits gap options from the base series."
              },
              "subtree": {}
            },
            "label": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "label",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Series labels are placed as close to the series as possible in a\nnatural way, seeking to avoid other series. The goal of this\nfeature is to make the chart more easily readable, like if a\nhuman designer placed the labels in the optimal position.\n\nThe series labels currently work with series types having a\n`graph` or an `area`.\n\nRequires the `series-label.js` module."
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true,
                    "description": "Enable the series label per series."
                  },
                  "subtree": {}
                },
                "connectorAllowed": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "connectorAllowed",
                    "excludes": {},
                    "default": true,
                    "description": "Allow labels to be placed distant to the graph if necessary,\nand draw a connector line to the graph."
                  },
                  "subtree": {}
                },
                "connectorNeighbourDistance": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "connectorNeighbourDistance",
                    "excludes": {},
                    "default": 24,
                    "description": "If the label is closer than this to a neighbour graph, draw a\nconnector."
                  },
                  "subtree": {}
                },
                "minFontSize": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "minFontSize",
                    "excludes": {},
                    "default": null,
                    "description": "For area-like series, allow the font size to vary so that\nsmall areas get a smaller font size. The default applies this\neffect to area-like series but not line-like series."
                  },
                  "subtree": {}
                },
                "maxFontSize": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "maxFontSize",
                    "excludes": {},
                    "default": null,
                    "description": "For area-like series, allow the font size to vary so that\nsmall areas get a smaller font size. The default applies this\neffect to area-like series but not line-like series."
                  },
                  "subtree": {}
                },
                "onArea": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "onArea",
                    "excludes": {},
                    "default": null,
                    "description": "Draw the label on the area of an area series. By default it\nis drawn on the area. Set it to `false` to draw it next to\nthe graph instead."
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "description": "Styles for the series label. The color defaults to the series\ncolor, or a contrast color if `onArea`."
                  },
                  "subtree": {
                    "fontWeight": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "fontWeight",
                        "excludes": {},
                        "default": "bold"
                      },
                      "subtree": {}
                    }
                  }
                },
                "boxesToAvoid": {
                  "meta": {
                    "types": {
                      "array": "Object"
                    },
                    "name": "boxesToAvoid",
                    "excludes": {},
                    "description": "An array of boxes to avoid when laying out the labels. Each \nitem has a `left`, `right`, `top` and `bottom` property."
                  },
                  "subtree": {}
                }
              }
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Data grouping is the concept of sampling the data values into larger\nblocks in order to ease readability and increase performance of the\nJavaScript charts. Highstock by default applies data grouping when\nthe points become closer than a certain pixel value, determined by\nthe `groupPixelWidth` option.\n\nIf data grouping is applied, the grouping information of grouped\npoints can be read from the [Point.dataGroup](#Point.dataGroup)."
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1,
                      "function": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "The method of approximation inside a group. When for example 30 days\nare grouped into one month, this determines what value should represent\nthe group. Possible values are \"average\", \"averages\", \"open\", \"high\",\n\"low\", \"close\" and \"sum\". For OHLC and candlestick series the approximation\nis \"ohlc\" by default, which finds the open, high, low and close values\nwithin all the grouped data. For ranges, the approximation is \"range\",\nwhich finds the low and high values. For multi-dimensional data,\nlike ranges and OHLC, \"averages\" will compute the average for each\ndimension.\n\nCustom aggregate methods can be added by assigning a callback function\nas the approximation. This function takes a numeric array as the\nargument and should return a single numeric value or `null`. Note\nthat the numeric array will never contain null values, only true\nnumbers. Instead, if null values are present in the raw data, the\nnumeric array will have an `.hasNulls` property set to `true`. For\nsingle-value data sets the data is available in the first argument\nof the callback function. For OHLC data sets, all the open values\nare in the first argument, all high values in the second etc.\n\nSince v4.2.7, grouping meta data is available in the approximation\ncallback from `this.dataGroupInfo`. It can be used to extract information\nfrom the raw data.\n\nDefaults to `average` for line-type series, `sum` for columns, `range`\nfor range series and `ohlc` for OHLC and candlestick."
                  },
                  "subtree": {}
                },
                "dateTimeLabelFormats": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "dateTimeLabelFormats",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "Datetime formats for the header of the tooltip in a stock chart.\nThe format can vary within a chart depending on the currently selected\ntime range and the current data grouping.\n\nThe default formats are:\n\n<pre>{\n    millisecond: [\n        '%A, %b %e, %H:%M:%S.%L', '%A, %b %e, %H:%M:%S.%L', '-%H:%M:%S.%L'\n    ],\n    second: ['%A, %b %e, %H:%M:%S', '%A, %b %e, %H:%M:%S', '-%H:%M:%S'],\n    minute: ['%A, %b %e, %H:%M', '%A, %b %e, %H:%M', '-%H:%M'],\n    hour: ['%A, %b %e, %H:%M', '%A, %b %e, %H:%M', '-%H:%M'],\n    day: ['%A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y'],\n    week: ['Week from %A, %b %e, %Y', '%A, %b %e', '-%A, %b %e, %Y'],\n    month: ['%B %Y', '%B', '-%B %Y'],\n    year: ['%Y', '%Y', '-%Y']\n}</pre>\n\nFor each of these array definitions, the first item is the format\nused when the active time span is one unit. For instance, if the\ncurrent data applies to one week, the first item of the week array\nis used. The second and third items are used when the active time\nspan is more than two units. For instance, if the current data applies\nto two weeks, the second and third item of the week array are used,\n and applied to the start and end date of the time span."
                  },
                  "subtree": {}
                },
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": "true",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Enable or disable data grouping."
                  },
                  "subtree": {}
                },
                "forced": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "forced",
                    "excludes": {},
                    "default": "false",
                    "products": {
                      "highstock": 1
                    },
                    "description": "When data grouping is forced, it runs no matter how small the intervals\nare. This can be handy for example when the sum should be calculated\nfor values appearing at random times within each hour."
                  },
                  "subtree": {}
                },
                "groupPixelWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "groupPixelWidth",
                    "excludes": {},
                    "default": "2",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The approximate pixel width of each group. If for example a series\nwith 30 points is displayed over a 600 pixel wide plot area, no grouping\nis performed. If however the series contains so many points that\nthe spacing is less than the groupPixelWidth, Highcharts will try\nto group it into appropriate groups so that each is more or less\ntwo pixels wide. If multiple series with different group pixel widths\nare drawn on the same x axis, all series will take the greatest width.\nFor example, line series have 2px default group width, while column\nseries have 10px. If combined, both the line and the column will\nhave 10px by default."
                  },
                  "subtree": {}
                },
                "smoothed": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "smoothed",
                    "excludes": {},
                    "default": "false",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Normally, a group is indexed by the start of that group, so for example\nwhen 30 daily values are grouped into one month, that month's x value\nwill be the 1st of the month. This apparently shifts the data to\nthe left. When the smoothed option is true, this is compensated for.\nThe data is shifted to the middle of the group, and min and max\nvalues are preserved. Internally, this is used in the Navigator series."
                  },
                  "subtree": {}
                },
                "units": {
                  "meta": {
                    "types": {
                      "array": "object"
                    },
                    "name": "units",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "An array determining what time intervals the data is allowed to be\ngrouped to. Each array item is an array where the first value is\nthe time unit and the second value another array of allowed multiples.\nDefaults to:\n\n<pre>units: [[\n    'millisecond', // unit name\n    [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples\n], [\n    'second',\n    [1, 2, 5, 10, 15, 30]\n], [\n    'minute',\n    [1, 2, 5, 10, 15, 30]\n], [\n    'hour',\n    [1, 2, 3, 4, 6, 8, 12]\n], [\n    'day',\n    [1]\n], [\n    'week',\n    [1]\n], [\n    'month',\n    [1, 3, 6]\n], [\n    'year',\n    null\n]]</pre>"
                  },
                  "subtree": {}
                }
              }
            },
            "navigatorOptions": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "navigatorOptions",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highstock": 1
                },
                "description": "Options for the corresponding navigator series if `showInNavigator`\nis `true` for this series. Available options are the same as any\nseries, documented at [plotOptions](#plotOptions.series) and\n[series](#series).\n\n\nThese options are merged with options in [navigator.series](#navigator.\nseries), and will take precedence if the same option is defined both\nplaces."
              },
              "subtree": {}
            },
            "showInNavigator": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInNavigator",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highstock": 1
                },
                "description": "Whether or not to show the series in the navigator. Takes precedence\nover [navigator.baseSeries](#navigator.baseSeries) if defined."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": "2",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Pixel width of the graph line."
              },
              "subtree": {}
            },
            "allowPointSelect": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowPointSelect",
                "excludes": {},
                "default": "false",
                "description": "Allow this series' points to be selected by clicking on the graphic \n(columns, point markers, pie slices, map areas etc)."
              },
              "subtree": {}
            },
            "showCheckbox": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showCheckbox",
                "excludes": {},
                "default": "false",
                "description": "If true, a checkbox is displayed next to the legend item to allow\nselecting the series. The state of the checkbox is determined by\nthe `selected` option."
              },
              "subtree": {}
            },
            "animation": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "animation",
                "excludes": {},
                "description": "Enable or disable the initial animation when a series is displayed.\nThe animation can also be set as a configuration object. Please\nnote that this option only applies to the initial animation of the\nseries itself. For other animations, see [chart.animation](#chart.\nanimation) and the animation parameter under the API methods. The\nfollowing properties are supported:\n\n<dl>\n\n<dt>duration</dt>\n\n<dd>The duration of the animation in milliseconds.</dd>\n\n<dt>easing</dt>\n\n<dd>A string reference to an easing function set on the `Math` object.\nSee the _Custom easing function_ demo below.</dd>\n\n</dl>\n\nDue to poor performance, animation is disabled in old IE browsers\nfor several chart types."
              },
              "subtree": {
                "duration": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "duration",
                    "excludes": {},
                    "default": 1000
                  },
                  "subtree": {}
                }
              }
            },
            "events": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "events",
                "excludes": {}
              },
              "subtree": {
                "afterAnimate": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "afterAnimate",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Fires after the series has finished its initial animation, or in\ncase animation is disabled, immediately as the series is displayed."
                  },
                  "subtree": {}
                },
                "checkboxClick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "checkboxClick",
                    "excludes": {},
                    "description": "Fires when the checkbox next to the series' name in the legend is\nclicked. One parameter, `event`, is passed to the function. The state\nof the checkbox is found by `event.checked`. The checked item is\nfound by `event.item`. Return `false` to prevent the default action\nwhich is to toggle the select state of the series."
                  },
                  "subtree": {}
                },
                "click": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "click",
                    "excludes": {},
                    "description": "Fires when the series is clicked. One parameter, `event`, is passed\nto the function, containing common event information. Additionally,\n`event.point` holds a pointer to the nearest point on the graph."
                  },
                  "subtree": {}
                },
                "hide": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "hide",
                    "excludes": {},
                    "description": "Fires when the series is hidden after chart generation time, either\nby clicking the legend item or by calling `.hide()`."
                  },
                  "subtree": {}
                },
                "legendItemClick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "legendItemClick",
                    "excludes": {},
                    "description": "Fires when the legend item belonging to the series is clicked. One\nparameter, `event`, is passed to the function. The default action\nis to toggle the visibility of the series. This can be prevented\nby returning `false` or calling `event.preventDefault()`."
                  },
                  "subtree": {}
                },
                "mouseOut": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "mouseOut",
                    "excludes": {},
                    "description": "Fires when the mouse leaves the graph. One parameter, `event`, is\npassed to the function, containing common event information. If the\n[stickyTracking](#plotOptions.series) option is true, `mouseOut`\ndoesn't happen before the mouse enters another graph or leaves the\nplot area."
                  },
                  "subtree": {}
                },
                "mouseOver": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "mouseOver",
                    "excludes": {},
                    "description": "Fires when the mouse enters the graph. One parameter, `event`, is\npassed to the function, containing common event information."
                  },
                  "subtree": {}
                },
                "show": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "show",
                    "excludes": {},
                    "description": "Fires when the series is shown after chart generation time, either\nby clicking the legend item or by calling `.show()`."
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {},
                "description": "Options for the point markers of line-like series. Properties like\n`fillColor`, `lineColor` and `lineWidth` define the visual appearance\nof the markers. Other series types, like column series, don't have\nmarkers, but have visual options on the series level instead.\n\nIn styled mode, the markers can be styled with the `.highcharts-point`,\n`.highcharts-point-hover` and `.highcharts-point-select`\nclass names."
              },
              "subtree": {
                "lineWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "lineWidth",
                    "excludes": {},
                    "default": "0",
                    "description": "The width of the point marker's outline."
                  },
                  "subtree": {}
                },
                "lineColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "lineColor",
                    "excludes": {},
                    "default": "#ffffff",
                    "description": "The color of the point marker's outline. When `null`, the series'\nor point's color is used."
                  },
                  "subtree": {}
                },
                "enabledThreshold": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "enabledThreshold",
                    "excludes": {},
                    "default": 2,
                    "description": "The threshold for how dense the point markers should be before they\nare hidden, given that `enabled` is not defined. The number indicates\nthe horizontal distance between the two closest points in the series,\nas multiples of the `marker.radius`. In other words, the default\nvalue of 2 means points are hidden if overlapping horizontally."
                  },
                  "subtree": {}
                },
                "radius": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "radius",
                    "excludes": {},
                    "default": 4,
                    "description": "The radius of the point marker."
                  },
                  "subtree": {}
                },
                "states": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "states",
                    "excludes": {},
                    "description": "States for a single point marker."
                  },
                  "subtree": {
                    "normal": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "normal",
                        "excludes": {},
                        "description": "The normal state of a single point marker. Currently only used\nfor setting animation when returning to normal state from hover."
                      },
                      "subtree": {
                        "animation": {
                          "meta": {
                            "types": {
                              "boolean": 1,
                              "object": 1
                            },
                            "name": "animation",
                            "excludes": {},
                            "default": true,
                            "description": "Animation when returning to normal state after hovering."
                          },
                          "subtree": {}
                        }
                      }
                    },
                    "hover": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "hover",
                        "excludes": {},
                        "description": "The hover state for a single point marker."
                      },
                      "subtree": {
                        "animation": {
                          "meta": {
                            "types": {
                              "boolean": 1,
                              "object": 1
                            },
                            "name": "animation",
                            "excludes": {},
                            "description": "Animation when hovering over the marker."
                          },
                          "subtree": {
                            "duration": {
                              "meta": {
                                "types": {
                                  "number": 1
                                },
                                "name": "duration",
                                "excludes": {},
                                "default": 50
                              },
                              "subtree": {}
                            }
                          }
                        },
                        "enabled": {
                          "meta": {
                            "types": {
                              "boolean": 1
                            },
                            "name": "enabled",
                            "excludes": {},
                            "default": true,
                            "description": "Enable or disable the point marker."
                          },
                          "subtree": {}
                        },
                        "radiusPlus": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "radiusPlus",
                            "excludes": {},
                            "default": 2,
                            "description": "The number of pixels to increase the radius of the hovered\npoint."
                          },
                          "subtree": {}
                        },
                        "lineWidthPlus": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "lineWidthPlus",
                            "excludes": {},
                            "default": 1,
                            "description": "The additional line width for a hovered point."
                          },
                          "subtree": {}
                        },
                        "fillColor": {
                          "meta": {
                            "types": {
                              "color": 1
                            },
                            "name": "fillColor",
                            "excludes": {},
                            "default": "null",
                            "description": "The fill color of the marker in hover state. When `null`, the\nseries' or point's fillColor for normal state is used."
                          },
                          "subtree": {}
                        },
                        "lineColor": {
                          "meta": {
                            "types": {
                              "color": 1
                            },
                            "name": "lineColor",
                            "excludes": {},
                            "default": "null",
                            "description": "The color of the point marker's outline. When `null`, the\nseries' or point's lineColor for normal state is used."
                          },
                          "subtree": {}
                        },
                        "lineWidth": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "lineWidth",
                            "excludes": {},
                            "default": "null",
                            "description": "The width of the point marker's outline. When `null`, the\nseries' or point's lineWidth for normal state is used."
                          },
                          "subtree": {}
                        },
                        "radius": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "radius",
                            "excludes": {},
                            "description": "The radius of the point marker. In hover state, it defaults\nto the normal state's radius + 2 as per the\n[radiusPlus](#plotOptions.series.marker.states.hover.radiusPlus)\noption."
                          },
                          "subtree": {}
                        }
                      }
                    },
                    "select": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "select",
                        "excludes": {},
                        "description": "The appearance of the point marker when selected. In order to\nallow a point to be selected, set the `series.allowPointSelect`\noption to true."
                      },
                      "subtree": {
                        "fillColor": {
                          "meta": {
                            "types": {
                              "color": 1
                            },
                            "name": "fillColor",
                            "excludes": {},
                            "default": "#cccccc",
                            "description": "The fill color of the point marker."
                          },
                          "subtree": {}
                        },
                        "lineColor": {
                          "meta": {
                            "types": {
                              "color": 1
                            },
                            "name": "lineColor",
                            "excludes": {},
                            "default": "#000000",
                            "description": "The color of the point marker's outline. When `null`, the\nseries' or point's color is used."
                          },
                          "subtree": {}
                        },
                        "lineWidth": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "lineWidth",
                            "excludes": {},
                            "default": 2,
                            "description": "The width of the point marker's outline."
                          },
                          "subtree": {}
                        },
                        "radius": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "radius",
                            "excludes": {},
                            "description": "The radius of the point marker. In hover state, it defaults\nto the normal state's radius + 2."
                          },
                          "subtree": {}
                        },
                        "enabled": {
                          "meta": {
                            "types": {
                              "boolean": 1
                            },
                            "name": "enabled",
                            "excludes": {},
                            "default": "true",
                            "description": "Enable or disable visible feedback for selection."
                          },
                          "subtree": {}
                        }
                      }
                    }
                  }
                },
                "fillColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "fillColor",
                    "excludes": {},
                    "default": "null",
                    "description": "The fill color of the point marker. When `null`, the series' or\npoint's color is used."
                  },
                  "subtree": {}
                },
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "description": "Enable or disable the point marker. If `null`, the markers are hidden\nwhen the data is dense, and shown for more widespread data points."
                  },
                  "subtree": {}
                },
                "height": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "height",
                    "excludes": {},
                    "default": "null",
                    "description": "Image markers only. Set the image width explicitly. When using this\noption, a `width` must also be set."
                  },
                  "subtree": {}
                },
                "symbol": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "symbol",
                    "excludes": {},
                    "default": "null",
                    "description": "A predefined shape or symbol for the marker. When null, the symbol\nis pulled from options.symbols. Other possible values are \"circle\",\n\"square\", \"diamond\", \"triangle\" and \"triangle-down\".\n\nAdditionally, the URL to a graphic can be given on this form:\n\"url(graphic.png)\". Note that for the image to be applied to exported\ncharts, its URL needs to be accessible by the export server.\n\nCustom callbacks for symbol path generation can also be added to\n`Highcharts.SVGRenderer.prototype.symbols`. The callback is then\nused by its method name, as shown in the demo."
                  },
                  "subtree": {}
                },
                "width": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "width",
                    "excludes": {},
                    "default": "null",
                    "description": "Image markers only. Set the image width explicitly. When using this\noption, a `height` must also be set."
                  },
                  "subtree": {}
                }
              }
            },
            "point": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "point",
                "excludes": {},
                "description": "Properties for each single point."
              },
              "subtree": {
                "events": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "events",
                    "excludes": {},
                    "description": "Events for each single point."
                  },
                  "subtree": {
                    "click": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "click",
                        "excludes": {},
                        "description": "Fires when a point is clicked. One parameter, `event`, is passed\nto the function, containing common event information.\n\nIf the `series.allowPointSelect` option is true, the default\naction for the point's click event is to toggle the point's\nselect state. Returning `false` cancels this action."
                      },
                      "subtree": {}
                    },
                    "mouseOut": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "mouseOut",
                        "excludes": {},
                        "description": "Fires when the mouse leaves the area close to the point. One\nparameter, `event`, is passed to the function, containing common\nevent information."
                      },
                      "subtree": {}
                    },
                    "mouseOver": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "mouseOver",
                        "excludes": {},
                        "description": "Fires when the mouse enters the area close to the point. One\nparameter, `event`, is passed to the function, containing common\nevent information."
                      },
                      "subtree": {}
                    },
                    "remove": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "remove",
                        "excludes": {},
                        "description": "Fires when the point is removed using the `.remove()` method. One\nparameter, `event`, is passed to the function. Returning `false`\ncancels the operation."
                      },
                      "subtree": {}
                    },
                    "select": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "select",
                        "excludes": {},
                        "description": "Fires when the point is selected either programmatically or\nfollowing a click on the point. One parameter, `event`, is passed\nto the function. Returning `false` cancels the operation."
                      },
                      "subtree": {}
                    },
                    "unselect": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "unselect",
                        "excludes": {},
                        "description": "Fires when the point is unselected either programmatically or\nfollowing a click on the point. One parameter, `event`, is passed\nto the function.\n Returning `false` cancels the operation."
                      },
                      "subtree": {}
                    },
                    "update": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "update",
                        "excludes": {},
                        "description": "Fires when the point is updated programmatically through the\n`.update()` method. One parameter, `event`, is passed to the\nfunction. The new point options can be accessed through\n`event.options`. Returning `false` cancels the operation."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "description": "Options for the series data labels, appearing next to each data\npoint.\n\nIn styled mode, the data labels can be styled wtih the\n`.highcharts-data-label-box` and `.highcharts-data-label` class names\n([see example](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/series-datalabels))."
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "center",
                    "description": "The alignment of the data label compared to the point. If `right`,\nthe right side of the label should be touching the point. For\npoints with an extent, like columns, the alignments also dictates\nhow to align it inside the box, as given with the\n[inside](#plotOptions.column.dataLabels.inside) option. Can be one of\n`left`, `center` or `right`."
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "formatter",
                    "excludes": {},
                    "description": "Callback JavaScript function to format the data label. Note that if a\n`format` is defined, the format takes precedence and the formatter is\nignored. Available data are:\n\n<table>\n\n<tbody>\n\n<tr>\n\n<td>`this.percentage`</td>\n\n<td>Stacked series and pies only. The point's percentage of the\ntotal.</td>\n\n</tr>\n\n<tr>\n\n<td>`this.point`</td>\n\n<td>The point object. The point name, if defined, is available\nthrough `this.point.name`.</td>\n\n</tr>\n\n<tr>\n\n<td>`this.series`:</td>\n\n<td>The series object. The series name is available through\n`this.series.name`.</td>\n\n</tr>\n\n<tr>\n\n<td>`this.total`</td>\n\n<td>Stacked series only. The total value at this point's x value.\n</td>\n\n</tr>\n\n<tr>\n\n<td>`this.x`:</td>\n\n<td>The x value.</td>\n\n</tr>\n\n<tr>\n\n<td>`this.y`:</td>\n\n<td>The y value.</td>\n\n</tr>\n\n</tbody>\n\n</table>"
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "cssobject": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "default": "{\"color\": \"contrast\", \"fontSize\": \"11px\", \"fontWeight\": \"bold\", \"textOutline\": \"1px contrast\" }",
                    "description": "Styles for the label. The default `color` setting is `\"contrast\"`,\nwhich is a pseudo color that Highcharts picks up and applies the\nmaximum contrast to the underlying point item, for example the\nbar in a bar chart.\n\nThe `textOutline` is a pseudo property that\napplies an outline of the given width with the given color, which\nby default is the maximum contrast to the text. So a bright text\ncolor will result in a black text outline for maximum readability\non a mixed background. In some cases, especially with grayscale\ntext, the text outline doesn't work well, in which cases it can\nbe disabled by setting it to `\"none\"`. When `useHTML` is true, the\n`textOutline` will not be picked up. In this, case, the same effect\ncan be acheived through the `text-shadow` CSS property."
                  },
                  "subtree": {
                    "fontSize": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "fontSize",
                        "excludes": {},
                        "default": "11px"
                      },
                      "subtree": {}
                    },
                    "fontWeight": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "fontWeight",
                        "excludes": {},
                        "default": "bold"
                      },
                      "subtree": {}
                    },
                    "color": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "contrast"
                      },
                      "subtree": {}
                    },
                    "textOutline": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "textOutline",
                        "excludes": {},
                        "default": "1px contrast"
                      },
                      "subtree": {}
                    }
                  }
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "bottom",
                    "description": "The vertical alignment of a data label. Can be one of `top`, `middle`\nor `bottom`. The default value depends on the data, for instance\nin a column chart, the label is above positive values and below\nnegative values."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": "0",
                    "description": "The x position offset of the label relative to the point."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": "-6",
                    "description": "The y position offset of the label relative to the point."
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": 5,
                    "description": "When either the `borderWidth` or the `backgroundColor` is set,\nthis is the padding within the box."
                  },
                  "subtree": {}
                },
                "allowOverlap": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "allowOverlap",
                    "excludes": {},
                    "default": "false",
                    "description": "Whether to allow data labels to overlap. To make the labels less\nsensitive for overlapping, the [dataLabels.padding](#plotOptions.\nseries.dataLabels.padding) can be set to 0."
                  },
                  "subtree": {}
                },
                "borderRadius": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderRadius",
                    "excludes": {},
                    "default": "0",
                    "description": "The border radius in pixels for the data label."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": "0",
                    "description": "The border width in pixels for the data label."
                  },
                  "subtree": {}
                },
                "className": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "className",
                    "excludes": {},
                    "description": "A class name for the data label. Particularly in styled mode, this\ncan be used to give each series' or point's data label unique\nstyling. In addition to this option, a default color class name is\nadded so that we can give the labels a\n[contrast text shadow](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/data-label-contrast/)."
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "description": "The text color for the data labels. Defaults to `null`. For certain\nseries types, like column or map, the data labels can be drawn inside\nthe points. In this case the data label will be drawn with maximum\ncontrast by default. Additionally, it will be given a `text-outline`\nstyle with the opposite color, to further increase the contrast. This\ncan be overridden by setting the `text-outline` style to `none` in\nthe `dataLabels.style` option."
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": "true",
                    "description": "Whether to hide data labels that are outside the plot area. By\ndefault, the data label is moved inside the plot area according to\nthe [overflow](#plotOptions.series.dataLabels.overflow) option."
                  },
                  "subtree": {}
                },
                "defer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "defer",
                    "excludes": {},
                    "default": "true",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Whether to defer displaying the data labels until the initial series\nanimation has finished."
                  },
                  "subtree": {}
                },
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": "false",
                    "description": "Enable or disable the data labels."
                  },
                  "subtree": {}
                },
                "format": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "format",
                    "excludes": {},
                    "description": "A [format string](http://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting)\nfor the data label. Available variables are the same as for\n`formatter`."
                  },
                  "subtree": {}
                },
                "shape": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "shape",
                    "excludes": {},
                    "default": "square",
                    "description": "The name of a symbol to use for the border around the label. Symbols\nare predefined functions on the Renderer object."
                  },
                  "subtree": {}
                },
                "zIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "zIndex",
                    "excludes": {},
                    "default": "6",
                    "description": "The Z index of the data labels. The default Z index puts it above\nthe series. Use a Z index of 2 to display it behind the series."
                  },
                  "subtree": {}
                },
                "filter": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "filter",
                    "excludes": {},
                    "description": "A declarative filter for which data labels to display. The\ndeclarative filter is designed for use when callback functions are\nnot available, like when the chart options require a pure JSON\nstructure or for use with graphical editors. For programmatic\ncontrol, use the `formatter` instead, and return `false` to disable\na single data label."
                  },
                  "subtree": {
                    "property": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "property",
                        "excludes": {},
                        "description": "The point property to filter by. Point options are passed directly to\nproperties, additionally there are `y` value, `percentage` and others\nlisted under [Point](https://api.highcharts.com/class-reference/Highcharts.Point)\nmembers."
                      },
                      "subtree": {}
                    },
                    "operator": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "operator",
                        "excludes": {},
                        "description": "The operator to compare by. Can be one of `>`, `<`, `>=`, `<=`, `==`,\nand `===`."
                      },
                      "subtree": {}
                    },
                    "value": {
                      "meta": {
                        "types": {
                          "mixed": 1
                        },
                        "name": "value",
                        "excludes": {},
                        "description": "The value to compare against."
                      },
                      "subtree": {}
                    }
                  }
                },
                "backgroundColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "backgroundColor",
                    "excludes": {},
                    "description": "The background color or gradient for the data label."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "default": "undefined",
                    "description": "The border color for the data label. Defaults to `undefined`."
                  },
                  "subtree": {}
                },
                "shadow": {
                  "meta": {
                    "types": {
                      "boolean": 1,
                      "object": 1
                    },
                    "name": "shadow",
                    "excludes": {},
                    "default": "false",
                    "description": "The shadow of the box. Works best with `borderWidth` or\n`backgroundColor`. Since 2.3 the shadow can be an object\nconfiguration containing `color`, `offsetX`, `offsetY`, `opacity` and\n`width`."
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "description": "For points with an extent, like columns or map areas, whether to\nalign the data label inside the box or to the actual value point.\nDefaults to `false` in most cases, `true` in stacked columns."
                  },
                  "subtree": {}
                },
                "overflow": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "overflow",
                    "excludes": {},
                    "default": "justify",
                    "description": "How to handle data labels that flow outside the plot area. The\ndefault is `justify`, which aligns them inside the plot area. For\ncolumns and bars, this means it will be moved inside the bar. To\ndisplay data labels outside the plot area, set `crop` to `false` and\n`overflow` to `\"none\"`."
                  },
                  "subtree": {}
                },
                "rotation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "rotation",
                    "excludes": {},
                    "default": "0",
                    "description": "Text rotation in degrees. Note that due to a more complex structure,\nbackgrounds, borders and padding will be lost on a rotated data\nlabel."
                  },
                  "subtree": {}
                },
                "useHTML": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "useHTML",
                    "excludes": {},
                    "default": "false",
                    "description": "Whether to\n[use HTML](http://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)\nto render the labels."
                  },
                  "subtree": {}
                }
              }
            },
            "cropThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "cropThreshold",
                "excludes": {},
                "default": "300",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When the series contains less points than the crop threshold, all\npoints are drawn, even if the points fall outside the visible plot\narea at the current zoom. The advantage of drawing all points (including\nmarkers and columns), is that animation is performed on updates.\nOn the other hand, when the series contains more points than the\ncrop threshold, the series data is cropped to only contain points\nthat fall within the plot area. The advantage of cropping away invisible\npoints is to increase performance on large series."
              },
              "subtree": {}
            },
            "pointRange": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": "0",
                "products": {
                  "highstock": 1
                },
                "description": "The width of each point on the x axis. For example in a column chart\nwith one value each day, the pointRange would be 1 day (= 24 * 3600\n* 1000 milliseconds). This is normally computed automatically, but\nthis option can be used to override the automatic value."
              },
              "subtree": {}
            },
            "softThreshold": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "softThreshold",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When this is true, the series will not cause the Y axis to cross\nthe zero plane (or [threshold](#plotOptions.series.threshold) option)\nunless the data actually crosses the plane.\n\nFor example, if `softThreshold` is `false`, a series of 0, 1, 2,\n3 will make the Y axis show negative values according to the `minPadding`\noption. If `softThreshold` is `true`, the Y axis starts at 0."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "plotoptions.series.states": 1
                },
                "name": "states",
                "excludes": {},
                "description": "A wrapper object for all the series options in specific states."
              },
              "subtree": {
                "normal": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "normal",
                    "excludes": {},
                    "products": {
                      "highmaps": 1
                    },
                    "description": "Overrides for the normal state."
                  },
                  "subtree": {
                    "animation": {
                      "meta": {
                        "types": {
                          "object": 1,
                          "boolean": 1
                        },
                        "name": "animation",
                        "excludes": {},
                        "default": "true",
                        "products": {
                          "highmaps": 1
                        },
                        "description": "Animation options for the fill color when returning from hover state\nto normal state. The animation adds some latency in order to reduce\nthe effect of flickering when hovering in and out of for example\nan uneven coastline."
                      },
                      "subtree": {}
                    }
                  }
                },
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "description": "Options for the hovered series. These settings override the normal\nstate options when a series is moused over or touched."
                  },
                  "subtree": {
                    "animation": {
                      "meta": {
                        "types": {
                          "boolean": 1,
                          "object": 1
                        },
                        "name": "animation",
                        "excludes": {},
                        "default": "{ \"duration\": 50 }",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "Animation setting for hovering the graph in line-type series."
                      },
                      "subtree": {
                        "duration": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "duration",
                            "excludes": {},
                            "default": 50,
                            "description": "The duration of the hover animation in milliseconds. By\ndefault the hover state animates quickly in, and slowly back\nto normal."
                          },
                          "subtree": {}
                        }
                      }
                    },
                    "lineWidthPlus": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidthPlus",
                        "excludes": {},
                        "default": "1",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "The additional line width for the graph of a hovered series."
                      },
                      "subtree": {}
                    },
                    "marker": {
                      "meta": {
                        "types": {},
                        "name": "marker",
                        "excludes": {},
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "In Highcharts 1.0, the appearance of all markers belonging to the\nhovered series. For settings on the hover state of the individual\npoint, see\n[marker.states.hover](#plotOptions.series.marker.states.hover).",
                        "extends": "plotOptions.series.marker"
                      },
                      "subtree": {}
                    },
                    "halo": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "halo",
                        "excludes": {},
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "Options for the halo appearing around the hovered point in line-\ntype series as well as outside the hovered slice in pie charts.\nBy default the halo is filled by the current point or series\ncolor with an opacity of 0.25\\. The halo can be disabled by\nsetting the `halo` option to `false`.\n\nIn styled mode, the halo is styled with the `.highcharts-halo`\nclass, with colors inherited from `.highcharts-color-{n}`."
                      },
                      "subtree": {
                        "size": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "size",
                            "excludes": {},
                            "default": "10",
                            "products": {
                              "highcharts": 1,
                              "highstock": 1
                            },
                            "description": "The pixel size of the halo. For point markers this is the\nradius of the halo. For pie slices it is the width of the\nhalo outside the slice. For bubbles it defaults to 5 and is\nthe width of the halo outside the bubble."
                          },
                          "subtree": {}
                        },
                        "opacity": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "opacity",
                            "excludes": {},
                            "default": "0.25",
                            "products": {
                              "highcharts": 1,
                              "highstock": 1
                            },
                            "description": "Opacity for the halo unless a specific fill is overridden\nusing the `attributes` setting. Note that Highcharts is only\nable to apply opacity to colors of hex or rgb(a) formats."
                          },
                          "subtree": {}
                        },
                        "attributes": {
                          "meta": {
                            "types": {
                              "object": 1
                            },
                            "name": "attributes",
                            "excludes": {},
                            "products": {
                              "highcharts": 1,
                              "highstock": 1
                            },
                            "description": "A collection of SVG attributes to override the appearance of\nthe halo, for example `fill`, `stroke` and `stroke-width`."
                          },
                          "subtree": {}
                        }
                      }
                    },
                    "enabled": {
                      "meta": {
                        "types": {
                          "boolean": 1
                        },
                        "name": "enabled",
                        "excludes": {},
                        "default": "true",
                        "description": "Enable separate styles for the hovered series to visualize that\nthe user hovers either the series itself or the legend. ."
                      },
                      "subtree": {}
                    },
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": "undefined",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "Pixel width of the graph line. By default this property is\nundefined, and the `lineWidthPlus` property dictates how much\nto increase the linewidth from normal state."
                      },
                      "subtree": {}
                    },
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "products": {
                          "highmaps": 1
                        },
                        "description": "The color of the shape in this state"
                      },
                      "subtree": {}
                    },
                    "borderColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "borderColor",
                        "excludes": {},
                        "products": {
                          "highmaps": 1
                        },
                        "description": "The border color of the point in this state."
                      },
                      "subtree": {}
                    },
                    "borderWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "borderWidth",
                        "excludes": {},
                        "products": {
                          "highmaps": 1
                        },
                        "description": "The border width of the point in this state"
                      },
                      "subtree": {}
                    },
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": "0.2",
                        "products": {
                          "highmaps": 1
                        },
                        "description": "The relative brightness of the point when hovered, relative to the\nnormal point color."
                      },
                      "subtree": {}
                    }
                  }
                },
                "select": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "select",
                    "excludes": {},
                    "products": {
                      "highmaps": 1
                    },
                    "description": "Specific options for point in selected states, after being selected\nby [allowPointSelect](#plotOptions.series.allowPointSelect) or\nprogrammatically.",
                    "extends": "plotOptions.series.states.hover"
                  },
                  "subtree": {
                    "marker": {
                      "meta": {
                        "types": {},
                        "name": "marker",
                        "excludes": {}
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": true,
                "description": "Sticky tracking of mouse events. When true, the `mouseOut` event\non a series isn't triggered until the mouse moves over another series,\nor out of the plot area. When false, the `mouseOut` event on a\nseries is triggered when the mouse leaves the area around the series'\ngraph or markers. This also implies the tooltip when not shared. When\n`stickyTracking` is false and `tooltip.shared` is false, the tooltip will\nbe hidden when moving the mouse between series. Defaults to true for line\nand area type series, but to false for columns, pies etc."
              },
              "subtree": {}
            },
            "turboThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "turboThreshold",
                "excludes": {},
                "default": "1000",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When a series contains a data array that is longer than this, only\none dimensional arrays of numbers, or two dimensional arrays with\nx and y values are allowed. Also, only the first point is tested,\nand the rest are assumed to be the same format. This saves expensive\ndata checking and indexing in long series. Set it to `0` disable."
              },
              "subtree": {}
            },
            "findNearestPointBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "findNearestPointBy",
                "excludes": {},
                "default": "x",
                "description": "Determines whether the series should look for the nearest point\nin both dimensions or just the x-dimension when hovering the series.\nDefaults to `'xy'` for scatter series and `'x'` for most other\nseries. If the data has duplicate x-values, it is recommended to\nset this to `'xy'` to allow hovering over all points.\n\nApplies only to series types using nearest neighbor search (not\ndirect hover) for tooltip."
              },
              "subtree": {}
            },
            "animationLimit": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "animationLimit",
                "excludes": {},
                "description": "For some series, there is a limit that shuts down initial animation\nby default when the total number of points in the chart is too high.\nFor example, for a column chart and its derivatives, animation doesn't\nrun if there is more than 250 points totally. To disable this cap, set\n`animationLimit` to `Infinity`."
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "description": "A class name to apply to the series' graphical elements."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "description": "The main color of the series. In line type series it applies to the\nline and the point markers unless otherwise specified. In bar type\nseries it applies to the bars unless a color is specified per point.\nThe default value is pulled from the `options.colors` array.\n\nIn styled mode, the color can be defined by the\n[colorIndex](#plotOptions.series.colorIndex) option. Also, the series\ncolor can be set with the `.highcharts-series`, `.highcharts-color-{n}`,\n`.highcharts-{type}-series` or `.highcharts-series-{n}` class, or\nindividual classes given by the `className` option."
              },
              "subtree": {}
            },
            "colorIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "colorIndex",
                "excludes": {},
                "description": "Styled mode only. A specific color index to use for the series, so its\ngraphic representations are given the class name `highcharts-color-{n}`."
              },
              "subtree": {}
            },
            "connectNulls": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "connectNulls",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to connect a graph line across null points, or render a gap\nbetween the two points on either side of the null."
              },
              "subtree": {}
            },
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "description": "You can set the cursor to \"pointer\" if you have click events attached\nto the series, to signal to the user that the points and lines can\nbe clicked."
              },
              "subtree": {}
            },
            "dashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "dashStyle",
                "excludes": {},
                "default": "Solid",
                "description": "A name for the dash style to use for the graph, or for some series types\nthe outline of each shape. The value for the `dashStyle` include:\n\n*   Solid\n*   ShortDash\n*   ShortDot\n*   ShortDashDot\n*   ShortDashDotDot\n*   Dot\n*   Dash\n*   LongDash\n*   DashDot\n*   LongDashDot\n*   LongDashDotDot"
              },
              "subtree": {}
            },
            "description": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "description",
                "excludes": {},
                "default": "undefined",
                "description": "Requires the Accessibility module.\n\nA description of the series to add to the screen reader information\nabout the series."
              },
              "subtree": {}
            },
            "enableMouseTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enableMouseTracking",
                "excludes": {},
                "default": "true",
                "description": "Enable or disable the mouse tracking for a specific series. This\nincludes point tooltips and click events on graphs and points. For\nlarge datasets it improves performance."
              },
              "subtree": {}
            },
            "exposeElementToA11y": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "exposeElementToA11y",
                "excludes": {},
                "default": "undefined",
                "description": "By default, series are exposed to screen readers as regions. By enabling\nthis option, the series element itself will be exposed in the same\nway as the data points. This is useful if the series is not used\nas a grouping entity in the chart, but you still want to attach a\ndescription to the series.\n\nRequires the Accessibility module."
              },
              "subtree": {}
            },
            "getExtremesFromAll": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "getExtremesFromAll",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to use the Y extremes of the total chart width or only the\nzoomed area when zooming in on parts of the X axis. By default, the\nY axis adjusts to the min and max of the visible data. Cartesian\nseries only."
              },
              "subtree": {}
            },
            "keys": {
              "meta": {
                "types": {
                  "array": "String"
                },
                "name": "keys",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An array specifying which option maps to which key in the data point\narray. This makes it convenient to work with unstructured data arrays\nfrom different sources."
              },
              "subtree": {}
            },
            "linecap": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linecap",
                "excludes": {},
                "default": "round",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The line cap used for line ends and line joins on the graph."
              },
              "subtree": {}
            },
            "linkedTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linkedTo",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The [id](#series.id) of another series to link to. Additionally,\nthe value can be \":previous\" to link to the previous series. When\ntwo series are linked, only the first one appears in the legend.\nToggling the visibility of this also toggles the linked series."
              },
              "subtree": {}
            },
            "negativeColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "negativeColor",
                "excludes": {},
                "default": "null",
                "description": "The color for the parts of the graph or points that are below the\n[threshold](#plotOptions.series.threshold)."
              },
              "subtree": {}
            },
            "pointDescriptionFormatter": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "pointDescriptionFormatter",
                "excludes": {},
                "description": "Same as [accessibility.pointDescriptionFormatter](#accessibility.\npointDescriptionFormatter), but for an individual series. Overrides\nthe chart wide configuration."
              },
              "subtree": {}
            },
            "pointInterval": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointInterval",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "If no x values are given for the points in a series, `pointInterval`\ndefines the interval of the x values. For example, if a series contains\none value every decade starting from year 0, set `pointInterval` to\n`10`. In true `datetime` axes, the `pointInterval` is set in\nmilliseconds.\n\nIt can be also be combined with `pointIntervalUnit` to draw irregular\ntime intervals.\n\nPlease note that this options applies to the _series data_, not the\ninterval of the axis ticks, which is independent."
              },
              "subtree": {}
            },
            "pointIntervalUnit": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "pointIntervalUnit",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "On datetime series, this allows for setting the\n[pointInterval](#plotOptions.series.pointInterval) to irregular time \nunits, `day`, `month` and `year`. A day is usually the same as 24 hours,\nbut `pointIntervalUnit` also takes the DST crossover into consideration\nwhen dealing with local time. Combine this option with `pointInterval`\nto draw weeks, quarters, 6 months, 10 years etc.\n\nPlease note that this options applies to the _series data_, not the\ninterval of the axis ticks, which is independent."
              },
              "subtree": {}
            },
            "pointPlacement": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1
                },
                "name": "pointPlacement",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Possible values: `null`, `\"on\"`, `\"between\"`.\n\nIn a column chart, when pointPlacement is `\"on\"`, the point will\nnot create any padding of the X axis. In a polar column chart this\nmeans that the first column points directly north. If the pointPlacement\nis `\"between\"`, the columns will be laid out between ticks. This\nis useful for example for visualising an amount between two points\nin time or in a certain sector of a polar chart.\n\nSince Highcharts 3.0.2, the point placement can also be numeric,\nwhere 0 is on the axis value, -0.5 is between this value and the\nprevious, and 0.5 is between this value and the next. Unlike the\ntextual options, numeric point placement options won't affect axis\npadding.\n\nNote that pointPlacement needs a [pointRange](#plotOptions.series.\npointRange) to work. For column series this is computed, but for\nline-type series it needs to be set.\n\nDefaults to `null` in cartesian charts, `\"between\"` in polar charts."
              },
              "subtree": {}
            },
            "pointStart": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointStart",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "If no x values are given for the points in a series, pointStart defines\non what value to start. For example, if a series contains one yearly\nvalue starting from 1945, set pointStart to 1945."
              },
              "subtree": {}
            },
            "selected": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "selected",
                "excludes": {},
                "default": "false",
                "description": "Whether to select the series initially. If `showCheckbox` is true,\nthe checkbox next to the series name in the legend will be checked for a\nselected series."
              },
              "subtree": {}
            },
            "shadow": {
              "meta": {
                "types": {
                  "boolean": 1,
                  "object": 1
                },
                "name": "shadow",
                "excludes": {},
                "default": "false",
                "description": "Whether to apply a drop shadow to the graph line. Since 2.3 the shadow\ncan be an object configuration containing `color`, `offsetX`, `offsetY`,\n `opacity` and `width`."
              },
              "subtree": {}
            },
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": "true",
                "description": "Whether to display this particular series or series type in the legend.\nThe default value is `true` for standalone series, `false` for linked\nseries."
              },
              "subtree": {}
            },
            "skipKeyboardNavigation": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "skipKeyboardNavigation",
                "excludes": {},
                "description": "If set to `True`, the accessibility module will skip past the points\nin this series for keyboard navigation."
              },
              "subtree": {}
            },
            "stacking": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "stacking",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to stack the values of each series on top of each other.\nPossible values are `null` to disable, `\"normal\"` to stack by value or\n`\"percent\"`. When stacking is enabled, data must be sorted in ascending\nX order. A special stacking option is with the streamgraph series type,\nwhere the stacking option is set to `\"stream\"`."
              },
              "subtree": {}
            },
            "step": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "step",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to apply steps to the line. Possible values are `left`, `center`\nand `right`."
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The threshold, also called zero level or base level. For line type\nseries this is only used in conjunction with\n[negativeColor](#plotOptions.series.negativeColor)."
              },
              "subtree": {}
            },
            "visible": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "visible",
                "excludes": {},
                "default": "true",
                "description": "Set the initial visibility of the series."
              },
              "subtree": {}
            },
            "zoneAxis": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "zoneAxis",
                "excludes": {},
                "default": "y",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Defines the Axis on which the zones are applied."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {},
                "description": "A configuration object for the tooltip rendering of each single series.\nProperties are inherited from [tooltip](#tooltip), but only the\nfollowing properties can be defined on a series level.",
                "extends": "tooltip"
              },
              "subtree": {}
            },
            "zones": {
              "meta": {
                "types": {
                  "array": "object"
                },
                "name": "zones",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An array defining zones within a series. Zones can be applied to\nthe X axis, Y axis or Z axis for bubbles, according to the `zoneAxis`\noption.\n\nIn styled mode, the color zones are styled with the\n`.highcharts-zone-{n}` class, or custom classed from the `className`\noption\n([view live demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/css/color-zones/))."
              },
              "subtree": {
                "className": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "className",
                    "excludes": {},
                    "description": "Styled mode only. A custom class name for the zone."
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Defines the color of the series."
                  },
                  "subtree": {}
                },
                "dashStyle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "dashStyle",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "A name for the dash style to use for the graph."
                  },
                  "subtree": {}
                },
                "fillColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "fillColor",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Defines the fill color for the series (in area type series)"
                  },
                  "subtree": {}
                },
                "value": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "value",
                    "excludes": {},
                    "default": "undefined",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "The value up to where the zone extends, if undefined the zones stretches\nto the last value in the series."
                  },
                  "subtree": {}
                }
              }
            },
            "compare": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "compare",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highstock": 1
                },
                "description": "Compare the values of the series against the first non-null, non-\nzero value in the visible range. The y axis will show percentage\nor absolute change depending on whether `compare` is set to `\"percent\"`\nor `\"value\"`. When this is applied to multiple series, it allows\ncomparing the development of the series against each other."
              },
              "subtree": {}
            },
            "compareStart": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "compareStart",
                "excludes": {},
                "default": "false",
                "products": {
                  "highstock": 1
                },
                "description": "Defines if comparisson should start from the first point within the visible\nrange or should start from the first point <b>before</b> the range.\nIn other words, this flag determines if first point within the visible range\nwill have 0% (`compareStart=true`) or should have been already calculated\naccording to the previous point (`compareStart=false`)."
              },
              "subtree": {}
            },
            "compareBase": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "compareBase",
                "excludes": {},
                "default": "0",
                "products": {
                  "highstock": 1
                },
                "description": "When [compare](#plotOptions.series.compare) is `percent`, this option\ndictates whether to use 0 or 100 as the base of comparison."
              },
              "subtree": {}
            },
            "connectEnds": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "connectEnds",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Polar charts only. Whether to connect the ends of a line series\nplot across the extremes."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "Define the z index of the series."
              },
              "subtree": {}
            },
            "allAreas": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allAreas",
                "excludes": {},
                "default": "true",
                "products": {
                  "highmaps": 1
                },
                "description": "Whether all areas of the map defined in `mapData` should be rendered.\nIf `true`, areas which don't correspond to a data point, are rendered\nas `null` points. If `false`, those areas are skipped."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#cccccc",
                "products": {
                  "highmaps": 1
                },
                "description": "The border color of the map areas.\n\nIn styled mode, the border stroke is given in the `.highcharts-point` class."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {},
                "name": "borderWidth",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "The border width of each map area.\n\nIn styled mode, the border stroke width is given in the\n`.highcharts-point` class."
              },
              "subtree": {}
            },
            "colorAxis": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorAxis",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highmaps": 1
                },
                "description": "Set this option to `false` to prevent a series from connecting to\nthe global color axis. This will cause the series to have its own\nlegend item."
              },
              "subtree": {}
            },
            "joinBy": {
              "meta": {
                "types": {
                  "string": 1,
                  "array": "String"
                },
                "name": "joinBy",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "What property to join the `mapData` to the value data. For example,\nif joinBy is \"code\", the mapData items with a specific code is merged\ninto the data with the same code. For maps loaded from GeoJSON, the\nkeys may be held in each point's `properties` object.\n\nThe joinBy option can also be an array of two values, where the first\npoints to a key in the `mapData`, and the second points to another\nkey in the `data`.\n\nWhen joinBy is `null`, the map items are joined by their position\nin the array, which performs much better in maps with many data points.\nThis is the recommended option if you are printing more than a thousand\ndata points and have a backend that can preprocess the data into\na parallel array of the mapData."
              },
              "subtree": {}
            }
          }
        },
        "bullet": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "bullet",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A bullet graph is a variation of a bar graph. The bullet graph features\na single measure, compares it to a target, and displays it in the context\nof qualitative ranges of performance that could be set using\n[plotBands](#yAxis.plotBands) on [yAxis](#yAxis).",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "targetOptions": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "targetOptions",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "All options related with look and positiong of targets."
              },
              "subtree": {
                "width": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "width",
                    "excludes": {},
                    "default": "140%",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The width of the rectangle representing the target. Could be set\nas a pixel value or as a percentage of a column width."
                  },
                  "subtree": {}
                },
                "height": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "height",
                    "excludes": {},
                    "default": 3,
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The height of the rectangle representing the target."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": 0,
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The border width of the rectangle representing the target.\n\nIn styled mode, use class `highcharts-bullet-target` instead."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The border color of the rectangle representing the target. When\nnot set, the  point's border color is used.\n\nIn styled mode, use class `highcharts-bullet-target` instead."
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The color of the rectangle representing the target. When not set,\npoint's color (if set in point's options -\n[`color`](#series.bullet.data.color)) or zone of the target value\n(if [`zones`](#plotOptions.bullet.zones) or\n[`negativeColor`](#plotOptions.bullet.negativeColor) are set)\nor the same color as the point has is used.\n\nIn styled mode, use class `highcharts-bullet-target` instead."
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "funnel": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "funnel",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Funnel charts are a type of chart often used to visualize stages in a sales \nproject, where the top are the initial stages with the most clients. \nIt requires that the modules/funnel.js file is loaded.",
            "extends": "{plotOptions.pie}"
          },
          "subtree": {
            "animation": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "animation",
                "excludes": {},
                "default": false,
                "description": "Initial animation is by default disabled for the funnel chart."
              },
              "subtree": {}
            },
            "center": {
              "meta": {
                "types": {
                  "array": "(String|Number)"
                },
                "name": "center",
                "excludes": {},
                "default": "[\"50%\", \"50%\"]",
                "products": {
                  "highcharts": 1
                },
                "description": "The center of the series. By default, it is centered in the middle\nof the plot area, so it fills the plot area height."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "width",
                "excludes": {},
                "default": "90%",
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the funnel compared to the width of the plot area,\nor the pixel width if it is a number."
              },
              "subtree": {}
            },
            "neckWidth": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "neckWidth",
                "excludes": {},
                "default": "30%",
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the neck, the lower part of the funnel. A number defines\npixel width, a percentage string defines a percentage of the plot\narea width."
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "height",
                "excludes": {},
                "default": "100%",
                "products": {
                  "highcharts": 1
                },
                "description": "The height of the funnel or pyramid. If it is a number it defines\nthe pixel height, if it is a percentage string it is the percentage\nof the plot area height."
              },
              "subtree": {}
            },
            "neckHeight": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "neckHeight",
                "excludes": {},
                "default": "25%",
                "products": {
                  "highcharts": 1
                },
                "description": "The height of the neck, the lower part of the funnel. A number defines\npixel width, a percentage string defines a percentage of the plot\narea height."
              },
              "subtree": {}
            },
            "reversed": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "reversed",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "A reversed funnel has the widest area down. A reversed funnel with\nno neck width and neck height is a pyramid."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "connectorWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "connectorWidth",
                    "excludes": {},
                    "default": 1
                  },
                  "subtree": {}
                }
              }
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Options for the series states."
              },
              "subtree": {
                "select": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "select",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Options for a selected funnel item."
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#cccccc",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "A specific color for the selected point."
                      },
                      "subtree": {}
                    },
                    "borderColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "borderColor",
                        "excludes": {},
                        "default": "#000000",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "A specific border color for the selected point."
                      },
                      "subtree": {}
                    }
                  }
                },
                "hover": {
                  "meta": {
                    "types": {},
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "pyramid": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "pyramid",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A pyramid series is a special type of funnel, without neck and reversed by\ndefault.",
            "extends": "plotOptions.funnel"
          },
          "subtree": {
            "neckWidth": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "neckWidth",
                "excludes": {},
                "default": "0%",
                "products": {
                  "highcharts": 1
                },
                "description": "The pyramid neck width is zero by default, as opposed to the funnel, \nwhich shares the same layout logic."
              },
              "subtree": {}
            },
            "neckHeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "neckHeight",
                "excludes": {},
                "default": "0%",
                "products": {
                  "highcharts": 1
                },
                "description": "The pyramid neck width is zero by default, as opposed to the funnel, \nwhich shares the same layout logic."
              },
              "subtree": {}
            },
            "reversed": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "reversed",
                "excludes": {},
                "default": true,
                "products": {
                  "highcharts": 1
                },
                "description": "The pyramid is reversed by default, as opposed to the funnel, which\nshares the layout engine, and is not reversed."
              },
              "subtree": {}
            }
          }
        },
        "histogram": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "histogram",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A histogram is a column series which represents the distribution of the data\nset in the base series. Histogram splits data into bins and shows their\nfrequencies.",
            "extends": "plotOptions.column"
          },
          "subtree": {
            "binsNumber": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1,
                  "function": 1
                },
                "name": "binsNumber",
                "excludes": {},
                "default": "square-root",
                "description": "A preferable number of bins. It is a suggestion, so a histogram may have\na different number of bins. By default it is set to the square root\nof the base series' data length. Available options are: `square-root`,\n`sturges`, `rice`. You can also define a function which takes a\n`baseSeries` as a parameter and should return a positive integer."
              },
              "subtree": {}
            },
            "binWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "binWidth",
                "excludes": {},
                "description": "Width of each bin. By default the bin's width is calculated as\n`(max - min) / number of bins`. This option takes precedence over\n[binsNumber](#plotOptions.histogram.binsNumber)."
              },
              "subtree": {}
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "groupPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "groupPadding",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "grouping": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "grouping",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "pointPlacement": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "pointPlacement",
                "excludes": {},
                "default": "between"
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "headerFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "headerFormat",
                    "excludes": {},
                    "default": ""
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "pareto": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "pareto",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A pareto diagram is a type of chart that contains both bars and a line graph,\nwhere individual values are represented in descending order by bars, \nand the cumulative total is represented by the line.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": 3,
                "description": "Higher zIndex than column series to draw line above shapes."
              },
              "subtree": {}
            }
          }
        },
        "sankey": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "sankey",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A sankey diagram is a type of flow diagram, in which the width of the \nlink between two nodes is shown proportionally to the flow quantity.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "curveFactor": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "curveFactor",
                "excludes": {},
                "default": 0.33,
                "description": "Higher numbers makes the links in a sankey diagram render more curved.\nA `curveFactor` of 0 makes the lines straight."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "description": "Options for the data labels appearing on top of the nodes and links. For\nsankey charts, data labels are visible for the nodes by default, but \nhidden for links. This is controlled by modifying the `nodeFormat`, and\nthe `format` that applies to links and is an empty string by default."
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "backgroundColor": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "backgroundColor",
                    "excludes": {},
                    "default": "none"
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "nodeFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "nodeFormat",
                    "excludes": {},
                    "description": "The [format string](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting) specifying what to show for _nodes_ in the \nsankey diagram. By default the `nodeFormatter` returns\n`{point.name}`."
                  },
                  "subtree": {}
                },
                "nodeFormatter": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "nodeFormatter",
                    "excludes": {},
                    "description": "Callback to format data labels for _nodes_ in the sankey diagram. \nThe `nodeFormat` option takes precedence over the `nodeFormatter`."
                  },
                  "subtree": {}
                },
                "format": {
                  "meta": {
                    "types": {},
                    "name": "format",
                    "excludes": {},
                    "description": "The [format string](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting) specifying what to show for _links_ in the \nsankey diagram. Defaults to an empty string returned from the \n`formatter`, in effect disabling the labels."
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {},
                    "description": "Callback to format data labels for _links_ in the sankey diagram. \nThe `format` option takes precedence over the `formatter`."
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "linkOpacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "linkOpacity",
                "excludes": {},
                "default": 0.5,
                "description": "Opacity for the links between nodes in the sankey diagram."
              },
              "subtree": {}
            },
            "nodeWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "nodeWidth",
                "excludes": {},
                "default": 20,
                "description": "The pixel width of each node in a sankey diagram, or the height in case\nthe chart is inverted."
              },
              "subtree": {}
            },
            "nodePadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "nodePadding",
                "excludes": {},
                "default": 10,
                "description": "The padding between nodes in a sankey diagram, in pixels."
              },
              "subtree": {}
            },
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "linkOpacity": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "linkOpacity",
                        "excludes": {},
                        "default": 1,
                        "description": "Opacity for the links between nodes in the sankey diagram in\nhover mode."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "followPointer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "followPointer",
                    "excludes": {},
                    "default": true,
                    "description": "Whether the tooltip should follow the pointer or stay fixed on the\nitem."
                  },
                  "subtree": {}
                },
                "headerFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "headerFormat",
                    "excludes": {},
                    "default": "<span class=\"highcharts-header\">{series.name}</span><br/>"
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "{point.fromNode.name} → {point.toNode.name}: <b>{point.weight}</b><br/>"
                  },
                  "subtree": {}
                },
                "nodeFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "nodeFormat",
                    "excludes": {},
                    "default": "{point.name}: <b>{point.sum}</b><br/>",
                    "description": "The [format string](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting) specifying what to show for _nodes_ in tooltip\nof a sankey diagram series, as opposed to links."
                  },
                  "subtree": {}
                },
                "nodeFormatter": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "nodeFormatter",
                    "excludes": {},
                    "description": "A callback for defining the format for _nodes_ in the sankey chart's\ntooltip, as opposed to links."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "solidgauge": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "solidgauge",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A solid gauge is a circular gauge where the value is indicated by a filled\narc, and the color of the arc may variate with the value.",
            "extends": "plotOptions.gauge"
          },
          "subtree": {
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": true,
                "description": "Whether to give each point an individual color."
              },
              "subtree": {}
            },
            "linecap": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linecap",
                "excludes": {},
                "default": "round",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether the strokes of the solid gauge should be `round` or `square`."
              },
              "subtree": {}
            },
            "overshoot": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "overshoot",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "Allow the gauge to overshoot the end of the perimeter axis by this\nmany degrees. Say if the gauge axis goes from 0 to 60, a value of\n100, or 1000, will show 5 degrees beyond the end of the axis when this\noption is set to 5."
              },
              "subtree": {}
            },
            "rounded": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "rounded",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "Wether to draw rounded edges on the gauge."
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The threshold or base level for the gauge."
              },
              "subtree": {}
            }
          }
        },
        "streamgraph": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "streamgraph",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A streamgraph is a type of stacked area graph which is displaced around a\ncentral axis, resulting in a flowing, organic shape.",
            "extends": "{plotOptions.areaspline}"
          },
          "subtree": {
            "fillOpacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "fillOpacity",
                "excludes": {},
                "default": 1
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "stacking": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "stacking",
                "excludes": {},
                "default": "stream"
              },
              "subtree": {}
            }
          }
        },
        "sunburst": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "sunburst",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A Sunburst displays hierarchical data, where a level in the hierarchy is represented by a circle.\nThe center represents the root node of the tree.\nThe visualization bears a resemblance to both treemap and pie charts.",
            "extends": "{plotOptions.pie}"
          },
          "subtree": {
            "center": {
              "meta": {
                "types": {
                  "array": "(String|Number)"
                },
                "name": "center",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The center of the sunburst chart relative to the plot area. Can be\npercentages or pixel values."
              },
              "subtree": {}
            },
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "extends": "plotOptions.series.dataLabels"
              },
              "subtree": {
                "defer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "defer",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {}
                  },
                  "subtree": {
                    "textOverflow": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "textOverflow",
                        "excludes": {},
                        "default": "ellipsis"
                      },
                      "subtree": {}
                    }
                  }
                },
                "rotationMode": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "rotationMode",
                    "excludes": {},
                    "default": "perpendicular",
                    "description": "Decides how the data label will be rotated according to the perimeter\nof the sunburst. It can either be parallel or perpendicular to the\nperimeter.\n`series.rotation` takes precedence over `rotationMode`."
                  },
                  "subtree": {}
                }
              }
            },
            "rootId": {
              "meta": {
                "types": {
                  "string": 1,
                  "undefined": 1
                },
                "name": "rootId",
                "excludes": {},
                "default": "undefined",
                "description": "Which point to use as a root in the visualization."
              },
              "subtree": {}
            },
            "levelIsConstant": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "levelIsConstant",
                "excludes": {},
                "default": true,
                "description": "Used together with the levels and `allowDrillToNode` options. When\nset to false the first level visible when drilling is considered\nto be level one. Otherwise the level will be the same as the tree\nstructure."
              },
              "subtree": {}
            },
            "levelSize": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "levelSize",
                "excludes": {},
                "description": "Determines the width of the ring per level."
              },
              "subtree": {
                "value": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "value",
                    "excludes": {},
                    "default": 1,
                    "description": "The value used for calculating the width of the ring. Its' affect is\ndetermined by `levelSize.unit`."
                  },
                  "subtree": {}
                },
                "unit": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "unit",
                    "excludes": {},
                    "default": "weight",
                    "description": "How to interpret `levelSize.value`.\n`percentage` gives a width relative to result of outer radius minus\ninner radius.\n`pixels` gives the ring a fixed width in pixels.\n`weight` takes the remaining width after percentage and pixels, and\ndistributes it accross all \"weighted\" levels. The value relative to the\nsum of all weights determines the width."
                  },
                  "subtree": {}
                }
              }
            },
            "slicedOffset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "slicedOffset",
                "excludes": {},
                "default": 10,
                "description": "If a point is sliced, moved out from the center, how many pixels\nshould it be moved?."
              },
              "subtree": {}
            },
            "levels": {
              "meta": {
                "types": {
                  "array": "Object"
                },
                "name": "levels",
                "excludes": {},
                "description": "Set options on specific levels. Takes precedence over series options,\nbut not point options."
              },
              "subtree": {
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "description": "Can set a `borderColor` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "description": "Can set a `borderWidth` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "borderDashStyle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "borderDashStyle",
                    "excludes": {},
                    "description": "Can set a `borderDashStyle` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "description": "Can set a `color` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "colorVariation": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "colorVariation",
                    "excludes": {},
                    "description": "Can set a `colorVariation` on all points which lies on the same level."
                  },
                  "subtree": {
                    "key": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "key",
                        "excludes": {},
                        "description": "The key of a color variation. Currently supports `brightness` only."
                      },
                      "subtree": {}
                    },
                    "to": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "to",
                        "excludes": {},
                        "description": "The ending value of a color variation. The last sibling will receive this\nvalue."
                      },
                      "subtree": {}
                    }
                  }
                },
                "levelSize": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "levelSize",
                    "excludes": {},
                    "description": "Can set a `levelSize` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "rotation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "rotation",
                    "excludes": {},
                    "description": "Can set a `rotation` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "rotationMode": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "rotationMode",
                    "excludes": {},
                    "description": "Can set a `rotationMode` on all points which lies on the same level."
                  },
                  "subtree": {}
                }
              }
            },
            "allowDrillToNode": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowDrillToNode",
                "excludes": {},
                "default": "false",
                "description": "When enabled the user can click on a point which is a parent and\nzoom in on its children."
              },
              "subtree": {}
            }
          }
        },
        "tilemap": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "tilemap",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "A tilemap series is a type of heatmap where the tile shapes are configurable.",
            "extends": "{plotOptions.heatmap}"
          },
          "subtree": {
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "halo": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "halo",
                        "excludes": {}
                      },
                      "subtree": {
                        "enabled": {
                          "meta": {
                            "types": {
                              "boolean": 1
                            },
                            "name": "enabled",
                            "excludes": {},
                            "default": true
                          },
                          "subtree": {}
                        },
                        "size": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "size",
                            "excludes": {},
                            "default": 2
                          },
                          "subtree": {}
                        },
                        "opacity": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "opacity",
                            "excludes": {},
                            "default": 0.5
                          },
                          "subtree": {}
                        },
                        "attributes": {
                          "meta": {
                            "types": {
                              "object": 1
                            },
                            "name": "attributes",
                            "excludes": {}
                          },
                          "subtree": {
                            "zIndex": {
                              "meta": {
                                "types": {
                                  "number": 1
                                },
                                "name": "zIndex",
                                "excludes": {},
                                "default": 3
                              },
                              "subtree": {}
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 2,
                "description": "The padding between points in the tilemap."
              },
              "subtree": {}
            },
            "tileShape": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "tileShape",
                "excludes": {},
                "default": "hexagon",
                "description": "The shape of the tiles in the tilemap. Possible values are `hexagon`,\n`circle`, `diamond`, and `square`."
              },
              "subtree": {}
            },
            "colsize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "colsize",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The column size - how many X axis units each column in the tilemap\nshould span. Works as in [Heatmaps](#plotOptions.heatmap.colsize)."
              },
              "subtree": {}
            },
            "rowsize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rowsize",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The row size - how many Y axis units each tilemap row should span.\nAnalogous to [colsize](#plotOptions.tilemap.colsize)."
              },
              "subtree": {}
            }
          }
        },
        "treemap": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "treemap",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A treemap displays hierarchical data using nested rectangles. The data can be\nlaid out in varying ways depending on options.",
            "extends": "{plotOptions.scatter}"
          },
          "subtree": {
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to display this series type or specific series item in the\nlegend."
              },
              "subtree": {}
            },
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": "false",
                "description": "When using automatic point colors pulled from the `options.colors`\ncollection, this option determines whether the chart should receive\none color per series or one color per point."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "extends": "plotOptions.heatmap.dataLabels"
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "defer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "defer",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "middle"
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "headerFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "headerFormat",
                    "excludes": {},
                    "default": ""
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<b>{point.name}</b>: {point.value}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "ignoreHiddenPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "ignoreHiddenPoint",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to ignore hidden points when the layout algorithm runs.\nIf `false`, hidden points will leave open spaces."
              },
              "subtree": {}
            },
            "layoutAlgorithm": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "layoutAlgorithm",
                "excludes": {},
                "default": "sliceAndDice",
                "products": {
                  "highcharts": 1
                },
                "description": "This option decides which algorithm is used for setting position\nand dimensions of the points. Can be one of `sliceAndDice`, `stripes`,\n `squarified` or `strip`."
              },
              "subtree": {}
            },
            "layoutStartingDirection": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "layoutStartingDirection",
                "excludes": {},
                "default": "vertical",
                "products": {
                  "highcharts": 1
                },
                "description": "Defines which direction the layout algorithm will start drawing.\n Possible values are \"vertical\" and \"horizontal\"."
              },
              "subtree": {}
            },
            "alternateStartingDirection": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "alternateStartingDirection",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "Enabling this option will make the treemap alternate the drawing\ndirection between vertical and horizontal. The next levels starting\ndirection will always be the opposite of the previous."
              },
              "subtree": {}
            },
            "levelIsConstant": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "levelIsConstant",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1
                },
                "description": "Used together with the levels and allowDrillToNode options. When\nset to false the first level visible when drilling is considered\nto be level one. Otherwise the level will be the same as the tree\nstructure."
              },
              "subtree": {}
            },
            "drillUpButton": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "drillUpButton",
                "excludes": {},
                "description": "Options for the button appearing when drilling down in a treemap."
              },
              "subtree": {
                "position": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "position",
                    "excludes": {},
                    "description": "The position of the button."
                  },
                  "subtree": {
                    "align": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "align",
                        "excludes": {},
                        "default": "right",
                        "description": "Horizontal alignment of the button."
                      },
                      "subtree": {}
                    },
                    "x": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "x",
                        "excludes": {},
                        "default": "-10",
                        "description": "Horizontal offset of the button."
                      },
                      "subtree": {}
                    },
                    "y": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "y",
                        "excludes": {},
                        "default": 10,
                        "description": "Vertical offset of the button."
                      },
                      "subtree": {}
                    },
                    "verticalAlign": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "verticalAlign",
                        "excludes": {},
                        "default": "top",
                        "description": "Vertical alignment of the button."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#e6e6e6",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the border surrounding each tree map item."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": 1,
                "description": "The width of the border surrounding each tree map item."
              },
              "subtree": {}
            },
            "opacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "opacity",
                "excludes": {},
                "default": "0.15",
                "products": {
                  "highcharts": 1
                },
                "description": "The opacity of a point in treemap. When a point has children, the\nvisibility of the children is determined by the opacity."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "A wrapper object for all the series options in specific states.",
                "extends": "plotOptions.heatmap.states"
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Options for the hovered series",
                    "extends": "plotOptions.heatmap.states.hover"
                  },
                  "subtree": {
                    "borderColor": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "borderColor",
                        "excludes": {},
                        "default": "#999999",
                        "description": "The border color for the hovered state."
                      },
                      "subtree": {}
                    },
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": "null",
                        "description": "Brightness for the hovered point. Defaults to 0 if the heatmap\nseries is loaded, otherwise 0.1."
                      },
                      "subtree": {}
                    },
                    "halo": {
                      "meta": {
                        "types": {
                          "boolean": 1
                        },
                        "name": "halo",
                        "excludes": {},
                        "default": false,
                        "extends": "plotOptions.heatmap.states.hover.halo"
                      },
                      "subtree": {}
                    },
                    "opacity": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "opacity",
                        "excludes": {},
                        "default": "0.75",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The opacity of a point in treemap. When a point has children,\nthe visibility of the children is determined by the opacity."
                      },
                      "subtree": {}
                    },
                    "shadow": {
                      "meta": {
                        "types": {
                          "boolean": 1
                        },
                        "name": "shadow",
                        "excludes": {},
                        "default": false,
                        "description": "The shadow option for hovered state."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "allowDrillToNode": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowDrillToNode",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "When enabled the user can click on a point which is a parent and\nzoom in on its children."
              },
              "subtree": {}
            },
            "cropThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "cropThreshold",
                "excludes": {},
                "default": "300",
                "products": {
                  "highcharts": 1
                },
                "description": "When the series contains less points than the crop threshold, all\npoints are drawn, event if the points fall outside the visible plot\narea at the current zoom. The advantage of drawing all points (including\nmarkers and columns), is that animation is performed on updates.\nOn the other hand, when the series contains more points than the\ncrop threshold, the series data is cropped to only contain points\nthat fall within the plot area. The advantage of cropping away invisible\npoints is to increase performance on large series."
              },
              "subtree": {}
            },
            "interactByLeaf": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "interactByLeaf",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "This option decides if the user can interact with the parent nodes\nor just the leaf nodes. When this option is undefined, it will be\ntrue by default. However when allowDrillToNode is true, then it will\nbe false by default."
              },
              "subtree": {}
            },
            "sortIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "sortIndex",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The sort index of the point inside the treemap level."
              },
              "subtree": {}
            },
            "colors": {
              "meta": {
                "types": {
                  "array": "Color"
                },
                "name": "colors",
                "excludes": {},
                "description": "A series specific or series type specific color set to apply instead\nof the global [colors](#colors) when [colorByPoint](#plotOptions.\ntreemap.colorByPoint) is true."
              },
              "subtree": {}
            },
            "levels": {
              "meta": {
                "types": {
                  "array": "Object"
                },
                "name": "levels",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Set options on specific levels. Takes precedence over series options,\nbut not point options."
              },
              "subtree": {
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Can set a `borderColor` on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "borderDashStyle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "borderDashStyle",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Set the dash style of the border of all the point which lies on the\nlevel. See <a href\"#plotoptions.scatter.dashstyle\">\nplotOptions.scatter.dashStyle</a> for possible options."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Can set the borderWidth on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Can set a color on all points which lies on the same level."
                  },
                  "subtree": {}
                },
                "colorVariation": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "colorVariation",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "A configuration object to define how the color of a child varies from the\nparent's color. The variation is distributed among the children of node.\nFor example when setting brightness, the brightness change will range\nfrom the parent's original brightness on the first child, to the amount\nset in the `to` setting on the last node. This allows a gradient-like\ncolor scheme that sets children out from each other while highlighting\nthe grouping on treemaps and sectors on sunburst charts."
                  },
                  "subtree": {
                    "key": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "key",
                        "excludes": {},
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The key of a color variation. Currently supports `brightness` only."
                      },
                      "subtree": {}
                    },
                    "to": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "to",
                        "excludes": {},
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The ending value of a color variation. The last sibling will receive this\nvalue."
                      },
                      "subtree": {}
                    }
                  }
                },
                "layoutAlgorithm": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "layoutAlgorithm",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Can set the layoutAlgorithm option on a specific level."
                  },
                  "subtree": {}
                },
                "layoutStartingDirection": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "layoutStartingDirection",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Can set the layoutStartingDirection option on a specific level."
                  },
                  "subtree": {}
                },
                "level": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "level",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Decides which level takes effect from the options set in the levels\nobject."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "variablepie": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "variablepie",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A variable pie series is a two dimensional series type, where each point\nrenders an Y and Z value.  Each point is drawn as a pie slice where the\nsize (arc) of the slice relates to the Y value and the radius of pie\nslice relates to the Z value. Requires `highcharts-more.js`.",
            "extends": "{plotOptions.pie}"
          },
          "subtree": {
            "minPointSize": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1
                },
                "name": "minPointSize",
                "excludes": {},
                "default": "10%",
                "products": {
                  "highcharts": 1
                },
                "description": "The minimum size of the points' radius related to chart's `plotArea`.\nIf a number is set, it applies in pixels."
              },
              "subtree": {}
            },
            "maxPointSize": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1
                },
                "name": "maxPointSize",
                "excludes": {},
                "default": "100%",
                "products": {
                  "highcharts": 1
                },
                "description": "The maximum size of the points' radius related to chart's `plotArea`.\nIf a number is set, it applies in pixels."
              },
              "subtree": {}
            },
            "zMin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMin",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The minimum possible z value for the point's radius calculation. \nIf the point's Z value is smaller than zMin, the slice will be drawn\naccording to the zMin value."
              },
              "subtree": {}
            },
            "zMax": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMax",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The maximum possible z value for the point's radius calculation. If\nthe point's Z value is bigger than zMax, the slice will be drawn\naccording to the zMax value"
              },
              "subtree": {}
            },
            "sizeBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "sizeBy",
                "excludes": {},
                "default": "area",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether the pie slice's value should be represented by the area \nor the radius of the slice. Can be either `area` or `radius`. The\ndefault, `area`, corresponds best to the human perception of the size\nof each pie slice."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span> {series.name}<br/>Value: {point.y}<br/>Size: {point.z}<br/>"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "variwide": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "variwide",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A variwide chart (related to marimekko chart) is a column chart with a\nvariable width expressing a third dimension.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 0,
                "description": "In a variwide chart, the point padding is 0 in order to express the \nhorizontal stacking of items."
              },
              "subtree": {}
            },
            "groupPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "groupPadding",
                "excludes": {},
                "default": 0,
                "description": "In a variwide chart, the group padding is 0 in order to express the \nhorizontal stacking of items."
              },
              "subtree": {}
            }
          }
        },
        "vector": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "vector",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A vector plot is a type of cartesian chart where each point has an X and Y\nposition, a length and a direction. Vectors are drawn as arrows.",
            "extends": "{plotOptions.scatter}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 2,
                "description": "The line width for each vector arrow."
              },
              "subtree": {}
            },
            "rotationOrigin": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "rotationOrigin",
                "excludes": {},
                "default": "center",
                "description": "What part of the vector it should be rotated around. Can be one of\n`start`, `center` and `end`. When `start`, the vectors will start from\nthe given [x, y] position, and when `end` the vectors will end in the\n[x, y] position."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidthPlus": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidthPlus",
                        "excludes": {},
                        "default": 1,
                        "description": "Additonal line width for the vector errors when they are hovered."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<b>[{point.x}, {point.y}]</b><br/>Length: <b>{point.length}</b><br/>Direction: <b>{point.direction}°</b><br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "vectorLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "vectorLength",
                "excludes": {},
                "default": 20,
                "description": "Maximum length of the arrows in the vector plot. The individual arrow\nlength is computed between 0 and this value."
              },
              "subtree": {}
            }
          }
        },
        "windbarb": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "windbarb",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Wind barbs are a convenient way to represent wind speed and direction in one\ngraphical form. Wind direction is given by the stem direction, and wind speed\nby the number and shape of barbs.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 2,
                "description": "The line width of the wind barb symbols."
              },
              "subtree": {}
            },
            "onSeries": {
              "meta": {
                "types": {
                  "string": 1,
                  "null": 1
                },
                "name": "onSeries",
                "excludes": {},
                "default": null,
                "description": "The id of another series in the chart that the wind barbs are projected\non. When `null`, the wind symbols are drawn on the X axis, but offset\nup or down by the `yOffset` setting."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidthPlus": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidthPlus",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span> {series.name}: <b>{point.value}</b> ({point.beaufort})<br/>",
                    "description": "The default point format for the wind barb tooltip. Note the \n`point.beaufort` property that refers to the Beaufort wind scale. The\nnames can be internationalized by modifying\n`Highcharts.seriesTypes.windbarb.prototype.beaufortNames`."
                  },
                  "subtree": {}
                }
              }
            },
            "vectorLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "vectorLength",
                "excludes": {},
                "default": 20,
                "description": "Pixel length of the stems."
              },
              "subtree": {}
            },
            "yOffset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "yOffset",
                "excludes": {},
                "default": -20,
                "description": "Vertical offset from the cartesian position, in pixels. The default value\nmakes sure the symbols don't overlap the X axis when `onSeries` is\n`null`, and that they don't overlap the linked series when `onSeries` is\ngiven."
              },
              "subtree": {}
            }
          }
        },
        "wordcloud": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "wordcloud",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A word cloud is a visualization of a set of words, where the size and\nplacement of a word is determined by how it is weighted.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "animation": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "animation",
                "excludes": {}
              },
              "subtree": {
                "duration": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "duration",
                    "excludes": {},
                    "default": 500
                  },
                  "subtree": {}
                }
              }
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "clip": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "clip",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": true,
                "description": "When using automatic point colors pulled from the `options.colors`\ncollection, this option determines whether the chart should receive\none color per series or one color per point."
              },
              "subtree": {}
            },
            "placementStrategy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "placementStrategy",
                "excludes": {},
                "default": "center",
                "description": "This option decides which algorithm is used for placement, and rotation\nof a word. The choice of algorith is therefore a crucial part of the\nresulting layout of the wordcloud.\nIt is possible for users to add their own custom placement strategies\nfor use in word cloud. Read more about it in our\n[documentation](https://www.highcharts.com/docs/chart-and-series-types/word-cloud-series#custom-placement-strategies)"
              },
              "subtree": {}
            },
            "rotation": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "rotation",
                "excludes": {},
                "description": "Rotation options for the words in the wordcloud."
              },
              "subtree": {
                "from": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "from",
                    "excludes": {},
                    "default": 0,
                    "description": "The smallest degree of rotation for a word."
                  },
                  "subtree": {}
                },
                "orientations": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "orientations",
                    "excludes": {},
                    "default": 2,
                    "description": "The number of possible orientations for a word, within the range of\n`rotation.from` and `rotation.to`."
                  },
                  "subtree": {}
                },
                "to": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "to",
                    "excludes": {},
                    "default": 90,
                    "description": "The largest degree of rotation for a word."
                  },
                  "subtree": {}
                }
              }
            },
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "spiral": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "spiral",
                "excludes": {},
                "default": "rectangular",
                "description": "Spiral used for placing a word after the inital position experienced a\ncollision with either another word or the borders.\nIt is possible for users to add their own custom spiralling algorithms\nfor use in word cloud. Read more about it in our\n[documentation](https://www.highcharts.com/docs/chart-and-series-types/word-cloud-series#custom-spiralling-algorithm)"
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "default": "{\"fontFamily\":\"sans-serif\", \"fontWeight\": \"900\"}",
                "description": "CSS styles for the words."
              },
              "subtree": {
                "fontFamily": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontFamily",
                    "excludes": {},
                    "default": "sans-serif"
                  },
                  "subtree": {}
                },
                "fontWeight": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "900"
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "followPointer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "followPointer",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span> {series.name}: <b>{point.weight}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "xrange": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "xrange",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The X-range series displays ranges on the X axis, typically time intervals\nwith a start and end date.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": true,
                "description": "In an X-range series, this option makes all points of the same Y-axis\ncategory the same color."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "middle"
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {},
                    "description": "The default formatter for X-range data labels displays the percentage\nof the partial fill amount."
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "headerFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "headerFormat",
                    "excludes": {},
                    "default": "<span style=\"font-size: 0.85em\">{point.x} - {point.x2}</span><br/>"
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span> {series.name}: <b>{point.yCategory}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "borderRadius": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderRadius",
                "excludes": {},
                "default": 3
              },
              "subtree": {}
            },
            "pointRange": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "partialFill": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "partialFill",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A partial fill for each point, typically used to visualize how much of\na task is performed. The partial fill object can be set either on series\nor point level."
              },
              "subtree": {
                "fill": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "fill",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "The fill color to be used for partial fills. Defaults to a darker shade\nof the point color."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "area": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "area",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The area series type.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "softThreshold": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "softThreshold",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When this is true, the series will not cause the Y axis to cross\nthe zero plane (or [threshold](#plotOptions.series.threshold) option)\nunless the data actually crosses the plane.\n\nFor example, if `softThreshold` is `false`, a series of 0, 1, 2,\n3 will make the Y axis show negative values according to the `minPadding`\noption. If `softThreshold` is `true`, the Y axis starts at 0."
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": 0,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The Y axis value to serve as the base for the area, for distinguishing\nbetween values above and below a threshold. If `null`, the area\nbehaves like a line series with fill between the graph and the Y\naxis minimum."
              },
              "subtree": {}
            },
            "fillColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "fillColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Fill color or gradient for the area. When `null`, the series' `color`\nis used with the series' `fillOpacity`.\n\nIn styled mode, the fill color can be set with the `.highcharts-area`\nclass name."
              },
              "subtree": {}
            },
            "fillOpacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "fillOpacity",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Fill opacity for the area. When you set an explicit `fillColor`,\nthe `fillOpacity` is not applied. Instead, you should define the\nopacity in the `fillColor` with an rgba color definition. The\n`fillOpacity` setting, also the default setting, overrides the alpha\ncomponent of the `color` setting.\n\nIn styled mode, the fill opacity can be set with the `.highcharts-area`\nclass name."
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A separate color for the graph line. By default the line takes the\n`color` of the series, but the lineColor setting allows setting a\nseparate color for the line without altering the `fillColor`.\n\nIn styled mode, the line stroke can be set with the `.highcharts-graph`\nclass name."
              },
              "subtree": {}
            },
            "negativeFillColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "negativeFillColor",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "A separate color for the negative part of the area.\n\nIn styled mode, a negative color is set with the `.highcharts-negative`\nclass name."
              },
              "subtree": {}
            },
            "trackByArea": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "trackByArea",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether the whole area or just the line should respond to mouseover\ntooltips and other mouse or touch events."
              },
              "subtree": {}
            }
          }
        },
        "areaspline": {
          "meta": {
            "types": {},
            "name": "areaspline",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The area spline series is an area series where the graph between the points\nis smoothed into a spline.",
            "extends": "plotOptions.area"
          },
          "subtree": {}
        },
        "bar": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "bar",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A bar series is a special type of column series where the columns are\nhorizontal.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "left",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Alignment of the data label relative to the data point."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": "5",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The x position of the data label relative to the data point."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "candlestick": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "candlestick",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "A candlestick chart is a style of financial chart used to describe price\nmovements over time.",
            "extends": "{plotOptions.ohlc}"
          },
          "subtree": {
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "extends": "plotOptions.column.states.hover"
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": "2",
                        "products": {
                          "highstock": 1
                        },
                        "description": "The pixel width of the line/border around the candlestick."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {},
                "name": "tooltip",
                "excludes": {},
                "extends": "{plotOptions.ohlc.tooltip}"
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": "#000000",
                "products": {
                  "highstock": 1
                },
                "description": "The color of the line/border of the candlestick.\n\nIn styled mode, the line stroke can be set with the\n`.highcharts-candlestick-series .highcahrts-point` rule."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highstock": 1
                },
                "description": "The pixel width of the candlestick line/border. Defaults to `1`.\n\n\nIn styled mode, the line stroke width can be set with the\n`.highcharts-candlestick-series .highcahrts-point` rule."
              },
              "subtree": {}
            },
            "upColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "upColor",
                "excludes": {},
                "default": "#ffffff",
                "products": {
                  "highstock": 1
                },
                "description": "The fill color of the candlestick when values are rising.\n\nIn styled mode, the up color can be set with the\n`.highcharts-candlestick-series .highcharts-point-up` rule."
              },
              "subtree": {}
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "upLineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "upLineColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highstock": 1
                },
                "description": "The specific line color for up candle sticks. The default is to inherit\nthe general `lineColor` setting."
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "ohlc"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "column": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "column",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Column series display one column per value along an X axis.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "borderRadius": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderRadius",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The corner radius of the border surrounding each column or bar."
              },
              "subtree": {}
            },
            "crisp": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "crisp",
                "excludes": {},
                "default": true,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When true, each column edge is rounded to its nearest pixel in order\nto render sharp on screen. In some cases, when there are a lot of\ndensely packed columns, this leads to visible difference in column\nwidths or distance between columns. In these cases, setting `crisp`\nto `false` may look better, even though each column is rendered\nblurry."
              },
              "subtree": {}
            },
            "groupPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "groupPadding",
                "excludes": {},
                "default": 0.2,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Padding between each value groups, in x axis units."
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": 0.1,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Padding between each column or bar, in x axis units."
              },
              "subtree": {}
            },
            "minPointLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "minPointLength",
                "excludes": {},
                "default": 0,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The minimal height for a column or width for a bar. By default,\n0 values are not shown. To visualize a 0 (or close to zero) point,\nset the minimal point length to a pixel value like 3\\. In stacked\ncolumn charts, minPointLength might not be respected for tightly\npacked values."
              },
              "subtree": {}
            },
            "cropThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "cropThreshold",
                "excludes": {},
                "default": 50,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When the series contains less points than the crop threshold, all\npoints are drawn, event if the points fall outside the visible plot\narea at the current zoom. The advantage of drawing all points (including\nmarkers and columns), is that animation is performed on updates.\nOn the other hand, when the series contains more points than the\ncrop threshold, the series data is cropped to only contain points\nthat fall within the plot area. The advantage of cropping away invisible\npoints is to increase performance on large series. ."
              },
              "subtree": {}
            },
            "pointRange": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": null,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The X axis range that each point is valid for. This determines the\nwidth of the column. On a categorized axis, the range will be 1\nby default (one category unit). On linear and datetime axes, the\nrange will be computed as the distance between the two closest data\npoints.\n\nThe default `null` means it is computed automatically, but this option\ncan be used to override the automatic value."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Options for the hovered point. These settings override the normal\nstate options when a point is moused over or touched.",
                    "extends": "plotOptions.series.states.hover"
                  },
                  "subtree": {
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": 0.1,
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "How much to brighten the point on interaction. Requires the main\ncolor to be defined in hex or rgb(a) format.\n\nIn styled mode, the hover brightening is by default replaced\nwith a fill-opacity set in the `.highcharts-point:hover` rule."
                      },
                      "subtree": {}
                    },
                    "borderColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "borderColor",
                        "excludes": {},
                        "products": {
                          "highcharts": 1
                        },
                        "description": "A specific border color for the hovered point. Defaults to\ninherit the normal state border color."
                      },
                      "subtree": {}
                    },
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "undefined",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "A specific color for the hovered point."
                      },
                      "subtree": {}
                    }
                  }
                },
                "select": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "select",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Options for the selected point. These settings override the normal\nstate options when a point is selected."
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#cccccc",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "A specific color for the selected point."
                      },
                      "subtree": {}
                    },
                    "borderColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "borderColor",
                        "excludes": {},
                        "default": "#000000",
                        "products": {
                          "highcharts": 1,
                          "highstock": 1
                        },
                        "description": "A specific border color for the selected point."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                }
              }
            },
            "softThreshold": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "softThreshold",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When this is true, the series will not cause the Y axis to cross\nthe zero plane (or [threshold](#plotOptions.series.threshold) option)\nunless the data actually crosses the plane.\n\nFor example, if `softThreshold` is `false`, a series of 0, 1, 2,\n3 will make the Y axis show negative values according to the `minPadding`\noption. If `softThreshold` is `true`, the Y axis starts at 0."
              },
              "subtree": {}
            },
            "startFromThreshold": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "startFromThreshold",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "distance": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "distance",
                    "excludes": {},
                    "default": 6
                  },
                  "subtree": {}
                }
              }
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": 0,
                "products": {
                  "highcharts": 1
                },
                "description": "The Y axis value to serve as the base for the columns, for distinguishing\nbetween values above and below a threshold. If `null`, the columns\nextend from the padding Y axis minimum."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#ffffff",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The color of the border surrounding each column or bar.\n\nIn styled mode, the border stroke can be set with the `.highcharts-point`\nrule."
              },
              "subtree": {}
            },
            "colorByPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "colorByPoint",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "When using automatic point colors pulled from the `options.colors`\ncollection, this option determines whether the chart should receive\none color per series or one color per point."
              },
              "subtree": {}
            },
            "colors": {
              "meta": {
                "types": {
                  "array": "Color"
                },
                "name": "colors",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A series specific or series type specific color set to apply instead\nof the global [colors](#colors) when [colorByPoint](#plotOptions.\ncolumn.colorByPoint) is true."
              },
              "subtree": {}
            },
            "grouping": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "grouping",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to group non-stacked columns or to let them render independent\nof each other. Non-grouped columns will be laid out individually\nand overlap each other."
              },
              "subtree": {}
            },
            "maxPointWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "maxPointWidth",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The maximum allowed pixel width for a column, translated to the height\nof a bar in a bar chart. This prevents the columns from becoming\ntoo wide when there is a small number of points in the chart."
              },
              "subtree": {}
            },
            "pointWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointWidth",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A pixel value specifying a fixed width for each column or bar. When\n`null`, the width is calculated from the `pointPadding` and\n`groupPadding`."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The width of the border surrounding each column or bar.\n\nIn styled mode, the stroke width can be set with the `.highcharts-point`\nrule."
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "groupPixelWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "groupPixelWidth",
                    "excludes": {},
                    "default": "10",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The approximate pixel width of each group. If for example a series\nwith 30 points is displayed over a 600 pixel wide plot area, no grouping\nis performed. If however the series contains so many points that\nthe spacing is less than the groupPixelWidth, Highcharts will try\nto group it into appropriate groups so that each is more or less\ntwo pixels wide. Defaults to `10`."
                  },
                  "subtree": {}
                }
              }
            },
            "depth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "depth",
                "excludes": {},
                "default": "25",
                "products": {
                  "highcharts": 1
                },
                "description": "Depth of the columns in a 3D column chart. Requires `highcharts-3d.js`."
              },
              "subtree": {}
            },
            "edgeColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "edgeColor",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "3D columns only. The color of the edges. Similar to `borderColor`,\n except it defaults to the same color as the column."
              },
              "subtree": {}
            },
            "edgeWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "edgeWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1
                },
                "description": "3D columns only. The width of the colored edges."
              },
              "subtree": {}
            },
            "groupZPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "groupZPadding",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1
                },
                "description": "The spacing between columns on the Z Axis in a 3D chart. Requires\n`highcharts-3d.js`."
              },
              "subtree": {}
            }
          }
        },
        "flags": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "flags",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Flags are used to mark events in stock charts. They can be added on the\ntimeline, or attached to a specific series.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "pointRange": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "allowOverlapX": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowOverlapX",
                "excludes": {},
                "default": false,
                "description": "Whether the flags are allowed to overlap sideways. If `false`, the flags\nare moved sideways using an algorithm that seeks to place every flag as\nclose as possible to its original position."
              },
              "subtree": {}
            },
            "shape": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "shape",
                "excludes": {},
                "default": "flag",
                "products": {
                  "highstock": 1
                },
                "description": "The shape of the marker. Can be one of \"flag\", \"circlepin\", \"squarepin\",\nor an image on the format `url(/path-to-image.jpg)`. Individual\nshapes can also be set for each point."
              },
              "subtree": {}
            },
            "stackDistance": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "stackDistance",
                "excludes": {},
                "default": 12,
                "products": {
                  "highstock": 1
                },
                "description": "When multiple flags in the same series fall on the same value, this\nnumber determines the vertical offset between them."
              },
              "subtree": {}
            },
            "textAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textAlign",
                "excludes": {},
                "default": "center",
                "products": {
                  "highstock": 1
                },
                "description": "Text alignment for the text inside the flag."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Specific tooltip options for flag series. Flag series tooltips are\ndifferent from most other types in that a flag doesn't have a data\nvalue, so the tooltip rather displays the `text` option for each\npoint.",
                "extends": "plotOptions.series.tooltip"
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "{point.text}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "threshold": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": -30,
                "products": {
                  "highstock": 1
                },
                "description": "The y position of the top left corner of the flag relative to either\nthe series (if onSeries is defined), or the x axis. Defaults to\n`-30`."
              },
              "subtree": {}
            },
            "fillColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "fillColor",
                "excludes": {},
                "default": "#ffffff",
                "products": {
                  "highstock": 1
                },
                "description": "The fill color for the flags."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1,
                "products": {
                  "highstock": 1
                },
                "description": "The pixel width of the flag's line/border."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "extends": "plotOptions.column.states.hover"
                  },
                  "subtree": {
                    "lineColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "lineColor",
                        "excludes": {},
                        "default": "#000000",
                        "products": {
                          "highstock": 1
                        },
                        "description": "The color of the line/border of the flag."
                      },
                      "subtree": {}
                    },
                    "fillColor": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "fillColor",
                        "excludes": {},
                        "default": "#ccd6eb",
                        "products": {
                          "highstock": 1
                        },
                        "description": "The fill or background color of the flag."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "default": "{ \"fontSize\": \"11px\", \"fontWeight\": \"bold\" }",
                "products": {
                  "highstock": 1
                },
                "description": "The text styles of the flag.\n\nIn styled mode, the styles are set in the\n`.highcharts-flag-series .highcharts-point` rule."
              },
              "subtree": {
                "fontSize": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontSize",
                    "excludes": {},
                    "default": "11px"
                  },
                  "subtree": {}
                },
                "fontWeight": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "bold"
                  },
                  "subtree": {}
                }
              }
            },
            "onKey": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "onKey",
                "excludes": {},
                "default": "y",
                "products": {
                  "highstock": 1
                },
                "description": "In case the flag is placed on a series, on what point key to place\nit. Line and columns have one key, `y`. In range or OHLC-type series,\nhowever, the flag can optionally be placed on the `open`, `high`,\n `low` or `close` key."
              },
              "subtree": {}
            },
            "onSeries": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "onSeries",
                "excludes": {},
                "default": "undefined",
                "products": {
                  "highstock": 1
                },
                "description": "The id of the series that the flags should be drawn on. If no id\nis given, the flags are drawn on the x axis."
              },
              "subtree": {}
            },
            "title": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "title",
                "excludes": {},
                "default": "A",
                "products": {
                  "highstock": 1
                },
                "description": "The text to display on each flag. This can be defined on series level,\n or individually for each point. Defaults to `\"A\"`."
              },
              "subtree": {}
            },
            "useHTML": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "useHTML",
                "excludes": {},
                "default": "false",
                "products": {
                  "highstock": 1
                },
                "description": "Whether to use HTML to render the flag texts. Using HTML allows for\nadvanced formatting, images and reliable bi-directional text rendering.\nNote that exported images won't respect the HTML, and that HTML\nwon't respect Z-index settings."
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": "#000000",
                "products": {
                  "highstock": 1
                },
                "description": "The color of the line/border of the flag.\n\nIn styled mode, the stroke is set in the\n`.highcharts-flag-series.highcharts-point` rule."
              },
              "subtree": {}
            }
          }
        },
        "ohlc": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "ohlc",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "An OHLC chart is a style of financial chart used to describe price\nmovements over time. It displays open, high, low and close values per data\npoint.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highstock": 1
                },
                "description": "The pixel width of the line/border. Defaults to `1`."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "threshold": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "extends": "plotOptions.column.states.hover"
                  },
                  "subtree": {
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": "3",
                        "products": {
                          "highstock": 1
                        },
                        "description": "The pixel width of the line representing the OHLC point."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {}
              },
              "subtree": {
                "groupPixelWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "groupPixelWidth",
                    "excludes": {},
                    "default": "5",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The approximate pixel width of each group. If for example a series\nwith 30 points is displayed over a 600 pixel wide plot area, no grouping\nis performed. If however the series contains so many points that\nthe spacing is less than the groupPixelWidth, Highcharts will try\nto group it into appropriate groups so that each is more or less\ntwo pixels wide. Defaults to `5`."
                  },
                  "subtree": {}
                }
              }
            },
            "upColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "upColor",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Line color for up points."
              },
              "subtree": {}
            }
          }
        },
        "pie": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "pie",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A pie chart is a circular graphic which is divided into slices to illustrate\nnumerical proportion.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "events": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "events",
                "excludes": {}
              },
              "subtree": {
                "checkboxClick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "checkboxClick",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Fires when the checkbox next to the point name in the legend is clicked.\nOne parameter, event, is passed to the function. The state of the\ncheckbox is found by event.checked. The checked item is found by\nevent.item. Return false to prevent the default action which is to\ntoggle the select state of the series."
                  },
                  "subtree": {}
                },
                "legendItemClick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "legendItemClick",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Not applicable to pies, as the legend item is per point. See point.\nevents."
                  },
                  "subtree": {}
                }
              }
            },
            "point": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "point",
                "excludes": {}
              },
              "subtree": {
                "events": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "events",
                    "excludes": {}
                  },
                  "subtree": {
                    "legendItemClick": {
                      "meta": {
                        "types": {
                          "function": 1
                        },
                        "name": "legendItemClick",
                        "excludes": {},
                        "products": {
                          "highcharts": 1
                        },
                        "description": "Fires when the legend item belonging to the pie point (slice) is\nclicked. The `this` keyword refers to the point itself. One parameter,\n`event`, is passed to the function, containing common event information. The\ndefault action is to toggle the visibility of the point. This can be\nprevented by calling `event.preventDefault()`."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "center": {
              "meta": {
                "types": {
                  "array": "(String|Number)"
                },
                "name": "center",
                "excludes": {},
                "default": "[null, null]",
                "products": {
                  "highcharts": 1
                },
                "description": "The center of the pie chart relative to the plot area. Can be percentages\nor pixel values. The default behaviour (as of 3.0) is to center\nthe pie so that all slices and data labels are within the plot area.\nAs a consequence, the pie may actually jump around in a chart with\ndynamic values, as the data labels move. In that case, the center\nshould be explicitly set, for example to `[\"50%\", \"50%\"]`."
              },
              "subtree": {}
            },
            "clip": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "clip",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "extends": "plotOptions.series.dataLabels"
              },
              "subtree": {
                "distance": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "distance",
                    "excludes": {},
                    "default": "30",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The distance of the data label from the pie's edge. Negative numbers\nput the data label on top of the pie slices. Connectors are only\nshown for data labels outside the pie."
                  },
                  "subtree": {}
                },
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true,
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Enable or disable the data labels."
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                },
                "connectorColor": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "connectorColor",
                    "excludes": {},
                    "default": "{point.color}",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The color of the line connecting the data label to the pie slice.\nThe default color is the same as the point's color.\n\nIn styled mode, the connector stroke is given in the\n`.highcharts-data-label-connector` class."
                  },
                  "subtree": {}
                },
                "connectorPadding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "connectorPadding",
                    "excludes": {},
                    "default": "5",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The distance from the data label to the connector."
                  },
                  "subtree": {}
                },
                "connectorWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "connectorWidth",
                    "excludes": {},
                    "default": "1",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The width of the line connecting the data label to the pie slice.\n\n\nIn styled mode, the connector stroke width is given in the\n`.highcharts-data-label-connector` class."
                  },
                  "subtree": {}
                },
                "softConnector": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "softConnector",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Whether to render the connector as a soft arc or a line with sharp\nbreak."
                  },
                  "subtree": {}
                }
              }
            },
            "ignoreHiddenPoint": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "ignoreHiddenPoint",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1
                },
                "description": "Equivalent to [chart.ignoreHiddenSeries](#chart.ignoreHiddenSeries),\nthis option tells whether the series shall be redrawn as if the\nhidden point were `null`.\n\nThe default value changed from `false` to `true` with Highcharts\n3.0."
              },
              "subtree": {}
            },
            "legendType": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "legendType",
                "excludes": {},
                "default": "point"
              },
              "subtree": {}
            },
            "size": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1
                },
                "name": "size",
                "excludes": {},
                "default": null,
                "products": {
                  "highcharts": 1
                },
                "description": "The diameter of the pie relative to the plot area. Can be a percentage\nor pixel value. Pixel values are given as integers. The default\nbehaviour (as of 3.0) is to scale to the plot area and give room\nfor data labels within the plot area.\n[slicedOffset](#plotOptions.pie.slicedOffset) is also included \nin the default size calculation. As a consequence, the size\nof the pie may vary when points are updated and data labels more\naround. In that case it is best to set a fixed value, for example\n`\"75%\"`."
              },
              "subtree": {}
            },
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to display this particular series or series type in the\nlegend. Since 2.1, pies are not shown in the legend by default."
              },
              "subtree": {}
            },
            "slicedOffset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "slicedOffset",
                "excludes": {},
                "default": "10",
                "products": {
                  "highcharts": 1
                },
                "description": "If a point is sliced, moved out from the center, how many pixels\nshould it be moved?."
              },
              "subtree": {}
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "Sticky tracking of mouse events. When true, the `mouseOut` event\non a series isn't triggered until the mouse moves over another series,\nor out of the plot area. When false, the `mouseOut` event on a\nseries is triggered when the mouse leaves the area around the series'\ngraph or markers. This also implies the tooltip. When `stickyTracking`\nis false and `tooltip.shared` is false, the tooltip will be hidden\nwhen moving the mouse between series."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "followPointer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "followPointer",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#ffffff",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the border surrounding each slice. When `null`, the\nborder takes the same color as the slice fill. This can be used\ntogether with a `borderWidth` to fill drawing gaps created by antialiazing\nartefacts in borderless pies.\n\nIn styled mode, the border stroke is given in the `.highcharts-point` class."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the border surrounding each slice.\n\nWhen setting the border width to 0, there may be small gaps between\nthe slices due to SVG antialiasing artefacts. To work around this,\nkeep the border width at 0.5 or 1, but set the `borderColor` to\n`null` instead.\n\nIn styled mode, the border stroke width is given in the `.highcharts-point` class."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "extends": "plotOptions.series.states.hover"
                  },
                  "subtree": {
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": 0.1,
                        "products": {
                          "highcharts": 1
                        },
                        "description": "How much to brighten the point on interaction. Requires the main\ncolor to be defined in hex or rgb(a) format.\n\nIn styled mode, the hover brightness is by default replaced\nby a fill-opacity given in the `.highcharts-point-hover` class."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "colors": {
              "meta": {
                "types": {
                  "array": "Color"
                },
                "name": "colors",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "A series specific or series type specific color set to use instead\nof the global [colors](#colors)."
              },
              "subtree": {}
            },
            "endAngle": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "endAngle",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The end angle of the pie in degrees where 0 is top and 90 is right.\nDefaults to `startAngle` plus 360."
              },
              "subtree": {}
            },
            "innerSize": {
              "meta": {
                "types": {
                  "string": 1,
                  "number": 1
                },
                "name": "innerSize",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "The size of the inner diameter for the pie. A size greater than 0\nrenders a donut chart. Can be a percentage or pixel value. Percentages\nare relative to the pie size. Pixel values are given as integers.\n\n\nNote: in Highcharts < 4.1.2, the percentage was relative to the plot\narea, not the pie size."
              },
              "subtree": {}
            },
            "minSize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "minSize",
                "excludes": {},
                "default": "80",
                "products": {
                  "highcharts": 1
                },
                "description": "The minimum size for a pie in response to auto margins. The pie will\ntry to shrink to make room for data labels in side the plot area,\n but only to this size."
              },
              "subtree": {}
            },
            "startAngle": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "startAngle",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "The start angle of the pie slices in degrees where 0 is top and 90\nright."
              },
              "subtree": {}
            },
            "depth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "depth",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "The thickness of a 3D pie. Requires `highcharts-3d.js`"
              },
              "subtree": {}
            }
          }
        },
        "scatter": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "scatter",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A scatter plot uses cartesian coordinates to display values for two variables\nfor a set of data.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 0,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The width of the line connecting the data points."
              },
              "subtree": {}
            },
            "findNearestPointBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "findNearestPointBy",
                "excludes": {},
                "default": "xy"
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A configuration object for the tooltip rendering of each single\nseries. Properties are inherited from <a class=\"internal\">#tooltip</a>.\nOverridable properties are `headerFormat`, `pointFormat`, `yDecimals`,\n`xDateFormat`, `yPrefix` and `ySuffix`. Unlike other series, in\na scatter plot the series.name by default shows in the headerFormat\nand point.x and point.y in the pointFormat."
              },
              "subtree": {
                "headerFormat": {
                  "meta": {
                    "types": {},
                    "name": "headerFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Sticky tracking of mouse events. When true, the `mouseOut` event\non a series isn't triggered until the mouse moves over another series,\nor out of the plot area. When false, the `mouseOut` event on a series\nis triggered when the mouse leaves the area around the series' graph\nor markers. This also implies the tooltip. When `stickyTracking`\nis false and `tooltip.shared` is false, the tooltip will be hidden\nwhen moving the mouse between series."
              },
              "subtree": {}
            }
          }
        },
        "line": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "line",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A line series displays information as a series of data points connected by\nstraight line segments.",
            "extends": "plotOptions.series"
          },
          "subtree": {
            "linecap": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linecap",
                "excludes": {},
                "default": "round",
                "description": "The SVG value used for the `stroke-linecap` and `stroke-linejoin`\nof a line graph. Round means that lines are rounded in the ends and\nbends."
              },
              "subtree": {}
            }
          }
        },
        "spline": {
          "meta": {
            "types": {},
            "name": "spline",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A spline series is a special type of line series, where the segments between\nthe data points are smoothed.",
            "extends": "plotOptions.series"
          },
          "subtree": {}
        },
        "scatter3d": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "scatter3d",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A 3D scatter plot uses x, y and z coordinates to display values for three\nvariables for a set of data.",
            "extends": "{plotOptions.scatter}"
          },
          "subtree": {
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>z: <b>{point.z}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "arearange": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "arearange",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The area range series is a carteseian series with higher and lower values\nfor each point along an X axis, where the area between the values is shaded.\nRequires `highcharts-more.js`.",
            "extends": "plotOptions.area"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Pixel width of the arearange graph line."
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{series.color}\">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "trackByArea": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "trackByArea",
                "excludes": {},
                "default": true,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether the whole area or just the line should respond to mouseover\ntooltips and other mouse or touch events."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Extended data labels for range series types. Range series data labels\nhave no `x` and `y` options. Instead, they have `xLow`, `xHigh`,\n`yLow` and `yHigh` options to allow the higher and lower data label\nsets individually.",
                "extends": "plotOptions.series.dataLabels"
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "xLow": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "xLow",
                    "excludes": {},
                    "default": 0,
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "X offset of the lower data labels relative to the point value."
                  },
                  "subtree": {}
                },
                "xHigh": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "xHigh",
                    "excludes": {},
                    "default": 0,
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "X offset of the higher data labels relative to the point value."
                  },
                  "subtree": {}
                },
                "yLow": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "yLow",
                    "excludes": {},
                    "default": "16",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Y offset of the lower data labels relative to the point value."
                  },
                  "subtree": {}
                },
                "yHigh": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "yHigh",
                    "excludes": {},
                    "default": "-6",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Y offset of the higher data labels relative to the point value."
                  },
                  "subtree": {}
                }
              }
            },
            "shadow": {
              "meta": {
                "types": {
                  "boolean": 1,
                  "object": 1
                },
                "name": "shadow",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to apply a drop shadow to the graph line. Since 2.3 the shadow\ncan be an object configuration containing `color`, `offsetX`, `offsetY`,\n`opacity` and `width`."
              },
              "subtree": {}
            }
          }
        },
        "areasplinerange": {
          "meta": {
            "types": {},
            "name": "areasplinerange",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The area spline range is a cartesian series type with higher and\nlower Y values along an X axis. The area inside the range is colored, and\nthe graph outlining the area is a smoothed spline. Requires\n`highcharts-more.js`.",
            "extends": "plotOptions.arearange"
          },
          "subtree": {}
        },
        "boxplot": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "boxplot",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A box plot is a convenient way of depicting groups of data through their\nfive-number summaries: the smallest observation (sample minimum), lower\nquartile (Q1), median (Q2), upper quartile (Q3), and largest observation\n(sample maximum).",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "threshold": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {},
                    "name": "pointFormat",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "whiskerLength": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "whiskerLength",
                "excludes": {},
                "default": "50%",
                "products": {
                  "highcharts": 1
                },
                "description": "The length of the whiskers, the horizontal lines marking low and\nhigh values. It can be a numerical pixel value, or a percentage\nvalue of the box width. Set `0` to disable whiskers."
              },
              "subtree": {}
            },
            "fillColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "fillColor",
                "excludes": {},
                "default": "#ffffff",
                "products": {
                  "highcharts": 1
                },
                "description": "The fill color of the box.\n\nIn styled mode, the fill color can be set with the\n`.highcharts-boxplot-box` class."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1,
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the line surrounding the box. If any of\n[stemWidth](#plotOptions.boxplot.stemWidth),\n[medianWidth](#plotOptions.boxplot.medianWidth)\nor [whiskerWidth](#plotOptions.boxplot.whiskerWidth) are `null`,\nthe lineWidth also applies to these lines."
              },
              "subtree": {}
            },
            "medianWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "medianWidth",
                "excludes": {},
                "default": 2,
                "products": {
                  "highcharts": 1
                },
                "description": "The pixel width of the median line. If `null`, the\n[lineWidth](#plotOptions.boxplot.lineWidth) is used.\n\nIn styled mode, the median stroke width can be set with the\n`.highcharts-boxplot-median` class."
              },
              "subtree": {}
            },
            "whiskerWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "whiskerWidth",
                "excludes": {},
                "default": 2,
                "products": {
                  "highcharts": 1
                },
                "description": "The line width of the whiskers, the horizontal lines marking low and\nhigh values. When `null`, the general\n[lineWidth](#plotOptions.boxplot.lineWidth) applies.\n\nIn styled mode, the whisker stroke width can be set with the\n`.highcharts-boxplot-whisker` class."
              },
              "subtree": {}
            },
            "medianColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "medianColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the median line. If `null`, the general series color\napplies.\n\nIn styled mode, the median stroke width can be set with the\n`.highcharts-boxplot-median` class."
              },
              "subtree": {}
            },
            "stemColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "stemColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the stem, the vertical line extending from the box to\nthe whiskers. If `null`, the series color is used.\n\nIn styled mode, the stem stroke can be set with the\n`.highcharts-boxplot-stem` class."
              },
              "subtree": {}
            },
            "stemDashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "stemDashStyle",
                "excludes": {},
                "default": "Solid",
                "products": {
                  "highcharts": 1
                },
                "description": "The dash style of the stem, the vertical line extending from the\nbox to the whiskers."
              },
              "subtree": {}
            },
            "stemWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "stemWidth",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the stem, the vertical line extending from the box to\nthe whiskers. If `null`, the width is inherited from the\n[lineWidth](#plotOptions.boxplot.lineWidth) option.\n\nIn styled mode, the stem stroke width can be set with the\n`.highcharts-boxplot-stem` class."
              },
              "subtree": {}
            },
            "whiskerColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "whiskerColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the whiskers, the horizontal lines marking low and high\nvalues. When `null`, the general series color is used.\n\nIn styled mode, the whisker stroke can be set with the\n`.highcharts-boxplot-whisker` class ."
              },
              "subtree": {}
            }
          }
        },
        "bubble": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "bubble",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A bubble series is a three dimensional series type where each point renders\nan X, Y and Z value. Each points is drawn as a bubble where the position\nalong the X and Y axes mark the X and Y values, and the size of the bubble\nrelates to the Z value. Requires `highcharts-more.js`.",
            "extends": "plotOptions.scatter"
          },
          "subtree": {
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "middle"
                  },
                  "subtree": {}
                }
              }
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {},
                "extends": "plotOptions.series.marker"
              },
              "subtree": {
                "lineColor": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "lineColor",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "lineWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "lineWidth",
                    "excludes": {},
                    "default": 1
                  },
                  "subtree": {}
                },
                "fillOpacity": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "fillOpacity",
                    "excludes": {},
                    "default": 0.5,
                    "description": "The fill opacity of the bubble markers."
                  },
                  "subtree": {}
                },
                "radius": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "radius",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                },
                "states": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "states",
                    "excludes": {}
                  },
                  "subtree": {
                    "hover": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "hover",
                        "excludes": {}
                      },
                      "subtree": {
                        "radiusPlus": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "radiusPlus",
                            "excludes": {},
                            "default": 0
                          },
                          "subtree": {}
                        }
                      }
                    }
                  }
                },
                "symbol": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "symbol",
                    "excludes": {},
                    "default": "circle",
                    "description": "A predefined shape or symbol for the marker. Possible values are\n\"circle\", \"square\", \"diamond\", \"triangle\" and \"triangle-down\".\n\nAdditionally, the URL to a graphic can be given on the form\n`url(graphic.png)`. Note that for the image to be applied to exported\ncharts, its URL needs to be accessible by the export server.\n\nCustom callbacks for symbol path generation can also be added to\n`Highcharts.SVGRenderer.prototype.symbols`. The callback is then\nused by its method name, as shown in the demo."
                  },
                  "subtree": {}
                }
              }
            },
            "minSize": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "minSize",
                "excludes": {},
                "default": 8,
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Minimum bubble size. Bubbles will automatically size between the\n`minSize` and `maxSize` to reflect the `z` value of each bubble.\nCan be either pixels (when no unit is given), or a percentage of\nthe smallest one of the plot width and height."
              },
              "subtree": {}
            },
            "maxSize": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "maxSize",
                "excludes": {},
                "default": "20%",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Maximum bubble size. Bubbles will automatically size between the\n`minSize` and `maxSize` to reflect the `z` value of each bubble.\nCan be either pixels (when no unit is given), or a percentage of\nthe smallest one of the plot width and height."
              },
              "subtree": {}
            },
            "softThreshold": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "softThreshold",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "When this is true, the series will not cause the Y axis to cross\nthe zero plane (or [threshold](#plotOptions.series.threshold) option)\nunless the data actually crosses the plane.\n\nFor example, if `softThreshold` is `false`, a series of 0, 1, 2,\n3 will make the Y axis show negative values according to the `minPadding`\noption. If `softThreshold` is `true`, the Y axis starts at 0."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "halo": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "halo",
                        "excludes": {}
                      },
                      "subtree": {
                        "size": {
                          "meta": {
                            "types": {
                              "number": 1
                            },
                            "name": "size",
                            "excludes": {},
                            "default": 5
                          },
                          "subtree": {}
                        }
                      }
                    }
                  }
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "({point.x}, {point.y}), Size: {point.z}"
                  },
                  "subtree": {}
                }
              }
            },
            "turboThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "turboThreshold",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "zThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zThreshold",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "When [displayNegative](#plotOptions.bubble.displayNegative) is `false`,\nbubbles with lower Z values are skipped. When `displayNegative`\nis `true` and a [negativeColor](#plotOptions.bubble.negativeColor)\nis given, points with lower Z is colored."
              },
              "subtree": {}
            },
            "zoneAxis": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "zoneAxis",
                "excludes": {},
                "default": "z"
              },
              "subtree": {}
            },
            "displayNegative": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "displayNegative",
                "excludes": {},
                "default": "true",
                "description": "Whether to display negative sized bubbles. The threshold is given\nby the [zThreshold](#plotOptions.bubble.zThreshold) option, and negative\nbubbles can be visualized by setting\n[negativeColor](#plotOptions.bubble.negativeColor)."
              },
              "subtree": {}
            },
            "negativeColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "negativeColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "When a point's Z value is below the\n[zThreshold](#plotOptions.bubble.zThreshold) setting, this color is used."
              },
              "subtree": {}
            },
            "sizeBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "sizeBy",
                "excludes": {},
                "default": "area",
                "description": "Whether the bubble's value should be represented by the area or the\nwidth of the bubble. The default, `area`, corresponds best to the\nhuman perception of the size of each bubble."
              },
              "subtree": {}
            },
            "sizeByAbsoluteValue": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "sizeByAbsoluteValue",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "When this is true, the absolute value of z determines the size of\nthe bubble. This means that with the default `zThreshold` of 0, a\nbubble of value -1 will have the same size as a bubble of value 1,\nwhile a bubble of value 0 will have a smaller size according to\n`minSize`."
              },
              "subtree": {}
            },
            "zMax": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMax",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The minimum for the Z value range. Defaults to the highest Z value\nin the data."
              },
              "subtree": {}
            },
            "zMin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMin",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The minimum for the Z value range. Defaults to the lowest Z value\nin the data."
              },
              "subtree": {}
            }
          }
        },
        "columnrange": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "columnrange",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The column range is a cartesian series type with higher and lower\nY values along an X axis. Requires `highcharts-more.js`. To display\nhorizontal bars, set [chart.inverted](#chart.inverted) to `true`.",
            "extends": "plotOptions.column"
          },
          "subtree": {
            "pointRange": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {},
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "errorbar": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "errorbar",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Error bars are a graphical representation of the variability of data and are\nused on graphs to indicate the error, or uncertainty in a reported\nmeasurement.",
            "extends": "{plotOptions.boxplot}"
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#000000",
                "products": {
                  "highcharts": 1
                },
                "description": "The main color of the bars. This can be overridden by\n[stemColor](#plotOptions.errorbar.stemColor) and\n[whiskerColor](#plotOptions.errorbar.whiskerColor) individually."
              },
              "subtree": {}
            },
            "grouping": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "grouping",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "linkedTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "linkedTo",
                "excludes": {},
                "default": ":previous",
                "products": {
                  "highcharts": 1
                },
                "description": "The parent series of the error bar. The default value links it to\nthe previous series. Otherwise, use the id of the parent series."
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "<span style=\"color:{point.color}\">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "whiskerWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "whiskerWidth",
                "excludes": {},
                "default": null,
                "products": {
                  "highcharts": 1
                },
                "description": "The line width of the whiskers, the horizontal lines marking low\nand high values. When `null`, the general\n[lineWidth](#plotOptions.errorbar.lineWidth) applies."
              },
              "subtree": {}
            }
          }
        },
        "gauge": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "gauge",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Gauges are circular plots displaying one or more values with a dial pointing\nto values along the perimeter.",
            "extends": "{plotOptions.line}"
          },
          "subtree": {
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Data labels for the gauge. For gauges, the data labels are enabled\nby default and shown in a bordered box below the point.",
                "extends": "plotOptions.series.dataLabels"
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true,
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "Enable or disable the data labels."
                  },
                  "subtree": {}
                },
                "defer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "defer",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": 15,
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The y position offset of the label relative to the center of the\ngauge."
                  },
                  "subtree": {}
                },
                "borderRadius": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderRadius",
                    "excludes": {},
                    "default": 3,
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The border radius in pixels for the gauge's data label."
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "top",
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The vertical alignment of the data label."
                  },
                  "subtree": {}
                },
                "zIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "zIndex",
                    "excludes": {},
                    "default": 2,
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The Z index of the data labels. A value of 2 display them behind\nthe dial."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": 1,
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The border width in pixels for the gauge data label."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "default": "#cccccc",
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "The border color for the data label."
                  },
                  "subtree": {}
                }
              }
            },
            "dial": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dial",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Options for the dial or arrow pointer of the gauge.\n\nIn styled mode, the dial is styled with the\n`.highcharts-gauge-series .highcharts-dial` rule."
              },
              "subtree": {
                "baseLength": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "baseLength",
                    "excludes": {},
                    "default": "70%",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The length of the dial's base part, relative to the total radius\nor length of the dial."
                  },
                  "subtree": {}
                },
                "baseWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "baseWidth",
                    "excludes": {},
                    "default": "3",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The pixel width of the base of the gauge dial. The base is the part\nclosest to the pivot, defined by baseLength."
                  },
                  "subtree": {}
                },
                "radius": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "radius",
                    "excludes": {},
                    "default": "80%",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The radius or length of the dial, in percentages relative to the\nradius of the gauge itself."
                  },
                  "subtree": {}
                },
                "rearLength": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "rearLength",
                    "excludes": {},
                    "default": "10%",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The length of the dial's rear end, the part that extends out on the\nother side of the pivot. Relative to the dial's length."
                  },
                  "subtree": {}
                },
                "topWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "topWidth",
                    "excludes": {},
                    "default": "1",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The width of the top of the dial, closest to the perimeter. The pivot\nnarrows in from the base to the top."
                  },
                  "subtree": {}
                },
                "backgroundColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "backgroundColor",
                    "excludes": {},
                    "default": "#000000",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The background or fill color of the gauge's dial."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "default": "#cccccc",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The border color or stroke of the gauge's dial. By default, the borderWidth\nis 0, so this must be set in addition to a custom border color."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": "0",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The width of the gauge dial border in pixels."
                  },
                  "subtree": {}
                }
              }
            },
            "pivot": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "pivot",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Options for the pivot or the center point of the gauge.\n\nIn styled mode, the pivot is styled with the\n`.highcharts-gauge-series .highcharts-pivot` rule."
              },
              "subtree": {
                "radius": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "radius",
                    "excludes": {},
                    "default": "5",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The pixel radius of the pivot."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": "0",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The border or stroke width of the pivot."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "default": "#cccccc",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The border or stroke color of the pivot. In able to change this,\nthe borderWidth must also be set to something other than the default\n0."
                  },
                  "subtree": {}
                },
                "backgroundColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "backgroundColor",
                    "excludes": {},
                    "default": "#000000",
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The background color or fill of the pivot."
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "headerFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "headerFormat",
                    "excludes": {},
                    "default": ""
                  },
                  "subtree": {}
                }
              }
            },
            "showInLegend": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showInLegend",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to display this particular series or series type in the\nlegend. Defaults to false for gauge series."
              },
              "subtree": {}
            },
            "wrap": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "wrap",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1
                },
                "description": "When this option is `true`, the dial will wrap around the axes. For\ninstance, in a full-range gauge going from 0 to 360, a value of 400\nwill point to 40\\. When `wrap` is `false`, the dial stops at 360."
              },
              "subtree": {}
            },
            "overshoot": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "overshoot",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "Allow the dial to overshoot the end of the perimeter axis by this\nmany degrees. Say if the gauge axis goes from 0 to 60, a value of\n100, or 1000, will show 5 degrees beyond the end of the axis when this\noption is set to 5."
              },
              "subtree": {}
            }
          }
        },
        "polygon": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "polygon",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A polygon series can be used to draw any freeform shape in the cartesian\ncoordinate system. A fill is applied with the `color` option, and\nstroke is applied through `lineWidth` and `lineColor` options. Requires\nthe `highcharts-more.js` file.",
            "extends": "plotOptions.scatter"
          },
          "subtree": {
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "states": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "states",
                    "excludes": {}
                  },
                  "subtree": {
                    "hover": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "hover",
                        "excludes": {}
                      },
                      "subtree": {
                        "enabled": {
                          "meta": {
                            "types": {
                              "boolean": 1
                            },
                            "name": "enabled",
                            "excludes": {},
                            "default": false
                          },
                          "subtree": {}
                        }
                      }
                    }
                  }
                }
              }
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "followPointer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "followPointer",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": ""
                  },
                  "subtree": {}
                }
              }
            },
            "trackByArea": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "trackByArea",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            }
          }
        },
        "waterfall": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "waterfall",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "A waterfall chart displays sequentially introduced positive or negative\nvalues in cumulative columns.",
            "extends": "{plotOptions.column}"
          },
          "subtree": {
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                }
              }
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1,
                "products": {
                  "highcharts": 1
                },
                "description": "The width of the line connecting waterfall columns."
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": "#333333",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the line that connects columns in a waterfall series.\n\nIn styled mode, the stroke can be set with the `.highcharts-graph` class."
              },
              "subtree": {}
            },
            "dashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "dashStyle",
                "excludes": {},
                "default": "Dot",
                "products": {
                  "highcharts": 1
                },
                "description": "A name for the dash style to use for the line connecting the columns\nof the waterfall series. Possible values:\n\n*   Solid\n*   ShortDash\n*   ShortDot\n*   ShortDashDot\n*   ShortDashDotDot\n*   Dot\n*   Dash\n*   LongDash\n*   DashDot\n*   LongDashDot\n*   LongDashDotDot\n\nIn styled mode, the stroke dash-array can be set with the\n`.highcharts-graph` class."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#333333",
                "products": {
                  "highcharts": 1
                },
                "description": "The color of the border of each waterfall column.\n\nIn styled mode, the border stroke can be set with the\n`.highcharts-point` class."
              },
              "subtree": {}
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "lineWidthPlus": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidthPlus",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "upColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "upColor",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The color used specifically for positive point columns. When not\nspecified, the general series color is used.\n\nIn styled mode, the waterfall colors can be set with the\n`.highcharts-point-negative`, `.highcharts-sum` and\n`.highcharts-intermediate-sum` classes."
              },
              "subtree": {}
            }
          }
        },
        "heatmap": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "heatmap",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "A heatmap is a graphical representation of data where the individual values\ncontained in a matrix are represented as colors.",
            "extends": "{plotOptions.scatter}"
          },
          "subtree": {
            "animation": {
              "meta": {
                "types": {
                  "boolean": 1,
                  "object": 1
                },
                "name": "animation",
                "excludes": {},
                "default": false,
                "description": "Animation is disabled by default on the heatmap series."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": 0,
                "description": "The border width for each heat map item."
              },
              "subtree": {}
            },
            "nullColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "nullColor",
                "excludes": {},
                "default": "#f7f7f7",
                "description": "The color applied to null points. In styled mode, a general CSS class is\napplied instead."
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "middle"
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "overflow": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "overflow",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "{point.x}, {point.y}: {point.value}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": 0.2,
                        "products": {
                          "highcharts": 1,
                          "highmaps": 1
                        },
                        "description": "How much to brighten the point on interaction. Requires the main\ncolor to be defined in hex or rgb(a) format.\n\nIn styled mode, the hover brightening is by default replaced\nwith a fill-opacity set in the `.highcharts-point:hover` rule."
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "pointPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointPadding",
                "excludes": {},
                "default": "0",
                "description": "Padding between the points in the heatmap."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "The main color of the series. In heat maps this color is rarely used,\nas we mostly use the color to denote the value of each point. Unless\noptions are set in the [colorAxis](#colorAxis), the default value\nis pulled from the [options.colors](#colors) array."
              },
              "subtree": {}
            },
            "colsize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "colsize",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The column size - how many X axis units each column in the heatmap\nshould span."
              },
              "subtree": {}
            },
            "rowsize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rowsize",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The row size - how many Y axis units each heatmap row should span."
              },
              "subtree": {}
            }
          }
        },
        "mapbubble": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "mapbubble",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "A map bubble series is a bubble series laid out on top of a map series,\nwhere each bubble is tied to a specific map area.",
            "extends": "{plotOptions.bubble}"
          },
          "subtree": {
            "animationLimit": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "animationLimit",
                "excludes": {},
                "default": 500
              },
              "subtree": {}
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "{point.name}: {point.z}"
                  },
                  "subtree": {}
                }
              }
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "The main color of the series. This color affects both the fill and\nthe stroke of the bubble. For enhanced control, use `marker` options."
              },
              "subtree": {}
            },
            "displayNegative": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "displayNegative",
                "excludes": {},
                "default": "true",
                "products": {
                  "highmaps": 1
                },
                "description": "Whether to display negative sized bubbles. The threshold is given\nby the [zThreshold](#plotOptions.mapbubble.zThreshold) option, and negative\nbubbles can be visualized by setting [negativeColor](#plotOptions.\nbubble.negativeColor)."
              },
              "subtree": {}
            },
            "maxSize": {
              "meta": {
                "types": {},
                "name": "maxSize",
                "excludes": {},
                "products": {
                  "highmaps": 1
                }
              },
              "subtree": {}
            },
            "minSize": {
              "meta": {
                "types": {},
                "name": "minSize",
                "excludes": {},
                "products": {
                  "highmaps": 1
                }
              },
              "subtree": {}
            },
            "negativeColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "negativeColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highmaps": 1
                },
                "description": "When a point's Z value is below the [zThreshold](#plotOptions.mapbubble.\nzThreshold) setting, this color is used."
              },
              "subtree": {}
            },
            "sizeBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "sizeBy",
                "excludes": {},
                "default": "area",
                "products": {
                  "highmaps": 1
                },
                "description": "Whether the bubble's value should be represented by the area or the\nwidth of the bubble. The default, `area`, corresponds best to the\nhuman perception of the size of each bubble."
              },
              "subtree": {}
            },
            "sizeByAbsoluteValue": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "sizeByAbsoluteValue",
                "excludes": {},
                "default": "false",
                "products": {
                  "highmaps": 1
                },
                "description": "When this is true, the absolute value of z determines the size of\nthe bubble. This means that with the default `zThreshold` of 0, a\nbubble of value -1 will have the same size as a bubble of value 1,\nwhile a bubble of value 0 will have a smaller size according to\n`minSize`."
              },
              "subtree": {}
            },
            "zMax": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMax",
                "excludes": {},
                "default": "null",
                "products": {
                  "highmaps": 1
                },
                "description": "The minimum for the Z value range. Defaults to the highest Z value\nin the data."
              },
              "subtree": {}
            },
            "zMin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zMin",
                "excludes": {},
                "default": "null",
                "products": {
                  "highmaps": 1
                },
                "description": "The minimum for the Z value range. Defaults to the lowest Z value\nin the data."
              },
              "subtree": {}
            },
            "zThreshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zThreshold",
                "excludes": {},
                "default": "0",
                "products": {
                  "highmaps": 1
                },
                "description": "When [displayNegative](#plotOptions.mapbubble.displayNegative) is `false`,\nbubbles with lower Z values are skipped. When `displayNegative`\nis `true` and a [negativeColor](#plotOptions.mapbubble.negativeColor)\nis given, points with lower Z is colored."
              },
              "subtree": {}
            }
          }
        },
        "mapline": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "mapline",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "A mapline series is a special case of the map series where the value colors\nare applied to the strokes rather than the fills. It can also be used for\nfreeform drawing, like dividers, in the map.",
            "extends": "{plotOptions.map}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highmaps": 1
                },
                "description": "The width of the map line."
              },
              "subtree": {}
            },
            "fillColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "fillColor",
                "excludes": {},
                "default": "none",
                "products": {
                  "highmaps": 1
                },
                "description": "Fill color for the map line shapes"
              },
              "subtree": {}
            }
          }
        },
        "mappoint": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "mappoint",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "A mappoint series is a special form of scatter series where the points can\nbe laid out in map coordinates on top of a map.",
            "extends": "plotOptions.scatter"
          },
          "subtree": {
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "defer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "defer",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "overflow": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "overflow",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {}
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#000000"
                      },
                      "subtree": {}
                    }
                  }
                },
                "format": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "format",
                    "excludes": {},
                    "default": "{point.name}"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "map": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "map",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "The map series is used for basic choropleth maps, where each map area has a\ncolor based on its value.",
            "extends": "{plotOptions.scatter}"
          },
          "subtree": {
            "allAreas": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allAreas",
                "excludes": {},
                "default": true
              },
              "subtree": {}
            },
            "animation": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "animation",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "nullColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "nullColor",
                "excludes": {},
                "default": "#f7f7f7",
                "products": {
                  "highmaps": 1
                },
                "description": "The color to apply to null points.\n\nIn styled mode, the null point fill is set in the\n`.highcharts-null-point` class."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#cccccc"
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": 1
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "stickyTracking": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "stickyTracking",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "joinBy": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "joinBy",
                "excludes": {},
                "default": "hc-key"
              },
              "subtree": {}
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {}
              },
              "subtree": {
                "formatter": {
                  "meta": {
                    "types": {},
                    "name": "formatter",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "inside": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "inside",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "middle"
                  },
                  "subtree": {}
                },
                "crop": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "crop",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "overflow": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "overflow",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                }
              }
            },
            "tooltip": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "tooltip",
                "excludes": {}
              },
              "subtree": {
                "followPointer": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "followPointer",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "pointFormat": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pointFormat",
                    "excludes": {},
                    "default": "{point.name}: {point.value}<br/>"
                  },
                  "subtree": {}
                }
              }
            },
            "states": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "states",
                "excludes": {}
              },
              "subtree": {
                "normal": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "normal",
                    "excludes": {}
                  },
                  "subtree": {
                    "animation": {
                      "meta": {
                        "types": {
                          "boolean": 1
                        },
                        "name": "animation",
                        "excludes": {},
                        "default": true
                      },
                      "subtree": {}
                    }
                  }
                },
                "hover": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "hover",
                    "excludes": {}
                  },
                  "subtree": {
                    "halo": {
                      "meta": {
                        "types": {
                          "object": 1
                        },
                        "name": "halo",
                        "excludes": {},
                        "default": null
                      },
                      "subtree": {}
                    },
                    "brightness": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "brightness",
                        "excludes": {},
                        "default": 0.2
                      },
                      "subtree": {}
                    }
                  }
                },
                "select": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "select",
                    "excludes": {}
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#cccccc"
                      },
                      "subtree": {}
                    }
                  }
                }
              }
            },
            "nullInteraction": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "nullInteraction",
                "excludes": {},
                "default": "false",
                "products": {
                  "highmaps": 1
                },
                "description": "Whether to allow pointer interaction like tooltips and mouse events\non null points."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "lang": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "lang",
        "excludes": {},
        "description": "Language object. The language object is global and it can't be set\non each chart initiation. Instead, use `Highcharts.setOptions` to\nset it before any chart is initialized.\n\n<pre>Highcharts.setOptions({\n    lang: {\n        months: [\n            'Janvier', 'Février', 'Mars', 'Avril',\n            'Mai', 'Juin', 'Juillet', 'Août',\n            'Septembre', 'Octobre', 'Novembre', 'Décembre'\n        ],\n        weekdays: [\n            'Dimanche', 'Lundi', 'Mardi', 'Mercredi',\n            'Jeudi', 'Vendredi', 'Samedi'\n        ]\n    }\n});</pre>"
      },
      "subtree": {
        "accessibility": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "accessibility",
            "excludes": {},
            "description": "Configure the accessibility strings in the chart. Requires the \n[accessibility module](//code.highcharts.com/modules/accessibility.\njs) to be loaded. For a description of the module and information\non its features, see [Highcharts Accessibility](http://www.highcharts.\ncom/docs/chart-concepts/accessibility).\n\nFor more dynamic control over the accessibility functionality, see\n[accessibility.pointDescriptionFormatter](accessibility.\npointDescriptionFormatter),\n[accessibility.seriesDescriptionFormatter](accessibility.\nseriesDescriptionFormatter), and\n[accessibility.screenReaderSectionFormatter](accessibility.\nscreenReaderSectionFormatter)."
          },
          "subtree": {
            "screenReaderRegionLabel": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "screenReaderRegionLabel",
                "excludes": {},
                "default": "Chart screen reader information."
              },
              "subtree": {}
            },
            "navigationHint": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "navigationHint",
                "excludes": {},
                "default": "Use regions/landmarks to skip ahead to chart {#plural(numSeries, and navigate between data series,)}"
              },
              "subtree": {}
            },
            "defaultChartTitle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "defaultChartTitle",
                "excludes": {},
                "default": "Chart"
              },
              "subtree": {}
            },
            "longDescriptionHeading": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "longDescriptionHeading",
                "excludes": {},
                "default": "Long description."
              },
              "subtree": {}
            },
            "noDescription": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "noDescription",
                "excludes": {},
                "default": "No description available."
              },
              "subtree": {}
            },
            "structureHeading": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "structureHeading",
                "excludes": {},
                "default": "Structure."
              },
              "subtree": {}
            },
            "viewAsDataTable": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "viewAsDataTable",
                "excludes": {},
                "default": "View as data table."
              },
              "subtree": {}
            },
            "chartHeading": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "chartHeading",
                "excludes": {},
                "default": "Chart graphic."
              },
              "subtree": {}
            },
            "chartContainerLabel": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "chartContainerLabel",
                "excludes": {},
                "default": "Interactive chart. {title}. Use up and down arrows to navigate with most screen readers."
              },
              "subtree": {}
            },
            "rangeSelectorMinInput": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "rangeSelectorMinInput",
                "excludes": {},
                "default": "Select start date."
              },
              "subtree": {}
            },
            "rangeSelectorMaxInput": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "rangeSelectorMaxInput",
                "excludes": {},
                "default": "Select end date."
              },
              "subtree": {}
            },
            "tableSummary": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "tableSummary",
                "excludes": {},
                "default": "Table representation of chart."
              },
              "subtree": {}
            },
            "mapZoomIn": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "mapZoomIn",
                "excludes": {},
                "default": "Zoom chart"
              },
              "subtree": {}
            },
            "mapZoomOut": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "mapZoomOut",
                "excludes": {},
                "default": "Zoom out chart"
              },
              "subtree": {}
            },
            "rangeSelectorButton": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "rangeSelectorButton",
                "excludes": {},
                "default": "Select range {buttonText}"
              },
              "subtree": {}
            },
            "legendItem": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "legendItem",
                "excludes": {},
                "default": "Toggle visibility of series {itemName}"
              },
              "subtree": {}
            },
            "svgContainerTitle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "svgContainerTitle",
                "excludes": {},
                "default": "{chartTitle}",
                "description": "Title element text for the chart SVG element. Leave this\nempty to disable adding the title element. Browsers will display\nthis content when hovering over elements in the chart. Assistive\ntechnology may use this element to label the chart."
              },
              "subtree": {}
            },
            "seriesTypeDescriptions": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "seriesTypeDescriptions",
                "excludes": {},
                "description": "Descriptions of lesser known series types. The relevant\ndescription is added to the screen reader information region\nwhen these series types are used."
              },
              "subtree": {
                "boxplot": {
                  "meta": {
                    "types": {},
                    "name": "boxplot",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "arearange": {
                  "meta": {
                    "types": {},
                    "name": "arearange",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "areasplinerange": {
                  "meta": {
                    "types": {},
                    "name": "areasplinerange",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "bubble": {
                  "meta": {
                    "types": {},
                    "name": "bubble",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "columnrange": {
                  "meta": {
                    "types": {},
                    "name": "columnrange",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "errorbar": {
                  "meta": {
                    "types": {},
                    "name": "errorbar",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "funnel": {
                  "meta": {
                    "types": {},
                    "name": "funnel",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "pyramid": {
                  "meta": {
                    "types": {},
                    "name": "pyramid",
                    "excludes": {}
                  },
                  "subtree": {}
                },
                "waterfall": {
                  "meta": {
                    "types": {},
                    "name": "waterfall",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "chartTypes": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "chartTypes",
                "excludes": {},
                "description": "Chart type description strings. This is added to the chart \ninformation region.\n\nIf there is only a single series type used in the chart, we use\nthe format string for the series type, or default if missing.\nThere is one format string for cases where there is only a single\nseries in the chart, and one for multiple series of the same\ntype."
              },
              "subtree": {
                "emptyChart": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "emptyChart",
                    "excludes": {},
                    "default": "Empty chart"
                  },
                  "subtree": {}
                },
                "mapTypeDescription": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "mapTypeDescription",
                    "excludes": {},
                    "default": "Map of {mapTitle} with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "unknownMap": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "unknownMap",
                    "excludes": {},
                    "default": "Map of unspecified region with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "combinationChart": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "combinationChart",
                    "excludes": {},
                    "default": "Combination chart with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "defaultSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "defaultSingle",
                    "excludes": {},
                    "default": "Chart with {numPoints} data {#plural(numPoints, points, point)}."
                  },
                  "subtree": {}
                },
                "defaultMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "defaultMultiple",
                    "excludes": {},
                    "default": "Chart with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "splineSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "splineSingle",
                    "excludes": {},
                    "default": "Line chart with {numPoints} data {#plural(numPoints, points, point)}."
                  },
                  "subtree": {}
                },
                "splineMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "splineMultiple",
                    "excludes": {},
                    "default": "Line chart with {numSeries} lines."
                  },
                  "subtree": {}
                },
                "lineSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "lineSingle",
                    "excludes": {},
                    "default": "Line chart with {numPoints} data {#plural(numPoints, points, point)}."
                  },
                  "subtree": {}
                },
                "lineMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "lineMultiple",
                    "excludes": {},
                    "default": "Line chart with {numSeries} lines."
                  },
                  "subtree": {}
                },
                "columnSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "columnSingle",
                    "excludes": {},
                    "default": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}."
                  },
                  "subtree": {}
                },
                "columnMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "columnMultiple",
                    "excludes": {},
                    "default": "Bar chart with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "barSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "barSingle",
                    "excludes": {},
                    "default": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}."
                  },
                  "subtree": {}
                },
                "barMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "barMultiple",
                    "excludes": {},
                    "default": "Bar chart with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "pieSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pieSingle",
                    "excludes": {},
                    "default": "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}."
                  },
                  "subtree": {}
                },
                "pieMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "pieMultiple",
                    "excludes": {},
                    "default": "Pie chart with {numSeries} pies."
                  },
                  "subtree": {}
                },
                "scatterSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "scatterSingle",
                    "excludes": {},
                    "default": "Scatter chart with {numPoints} {#plural(numPoints, points, point)}."
                  },
                  "subtree": {}
                },
                "scatterMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "scatterMultiple",
                    "excludes": {},
                    "default": "Scatter chart with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "boxplotSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "boxplotSingle",
                    "excludes": {},
                    "default": "Boxplot with {numPoints} {#plural(numPoints, boxes, box)}."
                  },
                  "subtree": {}
                },
                "boxplotMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "boxplotMultiple",
                    "excludes": {},
                    "default": "Boxplot with {numSeries} data series."
                  },
                  "subtree": {}
                },
                "bubbleSingle": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "bubbleSingle",
                    "excludes": {},
                    "default": "Bubble chart with {numPoints} {#plural(numPoints, bubbles, bubble)}."
                  },
                  "subtree": {}
                },
                "bubbleMultiple": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "bubbleMultiple",
                    "excludes": {},
                    "default": "Bubble chart with {numSeries} data series."
                  },
                  "subtree": {}
                }
              }
            },
            "axis": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "axis",
                "excludes": {},
                "description": "Axis description format strings."
              },
              "subtree": {
                "xAxisDescriptionSingular": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "xAxisDescriptionSingular",
                    "excludes": {},
                    "default": "The chart has 1 X axis displaying {names[0]}."
                  },
                  "subtree": {}
                },
                "xAxisDescriptionPlural": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "xAxisDescriptionPlural",
                    "excludes": {},
                    "default": "The chart has {numAxes} X axes displaying {#each(names, -1), }and {names[-1]}"
                  },
                  "subtree": {}
                },
                "yAxisDescriptionSingular": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "yAxisDescriptionSingular",
                    "excludes": {},
                    "default": "The chart has 1 Y axis displaying {names[0]}."
                  },
                  "subtree": {}
                },
                "yAxisDescriptionPlural": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "yAxisDescriptionPlural",
                    "excludes": {},
                    "default": "The chart has {numAxes} Y axes displaying {#each(names, -1), }and {names[-1]}"
                  },
                  "subtree": {}
                }
              }
            },
            "exporting": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "exporting",
                "excludes": {},
                "description": "Exporting menu format strings for accessibility module."
              },
              "subtree": {
                "chartMenuLabel": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "chartMenuLabel",
                    "excludes": {},
                    "default": "Chart export"
                  },
                  "subtree": {}
                },
                "menuButtonLabel": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "menuButtonLabel",
                    "excludes": {},
                    "default": "View export menu"
                  },
                  "subtree": {}
                },
                "exportRegionLabel": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "exportRegionLabel",
                    "excludes": {},
                    "default": "Chart export menu"
                  },
                  "subtree": {}
                }
              }
            },
            "series": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "series",
                "excludes": {},
                "description": "Lang configuration for different series types. For more dynamic\ncontrol over the series element descriptions, see\n[accessibility.seriesDescriptionFormatter](accessibility.\nseriesDescriptionFormatter)."
              },
              "subtree": {
                "summary": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "summary",
                    "excludes": {},
                    "description": "Lang configuration for the series main summary. Each series\ntype has two modes:\n\t1. This series type is the only series type used in the\n\t\tchart\n\t2. This is a combination chart with multiple series types\n\nIf a definition does not exist for the specific series type\nand mode, the 'default' lang definitions are used."
                  },
                  "subtree": {
                    "default": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "default",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "defaultCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "defaultCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "line": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "line",
                        "excludes": {},
                        "default": "{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "lineCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "lineCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "spline": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "spline",
                        "excludes": {},
                        "default": "{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "splineCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "splineCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "column": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "column",
                        "excludes": {},
                        "default": "{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}."
                      },
                      "subtree": {}
                    },
                    "columnCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "columnCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}."
                      },
                      "subtree": {}
                    },
                    "bar": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "bar",
                        "excludes": {},
                        "default": "{name}, bar series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bars, bar)}."
                      },
                      "subtree": {}
                    },
                    "barCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "barCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Bar series with {numPoints} {#plural(numPoints, bars, bar)}."
                      },
                      "subtree": {}
                    },
                    "pie": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "pie",
                        "excludes": {},
                        "default": "{name}, pie {ix} of {numSeries} with {numPoints} {#plural(numPoints, slices, slice)}."
                      },
                      "subtree": {}
                    },
                    "pieCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "pieCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Pie with {numPoints} {#plural(numPoints, slices, slice)}."
                      },
                      "subtree": {}
                    },
                    "scatter": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "scatter",
                        "excludes": {},
                        "default": "{name}, scatter plot {ix} of {numSeries} with {numPoints} {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "scatterCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "scatterCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}, scatter plot with {numPoints} {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "boxplot": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "boxplot",
                        "excludes": {},
                        "default": "{name}, boxplot {ix} of {numSeries} with {numPoints} {#plural(numPoints, boxes, box)}."
                      },
                      "subtree": {}
                    },
                    "boxplotCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "boxplotCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Boxplot with {numPoints} {#plural(numPoints, boxes, box)}."
                      },
                      "subtree": {}
                    },
                    "bubble": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "bubble",
                        "excludes": {},
                        "default": "{name}, bubble series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bubbles, bubble)}."
                      },
                      "subtree": {}
                    },
                    "bubbleCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "bubbleCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Bubble series with {numPoints} {#plural(numPoints, bubbles, bubble)}."
                      },
                      "subtree": {}
                    },
                    "map": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "map",
                        "excludes": {},
                        "default": "{name}, map {ix} of {numSeries} with {numPoints} {#plural(numPoints, areas, area)}."
                      },
                      "subtree": {}
                    },
                    "mapCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "mapCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Map with {numPoints} {#plural(numPoints, areas, area)}."
                      },
                      "subtree": {}
                    },
                    "mapline": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "mapline",
                        "excludes": {},
                        "default": "{name}, line {ix} of {numSeries} with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "maplineCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "maplineCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Line with {numPoints} data {#plural(numPoints, points, point)}."
                      },
                      "subtree": {}
                    },
                    "mapbubble": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "mapbubble",
                        "excludes": {},
                        "default": "{name}, bubble series {ix} of {numSeries} with {numPoints} {#plural(numPoints, bubbles, bubble)}."
                      },
                      "subtree": {}
                    },
                    "mapbubbleCombination": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "mapbubbleCombination",
                        "excludes": {},
                        "default": "{name}, series {ix} of {numSeries}. Bubble series with {numPoints} {#plural(numPoints, bubbles, bubble)}."
                      },
                      "subtree": {}
                    }
                  }
                },
                "description": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "description",
                    "excludes": {},
                    "default": "{description}",
                    "description": "User supplied description text. This is added after the main\nsummary if present."
                  },
                  "subtree": {}
                },
                "xAxisDescription": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "xAxisDescription",
                    "excludes": {},
                    "default": "X axis, {name}",
                    "description": "xAxis description for series if there are multiple xAxes in\nthe chart."
                  },
                  "subtree": {}
                },
                "yAxisDescription": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "yAxisDescription",
                    "excludes": {},
                    "default": "Y axis, {name}",
                    "description": "yAxis description for series if there are multiple yAxes in\nthe chart."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "drillUpText": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "drillUpText",
            "excludes": {},
            "default": "Back to {series.name}",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The text for the button that appears when drilling down, linking\nback to the parent series. The parent series' name is inserted for\n`{series.name}`."
          },
          "subtree": {}
        },
        "downloadCSV": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadCSV",
            "excludes": {},
            "default": "Download CSV",
            "description": "Export-data module only. The text for the menu item."
          },
          "subtree": {}
        },
        "downloadXLS": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadXLS",
            "excludes": {},
            "default": "Download XLS",
            "description": "Export-data module only. The text for the menu item."
          },
          "subtree": {}
        },
        "viewData": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "viewData",
            "excludes": {},
            "default": "View data table",
            "description": "Export-data module only. The text for the menu item."
          },
          "subtree": {}
        },
        "printChart": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "printChart",
            "excludes": {},
            "default": "Print chart",
            "description": "Exporting module only. The text for the menu item to print the chart."
          },
          "subtree": {}
        },
        "downloadPNG": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadPNG",
            "excludes": {},
            "default": "Download PNG image",
            "description": "Exporting module only. The text for the PNG download menu item."
          },
          "subtree": {}
        },
        "downloadJPEG": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadJPEG",
            "excludes": {},
            "default": "Download JPEG image",
            "description": "Exporting module only. The text for the JPEG download menu item."
          },
          "subtree": {}
        },
        "downloadPDF": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadPDF",
            "excludes": {},
            "default": "Download PDF document",
            "description": "Exporting module only. The text for the PDF download menu item."
          },
          "subtree": {}
        },
        "downloadSVG": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "downloadSVG",
            "excludes": {},
            "default": "Download SVG vector image",
            "description": "Exporting module only. The text for the SVG download menu item."
          },
          "subtree": {}
        },
        "contextButtonTitle": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "contextButtonTitle",
            "excludes": {},
            "default": "Chart context menu",
            "description": "Exporting module menu. The tooltip title for the context menu holding\nprint and export menu items."
          },
          "subtree": {}
        },
        "noData": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "noData",
            "excludes": {},
            "default": "No data to display",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The text to display when the chart contains no data. Requires the\nno-data module, see [noData](#noData)."
          },
          "subtree": {}
        },
        "loading": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "loading",
            "excludes": {},
            "default": "Loading...",
            "description": "The loading text that appears when the chart is set into the loading\nstate following a call to `chart.showLoading`."
          },
          "subtree": {}
        },
        "months": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "months",
            "excludes": {},
            "default": "[ \"January\" , \"February\" , \"March\" , \"April\" , \"May\" ,\n         \"June\" , \"July\" , \"August\" , \"September\" , \"October\" ,\n         \"November\" , \"December\"]",
            "description": "An array containing the months names. Corresponds to the `%B` format\nin `Highcharts.dateFormat()`."
          },
          "subtree": {}
        },
        "shortMonths": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "shortMonths",
            "excludes": {},
            "default": "[ \"Jan\" , \"Feb\" , \"Mar\" , \"Apr\" , \"May\" , \"Jun\" ,\n         \"Jul\" , \"Aug\" , \"Sep\" , \"Oct\" , \"Nov\" , \"Dec\"]",
            "description": "An array containing the months names in abbreviated form. Corresponds\nto the `%b` format in `Highcharts.dateFormat()`."
          },
          "subtree": {}
        },
        "weekdays": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "weekdays",
            "excludes": {},
            "default": "[\"Sunday\", \"Monday\", \"Tuesday\", \"Wednesday\", \"Thursday\",\n         \"Friday\", \"Saturday\"]",
            "description": "An array containing the weekday names."
          },
          "subtree": {}
        },
        "decimalPoint": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "decimalPoint",
            "excludes": {},
            "default": ".",
            "description": "The default decimal point used in the `Highcharts.numberFormat`\nmethod unless otherwise specified in the function arguments."
          },
          "subtree": {}
        },
        "numericSymbols": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "numericSymbols",
            "excludes": {},
            "default": "[ \"k\" , \"M\" , \"G\" , \"T\" , \"P\" , \"E\"]",
            "description": "[Metric prefixes](http://en.wikipedia.org/wiki/Metric_prefix) used\nto shorten high numbers in axis labels. Replacing any of the positions\nwith `null` causes the full number to be written. Setting `numericSymbols`\nto `null` disables shortening altogether."
          },
          "subtree": {}
        },
        "resetZoom": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "resetZoom",
            "excludes": {},
            "default": "Reset zoom",
            "description": "The text for the label appearing when a chart is zoomed."
          },
          "subtree": {}
        },
        "resetZoomTitle": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "resetZoomTitle",
            "excludes": {},
            "default": "Reset zoom level 1:1",
            "description": "The tooltip title for the label appearing when a chart is zoomed."
          },
          "subtree": {}
        },
        "thousandsSep": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "thousandsSep",
            "excludes": {},
            "default": " ",
            "description": "The default thousands separator used in the `Highcharts.numberFormat`\nmethod unless otherwise specified in the function arguments. Since\nHighcharts 4.1 it defaults to a single space character, which is\ncompatible with ISO and works across Anglo-American and continental\nEuropean languages.\n\nThe default is a single space."
          },
          "subtree": {}
        },
        "shortWeekdays": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "shortWeekdays",
            "excludes": {},
            "description": "Short week days, starting Sunday. If not specified, Highcharts uses\nthe first three letters of the `lang.weekdays` option."
          },
          "subtree": {}
        },
        "invalidDate": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "invalidDate",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "What to show in a date field for invalid dates. Defaults to an empty\nstring."
          },
          "subtree": {}
        },
        "numericSymbolMagnitude": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "numericSymbolMagnitude",
            "excludes": {},
            "default": "1000",
            "description": "The magnitude of [numericSymbols](#lang.numericSymbol) replacements.\nUse 10000 for Japanese, Korean and various Chinese locales, which\nuse symbols for 10^4, 10^8 and 10^12."
          },
          "subtree": {}
        },
        "rangeSelectorZoom": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "rangeSelectorZoom",
            "excludes": {},
            "default": "Zoom",
            "products": {
              "highstock": 1
            },
            "description": "The text for the label for the range selector buttons."
          },
          "subtree": {}
        },
        "rangeSelectorFrom": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "rangeSelectorFrom",
            "excludes": {},
            "default": "From",
            "products": {
              "highstock": 1
            },
            "description": "The text for the label for the \"from\" input box in the range\nselector."
          },
          "subtree": {}
        },
        "rangeSelectorTo": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "rangeSelectorTo",
            "excludes": {},
            "default": "To",
            "products": {
              "highstock": 1
            },
            "description": "The text for the label for the \"to\" input box in the range selector."
          },
          "subtree": {}
        },
        "zoomIn": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "zoomIn",
            "excludes": {},
            "default": "Zoom in",
            "products": {
              "highmaps": 1
            },
            "description": "The title appearing on hovering the zoom in button. The text itself\ndefaults to \"+\" and can be changed in the button options."
          },
          "subtree": {}
        },
        "zoomOut": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "zoomOut",
            "excludes": {},
            "default": "Zoom out",
            "products": {
              "highmaps": 1
            },
            "description": "The title appearing on hovering the zoom out button. The text itself\ndefaults to \"-\" and can be changed in the button options."
          },
          "subtree": {}
        }
      }
    },
    "defs": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "defs",
        "excludes": {},
        "description": "Styled mode only. Configuration object for adding SVG definitions for\nreusable elements. See [gradients, shadows and patterns](http://www.\nhighcharts.com/docs/chart-design-and-style/gradients-shadows-and-\npatterns) for more information and code examples."
      },
      "subtree": {}
    },
    "annotations": {
      "meta": {
        "types": {
          "array": "Object"
        },
        "name": "annotations",
        "excludes": {},
        "description": "Options for configuring annotations, for example labels, arrows or \nshapes. Annotations can be tied to points, axis coordinates or chart\npixel coordinates."
      },
      "subtree": {
        "visible": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "visible",
            "excludes": {},
            "default": true,
            "description": "Whether the annotation is visible."
          },
          "subtree": {}
        },
        "labelOptions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "labelOptions",
            "excludes": {},
            "description": "Options for annotation's labels. Each label inherits options\nfrom the labelOptions object. An option from the labelOptions can be\noverwritten by config for a specific label."
          },
          "subtree": {
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "center",
                "description": "The alignment of the annotation's label. If right,\nthe right side of the label should be touching the point."
              },
              "subtree": {}
            },
            "allowOverlap": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowOverlap",
                "excludes": {},
                "default": false,
                "description": "Whether to allow the annotation's labels to overlap.\nTo make the labels less sensitive for overlapping, \nthe can be set to 0."
              },
              "subtree": {}
            },
            "backgroundColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "backgroundColor",
                "excludes": {},
                "default": "rgba(0, 0, 0, 0.75)",
                "description": "The background color or gradient for the annotation's label."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "black",
                "description": "The border color for the annotation's label."
              },
              "subtree": {}
            },
            "borderRadius": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderRadius",
                "excludes": {},
                "default": 3,
                "description": "The border radius in pixels for the annotaiton's label."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": 1,
                "description": "The border width in pixels for the annotation's label"
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "default": "",
                "description": "A class name for styling by CSS."
              },
              "subtree": {}
            },
            "crop": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "crop",
                "excludes": {},
                "default": false,
                "description": "Whether to hide the annotation's label that is outside the plot\narea."
              },
              "subtree": {}
            },
            "formatter": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "formatter",
                "excludes": {},
                "default": "function () {\n\treturn defined(this.y) ? this.y : 'Annotation label';\n}\n*",
                "description": "Callback JavaScript function to format the annotation's label.\nNote that if a `format` or `text` are defined, the format or text\ntake precedence and the formatter is ignored. `This` refers to a\npoint object."
              },
              "subtree": {}
            },
            "overflow": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "overflow",
                "excludes": {},
                "default": "justify",
                "description": "How to handle the annotation's label that flow outside the plot\narea. The justify option aligns the label inside the plot area."
              },
              "subtree": {}
            },
            "padding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "padding",
                "excludes": {},
                "default": 5,
                "description": "When either the borderWidth or the backgroundColor is set,\nthis\tis the padding within the box."
              },
              "subtree": {}
            },
            "shadow": {
              "meta": {
                "types": {
                  "boolean": 1,
                  "object": 1
                },
                "name": "shadow",
                "excludes": {},
                "default": false,
                "description": "The shadow of the box. The shadow can be an object configuration\ncontaining `color`, `offsetX`, `offsetY`, `opacity` and `width`."
              },
              "subtree": {}
            },
            "shape": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "shape",
                "excludes": {},
                "default": "callout",
                "description": "The name of a symbol to use for the border around the label.\nSymbols are predefined functions on the Renderer object."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "description": "Styles for the annotation's label."
              },
              "subtree": {
                "fontSize": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontSize",
                    "excludes": {},
                    "default": "11px"
                  },
                  "subtree": {}
                },
                "fontWeight": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "normal"
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "default": "contrast"
                  },
                  "subtree": {}
                }
              }
            },
            "useHTML": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "useHTML",
                "excludes": {},
                "default": "false\n*",
                "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)\nto render the annotation's label."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "default": "bottom",
                "description": "The vertical alignment of the annotation's label."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": 0,
                "description": "The x position offset of the label relative to the point.\nNote that if a `distance` is defined, the distance takes\nprecedence over `x` and `y` options."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": -16,
                "description": "The y position offset of the label relative to the point.\nNote that if a `distance` is defined, the distance takes\nprecedence over `x` and `y` options."
              },
              "subtree": {}
            },
            "distance": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "distance",
                "excludes": {},
                "default": "undefined",
                "description": "The label's pixel distance from the point."
              },
              "subtree": {}
            },
            "format": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "format",
                "excludes": {},
                "default": "undefined",
                "description": "A [format](https://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting) string for the data label."
              },
              "subtree": {}
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "default": "undefined",
                "description": "Alias for the format option."
              },
              "subtree": {}
            }
          }
        },
        "shapeOptions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "shapeOptions",
            "excludes": {},
            "description": "Options for annotation's shapes. Each shape inherits options\nfrom the shapeOptions object. An option from the shapeOptions can be\noverwritten by config for a specific shape."
          },
          "subtree": {
            "stroke": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "stroke",
                "excludes": {},
                "default": "rgba(0, 0, 0, 0.75)",
                "description": "The color of the shape's stroke."
              },
              "subtree": {}
            },
            "strokeWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "strokeWidth",
                "excludes": {},
                "default": 1,
                "description": "The pixel stroke width of the shape."
              },
              "subtree": {}
            },
            "fill": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "fill",
                "excludes": {},
                "default": "rgba(0, 0, 0, 0.75)",
                "description": "The color of the shape's fill."
              },
              "subtree": {}
            },
            "r": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "r",
                "excludes": {},
                "default": 0,
                "description": "The radius of the shape."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "description": "The width of the shape."
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "height",
                "excludes": {},
                "description": "The height of the shape."
              },
              "subtree": {}
            },
            "type": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "type",
                "excludes": {},
                "default": "'rect'",
                "description": "The type of the shape, e.g. circle or rectangle."
              },
              "subtree": {}
            }
          }
        },
        "zIndex": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "zIndex",
            "excludes": {},
            "default": "6\n*",
            "description": "The Z index of the annotation."
          },
          "subtree": {}
        },
        "labels": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "labels",
            "excludes": {},
            "description": "An array of labels for the annotation. For options that apply to\nmultiple labels, they can be added to the\n[labelOptions](annotations.labelOptions.html).",
            "extends": "annotations.labelOptions"
          },
          "subtree": {
            "point": {
              "meta": {
                "types": {
                  "string": 1,
                  "object": 1
                },
                "name": "point",
                "excludes": {},
                "description": "This option defines the point to which the label will be connected.\nIt can be either the point which exists in the series - it is\nreferenced by the point's id - or a new point with defined x, y\nproperies and optionally axes."
              },
              "subtree": {
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "description": "The x position of the point. Units can be either in axis \nor chart pixel coordinates."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "description": "The y position of the point. Units can be either in axis\nor chart pixel coordinates."
                  },
                  "subtree": {}
                },
                "xAxis": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "xAxis",
                    "excludes": {},
                    "description": "This number defines which xAxis the point is connected to. It refers\nto either the axis id or the index of the axis in the xAxis array.\nIf the option is not configured or the axis is not found the point's\nx coordinate refers to the chart pixels."
                  },
                  "subtree": {}
                },
                "yAxis": {
                  "meta": {
                    "types": {
                      "number": 1,
                      "string": 1
                    },
                    "name": "yAxis",
                    "excludes": {},
                    "description": "This number defines which yAxis the point is connected to. It refers\nto either the axis id or the index of the axis in the yAxis array.\nIf the option is not configured or the axis is not found the point's\ny coordinate refers to the chart pixels."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "shapes": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "shapes",
            "excludes": {},
            "description": "An array of shapes for the annotation. For options that apply to\nmultiple shapes, then can be added to the\n[shapeOptions](annotations.shapeOptions.html).",
            "extends": "annotations.shapeOptions"
          },
          "subtree": {
            "point": {
              "meta": {
                "types": {
                  "string": 1,
                  "object": 1
                },
                "name": "point",
                "excludes": {},
                "description": "This option defines the point to which the shape will be connected.\nIt can be either the point which exists in the series - it is\nreferenced by the point's id - or a new point with defined x, y\nproperties and optionally axes.",
                "extends": "annotations.labels.point"
              },
              "subtree": {}
            },
            "points": {
              "meta": {
                "types": {
                  "array": "object"
                },
                "name": "points",
                "excludes": {},
                "description": "An array of points for the shape. This option is available for shapes\nwhich can use multiple points such as path. A point can be either \na point object or a point's id."
              },
              "subtree": {}
            },
            "markerEnd": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "markerEnd",
                "excludes": {},
                "description": "Id of the marker which will be drawn at the final vertex of the path.\nCustom markers can be defined in defs property."
              },
              "subtree": {}
            },
            "markerStart": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "markerStart",
                "excludes": {},
                "description": "Id of the marker which will be drawn at the first vertex of the path.\nCustom markers can be defined in defs property."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "boost": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "boost",
        "excludes": {},
        "products": {
          "highcharts": 1,
          "highstock": 1
        },
        "description": "Options for the Boost module. The Boost module allows certain series types\nto be rendered by WebGL instead of the default SVG. This allows hundreds of\nthousands of data points to be rendered in milliseconds. In addition to the\nWebGL rendering it saves time by skipping processing and inspection of the\ndata wherever possible. This introduces some limitations to what features are\navailable in Boost mode. See [the docs](https://www.highcharts.com/docs/advanced-chart-features/boost-module)\nfor details.\n\nIn addition to the global `boost` option, each series has a\n[boostThreshold](#plotOptions.series.boostThreshold) that defines when the\nboost should kick in.\n\nRequires the `modules/boost.js` module."
      },
      "subtree": {
        "seriesThreshold": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "seriesThreshold",
            "excludes": {},
            "default": "null",
            "description": "Set the series threshold for when the boost should kick in globally.\n\nSetting to e.g. 20 will cause the whole chart to enter boost mode\nif there are 20 or more series active. When the chart is in boost mode,\nevery series in it will be rendered to a common canvas. This offers\na significant speed improvment in charts with a very high\namount of series."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "description": "Enable or disable boost on a chart."
          },
          "subtree": {}
        },
        "debug": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "debug",
            "excludes": {},
            "description": "Debugging options for boost.\nUseful for benchmarking, and general timing."
          },
          "subtree": {
            "timeRendering": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "timeRendering",
                "excludes": {},
                "default": "false",
                "description": "Time the series rendering.\n\nThis outputs the time spent on actual rendering in the console when\nset to true."
              },
              "subtree": {}
            },
            "timeSeriesProcessing": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "timeSeriesProcessing",
                "excludes": {},
                "default": "false",
                "description": "Time the series processing.\n\nThis outputs the time spent on transforming the series data to\nvertex buffers when set to true."
              },
              "subtree": {}
            },
            "timeSetup": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "timeSetup",
                "excludes": {},
                "default": "false",
                "description": "Time the the WebGL setup.\n\nThis outputs the time spent on setting up the WebGL context,\ncreating shaders, and textures."
              },
              "subtree": {}
            },
            "timeKDTree": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "timeKDTree",
                "excludes": {},
                "default": "false",
                "description": "Time the building of the k-d tree.\n\nThis outputs the time spent building the k-d tree used for\nmarkers etc.\n\nNote that the k-d tree is built async, and runs post-rendering.\nFollowing, it does not affect the performance of the rendering itself."
              },
              "subtree": {}
            },
            "showSkipSummary": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showSkipSummary",
                "excludes": {},
                "default": "false",
                "description": "Show the number of points skipped through culling.\n\nWhen set to true, the number of points skipped in series processing\nis outputted. Points are skipped if they are closer than 1 pixel from\neach other."
              },
              "subtree": {}
            },
            "timeBufferCopy": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "timeBufferCopy",
                "excludes": {},
                "default": "false",
                "description": "Time the WebGL to SVG buffer copy\n\nAfter rendering, the result is copied to an image which is injected\ninto the SVG.\n\nIf this property is set to true, the time it takes for the buffer copy\nto complete is outputted."
              },
              "subtree": {}
            }
          }
        },
        "useGPUTranslations": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useGPUTranslations",
            "excludes": {},
            "default": "false",
            "description": "Enable or disable GPU translations. GPU translations are faster than doing\nthe translation in JavaScript.\n\nThis option may cause rendering issues with certain datasets.\nNamely, if your dataset has large numbers with small increments (such as\ntimestamps), it won't work correctly. This is due to floating point\nprecission."
          },
          "subtree": {}
        },
        "allowForce": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allowForce",
            "excludes": {},
            "default": "true",
            "description": "If set to true, the whole chart will be boosted if one of the series\ncrosses its threshold, and all the series can be boosted."
          },
          "subtree": {}
        }
      }
    },
    "yAxis": {
      "meta": {
        "types": {
          "array": "yAxis"
        },
        "name": "yAxis",
        "excludes": {},
        "description": "The Y axis or value axis. Normally this is the vertical axis,\nthough if the chart is inverted this is the horizontal axis.\nIn case of multiple axes, the yAxis node is an array of\nconfiguration objects.\n\nSee [the Axis object](#Axis) for programmatic access to the axis.",
        "extends": "xAxis"
      },
      "subtree": {
        "minLength": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "minLength",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Minimal size of a resizable axis. Could be set as a percent\nof plot area or pixel size.\n\nThis feature requires the `drag-panes.js` module."
          },
          "subtree": {}
        },
        "maxLength": {
          "meta": {
            "types": {
              "string": 1,
              "number": 1
            },
            "name": "maxLength",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Maximal size of a resizable axis. Could be set as a percent\nof plot area or pixel size.\n\nThis feature requires the `drag-panes.js` module."
          },
          "subtree": {}
        },
        "resize": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "resize",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Options for axis resizing. This feature requires the\n`drag-panes.js` -\n[classic](http://code.highcharts.com/stock/modules/drag-panes.js) or\n[styled](http://code.highcharts.com/stock/js/modules/drag-panes.js)\nmode - module."
          },
          "subtree": {
            "controlledAxis": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "controlledAxis",
                "excludes": {},
                "description": "Contains two arrays of axes that are controlled by control line\nof the axis.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {
                "next": {
                  "meta": {
                    "types": {
                      "array": "(String|Number)"
                    },
                    "name": "next",
                    "excludes": {},
                    "default": "[]",
                    "description": "Array of axes that should move out of the way of resizing\nbeing done for the current axis. If not set, the next axis\nwill be used.\n\nThis feature requires the `drag-panes.js` module."
                  },
                  "subtree": {}
                },
                "prev": {
                  "meta": {
                    "types": {
                      "array": "(String|Number)"
                    },
                    "name": "prev",
                    "excludes": {},
                    "description": "Array of axes that should move with the current axis\nwhile resizing.\n\nThis feature requires the `drag-panes.js` module."
                  },
                  "subtree": {}
                }
              }
            },
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": false,
                "description": "Enable or disable resize by drag for the axis.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "default": "ns-resize",
                "description": "Cursor style for the control line.\n\nIn styled mode use class `highcharts-axis-resizer` instead.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": "#cccccc",
                "description": "Color of the control line.\n\nIn styled mode use class `highcharts-axis-resizer` instead.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "lineDashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "lineDashStyle",
                "excludes": {},
                "default": "Solid",
                "description": "Dash style of the control line.\n\nIn styled mode use class `highcharts-axis-resizer` instead.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 4,
                "description": "Width of the control line.\n\nIn styled mode use class `highcharts-axis-resizer` instead.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": 0,
                "description": "Horizontal offset of the control line.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": 0,
                "description": "Vertical offset of the control line.\n\nThis feature requires the `drag-panes.js` module."
              },
              "subtree": {}
            }
          }
        },
        "tooltipValueFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "tooltipValueFormat",
            "excludes": {},
            "default": "undefined",
            "description": "Parallel coordinates only. Format that will be used for point.y\nand available in [tooltip.pointFormat](#tooltip.pointFormat) as\n`{point.formattedValue}`. If not set, `{point.formattedValue}`\nwill use other options, in this order:\n\n1. [yAxis.labels.format](#yAxis.labels.format) will be used if\n   set\n2. if yAxis is a category, then category name will be displayed\n3. if yAxis is a datetime, then value will use the same format as\n   yAxis labels\n4. if yAxis is linear/logarithmic type, then simple value will be\n   used"
          },
          "subtree": {}
        },
        "endOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "endOnTick",
            "excludes": {},
            "default": true
          },
          "subtree": {}
        },
        "tickPixelInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickPixelInterval",
            "excludes": {},
            "default": 72
          },
          "subtree": {}
        },
        "showLastLabel": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showLastLabel",
            "excludes": {},
            "default": true
          },
          "subtree": {}
        },
        "labels": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "labels",
            "excludes": {},
            "extends": "xAxis.labels"
          },
          "subtree": {
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": -8,
                "description": "The x position offset of the label relative to the tick position\non the axis. Defaults to -15 for left axis, 15 for right axis."
              },
              "subtree": {}
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "description": "What part of the string the given position is anchored to. Can\nbe one of `\"left\"`, `\"center\"` or `\"right\"`. The exact position\nalso depends on the `labels.x` setting.\n\nAngular gauges and solid gauges defaults to `center`."
              },
              "subtree": {}
            },
            "distance": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "distance",
                "excludes": {},
                "default": "-25",
                "products": {
                  "highcharts": 1
                },
                "description": "Angular gauges and solid gauges only. The label's pixel distance\nfrom the perimeter of the plot area."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "description": "The y position offset of the label relative to the tick position\non the axis."
              },
              "subtree": {}
            }
          }
        },
        "maxPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxPadding",
            "excludes": {},
            "default": 0.05,
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Padding of the max value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer. This is useful\nwhen you don't want the highest data value to appear on the edge\nof the plot area. When the axis' `max` option is set or a max extreme\nis set using `axis.setExtremes()`, the maxPadding will be ignored."
          },
          "subtree": {}
        },
        "minPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minPadding",
            "excludes": {},
            "default": 0.05,
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Padding of the min value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer. This is useful\nwhen you don't want the lowest data value to appear on the edge\nof the plot area. When the axis' `min` option is set or a max extreme\nis set using `axis.setExtremes()`, the maxPadding will be ignored."
          },
          "subtree": {}
        },
        "startOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "startOnTick",
            "excludes": {},
            "default": true,
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Whether to force the axis to start on a tick. Use this option with\nthe `maxPadding` option to control the axis start."
          },
          "subtree": {}
        },
        "title": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "title",
            "excludes": {},
            "extends": "xAxis.title"
          },
          "subtree": {
            "rotation": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rotation",
                "excludes": {},
                "default": 270,
                "description": "The rotation of the text in degrees. 0 is horizontal, 270 is\nvertical reading from bottom to top."
              },
              "subtree": {}
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "default": "Values",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The actual text of the axis title. Horizontal texts can contain\nHTML, but rotated texts are painted using vector techniques and\nmust be clean text. The Y axis title is disabled by setting the\n`text` option to `null`."
              },
              "subtree": {}
            },
            "margin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "margin",
                "excludes": {},
                "default": "40",
                "description": "The pixel distance between the axis labels and the title. Positive\nvalues are outside the axis line, negative are inside."
              },
              "subtree": {}
            }
          }
        },
        "stackLabels": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "stackLabels",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "The stack labels show the total value for each bar in a stacked\ncolumn or bar chart. The label will be placed on top of positive\ncolumns and below negative columns. In case of an inverted column\nchart or a bar chart the label is placed to the right of positive\nbars and to the left of negative bars."
          },
          "subtree": {
            "allowOverlap": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "allowOverlap",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "Allow the stack labels to overlap."
              },
              "subtree": {}
            },
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "Enable or disable the stack total labels."
              },
              "subtree": {}
            },
            "formatter": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "formatter",
                "excludes": {},
                "default": "function() { return this.total; }",
                "products": {
                  "highcharts": 1
                },
                "description": "Callback JavaScript function to format the label. The value is\ngiven by `this.total`."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "CSS styles for the label.\n\nIn styled mode, the styles are set in the\n`.highcharts-stack-label` class."
              },
              "subtree": {
                "fontSize": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontSize",
                    "excludes": {},
                    "default": "11px"
                  },
                  "subtree": {}
                },
                "fontWeight": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "bold"
                  },
                  "subtree": {}
                },
                "color": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "default": "#000000"
                  },
                  "subtree": {}
                },
                "textOutline": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "textOutline",
                    "excludes": {},
                    "default": "1px contrast"
                  },
                  "subtree": {}
                }
              }
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Defines the horizontal alignment of the stack total label. Can be\none of `\"left\"`, `\"center\"` or `\"right\"`. The default value is calculated\nat runtime and depends on orientation and whether the stack is positive\nor negative."
              },
              "subtree": {}
            },
            "format": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "format",
                "excludes": {},
                "default": "{total}",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A [format string](http://docs.highcharts.com/#formatting) for the\ndata label. Available variables are the same as for `formatter`."
              },
              "subtree": {}
            },
            "rotation": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rotation",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "Rotation of the labels in degrees."
              },
              "subtree": {}
            },
            "textAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textAlign",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The text alignment for the label. While `align` determines where\nthe texts anchor point is placed with regards to the stack, `textAlign`\ndetermines how the text is aligned against its anchor point. Possible\nvalues are `\"left\"`, `\"center\"` and `\"right\"`. The default value\nis calculated at runtime and depends on orientation and whether the\nstack is positive or negative."
              },
              "subtree": {}
            },
            "useHTML": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "useHTML",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-and-string-formatting#html)\nto render the labels."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Defines the vertical alignment of the stack total label. Can be one\nof `\"top\"`, `\"middle\"` or `\"bottom\"`. The default value is calculated\nat runtime and depends on orientation and whether the stack is positive\nor negative."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The x position offset of the label relative to the left of the stacked\nbar. The default value is calculated at runtime and depends on orientation\nand whether the stack is positive or negative."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The y position offset of the label relative to the tick position\non the axis. The default value is calculated at runtime and depends\non orientation and whether the stack is positive or negative."
              },
              "subtree": {}
            }
          }
        },
        "gridLineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "gridLineWidth",
            "excludes": {},
            "default": 1
          },
          "subtree": {}
        },
        "lineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "lineWidth",
            "excludes": {},
            "default": 0
          },
          "subtree": {}
        },
        "opposite": {
          "meta": {
            "types": {},
            "name": "opposite",
            "excludes": {},
            "products": {
              "highstock": 1,
              "highcharts": 1
            }
          },
          "subtree": {}
        },
        "lineColor": {
          "meta": {
            "types": {},
            "name": "lineColor",
            "excludes": {}
          },
          "subtree": {}
        },
        "min": {
          "meta": {
            "types": {},
            "name": "min",
            "excludes": {}
          },
          "subtree": {}
        },
        "max": {
          "meta": {
            "types": {},
            "name": "max",
            "excludes": {}
          },
          "subtree": {}
        },
        "angle": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "angle",
            "excludes": {},
            "default": "0",
            "products": {
              "highcharts": 1
            },
            "description": "In a polar chart, this is the angle of the Y axis in degrees, where\n0 is up and 90 is right. The angle determines the position of the\naxis line and the labels, though the coordinate system is unaffected."
          },
          "subtree": {}
        },
        "gridLineInterpolation": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "gridLineInterpolation",
            "excludes": {},
            "default": "null",
            "products": {
              "highcharts": 1
            },
            "description": "Polar charts only. Whether the grid lines should draw as a polygon\nwith straight lines between categories, or as circles. Can be either\n`circle` or `polygon`."
          },
          "subtree": {}
        },
        "maxColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "maxColor",
            "excludes": {},
            "default": "#003399",
            "products": {
              "highcharts": 1
            },
            "description": "Solid gauge only. Unless [stops](#yAxis.stops) are set, the color\nto represent the maximum value of the Y axis."
          },
          "subtree": {}
        },
        "minColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "minColor",
            "excludes": {},
            "default": "#e6ebf5",
            "products": {
              "highcharts": 1
            },
            "description": "Solid gauge only. Unless [stops](#yAxis.stops) are set, the color\nto represent the minimum value of the Y axis."
          },
          "subtree": {}
        },
        "reversedStacks": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "reversedStacks",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "If `true`, the first series in a stack will be drawn on top in a\npositive, non-reversed Y axis. If `false`, the first series is in\nthe base of the stack."
          },
          "subtree": {}
        },
        "stops": {
          "meta": {
            "types": {
              "array": "Array"
            },
            "name": "stops",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Solid gauge series only. Color stops for the solid gauge. Use this\nin cases where a linear gradient between a `minColor` and `maxColor`\nis not sufficient. The stops is an array of tuples, where the first\nitem is a float between 0 and 1 assigning the relative position in\nthe gradient, and the second item is the color.\n\nFor solid gauges, the Y axis also inherits the concept of [data classes](http://api.\nhighcharts.com/highmaps#colorAxis.dataClasses) from the Highmaps\ncolor axis."
          },
          "subtree": {}
        },
        "tickWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickWidth",
            "excludes": {},
            "default": "0",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The pixel width of the major tick marks."
          },
          "subtree": {}
        },
        "plotBands": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "plotBands",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An array of objects defining plot bands on the Y axis.",
            "extends": "xAxis.plotBands"
          },
          "subtree": {
            "innerRadius": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "innerRadius",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "In a gauge chart, this option determines the inner radius of the\nplot band that stretches along the perimeter. It can be given as\na percentage string, like `\"100%\"`, or as a pixel number, like `100`.\nBy default, the inner radius is controlled by the [thickness](#yAxis.\nplotBands.thickness) option."
              },
              "subtree": {}
            },
            "outerRadius": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "outerRadius",
                "excludes": {},
                "default": "100%",
                "products": {
                  "highcharts": 1
                },
                "description": "In a gauge chart, this option determines the outer radius of the\nplot band that stretches along the perimeter. It can be given as\na percentage string, like `\"100%\"`, or as a pixel number, like `100`."
              },
              "subtree": {}
            },
            "thickness": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "thickness",
                "excludes": {},
                "default": "10",
                "products": {
                  "highcharts": 1
                },
                "description": "In a gauge chart, this option sets the width of the plot band stretching\nalong the perimeter. It can be given as a percentage string, like\n`\"10%\"`, or as a pixel number, like `10`. The default value 10 is\nthe same as the default [tickLength](#yAxis.tickLength), thus making\nthe plot band act as a background for the tick markers."
              },
              "subtree": {}
            }
          }
        },
        "plotLines": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "plotLines",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An array of objects representing plot lines on the X axis",
            "extends": "xAxis.plotLines"
          },
          "subtree": {}
        },
        "height": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "height",
            "excludes": {},
            "default": "null",
            "products": {
              "highstock": 1
            },
            "description": "The height of the Y axis. If it's a number, it is interpreted as\npixels.\n\nSince Highstock 2: If it's a percentage string, it is interpreted\nas percentages of the total plot height."
          },
          "subtree": {}
        },
        "softMax": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "softMax",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A soft maximum for the axis. If the series data maximum is less\nthan this, the axis will stay at this maximum, but if the series\ndata maximum is higher, the axis will flex to show all data."
          },
          "subtree": {}
        },
        "softMin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "softMin",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A soft minimum for the axis. If the series data minimum is greater\nthan this, the axis will stay at this minimum, but if the series\ndata minimum is lower, the axis will flex to show all data."
          },
          "subtree": {}
        },
        "top": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "top",
            "excludes": {},
            "default": "null",
            "products": {
              "highstock": 1
            },
            "description": "The top position of the Y axis. If it's a number, it is interpreted\nas pixel position relative to the chart.\n\nSince Highstock 2: If it's a percentage string, it is interpreted\nas percentages of the plot height, offset from plot area top."
          },
          "subtree": {}
        },
        "scrollbar": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "scrollbar",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "An optional scrollbar to display on the Y axis in response to limiting\nthe minimum an maximum of the axis values.\n\nIn styled mode, all the presentational options for the scrollbar\nare replaced by the classes `.highcharts-scrollbar-thumb`, `.highcharts-scrollbar-arrow`, `.highcharts-scrollbar-button`, `.highcharts-scrollbar-rifles` and `.highcharts-scrollbar-track`.",
            "extends": "scrollbar"
          },
          "subtree": {
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "false",
                "products": {
                  "highstock": 1
                },
                "description": "Enable the scrollbar on the Y axis."
              },
              "subtree": {}
            },
            "margin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "margin",
                "excludes": {},
                "default": "10",
                "products": {
                  "highstock": 1
                },
                "description": "Pixel margin between the scrollbar and the axis elements."
              },
              "subtree": {}
            },
            "showFull": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "showFull",
                "excludes": {},
                "default": "true",
                "products": {
                  "highstock": 1
                },
                "description": "Whether to show the scrollbar when it is fully zoomed out at max\nrange. Setting it to `false` on the Y axis makes the scrollbar stay\nhidden until the user zooms in, like common in browsers."
              },
              "subtree": {}
            },
            "size": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "size",
                "excludes": {},
                "default": "14",
                "products": {
                  "highstock": 1
                },
                "description": "The width of a vertical scrollbar or height of a horizontal scrollbar.\n Defaults to 20 on touch devices."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": "3",
                "products": {
                  "highstock": 1
                },
                "description": "Z index of the scrollbar elements."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "drilldown": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "drilldown",
        "excludes": {},
        "description": "Options for drill down, the concept of inspecting increasingly high \nresolution data through clicking on chart items like columns or pie slices.\n\nThe drilldown feature requires the drilldown.js file to be loaded, \nfound in the modules directory of the download package, or online at \n(code.highcharts.com/modules/drilldown.js)[code.highcharts.com/modules/\ndrilldown.js]."
      },
      "subtree": {
        "activeAxisLabelStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "activeAxisLabelStyle",
            "excludes": {},
            "default": "{ \"cursor\": \"pointer\", \"color\": \"#003399\", \"fontWeight\": \"bold\", \"textDecoration\": \"underline\" }",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Additional styles to apply to the X axis label for a point that\nhas drilldown data. By default it is underlined and blue to invite\nto interaction."
          },
          "subtree": {
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "default": "pointer"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#003399"
              },
              "subtree": {}
            },
            "fontWeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontWeight",
                "excludes": {},
                "default": "bold"
              },
              "subtree": {}
            },
            "textDecoration": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textDecoration",
                "excludes": {},
                "default": "underline"
              },
              "subtree": {}
            }
          }
        },
        "activeDataLabelStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "activeDataLabelStyle",
            "excludes": {},
            "default": "{ \"cursor\": \"pointer\", \"color\": \"#003399\", \"fontWeight\": \"bold\", \"textDecoration\": \"underline\" }",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Additional styles to apply to the data label of a point that has\ndrilldown data. By default it is underlined and blue to invite to\ninteraction."
          },
          "subtree": {
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "default": "pointer"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#003399"
              },
              "subtree": {}
            },
            "fontWeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontWeight",
                "excludes": {},
                "default": "bold"
              },
              "subtree": {}
            },
            "textDecoration": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textDecoration",
                "excludes": {},
                "default": "underline"
              },
              "subtree": {}
            }
          }
        },
        "animation": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "animation",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Set the animation for all drilldown animations. Animation of a drilldown\noccurs when drilling between a column point and a column series,\nor a pie slice and a full pie series. Drilldown can still be used\nbetween series and points of different types, but animation will\nnot occur.\n\nThe animation can either be set as a boolean or a configuration\nobject. If `true`, it will use the 'swing' jQuery easing and a duration\nof 500 ms. If used as a configuration object, the following properties\nare supported:\n\n<dl>\n\n<dt>duration</dt>\n\n<dd>The duration of the animation in milliseconds.</dd>\n\n<dt>easing</dt>\n\n<dd>A string reference to an easing function set on the `Math` object.\nSee [the easing demo](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-\nanimation-easing/).</dd>\n\n</dl>"
          },
          "subtree": {
            "duration": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "duration",
                "excludes": {},
                "default": "500",
                "description": "Duration for the drilldown animation."
              },
              "subtree": {}
            }
          }
        },
        "drillUpButton": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "drillUpButton",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Options for the drill up button that appears when drilling down\non a series. The text for the button is defined in\n[lang.drillUpText](#lang.drillUpText)."
          },
          "subtree": {
            "position": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "position",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "Positioning options for the button within the `relativeTo` box.\nAvailable properties are `x`, `y`, `align` and `verticalAlign`."
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "right",
                    "description": "Horizontal alignment."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": -10,
                    "description": "The X offset of the button."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": 10,
                    "description": "The Y offset of the button."
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "top",
                    "products": {
                      "highcharts": 1,
                      "highmaps": 1
                    },
                    "description": "Vertical alignment of the button."
                  },
                  "subtree": {}
                }
              }
            },
            "relativeTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "relativeTo",
                "excludes": {},
                "default": "plotBox",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "What box to align the button to. Can be either `plotBox` or\n`spacingBox`."
              },
              "subtree": {}
            },
            "theme": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "theme",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "A collection of attributes for the button. The object takes SVG\nattributes like `fill`, `stroke`, `stroke-width` or `r`, the border\nradius. The theme also supports `style`, a collection of CSS\nproperties for the text. Equivalent attributes for the hover state\nare given in `theme.states.hover`."
              },
              "subtree": {}
            }
          }
        },
        "allowPointDrilldown": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allowPointDrilldown",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1
            },
            "description": "When this option is false, clicking a single point will drill down\nall points in the same category, equivalent to clicking the X axis\nlabel."
          },
          "subtree": {}
        },
        "series": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "series",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "An array of series configurations for the drill down. Each series\nconfiguration uses the same syntax as the [series](#series) option\nset. These drilldown series are hidden by default. The drilldown\nseries is linked to the parent series' point by its `id`."
          },
          "subtree": {}
        }
      }
    },
    "chart": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "chart",
        "excludes": {}
      },
      "subtree": {
        "events": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "events",
            "excludes": {},
            "description": "Event listeners for the chart."
          },
          "subtree": {
            "drilldown": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "drilldown",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "Fires when a drilldown point is clicked, before the new series is\nadded. This event is also utilized for async drilldown, where the\nseriesOptions are not added by option, but rather loaded async. Note\nthat when clicking a category label to trigger multiple series drilldown,\none `drilldown` event is triggered per point in the category.\n\nEvent arguments:\n\n<dl>\n\n<dt>`category`</dt>\n\n<dd>If a category label was clicked, which index.</dd>\n\n<dt>`point`</dt>\n\n<dd>The originating point.</dd>\n\n<dt>`originalEvent`</dt>\n\n<dd>The original browser event (usually click) that triggered the\ndrilldown.</dd>\n\n<dt>`points`</dt>\n\n<dd>If a category label was clicked, this array holds all points\ncorresponing to the category.</dd>\n\n<dt>`seriesOptions`</dt>\n\n<dd>Options for the new series</dd>\n\n</dl>"
              },
              "subtree": {}
            },
            "drillup": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "drillup",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "Fires when drilling up from a drilldown series."
              },
              "subtree": {}
            },
            "drillupall": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "drillupall",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "In a chart with multiple drilldown series, this event fires after\nall the series have been drilled up."
              },
              "subtree": {}
            },
            "afterPrint": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "afterPrint",
                "excludes": {},
                "description": "Fires after a chart is printed through the context menu item or the\n`Chart.print` method. Requires the exporting module."
              },
              "subtree": {}
            },
            "beforePrint": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "beforePrint",
                "excludes": {},
                "description": "Fires before a chart is printed through the context menu item or\nthe `Chart.print` method. Requires the exporting module."
              },
              "subtree": {}
            },
            "addSeries": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "addSeries",
                "excludes": {},
                "description": "Fires when a series is added to the chart after load time, using\nthe `addSeries` method. One parameter, `event`, is passed to the\nfunction, containing common event information.\nThrough `event.options` you can access the series options that was\npassed to the `addSeries` method. Returning false prevents the series\nfrom being added."
              },
              "subtree": {}
            },
            "click": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "click",
                "excludes": {},
                "description": "Fires when clicking on the plot background. One parameter, `event`,\nis passed to the function, containing common event information.\n\nInformation on the clicked spot can be found through `event.xAxis`\nand `event.yAxis`, which are arrays containing the axes of each dimension\nand each axis' value at the clicked spot. The primary axes are\n`event.xAxis[0]` and `event.yAxis[0]`. Remember the unit of a\ndatetime axis is milliseconds since 1970-01-01 00:00:00.\n\n<pre>click: function(e) {\n    console.log(\n        Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', e.xAxis[0].value),\n        e.yAxis[0].value\n    )\n}</pre>"
              },
              "subtree": {}
            },
            "load": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "load",
                "excludes": {},
                "description": "Fires when the chart is finished loading. Since v4.2.2, it also waits\nfor images to be loaded, for example from point markers. One parameter,\n`event`, is passed to the function, containing common event information.\n\nThere is also a second parameter to the chart constructor where a\ncallback function can be passed to be executed on chart.load."
              },
              "subtree": {}
            },
            "redraw": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "redraw",
                "excludes": {},
                "description": "Fires when the chart is redrawn, either after a call to chart.redraw()\nor after an axis, series or point is modified with the `redraw` option\nset to true. One parameter, `event`, is passed to the function, containing common event information."
              },
              "subtree": {}
            },
            "render": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "render",
                "excludes": {},
                "description": "Fires after initial load of the chart (directly after the `load`\nevent), and after each redraw (directly after the `redraw` event)."
              },
              "subtree": {}
            },
            "selection": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "selection",
                "excludes": {},
                "description": "Fires when an area of the chart has been selected. Selection is enabled\nby setting the chart's zoomType. One parameter, `event`, is passed\nto the function, containing common event information. The default action for the selection event is to\nzoom the chart to the selected area. It can be prevented by calling\n`event.preventDefault()`.\n\nInformation on the selected area can be found through `event.xAxis`\nand `event.yAxis`, which are arrays containing the axes of each dimension\nand each axis' min and max values. The primary axes are `event.xAxis[0]`\nand `event.yAxis[0]`. Remember the unit of a datetime axis is milliseconds\nsince 1970-01-01 00:00:00.\n\n<pre>selection: function(event) {\n    // log the min and max of the primary, datetime x-axis\n    console.log(\n        Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].min),\n        Highcharts.dateFormat('%Y-%m-%d %H:%M:%S', event.xAxis[0].max)\n    );\n    // log the min and max of the y axis\n    console.log(event.yAxis[0].min, event.yAxis[0].max);\n}</pre>"
              },
              "subtree": {}
            }
          }
        },
        "parallelCoordinates": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "parallelCoordinates",
            "excludes": {},
            "default": false,
            "products": {
              "highcharts": 1
            },
            "description": "Flag to render charts as a parallel coordinates plot. In a parallel\ncoordinates plot (||-coords) by default all required yAxes are generated\nand the legend is disabled. This feature requires\n`modules/parallel-coordinates.js`."
          },
          "subtree": {}
        },
        "parallelAxes": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "parallelAxes",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Common options for all yAxes rendered in a parallel coordinates plot.\nThis feature requires `modules/parallel-coordinates.js`.\n\nThe default options are:\n<pre>\nparallelAxes: {\n\tlineWidth: 1,       // classic mode only\n\tgridlinesWidth: 0,  // classic mode only\n\ttitle: {\n\t\ttext: '',\n\t\treserveSpace: false\n\t},\n\tlabels: {\n\t\tx: 0,\n\t\ty: 0,\n\t\talign: 'center',\n\t\treserveSpace: false\n\t},\n\toffset: 0\n}</pre>",
            "extends": "{yAxis}"
          },
          "subtree": {
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1
              },
              "subtree": {}
            },
            "title": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "title",
                "excludes": {},
                "description": "Titles for yAxes are taken from \n[xAxis.categories](#xAxis.categories). All options for \n`xAxis.labels` applies to parallel coordinates titles.\nFor example, to style categories, use \n[xAxis.labels.style](#xAxis.labels.style)."
              },
              "subtree": {
                "text": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "default": ""
                  },
                  "subtree": {}
                },
                "reserveSpace": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "reserveSpace",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "labels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "labels",
                "excludes": {}
              },
              "subtree": {
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": 0
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": 4
                  },
                  "subtree": {}
                },
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "center"
                  },
                  "subtree": {}
                },
                "reserveSpace": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "reserveSpace",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "offset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "offset",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            }
          }
        },
        "description": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "description",
            "excludes": {},
            "default": "undefined",
            "description": "A text description of the chart.\n\nIf the Accessibility module is loaded, this is included by default\nas a long description of the chart and its contents in the hidden\nscreen reader information region."
          },
          "subtree": {}
        },
        "typeDescription": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "typeDescription",
            "excludes": {},
            "default": "undefined",
            "description": "A text description of the chart type.\n\nIf the Accessibility module is loaded, this will be included in the\ndescription of the chart in the screen reader information region.\n\n\nHighcharts will by default attempt to guess the chart type, but for\nmore complex charts it is recommended to specify this property for\nclarity."
          },
          "subtree": {}
        },
        "borderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderRadius",
            "excludes": {},
            "default": "0",
            "description": "The corner radius of the outer chart border."
          },
          "subtree": {}
        },
        "colorCount": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "colorCount",
            "excludes": {},
            "default": "10",
            "description": "In styled mode, this sets how many colors the class names\nshould rotate between. With ten colors, series (or points) are\ngiven class names like `highcharts-color-0`, `highcharts-color-0`\n[...] `highcharts-color-9`. The equivalent in non-styled mode\nis to set colors using the [colors](#colors) setting."
          },
          "subtree": {}
        },
        "defaultSeriesType": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "defaultSeriesType",
            "excludes": {},
            "default": "line",
            "products": {
              "highcharts": 1
            },
            "description": "Alias of `type`."
          },
          "subtree": {}
        },
        "ignoreHiddenSeries": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "ignoreHiddenSeries",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "If true, the axes will scale to the remaining visible series once\none series is hidden. If false, hiding and showing a series will\nnot affect the axes or the other series. For stacks, once one series\nwithin the stack is hidden, the rest of the stack will close in\naround it even if the axis is not affected."
          },
          "subtree": {}
        },
        "spacing": {
          "meta": {
            "types": {
              "array": "Number"
            },
            "name": "spacing",
            "excludes": {},
            "default": "[10, 10, 15, 10]",
            "description": "The distance between the outer edge of the chart and the content,\nlike title or legend, or axis title and labels if present. The\nnumbers in the array designate top, right, bottom and left respectively.\nUse the options spacingTop, spacingRight, spacingBottom and spacingLeft\noptions for shorthand setting of one option."
          },
          "subtree": {}
        },
        "resetZoomButton": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "resetZoomButton",
            "excludes": {},
            "description": "The button that appears after a selection zoom, allowing the user\nto reset zoom."
          },
          "subtree": {
            "theme": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "theme",
                "excludes": {},
                "description": "A collection of attributes for the button. The object takes SVG\nattributes like `fill`, `stroke`, `stroke-width` or `r`, the border\nradius. The theme also supports `style`, a collection of CSS properties\nfor the text. Equivalent attributes for the hover state are given\nin `theme.states.hover`."
              },
              "subtree": {
                "zIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "zIndex",
                    "excludes": {},
                    "default": 6,
                    "description": "The Z index for the reset zoom button. The default value\nplaces it below the tooltip that has Z index 7."
                  },
                  "subtree": {}
                }
              }
            },
            "position": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "position",
                "excludes": {},
                "description": "The position of the button."
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "right",
                    "description": "The horizontal alignment of the button."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": -10,
                    "description": "The horizontal offset of the button."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": 10,
                    "description": "The vertical offset of the button."
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "top",
                    "description": "The vertical alignment of the button."
                  },
                  "subtree": {}
                }
              }
            },
            "relativeTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "relativeTo",
                "excludes": {},
                "default": "plot",
                "description": "What frame the button should be placed related to. Can be either\n`plot` or `chart`"
              },
              "subtree": {}
            }
          }
        },
        "width": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "width",
            "excludes": {},
            "default": "null",
            "description": "An explicit width for the chart. By default (when `null`) the width\nis calculated from the offset width of the containing element."
          },
          "subtree": {}
        },
        "height": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "height",
            "excludes": {},
            "default": "null",
            "description": "An explicit height for the chart. If a _number_, the height is\ngiven in pixels. If given a _percentage string_ (for example `'56%'`),\nthe height is given as the percentage of the actual chart width.\nThis allows for preserving the aspect ratio across responsive\nsizes.\n\nBy default (when `null`) the height is calculated from the offset\nheight of the containing element, or 400 pixels if the containing\nelement's height is 0."
          },
          "subtree": {}
        },
        "borderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "borderColor",
            "excludes": {},
            "default": "#335cad",
            "description": "The color of the outer chart border."
          },
          "subtree": {}
        },
        "backgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "backgroundColor",
            "excludes": {},
            "default": "#FFFFFF",
            "description": "The background color or gradient for the outer chart area."
          },
          "subtree": {}
        },
        "plotBorderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "plotBorderColor",
            "excludes": {},
            "default": "#cccccc",
            "description": "The color of the inner chart or plot area border."
          },
          "subtree": {}
        },
        "alignTicks": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "alignTicks",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "When using multiple axis, the ticks of two or more opposite axes\nwill automatically be aligned by adding ticks to the axis or axes\nwith the least ticks, as if `tickAmount` were specified.\n\nThis can be prevented by setting `alignTicks` to false. If the grid\nlines look messy, it's a good idea to hide them for the secondary\naxis by setting `gridLineWidth` to 0.\n\nIf `startOnTick` or `endOnTick` in an Axis options are set to false,\nthen the `alignTicks ` will be disabled for the Axis.\n\nDisabled for logarithmic axes."
          },
          "subtree": {}
        },
        "animation": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "animation",
            "excludes": {},
            "default": "true",
            "description": "Set the overall animation for all chart updating. Animation can be\ndisabled throughout the chart by setting it to false here. It can\nbe overridden for each individual API method as a function parameter.\nThe only animation not affected by this option is the initial series\nanimation, see [plotOptions.series.animation](#plotOptions.series.\nanimation).\n\nThe animation can either be set as a boolean or a configuration\nobject. If `true`, it will use the 'swing' jQuery easing and a\nduration of 500 ms. If used as a configuration object, the following\nproperties are supported:\n\n<dl>\n\n<dt>duration</dt>\n\n<dd>The duration of the animation in milliseconds.</dd>\n\n<dt>easing</dt>\n\n<dd>A string reference to an easing function set on the `Math` object.\nSee [the easing demo](http://jsfiddle.net/gh/get/library/pure/\nhighcharts/highcharts/tree/master/samples/highcharts/plotoptions/\nseries-animation-easing/).</dd>\n\n</dl>"
          },
          "subtree": {}
        },
        "className": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "className",
            "excludes": {},
            "description": "A CSS class name to apply to the charts container `div`, allowing\nunique CSS styling for each chart."
          },
          "subtree": {}
        },
        "margin": {
          "meta": {
            "types": {
              "array": "object"
            },
            "name": "margin",
            "excludes": {},
            "description": "The margin between the outer edge of the chart and the plot area.\nThe numbers in the array designate top, right, bottom and left\nrespectively. Use the options `marginTop`, `marginRight`,\n`marginBottom` and `marginLeft` for shorthand setting of one option.\n\nBy default there is no margin. The actual space is dynamically calculated\nfrom the offset of axis labels, axis title, title, subtitle and legend\nin addition to the `spacingTop`, `spacingRight`, `spacingBottom`\nand `spacingLeft` options."
          },
          "subtree": {}
        },
        "marginBottom": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "marginBottom",
            "excludes": {},
            "description": "The margin between the bottom outer edge of the chart and the plot\narea. Use this to set a fixed pixel value for the margin as opposed\nto the default dynamic margin. See also `spacingBottom`."
          },
          "subtree": {}
        },
        "marginLeft": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "marginLeft",
            "excludes": {},
            "default": "null",
            "description": "The margin between the left outer edge of the chart and the plot\narea. Use this to set a fixed pixel value for the margin as opposed\nto the default dynamic margin. See also `spacingLeft`."
          },
          "subtree": {}
        },
        "marginRight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "marginRight",
            "excludes": {},
            "default": "null",
            "description": "The margin between the right outer edge of the chart and the plot\narea. Use this to set a fixed pixel value for the margin as opposed\nto the default dynamic margin. See also `spacingRight`."
          },
          "subtree": {}
        },
        "marginTop": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "marginTop",
            "excludes": {},
            "default": "null",
            "description": "The margin between the top outer edge of the chart and the plot area.\nUse this to set a fixed pixel value for the margin as opposed to\nthe default dynamic margin. See also `spacingTop`."
          },
          "subtree": {}
        },
        "panKey": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "panKey",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Allows setting a key to switch between zooming and panning. Can be\none of `alt`, `ctrl`, `meta` (the command key on Mac and Windows\nkey on Windows) or `shift`. The keys are mapped directly to the key\nproperties of the click event argument (`event.altKey`, `event.ctrlKey`,\n`event.metaKey` and `event.shiftKey`)."
          },
          "subtree": {}
        },
        "panning": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "panning",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Allow panning in a chart. Best used with [panKey](#chart.panKey)\nto combine zooming and panning.\n\nOn touch devices, when the [tooltip.followTouchMove](#tooltip.followTouchMove)\noption is `true` (default), panning requires two fingers. To allow\npanning with one finger, set `followTouchMove` to `false`."
          },
          "subtree": {}
        },
        "pinchType": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "pinchType",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Equivalent to [zoomType](#chart.zoomType), but for multitouch gestures\nonly. By default, the `pinchType` is the same as the `zoomType` setting.\nHowever, pinching can be enabled separately in some cases, for example\nin stock charts where a mouse drag pans the chart, while pinching\nis enabled. When [tooltip.followTouchMove](#tooltip.followTouchMove)\nis true, pinchType only applies to two-finger touches."
          },
          "subtree": {}
        },
        "inverted": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "inverted",
            "excludes": {},
            "default": "false",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Whether to invert the axes so that the x axis is vertical and y axis\nis horizontal. When `true`, the x axis is [reversed](#xAxis.reversed)\nby default."
          },
          "subtree": {}
        },
        "plotBorderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "plotBorderWidth",
            "excludes": {},
            "default": "0",
            "description": "The pixel width of the plot area border."
          },
          "subtree": {}
        },
        "plotShadow": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "plotShadow",
            "excludes": {},
            "default": "false",
            "description": "Whether to apply a drop shadow to the plot area. Requires that\nplotBackgroundColor be set. The shadow can be an object configuration\ncontaining `color`, `offsetX`, `offsetY`, `opacity` and `width`."
          },
          "subtree": {}
        },
        "polar": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "polar",
            "excludes": {},
            "default": "false",
            "products": {
              "highcharts": 1
            },
            "description": "When true, cartesian charts like line, spline, area and column are\ntransformed into the polar coordinate system. Requires\n`highcharts-more.js`."
          },
          "subtree": {}
        },
        "reflow": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "reflow",
            "excludes": {},
            "default": "true",
            "description": "Whether to reflow the chart to fit the width of the container div\non resizing the window."
          },
          "subtree": {}
        },
        "renderTo": {
          "meta": {
            "types": {
              "string": 1,
              "object": 1
            },
            "name": "renderTo",
            "excludes": {},
            "description": "The HTML element where the chart will be rendered. If it is a string,\nthe element by that id is used. The HTML element can also be passed\nby direct reference, or as the first argument of the chart constructor,\n in which case the option is not needed."
          },
          "subtree": {}
        },
        "selectionMarkerFill": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "selectionMarkerFill",
            "excludes": {},
            "default": "rgba(51,92,173,0.25)",
            "description": "The background color of the marker square when selecting (zooming\nin on) an area of the chart."
          },
          "subtree": {}
        },
        "shadow": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "shadow",
            "excludes": {},
            "default": "false",
            "description": "Whether to apply a drop shadow to the outer chart area. Requires\nthat backgroundColor be set. The shadow can be an object configuration\ncontaining `color`, `offsetX`, `offsetY`, `opacity` and `width`."
          },
          "subtree": {}
        },
        "showAxes": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showAxes",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Whether to show the axes initially. This only applies to empty charts\nwhere series are added dynamically, as axes are automatically added\nto cartesian series."
          },
          "subtree": {}
        },
        "spacingBottom": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "spacingBottom",
            "excludes": {},
            "default": "15",
            "description": "The space between the bottom edge of the chart and the content (plot\narea, axis title and labels, title, subtitle or legend in top position)."
          },
          "subtree": {}
        },
        "spacingLeft": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "spacingLeft",
            "excludes": {},
            "default": "10",
            "description": "The space between the left edge of the chart and the content (plot\narea, axis title and labels, title, subtitle or legend in top position)."
          },
          "subtree": {}
        },
        "spacingRight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "spacingRight",
            "excludes": {},
            "default": "10",
            "description": "The space between the right edge of the chart and the content (plot\narea, axis title and labels, title, subtitle or legend in top\nposition)."
          },
          "subtree": {}
        },
        "spacingTop": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "spacingTop",
            "excludes": {},
            "default": "10",
            "description": "The space between the top edge of the chart and the content (plot\narea, axis title and labels, title, subtitle or legend in top\nposition)."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{\"fontFamily\":\"\\\"Lucida Grande\\\", \\\"Lucida Sans Unicode\\\", Verdana, Arial, Helvetica, sans-serif\",\"fontSize\":\"12px\"}",
            "description": "Additional CSS styles to apply inline to the container `div`. Note\nthat since the default font styles are applied in the renderer, it\nis ignorant of the individual chart options and must be set globally."
          },
          "subtree": {}
        },
        "type": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "type",
            "excludes": {},
            "description": "The default series type for the chart. Can be any of the chart types\nlisted under [plotOptions](#plotOptions)."
          },
          "subtree": {}
        },
        "zoomType": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "zoomType",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Decides in what dimensions the user can zoom by dragging the mouse.\nCan be one of `x`, `y` or `xy`."
          },
          "subtree": {}
        },
        "borderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderWidth",
            "excludes": {},
            "default": "0",
            "description": "The pixel width of the outer chart border."
          },
          "subtree": {}
        },
        "plotBackgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "plotBackgroundColor",
            "excludes": {},
            "default": "null",
            "description": "The background color or gradient for the plot area."
          },
          "subtree": {}
        },
        "plotBackgroundImage": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "plotBackgroundImage",
            "excludes": {},
            "default": "null",
            "description": "The URL for an image to use as the plot background. To set an image\nas the background for the entire chart, set a CSS background image\nto the container element. Note that for the image to be applied to\nexported charts, its URL needs to be accessible by the export server."
          },
          "subtree": {}
        },
        "options3d": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "options3d",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Options to render charts in 3 dimensions. This feature requires\n`highcharts-3d.js`, found in the download package or online at\n[code.highcharts.com/highcharts-3d.js](http://code.highcharts.com/highcharts-\n3d.js)."
          },
          "subtree": {
            "frame": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "frame",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "Provides the option to draw a frame around the charts by defining\na bottom, front and back panel."
              },
              "subtree": {
                "side": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "side",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "Note: As of v5.0.12, `frame.left` or `frame.right` should be used\ninstead.\n\nThe side for the frame around a 3D chart."
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "transparent",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The color of the panel."
                      },
                      "subtree": {}
                    },
                    "size": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "size",
                        "excludes": {},
                        "default": "1",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The thickness of the panel."
                      },
                      "subtree": {}
                    }
                  }
                },
                "visible": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "visible",
                    "excludes": {},
                    "default": "default",
                    "description": "Whether the frames are visible."
                  },
                  "subtree": {}
                },
                "size": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "size",
                    "excludes": {},
                    "default": 1,
                    "description": "General pixel thickness for the frame faces."
                  },
                  "subtree": {}
                },
                "bottom": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "bottom",
                    "excludes": {},
                    "description": "The bottom of the frame around a 3D chart."
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "transparent",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The color of the panel."
                      },
                      "subtree": {}
                    },
                    "size": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "size",
                        "excludes": {},
                        "default": "1",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "The thickness of the panel."
                      },
                      "subtree": {}
                    },
                    "visible": {
                      "meta": {
                        "types": {
                          "boolean": 1,
                          "string": 1
                        },
                        "name": "visible",
                        "excludes": {},
                        "default": "default",
                        "products": {
                          "highcharts": 1
                        },
                        "description": "Whether to display the frame. Possible values are `true`, `false`,\n`\"auto\"` to display only the frames behind the data, and `\"default\"`\nto display faces behind the data based on the axis layout, ignoring\nthe point of view."
                      },
                      "subtree": {}
                    }
                  }
                },
                "top": {
                  "meta": {
                    "types": {},
                    "name": "top",
                    "excludes": {},
                    "description": "The top of the frame around a 3D chart.",
                    "extends": "{chart.options3d.frame.bottom}"
                  },
                  "subtree": {}
                },
                "left": {
                  "meta": {
                    "types": {},
                    "name": "left",
                    "excludes": {},
                    "description": "The left side of the frame around a 3D chart.",
                    "extends": "{chart.options3d.frame.bottom}"
                  },
                  "subtree": {}
                },
                "right": {
                  "meta": {
                    "types": {},
                    "name": "right",
                    "excludes": {},
                    "description": "The right of the frame around a 3D chart.",
                    "extends": "{chart.options3d.frame.bottom}"
                  },
                  "subtree": {}
                },
                "back": {
                  "meta": {
                    "types": {},
                    "name": "back",
                    "excludes": {},
                    "description": "The back side of the frame around a 3D chart.",
                    "extends": "{chart.options3d.frame.bottom}"
                  },
                  "subtree": {}
                },
                "front": {
                  "meta": {
                    "types": {},
                    "name": "front",
                    "excludes": {},
                    "description": "The front of the frame around a 3D chart.",
                    "extends": "{chart.options3d.frame.bottom}"
                  },
                  "subtree": {}
                }
              }
            },
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1
                },
                "description": "Wether to render the chart using the 3D functionality."
              },
              "subtree": {}
            },
            "alpha": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "alpha",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "One of the two rotation angles for the chart."
              },
              "subtree": {}
            },
            "beta": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "beta",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "One of the two rotation angles for the chart."
              },
              "subtree": {}
            },
            "depth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "depth",
                "excludes": {},
                "default": "100",
                "products": {
                  "highcharts": 1
                },
                "description": "The total depth of the chart."
              },
              "subtree": {}
            },
            "fitToPlot": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "fitToPlot",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether the 3d box should automatically adjust to the chart plot\narea."
              },
              "subtree": {}
            },
            "viewDistance": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "viewDistance",
                "excludes": {},
                "default": "100",
                "products": {
                  "highcharts": 1
                },
                "description": "Defines the distance the viewer is standing in front of the chart,\nthis setting is important to calculate the perspective effect\nin column and scatter charts. It is not used for 3D pie charts."
              },
              "subtree": {}
            },
            "axisLabelPosition": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "axisLabelPosition",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "Set it to `\"auto\"` to automatically move the labels to the best\nedge."
              },
              "subtree": {}
            }
          }
        },
        "map": {
          "meta": {
            "types": {
              "string": 1,
              "array": "Object"
            },
            "name": "map",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highmaps": 1
            },
            "description": "Default `mapData` for all series. If set to a string, it functions\nas an index into the `Highcharts.maps` array. Otherwise it is interpreted\nas map data."
          },
          "subtree": {}
        },
        "mapTransforms": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "mapTransforms",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highmaps": 1
            },
            "description": "Set lat/lon transformation definitions for the chart. If not defined,\n these are extracted from the map data."
          },
          "subtree": {}
        }
      }
    },
    "exporting": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "exporting",
        "excludes": {},
        "description": "Options for the exporting module. For an overview on the matter, see [the docs](http://www.highcharts.com/docs/export-module/export-module-overview)."
      },
      "subtree": {
        "csv": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "csv",
            "excludes": {},
            "description": "Options for exporting data to CSV or ExCel, or displaying the data\nin a HTML table or a JavaScript structure. Requires the\n`export-data.js` module. This module adds data export options to the\nexport menu and provides functions like `Chart.getCSV`,\n`Chart.getTable`, `Chart.getDataRows` and `Chart.viewData`."
          },
          "subtree": {
            "columnHeaderFormatter": {
              "meta": {
                "types": {
                  "function": 1,
                  "null": 1
                },
                "name": "columnHeaderFormatter",
                "excludes": {},
                "default": null,
                "description": "Formatter callback for the column headers. Parameters are:\n- `item` - The series or axis object)\n- `key` -  The point key, for example y or z\n- `keyLength` - The amount of value keys for this item, for\n  example a range series has the keys `low` and `high` so the\n  key length is 2.\n\nIf [useMultiLevelHeaders](#exporting.useMultiLevelHeaders) is\ntrue, columnHeaderFormatter by default returns an object with\ncolumnTitle and topLevelColumnTitle for each key. Columns with\nthe same topLevelColumnTitle have their titles merged into a\nsingle cell with colspan for table/Excel export.\n\nIf `useMultiLevelHeaders` is false, or for CSV export, it returns\nthe series name, followed by the key if there is more than one\nkey.\n\nFor the axis it returns the axis title or \"Category\" or\n\"DateTime\" by default.\n\nReturn `false` to use Highcharts' proposed header."
              },
              "subtree": {}
            },
            "dateFormat": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "dateFormat",
                "excludes": {},
                "default": "%Y-%m-%d %H:%M:%S",
                "description": "Which date format to use for exported dates on a datetime X axis.\nSee `Highcharts.dateFormat`."
              },
              "subtree": {}
            },
            "decimalPoint": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "decimalPoint",
                "excludes": {},
                "default": null,
                "description": "Which decimal point to use for exported CSV. Defaults to the same\nas the browser locale, typically `.` (English) or `,` (German,\nFrench etc)."
              },
              "subtree": {}
            },
            "itemDelimiter": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "itemDelimiter",
                "excludes": {},
                "default": null,
                "description": "The item delimiter in the exported data. Use `;` for direct\nexporting to Excel. Defaults to a best guess based on the browser\nlocale. If the locale _decimal point_ is `,`, the `itemDelimiter`\ndefaults to `;`, otherwise the `itemDelimiter` defaults to `,`."
              },
              "subtree": {}
            },
            "lineDelimiter": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "lineDelimiter",
                "excludes": {},
                "default": "\n",
                "description": "The line delimiter in the exported data, defaults to a newline."
              },
              "subtree": {}
            }
          }
        },
        "showTable": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showTable",
            "excludes": {},
            "default": false,
            "description": "Export-data module required. Show a HTML table below the chart with\nthe chart's current data."
          },
          "subtree": {}
        },
        "useMultiLevelHeaders": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useMultiLevelHeaders",
            "excludes": {},
            "default": true,
            "description": "Export-data module required. Use multi level headers in data table.\nIf [csv.columnHeaderFormatter](#exporting.csv.columnHeaderFormatter)\nis defined, it has to return objects in order for multi level headers\nto work."
          },
          "subtree": {}
        },
        "useRowspanHeaders": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useRowspanHeaders",
            "excludes": {},
            "default": true,
            "description": "Export-data module required. If using multi level table headers, use\nrowspans for headers that have only one level."
          },
          "subtree": {}
        },
        "tableCaption": {
          "meta": {
            "types": {
              "boolean": 1,
              "string": 1
            },
            "name": "tableCaption",
            "excludes": {},
            "default": "undefined",
            "description": "Export-data module required. Caption for the data table. Same as\nchart title by default. Set to `false` to disable."
          },
          "subtree": {}
        },
        "type": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "type",
            "excludes": {},
            "default": "image/png",
            "description": "Default MIME type for exporting if `chart.exportChart()` is called\nwithout specifying a `type` option. Possible values are `image/png`,\n `image/jpeg`, `application/pdf` and `image/svg+xml`."
          },
          "subtree": {}
        },
        "url": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "url",
            "excludes": {},
            "default": "https://export.highcharts.com/",
            "description": "The URL for the server module converting the SVG string to an image\nformat. By default this points to Highchart's free web service."
          },
          "subtree": {}
        },
        "printMaxWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "printMaxWidth",
            "excludes": {},
            "default": "780",
            "description": "When printing the chart from the menu item in the burger menu, if\nthe on-screen chart exceeds this width, it is resized. After printing\nor cancelled, it is restored. The default width makes the chart\nfit into typical paper format. Note that this does not affect the\nchart when printing the web page as a whole."
          },
          "subtree": {}
        },
        "scale": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "scale",
            "excludes": {},
            "default": 2,
            "description": "Defines the scale or zoom factor for the exported image compared\nto the on-screen display. While for instance a 600px wide chart\nmay look good on a website, it will look bad in print. The default\nscale of 2 makes this chart export to a 1200px PNG or JPG."
          },
          "subtree": {}
        },
        "buttons": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttons",
            "excludes": {},
            "description": "Options for the export related buttons, print and export. In addition\nto the default buttons listed here, custom buttons can be added.\nSee [navigation.buttonOptions](#navigation.buttonOptions) for general\noptions."
          },
          "subtree": {
            "contextButton": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "contextButton",
                "excludes": {},
                "description": "Options for the export button.\n\nIn styled mode, export button styles can be applied with the\n`.highcharts-contextbutton` class.",
                "extends": "navigation.buttonOptions"
              },
              "subtree": {
                "className": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "className",
                    "excludes": {},
                    "default": "highcharts-contextbutton",
                    "description": "The class name of the context button."
                  },
                  "subtree": {}
                },
                "menuClassName": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "menuClassName",
                    "excludes": {},
                    "default": "highcharts-contextmenu",
                    "description": "The class name of the menu appearing from the button."
                  },
                  "subtree": {}
                },
                "symbol": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "symbol",
                    "excludes": {},
                    "default": "menu",
                    "description": "The symbol for the button. Points to a definition function in\nthe `Highcharts.Renderer.symbols` collection. The default `exportIcon`\nfunction is part of the exporting module."
                  },
                  "subtree": {}
                },
                "_titleKey": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "_titleKey",
                    "excludes": {},
                    "default": "contextButtonTitle",
                    "description": "The key to a [lang](#lang) option setting that is used for the\nbutton's title tooltip. When the key is `contextButtonTitle`, it\nrefers to [lang.contextButtonTitle](#lang.contextButtonTitle)\nthat defaults to \"Chart context menu\"."
                  },
                  "subtree": {}
                },
                "menuItems": {
                  "meta": {
                    "types": {
                      "array": "Object"
                    },
                    "name": "menuItems",
                    "excludes": {},
                    "description": "A collection of strings pointing to config options for the menu\nitems. The config options are defined in the\n`menuItemDefinitions` option.\n\nBy default, there is the \"Print\" menu item plus one menu item\nfor each of the available export types. \n\nDefaults to \n<pre>\n[\n\t'printChart',\n\t'separator',\n\t'downloadPNG',\n\t'downloadJPEG',\n\t'downloadPDF',\n\t'downloadSVG'\n]\n</pre>"
                  },
                  "subtree": {}
                },
                "onclick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "onclick",
                    "excludes": {},
                    "description": "A click handler callback to use on the button directly instead of\nthe popup menu."
                  },
                  "subtree": {}
                },
                "symbolFill": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "symbolFill",
                    "excludes": {},
                    "default": "#666666",
                    "description": "See [navigation.buttonOptions.symbolFill](#navigation.buttonOptions.symbolFill)."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": "-10",
                    "description": "The horizontal position of the button relative to the `align`\noption."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "menuItemDefinitions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "menuItemDefinitions",
            "excludes": {},
            "description": "An object consisting of definitions for the menu items in the context\nmenu. Each key value pair has a `key` that is referenced in the\n[menuItems](#exporting.buttons.contextButton.menuItems) setting,\nand a `value`, which is an object with the following properties:\n\n<dl>\n\n<dt>onclick</dt>\n\n<dd>The click handler for the menu item</dd>\n\n<dt>text</dt>\n\n<dd>The text for the menu item</dd>\n\n<dt>textKey</dt>\n\n<dd>If internationalization is required, the key to a language string</dd>\n\n</dl>"
          },
          "subtree": {}
        },
        "allowHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allowHTML",
            "excludes": {},
            "default": "false",
            "description": "Experimental setting to allow HTML inside the chart (added through\nthe `useHTML` options), directly in the exported image. This allows\nyou to preserve complicated HTML structures like tables or bi-directional\ntext in exported charts.\n\nDisclaimer: The HTML is rendered in a `foreignObject` tag in the\ngenerated SVG. The official export server is based on PhantomJS,\nwhich supports this, but other SVG clients, like Batik, does not\nsupport it. This also applies to downloaded SVG that you want to\nopen in a desktop client."
          },
          "subtree": {}
        },
        "chartOptions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "chartOptions",
            "excludes": {},
            "default": "null",
            "description": "Additional chart options to be merged into an exported chart. For\nexample, a common use case is to add data labels to improve readability\nof the exported chart, or to add a printer-friendly color scheme."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "description": "Whether to enable the exporting module. Disabling the module will\nhide the context button, but API methods will still be available."
          },
          "subtree": {}
        },
        "error": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "error",
            "excludes": {},
            "default": "undefined",
            "description": "Function to call if the offline-exporting module fails to export\na chart on the client side, and [fallbackToExportServer](#exporting.\nfallbackToExportServer) is disabled. If left undefined, an exception\nis thrown instead."
          },
          "subtree": {}
        },
        "fallbackToExportServer": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "fallbackToExportServer",
            "excludes": {},
            "default": "true",
            "description": "Whether or not to fall back to the export server if the offline-exporting\nmodule is unable to export the chart on the client side."
          },
          "subtree": {}
        },
        "filename": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "filename",
            "excludes": {},
            "default": "chart",
            "description": "The filename, without extension, to use for the exported chart."
          },
          "subtree": {}
        },
        "formAttributes": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "formAttributes",
            "excludes": {},
            "description": "An object containing additional attributes for the POST form that\nsends the SVG to the export server. For example, a `target` can be\nset to make sure the generated image is received in another frame,\n or a custom `enctype` or `encoding` can be set."
          },
          "subtree": {}
        },
        "libURL": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "libURL",
            "excludes": {},
            "description": "Path where Highcharts will look for export module dependencies to\nload on demand if they don't already exist on `window`. Should currently\npoint to location of [CanVG](https://github.com/canvg/canvg) library,\n[RGBColor.js](https://github.com/canvg/canvg), [jsPDF](https://github.\ncom/yWorks/jsPDF) and [svg2pdf.js](https://github.com/yWorks/svg2pdf.\njs), required for client side export in certain browsers."
          },
          "subtree": {}
        },
        "sourceHeight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "sourceHeight",
            "excludes": {},
            "description": "Analogous to [sourceWidth](#exporting.sourceWidth)."
          },
          "subtree": {}
        },
        "sourceWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "sourceWidth",
            "excludes": {},
            "description": "The width of the original chart when exported, unless an explicit\n[chart.width](#chart.width) is set. The width exported raster image\nis then multiplied by [scale](#exporting.scale)."
          },
          "subtree": {}
        },
        "width": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "width",
            "excludes": {},
            "default": "undefined",
            "description": "The pixel width of charts exported to PNG or JPG. As of Highcharts\n3.0, the default pixel width is a function of the [chart.width](#chart.\nwidth) or [exporting.sourceWidth](#exporting.sourceWidth) and the\n[exporting.scale](#exporting.scale)."
          },
          "subtree": {}
        }
      }
    },
    "navigation": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "navigation",
        "excludes": {},
        "description": "A collection of options for buttons and menus appearing in the exporting module."
      },
      "subtree": {
        "buttonOptions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttonOptions",
            "excludes": {},
            "description": "A collection of options for buttons appearing in the exporting module.\n\n\nIn styled mode, the buttons are styled with the `.highcharts-contextbutton` and `.highcharts-button-symbol` class."
          },
          "subtree": {
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "true",
                "description": "Whether to enable buttons."
              },
              "subtree": {}
            },
            "symbolSize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "symbolSize",
                "excludes": {},
                "default": "14",
                "description": "The pixel size of the symbol on the button."
              },
              "subtree": {}
            },
            "symbolX": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "symbolX",
                "excludes": {},
                "default": "12.5",
                "description": "The x position of the center of the symbol inside the button."
              },
              "subtree": {}
            },
            "symbolY": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "symbolY",
                "excludes": {},
                "default": "10.5",
                "description": "The y position of the center of the symbol inside the button."
              },
              "subtree": {}
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "right",
                "description": "Alignment for the buttons."
              },
              "subtree": {}
            },
            "buttonSpacing": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "buttonSpacing",
                "excludes": {},
                "default": "3",
                "description": "The pixel spacing between buttons."
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "height",
                "excludes": {},
                "default": "22",
                "description": "Pixel height of the buttons."
              },
              "subtree": {}
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "default": "null",
                "description": "A text string to add to the individual button."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": "0",
                "description": "The vertical offset of the button's position relative to its\n`verticalAlign`."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "default": "top",
                "description": "The vertical alignment of the buttons. Can be one of \"top\", \"middle\"\nor \"bottom\"."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": "24",
                "description": "The pixel width of the button."
              },
              "subtree": {}
            },
            "symbolFill": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "symbolFill",
                "excludes": {},
                "default": "#666666",
                "description": "Fill color for the symbol within the button."
              },
              "subtree": {}
            },
            "symbolStroke": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "symbolStroke",
                "excludes": {},
                "default": "#666666",
                "description": "The color of the symbol's stroke or line."
              },
              "subtree": {}
            },
            "symbolStrokeWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "symbolStrokeWidth",
                "excludes": {},
                "default": "1",
                "description": "The pixel stroke width of the symbol on the button."
              },
              "subtree": {}
            },
            "theme": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "theme",
                "excludes": {},
                "description": "A configuration object for the button theme. The object accepts\nSVG properties like `stroke-width`, `stroke` and `fill`. Tri-state\nbutton styles are supported by the `states.hover` and `states.select`\nobjects."
              },
              "subtree": {
                "fill": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fill",
                    "excludes": {},
                    "default": "#ffffff",
                    "description": "The default fill exists only to capture hover events."
                  },
                  "subtree": {}
                },
                "stroke": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "stroke",
                    "excludes": {},
                    "default": "none"
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": "5"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "menuStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "menuStyle",
            "excludes": {},
            "default": "{ \"border\": \"1px solid #999999\", \"background\": \"#ffffff\", \"padding\": \"5px 0\" }",
            "description": "CSS styles for the popup menu appearing by default when the export\nicon is clicked. This menu is rendered in HTML."
          },
          "subtree": {
            "border": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "border",
                "excludes": {},
                "default": "1px solid #999999"
              },
              "subtree": {}
            },
            "background": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "background",
                "excludes": {},
                "default": "#ffffff"
              },
              "subtree": {}
            },
            "padding": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "padding",
                "excludes": {},
                "default": "5px 0"
              },
              "subtree": {}
            }
          }
        },
        "menuItemStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "menuItemStyle",
            "excludes": {},
            "default": "{ \"padding\": \"0.5em 1em\", \"color\": \"#333333\", \"background\": \"none\" }",
            "description": "CSS styles for the individual items within the popup menu appearing\nby default when the export icon is clicked. The menu items are rendered\nin HTML."
          },
          "subtree": {
            "padding": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "padding",
                "excludes": {},
                "default": "0.5em 1em"
              },
              "subtree": {}
            },
            "background": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "background",
                "excludes": {},
                "default": "none"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#333333"
              },
              "subtree": {}
            },
            "fontSize": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontSize",
                "excludes": {},
                "description": "Defaults to `14px` on touch devices and `11px` on desktop."
              },
              "subtree": {}
            },
            "transition": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "transition",
                "excludes": {},
                "default": "background 250ms, color 250ms"
              },
              "subtree": {}
            }
          }
        },
        "menuItemHoverStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "menuItemHoverStyle",
            "excludes": {},
            "default": "{ \"background\": \"#335cad\", \"color\": \"#ffffff\" }",
            "description": "CSS styles for the hover state of the individual items within the\npopup menu appearing by default when the export icon is clicked.\n The menu items are rendered in HTML."
          },
          "subtree": {
            "background": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "background",
                "excludes": {},
                "default": "#335cad"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#ffffff"
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "accessibility": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "accessibility",
        "excludes": {},
        "description": "Options for configuring accessibility for the chart. Requires the\n[accessibility module](//code.highcharts.com/modules/accessibility.\njs) to be loaded. For a description of the module and information\non its features, see [Highcharts Accessibility](http://www.highcharts.\ncom/docs/chart-concepts/accessibility)."
      },
      "subtree": {
        "keyboardNavigation": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "keyboardNavigation",
            "excludes": {},
            "description": "Options for keyboard navigation."
          },
          "subtree": {
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "true",
                "description": "Enable keyboard navigation for the chart."
              },
              "subtree": {}
            },
            "focusBorder": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "focusBorder",
                "excludes": {},
                "description": "Options for the focus border drawn around elements while\nnavigating through them."
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": "true",
                    "description": "Enable/disable focus border for chart."
                  },
                  "subtree": {}
                },
                "hideBrowserFocusOutline": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "hideBrowserFocusOutline",
                    "excludes": {},
                    "default": "true",
                    "description": "Hide the browser's default focus indicator."
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "description": "Style options for the focus border drawn around elements \nwhile navigating through them. Note that some browsers in \naddition draw their own borders for focused elements. These\nautomatic borders can not be styled by Highcharts.\n\nIn styled mode, the border is given the \n`.highcharts-focus-border` class."
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "color": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#000000",
                        "description": "Color of the focus border."
                      },
                      "subtree": {}
                    },
                    "lineWidth": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "lineWidth",
                        "excludes": {},
                        "default": "2",
                        "description": "Line width of the focus border."
                      },
                      "subtree": {}
                    },
                    "borderRadius": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "borderRadius",
                        "excludes": {},
                        "default": "3",
                        "description": "Border radius of the focus border."
                      },
                      "subtree": {}
                    }
                  }
                },
                "margin": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "margin",
                    "excludes": {},
                    "default": "2",
                    "description": "Focus border margin around the elements."
                  },
                  "subtree": {}
                }
              }
            },
            "mode": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "mode",
                "excludes": {},
                "default": "normal",
                "description": "Set the keyboard navigation mode for the chart. Can be \"normal\"\nor \"serialize\". In normal mode, left/right arrow keys move\nbetween points in a series, while up/down arrow keys move between\nseries. Up/down navigation acts intelligently to figure out which\nseries makes sense to move to from any given point.\n\nIn \"serialize\" mode, points are instead navigated as a single \nlist. Left/right behaves as in \"normal\" mode. Up/down arrow keys\nwill behave like left/right. This is useful for unifying \nnavigation behavior with/without screen readers enabled."
              },
              "subtree": {}
            },
            "skipNullPoints": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "skipNullPoints",
                "excludes": {},
                "default": "true",
                "description": "Skip null points when navigating through points with the\nkeyboard."
              },
              "subtree": {}
            }
          }
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "description": "Enable accessibility features for the chart."
          },
          "subtree": {}
        },
        "pointDescriptionThreshold": {
          "meta": {
            "types": {
              "number": 1,
              "boolean": 1
            },
            "name": "pointDescriptionThreshold",
            "excludes": {},
            "default": false,
            "description": "When a series contains more points than this, we no longer expose\ninformation about individual points to screen readers.\n\nSet to `false` to disable."
          },
          "subtree": {}
        },
        "screenReaderSectionFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "screenReaderSectionFormatter",
            "excludes": {},
            "default": "undefined",
            "description": "A formatter function to create the HTML contents of the hidden screen\nreader information region. Receives one argument, `chart`, referring\nto the chart object. Should return a String with the HTML content\nof the region.\n\nThe link to view the chart as a data table will be added\nautomatically after the custom HTML content."
          },
          "subtree": {}
        },
        "describeSingleSeries": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "describeSingleSeries",
            "excludes": {},
            "default": "false",
            "description": "Whether or not to add series descriptions to charts with a single\nseries."
          },
          "subtree": {}
        },
        "onTableAnchorClick": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "onTableAnchorClick",
            "excludes": {},
            "description": "Function to run upon clicking the \"View as Data Table\" link in the\nscreen reader region.\n\nBy default Highcharts will insert and set focus to a data table\nrepresentation of the chart."
          },
          "subtree": {}
        },
        "pointDateFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "pointDateFormat",
            "excludes": {},
            "description": "Date format to use for points on datetime axes when describing them\nto screen reader users.\n\nDefaults to the same format as in tooltip.\n\nFor an overview of the replacement codes, see\n[dateFormat](#Highcharts.dateFormat)."
          },
          "subtree": {}
        },
        "pointDateFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "pointDateFormatter",
            "excludes": {},
            "description": "Formatter function to determine the date/time format used with\npoints on datetime axes when describing them to screen reader users.\nReceives one argument, `point`, referring to the point to describe.\nShould return a date format string compatible with\n[dateFormat](#Highcharts.dateFormat)."
          },
          "subtree": {}
        },
        "pointDescriptionFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "pointDescriptionFormatter",
            "excludes": {},
            "description": "Formatter function to use instead of the default for point\ndescriptions.\nReceives one argument, `point`, referring to the point to describe.\nShould return a String with the description of the point for a screen\nreader user."
          },
          "subtree": {}
        },
        "seriesDescriptionFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "seriesDescriptionFormatter",
            "excludes": {},
            "description": "Formatter function to use instead of the default for series\ndescriptions. Receives one argument, `series`, referring to the\nseries to describe. Should return a String with the description of\nthe series for a screen reader user."
          },
          "subtree": {}
        }
      }
    },
    "legend": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "legend",
        "excludes": {},
        "description": "The legend is a box containing a symbol and name for each series\nitem or point item in the chart. Each series (or points in case\nof pie charts) is represented by a symbol and its name in the legend.\n\nIt is possible to override the symbol creator function and\ncreate [custom legend symbols](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/studies/legend-\ncustom-symbol/)."
      },
      "subtree": {
        "keyboardNavigation": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "keyboardNavigation",
            "excludes": {},
            "description": "Keyboard navigation for the legend. Requires the Accessibility module."
          },
          "subtree": {
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "true",
                "description": "Enable/disable keyboard navigation for the legend. Requires the Accessibility\nmodule."
              },
              "subtree": {}
            }
          }
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": true,
            "description": "Enable or disable the legend."
          },
          "subtree": {}
        },
        "align": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "align",
            "excludes": {},
            "default": "center",
            "description": "The horizontal alignment of the legend box within the chart area.\nValid values are `left`, `center` and `right`.\n\nIn the case that the legend is aligned in a corner position, the\n`layout` option will determine whether to place it above/below\nor on the side of the plot area."
          },
          "subtree": {}
        },
        "layout": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "layout",
            "excludes": {},
            "default": "horizontal",
            "description": "The layout of the legend items. Can be one of \"horizontal\" or \"vertical\"."
          },
          "subtree": {}
        },
        "labelFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "labelFormatter",
            "excludes": {},
            "description": "Callback function to format each of the series' labels. The `this`\nkeyword refers to the series object, or the point object in case\nof pie charts. By default the series or point name is printed."
          },
          "subtree": {}
        },
        "borderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "borderColor",
            "excludes": {},
            "default": "#999999",
            "description": "The color of the drawn border around the legend."
          },
          "subtree": {}
        },
        "borderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderRadius",
            "excludes": {},
            "default": "0",
            "description": "The border corner radius of the legend."
          },
          "subtree": {}
        },
        "navigation": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "navigation",
            "excludes": {},
            "description": "Options for the paging or navigation appearing when the legend\nis overflown. Navigation works well on screen, but not in static\nexported images. One way of working around that is to [increase\nthe chart height in export](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/legend/navigation-\nenabled-false/)."
          },
          "subtree": {
            "activeColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "activeColor",
                "excludes": {},
                "default": "#003399",
                "description": "The color for the active up or down arrow in the legend page navigation."
              },
              "subtree": {}
            },
            "inactiveColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "inactiveColor",
                "excludes": {},
                "default": "#cccccc",
                "description": "The color of the inactive up or down arrow in the legend page\nnavigation. ."
              },
              "subtree": {}
            },
            "animation": {
              "meta": {
                "types": {
                  "boolean": 1,
                  "object": 1
                },
                "name": "animation",
                "excludes": {},
                "default": "true",
                "description": "How to animate the pages when navigating up or down. A value of `true`\napplies the default navigation given in the chart.animation option.\nAdditional options can be given as an object containing values for\neasing and duration."
              },
              "subtree": {}
            },
            "arrowSize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "arrowSize",
                "excludes": {},
                "default": "12",
                "description": "The pixel size of the up and down arrows in the legend paging\nnavigation."
              },
              "subtree": {}
            },
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "true",
                "description": "Whether to enable the legend navigation. In most cases, disabling\nthe navigation results in an unwanted overflow.\n\nSee also the [adapt chart to legend](http://www.highcharts.com/plugin-\nregistry/single/8/Adapt-Chart-To-Legend) plugin for a solution to\nextend the chart height to make room for the legend, optionally in\nexported charts only."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "description": "Text styles for the legend page navigation."
              },
              "subtree": {}
            }
          }
        },
        "itemStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "itemStyle",
            "excludes": {},
            "default": "{ \"color\": \"#333333\", \"cursor\": \"pointer\", \"fontSize\": \"12px\", \"fontWeight\": \"bold\", \"textOverflow\": \"ellipsis\" }",
            "description": "CSS styles for each legend item. Only a subset of CSS is supported,\nnotably those options related to text. The default `textOverflow`\nproperty makes long texts truncate. Set it to `null` to wrap text\ninstead. A `width` property can be added to control the text width."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#333333"
              },
              "subtree": {}
            },
            "fontSize": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontSize",
                "excludes": {},
                "default": "12px"
              },
              "subtree": {}
            },
            "fontWeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontWeight",
                "excludes": {},
                "default": "bold"
              },
              "subtree": {}
            },
            "textOverflow": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textOverflow",
                "excludes": {},
                "default": "ellipsis"
              },
              "subtree": {}
            }
          }
        },
        "itemHoverStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "itemHoverStyle",
            "excludes": {},
            "default": "{ \"color\": \"#000000\" }",
            "description": "CSS styles for each legend item in hover mode. Only a subset of\nCSS is supported, notably those options related to text. Properties\nare inherited from `style` unless overridden here."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#000000"
              },
              "subtree": {}
            }
          }
        },
        "itemHiddenStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "itemHiddenStyle",
            "excludes": {},
            "default": "{ \"color\": \"#cccccc\" }",
            "description": "CSS styles for each legend item when the corresponding series or\npoint is hidden. Only a subset of CSS is supported, notably those\noptions related to text. Properties are inherited from `style`\nunless overridden here."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#cccccc"
              },
              "subtree": {}
            }
          }
        },
        "shadow": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "shadow",
            "excludes": {},
            "default": "false",
            "description": "Whether to apply a drop shadow to the legend. A `backgroundColor`\nalso needs to be applied for this to take effect. The shadow can be\nan object configuration containing `color`, `offsetX`, `offsetY`,\n`opacity` and `width`."
          },
          "subtree": {}
        },
        "itemCheckboxStyle": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "itemCheckboxStyle",
            "excludes": {},
            "description": "Default styling for the checkbox next to a legend item when\n`showCheckbox` is true."
          },
          "subtree": {
            "position": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position",
                "excludes": {},
                "default": "absolute"
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "width",
                "excludes": {},
                "default": "13px"
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "height",
                "excludes": {},
                "default": "13px"
              },
              "subtree": {}
            }
          }
        },
        "squareSymbol": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "squareSymbol",
            "excludes": {},
            "default": "true",
            "description": "When this is true, the legend symbol width will be the same as\nthe symbol height, which in turn defaults to the font size of the\nlegend items."
          },
          "subtree": {}
        },
        "symbolPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "symbolPadding",
            "excludes": {},
            "default": "5",
            "description": "The pixel padding between the legend item symbol and the legend\nitem text."
          },
          "subtree": {}
        },
        "verticalAlign": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "verticalAlign",
            "excludes": {},
            "default": "bottom",
            "description": "The vertical alignment of the legend box. Can be one of `top`,\n`middle` or `bottom`. Vertical position can be further determined\nby the `y` option.\n\nIn the case that the legend is aligned in a corner position, the\n`layout` option will determine whether to place it above/below\nor on the side of the plot area."
          },
          "subtree": {}
        },
        "x": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "x",
            "excludes": {},
            "default": "0",
            "description": "The x offset of the legend relative to its horizontal alignment\n`align` within chart.spacingLeft and chart.spacingRight. Negative\nx moves it to the left, positive x moves it to the right."
          },
          "subtree": {}
        },
        "y": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "y",
            "excludes": {},
            "default": "0",
            "description": "The vertical offset of the legend relative to it's vertical alignment\n`verticalAlign` within chart.spacingTop and chart.spacingBottom.\n Negative y moves it up, positive y moves it down."
          },
          "subtree": {}
        },
        "title": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "title",
            "excludes": {},
            "description": "A title to be added on top of the legend."
          },
          "subtree": {
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "default": "{\"fontWeight\":\"bold\"}",
                "description": "Generic CSS styles for the legend title."
              },
              "subtree": {
                "fontWeight": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "bold"
                  },
                  "subtree": {}
                }
              }
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "default": "null",
                "description": "A text or HTML string for the title."
              },
              "subtree": {}
            }
          }
        },
        "backgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "backgroundColor",
            "excludes": {},
            "description": "The background color of the legend."
          },
          "subtree": {}
        },
        "borderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderWidth",
            "excludes": {},
            "default": "0",
            "description": "The width of the drawn border around the legend."
          },
          "subtree": {}
        },
        "floating": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "floating",
            "excludes": {},
            "default": "false",
            "description": "When the legend is floating, the plot area ignores it and is allowed\nto be placed below it."
          },
          "subtree": {}
        },
        "itemDistance": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "itemDistance",
            "excludes": {},
            "description": "In a legend with horizontal layout, the itemDistance defines the\npixel distance between each item."
          },
          "subtree": {}
        },
        "itemMarginBottom": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "itemMarginBottom",
            "excludes": {},
            "default": "0",
            "description": "The pixel bottom margin for each legend item."
          },
          "subtree": {}
        },
        "itemMarginTop": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "itemMarginTop",
            "excludes": {},
            "default": "0",
            "description": "The pixel top margin for each legend item."
          },
          "subtree": {}
        },
        "itemWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "itemWidth",
            "excludes": {},
            "default": "null",
            "description": "The width for each legend item. This is useful in a horizontal layout\nwith many items when you want the items to align vertically. ."
          },
          "subtree": {}
        },
        "labelFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "labelFormat",
            "excludes": {},
            "default": "{name}",
            "description": "A [format string](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting) for each legend label. Available variables\nrelates to properties on the series, or the point in case of pies."
          },
          "subtree": {}
        },
        "lineHeight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "lineHeight",
            "excludes": {},
            "default": "16",
            "products": {
              "highcharts": 1
            },
            "description": "Line height for the legend items. Deprecated as of 2.1\\. Instead,\nthe line height for each item can be set using itemStyle.lineHeight,\nand the padding between items using itemMarginTop and itemMarginBottom."
          },
          "subtree": {}
        },
        "margin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "margin",
            "excludes": {},
            "default": "12",
            "description": "If the plot area sized is calculated automatically and the legend\nis not floating, the legend margin is the space between the legend\nand the axis labels or plot area."
          },
          "subtree": {}
        },
        "maxHeight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxHeight",
            "excludes": {},
            "default": "undefined",
            "description": "Maximum pixel height for the legend. When the maximum height is extended,\n navigation will show."
          },
          "subtree": {}
        },
        "padding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "padding",
            "excludes": {},
            "default": "8",
            "description": "The inner padding of the legend box."
          },
          "subtree": {}
        },
        "reversed": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "reversed",
            "excludes": {},
            "default": "false",
            "description": "Whether to reverse the order of the legend items compared to the\norder of the series or points as defined in the configuration object."
          },
          "subtree": {}
        },
        "rtl": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "rtl",
            "excludes": {},
            "default": "false",
            "description": "Whether to show the symbol on the right side of the text rather than\nthe left side. This is common in Arabic and Hebraic."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "CSS styles for the legend area. In the 1.x versions the position\nof the legend area was determined by CSS. In 2.x, the position is\ndetermined by properties like `align`, `verticalAlign`, `x` and `y`,\n but the styles are still parsed for backwards compatibility."
          },
          "subtree": {}
        },
        "symbolHeight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "symbolHeight",
            "excludes": {},
            "description": "The pixel height of the symbol for series types that use a rectangle\nin the legend. Defaults to the font size of legend items."
          },
          "subtree": {}
        },
        "symbolRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "symbolRadius",
            "excludes": {},
            "description": "The border radius of the symbol for series types that use a rectangle\nin the legend. Defaults to half the `symbolHeight`."
          },
          "subtree": {}
        },
        "symbolWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "symbolWidth",
            "excludes": {},
            "description": "The pixel width of the legend item symbol. When the `squareSymbol`\noption is set, this defaults to the `symbolHeight`, otherwise 16."
          },
          "subtree": {}
        },
        "useHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useHTML",
            "excludes": {},
            "default": "false",
            "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the legend item texts. Prior\nto 4.1.7, when using HTML, [legend.navigation](#legend.navigation)\nwas disabled."
          },
          "subtree": {}
        },
        "width": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "width",
            "excludes": {},
            "default": "null",
            "description": "The width of the legend box."
          },
          "subtree": {}
        }
      }
    },
    "noData": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "noData",
        "excludes": {},
        "description": "Options for displaying a message like \"No data to display\". \nThis feature requires the file no-data-to-display.js to be loaded in the\npage. The actual text to display is set in the lang.noData option."
      },
      "subtree": {
        "position": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "position",
            "excludes": {},
            "default": "{ \"x\": 0, \"y\": 0, \"align\": \"center\", \"verticalAlign\": \"middle\" }",
            "description": "The position of the no-data label, relative to the plot area."
          },
          "subtree": {
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Horizontal offset of the label, in pixels."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Vertical offset of the label, in pixels."
              },
              "subtree": {}
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "center",
                "description": "Horizontal alignment of the label."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "default": "middle",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Vertical alignment of the label."
              },
              "subtree": {}
            }
          }
        },
        "attr": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "attr",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An object of additional SVG attributes for the no-data label."
          },
          "subtree": {}
        },
        "useHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useHTML",
            "excludes": {},
            "default": "false",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Whether to insert the label as HTML, or as pseudo-HTML rendered with\nSVG."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "style",
            "excludes": {},
            "description": "CSS styles for the no-data label."
          },
          "subtree": {
            "fontWeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontWeight",
                "excludes": {},
                "default": "bold"
              },
              "subtree": {}
            },
            "fontSize": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontSize",
                "excludes": {},
                "default": "12px"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#666666"
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "global": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "global",
        "excludes": {}
      },
      "subtree": {
        "VMLRadialGradientURL": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "VMLRadialGradientURL",
            "excludes": {},
            "description": "Path to the pattern image required by VML browsers in order to\ndraw radial gradients."
          },
          "subtree": {}
        },
        "canvasToolsURL": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "canvasToolsURL",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "_Canvg rendering for Android 2.x is removed as of Highcharts 5.0\\.\nUse the [libURL](#exporting.libURL) option to configure exporting._\n\nThe URL to the additional file to lazy load for Android 2.x devices.\nThese devices don't support SVG, so we download a helper file that\ncontains [canvg](http://code.google.com/p/canvg/), its dependency\nrbcolor, and our own CanVG Renderer class. To avoid hotlinking to\nour site, you can install canvas-tools.js on your own server and\nchange this option accordingly."
          },
          "subtree": {}
        },
        "useUTC": {
          "meta": {
            "types": {},
            "name": "useUTC",
            "excludes": {},
            "description": "This option is deprecated since v6.0.5. Instead, use\n[time.useUTC](#time.useUTC) that supports individual time settings\nper chart."
          },
          "subtree": {}
        },
        "Date": {
          "meta": {
            "types": {},
            "name": "Date",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "This option is deprecated since v6.0.5. Instead, use\n[time.Date](#time.Date) that supports individual time settings\nper chart."
          },
          "subtree": {}
        },
        "getTimezoneOffset": {
          "meta": {
            "types": {},
            "name": "getTimezoneOffset",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "This option is deprecated since v6.0.5. Instead, use\n[time.getTimezoneOffset](#time.getTimezoneOffset) that supports\nindividual time settings per chart."
          },
          "subtree": {}
        },
        "timezone": {
          "meta": {
            "types": {},
            "name": "timezone",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "This option is deprecated since v6.0.5. Instead, use\n[time.timezone](#time.timezone) that supports individual time\nsettings per chart."
          },
          "subtree": {}
        },
        "timezoneOffset": {
          "meta": {
            "types": {},
            "name": "timezoneOffset",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "This option is deprecated since v6.0.5. Instead, use\n[time.timezoneOffset](#time.timezoneOffset) that supports individual\ntime settings per chart."
          },
          "subtree": {}
        }
      }
    },
    "xAxis": {
      "meta": {
        "types": {
          "array": "xAxis"
        },
        "name": "xAxis",
        "excludes": {},
        "description": "The X axis or category axis. Normally this is the horizontal axis,\nthough if the chart is inverted this is the vertical axis. In case of\nmultiple axes, the xAxis node is an array of configuration objects.\n\nSee [the Axis object](#Axis) for programmatic access to the axis."
      },
      "subtree": {
        "dateTimeLabelFormats": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "dateTimeLabelFormats",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "For a datetime axis, the scale will automatically adjust to the\nappropriate unit. This member gives the default string\nrepresentations used for each unit. For intermediate values,\ndifferent units may be used, for example the `day` unit can be used\non midnight and `hour` unit be used for intermediate values on the\nsame axis. For an overview of the replacement codes, see\n[dateFormat](#Highcharts.dateFormat). Defaults to:\n\n<pre>{\n    millisecond: '%H:%M:%S.%L',\n    second: '%H:%M:%S',\n    minute: '%H:%M',\n    hour: '%H:%M',\n    day: '%e. %b',\n    week: '%e. %b',\n    month: '%b \\'%y',\n    year: '%Y'\n}</pre>"
          },
          "subtree": {
            "millisecond": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "millisecond",
                "excludes": {},
                "default": "%H:%M:%S.%L"
              },
              "subtree": {}
            },
            "second": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "second",
                "excludes": {},
                "default": "%H:%M:%S"
              },
              "subtree": {}
            },
            "minute": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "minute",
                "excludes": {},
                "default": "%H:%M"
              },
              "subtree": {}
            },
            "hour": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "hour",
                "excludes": {},
                "default": "%H:%M"
              },
              "subtree": {}
            },
            "day": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "day",
                "excludes": {},
                "default": "%e. %b"
              },
              "subtree": {}
            },
            "week": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "week",
                "excludes": {},
                "default": "%e. %b"
              },
              "subtree": {}
            },
            "month": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "month",
                "excludes": {},
                "default": "%b '%y"
              },
              "subtree": {}
            },
            "year": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "year",
                "excludes": {},
                "default": "%Y"
              },
              "subtree": {}
            }
          }
        },
        "endOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "endOnTick",
            "excludes": {},
            "default": false,
            "description": "Whether to force the axis to end on a tick. Use this option with\nthe `maxPadding` option to control the axis end."
          },
          "subtree": {}
        },
        "labels": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "labels",
            "excludes": {},
            "description": "The axis labels show the number or category for each tick."
          },
          "subtree": {
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": true,
                "description": "Enable or disable the axis labels."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "description": "CSS styles for the label. Use `whiteSpace: 'nowrap'` to prevent\nwrapping of category labels. Use `textOverflow: 'none'` to\nprevent ellipsis (dots).\n\nIn styled mode, the labels are styled with the\n`.highcharts-axis-labels` class."
              },
              "subtree": {
                "color": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "default": "#666666"
                  },
                  "subtree": {}
                },
                "cursor": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "cursor",
                    "excludes": {},
                    "default": "default"
                  },
                  "subtree": {}
                },
                "fontSize": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontSize",
                    "excludes": {},
                    "default": "11px"
                  },
                  "subtree": {}
                }
              }
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": 0,
                "description": "The x position offset of the label relative to the tick position\non the axis."
              },
              "subtree": {}
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "description": "What part of the string the given position is anchored to.\nIf `left`, the left side of the string is at the axis position.\nCan be one of `\"left\"`, `\"center\"` or `\"right\"`. Defaults to\nan intelligent guess based on which side of the chart the axis\nis on and the rotation of the label."
              },
              "subtree": {}
            },
            "autoRotation": {
              "meta": {
                "types": {
                  "array": "Number"
                },
                "name": "autoRotation",
                "excludes": {},
                "default": "[-45]",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "For horizontal axes, the allowed degrees of label rotation\nto prevent overlapping labels. If there is enough space,\nlabels are not rotated. As the chart gets narrower, it\nwill start rotating the labels -45 degrees, then remove\nevery second label and try again with rotations 0 and -45 etc.\nSet it to `false` to disable rotation, which will\ncause the labels to word-wrap if possible."
              },
              "subtree": {}
            },
            "autoRotationLimit": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "autoRotationLimit",
                "excludes": {},
                "default": "80",
                "products": {
                  "highcharts": 1
                },
                "description": "When each category width is more than this many pixels, we don't\napply auto rotation. Instead, we lay out the axis label with word\nwrap. A lower limit makes sense when the label contains multiple\nshort words that don't extend the available horizontal space for\neach label."
              },
              "subtree": {}
            },
            "distance": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "distance",
                "excludes": {},
                "default": "15",
                "products": {
                  "highcharts": 1
                },
                "description": "Polar charts only. The label's pixel distance from the perimeter\nof the plot area."
              },
              "subtree": {}
            },
            "format": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "format",
                "excludes": {},
                "default": "{value}",
                "description": "A [format string](http://www.highcharts.com/docs/chart-\nconcepts/labels-and-string-formatting) for the axis label."
              },
              "subtree": {}
            },
            "formatter": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "formatter",
                "excludes": {},
                "description": "Callback JavaScript function to format the label. The value\nis given by `this.value`. Additional properties for `this` are\n`axis`, `chart`, `isFirst` and `isLast`. The value of the default\nlabel formatter can be retrieved by calling\n`this.axis.defaultLabelFormatter.call(this)` within the function.\n\nDefaults to:\n\n<pre>function() {\n    return this.value;\n}</pre>"
              },
              "subtree": {}
            },
            "overflow": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "overflow",
                "excludes": {},
                "description": "How to handle overflowing labels on horizontal axis. Can be\nundefined, `false` or `\"justify\"`. By default it aligns inside\nthe chart area. If \"justify\", labels will not render outside\nthe plot area. If `false`, it will not be aligned at all.\nIf there is room to move it, it will be aligned to the edge,\nelse it will be removed."
              },
              "subtree": {}
            },
            "padding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "padding",
                "excludes": {},
                "default": "5",
                "products": {
                  "highcharts": 1
                },
                "description": "The pixel padding for axis labels, to ensure white space between\nthem."
              },
              "subtree": {}
            },
            "reserveSpace": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "reserveSpace",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1
                },
                "description": "Whether to reserve space for the labels. By default, space is\nreserved for the labels in these cases:\n\n* On all horizontal axes.\n* On vertical axes if `label.align` is `right` on a left-side\naxis or `left` on a right-side axis.\n* On vertical axes if `label.align` is `center`.\n\nThis can be turned off when for example the labels are rendered\ninside the plot area instead of outside."
              },
              "subtree": {}
            },
            "rotation": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rotation",
                "excludes": {},
                "default": "0",
                "description": "Rotation of the labels in degrees."
              },
              "subtree": {}
            },
            "staggerLines": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "staggerLines",
                "excludes": {},
                "default": "null",
                "description": "Horizontal axes only. The number of lines to spread the labels\nover to make room or tighter labels."
              },
              "subtree": {}
            },
            "step": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "step",
                "excludes": {},
                "default": "null",
                "description": "To show only every _n_'th label on the axis, set the step to _n_.\nSetting the step to 2 shows every other label.\n\nBy default, the step is calculated automatically to avoid\noverlap. To prevent this, set it to 1\\. This usually only\nhappens on a category axis, and is often a sign that you have\nchosen the wrong axis type.\n\nRead more at\n[Axis docs](http://www.highcharts.com/docs/chart-concepts/axes)\n=> What axis should I use?"
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": "null",
                "description": "The y position offset of the label relative to the tick position\non the axis. The default makes it adapt to the font size on\nbottom axis."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": "7",
                "description": "The Z index for the axis labels."
              },
              "subtree": {}
            },
            "useHTML": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "useHTML",
                "excludes": {},
                "default": "false",
                "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-\nconcepts/labels-and-string-formatting#html) to render the labels."
              },
              "subtree": {}
            },
            "position3d": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position3d",
                "excludes": {},
                "default": "offset",
                "products": {
                  "highcharts": 1
                },
                "description": "Defines how the labels are be repositioned according to the 3D chart\norientation.\n- `'offset'`: Maintain a fixed horizontal/vertical distance from the\n\t tick marks, despite the chart orientation. This is the backwards\n\t compatible behavior, and causes skewing of X and Z axes.\n- `'chart'`: Preserve 3D position relative to the chart.\n  This looks nice, but hard to read if the text isn't\n  forward-facing.\n- `'flap'`: Rotated text along the axis to compensate for the chart\n\t orientation. This tries to maintain text as legible as possible on\n\t all orientations.\n- `'ortho'`: Rotated text along the axis direction so that the labels\n\t are orthogonal to the axis. This is very similar to `'flap'`, but\n\t prevents skewing the labels (X and Y scaling are still present)."
              },
              "subtree": {}
            },
            "skew3d": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "skew3d",
                "excludes": {},
                "default": false,
                "products": {
                  "highcharts": 1
                },
                "description": "If enabled, the axis labels will skewed to follow the perspective. \n\nThis will fix overlapping labels and titles, but texts become less\nlegible due to the distortion.\n\nThe final appearance depends heavily on `labels.position3d`."
              },
              "subtree": {}
            },
            "maxStaggerLines": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "maxStaggerLines",
                "excludes": {},
                "default": "5",
                "products": {
                  "highstock": 1,
                  "highmaps": 1
                },
                "description": "Horizontal axis only. When `staggerLines` is not set, `maxStaggerLines`\ndefines how many lines the axis is allowed to add to automatically\navoid overlapping X labels. Set to `1` to disable overlap detection."
              },
              "subtree": {}
            }
          }
        },
        "maxPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxPadding",
            "excludes": {},
            "default": 0.01,
            "description": "Padding of the max value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer. This is useful\nwhen you don't want the highest data value to appear on the edge\nof the plot area. When the axis' `max` option is set or a max extreme\nis set using `axis.setExtremes()`, the maxPadding will be ignored."
          },
          "subtree": {}
        },
        "minorTickLength": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minorTickLength",
            "excludes": {},
            "default": 2,
            "description": "The pixel length of the minor tick marks."
          },
          "subtree": {}
        },
        "minorTickPosition": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "minorTickPosition",
            "excludes": {},
            "default": "outside",
            "description": "The position of the minor tick marks relative to the axis line.\n Can be one of `inside` and `outside`."
          },
          "subtree": {}
        },
        "minPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minPadding",
            "excludes": {},
            "default": 0.01,
            "description": "Padding of the min value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer. This is useful\nwhen you don't want the lowest data value to appear on the edge\nof the plot area. When the axis' `min` option is set or a min extreme\nis set using `axis.setExtremes()`, the minPadding will be ignored."
          },
          "subtree": {}
        },
        "startOfWeek": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "startOfWeek",
            "excludes": {},
            "default": 1,
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "For datetime axes, this decides where to put the tick between weeks.\n 0 = Sunday, 1 = Monday."
          },
          "subtree": {}
        },
        "startOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "startOnTick",
            "excludes": {},
            "default": false,
            "description": "Whether to force the axis to start on a tick. Use this option with\nthe `minPadding` option to control the axis start."
          },
          "subtree": {}
        },
        "tickLength": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickLength",
            "excludes": {},
            "default": 10,
            "description": "The pixel length of the main tick marks."
          },
          "subtree": {}
        },
        "tickmarkPlacement": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "tickmarkPlacement",
            "excludes": {},
            "default": "between",
            "products": {
              "highcharts": 1
            },
            "description": "For categorized axes only. If `on` the tick mark is placed in the\ncenter of the category, if `between` the tick mark is placed between\ncategories. The default is `between` if the `tickInterval` is 1,\n else `on`."
          },
          "subtree": {}
        },
        "tickPixelInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickPixelInterval",
            "excludes": {},
            "default": 100,
            "description": "If tickInterval is `null` this option sets the approximate pixel\ninterval of the tick marks. Not applicable to categorized axis.\n\nThe tick interval is also influenced by the [minTickInterval](#xAxis.\nminTickInterval) option, that, by default prevents ticks from being\ndenser than the data points."
          },
          "subtree": {}
        },
        "tickPosition": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "tickPosition",
            "excludes": {},
            "default": "outside",
            "description": "The position of the major tick marks relative to the axis line.\nCan be one of `inside` and `outside`."
          },
          "subtree": {}
        },
        "title": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "title",
            "excludes": {},
            "description": "The axis title, showing next to the axis line."
          },
          "subtree": {
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "middle",
                "description": "Alignment of the title relative to the axis values. Possible\nvalues are \"low\", \"middle\" or \"high\"."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "default": "{ \"color\": \"#666666\" }",
                "description": "CSS styles for the title. If the title text is longer than the\naxis length, it will wrap to multiple lines by default. This can\nbe customized by setting `textOverflow: 'ellipsis'`, by \nsetting a specific `width` or by setting `whiteSpace: 'nowrap'`.\n\nIn styled mode, the stroke width is given in the\n`.highcharts-axis-title` class."
              },
              "subtree": {
                "color": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "color",
                    "excludes": {},
                    "default": "#666666"
                  },
                  "subtree": {}
                }
              }
            },
            "position3d": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position3d",
                "excludes": {},
                "default": null,
                "products": {
                  "highcharts": 1
                },
                "description": "Defines how the title is repositioned according to the 3D chart\norientation.\n- `'offset'`: Maintain a fixed horizontal/vertical distance from the\n  tick marks, despite the chart orientation. This is the backwards\n  compatible behavior, and causes skewing of X and Z axes.\n- `'chart'`: Preserve 3D position relative to the chart.\n  This looks nice, but hard to read if the text isn't\n  forward-facing.\n- `'flap'`: Rotated text along the axis to compensate for the chart\n  orientation. This tries to maintain text as legible as possible on\n  all orientations.\n- `'ortho'`: Rotated text along the axis direction so that the labels\n  are orthogonal to the axis. This is very similar to `'flap'`, but\n  prevents skewing the labels (X and Y scaling are still present).\n- `null`: Will use the config from `labels.position3d`"
              },
              "subtree": {}
            },
            "skew3d": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "skew3d",
                "excludes": {},
                "default": null,
                "products": {
                  "highcharts": 1
                },
                "description": "If enabled, the axis title will skewed to follow the perspective.\n\nThis will fix overlapping labels and titles, but texts become less\nlegible due to the distortion.\n\nThe final appearance depends heavily on `title.position3d`.\n\nA `null` value will use the config from `labels.skew3d`."
              },
              "subtree": {}
            },
            "enabled": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "middle",
                "products": {
                  "highcharts": 1
                },
                "description": "Deprecated. Set the `text` to `null` to disable the title."
              },
              "subtree": {}
            },
            "margin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "margin",
                "excludes": {},
                "description": "The pixel distance between the axis labels or line and the title.\n Defaults to 0 for horizontal axes, 10 for vertical"
              },
              "subtree": {}
            },
            "offset": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "offset",
                "excludes": {},
                "description": "The distance of the axis title from the axis line. By default, this\ndistance is computed from the offset width of the labels, the labels'\ndistance from the axis and the title's margin. However when the offset\noption is set, it overrides all this."
              },
              "subtree": {}
            },
            "reserveSpace": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "reserveSpace",
                "excludes": {},
                "default": "true",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to reserve space for the title when laying out the axis."
              },
              "subtree": {}
            },
            "rotation": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rotation",
                "excludes": {},
                "default": "0",
                "description": "The rotation of the text in degrees. 0 is horizontal, 270 is vertical\nreading from bottom to top."
              },
              "subtree": {}
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "default": "null",
                "description": "The actual text of the axis title. It can contain basic HTML text\nmarkup like <b>, <i> and spans with style."
              },
              "subtree": {}
            },
            "useHTML": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "useHTML",
                "excludes": {},
                "default": "false",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the axis title."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Horizontal pixel offset of the title position."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Vertical pixel offset of the title position."
              },
              "subtree": {}
            }
          }
        },
        "type": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "type",
            "excludes": {},
            "default": "linear",
            "products": {
              "highcharts": 1
            },
            "description": "The type of axis. Can be one of `linear`, `logarithmic`, `datetime`\nor `category`. In a datetime axis, the numbers are given in\nmilliseconds, and tick marks are placed on appropriate values like\nfull hours or days. In a category axis, the \n[point names](#series.line.data.name) of the chart's series are used\nfor categories, if not a [categories](#xAxis.categories) array is\ndefined."
          },
          "subtree": {}
        },
        "minorGridLineColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "minorGridLineColor",
            "excludes": {},
            "default": "#f2f2f2",
            "description": "Color of the minor, secondary grid lines.\n\nIn styled mode, the stroke width is given in the\n`.highcharts-minor-grid-line` class."
          },
          "subtree": {}
        },
        "minorGridLineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minorGridLineWidth",
            "excludes": {},
            "default": 1,
            "description": "Width of the minor, secondary grid lines.\n\nIn styled mode, the stroke width is given in the\n`.highcharts-grid-line` class."
          },
          "subtree": {}
        },
        "minorTickColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "minorTickColor",
            "excludes": {},
            "default": "#999999",
            "description": "Color for the minor tick marks."
          },
          "subtree": {}
        },
        "lineColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "lineColor",
            "excludes": {},
            "default": "#ccd6eb",
            "description": "The color of the line marking the axis itself.\n\nIn styled mode, the line stroke is given in the\n`.highcharts-axis-line` or `.highcharts-xaxis-line` class."
          },
          "subtree": {}
        },
        "lineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "lineWidth",
            "excludes": {},
            "default": 1,
            "description": "The width of the line marking the axis itself.\n\nIn styled mode, the stroke width is given in the\n`.highcharts-axis-line` or `.highcharts-xaxis-line` class."
          },
          "subtree": {}
        },
        "gridLineColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "gridLineColor",
            "excludes": {},
            "default": "#e6e6e6",
            "description": "Color of the grid lines extending the ticks across the plot area.\n\nIn styled mode, the stroke is given in the `.highcharts-grid-line`\nclass."
          },
          "subtree": {}
        },
        "tickColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "tickColor",
            "excludes": {},
            "default": "#ccd6eb",
            "description": "Color for the main tick marks.\n\nIn styled mode, the stroke is given in the `.highcharts-tick`\nclass."
          },
          "subtree": {}
        },
        "allowDecimals": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allowDecimals",
            "excludes": {},
            "default": "true",
            "description": "Whether to allow decimals in this axis' ticks. When counting\nintegers, like persons or hits on a web page, decimals should\nbe avoided in the labels."
          },
          "subtree": {}
        },
        "alternateGridColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "alternateGridColor",
            "excludes": {},
            "default": "null",
            "description": "When using an alternate grid color, a band is painted across the\nplot area between every other grid line."
          },
          "subtree": {}
        },
        "breaks": {
          "meta": {
            "types": {
              "array": "object"
            },
            "name": "breaks",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An array defining breaks in the axis, the sections defined will be\nleft out and all the points shifted closer to each other."
          },
          "subtree": {
            "breakSize": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "breakSize",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "A number indicating how much space should be left between the start\nand the end of the break. The break size is given in axis units,\nso for instance on a `datetime` axis, a break size of 3600000 would\nindicate the equivalent of an hour."
              },
              "subtree": {}
            },
            "from": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "from",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The point where the break starts."
              },
              "subtree": {}
            },
            "repeat": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "repeat",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Defines an interval after which the break appears again. By default\nthe breaks do not repeat."
              },
              "subtree": {}
            },
            "to": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "to",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The point where the break ends."
              },
              "subtree": {}
            }
          }
        },
        "categories": {
          "meta": {
            "types": {
              "array": "String"
            },
            "name": "categories",
            "excludes": {},
            "default": "null",
            "products": {
              "highcharts": 1
            },
            "description": "If categories are present for the xAxis, names are used instead of\nnumbers for that axis. Since Highcharts 3.0, categories can also\nbe extracted by giving each point a [name](#series.data) and setting\naxis [type](#xAxis.type) to `category`. However, if you have multiple\nseries, best practice remains defining the `categories` array.\n\nExample:\n\n<pre>categories: ['Apples', 'Bananas', 'Oranges']</pre>"
          },
          "subtree": {}
        },
        "ceiling": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "ceiling",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The highest allowed value for automatically computed axis extremes."
          },
          "subtree": {}
        },
        "className": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "className",
            "excludes": {},
            "description": "A class name that opens for styling the axis by CSS, especially in\nHighcharts styled mode. The class name is applied to group elements\nfor the grid, axis elements and labels."
          },
          "subtree": {}
        },
        "crosshair": {
          "meta": {
            "types": {
              "boolean": 1,
              "object": 1
            },
            "name": "crosshair",
            "excludes": {},
            "default": "false",
            "description": "Configure a crosshair that follows either the mouse pointer or the\nhovered point.\n\nIn styled mode, the crosshairs are styled in the\n`.highcharts-crosshair`, `.highcharts-crosshair-thin` or\n`.highcharts-xaxis-category` classes."
          },
          "subtree": {
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "description": "A class name for the crosshair, especially as a hook for styling."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#cccccc",
                "description": "The color of the crosshair. Defaults to `#cccccc` for numeric and\ndatetime axes, and `rgba(204,214,235,0.25)` for category axes, where\nthe crosshair by default highlights the whole category."
              },
              "subtree": {}
            },
            "dashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "dashStyle",
                "excludes": {},
                "default": "Solid",
                "description": "The dash style for the crosshair. See\n[series.dashStyle](#plotOptions.series.dashStyle)\nfor possible values."
              },
              "subtree": {}
            },
            "snap": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "snap",
                "excludes": {},
                "default": "true",
                "description": "Whether the crosshair should snap to the point or follow the pointer\nindependent of points."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": "1",
                "description": "The pixel width of the crosshair. Defaults to 1 for numeric or\ndatetime axes, and for one category width for category axes."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": "2",
                "description": "The Z index of the crosshair. Higher Z indices allow drawing the\ncrosshair on top of the series or behind the grid lines."
              },
              "subtree": {}
            },
            "label": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "label",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "A label on the axis next to the crosshair.\n\nIn styled mode, the label is styled with the `.highcharts-crosshair-label` class."
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "Alignment of the label compared to the axis. Defaults to `left` for\nright-side axes, `right` for left-side axes and `center` for horizontal\naxes."
                  },
                  "subtree": {}
                },
                "backgroundColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "backgroundColor",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "The background color for the label. Defaults to the related series\ncolor, or `#666666` if that is not available."
                  },
                  "subtree": {}
                },
                "borderColor": {
                  "meta": {
                    "types": {
                      "color": 1
                    },
                    "name": "borderColor",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "The border color for the crosshair label"
                  },
                  "subtree": {}
                },
                "borderRadius": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderRadius",
                    "excludes": {},
                    "default": "3",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The border corner radius of the crosshair label."
                  },
                  "subtree": {}
                },
                "borderWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "borderWidth",
                    "excludes": {},
                    "default": "0",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The border width for the crosshair label."
                  },
                  "subtree": {}
                },
                "format": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "format",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "A format string for the crosshair label. Defaults to `{value}` for\nnumeric axes and `{value:%b %d, %Y}` for datetime axes."
                  },
                  "subtree": {}
                },
                "formatter": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "formatter",
                    "excludes": {},
                    "products": {
                      "highstock": 1
                    },
                    "description": "Formatter function for the label text."
                  },
                  "subtree": {}
                },
                "padding": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "padding",
                    "excludes": {},
                    "default": "8",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Padding inside the crosshair label."
                  },
                  "subtree": {}
                },
                "shape": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "shape",
                    "excludes": {},
                    "default": "callout",
                    "products": {
                      "highstock": 1
                    },
                    "description": "The shape to use for the label box."
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "cssobject": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "default": "{ \"color\": \"white\", \"fontWeight\": \"normal\", \"fontSize\": \"11px\", \"textAlign\": \"center\" }",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Text styles for the crosshair label."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "description": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "description",
            "excludes": {},
            "default": "undefined",
            "description": "_Requires Accessibility module_\n\nDescription of the axis to screen reader users."
          },
          "subtree": {}
        },
        "events": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "events",
            "excludes": {},
            "description": "Event handlers for the axis."
          },
          "subtree": {
            "afterBreaks": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "afterBreaks",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "An event fired after the breaks have rendered."
              },
              "subtree": {}
            },
            "afterSetExtremes": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "afterSetExtremes",
                "excludes": {},
                "description": "As opposed to the `setExtremes` event, this event fires after the\nfinal min and max values are computed and corrected for `minRange`.\n\n\nFires when the minimum and maximum is set for the axis, either by\ncalling the `.setExtremes()` method or by selecting an area in the\nchart. One parameter, `event`, is passed to the function, containing\ncommon event information.\n\nThe new user set minimum and maximum values can be found by\n`event.min` and `event.max`. These reflect the axis minimum and\nmaximum in axis values. The actual data extremes are found in\n`event.dataMin` and `event.dataMax`."
              },
              "subtree": {}
            },
            "pointBreak": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "pointBreak",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "An event fired when a break from this axis occurs on a point."
              },
              "subtree": {}
            },
            "pointInBreak": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "pointInBreak",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An event fired when a point falls inside a break from this axis."
              },
              "subtree": {}
            },
            "setExtremes": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "setExtremes",
                "excludes": {},
                "description": "Fires when the minimum and maximum is set for the axis, either by\ncalling the `.setExtremes()` method or by selecting an area in the\nchart. One parameter, `event`, is passed to the function,\ncontaining common event information.\n\nThe new user set minimum and maximum values can be found by\n`event.min` and `event.max`. These reflect the axis minimum and\nmaximum in data values. When an axis is zoomed all the way out from\nthe \"Reset zoom\" button, `event.min` and `event.max` are null, and\nthe new extremes are set based on `this.dataMin` and `this.dataMax`."
              },
              "subtree": {}
            }
          }
        },
        "floor": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "floor",
            "excludes": {},
            "default": "null",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The lowest allowed value for automatically computed axis extremes."
          },
          "subtree": {}
        },
        "gridLineDashStyle": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "gridLineDashStyle",
            "excludes": {},
            "default": "Solid",
            "description": "The dash or dot style of the grid lines. For possible values, see\n[this demonstration](http://jsfiddle.net/gh/get/library/pure/\nhighcharts/highcharts/tree/master/samples/highcharts/plotoptions/\nseries-dashstyle-all/)."
          },
          "subtree": {}
        },
        "gridZIndex": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "gridZIndex",
            "excludes": {},
            "default": "1",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The Z index of the grid lines."
          },
          "subtree": {}
        },
        "id": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "id",
            "excludes": {},
            "default": "null",
            "description": "An id for the axis. This can be used after render time to get\na pointer to the axis object through `chart.get()`."
          },
          "subtree": {}
        },
        "linkedTo": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "linkedTo",
            "excludes": {},
            "default": "null",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Index of another axis that this axis is linked to. When an axis is\nlinked to a master axis, it will take the same extremes as\nthe master, but as assigned by min or max or by setExtremes.\nIt can be used to show additional info, or to ease reading the\nchart by duplicating the scales."
          },
          "subtree": {}
        },
        "max": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "max",
            "excludes": {},
            "description": "The maximum value of the axis. If `null`, the max value is\nautomatically calculated.\n\nIf the `endOnTick` option is true, the `max` value might\nbe rounded up.\n\nIf a [tickAmount](#yAxis.tickAmount) is set, the axis may be extended\nbeyond the set max in order to reach the given number of ticks. The\nsame may happen in a chart with multiple axes, determined by [chart.\nalignTicks](#chart), where a `tickAmount` is applied internally."
          },
          "subtree": {}
        },
        "alignTicks": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "alignTicks",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "When using multiple axis, the ticks of two or more opposite axes\nwill automatically be aligned by adding ticks to the axis or axes\nwith the least ticks, as if `tickAmount` were specified.\n\nThis can be prevented by setting `alignTicks` to false. If the grid\nlines look messy, it's a good idea to hide them for the secondary\naxis by setting `gridLineWidth` to 0.\n\nIf `startOnTick` or `endOnTick` in an Axis options are set to false,\nthen the `alignTicks ` will be disabled for the Axis.\n\nDisabled for logarithmic axes."
          },
          "subtree": {}
        },
        "maxZoom": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxZoom",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Deprecated. Use `minRange` instead."
          },
          "subtree": {}
        },
        "min": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "min",
            "excludes": {},
            "description": "The minimum value of the axis. If `null` the min value is \nautomatically calculated.\n\nIf the `startOnTick` option is true (default), the `min` value might\nbe rounded down.\n\nThe automatically calculated minimum value is also affected by\n[floor](#yAxis.floor), [softMin](#yAxis.softMin),\n[minPadding](#yAxis.minPadding), [minRange](#yAxis.minRange)\nas well as [series.threshold](#plotOptions.series.threshold)\nand [series.softThreshold](#plotOptions.series.softThreshold)."
          },
          "subtree": {}
        },
        "minorGridLineDashStyle": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "minorGridLineDashStyle",
            "excludes": {},
            "default": "Solid",
            "description": "The dash or dot style of the minor grid lines. For possible values,\nsee [this demonstration](http://jsfiddle.net/gh/get/library/pure/\nhighcharts/highcharts/tree/master/samples/highcharts/plotoptions/\nseries-dashstyle-all/)."
          },
          "subtree": {}
        },
        "minorTickInterval": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "minorTickInterval",
            "excludes": {},
            "description": "Specific tick interval in axis units for the minor ticks.\nOn a linear axis, if `\"auto\"`, the minor tick interval is\ncalculated as a fifth of the tickInterval. If `null`, minor\nticks are not shown.\n\nOn logarithmic axes, the unit is the power of the value. For example,\nsetting the minorTickInterval to 1 puts one tick on each of 0.1,\n1, 10, 100 etc. Setting the minorTickInterval to 0.1 produces 9\nticks between 1 and 10, 10 and 100 etc.\n\nIf user settings dictate minor ticks to become too dense, they don't\nmake sense, and will be ignored to prevent performance problems."
          },
          "subtree": {}
        },
        "minorTicks": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "minorTicks",
            "excludes": {},
            "default": "false",
            "description": "Enable or disable minor ticks. Unless\n[minorTickInterval](#xAxis.minorTickInterval) is set, the tick\ninterval is calculated as a fifth of the `tickInterval`.\n\nOn a logarithmic axis, minor ticks are laid out based on a best\nguess, attempting to enter approximately 5 minor ticks between\neach major tick.\n\nPrior to v6.0.0, ticks were unabled in auto layout by setting\n`minorTickInterval` to `\"auto\"`."
          },
          "subtree": {}
        },
        "minorTickWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minorTickWidth",
            "excludes": {},
            "default": "0",
            "description": "The pixel width of the minor tick mark."
          },
          "subtree": {}
        },
        "minRange": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minRange",
            "excludes": {},
            "description": "The minimum range to display on this axis. The entire axis will not\nbe allowed to span over a smaller interval than this. For example,\nfor a datetime axis the main unit is milliseconds. If minRange is\nset to 3600000, you can't zoom in more than to one hour.\n\nThe default minRange for the x axis is five times the smallest\ninterval between any of the data points.\n\nOn a logarithmic axis, the unit for the minimum range is the power.\nSo a minRange of 1 means that the axis can be zoomed to 10-100,\n100-1000, 1000-10000 etc.\n\nNote that the `minPadding`, `maxPadding`, `startOnTick` and\n`endOnTick` settings also affect how the extremes of the axis\nare computed."
          },
          "subtree": {}
        },
        "minTickInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minTickInterval",
            "excludes": {},
            "description": "The minimum tick interval allowed in axis values. For example on\nzooming in on an axis with daily data, this can be used to prevent\nthe axis from showing hours. Defaults to the closest distance between\ntwo points on the axis."
          },
          "subtree": {}
        },
        "offset": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "offset",
            "excludes": {},
            "default": "0",
            "description": "The distance in pixels from the plot area to the axis line.\nA positive offset moves the axis with it's line, labels and ticks\naway from the plot area. This is typically used when two or more\naxes are displayed on the same side of the plot. With multiple\naxes the offset is dynamically adjusted to avoid collision, this\ncan be overridden by setting offset explicitly."
          },
          "subtree": {}
        },
        "opposite": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "opposite",
            "excludes": {},
            "default": "false",
            "description": "Whether to display the axis on the opposite side of the normal. The\nnormal is on the left side for vertical axes and bottom for\nhorizontal, so the opposite sides will be right and top respectively.\nThis is typically used with dual or multiple axes."
          },
          "subtree": {}
        },
        "pane": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "pane",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "Refers to the index in the [panes](#panes) array. Used for circular\ngauges and polar charts. When the option is not set then first pane\nwill be used."
          },
          "subtree": {}
        },
        "reversed": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "reversed",
            "excludes": {},
            "default": "false",
            "description": "Whether to reverse the axis so that the highest number is closest\nto the origin. If the chart is inverted, the x axis is reversed by\ndefault."
          },
          "subtree": {}
        },
        "showLastLabel": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showLastLabel",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Whether to show the last tick label. Defaults to `true` on cartesian\ncharts, and `false` on polar charts."
          },
          "subtree": {}
        },
        "gridLineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "gridLineWidth",
            "excludes": {},
            "default": "0",
            "description": "The width of the grid lines extending the ticks across the plot area.\n\nIn styled mode, the stroke width is given in the\n`.highcharts-grid-line` class."
          },
          "subtree": {}
        },
        "overscroll": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "overscroll",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "Additional range on the right side of the xAxis. Works similar to\n`xAxis.maxPadding`, but value is set in milliseconds. Can be set for both\nmain `xAxis` and the navigator's `xAxis`."
          },
          "subtree": {}
        },
        "maxRange": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxRange",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highstock": 1
            },
            "description": "Maximum range which can be set using the navigator's handles.\nOpposite of [xAxis.minRange](#xAxis.minRange)."
          },
          "subtree": {}
        },
        "scrollbar": {
          "meta": {
            "types": {},
            "name": "scrollbar",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "An optional scrollbar to display on the X axis in response to limiting\nthe minimum and maximum of the axis values.\n\nIn styled mode, all the presentational options for the scrollbar\nare replaced by the classes `.highcharts-scrollbar-thumb`, `.highcharts-scrollbar-arrow`, `.highcharts-scrollbar-button`, `.highcharts-scrollbar-rifles` and `.highcharts-scrollbar-track`.",
            "extends": "scrollbar"
          },
          "subtree": {}
        },
        "showEmpty": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showEmpty",
            "excludes": {},
            "default": "true",
            "description": "Whether to show the axis line and title when the axis has no data."
          },
          "subtree": {}
        },
        "showFirstLabel": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showFirstLabel",
            "excludes": {},
            "default": "true",
            "description": "Whether to show the first tick label."
          },
          "subtree": {}
        },
        "softMax": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "softMax",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A soft maximum for the axis. If the series data maximum is less than\nthis, the axis will stay at this maximum, but if the series data\nmaximum is higher, the axis will flex to show all data."
          },
          "subtree": {}
        },
        "softMin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "softMin",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A soft minimum for the axis. If the series data minimum is greater\nthan this, the axis will stay at this minimum, but if the series\ndata minimum is lower, the axis will flex to show all data."
          },
          "subtree": {}
        },
        "tickAmount": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickAmount",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The amount of ticks to draw on the axis. This opens up for aligning\nthe ticks of multiple charts or panes within a chart. This option\noverrides the `tickPixelInterval` option.\n\nThis option only has an effect on linear axes. Datetime, logarithmic\nor category axes are not affected."
          },
          "subtree": {}
        },
        "tickInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickInterval",
            "excludes": {},
            "default": "null",
            "description": "The interval of the tick marks in axis units. When `null`, the tick\ninterval is computed to approximately follow the [tickPixelInterval](#xAxis.\ntickPixelInterval) on linear and datetime axes. On categorized axes,\na `null` tickInterval will default to 1, one category. Note that\ndatetime axes are based on milliseconds, so for example an interval\nof one day is expressed as `24 * 3600 * 1000`.\n\nOn logarithmic axes, the tickInterval is based on powers, so a tickInterval\nof 1 means one tick on each of 0.1, 1, 10, 100 etc. A tickInterval\nof 2 means a tick of 0.1, 10, 1000 etc. A tickInterval of 0.2 puts\na tick on 0.1, 0.2, 0.4, 0.6, 0.8, 1, 2, 4, 6, 8, 10, 20, 40 etc.\n\n\nIf the tickInterval is too dense for labels to be drawn, Highcharts\nmay remove ticks.\n\nIf the chart has multiple axes, the [alignTicks](#chart.alignTicks)\noption may interfere with the `tickInterval` setting."
          },
          "subtree": {}
        },
        "tickPositioner": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "tickPositioner",
            "excludes": {},
            "description": "A callback function returning array defining where the ticks are\nlaid out on the axis. This overrides the default behaviour of [tickPixelInterval](#xAxis.\ntickPixelInterval) and [tickInterval](#xAxis.tickInterval). The automatic\ntick positions are accessible through `this.tickPositions` and can\nbe modified by the callback."
          },
          "subtree": {}
        },
        "tickPositions": {
          "meta": {
            "types": {
              "array": "Number"
            },
            "name": "tickPositions",
            "excludes": {},
            "description": "An array defining where the ticks are laid out on the axis. This\noverrides the default behaviour of [tickPixelInterval](#xAxis.tickPixelInterval)\nand [tickInterval](#xAxis.tickInterval)."
          },
          "subtree": {}
        },
        "tickWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickWidth",
            "excludes": {},
            "description": "The pixel width of the major tick marks.\n\nIn styled mode, the stroke width is given in the `.highcharts-tick` class."
          },
          "subtree": {}
        },
        "uniqueNames": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "uniqueNames",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1
            },
            "description": "Applies only when the axis `type` is `category`. When `uniqueNames`\nis true, points are placed on the X axis according to their names.\nIf the same point name is repeated in the same or another series,\nthe point is placed on the same X position as other points of the\nsame name. When `uniqueNames` is false, the points are laid out in\nincreasing X positions regardless of their names, and the X axis\ncategory will take the name of the last point in each position."
          },
          "subtree": {}
        },
        "units": {
          "meta": {
            "types": {
              "array": "object"
            },
            "name": "units",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Datetime axis only. An array determining what time intervals the\nticks are allowed to fall on. Each array item is an array where the\nfirst value is the time unit and the second value another array of\nallowed multiples. Defaults to:\n\n<pre>units: [[\n    'millisecond', // unit name\n    [1, 2, 5, 10, 20, 25, 50, 100, 200, 500] // allowed multiples\n], [\n    'second',\n    [1, 2, 5, 10, 15, 30]\n], [\n    'minute',\n    [1, 2, 5, 10, 15, 30]\n], [\n    'hour',\n    [1, 2, 3, 4, 6, 8, 12]\n], [\n    'day',\n    [1]\n], [\n    'week',\n    [1]\n], [\n    'month',\n    [1, 3, 6]\n], [\n    'year',\n    null\n]]</pre>"
          },
          "subtree": {}
        },
        "visible": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "visible",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Whether axis, including axis title, line, ticks and labels, should\nbe visible."
          },
          "subtree": {}
        },
        "plotBands": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "plotBands",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An array of colored bands stretching across the plot area marking\nan interval on the axis.\n\nIn styled mode, the plot bands are styled by the `.highcharts-plot-band` class in addition to the `className` option."
          },
          "subtree": {
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Border color for the plot band. Also requires `borderWidth` to be\nset."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Border width for the plot band. Also requires `borderColor` to be\nset."
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "description": "A custom class name, in addition to the default `highcharts-plot-band`, to\napply to each individual band."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The color of the plot band."
              },
              "subtree": {}
            },
            "events": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "events",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An object defining mouse events for the plot band. Supported properties\nare `click`, `mouseover`, `mouseout`, `mousemove`."
              },
              "subtree": {}
            },
            "from": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "from",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The start position of the plot band in axis units."
              },
              "subtree": {}
            },
            "id": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "id",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An id used for identifying the plot band in Axis.removePlotBand."
              },
              "subtree": {}
            },
            "to": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "to",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The end position of the plot band in axis units."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The z index of the plot band within the chart, relative to other\nelements. Using the same z index as another element may give unpredictable\nresults, as the last rendered element will be on top. Values from\n0 to 20 make sense."
              },
              "subtree": {}
            },
            "label": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "label",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Text labels for the plot bands"
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "center",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Horizontal alignment of the label. Can be one of \"left\", \"center\"\nor \"right\"."
                  },
                  "subtree": {}
                },
                "rotation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "rotation",
                    "excludes": {},
                    "default": "0",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Rotation of the text label in degrees ."
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "CSS styles for the text label.\n\nIn styled mode, the labels are styled by the `.highcharts-plot-band-label` class."
                  },
                  "subtree": {}
                },
                "text": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The string text itself. A subset of HTML is supported."
                  },
                  "subtree": {}
                },
                "textAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "textAlign",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "The text alignment for the label. While `align` determines where\nthe texts anchor point is placed within the plot band, `textAlign`\ndetermines how the text is aligned against its anchor point. Possible\nvalues are \"left\", \"center\" and \"right\". Defaults to the same as\nthe `align` option."
                  },
                  "subtree": {}
                },
                "useHTML": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "useHTML",
                    "excludes": {},
                    "default": "false",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the labels."
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "default": "top",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Vertical alignment of the label relative to the plot band. Can be\none of \"top\", \"middle\" or \"bottom\"."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Horizontal position relative the alignment. Default varies by orientation."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Vertical position of the text baseline relative to the alignment.\n Default varies by orientation."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "plotLines": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "plotLines",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "An array of lines stretching across the plot area, marking a specific\nvalue on one of the axes.\n\nIn styled mode, the plot lines are styled by the `.highcharts-plot-line` class in addition to the `className` option."
          },
          "subtree": {
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "description": "A custom class name, in addition to the default `highcharts-plot-line`, to\napply to each individual line."
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The color of the line."
              },
              "subtree": {}
            },
            "dashStyle": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "dashStyle",
                "excludes": {},
                "default": "Solid",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The dashing or dot style for the plot line. For possible values see\n[this overview](http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-\ndashstyle-all/)."
              },
              "subtree": {}
            },
            "events": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "events",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An object defining mouse events for the plot line. Supported properties\nare `click`, `mouseover`, `mouseout`, `mousemove`."
              },
              "subtree": {}
            },
            "id": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "id",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "An id used for identifying the plot line in Axis.removePlotLine."
              },
              "subtree": {}
            },
            "value": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "value",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The position of the line in axis units."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The width or thickness of the plot line."
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": "null",
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "The z index of the plot line within the chart."
              },
              "subtree": {}
            },
            "label": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "label",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highstock": 1
                },
                "description": "Text labels for the plot bands"
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "left",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Horizontal alignment of the label. Can be one of \"left\", \"center\"\nor \"right\"."
                  },
                  "subtree": {}
                },
                "rotation": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "rotation",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Rotation of the text label in degrees. Defaults to 0 for horizontal\nplot lines and 90 for vertical lines."
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "CSS styles for the text label.\n\nIn styled mode, the labels are styled by the\n`.highcharts-plot-line-label` class."
                  },
                  "subtree": {}
                },
                "text": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "products": {
                      "highcharts": 1
                    },
                    "description": "The text itself. A subset of HTML is supported."
                  },
                  "subtree": {}
                },
                "textAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "textAlign",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "The text alignment for the label. While `align` determines where\nthe texts anchor point is placed within the plot band, `textAlign`\ndetermines how the text is aligned against its anchor point. Possible\nvalues are \"left\", \"center\" and \"right\". Defaults to the same as\nthe `align` option."
                  },
                  "subtree": {}
                },
                "useHTML": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "useHTML",
                    "excludes": {},
                    "default": "false",
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the labels."
                  },
                  "subtree": {}
                },
                "verticalAlign": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "verticalAlign",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Vertical alignment of the label relative to the plot line. Can be\none of \"top\", \"middle\" or \"bottom\"."
                  },
                  "subtree": {}
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Horizontal position relative the alignment. Default varies by orientation."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "products": {
                      "highcharts": 1,
                      "highstock": 1
                    },
                    "description": "Vertical position of the text baseline relative to the alignment.\n Default varies by orientation."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "ordinal": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "ordinal",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "In an ordinal axis, the points are equally spaced in the chart regardless\nof the actual time or x distance between them. This means that missing\ndata for nights or weekends will not take up space in the chart."
          },
          "subtree": {}
        },
        "range": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "range",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highstock": 1
            },
            "description": "The zoomed range to display when only defining one or none of `min`\nor `max`. For example, to show the latest month, a range of one month\ncan be set."
          },
          "subtree": {}
        }
      }
    },
    "navigator": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "navigator",
        "excludes": {},
        "products": {
          "highstock": 1
        },
        "description": "The navigator is a small series below the main series, displaying\na view of the entire data set. It provides tools to zoom in and\nout on parts of the data as well as panning across the dataset."
      },
      "subtree": {
        "height": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "height",
            "excludes": {},
            "default": "40",
            "products": {
              "highstock": 1
            },
            "description": "The height of the navigator."
          },
          "subtree": {}
        },
        "margin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "margin",
            "excludes": {},
            "default": "25",
            "products": {
              "highstock": 1
            },
            "description": "The distance from the nearest element, the X axis or X axis labels."
          },
          "subtree": {}
        },
        "maskInside": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "maskInside",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Whether the mask should be inside the range marking the zoomed\nrange, or outside. In Highstock 1.x it was always `false`."
          },
          "subtree": {}
        },
        "handles": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "handles",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Options for the handles for dragging the zoomed area."
          },
          "subtree": {
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": "7",
                "products": {
                  "highstock": 1
                },
                "description": "Width for handles."
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "height",
                "excludes": {},
                "default": "15",
                "products": {
                  "highstock": 1
                },
                "description": "Height for handles."
              },
              "subtree": {}
            },
            "symbols": {
              "meta": {
                "types": {
                  "array": "object"
                },
                "name": "symbols",
                "excludes": {},
                "default": "['navigator-handle', 'navigator-handle']",
                "products": {
                  "highstock": 1
                },
                "description": "Array to define shapes of handles. 0-index for left, 1-index for\nright.\n\nAdditionally, the URL to a graphic can be given on this form:\n`url(graphic.png)`. Note that for the image to be applied to\nexported charts, its URL needs to be accessible by the export\nserver.\n\nCustom callbacks for symbol path generation can also be added to\n`Highcharts.SVGRenderer.prototype.symbols`. The callback is then\nused by its method name, as shown in the demo."
              },
              "subtree": {}
            },
            "enabled": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "enabled",
                "excludes": {},
                "default": "true",
                "products": {
                  "highstock": 1
                },
                "description": "Allows to enable/disable handles."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": "7",
                "products": {
                  "highstock": 1
                },
                "description": "The width for the handle border and the stripes inside."
              },
              "subtree": {}
            },
            "backgroundColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "backgroundColor",
                "excludes": {},
                "default": "#f2f2f2",
                "products": {
                  "highstock": 1
                },
                "description": "The fill for the handle."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#999999",
                "products": {
                  "highstock": 1
                },
                "description": "The stroke for the handle border and the stripes inside."
              },
              "subtree": {}
            }
          }
        },
        "maskFill": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "maskFill",
            "excludes": {},
            "default": "rgba(102,133,194,0.3)",
            "products": {
              "highstock": 1
            },
            "description": "The color of the mask covering the areas of the navigator series\nthat are currently not visible in the main series. The default\ncolor is bluish with an opacity of 0.3 to see the series below."
          },
          "subtree": {}
        },
        "outlineColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "outlineColor",
            "excludes": {},
            "default": "#cccccc",
            "products": {
              "highstock": 1
            },
            "description": "The color of the line marking the currently zoomed area in the\nnavigator."
          },
          "subtree": {}
        },
        "outlineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "outlineWidth",
            "excludes": {},
            "default": "2",
            "products": {
              "highstock": 1
            },
            "description": "The width of the line marking the currently zoomed area in the\nnavigator."
          },
          "subtree": {}
        },
        "series": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "series",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Options for the navigator series. Available options are the same\nas any series, documented at [plotOptions](#plotOptions.series)\nand [series](#series).\n\nUnless data is explicitly defined on navigator.series, the data\nis borrowed from the first series in the chart.\n\nDefault series options for the navigator series are:\n\n<pre>series: {\n    type: 'areaspline',\n    fillOpacity: 0.05,\n    dataGrouping: {\n        smoothed: true\n    },\n    lineWidth: 1,\n    marker: {\n        enabled: false\n    }\n}</pre>"
          },
          "subtree": {
            "type": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "type",
                "excludes": {},
                "description": "The type of the navigator series. Defaults to `areaspline` if\ndefined, otherwise `line`."
              },
              "subtree": {}
            },
            "fillOpacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "fillOpacity",
                "excludes": {},
                "default": 0.05,
                "description": "The fill opacity of the navigator series."
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 1,
                "description": "The pixel line width of the navigator series."
              },
              "subtree": {}
            },
            "compare": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "compare",
                "excludes": {},
                "default": null
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {},
                "description": "Data grouping options for the navigator series.",
                "extends": "{plotOptions.series.dataGrouping}"
              },
              "subtree": {
                "approximation": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "approximation",
                    "excludes": {},
                    "default": "average"
                  },
                  "subtree": {}
                },
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "groupPixelWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "groupPixelWidth",
                    "excludes": {},
                    "default": 2
                  },
                  "subtree": {}
                },
                "smoothed": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "smoothed",
                    "excludes": {},
                    "default": true
                  },
                  "subtree": {}
                },
                "units": {
                  "meta": {
                    "types": {},
                    "name": "units",
                    "excludes": {}
                  },
                  "subtree": {}
                }
              }
            },
            "dataLabels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataLabels",
                "excludes": {},
                "description": "Data label options for the navigator series. Data labels are\ndisabled by default on the navigator series.",
                "extends": "{plotOptions.series.dataLabels}"
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                },
                "zIndex": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "zIndex",
                    "excludes": {},
                    "default": 2
                  },
                  "subtree": {}
                }
              }
            },
            "id": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "id",
                "excludes": {},
                "default": "highcharts-navigator-series"
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "default": "highcharts-navigator-series"
              },
              "subtree": {}
            },
            "lineColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "lineColor",
                "excludes": {},
                "default": null,
                "description": "Line color for the navigator series. Allows setting the color\nwhile disallowing the default candlestick setting."
              },
              "subtree": {}
            },
            "marker": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "marker",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "pointRange": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "pointRange",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "threshold": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "threshold",
                "excludes": {},
                "default": null,
                "description": "The threshold option. Setting it to 0 will make the default\nnavigator area series draw its area from the 0 value and up."
              },
              "subtree": {}
            }
          }
        },
        "xAxis": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "xAxis",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Options for the navigator X axis. Default series options\nfor the navigator xAxis are:\n\n<pre>xAxis: {\n    tickWidth: 0,\n    lineWidth: 0,\n    gridLineWidth: 1,\n    tickPixelInterval: 200,\n    labels: {\n    \t   align: 'left',\n        style: {\n            color: '#888'\n        },\n        x: 3,\n        y: -4\n    }\n}</pre>",
            "extends": "{xAxis}"
          },
          "subtree": {
            "overscroll": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "overscroll",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "default": "highcharts-navigator-xaxis"
              },
              "subtree": {}
            },
            "tickLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "tickLength",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "lineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "lineWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "gridLineColor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "gridLineColor",
                "excludes": {},
                "default": "#e6e6e6"
              },
              "subtree": {}
            },
            "gridLineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "gridLineWidth",
                "excludes": {},
                "default": 1
              },
              "subtree": {}
            },
            "tickPixelInterval": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "tickPixelInterval",
                "excludes": {},
                "default": 200
              },
              "subtree": {}
            },
            "labels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "labels",
                "excludes": {}
              },
              "subtree": {
                "align": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "align",
                    "excludes": {},
                    "default": "left"
                  },
                  "subtree": {}
                },
                "style": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "style",
                    "excludes": {}
                  },
                  "subtree": {
                    "color": {
                      "meta": {
                        "types": {
                          "string": 1
                        },
                        "name": "color",
                        "excludes": {},
                        "default": "#999999"
                      },
                      "subtree": {}
                    }
                  }
                },
                "x": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "x",
                    "excludes": {},
                    "default": 3
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": -4
                  },
                  "subtree": {}
                }
              }
            },
            "crosshair": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "crosshair",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            }
          }
        },
        "yAxis": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "yAxis",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Options for the navigator Y axis. Default series options\nfor the navigator yAxis are:\n\n<pre>yAxis: {\n    gridLineWidth: 0,\n    startOnTick: false,\n    endOnTick: false,\n    minPadding: 0.1,\n    maxPadding: 0.1,\n    labels: {\n        enabled: false\n    },\n    title: {\n        text: null\n    },\n    tickWidth: 0\n}</pre>",
            "extends": "{yAxis}"
          },
          "subtree": {
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "default": "highcharts-navigator-yaxis"
              },
              "subtree": {}
            },
            "gridLineWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "gridLineWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "startOnTick": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "startOnTick",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "endOnTick": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "endOnTick",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "minPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "minPadding",
                "excludes": {},
                "default": 0.1
              },
              "subtree": {}
            },
            "maxPadding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "maxPadding",
                "excludes": {},
                "default": 0.1
              },
              "subtree": {}
            },
            "labels": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "labels",
                "excludes": {}
              },
              "subtree": {
                "enabled": {
                  "meta": {
                    "types": {
                      "boolean": 1
                    },
                    "name": "enabled",
                    "excludes": {},
                    "default": false
                  },
                  "subtree": {}
                }
              }
            },
            "crosshair": {
              "meta": {
                "types": {
                  "boolean": 1
                },
                "name": "crosshair",
                "excludes": {},
                "default": false
              },
              "subtree": {}
            },
            "title": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "title",
                "excludes": {}
              },
              "subtree": {
                "text": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "default": null
                  },
                  "subtree": {}
                }
              }
            },
            "tickLength": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "tickLength",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "tickWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "tickWidth",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            }
          }
        },
        "adaptToUpdatedData": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "adaptToUpdatedData",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Whether the navigator and scrollbar should adapt to updated data\nin the base X axis. When loading data async, as in the demo below,\nthis should be `false`. Otherwise new data will trigger navigator\nredraw, which will cause unwanted looping. In the demo below, the\ndata in the navigator is set only once. On navigating, only the main\nchart content is updated."
          },
          "subtree": {}
        },
        "baseSeries": {
          "meta": {
            "types": {
              "mixed": 1
            },
            "name": "baseSeries",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "An integer identifying the index to use for the base series, or a\nstring representing the id of the series.\n\n**Note**: As of Highcharts 5.0, this is now a deprecated option.\nPrefer [series.showInNavigator](#plotOptions.series.showInNavigator)."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Enable or disable the navigator."
          },
          "subtree": {}
        },
        "opposite": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "opposite",
            "excludes": {},
            "default": "false",
            "products": {
              "highstock": 1
            },
            "description": "When the chart is inverted, whether to draw the navigator on the\nopposite side."
          },
          "subtree": {}
        }
      }
    },
    "colors": {
      "meta": {
        "types": {
          "array": "Color"
        },
        "name": "colors",
        "excludes": {},
        "default": "[\"#7cb5ec\", \"#434348\", \"#90ed7d\", \"#f7a35c\", \"#8085e9\",\n         \"#f15c80\", \"#e4d354\", \"#2b908f\", \"#f45b5b\", \"#91e8e1\"]",
        "description": "An array containing the default colors for the chart's series. When\nall colors are used, new colors are pulled from the start again.\n\nDefault colors can also be set on a series or series.type basis,\nsee [column.colors](#plotOptions.column.colors),\n[pie.colors](#plotOptions.pie.colors).\n\nIn styled mode, the colors option doesn't exist. Instead, colors\nare defined in CSS and applied either through series or point class\nnames, or through the [chart.colorCount](#chart.colorCount) option.\n\n\n### Legacy\n\nIn Highcharts 3.x, the default colors were:\n\n<pre>colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',\n    '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a']</pre>\n\nIn Highcharts 2.x, the default colors were:\n\n<pre>colors: ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE',\n   '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92']</pre>"
      },
      "subtree": {}
    },
    "time": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "time",
        "excludes": {},
        "description": "Time options that can apply globally or to individual charts. These\nsettings affect how `datetime` axes are laid out, how tooltips are\nformatted, how series\n[pointIntervalUnit](#plotOptions.series.pointIntervalUnit) works and how\nthe Highstock range selector handles time.\n\nThe common use case is that all charts in the same Highcharts object\nshare the same time settings, in which case the global settings are set\nusing `setOptions`.\n\n```js\n// Apply time settings globally\nHighcharts.setOptions({\n    time: {\n        timezone: 'Europe/London'\n    }\n});\n// Apply time settings by instance\nvar chart = Highcharts.chart('container', {\n    time: {\n        timezone: 'America/New_York'\n    },\n    series: [{\n        data: [1, 4, 3, 5]\n    }]\n});\n\n// Use the Time object\nconsole.log(\n\t   'Current time in New York',\n\t    chart.time.dateFormat('%Y-%m-%d %H:%M:%S', Date.now())\n);\n```\n\nSince v6.0.5, the time options were moved from the `global` obect to the\n`time` object, and time options can be set on each individual chart."
      },
      "subtree": {
        "useUTC": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useUTC",
            "excludes": {},
            "description": "Whether to use UTC time for axis scaling, tickmark placement and\ntime display in `Highcharts.dateFormat`. Advantages of using UTC\nis that the time displays equally regardless of the user agent's\ntime zone settings. Local time can be used when the data is loaded\nin real time or when correct Daylight Saving Time transitions are\nrequired."
          },
          "subtree": {}
        },
        "Date": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "Date",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A custom `Date` class for advanced date handling. For example,\n[JDate](https://github.com/tahajahangir/jdate) can be hooked in to\nhandle Jalali dates."
          },
          "subtree": {}
        },
        "getTimezoneOffset": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "getTimezoneOffset",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "A callback to return the time zone offset for a given datetime. It\ntakes the timestamp in terms of milliseconds since January 1 1970,\nand returns the timezone offset in minutes. This provides a hook\nfor drawing time based charts in specific time zones using their\nlocal DST crossover dates, with the help of external libraries."
          },
          "subtree": {}
        },
        "timezone": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "timezone",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Requires [moment.js](http://momentjs.com/). If the timezone option\nis specified, it creates a default\n[getTimezoneOffset](#time.getTimezoneOffset) function that looks\nup the specified timezone in moment.js. If moment.js is not included,\nthis throws a Highcharts error in the console, but does not crash the\nchart."
          },
          "subtree": {}
        },
        "timezoneOffset": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "timezoneOffset",
            "excludes": {},
            "default": "0",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The timezone offset in minutes. Positive values are west, negative\nvalues are east of UTC, as in the ECMAScript\n[getTimezoneOffset](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset)\nmethod. Use this to display UTC based data in a predefined time zone."
          },
          "subtree": {}
        }
      }
    },
    "title": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "title",
        "excludes": {},
        "description": "The chart's main title."
      },
      "subtree": {
        "text": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "text",
            "excludes": {},
            "default": "Chart title",
            "description": "The title of the chart. To disable the title, set the `text` to\n`null`."
          },
          "subtree": {}
        },
        "align": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "align",
            "excludes": {},
            "default": "center",
            "description": "The horizontal alignment of the title. Can be one of \"left\", \"center\"\nand \"right\"."
          },
          "subtree": {}
        },
        "margin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "margin",
            "excludes": {},
            "default": "15",
            "description": "The margin between the title and the plot area, or if a subtitle\nis present, the margin between the subtitle and the plot area."
          },
          "subtree": {}
        },
        "widthAdjust": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "widthAdjust",
            "excludes": {},
            "default": "-44",
            "description": "Adjustment made to the title width, normally to reserve space for\nthe exporting burger menu."
          },
          "subtree": {}
        },
        "floating": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "floating",
            "excludes": {},
            "default": "false",
            "description": "When the title is floating, the plot area will not move to make space\nfor it."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "description": "CSS styles for the title. Use this for font styling, but use `align`,\n`x` and `y` for text alignment.\n\nIn styled mode, the title style is given in the `.highcharts-title` class."
          },
          "subtree": {}
        },
        "useHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useHTML",
            "excludes": {},
            "default": "false",
            "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the text."
          },
          "subtree": {}
        },
        "verticalAlign": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "verticalAlign",
            "excludes": {},
            "description": "The vertical alignment of the title. Can be one of `\"top\"`, `\"middle\"`\nand `\"bottom\"`. When a value is given, the title behaves as if [floating](#title.\nfloating) were `true`."
          },
          "subtree": {}
        },
        "x": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "x",
            "excludes": {},
            "default": "0",
            "description": "The x position of the title relative to the alignment within chart.\nspacingLeft and chart.spacingRight."
          },
          "subtree": {}
        },
        "y": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "y",
            "excludes": {},
            "description": "The y position of the title relative to the alignment within [chart.\nspacingTop](#chart.spacingTop) and [chart.spacingBottom](#chart.spacingBottom).\n By default it depends on the font size."
          },
          "subtree": {}
        }
      }
    },
    "subtitle": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "subtitle",
        "excludes": {},
        "description": "The chart's subtitle. This can be used both to display a subtitle below\nthe main title, and to display random text anywhere in the chart. The\nsubtitle can be updated after chart initialization through the\n`Chart.setTitle` method."
      },
      "subtree": {
        "text": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "text",
            "excludes": {},
            "default": "",
            "description": "The subtitle of the chart."
          },
          "subtree": {}
        },
        "align": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "align",
            "excludes": {},
            "default": "center",
            "description": "The horizontal alignment of the subtitle. Can be one of \"left\",\n \"center\" and \"right\"."
          },
          "subtree": {}
        },
        "widthAdjust": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "widthAdjust",
            "excludes": {},
            "default": "-44",
            "description": "Adjustment made to the subtitle width, normally to reserve space\nfor the exporting burger menu."
          },
          "subtree": {}
        },
        "floating": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "floating",
            "excludes": {},
            "default": "false",
            "description": "When the subtitle is floating, the plot area will not move to make\nspace for it."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{ \"color\": \"#666666\" }",
            "description": "CSS styles for the title.\n\nIn styled mode, the subtitle style is given in the `.highcharts-subtitle` class."
          },
          "subtree": {}
        },
        "useHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useHTML",
            "excludes": {},
            "default": "false",
            "description": "Whether to [use HTML](http://www.highcharts.com/docs/chart-concepts/labels-\nand-string-formatting#html) to render the text."
          },
          "subtree": {}
        },
        "verticalAlign": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "verticalAlign",
            "excludes": {},
            "description": "The vertical alignment of the title. Can be one of \"top\", \"middle\"\nand \"bottom\". When a value is given, the title behaves as floating."
          },
          "subtree": {}
        },
        "x": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "x",
            "excludes": {},
            "default": "0",
            "description": "The x position of the subtitle relative to the alignment within chart.\nspacingLeft and chart.spacingRight."
          },
          "subtree": {}
        },
        "y": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "y",
            "excludes": {},
            "description": "The y position of the subtitle relative to the alignment within chart.\nspacingTop and chart.spacingBottom. By default the subtitle is laid\nout below the title unless the title is floating."
          },
          "subtree": {}
        }
      }
    },
    "labels": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "labels",
        "excludes": {},
        "description": "HTML labels that can be positioned anywhere in the chart area."
      },
      "subtree": {
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{ \"color\": \"#333333\" }",
            "description": "Shared CSS styles for all labels."
          },
          "subtree": {
            "position": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position",
                "excludes": {},
                "default": "absolute"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#333333"
              },
              "subtree": {}
            }
          }
        },
        "items": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "items",
            "excludes": {},
            "description": "A HTML label that can be positioned anywhere in the chart area."
          },
          "subtree": {
            "html": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "html",
                "excludes": {},
                "description": "Inner HTML or text for the label."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "description": "CSS styles for each label. To position the label, use left and top\nlike this:\n\n<pre>style: {\n    left: '100px',\n    top: '100px'\n}</pre>"
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "loading": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "loading",
        "excludes": {},
        "description": "The loading options control the appearance of the loading screen\nthat covers the plot area on chart operations. This screen only\nappears after an explicit call to `chart.showLoading()`. It is a\nutility for developers to communicate to the end user that something\nis going on, for example while retrieving new data via an XHR connection.\nThe \"Loading...\" text itself is not part of this configuration\nobject, but part of the `lang` object."
      },
      "subtree": {
        "labelStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "labelStyle",
            "excludes": {},
            "default": "{ \"fontWeight\": \"bold\", \"position\": \"relative\", \"top\": \"45%\" }",
            "description": "CSS styles for the loading label `span`."
          },
          "subtree": {
            "fontWeight": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontWeight",
                "excludes": {},
                "default": "bold"
              },
              "subtree": {}
            },
            "position": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position",
                "excludes": {},
                "default": "relative"
              },
              "subtree": {}
            },
            "top": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "top",
                "excludes": {},
                "default": "45%"
              },
              "subtree": {}
            }
          }
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{ \"position\": \"absolute\", \"backgroundColor\": \"#ffffff\", \"opacity\": 0.5, \"textAlign\": \"center\" }",
            "description": "CSS styles for the loading screen that covers the plot area."
          },
          "subtree": {
            "position": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "position",
                "excludes": {},
                "default": "absolute"
              },
              "subtree": {}
            },
            "backgroundColor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "backgroundColor",
                "excludes": {},
                "default": "#ffffff"
              },
              "subtree": {}
            },
            "opacity": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "opacity",
                "excludes": {},
                "default": 0.5
              },
              "subtree": {}
            },
            "textAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "textAlign",
                "excludes": {},
                "default": "center"
              },
              "subtree": {}
            }
          }
        },
        "hideDuration": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "hideDuration",
            "excludes": {},
            "default": "100",
            "description": "The duration in milliseconds of the fade out effect."
          },
          "subtree": {}
        },
        "showDuration": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "showDuration",
            "excludes": {},
            "default": "100",
            "description": "The duration in milliseconds of the fade in effect."
          },
          "subtree": {}
        }
      }
    },
    "tooltip": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "tooltip",
        "excludes": {},
        "description": "Options for the tooltip that appears when the user hovers over a\nseries or point."
      },
      "subtree": {
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "description": "Enable or disable the tooltip."
          },
          "subtree": {}
        },
        "animation": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "animation",
            "excludes": {},
            "default": "true",
            "description": "Enable or disable animation of the tooltip. In slow legacy IE browsers\nthe animation is disabled by default."
          },
          "subtree": {}
        },
        "borderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderRadius",
            "excludes": {},
            "default": "3",
            "description": "The radius of the rounded border corners."
          },
          "subtree": {}
        },
        "dateTimeLabelFormats": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "dateTimeLabelFormats",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "For series on a datetime axes, the date format in the tooltip's\nheader will by default be guessed based on the closest data points.\nThis member gives the default string representations used for\neach unit. For an overview of the replacement codes, see [dateFormat](#Highcharts.\ndateFormat).\n\nDefaults to:\n\n<pre>{\n    millisecond:\"%A, %b %e, %H:%M:%S.%L\",\n    second:\"%A, %b %e, %H:%M:%S\",\n    minute:\"%A, %b %e, %H:%M\",\n    hour:\"%A, %b %e, %H:%M\",\n    day:\"%A, %b %e, %Y\",\n    week:\"Week from %A, %b %e, %Y\",\n    month:\"%B %Y\",\n    year:\"%Y\"\n}</pre>"
          },
          "subtree": {
            "millisecond": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "millisecond",
                "excludes": {},
                "default": "%A, %b %e, %H:%M:%S.%L"
              },
              "subtree": {}
            },
            "second": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "second",
                "excludes": {},
                "default": "%A, %b %e, %H:%M:%S"
              },
              "subtree": {}
            },
            "minute": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "minute",
                "excludes": {},
                "default": "%A, %b %e, %H:%M"
              },
              "subtree": {}
            },
            "hour": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "hour",
                "excludes": {},
                "default": "%A, %b %e, %H:%M"
              },
              "subtree": {}
            },
            "day": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "day",
                "excludes": {},
                "default": "%A, %b %e, %Y"
              },
              "subtree": {}
            },
            "week": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "week",
                "excludes": {},
                "default": "Week from %A, %b %e, %Y"
              },
              "subtree": {}
            },
            "month": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "month",
                "excludes": {},
                "default": "%B %Y"
              },
              "subtree": {}
            },
            "year": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "year",
                "excludes": {},
                "default": "%Y"
              },
              "subtree": {}
            }
          }
        },
        "footerFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "footerFormat",
            "excludes": {},
            "default": "",
            "description": "A string to append to the tooltip format."
          },
          "subtree": {}
        },
        "padding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "padding",
            "excludes": {},
            "default": "8",
            "description": "Padding inside the tooltip, in pixels."
          },
          "subtree": {}
        },
        "snap": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "snap",
            "excludes": {},
            "default": "10/25",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Proximity snap for graphs or single points. It defaults to 10 for\nmouse-powered devices and 25 for touch devices.\n\nNote that in most cases the whole plot area captures the mouse\nmovement, and in these cases `tooltip.snap` doesn't make sense.\nThis applies when [stickyTracking](#plotOptions.series.stickyTracking)\nis `true` (default) and when the tooltip is [shared](#tooltip.shared)\nor [split](#tooltip.split)."
          },
          "subtree": {}
        },
        "headerFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "headerFormat",
            "excludes": {},
            "default": "<span style=\"font-size: 10px\">{point.key}</span><br/>",
            "description": "The HTML of the tooltip header line. Variables are enclosed by\ncurly brackets. Available variables are `point.key`, `series.name`,\n`series.color` and other members from the `point` and `series`\nobjects. The `point.key` variable contains the category name, x\nvalue or datetime string depending on the type of axis. For datetime\naxes, the `point.key` date format can be set using tooltip.xDateFormat."
          },
          "subtree": {}
        },
        "pointFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "pointFormat",
            "excludes": {},
            "default": "<span style=\"color:{point.color}\">\\u25CF</span> {series.name}: <b>{point.y}</b><br/>",
            "description": "The HTML of the point's line in the tooltip. Variables are enclosed\nby curly brackets. Available variables are point.x, point.y, series.\nname and series.color and other properties on the same form. Furthermore,\npoint.y can be extended by the `tooltip.valuePrefix` and\n`tooltip.valueSuffix` variables. This can also be overridden for each\nseries, which makes it a good hook for displaying units.\n\nIn styled mode, the dot is colored by a class name rather\nthan the point color."
          },
          "subtree": {}
        },
        "backgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "backgroundColor",
            "excludes": {},
            "default": "rgba(247,247,247,0.85)",
            "description": "The background color or gradient for the tooltip.\n\nIn styled mode, the stroke width is set in the `.highcharts-tooltip-box` class."
          },
          "subtree": {}
        },
        "borderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "borderWidth",
            "excludes": {},
            "default": "1",
            "description": "The pixel width of the tooltip border.\n\nIn styled mode, the stroke width is set in the `.highcharts-tooltip-box` class."
          },
          "subtree": {}
        },
        "shadow": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "shadow",
            "excludes": {},
            "default": "true",
            "description": "Whether to apply a drop shadow to the tooltip."
          },
          "subtree": {}
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{ \"color\": \"#333333\", \"cursor\": \"default\", \"fontSize\": \"12px\", \"pointerEvents\": \"none\", \"whiteSpace\": \"nowrap\" }",
            "description": "CSS styles for the tooltip. The tooltip can also be styled through\nthe CSS class `.highcharts-tooltip`."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#333333"
              },
              "subtree": {}
            },
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "default": "default"
              },
              "subtree": {}
            },
            "fontSize": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontSize",
                "excludes": {},
                "default": "12px"
              },
              "subtree": {}
            },
            "pointerEvents": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "pointerEvents",
                "excludes": {},
                "default": "none"
              },
              "subtree": {}
            },
            "whiteSpace": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "whiteSpace",
                "excludes": {},
                "default": "nowrap"
              },
              "subtree": {}
            }
          }
        },
        "borderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "borderColor",
            "excludes": {},
            "default": "null",
            "description": "The color of the tooltip border. When `null`, the border takes the\ncolor of the corresponding series or point."
          },
          "subtree": {}
        },
        "crosshairs": {
          "meta": {
            "types": {
              "mixed": 1
            },
            "name": "crosshairs",
            "excludes": {},
            "default": "true",
            "description": "Since 4.1, the crosshair definitions are moved to the Axis object\nin order for a better separation from the tooltip. See [xAxis.crosshair](#xAxis.\ncrosshair)<a>.</a>"
          },
          "subtree": {}
        },
        "followPointer": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "followPointer",
            "excludes": {},
            "description": "Whether the tooltip should follow the mouse as it moves across columns,\npie slices and other point types with an extent. By default it behaves\nthis way for scatter, bubble and pie series by override in the `plotOptions`\nfor those series types.\n\nFor touch moves to behave the same way, [followTouchMove](#tooltip.\nfollowTouchMove) must be `true` also."
          },
          "subtree": {}
        },
        "followTouchMove": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "followTouchMove",
            "excludes": {},
            "description": "Whether the tooltip should follow the finger as it moves on a touch\ndevice. If this is `true` and [chart.panning](#chart.panning) is\nset,`followTouchMove` will take over one-finger touches, so the user\nneeds to use two fingers for zooming and panning."
          },
          "subtree": {}
        },
        "formatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "formatter",
            "excludes": {},
            "description": "Callback function to format the text of the tooltip from scratch. Return\n`false` to disable tooltip for a specific point on series.\n\nA subset of HTML is supported. Unless `useHTML` is true, the HTML of the\ntooltip is parsed and converted to SVG, therefore this isn't a complete HTML\nrenderer. The following tags are supported: `<b>`, `<strong>`, `<i>`, `<em>`,\n`<br/>`, `<span>`. Spans can be styled with a `style` attribute,\nbut only text-related CSS that is shared with SVG is handled.\n\nSince version 2.1 the tooltip can be shared between multiple series\nthrough the `shared` option. The available data in the formatter\ndiffer a bit depending on whether the tooltip is shared or not. In\na shared tooltip, all properties except `x`, which is common for\nall points, are kept in an array, `this.points`.\n\nAvailable data are:\n\n<dl>\n\n<dt>this.percentage (not shared) / this.points[i].percentage (shared)</dt>\n\n<dd>Stacked series and pies only. The point's percentage of the total.\n</dd>\n\n<dt>this.point (not shared) / this.points[i].point (shared)</dt>\n\n<dd>The point object. The point name, if defined, is available through\n`this.point.name`.</dd>\n\n<dt>this.points</dt>\n\n<dd>In a shared tooltip, this is an array containing all other properties\nfor each point.</dd>\n\n<dt>this.series (not shared) / this.points[i].series (shared)</dt>\n\n<dd>The series object. The series name is available through\n`this.series.name`.</dd>\n\n<dt>this.total (not shared) / this.points[i].total (shared)</dt>\n\n<dd>Stacked series only. The total value at this point's x value.\n</dd>\n\n<dt>this.x</dt>\n\n<dd>The x value. This property is the same regardless of the tooltip\nbeing shared or not.</dd>\n\n<dt>this.y (not shared) / this.points[i].y (shared)</dt>\n\n<dd>The y value.</dd>\n\n</dl>"
          },
          "subtree": {}
        },
        "hideDelay": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "hideDelay",
            "excludes": {},
            "default": "500",
            "description": "The number of milliseconds to wait until the tooltip is hidden when\nmouse out from a point or chart."
          },
          "subtree": {}
        },
        "pointFormatter": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "pointFormatter",
            "excludes": {},
            "description": "A callback function for formatting the HTML output for a single point\nin the tooltip. Like the `pointFormat` string, but with more flexibility."
          },
          "subtree": {}
        },
        "positioner": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "positioner",
            "excludes": {},
            "description": "A callback function to place the tooltip in a default position. The\ncallback receives three parameters: `labelWidth`, `labelHeight` and\n`point`, where point contains values for `plotX` and `plotY` telling\nwhere the reference point is in the plot area. Add `chart.plotLeft`\nand `chart.plotTop` to get the full coordinates.\n\nThe return should be an object containing x and y values, for example\n`{ x: 100, y: 100 }`."
          },
          "subtree": {}
        },
        "shape": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "shape",
            "excludes": {},
            "default": "callout",
            "description": "The name of a symbol to use for the border around the tooltip."
          },
          "subtree": {}
        },
        "shared": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "shared",
            "excludes": {},
            "default": "false",
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "When the tooltip is shared, the entire plot area will capture mouse\nmovement or touch events. Tooltip texts for series types with ordered\ndata (not pie, scatter, flags etc) will be shown in a single bubble.\nThis is recommended for single series charts and for tablet/mobile\noptimized charts.\n\nSee also [tooltip.split](#tooltip.split), that is better suited for\ncharts with many series, especially line-type series. The\n`tooltip.split` option takes precedence over `tooltip.shared`."
          },
          "subtree": {}
        },
        "split": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "split",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "Split the tooltip into one label per series, with the header close\nto the axis. This is recommended over [shared](#tooltip.shared) tooltips\nfor charts with multiple line series, generally making them easier\nto read. This option takes precedence over `tooltip.shared`."
          },
          "subtree": {}
        },
        "useHTML": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "useHTML",
            "excludes": {},
            "default": "false",
            "description": "Use HTML to render the contents of the tooltip instead of SVG. Using\nHTML allows advanced formatting like tables and images in the tooltip.\nIt is also recommended for rtl languages as it works around rtl\nbugs in early Firefox."
          },
          "subtree": {}
        },
        "valueDecimals": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "valueDecimals",
            "excludes": {},
            "description": "How many decimals to show in each series' y value. This is overridable\nin each series' tooltip options object. The default is to preserve\nall decimals."
          },
          "subtree": {}
        },
        "valuePrefix": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "valuePrefix",
            "excludes": {},
            "description": "A string to prepend to each series' y value. Overridable in each\nseries' tooltip options object."
          },
          "subtree": {}
        },
        "valueSuffix": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "valueSuffix",
            "excludes": {},
            "description": "A string to append to each series' y value. Overridable in each series'\ntooltip options object."
          },
          "subtree": {}
        },
        "xDateFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "xDateFormat",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highstock": 1
            },
            "description": "The format for the date in the tooltip header if the X axis is a\ndatetime axis. The default is a best guess based on the smallest\ndistance between points in the chart."
          },
          "subtree": {}
        },
        "changeDecimals": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "changeDecimals",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "How many decimals to show for the `point.change` value when the\n`series.compare` option is set. This is overridable in each series' tooltip\noptions object. The default is to preserve all decimals."
          },
          "subtree": {}
        }
      }
    },
    "credits": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "credits",
        "excludes": {},
        "description": "Highchart by default puts a credits label in the lower right corner\nof the chart. This can be changed using these options."
      },
      "subtree": {
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "description": "Whether to show the credits text."
          },
          "subtree": {}
        },
        "href": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "href",
            "excludes": {},
            "default": "http://www.highcharts.com",
            "description": "The URL for the credits label."
          },
          "subtree": {}
        },
        "position": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "position",
            "excludes": {},
            "description": "Position configuration for the credits label."
          },
          "subtree": {
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "right",
                "description": "Horizontal alignment of the credits."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": "-10",
                "description": "Horizontal pixel offset of the credits."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "default": "bottom",
                "description": "Vertical alignment of the credits."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": "-5",
                "description": "Vertical pixel offset of the credits."
              },
              "subtree": {}
            }
          }
        },
        "style": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "style",
            "excludes": {},
            "default": "{ \"cursor\": \"pointer\", \"color\": \"#999999\", \"fontSize\": \"10px\" }",
            "description": "CSS styles for the credits label."
          },
          "subtree": {
            "cursor": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "cursor",
                "excludes": {},
                "default": "pointer"
              },
              "subtree": {}
            },
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#999999"
              },
              "subtree": {}
            },
            "fontSize": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "fontSize",
                "excludes": {},
                "default": "9px"
              },
              "subtree": {}
            }
          }
        },
        "text": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "text",
            "excludes": {},
            "default": "Highcharts.com",
            "description": "The text for the credits label."
          },
          "subtree": {}
        },
        "mapText": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "mapText",
            "excludes": {},
            "default": "\\u00a9 <a href=\"{geojson.copyrightUrl}\">{geojson.copyrightShort}</a>",
            "products": {
              "highmaps": 1
            },
            "description": "Credits for map source to be concatenated with conventional credit\ntext. By default this is a format string that collects copyright\ninformation from the map if available."
          },
          "subtree": {}
        },
        "mapTextFull": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "mapTextFull",
            "excludes": {},
            "default": "{geojson.copyright}",
            "products": {
              "highmaps": 1
            },
            "description": "Detailed credits for map source to be displayed on hover of credits\ntext. By default this is a format string that collects copyright\ninformation from the map if available."
          },
          "subtree": {}
        }
      }
    },
    "rangeSelector": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "rangeSelector",
        "excludes": {},
        "products": {
          "highstock": 1
        },
        "description": "The range selector is a tool for selecting ranges to display within\nthe chart. It provides buttons to select preconfigured ranges in\nthe chart, like 1 day, 1 week, 1 month etc. It also provides input\nboxes where min and max dates can be manually input."
      },
      "subtree": {
        "verticalAlign": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "verticalAlign",
            "excludes": {},
            "default": "top",
            "description": "The vertical alignment of the rangeselector box. Allowed properties are `top`,\n`middle`, `bottom`."
          },
          "subtree": {}
        },
        "buttonTheme": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttonTheme",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "A collection of attributes for the buttons. The object takes SVG\nattributes like `fill`, `stroke`, `stroke-width`, as well as `style`,\na collection of CSS properties for the text.\n\nThe object can also be extended with states, so you can set presentational\noptions for `hover`, `select` or `disabled` button states.\n\nCSS styles for the text label.\n\nIn styled mode, the buttons are styled by the\n`.highcharts-range-selector-buttons .highcharts-button` rule with its\ndifferent states."
          },
          "subtree": {
            "undefined": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "undefined",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": 28
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "height",
                "excludes": {},
                "default": 18
              },
              "subtree": {}
            },
            "padding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "padding",
                "excludes": {},
                "default": 2
              },
              "subtree": {}
            },
            "zIndex": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "zIndex",
                "excludes": {},
                "default": 7
              },
              "subtree": {}
            }
          }
        },
        "floating": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "floating",
            "excludes": {},
            "default": false,
            "products": {
              "highstock": 1
            },
            "description": "When the rangeselector is floating, the plot area does not reserve \nspace for it. This opens for positioning anywhere on the chart."
          },
          "subtree": {}
        },
        "x": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "x",
            "excludes": {},
            "default": 0,
            "products": {
              "highstock": 1
            },
            "description": "The x offset of the range selector relative to its horizontal\nalignment within `chart.spacingLeft` and `chart.spacingRight`."
          },
          "subtree": {}
        },
        "y": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "y",
            "excludes": {},
            "default": 0,
            "products": {
              "highstock": 1
            },
            "description": "The y offset of the range selector relative to its horizontal\nalignment within `chart.spacingLeft` and `chart.spacingRight`."
          },
          "subtree": {}
        },
        "height": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "height",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highstock": 1
            },
            "description": "Deprecated. The height of the range selector. Currently it is\ncalculated dynamically."
          },
          "subtree": {}
        },
        "inputPosition": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "inputPosition",
            "excludes": {},
            "default": "{ align: \"right\" }",
            "products": {
              "highstock": 1
            },
            "description": "Positioning for the input boxes. Allowed properties are `align`,\n `x` and `y`."
          },
          "subtree": {
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "right",
                "description": "The alignment of the input box. Allowed properties are `left`,\n`center`, `right`."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            }
          }
        },
        "buttonPosition": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttonPosition",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Positioning for the button row."
          },
          "subtree": {
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "left",
                "description": "The alignment of the input box. Allowed properties are `left`,\n`center`, `right`."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": 0,
                "description": "X offset of the button row."
              },
              "subtree": {}
            },
            "y": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "y",
                "excludes": {},
                "default": 0,
                "description": "Y offset of the button row."
              },
              "subtree": {}
            }
          }
        },
        "labelStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "labelStyle",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "CSS styles for the labels - the Zoom, From and To texts.\n\nIn styled mode, the labels are styled by the `.highcharts-range-label` class."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#666666"
              },
              "subtree": {}
            }
          }
        },
        "allButtonsEnabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allButtonsEnabled",
            "excludes": {},
            "default": "false",
            "products": {
              "highstock": 1
            },
            "description": "Whether to enable all buttons from the start. By default buttons\nare only enabled if the corresponding time range exists on the X\naxis, but enabling all buttons allows for dynamically loading different\ntime ranges."
          },
          "subtree": {}
        },
        "buttonSpacing": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "buttonSpacing",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "The space in pixels between the buttons in the range selector."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Enable or disable the range selector."
          },
          "subtree": {}
        },
        "inputBoxBorderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "inputBoxBorderColor",
            "excludes": {},
            "default": "#cccccc",
            "products": {
              "highstock": 1
            },
            "description": "The border color of the date input boxes."
          },
          "subtree": {}
        },
        "inputBoxHeight": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "inputBoxHeight",
            "excludes": {},
            "default": "17",
            "products": {
              "highstock": 1
            },
            "description": "The pixel height of the date input boxes."
          },
          "subtree": {}
        },
        "inputBoxStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "inputBoxStyle",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "CSS for the container DIV holding the input boxes. Deprecated as\nof 1.2.5\\. Use [inputPosition](#rangeSelector.inputPosition) instead."
          },
          "subtree": {}
        },
        "inputBoxWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "inputBoxWidth",
            "excludes": {},
            "default": "90",
            "products": {
              "highstock": 1
            },
            "description": "The pixel width of the date input boxes."
          },
          "subtree": {}
        },
        "inputDateFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "inputDateFormat",
            "excludes": {},
            "default": "%b %e %Y,",
            "products": {
              "highstock": 1
            },
            "description": "The date format in the input boxes when not selected for editing.\n Defaults to `%b %e, %Y`."
          },
          "subtree": {}
        },
        "inputDateParser": {
          "meta": {
            "types": {
              "function": 1
            },
            "name": "inputDateParser",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "A custom callback function to parse values entered in the input boxes\nand return a valid JavaScript time as milliseconds since 1970."
          },
          "subtree": {}
        },
        "inputEditDateFormat": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "inputEditDateFormat",
            "excludes": {},
            "default": "%Y-%m-%d",
            "products": {
              "highstock": 1
            },
            "description": "The date format in the input boxes when they are selected for editing.\nThis must be a format that is recognized by JavaScript Date.parse."
          },
          "subtree": {}
        },
        "inputEnabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "inputEnabled",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Enable or disable the date input boxes. Defaults to enabled when\nthere is enough space, disabled if not (typically mobile)."
          },
          "subtree": {}
        },
        "inputStyle": {
          "meta": {
            "types": {
              "cssobject": 1
            },
            "name": "inputStyle",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "CSS for the HTML inputs in the range selector.\n\nIn styled mode, the inputs are styled by the `.highcharts-range-input text`\nrule in SVG mode, and `input.highcharts-range-selector` when active."
          },
          "subtree": {}
        },
        "selected": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "selected",
            "excludes": {},
            "default": "undefined",
            "products": {
              "highstock": 1
            },
            "description": "The index of the button to appear pre-selected."
          },
          "subtree": {}
        },
        "buttons": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "buttons",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "An array of configuration objects for the buttons.\n\nDefaults to\n\n<pre>buttons: [{\n    type: 'month',\n    count: 1,\n    text: '1m'\n}, {\n    type: 'month',\n    count: 3,\n    text: '3m'\n}, {\n    type: 'month',\n    count: 6,\n    text: '6m'\n}, {\n    type: 'ytd',\n    text: 'YTD'\n}, {\n    type: 'year',\n    count: 1,\n    text: '1y'\n}, {\n    type: 'all',\n    text: 'All'\n}]</pre>"
          },
          "subtree": {
            "count": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "count",
                "excludes": {},
                "default": "1",
                "products": {
                  "highstock": 1
                },
                "description": "How many units of the defined type the button should span. If `type`\nis \"month\" and `count` is 3, the button spans three months."
              },
              "subtree": {}
            },
            "events": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "events",
                "excludes": {}
              },
              "subtree": {
                "click": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "click",
                    "excludes": {},
                    "default": "undefined",
                    "products": {
                      "highstock": 1
                    },
                    "description": "Fires when clicking on the rangeSelector button. One parameter, event,\nis passed to the function, containing common event information.\n<pre>\nclick: function(e) {\n  console.log(this);\n}\n</pre>\n\nReturn false to stop default button's click action."
                  },
                  "subtree": {}
                }
              }
            },
            "offsetMax": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "offsetMax",
                "excludes": {},
                "default": "0",
                "products": {
                  "highstock": 1
                },
                "description": "Additional range (in milliseconds) added to the end of the calculated time span."
              },
              "subtree": {}
            },
            "offsetMin": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "offsetMin",
                "excludes": {},
                "default": "0",
                "products": {
                  "highstock": 1
                },
                "description": "Additional range (in milliseconds) added to the start of the calculated time span."
              },
              "subtree": {}
            },
            "dataGrouping": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "dataGrouping",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "A custom data grouping object for each button."
              },
              "subtree": {}
            },
            "text": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "text",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "The text for the button itself."
              },
              "subtree": {}
            },
            "type": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "type",
                "excludes": {},
                "products": {
                  "highstock": 1
                },
                "description": "Defined the time span for the button. Can be one of `millisecond`,\n`second`, `minute`, `hour`, `day`, `week`, `month`, `ytd`, `all`."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "responsive": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "responsive",
        "excludes": {},
        "description": "Allows setting a set of rules to apply for different screen or chart\nsizes. Each rule specifies additional chart options."
      },
      "subtree": {
        "rules": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "rules",
            "excludes": {},
            "description": "A set of rules for responsive settings. The rules are executed from\nthe top down."
          },
          "subtree": {
            "chartOptions": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "chartOptions",
                "excludes": {},
                "description": "A full set of chart options to apply as overrides to the general\nchart options. The chart options are applied when the given rule\nis active.\n\nA special case is configuration objects that take arrays, for example\n[xAxis](#xAxis), [yAxis](#yAxis) or [series](#series). For these\ncollections, an `id` option is used to map the new option set to\nan existing object. If an existing object of the same id is not found,\nthe item of the same indexupdated. So for example, setting `chartOptions`\nwith two series items without an `id`, will cause the existing chart's\ntwo series to be updated with respective options."
              },
              "subtree": {}
            },
            "condition": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "condition",
                "excludes": {},
                "description": "Under which conditions the rule applies."
              },
              "subtree": {
                "callback": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "callback",
                    "excludes": {},
                    "description": "A callback function to gain complete control on when the responsive\nrule applies. Return `true` if it applies. This opens for checking\nagainst other metrics than the chart size, or example the document\nsize or other elements."
                  },
                  "subtree": {}
                },
                "maxHeight": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "maxHeight",
                    "excludes": {},
                    "description": "The responsive rule applies if the chart height is less than this."
                  },
                  "subtree": {}
                },
                "maxWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "maxWidth",
                    "excludes": {},
                    "description": "The responsive rule applies if the chart width is less than this."
                  },
                  "subtree": {}
                },
                "minHeight": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "minHeight",
                    "excludes": {},
                    "default": "0",
                    "description": "The responsive rule applies if the chart height is greater than this."
                  },
                  "subtree": {}
                },
                "minWidth": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "minWidth",
                    "excludes": {},
                    "default": "0",
                    "description": "The responsive rule applies if the chart width is greater than this."
                  },
                  "subtree": {}
                }
              }
            }
          }
        }
      }
    },
    "scrollbar": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "scrollbar",
        "excludes": {},
        "products": {
          "highstock": 1
        },
        "description": "The scrollbar is a means of panning over the X axis of a stock chart.\n\nIn styled mode, all the presentational options for the\nscrollbar are replaced by the classes `.highcharts-scrollbar-thumb`,\n`.highcharts-scrollbar-arrow`, `.highcharts-scrollbar-button`,\n`.highcharts-scrollbar-rifles` and `.highcharts-scrollbar-track`."
      },
      "subtree": {
        "height": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "height",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "The height of the scrollbar. The height also applies to the width\nof the scroll arrows so that they are always squares. Defaults to\n20 for touch devices and 14 for mouse devices."
          },
          "subtree": {}
        },
        "barBorderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "barBorderRadius",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "The border rounding radius of the bar."
          },
          "subtree": {}
        },
        "buttonBorderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "buttonBorderRadius",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "The corner radius of the scrollbar buttons."
          },
          "subtree": {}
        },
        "liveRedraw": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "liveRedraw",
            "excludes": {},
            "products": {
              "highstock": 1
            },
            "description": "Whether to redraw the main chart as the scrollbar or the navigator\nzoomed window is moved. Defaults to `true` for modern browsers and\n`false` for legacy IE browsers as well as mobile devices."
          },
          "subtree": {}
        },
        "margin": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "margin",
            "excludes": {},
            "default": 10,
            "description": "The margin between the scrollbar and its axis when the scrollbar is\napplied directly to an axis."
          },
          "subtree": {}
        },
        "minWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minWidth",
            "excludes": {},
            "default": "6",
            "products": {
              "highstock": 1
            },
            "description": "The minimum width of the scrollbar."
          },
          "subtree": {}
        },
        "step": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "step",
            "excludes": {},
            "default": 0.2
          },
          "subtree": {}
        },
        "zIndex": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "zIndex",
            "excludes": {},
            "default": 3,
            "description": "The z index of the scrollbar group."
          },
          "subtree": {}
        },
        "barBackgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "barBackgroundColor",
            "excludes": {},
            "default": "#cccccc",
            "products": {
              "highstock": 1
            },
            "description": "The background color of the scrollbar itself."
          },
          "subtree": {}
        },
        "barBorderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "barBorderWidth",
            "excludes": {},
            "default": "1",
            "products": {
              "highstock": 1
            },
            "description": "The width of the bar's border."
          },
          "subtree": {}
        },
        "barBorderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "barBorderColor",
            "excludes": {},
            "default": "#cccccc",
            "products": {
              "highstock": 1
            },
            "description": "The color of the scrollbar's border."
          },
          "subtree": {}
        },
        "buttonArrowColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "buttonArrowColor",
            "excludes": {},
            "default": "#333333",
            "products": {
              "highstock": 1
            },
            "description": "The color of the small arrow inside the scrollbar buttons."
          },
          "subtree": {}
        },
        "buttonBackgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "buttonBackgroundColor",
            "excludes": {},
            "default": "#e6e6e6",
            "products": {
              "highstock": 1
            },
            "description": "The color of scrollbar buttons."
          },
          "subtree": {}
        },
        "buttonBorderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "buttonBorderColor",
            "excludes": {},
            "default": "#cccccc",
            "products": {
              "highstock": 1
            },
            "description": "The color of the border of the scrollbar buttons."
          },
          "subtree": {}
        },
        "buttonBorderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "buttonBorderWidth",
            "excludes": {},
            "default": "1",
            "products": {
              "highstock": 1
            },
            "description": "The border width of the scrollbar buttons."
          },
          "subtree": {}
        },
        "rifleColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "rifleColor",
            "excludes": {},
            "default": "#333333",
            "products": {
              "highstock": 1
            },
            "description": "The color of the small rifles in the middle of the scrollbar."
          },
          "subtree": {}
        },
        "trackBackgroundColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "trackBackgroundColor",
            "excludes": {},
            "default": "#f2f2f2",
            "products": {
              "highstock": 1
            },
            "description": "The color of the track background."
          },
          "subtree": {}
        },
        "trackBorderColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "trackBorderColor",
            "excludes": {},
            "default": "#f2f2f2",
            "products": {
              "highstock": 1
            },
            "description": "The color of the border of the scrollbar track."
          },
          "subtree": {}
        },
        "trackBorderWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "trackBorderWidth",
            "excludes": {},
            "default": "1",
            "products": {
              "highstock": 1
            },
            "description": "The width of the border of the scrollbar track."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Enable or disable the scrollbar."
          },
          "subtree": {}
        },
        "showFull": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showFull",
            "excludes": {},
            "default": "true",
            "products": {
              "highstock": 1
            },
            "description": "Whether to show or hide the scrollbar when the scrolled content is\nzoomed out to it full extent."
          },
          "subtree": {}
        },
        "trackBorderRadius": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "trackBorderRadius",
            "excludes": {},
            "default": "0",
            "products": {
              "highstock": 1
            },
            "description": "The corner radius of the border of the scrollbar track."
          },
          "subtree": {}
        }
      }
    },
    "pane": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "pane",
        "excludes": {},
        "description": "The pane serves as a container for axes and backgrounds for circular \ngauges and polar charts."
      },
      "subtree": {
        "center": {
          "meta": {
            "types": {
              "array": "(String|Number)"
            },
            "name": "center",
            "excludes": {},
            "default": "[\"50%\", \"50%\"]",
            "products": {
              "highcharts": 1
            },
            "description": "The center of a polar chart or angular gauge, given as an array\nof [x, y] positions. Positions can be given as integers that transform\nto pixels, or as percentages of the plot area size."
          },
          "subtree": {}
        },
        "size": {
          "meta": {
            "types": {
              "number": 1,
              "string": 1
            },
            "name": "size",
            "excludes": {},
            "default": "85%",
            "products": {
              "highcharts": 1
            },
            "description": "The size of the pane, either as a number defining pixels, or a\npercentage defining a percentage of the plot are."
          },
          "subtree": {}
        },
        "startAngle": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "startAngle",
            "excludes": {},
            "default": 0,
            "products": {
              "highcharts": 1
            },
            "description": "The start angle of the polar X axis or gauge axis, given in degrees\nwhere 0 is north. Defaults to 0."
          },
          "subtree": {}
        },
        "endAngle": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "endAngle",
            "excludes": {},
            "products": {
              "highcharts": 1
            },
            "description": "The end angle of the polar X axis or gauge value axis, given in degrees\nwhere 0 is north. Defaults to [startAngle](#pane.startAngle) + 360."
          },
          "subtree": {}
        },
        "background": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "background",
            "excludes": {},
            "description": "An array of background items for the pane."
          },
          "subtree": {
            "shape": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "shape",
                "excludes": {},
                "default": "solid",
                "products": {
                  "highcharts": 1
                },
                "description": "Tha shape of the pane background. When `solid`, the background\nis circular. When `arc`, the background extends only from the min\nto the max of the value axis."
              },
              "subtree": {}
            },
            "borderWidth": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "borderWidth",
                "excludes": {},
                "default": "1",
                "products": {
                  "highcharts": 1
                },
                "description": "The pixel border width of the pane background."
              },
              "subtree": {}
            },
            "borderColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "borderColor",
                "excludes": {},
                "default": "#cccccc",
                "products": {
                  "highcharts": 1
                },
                "description": "The pane background border color."
              },
              "subtree": {}
            },
            "backgroundColor": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "backgroundColor",
                "excludes": {},
                "products": {
                  "highcharts": 1
                },
                "description": "The background color or gradient for the pane."
              },
              "subtree": {
                "linearGradient": {
                  "meta": {
                    "types": {
                      "object": 1
                    },
                    "name": "linearGradient",
                    "excludes": {},
                    "description": "Definition of the gradient, similar to SVG: object literal holds\nstart position (x1, y1) and the end position (x2, y2) relative\nto the shape, where 0 means top/left and 1 is bottom/right.\nAll positions are floats between 0 and 1."
                  },
                  "subtree": {
                    "x1": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "x1",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    },
                    "y1": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "y1",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    },
                    "x2": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "x2",
                        "excludes": {},
                        "default": 0
                      },
                      "subtree": {}
                    },
                    "y2": {
                      "meta": {
                        "types": {
                          "number": 1
                        },
                        "name": "y2",
                        "excludes": {},
                        "default": 1
                      },
                      "subtree": {}
                    }
                  }
                },
                "stops": {
                  "meta": {
                    "types": {
                      "array": "Array"
                    },
                    "name": "stops",
                    "excludes": {},
                    "default": "[[0, #ffffff], [1, #e6e6e6]]",
                    "description": "The stops is an array of tuples, where the first\nitem is a float between 0 and 1 assigning the relative position in\nthe gradient, and the second item is the color."
                  },
                  "subtree": {}
                }
              }
            },
            "from": {
              "meta": {
                "types": {},
                "name": "from",
                "excludes": {}
              },
              "subtree": {}
            },
            "innerRadius": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "innerRadius",
                "excludes": {},
                "default": "0",
                "products": {
                  "highcharts": 1
                },
                "description": "The inner radius of the pane background. Can be either numeric\n(pixels) or a percentage string."
              },
              "subtree": {}
            },
            "outerRadius": {
              "meta": {
                "types": {
                  "number": 1,
                  "string": 1
                },
                "name": "outerRadius",
                "excludes": {},
                "default": "105%",
                "products": {
                  "highcharts": 1
                },
                "description": "The outer radius of the circular pane background. Can be either\nnumeric (pixels) or a percentage string."
              },
              "subtree": {}
            },
            "className": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "className",
                "excludes": {},
                "description": "The class name for this background."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "colorAxis": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "colorAxis",
        "excludes": {},
        "products": {
          "highcharts": 1,
          "highmaps": 1
        },
        "description": "A color axis for choropleth maps and heat maps. Visually, the color axis\nwill appear as a gradient or as separate items inside the legend,\ndepending on whether the axis is scalar or based on data classes.\n\nFor supported color formats, see the \n[docs article about colors](http://www.highcharts.com/docs/chart-design-and-style/colors).\n\nA scalar color axis is represented by a gradient. The colors either range\nbetween the [minColor](#colorAxis.minColor) and the [maxColor](#colorAxis.maxColor),\nor for more fine grained control the colors can be\ndefined in [stops](#colorAxis.stops). Often times, the color axis needs\nto be adjusted to get the right color spread for the data. In addition to\nstops, consider using a logarithmic [axis type](#colorAxis.type), or\nsetting [min](#colorAxis.min) and [max](#colorAxis.max) to avoid the\ncolors being determined by outliers.\n\nWhen [dataClasses](#colorAxis.dataClasses) are used, the ranges are\nsubdivided into separate classes like categories based on their values.\nThis can be used for ranges between two values, but also for a true\ncategory. However, when your data is categorized, it may be as convenient\nto add each category to a separate series.\n\nSee [the Axis object](#Axis) for programmatic access to the axis.",
        "extends": "{xAxis}"
      },
      "subtree": {
        "lineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "lineWidth",
            "excludes": {},
            "default": 0
          },
          "subtree": {}
        },
        "minPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "minPadding",
            "excludes": {},
            "default": 0,
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Padding of the min value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer."
          },
          "subtree": {}
        },
        "maxPadding": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "maxPadding",
            "excludes": {},
            "default": 0,
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Padding of the max value relative to the length of the axis. A\npadding of 0.05 will make a 100px axis 5px longer."
          },
          "subtree": {}
        },
        "gridLineWidth": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "gridLineWidth",
            "excludes": {},
            "default": "1",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The width of the grid lines extending from the axis across the\ngradient of a scalar color axis."
          },
          "subtree": {}
        },
        "tickPixelInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickPixelInterval",
            "excludes": {},
            "default": "72",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "If [tickInterval](#colorAxis.tickInterval) is `null` this option\nsets the approximate pixel interval of the tick marks."
          },
          "subtree": {}
        },
        "startOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "startOnTick",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Whether to force the axis to start on a tick. Use this option with\nthe `maxPadding` option to control the axis start."
          },
          "subtree": {}
        },
        "endOnTick": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "endOnTick",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Whether to force the axis to end on a tick. Use this option with\nthe [maxPadding](#colorAxis.maxPadding) option to control the axis\nend."
          },
          "subtree": {}
        },
        "marker": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "marker",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The triangular marker on a scalar color axis that points to the\nvalue of the hovered area. To disable the marker, set\n`marker: null`."
          },
          "subtree": {
            "animation": {
              "meta": {
                "types": {
                  "object": 1,
                  "boolean": 1
                },
                "name": "animation",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "Animation for the marker as it moves between values. Set to `false`\nto disable animation. Defaults to `{ duration: 50 }`."
              },
              "subtree": {
                "duration": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "duration",
                    "excludes": {},
                    "default": 50
                  },
                  "subtree": {}
                }
              }
            },
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "default": "#999999",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The color of the marker."
              },
              "subtree": {}
            }
          }
        },
        "labels": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "labels",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The axis labels show the number for each tick.\n\nFor more live examples on label options, see [xAxis.labels in the\nHighcharts API.](/highcharts#xAxis.labels)",
            "extends": "xAxis.labels"
          },
          "subtree": {
            "overflow": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "overflow",
                "excludes": {},
                "default": "justify",
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "How to handle overflowing labels on horizontal color axis. Can be\nundefined or \"justify\". If \"justify\", labels will not render\noutside the legend area. If there is room to move it, it will be\naligned to the edge, else it will be removed."
              },
              "subtree": {}
            },
            "rotation": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "rotation",
                "excludes": {},
                "default": 0
              },
              "subtree": {}
            }
          }
        },
        "minColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "minColor",
            "excludes": {},
            "default": "#e6ebf5",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The color to represent the minimum of the color axis. Unless [dataClasses](#colorAxis.\ndataClasses) or [stops](#colorAxis.stops) are set, the gradient\nstarts at this value.\n\nIf dataClasses are set, the color is based on minColor and maxColor\nunless a color is set for each data class, or the [dataClassColor](#colorAxis.\ndataClassColor) is set."
          },
          "subtree": {}
        },
        "maxColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "maxColor",
            "excludes": {},
            "default": "#003399",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The color to represent the maximum of the color axis. Unless [dataClasses](#colorAxis.\ndataClasses) or [stops](#colorAxis.stops) are set, the gradient\nends at this value.\n\nIf dataClasses are set, the color is based on minColor and maxColor\nunless a color is set for each data class, or the [dataClassColor](#colorAxis.\ndataClassColor) is set."
          },
          "subtree": {}
        },
        "tickLength": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickLength",
            "excludes": {},
            "default": 5,
            "description": "The pixel length of the main tick marks on the color axis."
          },
          "subtree": {}
        },
        "showInLegend": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "showInLegend",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Whether to display the colorAxis in the legend."
          },
          "subtree": {}
        },
        "allowDecimals": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "allowDecimals",
            "excludes": {},
            "default": "true",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Whether to allow decimals on the color axis."
          },
          "subtree": {}
        },
        "dataClassColor": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "dataClassColor",
            "excludes": {},
            "default": "tween",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Determines how to set each data class' color if no individual color\nis set. The default value, `tween`, computes intermediate colors\nbetween `minColor` and `maxColor`. The other possible value, `category`,\npulls colors from the global or chart specific [colors](#colors)\narray."
          },
          "subtree": {}
        },
        "dataClasses": {
          "meta": {
            "types": {
              "array": "Object"
            },
            "name": "dataClasses",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "An array of data classes or ranges for the choropleth map. If none\ngiven, the color axis is scalar and values are distributed as a gradient\nbetween the minimum and maximum colors."
          },
          "subtree": {
            "color": {
              "meta": {
                "types": {
                  "color": 1
                },
                "name": "color",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The color of each data class. If not set, the color is pulled from\nthe global or chart-specific [colors](#colors) array. In \nstyled mode, this option is ignored. Instead, use colors defined in\nCSS."
              },
              "subtree": {}
            },
            "from": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "from",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The start of the value range that the data class represents,\nrelating to the point value.\n\nThe range of each `dataClass` is closed in both ends, but can be\noverridden by the next `dataClass`."
              },
              "subtree": {}
            },
            "name": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "name",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The name of the data class as it appears in the legend.\nIf no name is given, it is automatically created based on the\n`from` and `to` values. For full programmatic control,\n[legend.labelFormatter](#legend.labelFormatter) can be used.\nIn the formatter, `this.from` and `this.to` can be accessed."
              },
              "subtree": {}
            },
            "to": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "to",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "The end of the value range that the data class represents,\nrelating to the point value.\n\nThe range of each `dataClass` is closed in both ends, but can be\noverridden by the next `dataClass`."
              },
              "subtree": {}
            }
          }
        },
        "max": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "max",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The maximum value of the axis in terms of map point values. If `null`,\nthe max value is automatically calculated. If the `endOnTick` option\nis true, the max value might be rounded up."
          },
          "subtree": {}
        },
        "min": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "min",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The minimum value of the axis in terms of map point values. If `null`,\nthe min value is automatically calculated. If the `startOnTick`\noption is true, the min value might be rounded down."
          },
          "subtree": {}
        },
        "gridLineColor": {
          "meta": {
            "types": {
              "color": 1
            },
            "name": "gridLineColor",
            "excludes": {},
            "default": "#e6e6e6",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Color of the grid lines extending from the axis across the gradient."
          },
          "subtree": {}
        },
        "tickInterval": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "tickInterval",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The interval of the tick marks in axis units. When `null`, the tick\ninterval is computed to approximately follow the `tickPixelInterval`."
          },
          "subtree": {}
        },
        "stops": {
          "meta": {
            "types": {
              "array": "Array"
            },
            "name": "stops",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Color stops for the gradient of a scalar color axis. Use this in\ncases where a linear gradient between a `minColor` and `maxColor`\nis not sufficient. The stops is an array of tuples, where the first\nitem is a float between 0 and 1 assigning the relative position in\nthe gradient, and the second item is the color."
          },
          "subtree": {}
        },
        "type": {
          "meta": {
            "types": {
              "string": 1
            },
            "name": "type",
            "excludes": {},
            "default": "linear",
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "The type of interpolation to use for the color axis. Can be `linear`\nor `logarithmic`."
          },
          "subtree": {}
        },
        "reversed": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "reversed",
            "excludes": {},
            "products": {
              "highcharts": 1,
              "highmaps": 1
            },
            "description": "Whether to reverse the axis so that the highest number is closest\nto the origin. Defaults to `false` in a horizontal legend and `true`\nin a vertical legend, where the smallest value starts on top."
          },
          "subtree": {}
        },
        "events": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "events",
            "excludes": {}
          },
          "subtree": {
            "legendItemClick": {
              "meta": {
                "types": {
                  "function": 1
                },
                "name": "legendItemClick",
                "excludes": {},
                "products": {
                  "highcharts": 1,
                  "highmaps": 1
                },
                "description": "Fires when the legend item belonging to the colorAxis is clicked.\nOne parameter, `event`, is passed to the function."
              },
              "subtree": {}
            }
          }
        }
      }
    },
    "mapNavigation": {
      "meta": {
        "types": {
          "object": 1
        },
        "name": "mapNavigation",
        "excludes": {},
        "products": {
          "highmaps": 1
        }
      },
      "subtree": {
        "buttonOptions": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttonOptions",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "General options for the map navigation buttons. Individual options\ncan be given from the [mapNavigation.buttons](#mapNavigation.buttons)\noption set."
          },
          "subtree": {
            "alignTo": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "alignTo",
                "excludes": {},
                "default": "plotBox",
                "products": {
                  "highmaps": 1
                },
                "description": "What box to align the buttons to. Possible values are `plotBox`\nand `spacingBox`."
              },
              "subtree": {}
            },
            "align": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "align",
                "excludes": {},
                "default": "left",
                "products": {
                  "highmaps": 1
                },
                "description": "The alignment of the navigation buttons."
              },
              "subtree": {}
            },
            "verticalAlign": {
              "meta": {
                "types": {
                  "string": 1
                },
                "name": "verticalAlign",
                "excludes": {},
                "default": "bottom",
                "products": {
                  "highmaps": 1
                },
                "description": "The vertical alignment of the buttons. Individual alignment can\nbe adjusted by each button's `y` offset."
              },
              "subtree": {}
            },
            "x": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "x",
                "excludes": {},
                "default": "0",
                "products": {
                  "highmaps": 1
                },
                "description": "The X offset of the buttons relative to its `align` setting."
              },
              "subtree": {}
            },
            "width": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "width",
                "excludes": {},
                "default": "18",
                "products": {
                  "highmaps": 1
                },
                "description": "The width of the map navigation buttons."
              },
              "subtree": {}
            },
            "height": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "height",
                "excludes": {},
                "default": "18",
                "products": {
                  "highmaps": 1
                },
                "description": "The pixel height of the map navigation buttons."
              },
              "subtree": {}
            },
            "padding": {
              "meta": {
                "types": {
                  "number": 1
                },
                "name": "padding",
                "excludes": {},
                "default": "5",
                "products": {
                  "highmaps": 1
                },
                "description": "Padding for the navigation buttons."
              },
              "subtree": {}
            },
            "style": {
              "meta": {
                "types": {
                  "cssobject": 1
                },
                "name": "style",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "Text styles for the map navigation buttons. Defaults to\n\n<pre>{\n    fontSize: '15px',\n    fontWeight: 'bold',\n    textAlign: 'center'\n}</pre>"
              },
              "subtree": {
                "fontSize": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontSize",
                    "excludes": {},
                    "default": "15px"
                  },
                  "subtree": {}
                },
                "fontWeight": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "fontWeight",
                    "excludes": {},
                    "default": "bold"
                  },
                  "subtree": {}
                }
              }
            },
            "theme": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "theme",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "A configuration object for the button theme. The object accepts\nSVG properties like `stroke-width`, `stroke` and `fill`. Tri-state\nbutton styles are supported by the `states.hover` and `states.select`\nobjects."
              },
              "subtree": {
                "undefined": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "undefined",
                    "excludes": {},
                    "default": "center"
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "buttons": {
          "meta": {
            "types": {
              "object": 1
            },
            "name": "buttons",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "The individual buttons for the map navigation. This usually includes\nthe zoom in and zoom out buttons. Properties for each button is\ninherited from\n[mapNavigation.buttonOptions](#mapNavigation.buttonOptions), while\nindividual options can be overridden. But default, the `onclick`, `text`\nand `y` options are individual."
          },
          "subtree": {
            "zoomIn": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "zoomIn",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "Options for the zoom in button. Properties for the zoom in and zoom\nout buttons are inherited from\n[mapNavigation.buttonOptions](#mapNavigation.buttonOptions), while\nindividual options can be overridden. By default, the `onclick`,\n`text` and `y` options are individual.",
                "extends": "mapNavigation.buttonOptions"
              },
              "subtree": {
                "onclick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "onclick",
                    "excludes": {},
                    "products": {
                      "highmaps": 1
                    },
                    "description": "Click handler for the button. Defaults to:\n\n<pre>function () {\nthis.mapZoom(0.5);\n}</pre>"
                  },
                  "subtree": {}
                },
                "text": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "default": "+",
                    "products": {
                      "highmaps": 1
                    },
                    "description": "The text for the button. The tooltip (title) is a language option\ngiven by [lang.zoomIn](#lang.zoomIn)."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": "0",
                    "products": {
                      "highmaps": 1
                    },
                    "description": "The position of the zoomIn button relative to the vertical\nalignment."
                  },
                  "subtree": {}
                }
              }
            },
            "zoomOut": {
              "meta": {
                "types": {
                  "object": 1
                },
                "name": "zoomOut",
                "excludes": {},
                "products": {
                  "highmaps": 1
                },
                "description": "Options for the zoom out button. Properties for the zoom in and\nzoom out buttons are inherited from\n[mapNavigation.buttonOptions](#mapNavigation.buttonOptions), while\nindividual options can be overridden. By default, the `onclick`,\n`text` and `y` options are individual.",
                "extends": "mapNavigation.buttonOptions"
              },
              "subtree": {
                "onclick": {
                  "meta": {
                    "types": {
                      "function": 1
                    },
                    "name": "onclick",
                    "excludes": {},
                    "products": {
                      "highmaps": 1
                    },
                    "description": "Click handler for the button. Defaults to:\n\n<pre>function () {\n    this.mapZoom(2);\n}</pre>"
                  },
                  "subtree": {}
                },
                "text": {
                  "meta": {
                    "types": {
                      "string": 1
                    },
                    "name": "text",
                    "excludes": {},
                    "default": "-",
                    "products": {
                      "highmaps": 1
                    },
                    "description": "The text for the button. The tooltip (title) is a language option\ngiven by [lang.zoomOut](#lang.zoomIn)."
                  },
                  "subtree": {}
                },
                "y": {
                  "meta": {
                    "types": {
                      "number": 1
                    },
                    "name": "y",
                    "excludes": {},
                    "default": "28",
                    "products": {
                      "highmaps": 1
                    },
                    "description": "The position of the zoomOut button relative to the vertical\nalignment."
                  },
                  "subtree": {}
                }
              }
            }
          }
        },
        "mouseWheelSensitivity": {
          "meta": {
            "types": {
              "number": 1
            },
            "name": "mouseWheelSensitivity",
            "excludes": {},
            "default": "1.1",
            "products": {
              "highmaps": 1
            },
            "description": "Sensitivity of mouse wheel or trackpad scrolling. 1 is no sensitivity,\n while with 2, one mousewheel delta will zoom in 50%."
          },
          "subtree": {}
        },
        "enableButtons": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enableButtons",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "Whether to enable navigation buttons. By default it inherits the\n[enabled](#mapNavigation.enabled) setting."
          },
          "subtree": {}
        },
        "enableDoubleClickZoom": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enableDoubleClickZoom",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "Enables zooming in on an area on double clicking in the map. By default\nit inherits the [enabled](#mapNavigation.enabled) setting."
          },
          "subtree": {}
        },
        "enableDoubleClickZoomTo": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enableDoubleClickZoomTo",
            "excludes": {},
            "default": "false",
            "products": {
              "highmaps": 1
            },
            "description": "Whether to zoom in on an area when that area is double clicked."
          },
          "subtree": {}
        },
        "enableMouseWheelZoom": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enableMouseWheelZoom",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "Enables zooming by mouse wheel. By default it inherits the [enabled](#mapNavigation.\nenabled) setting."
          },
          "subtree": {}
        },
        "enableTouchZoom": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enableTouchZoom",
            "excludes": {},
            "products": {
              "highmaps": 1
            },
            "description": "Whether to enable multitouch zooming. Note that if the chart covers\nthe viewport, this prevents the user from using multitouch and touchdrag\non the web page, so you should make sure the user is not trapped\ninside the chart. By default it inherits the [enabled](#mapNavigation.\nenabled) setting."
          },
          "subtree": {}
        },
        "enabled": {
          "meta": {
            "types": {
              "boolean": 1
            },
            "name": "enabled",
            "excludes": {},
            "default": "false",
            "products": {
              "highmaps": 1
            },
            "description": "Whether to enable map navigation. The default is not to enable navigation,\nas many choropleth maps are simple and don't need it. Additionally,\nwhen touch zoom and mousewheel zoom is enabled, it breaks the default\nbehaviour of these interactions in the website, and the implementer\nshould be aware of this.\n\nIndividual interactions can be enabled separately, namely buttons,\nmultitouch zoom, double click zoom, double click zoom to element\nand mousewheel zoom."
          },
          "subtree": {}
        }
      }
    },
    "zAxis": {
      "meta": {
        "types": {
          "array": "zAxis"
        },
        "name": "zAxis",
        "excludes": {},
        "products": {
          "highcharts": 1
        },
        "description": "The Z axis or depth axis for 3D plots.\n\nSee [the Axis object](#Axis) for programmatic access to the axis.",
        "extends": "xAxis"
      },
      "subtree": {}
    }
  }
};
